export const LocationVN = [
  {
    id: '1',
    code: 'SG',
    name: 'Hồ Chí Minh',
    districts: [
      {
        id: '1',
        name: 'Bình Chánh',
        wards: [
          {
            id: '1',
            name: 'An Phú Tây',
            prefix: 'Xã',
          },
          {
            id: '2',
            name: 'Bình Chánh',
            prefix: 'Xã',
          },
          {
            id: '3',
            name: 'Bình Hưng',
            prefix: 'Xã',
          },
          {
            id: '4',
            name: 'Bình Lợi',
            prefix: 'Xã',
          },
          {
            id: '5',
            name: 'Đa Phước',
            prefix: 'Xã',
          },
          {
            id: '6',
            name: 'Hưng Long',
            prefix: 'Xã',
          },
          {
            id: '7',
            name: 'Lê Minh Xuân',
            prefix: 'Xã',
          },
          {
            id: '8',
            name: 'Phạm Văn Hai',
            prefix: 'Xã',
          },
          {
            id: '9',
            name: 'Phong Phú',
            prefix: 'Xã',
          },
          {
            id: '10',
            name: 'Quy Đức',
            prefix: 'Xã',
          },
          {
            id: '11',
            name: 'Tân Kiên',
            prefix: 'Xã',
          },
          {
            id: '12',
            name: 'Tân Nhựt',
            prefix: 'Xã',
          },
          {
            id: '13',
            name: 'Tân Quý Tây',
            prefix: 'Xã',
          },
          {
            id: '14',
            name: 'Tân Túc',
            prefix: 'Thị trấn',
          },
          {
            id: '15',
            name: 'Vĩnh Lộc A',
            prefix: 'Xã',
          },
          {
            id: '16',
            name: 'Vĩnh Lộc B',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '2',
        name: 'Bình Tân',
        wards: [
          {
            id: '17',
            name: 'An Lạc',
            prefix: 'Phường',
          },
          {
            id: '18',
            name: 'An Lạc A',
            prefix: 'Phường',
          },
          {
            id: '19',
            name: 'Bình Hưng Hòa',
            prefix: 'Phường',
          },
          {
            id: '20',
            name: 'Bình Hưng Hòa A',
            prefix: 'Phường',
          },
          {
            id: '21',
            name: 'Bình Hưng Hòa B',
            prefix: 'Phường',
          },
          {
            id: '22',
            name: 'Bình Trị Đông',
            prefix: 'Phường',
          },
          {
            id: '23',
            name: 'Bình Trị Đông A',
            prefix: 'Phường',
          },
          {
            id: '24',
            name: 'Bình Trị Đông B',
            prefix: 'Phường',
          },
          {
            id: '25',
            name: 'Tân Tạo',
            prefix: 'Phường',
          },
          {
            id: '26',
            name: 'Tân Tạo A',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '3',
        name: 'Bình Thạnh',
        wards: [
          {
            id: '27',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '28',
            name: '11',
            prefix: 'Phường',
          },
          {
            id: '29',
            name: '12',
            prefix: 'Phường',
          },
          {
            id: '30',
            name: '13',
            prefix: 'Phường',
          },
          {
            id: '31',
            name: '14',
            prefix: 'Phường',
          },
          {
            id: '32',
            name: '15',
            prefix: 'Phường',
          },
          {
            id: '33',
            name: '17',
            prefix: 'Phường',
          },
          {
            id: '34',
            name: '19',
            prefix: 'Phường',
          },
          {
            id: '35',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '36',
            name: '21',
            prefix: 'Phường',
          },
          {
            id: '37',
            name: '22',
            prefix: 'Phường',
          },
          {
            id: '38',
            name: '24',
            prefix: 'Phường',
          },
          {
            id: '39',
            name: '25',
            prefix: 'Phường',
          },
          {
            id: '40',
            name: '26',
            prefix: 'Phường',
          },
          {
            id: '41',
            name: '27',
            prefix: 'Phường',
          },
          {
            id: '42',
            name: '28',
            prefix: 'Phường',
          },
          {
            id: '43',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '44',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '45',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '46',
            name: '7',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '4',
        name: 'Cần Giờ',
        wards: [
          {
            id: '47',
            name: 'An Thới Đông',
            prefix: 'Xã',
          },
          {
            id: '48',
            name: 'Bình Khánh',
            prefix: 'Xã',
          },
          {
            id: '49',
            name: 'Cần Thạnh ',
            prefix: 'Phường',
          },
          {
            id: '50',
            name: 'Long Hòa',
            prefix: 'Xã',
          },
          {
            id: '51',
            name: 'Lý Nhơn',
            prefix: 'Xã',
          },
          {
            id: '52',
            name: 'Tam Thôn Hiệp',
            prefix: 'Xã',
          },
          {
            id: '53',
            name: 'Thạnh An',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '5',
        name: 'Củ Chi',
        wards: [
          {
            id: '54',
            name: 'An Nhơn Tây',
            prefix: 'Xã',
          },
          {
            id: '55',
            name: 'An Phú',
            prefix: 'Xã',
          },
          {
            id: '56',
            name: 'An Phú Trung',
            prefix: 'Xã',
          },
          {
            id: '57',
            name: 'Bình Mỹ',
            prefix: 'Xã',
          },
          {
            id: '58',
            name: 'Củ Chi',
            prefix: 'Thị trấn',
          },
          {
            id: '59',
            name: 'Hòa Phú',
            prefix: 'Xã',
          },
          {
            id: '60',
            name: 'Nhuận Đức',
            prefix: 'Xã',
          },
          {
            id: '61',
            name: 'Phạm Văn Cội',
            prefix: 'Xã',
          },
          {
            id: '62',
            name: 'Phú Hòa Đông',
            prefix: 'Xã',
          },
          {
            id: '63',
            name: 'Phú Mỹ Hưng',
            prefix: 'Xã',
          },
          {
            id: '64',
            name: 'Phước Hiệp',
            prefix: 'Xã',
          },
          {
            id: '65',
            name: 'Phước Thạnh',
            prefix: 'Xã',
          },
          {
            id: '66',
            name: 'Phước Vĩnh An',
            prefix: 'Xã',
          },
          {
            id: '67',
            name: 'Tân An Hội',
            prefix: 'Xã',
          },
          {
            id: '68',
            name: 'Tân Phú Trung',
            prefix: 'Xã',
          },
          {
            id: '69',
            name: 'Tân Thạnh Đông',
            prefix: 'Xã',
          },
          {
            id: '70',
            name: 'Tân Thạnh Tây',
            prefix: 'Xã',
          },
          {
            id: '71',
            name: 'Tân Thông Hội',
            prefix: 'Xã',
          },
          {
            id: '72',
            name: 'Thái Mỹ',
            prefix: 'Xã',
          },
          {
            id: '73',
            name: 'Trung An',
            prefix: 'Xã',
          },
          {
            id: '74',
            name: 'Trung Lập Hạ',
            prefix: 'Xã',
          },
          {
            id: '75',
            name: 'Trung Lập Hạ',
            prefix: 'Xã',
          },
          {
            id: '76',
            name: 'Trung Lập Thượng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '6',
        name: 'Gò Vấp',
        wards: [
          {
            id: '77',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '78',
            name: '10',
            prefix: 'Phường',
          },
          {
            id: '79',
            name: '11',
            prefix: 'Phường',
          },
          {
            id: '80',
            name: '12',
            prefix: 'Phường',
          },
          {
            id: '81',
            name: '13',
            prefix: 'Phường',
          },
          {
            id: '82',
            name: '14',
            prefix: 'Phường',
          },
          {
            id: '83',
            name: '15',
            prefix: 'Phường',
          },
          {
            id: '84',
            name: '16',
            prefix: 'Phường',
          },
          {
            id: '85',
            name: '17',
            prefix: 'Phường',
          },
          {
            id: '86',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '87',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '88',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '89',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '90',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '91',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '92',
            name: '9',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '7',
        name: 'Hóc Môn',
        wards: [
          {
            id: '93',
            name: ' Đông Thạnh',
            prefix: 'Xã',
          },
          {
            id: '94',
            name: ' Hóc Môn',
            prefix: 'Phường',
          },
          {
            id: '95',
            name: 'Bà Điểm',
            prefix: 'Phường',
          },
          {
            id: '96',
            name: 'Nhị Bình',
            prefix: 'Xã',
          },
          {
            id: '97',
            name: 'Tân Hiệp',
            prefix: 'Xã',
          },
          {
            id: '98',
            name: 'Tân Thới Nhì',
            prefix: 'Xã',
          },
          {
            id: '99',
            name: 'Tân Xuân',
            prefix: 'Xã',
          },
          {
            id: '100',
            name: 'Thới Tam Thôn',
            prefix: 'Xã',
          },
          {
            id: '101',
            name: 'Trung Chánh',
            prefix: 'Xã',
          },
          {
            id: '102',
            name: 'Xuân Thới Đông',
            prefix: 'Xã',
          },
          {
            id: '103',
            name: 'Xuân Thới Sơn',
            prefix: 'Xã',
          },
          {
            id: '104',
            name: 'Xuân Thới Thượng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '8',
        name: 'Nhà Bè',
        wards: [
          {
            id: '105',
            name: 'Hiệp Phước',
            prefix: 'Phường',
          },
          {
            id: '106',
            name: 'Long Thới',
            prefix: 'Xã',
          },
          {
            id: '107',
            name: 'Nhà Bè',
            prefix: 'Thị trấn',
          },
          {
            id: '108',
            name: 'Nhơn Đức',
            prefix: 'Xã',
          },
          {
            id: '109',
            name: 'Phú Xuân',
            prefix: 'Xã',
          },
          {
            id: '110',
            name: 'Phước Kiển',
            prefix: 'Xã',
          },
          {
            id: '111',
            name: 'Phước Lộc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '9',
        name: 'Phú Nhuận',
        wards: [
          {
            id: '112',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '113',
            name: '10',
            prefix: 'Phường',
          },
          {
            id: '114',
            name: '11',
            prefix: 'Phường',
          },
          {
            id: '115',
            name: '12',
            prefix: 'Phường',
          },
          {
            id: '116',
            name: '13',
            prefix: 'Phường',
          },
          {
            id: '117',
            name: '14',
            prefix: 'Phường',
          },
          {
            id: '118',
            name: '15',
            prefix: 'Phường',
          },
          {
            id: '119',
            name: '17',
            prefix: 'Phường',
          },
          {
            id: '120',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '121',
            name: '25',
            prefix: 'Phường',
          },
          {
            id: '122',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '123',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '124',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '125',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '126',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '127',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '128',
            name: '9',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '10',
        name: 'Quận 1',
        wards: [
          {
            id: '129',
            name: 'Bến Nghé',
            prefix: 'Phường',
          },
          {
            id: '130',
            name: 'Bến Thành',
            prefix: 'Phường',
          },
          {
            id: '131',
            name: 'Cầu Kho',
            prefix: 'Phường',
          },
          {
            id: '132',
            name: 'Cầu Ông Lãnh',
            prefix: 'Phường',
          },
          {
            id: '133',
            name: 'Cô Giang',
            prefix: 'Phường',
          },
          {
            id: '134',
            name: 'Đa Kao',
            prefix: 'Phường',
          },
          {
            id: '135',
            name: 'Nguyễn Cư Trinh',
            prefix: 'Phường',
          },
          {
            id: '136',
            name: 'Nguyễn Thái Bình',
            prefix: 'Phường',
          },
          {
            id: '137',
            name: 'Phạm Ngũ Lão',
            prefix: 'Phường',
          },
          {
            id: '138',
            name: 'Tân Định',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '11',
        name: 'Quận 10',
        wards: [
          {
            id: '139',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '140',
            name: '10',
            prefix: 'Phường',
          },
          {
            id: '141',
            name: '11',
            prefix: 'Phường',
          },
          {
            id: '142',
            name: '12',
            prefix: 'Phường',
          },
          {
            id: '143',
            name: '13',
            prefix: 'Phường',
          },
          {
            id: '144',
            name: '14',
            prefix: 'Phường',
          },
          {
            id: '145',
            name: '15',
            prefix: 'Phường',
          },
          {
            id: '146',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '147',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '148',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '149',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '150',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '151',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '152',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '153',
            name: '9',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '12',
        name: 'Quận 11',
        wards: [
          {
            id: '154',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '155',
            name: '10',
            prefix: 'Phường',
          },
          {
            id: '156',
            name: '11',
            prefix: 'Phường',
          },
          {
            id: '157',
            name: '12',
            prefix: 'Phường',
          },
          {
            id: '158',
            name: '13',
            prefix: 'Phường',
          },
          {
            id: '159',
            name: '14',
            prefix: 'Phường',
          },
          {
            id: '160',
            name: '15',
            prefix: 'Phường',
          },
          {
            id: '161',
            name: '16',
            prefix: 'Phường',
          },
          {
            id: '162',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '163',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '164',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '165',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '166',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '167',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '168',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '169',
            name: '9',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '13',
        name: 'Quận 12',
        wards: [
          {
            id: '170',
            name: 'An Phú Đông',
            prefix: 'Phường',
          },
          {
            id: '171',
            name: 'Đông Hưng Thuận',
            prefix: 'Phường',
          },
          {
            id: '172',
            name: 'Hiệp Thành',
            prefix: 'Phường',
          },
          {
            id: '173',
            name: 'Tân Chánh Hiệp',
            prefix: 'Phường',
          },
          {
            id: '174',
            name: 'Tân Hưng Thuận',
            prefix: 'Phường',
          },
          {
            id: '175',
            name: 'Tân Thới Hiệp',
            prefix: 'Phường',
          },
          {
            id: '176',
            name: 'Tân Thới Nhất',
            prefix: 'Phường',
          },
          {
            id: '177',
            name: 'Thạnh Lộc',
            prefix: 'Phường',
          },
          {
            id: '178',
            name: 'Thạnh Xuân',
            prefix: 'Phường',
          },
          {
            id: '179',
            name: 'Thới An',
            prefix: 'Phường',
          },
          {
            id: '180',
            name: 'Trung Mỹ Tây',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '14',
        name: 'Quận 2',
        wards: [
          {
            id: '181',
            name: ' Thạnh Mỹ Lợi',
            prefix: 'Phường',
          },
          {
            id: '182',
            name: 'An Khánh',
            prefix: 'Phường',
          },
          {
            id: '183',
            name: 'An Lợi Đông',
            prefix: 'Phường',
          },
          {
            id: '184',
            name: 'An Phú',
            prefix: 'Phường',
          },
          {
            id: '185',
            name: 'Bình An',
            prefix: 'Phường',
          },
          {
            id: '186',
            name: 'Bình Khánh',
            prefix: 'Phường',
          },
          {
            id: '187',
            name: 'Bình Trưng Đông',
            prefix: 'Phường',
          },
          {
            id: '188',
            name: 'Bình Trưng Tây',
            prefix: 'Phường',
          },
          {
            id: '189',
            name: 'Cát Lái',
            prefix: 'Phường',
          },
          {
            id: '190',
            name: 'Thảo Điền',
            prefix: 'Phường',
          },
          {
            id: '191',
            name: 'Thủ Thiêm',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '15',
        name: 'Quận 3',
        wards: [
          {
            id: '192',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '193',
            name: '10',
            prefix: 'Phường',
          },
          {
            id: '194',
            name: '11',
            prefix: 'Phường',
          },
          {
            id: '195',
            name: '12',
            prefix: 'Phường',
          },
          {
            id: '196',
            name: '13',
            prefix: 'Phường',
          },
          {
            id: '197',
            name: '14',
            prefix: 'Phường',
          },
          {
            id: '198',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '199',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '200',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '201',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '202',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '203',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '204',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '205',
            name: '9',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '16',
        name: 'Quận 4',
        wards: [
          {
            id: '206',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '207',
            name: '10',
            prefix: 'Phường',
          },
          {
            id: '208',
            name: '12',
            prefix: 'Phường',
          },
          {
            id: '209',
            name: '13',
            prefix: 'Phường',
          },
          {
            id: '210',
            name: '14',
            prefix: 'Phường',
          },
          {
            id: '211',
            name: '15',
            prefix: 'Phường',
          },
          {
            id: '212',
            name: '16',
            prefix: 'Phường',
          },
          {
            id: '213',
            name: '18',
            prefix: 'Phường',
          },
          {
            id: '214',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '215',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '216',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '217',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '218',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '219',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '220',
            name: '9',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '17',
        name: 'Quận 5',
        wards: [
          {
            id: '221',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '222',
            name: '10',
            prefix: 'Phường',
          },
          {
            id: '223',
            name: '11',
            prefix: 'Phường',
          },
          {
            id: '224',
            name: '12',
            prefix: 'Phường',
          },
          {
            id: '225',
            name: '13',
            prefix: 'Phường',
          },
          {
            id: '226',
            name: '14',
            prefix: 'Phường',
          },
          {
            id: '227',
            name: '15',
            prefix: 'Phường',
          },
          {
            id: '228',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '229',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '230',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '231',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '232',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '233',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '234',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '235',
            name: '9',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '18',
        name: 'Quận 6',
        wards: [
          {
            id: '236',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '237',
            name: '10',
            prefix: 'Phường',
          },
          {
            id: '238',
            name: '11',
            prefix: 'Phường',
          },
          {
            id: '239',
            name: '12',
            prefix: 'Phường',
          },
          {
            id: '240',
            name: '13',
            prefix: 'Phường',
          },
          {
            id: '241',
            name: '14',
            prefix: 'Phường',
          },
          {
            id: '242',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '243',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '244',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '245',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '246',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '247',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '248',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '249',
            name: '9',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '19',
        name: 'Quận 7',
        wards: [
          {
            id: '250',
            name: 'Bình Thuận',
            prefix: 'Phường',
          },
          {
            id: '251',
            name: 'Phú Mỹ',
            prefix: 'Phường',
          },
          {
            id: '252',
            name: 'Phú Thuận',
            prefix: 'Phường',
          },
          {
            id: '253',
            name: 'Tân Hưng',
            prefix: 'Phường',
          },
          {
            id: '254',
            name: 'Tân Kiểng',
            prefix: 'Phường',
          },
          {
            id: '255',
            name: 'Tân Phong',
            prefix: 'Phường',
          },
          {
            id: '256',
            name: 'Tân Phú',
            prefix: 'Phường',
          },
          {
            id: '257',
            name: 'Tân Quy',
            prefix: 'Phường',
          },
          {
            id: '258',
            name: 'Tân Thuận Đông',
            prefix: 'Phường',
          },
          {
            id: '259',
            name: 'Tân Thuận Tây',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '20',
        name: 'Quận 8',
        wards: [
          {
            id: '260',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '261',
            name: '10',
            prefix: 'Phường',
          },
          {
            id: '262',
            name: '11',
            prefix: 'Phường',
          },
          {
            id: '263',
            name: '12',
            prefix: 'Phường',
          },
          {
            id: '264',
            name: '13',
            prefix: 'Phường',
          },
          {
            id: '265',
            name: '14',
            prefix: 'Phường',
          },
          {
            id: '266',
            name: '15',
            prefix: 'Phường',
          },
          {
            id: '267',
            name: '16',
            prefix: 'Phường',
          },
          {
            id: '268',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '269',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '270',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '271',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '272',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '273',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '274',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '275',
            name: '9',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '21',
        name: 'Quận 9',
        wards: [
          {
            id: '276',
            name: 'Hiệp Phú',
            prefix: 'Phường',
          },
          {
            id: '277',
            name: 'Long Bình',
            prefix: 'Phường',
          },
          {
            id: '278',
            name: 'Long Phước',
            prefix: 'Phường',
          },
          {
            id: '279',
            name: 'Long Thạnh Mỹ',
            prefix: 'Phường',
          },
          {
            id: '280',
            name: 'Long Trường',
            prefix: 'Phường',
          },
          {
            id: '281',
            name: 'Phú Hữu',
            prefix: 'Phường',
          },
          {
            id: '282',
            name: 'Phước Bình',
            prefix: 'Phường',
          },
          {
            id: '283',
            name: 'Phước Long A',
            prefix: 'Phường',
          },
          {
            id: '284',
            name: 'Phước Long B',
            prefix: 'Phường',
          },
          {
            id: '285',
            name: 'Tân Phú',
            prefix: 'Phường',
          },
          {
            id: '286',
            name: 'Tăng Nhơn Phú A',
            prefix: 'Phường',
          },
          {
            id: '287',
            name: 'Tăng Nhơn Phú B',
            prefix: 'Phường',
          },
          {
            id: '288',
            name: 'Trường Thạnh',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '22',
        name: 'Tân Bình',
        wards: [
          {
            id: '289',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '290',
            name: '10',
            prefix: 'Phường',
          },
          {
            id: '291',
            name: '11',
            prefix: 'Phường',
          },
          {
            id: '292',
            name: '12',
            prefix: 'Phường',
          },
          {
            id: '293',
            name: '13',
            prefix: 'Phường',
          },
          {
            id: '294',
            name: '14',
            prefix: 'Phường',
          },
          {
            id: '295',
            name: '15',
            prefix: 'Phường',
          },
          {
            id: '296',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '297',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '298',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '299',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '300',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '301',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '302',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '303',
            name: '9',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '23',
        name: 'Tân Phú',
        wards: [
          {
            id: '304',
            name: 'Hiệp Tân',
            prefix: 'Phường',
          },
          {
            id: '305',
            name: 'Hòa Thạnh',
            prefix: 'Phường',
          },
          {
            id: '306',
            name: 'Phú Thạnh',
            prefix: 'Phường',
          },
          {
            id: '307',
            name: 'Phú Thọ Hòa',
            prefix: 'Phường',
          },
          {
            id: '308',
            name: 'Phú Trung',
            prefix: 'Phường',
          },
          {
            id: '309',
            name: 'Sơn Kỳ',
            prefix: 'Phường',
          },
          {
            id: '310',
            name: 'Tân Quý',
            prefix: 'Phường',
          },
          {
            id: '311',
            name: 'Tân Sơn Nhì',
            prefix: 'Phường',
          },
          {
            id: '312',
            name: 'Tân Thành',
            prefix: 'Phường',
          },
          {
            id: '313',
            name: 'Tân Thới Hòa',
            prefix: 'Phường',
          },
          {
            id: '314',
            name: 'Tây Thạnh',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '24',
        name: 'Thủ Đức',
        wards: [
          {
            id: '315',
            name: 'Bình Chiểu',
            prefix: 'Phường',
          },
          {
            id: '316',
            name: 'Bình Thọ',
            prefix: 'Phường',
          },
          {
            id: '317',
            name: 'Hiệp Bình Chánh',
            prefix: 'Phường',
          },
          {
            id: '318',
            name: 'Hiệp Bình Phước',
            prefix: 'Phường',
          },
          {
            id: '319',
            name: 'Linh Chiểu',
            prefix: 'Phường',
          },
          {
            id: '320',
            name: 'Linh Đông',
            prefix: 'Phường',
          },
          {
            id: '321',
            name: 'Linh Tây',
            prefix: 'Phường',
          },
          {
            id: '322',
            name: 'Linh Trung',
            prefix: 'Phường',
          },
          {
            id: '323',
            name: 'Linh Xuân',
            prefix: 'Phường',
          },
          {
            id: '324',
            name: 'Tam Bình',
            prefix: 'Phường',
          },
          {
            id: '325',
            name: 'Tam Phú',
            prefix: 'Phường',
          },
          {
            id: '326',
            name: 'Trường Thọ',
            prefix: 'Phường',
          },
        ],
      },
    ],
  },
  {
    id: '2',
    code: 'HN',
    name: 'Hà Nội',
    districts: [
      {
        id: '25',
        name: 'Ba Đình',
        wards: [
          {
            id: '327',
            name: 'Cống Vị',
            prefix: 'Phường',
          },
          {
            id: '328',
            name: 'Điện Biên',
            prefix: 'Phường',
          },
          {
            id: '329',
            name: 'Đội Cấn',
            prefix: 'Phường',
          },
          {
            id: '330',
            name: 'Giảng Võ',
            prefix: 'Phường',
          },
          {
            id: '331',
            name: 'Kim Mã',
            prefix: 'Phường',
          },
          {
            id: '332',
            name: 'Liễu Giai',
            prefix: 'Phường',
          },
          {
            id: '333',
            name: 'Ngọc Hà',
            prefix: 'Phường',
          },
          {
            id: '334',
            name: 'Ngọc Khánh',
            prefix: 'Phường',
          },
          {
            id: '335',
            name: 'Nguyễn Trung Trực',
            prefix: 'Phường',
          },
          {
            id: '336',
            name: 'Phúc Xá',
            prefix: 'Phường',
          },
          {
            id: '337',
            name: 'Quán Thánh',
            prefix: 'Phường',
          },
          {
            id: '338',
            name: 'Thành Công',
            prefix: 'Phường',
          },
          {
            id: '339',
            name: 'Trúc Bạch',
            prefix: 'Phường',
          },
          {
            id: '340',
            name: 'Vĩnh Phúc',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '26',
        name: 'Ba Vì',
        wards: [
          {
            id: '341',
            name: 'Ba Trại',
            prefix: 'Xã',
          },
          {
            id: '342',
            name: 'Ba Vì',
            prefix: 'Xã',
          },
          {
            id: '343',
            name: 'Cẩm Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '344',
            name: 'Cam Thượng',
            prefix: 'Xã',
          },
          {
            id: '345',
            name: 'Châu Sơn',
            prefix: 'Xã',
          },
          {
            id: '346',
            name: 'Chu Minh',
            prefix: 'Xã',
          },
          {
            id: '347',
            name: 'Cổ Đô',
            prefix: 'Xã',
          },
          {
            id: '348',
            name: 'Đông Quang',
            prefix: 'Xã',
          },
          {
            id: '349',
            name: 'Đồng Thái',
            prefix: 'Xã',
          },
          {
            id: '350',
            name: 'Khánh Thượng',
            prefix: 'Xã',
          },
          {
            id: '351',
            name: 'Minh Châu',
            prefix: 'Xã',
          },
          {
            id: '352',
            name: 'Minh Quang',
            prefix: 'Xã',
          },
          {
            id: '353',
            name: 'Phong Vân',
            prefix: 'Xã',
          },
          {
            id: '354',
            name: 'Phú Châu',
            prefix: 'Xã',
          },
          {
            id: '355',
            name: 'Phú Cường',
            prefix: 'Xã',
          },
          {
            id: '356',
            name: 'Phú Đông',
            prefix: 'Xã',
          },
          {
            id: '357',
            name: 'Phú Phương',
            prefix: 'Xã',
          },
          {
            id: '358',
            name: 'Phú Sơn',
            prefix: 'Xã',
          },
          {
            id: '359',
            name: 'Sơn Đà',
            prefix: 'Xã',
          },
          {
            id: '360',
            name: 'Tản Hồng',
            prefix: 'Xã',
          },
          {
            id: '361',
            name: 'Tản Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '362',
            name: 'Tây Đằng',
            prefix: 'Thị trấn',
          },
          {
            id: '363',
            name: 'Thái Hòa',
            prefix: 'Xã',
          },
          {
            id: '364',
            name: 'Thuần Mỹ',
            prefix: 'Xã',
          },
          {
            id: '365',
            name: 'Thụy An',
            prefix: 'Xã',
          },
          {
            id: '366',
            name: 'Tiên Phong',
            prefix: 'Xã',
          },
          {
            id: '367',
            name: 'Tòng Bạt',
            prefix: 'Xã',
          },
          {
            id: '368',
            name: 'Vân Hòa',
            prefix: 'Xã',
          },
          {
            id: '369',
            name: 'Vạn Thắng',
            prefix: 'Xã',
          },
          {
            id: '370',
            name: 'Vật Lại',
            prefix: 'Xã',
          },
          {
            id: '371',
            name: 'Yên Bài',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '27',
        name: 'Bắc Từ Liêm',
        wards: [
          {
            id: '372',
            name: 'Cổ Nhuế 1',
            prefix: 'Phường',
          },
          {
            id: '373',
            name: 'Cổ Nhuế 2',
            prefix: 'Phường',
          },
          {
            id: '374',
            name: 'Đông Ngạc',
            prefix: 'Xã',
          },
          {
            id: '375',
            name: 'Đức Thắng',
            prefix: 'Phường',
          },
          {
            id: '376',
            name: 'Liên Mạc',
            prefix: 'Xã',
          },
          {
            id: '377',
            name: 'Minh Khai',
            prefix: 'Xã',
          },
          {
            id: '378',
            name: 'Phú Diễn',
            prefix: 'Phường',
          },
          {
            id: '379',
            name: 'Phúc Diễn',
            prefix: 'Phường',
          },
          {
            id: '380',
            name: 'Tây Tựu',
            prefix: 'Xã',
          },
          {
            id: '381',
            name: 'Thượng Cát',
            prefix: 'Xã',
          },
          {
            id: '382',
            name: 'Thụy Phương',
            prefix: 'Xã',
          },
          {
            id: '383',
            name: 'Xuân Đỉnh',
            prefix: 'Phường',
          },
          {
            id: '384',
            name: 'Xuân Tảo',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '28',
        name: 'Cầu Giấy',
        wards: [
          {
            id: '385',
            name: 'Dịch Vọng',
            prefix: 'Phường',
          },
          {
            id: '386',
            name: 'Dịch Vọng Hậu',
            prefix: 'Phường',
          },
          {
            id: '387',
            name: 'Mai Dịch',
            prefix: 'Phường',
          },
          {
            id: '388',
            name: 'Nghĩa Đô',
            prefix: 'Phường',
          },
          {
            id: '389',
            name: 'Nghĩa Tân',
            prefix: 'Phường',
          },
          {
            id: '390',
            name: 'Quan Hoa',
            prefix: 'Phường',
          },
          {
            id: '391',
            name: 'Trung Hòa',
            prefix: 'Phường',
          },
          {
            id: '392',
            name: 'Yên Hòa',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '29',
        name: 'Chương Mỹ',
        wards: [
          {
            id: '393',
            name: 'Chúc Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '394',
            name: 'Đại Yên',
            prefix: 'Xã',
          },
          {
            id: '395',
            name: 'Đồng Lạc',
            prefix: 'Xã',
          },
          {
            id: '396',
            name: 'Đồng Phú',
            prefix: 'Xã',
          },
          {
            id: '397',
            name: 'Đông Phương Yên',
            prefix: 'Xã',
          },
          {
            id: '398',
            name: 'Đông Sơn',
            prefix: 'Xã',
          },
          {
            id: '399',
            name: 'Hoà Chính',
            prefix: 'Xã',
          },
          {
            id: '400',
            name: 'Hoàng Diệu',
            prefix: 'Xã',
          },
          {
            id: '401',
            name: 'Hoàng Văn Thụ',
            prefix: 'Xã',
          },
          {
            id: '402',
            name: 'Hồng Phong',
            prefix: 'Xã',
          },
          {
            id: '403',
            name: 'Hợp Đồng',
            prefix: 'Xã',
          },
          {
            id: '404',
            name: 'Hữu Văn',
            prefix: 'Xã',
          },
          {
            id: '405',
            name: 'Lam Điền',
            prefix: 'Xã',
          },
          {
            id: '406',
            name: 'Mỹ Lương',
            prefix: 'Xã',
          },
          {
            id: '407',
            name: 'Nam Phương Tiến',
            prefix: 'Xã',
          },
          {
            id: '408',
            name: 'Ngọc Hòa',
            prefix: 'Xã',
          },
          {
            id: '409',
            name: 'Phú Nam An',
            prefix: 'Xã',
          },
          {
            id: '410',
            name: 'Phú Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '411',
            name: 'Phụng Châu',
            prefix: 'Xã',
          },
          {
            id: '412',
            name: 'Quảng Bị',
            prefix: 'Xã',
          },
          {
            id: '413',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '414',
            name: 'Thanh Bình',
            prefix: 'Xã',
          },
          {
            id: '415',
            name: 'Thượng Vực',
            prefix: 'Xã',
          },
          {
            id: '416',
            name: 'Thụy Hương',
            prefix: 'Xã',
          },
          {
            id: '417',
            name: 'Thuỷ Xuân Tiên',
            prefix: 'Xã',
          },
          {
            id: '418',
            name: 'Tiên Phương',
            prefix: 'Xã',
          },
          {
            id: '419',
            name: 'Tốt Động',
            prefix: 'Xã',
          },
          {
            id: '420',
            name: 'Trần Phú',
            prefix: 'Xã',
          },
          {
            id: '421',
            name: 'Trung Hòa',
            prefix: 'Xã',
          },
          {
            id: '422',
            name: 'Trường Yên',
            prefix: 'Xã',
          },
          {
            id: '423',
            name: 'Văn Võ',
            prefix: 'Xã',
          },
          {
            id: '424',
            name: 'Xuân Mai',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '30',
        name: 'Đan Phượng',
        wards: [
          {
            id: '425',
            name: 'Đan Phượng',
            prefix: 'Xã',
          },
          {
            id: '426',
            name: 'Đồng Tháp',
            prefix: 'Xã',
          },
          {
            id: '427',
            name: 'Hạ Mỗ',
            prefix: 'Xã',
          },
          {
            id: '428',
            name: 'Hồng Hà',
            prefix: 'Xã',
          },
          {
            id: '429',
            name: 'Liên Hà',
            prefix: 'Xã',
          },
          {
            id: '430',
            name: 'Liên Hồng',
            prefix: 'Xã',
          },
          {
            id: '431',
            name: 'Liên Trung',
            prefix: 'Xã',
          },
          {
            id: '432',
            name: 'Phùng',
            prefix: 'Thị trấn',
          },
          {
            id: '433',
            name: 'Phương Đình',
            prefix: 'Xã',
          },
          {
            id: '434',
            name: 'Song Phượng',
            prefix: 'Xã',
          },
          {
            id: '435',
            name: 'Tân Hội',
            prefix: 'Xã',
          },
          {
            id: '436',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '437',
            name: 'Thọ An',
            prefix: 'Xã',
          },
          {
            id: '438',
            name: 'Thọ Xuân',
            prefix: 'Xã',
          },
          {
            id: '439',
            name: 'Thượng Mỗ',
            prefix: 'Xã',
          },
          {
            id: '440',
            name: 'Trung Châu',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '31',
        name: 'Đông Anh',
        wards: [
          {
            id: '441',
            name: 'Bắc Hồng',
            prefix: 'Xã',
          },
          {
            id: '442',
            name: 'Cổ Loa',
            prefix: 'Xã',
          },
          {
            id: '446',
            name: 'Dục Tú',
            prefix: 'Xã',
          },
          {
            id: '443',
            name: 'Đại Mạch',
            prefix: 'Xã',
          },
          {
            id: '444',
            name: 'Đông Anh',
            prefix: 'Thị trấn',
          },
          {
            id: '445',
            name: 'Đông Hội',
            prefix: 'Xã',
          },
          {
            id: '447',
            name: 'Hải Bối',
            prefix: 'Xã',
          },
          {
            id: '448',
            name: 'Kim Chung',
            prefix: 'Xã',
          },
          {
            id: '449',
            name: 'Kim Nỗ',
            prefix: 'Xã',
          },
          {
            id: '450',
            name: 'Liên Hà',
            prefix: 'Xã',
          },
          {
            id: '451',
            name: 'Mai Lâm',
            prefix: 'Xã',
          },
          {
            id: '452',
            name: 'Nam Hồng',
            prefix: 'Xã',
          },
          {
            id: '453',
            name: 'Nguyên Khê',
            prefix: 'Xã',
          },
          {
            id: '454',
            name: 'Tàm Xá',
            prefix: 'Xã',
          },
          {
            id: '455',
            name: 'Tầm Xá',
            prefix: 'Xã',
          },
          {
            id: '456',
            name: 'Thụy Lâm',
            prefix: 'Xã',
          },
          {
            id: '457',
            name: 'Tiên Dương',
            prefix: 'Xã',
          },
          {
            id: '458',
            name: 'Uy Nỗ',
            prefix: 'Xã',
          },
          {
            id: '459',
            name: 'Vân Hà',
            prefix: 'Xã',
          },
          {
            id: '460',
            name: 'Vân Nội',
            prefix: 'Xã',
          },
          {
            id: '461',
            name: 'Việt Hùng',
            prefix: 'Xã',
          },
          {
            id: '462',
            name: 'Vĩnh Ngọc',
            prefix: 'Xã',
          },
          {
            id: '463',
            name: 'Võng La',
            prefix: 'Xã',
          },
          {
            id: '464',
            name: 'Xuân Canh',
            prefix: 'Xã',
          },
          {
            id: '465',
            name: 'Xuân Nộn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '32',
        name: 'Đống Đa',
        wards: [
          {
            id: '466',
            name: 'Cát Linh',
            prefix: 'Phường',
          },
          {
            id: '467',
            name: 'Hàng Bột',
            prefix: 'Phường',
          },
          {
            id: '468',
            name: 'Khâm Thiên',
            prefix: 'Phường',
          },
          {
            id: '469',
            name: 'Khương Thượng',
            prefix: 'Phường',
          },
          {
            id: '470',
            name: 'Kim Liên',
            prefix: 'Phường',
          },
          {
            id: '471',
            name: 'Láng Hạ',
            prefix: 'Phường',
          },
          {
            id: '472',
            name: 'Láng Thượng',
            prefix: 'Phường',
          },
          {
            id: '473',
            name: 'Nam Đồng',
            prefix: 'Phường',
          },
          {
            id: '474',
            name: 'Ngã Tư Sở',
            prefix: 'Phường',
          },
          {
            id: '475',
            name: 'Ô Chợ Dừa',
            prefix: 'Phường',
          },
          {
            id: '476',
            name: 'Phương Liên',
            prefix: 'Phường',
          },
          {
            id: '477',
            name: 'Phương Mai',
            prefix: 'Phường',
          },
          {
            id: '478',
            name: 'Quang Trung',
            prefix: 'Phường',
          },
          {
            id: '479',
            name: 'Quốc Tử Giám',
            prefix: 'Phường',
          },
          {
            id: '480',
            name: 'Thịnh Quang',
            prefix: 'Phường',
          },
          {
            id: '481',
            name: 'Thổ Quan',
            prefix: 'Phường',
          },
          {
            id: '482',
            name: 'Trung Liệt',
            prefix: 'Phường',
          },
          {
            id: '483',
            name: 'Trung Phụng',
            prefix: 'Phường',
          },
          {
            id: '484',
            name: 'Trung Tự',
            prefix: 'Phường',
          },
          {
            id: '485',
            name: 'Văn Chương',
            prefix: 'Phường',
          },
          {
            id: '486',
            name: 'Văn Miếu',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '33',
        name: 'Gia Lâm',
        wards: [
          {
            id: '487',
            name: 'Bát Tràng',
            prefix: 'Xã',
          },
          {
            id: '488',
            name: 'Cổ Bi',
            prefix: 'Xã',
          },
          {
            id: '493',
            name: 'Dương Hà',
            prefix: 'Xã',
          },
          {
            id: '494',
            name: 'Dương Quang',
            prefix: 'Xã',
          },
          {
            id: '495',
            name: 'Dương Xá',
            prefix: 'Xã',
          },
          {
            id: '489',
            name: 'Đa Tốn',
            prefix: 'Xã',
          },
          {
            id: '490',
            name: 'Đặng Xá',
            prefix: 'Xã',
          },
          {
            id: '491',
            name: 'Đình Xuyên',
            prefix: 'Xã',
          },
          {
            id: '492',
            name: 'Đông Dư',
            prefix: 'Xã',
          },
          {
            id: '496',
            name: 'Kiêu Kỵ',
            prefix: 'Xã',
          },
          {
            id: '497',
            name: 'Kim Lan',
            prefix: 'Thị trấn',
          },
          {
            id: '498',
            name: 'Kim Sơn',
            prefix: 'Xã',
          },
          {
            id: '499',
            name: 'Lệ Chi',
            prefix: 'Xã',
          },
          {
            id: '500',
            name: 'Ninh Hiệp',
            prefix: 'Xã',
          },
          {
            id: '501',
            name: 'Phù Đổng',
            prefix: 'Xã',
          },
          {
            id: '502',
            name: 'Phú Thị',
            prefix: 'Xã',
          },
          {
            id: '503',
            name: 'Trâu Quỳ',
            prefix: 'Thị trấn',
          },
          {
            id: '504',
            name: 'Trung Mầu',
            prefix: 'Xã',
          },
          {
            id: '505',
            name: 'Văn Đức',
            prefix: 'Xã',
          },
          {
            id: '506',
            name: 'Yên Thường',
            prefix: 'Xã',
          },
          {
            id: '507',
            name: 'Yên Viên',
            prefix: 'Thị trấn',
          },
          {
            id: '508',
            name: 'Yên Viên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '34',
        name: 'Hà Đông',
        wards: [
          {
            id: '509',
            name: 'Biên Giang',
            prefix: 'Phường',
          },
          {
            id: '511',
            name: 'Dương Nội',
            prefix: 'Phường',
          },
          {
            id: '510',
            name: 'Đồng Mai',
            prefix: 'Phường',
          },
          {
            id: '512',
            name: 'Hà Cầu',
            prefix: 'Phường',
          },
          {
            id: '513',
            name: 'Kiến Hưng',
            prefix: 'Phường',
          },
          {
            id: '514',
            name: 'La Khê',
            prefix: 'Phường',
          },
          {
            id: '515',
            name: 'Mỗ Lao',
            prefix: 'Phường',
          },
          {
            id: '516',
            name: 'Nguyễn Trãi',
            prefix: 'Phường',
          },
          {
            id: '517',
            name: 'Phú La',
            prefix: 'Phường',
          },
          {
            id: '518',
            name: 'Phú Lãm',
            prefix: 'Phường',
          },
          {
            id: '519',
            name: 'Phú Lương',
            prefix: 'Phường',
          },
          {
            id: '520',
            name: 'Phúc La',
            prefix: 'Phường',
          },
          {
            id: '521',
            name: 'Quang Trung',
            prefix: 'Phường',
          },
          {
            id: '522',
            name: 'Vạn Phúc',
            prefix: 'Phường',
          },
          {
            id: '523',
            name: 'Văn Quán',
            prefix: 'Phường',
          },
          {
            id: '524',
            name: 'Yên Nghĩa',
            prefix: 'Phường',
          },
          {
            id: '525',
            name: 'Yết Kiêu',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '35',
        name: 'Hai Bà Trưng',
        wards: [
          {
            id: '526',
            name: 'Bạch Đằng',
            prefix: 'Phường',
          },
          {
            id: '527',
            name: 'Bách Khoa',
            prefix: 'Phường',
          },
          {
            id: '528',
            name: 'Bạch Mai',
            prefix: 'Phường',
          },
          {
            id: '529',
            name: 'Bùi Thị Xuân',
            prefix: 'Phường',
          },
          {
            id: '530',
            name: 'Cầu Dền',
            prefix: 'Phường',
          },
          {
            id: '531',
            name: 'Đống Mác',
            prefix: 'Phường',
          },
          {
            id: '532',
            name: 'Đồng Nhân',
            prefix: 'Phường',
          },
          {
            id: '533',
            name: 'Đồng Tâm',
            prefix: 'Phường',
          },
          {
            id: '534',
            name: 'Lê Đại Hành',
            prefix: 'Phường',
          },
          {
            id: '535',
            name: 'Minh Khai',
            prefix: 'Phường',
          },
          {
            id: '536',
            name: 'Ngô Thì Nhậm',
            prefix: 'Phường',
          },
          {
            id: '537',
            name: 'Nguyễn Du',
            prefix: 'Phường',
          },
          {
            id: '538',
            name: 'Phạm Đình Hổ',
            prefix: 'Phường',
          },
          {
            id: '539',
            name: 'Phố Huế',
            prefix: 'Phường',
          },
          {
            id: '540',
            name: 'Quỳnh Lôi',
            prefix: 'Phường',
          },
          {
            id: '541',
            name: 'Quỳnh Mai',
            prefix: 'Phường',
          },
          {
            id: '542',
            name: 'Thanh Lương',
            prefix: 'Phường',
          },
          {
            id: '543',
            name: 'Thanh Nhàn',
            prefix: 'Phường',
          },
          {
            id: '544',
            name: 'Trương Định',
            prefix: 'Phường',
          },
          {
            id: '545',
            name: 'Vĩnh Tuy',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '36',
        name: 'Hoài Đức',
        wards: [
          {
            id: '546',
            name: 'An Khánh',
            prefix: 'Xã',
          },
          {
            id: '547',
            name: 'An Thượng',
            prefix: 'Xã',
          },
          {
            id: '548',
            name: 'Cát Quế',
            prefix: 'Xã',
          },
          {
            id: '550',
            name: 'Di Trạch',
            prefix: 'Xã',
          },
          {
            id: '554',
            name: 'Dương Liễu',
            prefix: 'Xã',
          },
          {
            id: '549',
            name: 'Đắc Sở',
            prefix: 'Xã',
          },
          {
            id: '551',
            name: 'Đông La',
            prefix: 'Xã',
          },
          {
            id: '552',
            name: 'Đức Giang',
            prefix: 'Xã',
          },
          {
            id: '553',
            name: 'Đức Thượng',
            prefix: 'Xã',
          },
          {
            id: '555',
            name: 'Kim Chung',
            prefix: 'Xã',
          },
          {
            id: '556',
            name: 'La Phù',
            prefix: 'Xã',
          },
          {
            id: '557',
            name: 'Lại Yên',
            prefix: 'Xã',
          },
          {
            id: '558',
            name: 'Minh Khai',
            prefix: 'Xã',
          },
          {
            id: '559',
            name: 'Sơn Đồng',
            prefix: 'Xã',
          },
          {
            id: '560',
            name: 'Song Phương',
            prefix: 'Xã',
          },
          {
            id: '561',
            name: 'Tiền Yên',
            prefix: 'Xã',
          },
          {
            id: '562',
            name: 'Trạm Trôi',
            prefix: 'Thị trấn',
          },
          {
            id: '563',
            name: 'Vân Canh',
            prefix: 'Xã',
          },
          {
            id: '564',
            name: 'Vân Côn',
            prefix: 'Xã',
          },
          {
            id: '565',
            name: 'Yên Sở',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '37',
        name: 'Hoàn Kiếm',
        wards: [
          {
            id: '566',
            name: 'Chương Dương Độ',
            prefix: 'Phường',
          },
          {
            id: '567',
            name: 'Cửa Đông',
            prefix: 'Phường',
          },
          {
            id: '568',
            name: 'Cửa Nam',
            prefix: 'Phường',
          },
          {
            id: '569',
            name: 'Đồng Xuân',
            prefix: 'Phường',
          },
          {
            id: '570',
            name: 'Hàng Bạc',
            prefix: 'Phường',
          },
          {
            id: '571',
            name: 'Hàng Bài',
            prefix: 'Phường',
          },
          {
            id: '572',
            name: 'Hàng Bồ',
            prefix: 'Phường',
          },
          {
            id: '573',
            name: 'Hàng Bông',
            prefix: 'Phường',
          },
          {
            id: '574',
            name: 'Hàng Buồm',
            prefix: 'Phường',
          },
          {
            id: '575',
            name: 'Hàng Đào',
            prefix: 'Phường',
          },
          {
            id: '576',
            name: 'Hàng Gai',
            prefix: 'Phường',
          },
          {
            id: '577',
            name: 'Hàng Mã',
            prefix: 'Phường',
          },
          {
            id: '578',
            name: 'Hàng Trống',
            prefix: 'Phường',
          },
          {
            id: '579',
            name: 'Lý Thái Tổ',
            prefix: 'Phường',
          },
          {
            id: '580',
            name: 'Phan Chu Trinh',
            prefix: 'Phường',
          },
          {
            id: '581',
            name: 'Phúc Tân',
            prefix: 'Phường',
          },
          {
            id: '582',
            name: 'Trần Hưng Đạo',
            prefix: 'Phường',
          },
          {
            id: '583',
            name: 'Tràng Tiền',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '38',
        name: 'Hoàng Mai',
        wards: [
          {
            id: '584',
            name: 'Đại Kim',
            prefix: 'Phường',
          },
          {
            id: '585',
            name: 'Định Công',
            prefix: 'Phường',
          },
          {
            id: '586',
            name: 'Giáp Bát',
            prefix: 'Phường',
          },
          {
            id: '587',
            name: 'Hoàng Liệt',
            prefix: 'Phường',
          },
          {
            id: '588',
            name: 'Hoàng Văn Thụ',
            prefix: 'Phường',
          },
          {
            id: '589',
            name: 'Lĩnh Nam',
            prefix: 'Phường',
          },
          {
            id: '590',
            name: 'Mai Động',
            prefix: 'Phường',
          },
          {
            id: '591',
            name: 'Tân Mai',
            prefix: 'Phường',
          },
          {
            id: '592',
            name: 'Thanh Trì',
            prefix: 'Phường',
          },
          {
            id: '593',
            name: 'Thịnh Liệt',
            prefix: 'Phường',
          },
          {
            id: '594',
            name: 'Trần Phú',
            prefix: 'Phường',
          },
          {
            id: '595',
            name: 'Tương Mai',
            prefix: 'Phường',
          },
          {
            id: '596',
            name: 'Vĩnh Hưng',
            prefix: 'Phường',
          },
          {
            id: '597',
            name: 'Yên Sở',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '39',
        name: 'Long Biên',
        wards: [
          {
            id: '598',
            name: 'Bồ Đề',
            prefix: 'Phường',
          },
          {
            id: '599',
            name: 'Cự Khối',
            prefix: 'Phường',
          },
          {
            id: '600',
            name: 'Đức Giang',
            prefix: 'Phường',
          },
          {
            id: '601',
            name: 'Gia Thụy',
            prefix: 'Phường',
          },
          {
            id: '602',
            name: 'Giang Biên',
            prefix: 'Phường',
          },
          {
            id: '603',
            name: 'Long Biên',
            prefix: 'Phường',
          },
          {
            id: '604',
            name: 'Ngọc Lâm',
            prefix: 'Phường',
          },
          {
            id: '605',
            name: 'Ngọc Thụy',
            prefix: 'Phường',
          },
          {
            id: '606',
            name: 'Phúc Đồng',
            prefix: 'Phường',
          },
          {
            id: '607',
            name: 'Phúc Lợi',
            prefix: 'Phường',
          },
          {
            id: '608',
            name: 'Sài Đồng',
            prefix: 'Phường',
          },
          {
            id: '609',
            name: 'Thạch Bàn',
            prefix: 'Phường',
          },
          {
            id: '610',
            name: 'Thượng Thanh',
            prefix: 'Phường',
          },
          {
            id: '611',
            name: 'Việt Hưng',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '40',
        name: 'Mê Linh',
        wards: [
          {
            id: '612',
            name: 'Chi Đông',
            prefix: 'Thị trấn',
          },
          {
            id: '613',
            name: 'Chu Phan',
            prefix: 'Xã',
          },
          {
            id: '614',
            name: 'Đại Thịnh',
            prefix: 'Xã',
          },
          {
            id: '615',
            name: 'Hoàng Kim',
            prefix: 'Xã',
          },
          {
            id: '616',
            name: 'Kim Hoa',
            prefix: 'Xã',
          },
          {
            id: '617',
            name: 'Liên Mạc',
            prefix: 'Xã',
          },
          {
            id: '618',
            name: 'Mê Linh',
            prefix: 'Xã',
          },
          {
            id: '619',
            name: 'Quang Minh',
            prefix: 'Thị trấn',
          },
          {
            id: '620',
            name: 'Tam Đồng',
            prefix: 'Xã',
          },
          {
            id: '621',
            name: 'Thạch Đà',
            prefix: 'Xã',
          },
          {
            id: '622',
            name: 'Thanh Lâm',
            prefix: 'Xã',
          },
          {
            id: '623',
            name: 'Tiền Phong',
            prefix: 'Xã',
          },
          {
            id: '624',
            name: 'Tiến Thắng',
            prefix: 'Xã',
          },
          {
            id: '625',
            name: 'Tiến Thịnh',
            prefix: 'Xã',
          },
          {
            id: '626',
            name: 'Tráng Việt',
            prefix: 'Xã',
          },
          {
            id: '627',
            name: 'Tự Lập',
            prefix: 'Xã',
          },
          {
            id: '628',
            name: 'Văn Khê',
            prefix: 'Xã',
          },
          {
            id: '629',
            name: 'Vạn Yên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '41',
        name: 'Mỹ Đức',
        wards: [
          {
            id: '630',
            name: 'An Mỹ',
            prefix: 'Xã',
          },
          {
            id: '631',
            name: 'An Phú',
            prefix: 'Xã',
          },
          {
            id: '632',
            name: 'An Tiến',
            prefix: 'Xã',
          },
          {
            id: '633',
            name: 'Bột Xuyên',
            prefix: 'Xã',
          },
          {
            id: '634',
            name: 'Đại Hưng',
            prefix: 'Xã',
          },
          {
            id: '635',
            name: 'Đại Nghĩa',
            prefix: 'Thị trấn',
          },
          {
            id: '636',
            name: 'Đốc Tín',
            prefix: 'Xã',
          },
          {
            id: '637',
            name: 'Đồng Tâm',
            prefix: 'Xã',
          },
          {
            id: '638',
            name: 'Hồng Sơn',
            prefix: 'Xã',
          },
          {
            id: '639',
            name: 'Hợp Thanh',
            prefix: 'Xã',
          },
          {
            id: '640',
            name: 'Hợp Tiến',
            prefix: 'Xã',
          },
          {
            id: '641',
            name: 'Hùng Tiến',
            prefix: 'Xã',
          },
          {
            id: '642',
            name: 'Hương Sơn',
            prefix: 'Xã',
          },
          {
            id: '643',
            name: 'Lê Thanh',
            prefix: 'Xã',
          },
          {
            id: '644',
            name: 'Mỹ Thành',
            prefix: 'Xã',
          },
          {
            id: '645',
            name: 'Phù Lưu Tế',
            prefix: 'Xã',
          },
          {
            id: '646',
            name: 'Phúc Lâm',
            prefix: 'Xã',
          },
          {
            id: '647',
            name: 'Phùng Xá',
            prefix: 'Xã',
          },
          {
            id: '648',
            name: 'Thượng Lâm',
            prefix: 'Xã',
          },
          {
            id: '649',
            name: 'Tuy Lai',
            prefix: 'Xã',
          },
          {
            id: '650',
            name: 'Vạn Kim',
            prefix: 'Xã',
          },
          {
            id: '651',
            name: 'Xuy Xá',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '42',
        name: 'Nam Từ Liêm',
        wards: [
          {
            id: '652',
            name: 'Cầu Diễn',
            prefix: 'Thị trấn',
          },
          {
            id: '653',
            name: 'Đại Mỗ',
            prefix: 'Xã',
          },
          {
            id: '654',
            name: 'Mễ Trì',
            prefix: 'Xã',
          },
          {
            id: '655',
            name: 'Mỹ Đình 1',
            prefix: 'Phường',
          },
          {
            id: '656',
            name: 'Mỹ Đình 2',
            prefix: 'Phường',
          },
          {
            id: '657',
            name: 'Phú Đô',
            prefix: 'Xã',
          },
          {
            id: '658',
            name: 'Phương Canh',
            prefix: 'Phường',
          },
          {
            id: '659',
            name: 'Tây Mỗ',
            prefix: 'Xã',
          },
          {
            id: '660',
            name: 'Trung Văn',
            prefix: 'Xã',
          },
          {
            id: '661',
            name: 'Xuân Phương',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '43',
        name: 'Phú Xuyên',
        wards: [
          {
            id: '662',
            name: 'Bạch Hạ',
            prefix: 'Xã',
          },
          {
            id: '663',
            name: 'Châu Can',
            prefix: 'Xã',
          },
          {
            id: '664',
            name: 'Chuyên Mỹ',
            prefix: 'Xã',
          },
          {
            id: '665',
            name: 'Đại Thắng',
            prefix: 'Xã',
          },
          {
            id: '666',
            name: 'Đại Xuyên',
            prefix: 'Xã',
          },
          {
            id: '667',
            name: 'Hoàng Long',
            prefix: 'Xã',
          },
          {
            id: '668',
            name: 'Hồng Minh',
            prefix: 'Xã',
          },
          {
            id: '669',
            name: 'Hồng Thái',
            prefix: 'Xã',
          },
          {
            id: '670',
            name: 'Khai Thái',
            prefix: 'Xã',
          },
          {
            id: '671',
            name: 'Minh Tân',
            prefix: 'Xã',
          },
          {
            id: '672',
            name: 'Nam Phong',
            prefix: 'Xã',
          },
          {
            id: '673',
            name: 'Nam Triều',
            prefix: 'Xã',
          },
          {
            id: '674',
            name: 'Phú Minh',
            prefix: 'Thị trấn',
          },
          {
            id: '675',
            name: 'Phú Túc',
            prefix: 'Xã',
          },
          {
            id: '676',
            name: 'Phú Xuyên',
            prefix: 'Thị trấn',
          },
          {
            id: '677',
            name: 'Phú Yên',
            prefix: 'Xã',
          },
          {
            id: '678',
            name: 'Phúc Tiến',
            prefix: 'Xã',
          },
          {
            id: '679',
            name: 'Phượng Dực',
            prefix: 'Xã',
          },
          {
            id: '680',
            name: 'Quang Lãng',
            prefix: 'Xã',
          },
          {
            id: '681',
            name: 'Quang Trung',
            prefix: 'Xã',
          },
          {
            id: '682',
            name: 'Sơn Hà',
            prefix: 'Xã',
          },
          {
            id: '683',
            name: 'Tân Dân',
            prefix: 'Xã',
          },
          {
            id: '684',
            name: 'Thụy Phú',
            prefix: 'Xã',
          },
          {
            id: '685',
            name: 'Tri Thủy',
            prefix: 'Xã',
          },
          {
            id: '686',
            name: 'Tri Trung',
            prefix: 'Xã',
          },
          {
            id: '687',
            name: 'Văn Hoàng',
            prefix: 'Xã',
          },
          {
            id: '688',
            name: 'Văn Nhân',
            prefix: 'Xã',
          },
          {
            id: '689',
            name: 'Vân Từ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '44',
        name: 'Phúc Thọ',
        wards: [
          {
            id: '690',
            name: 'Cẩm Đình',
            prefix: 'Xã',
          },
          {
            id: '691',
            name: 'Gạch',
            prefix: 'Thị trấn',
          },
          {
            id: '692',
            name: 'Hát Môn',
            prefix: 'Xã',
          },
          {
            id: '693',
            name: 'Hiệp Thuận',
            prefix: 'Xã',
          },
          {
            id: '694',
            name: 'Liên Hiệp',
            prefix: 'Xã',
          },
          {
            id: '695',
            name: 'Long Xuyên',
            prefix: 'Xã',
          },
          {
            id: '696',
            name: 'Ngọc Tảo',
            prefix: 'Xã',
          },
          {
            id: '697',
            name: 'Phúc Hòa',
            prefix: 'Xã',
          },
          {
            id: '698',
            name: 'Phúc Thọ',
            prefix: 'Thị trấn',
          },
          {
            id: '699',
            name: 'Phụng Thượng',
            prefix: 'Xã',
          },
          {
            id: '700',
            name: 'Phương Độ',
            prefix: 'Xã',
          },
          {
            id: '701',
            name: 'Sen Chiểu',
            prefix: 'Xã',
          },
          {
            id: '702',
            name: 'Tam Hiệp',
            prefix: 'Xã',
          },
          {
            id: '703',
            name: 'Tam Thuấn',
            prefix: 'Xã',
          },
          {
            id: '704',
            name: 'Thanh Đa',
            prefix: 'Xã',
          },
          {
            id: '705',
            name: 'Thọ Lộc',
            prefix: 'Xã',
          },
          {
            id: '706',
            name: 'Thượng Cốc',
            prefix: 'Xã',
          },
          {
            id: '707',
            name: 'Tích Giang',
            prefix: 'Xã',
          },
          {
            id: '708',
            name: 'Trạch Mỹ Lộc',
            prefix: 'Xã',
          },
          {
            id: '709',
            name: 'Vân Hà',
            prefix: 'Xã',
          },
          {
            id: '710',
            name: 'Vân Nam',
            prefix: 'Xã',
          },
          {
            id: '711',
            name: 'Vân Phúc',
            prefix: 'Xã',
          },
          {
            id: '712',
            name: 'Võng Xuyên',
            prefix: 'Xã',
          },
          {
            id: '713',
            name: 'Xuân Phú',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '45',
        name: 'Quốc Oai',
        wards: [
          {
            id: '714',
            name: 'Cấn Hữu',
            prefix: 'Xã',
          },
          {
            id: '715',
            name: 'Cộng Hòa',
            prefix: 'Xã',
          },
          {
            id: '716',
            name: 'Đại Thành',
            prefix: 'Xã',
          },
          {
            id: '717',
            name: 'Đồng Quang',
            prefix: 'Xã',
          },
          {
            id: '718',
            name: 'Đông Xuân',
            prefix: 'Xã',
          },
          {
            id: '719',
            name: 'Đông Yên',
            prefix: 'Xã',
          },
          {
            id: '720',
            name: 'Hòa Thạch',
            prefix: 'Xã',
          },
          {
            id: '721',
            name: 'Liệp Tuyết',
            prefix: 'Xã',
          },
          {
            id: '722',
            name: 'Nghĩa Hương',
            prefix: 'Xã',
          },
          {
            id: '723',
            name: 'Ngọc Liệp',
            prefix: 'Xã',
          },
          {
            id: '724',
            name: 'Ngọc Mỹ',
            prefix: 'Xã',
          },
          {
            id: '725',
            name: 'Phú Cát',
            prefix: 'Xã',
          },
          {
            id: '726',
            name: 'Phú Mãn',
            prefix: 'Xã',
          },
          {
            id: '727',
            name: 'Phượng Cách',
            prefix: 'Xã',
          },
          {
            id: '728',
            name: 'Quốc Oai',
            prefix: 'Thị trấn',
          },
          {
            id: '729',
            name: 'Sài Sơn',
            prefix: 'Xã',
          },
          {
            id: '730',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
          {
            id: '731',
            name: 'Tân Phú',
            prefix: 'Xã',
          },
          {
            id: '732',
            name: 'Thạch Thán',
            prefix: 'Xã',
          },
          {
            id: '733',
            name: 'Tuyết Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '734',
            name: 'Yên Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '46',
        name: 'Sóc Sơn',
        wards: [
          {
            id: '735',
            name: 'Bắc Phú',
            prefix: 'Xã',
          },
          {
            id: '736',
            name: 'Bắc Sơn',
            prefix: 'Xã',
          },
          {
            id: '737',
            name: 'Đông Xuân',
            prefix: 'Xã',
          },
          {
            id: '738',
            name: 'Đức Hoà',
            prefix: 'Xã',
          },
          {
            id: '739',
            name: 'Hiền Ninh',
            prefix: 'Xã',
          },
          {
            id: '740',
            name: 'Hồng Kỳ',
            prefix: 'Xã',
          },
          {
            id: '741',
            name: 'Kim Lũ',
            prefix: 'Xã',
          },
          {
            id: '742',
            name: 'Mai Đình',
            prefix: 'Xã',
          },
          {
            id: '743',
            name: 'Minh Phú',
            prefix: 'Xã',
          },
          {
            id: '744',
            name: 'Minh Trí',
            prefix: 'Xã',
          },
          {
            id: '745',
            name: 'Nam Sơn',
            prefix: 'Xã',
          },
          {
            id: '746',
            name: 'Phú Cường',
            prefix: 'Xã',
          },
          {
            id: '747',
            name: 'Phù Linh',
            prefix: 'Xã',
          },
          {
            id: '748',
            name: 'Phù Lỗ',
            prefix: 'Xã',
          },
          {
            id: '749',
            name: 'Phú Minh',
            prefix: 'Xã',
          },
          {
            id: '750',
            name: 'Quang Tiến',
            prefix: 'Xã',
          },
          {
            id: '751',
            name: 'Sóc Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '752',
            name: 'Tân Dân',
            prefix: 'Xã',
          },
          {
            id: '753',
            name: 'Tân Hưng',
            prefix: 'Xã',
          },
          {
            id: '754',
            name: 'Tân Minh',
            prefix: 'Xã',
          },
          {
            id: '755',
            name: 'Thanh Xuân',
            prefix: 'Xã',
          },
          {
            id: '756',
            name: 'Tiên Dược',
            prefix: 'Xã',
          },
          {
            id: '757',
            name: 'Trung Giã',
            prefix: 'Xã',
          },
          {
            id: '758',
            name: 'Việt Long',
            prefix: 'Xã',
          },
          {
            id: '759',
            name: 'Xuân Giang',
            prefix: 'Xã',
          },
          {
            id: '760',
            name: 'Xuân Thu',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '47',
        name: 'Sơn Tây',
        wards: [
          {
            id: '761',
            name: 'Cổ Đông',
            prefix: 'Xã',
          },
          {
            id: '762',
            name: 'Đường Lâm',
            prefix: 'Xã',
          },
          {
            id: '763',
            name: 'Kim Sơn',
            prefix: 'Phường',
          },
          {
            id: '764',
            name: 'Lê Lợi',
            prefix: 'Phường',
          },
          {
            id: '765',
            name: 'Ngô Quyền',
            prefix: 'Phường',
          },
          {
            id: '766',
            name: 'Phú Thịnh',
            prefix: 'Phường',
          },
          {
            id: '767',
            name: 'Quang Trung',
            prefix: 'Phường',
          },
          {
            id: '768',
            name: 'Sơn Đông',
            prefix: 'Xã',
          },
          {
            id: '769',
            name: 'Sơn Lộc',
            prefix: 'Phường',
          },
          {
            id: '770',
            name: 'Thanh Mỹ',
            prefix: 'Xã',
          },
          {
            id: '771',
            name: 'Trung Hưng',
            prefix: 'Phường',
          },
          {
            id: '772',
            name: 'Trung Sơn Trầm',
            prefix: 'Phường',
          },
          {
            id: '773',
            name: 'Viên Sơn',
            prefix: 'Phường',
          },
          {
            id: '774',
            name: 'Xuân Khanh',
            prefix: 'Phường',
          },
          {
            id: '775',
            name: 'Xuân Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '48',
        name: 'Tây Hồ',
        wards: [
          {
            id: '776',
            name: 'Bưởi',
            prefix: 'Phường',
          },
          {
            id: '777',
            name: 'Nhật Tân',
            prefix: 'Phường',
          },
          {
            id: '778',
            name: 'Phú Thượng',
            prefix: 'Phường',
          },
          {
            id: '779',
            name: 'Quảng An',
            prefix: 'Phường',
          },
          {
            id: '780',
            name: 'Thụy Khuê',
            prefix: 'Phường',
          },
          {
            id: '781',
            name: 'Tứ Liên',
            prefix: 'Phường',
          },
          {
            id: '782',
            name: 'Xuân La',
            prefix: 'Phường',
          },
          {
            id: '783',
            name: 'Yên Phụ',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '49',
        name: 'Thạch Thất',
        wards: [
          {
            id: '784',
            name: 'Bình Phú',
            prefix: 'Xã',
          },
          {
            id: '785',
            name: 'Bình Yên',
            prefix: 'Xã',
          },
          {
            id: '786',
            name: 'Cẩm Yên',
            prefix: 'Xã',
          },
          {
            id: '787',
            name: 'Cần Kiệm',
            prefix: 'Xã',
          },
          {
            id: '788',
            name: 'Canh Nậu',
            prefix: 'Xã',
          },
          {
            id: '789',
            name: 'Chàng Sơn',
            prefix: 'Xã',
          },
          {
            id: '791',
            name: 'Dị Nậu',
            prefix: 'Xã',
          },
          {
            id: '790',
            name: 'Đại Đồng',
            prefix: 'Xã',
          },
          {
            id: '792',
            name: 'Đồng Trúc',
            prefix: 'Xã',
          },
          {
            id: '793',
            name: 'Hạ Bằng',
            prefix: 'Xã',
          },
          {
            id: '794',
            name: 'Hương Ngải',
            prefix: 'Xã',
          },
          {
            id: '795',
            name: 'Hữu Bằng',
            prefix: 'Xã',
          },
          {
            id: '796',
            name: 'Kim Quan',
            prefix: 'Xã',
          },
          {
            id: '797',
            name: 'Lại Thượng',
            prefix: 'Xã',
          },
          {
            id: '798',
            name: 'Liên Quan',
            prefix: 'Thị trấn',
          },
          {
            id: '799',
            name: 'Phú Kim',
            prefix: 'Xã',
          },
          {
            id: '800',
            name: 'Phùng Xá',
            prefix: 'Xã',
          },
          {
            id: '801',
            name: 'Tân Xã',
            prefix: 'Xã',
          },
          {
            id: '802',
            name: 'Thạch Hòa',
            prefix: 'Xã',
          },
          {
            id: '803',
            name: 'Thạch Xá',
            prefix: 'Xã',
          },
          {
            id: '804',
            name: 'Tiến Xuân',
            prefix: 'Xã',
          },
          {
            id: '805',
            name: 'Yên Bình',
            prefix: 'Xã',
          },
          {
            id: '806',
            name: 'Yên Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '50',
        name: 'Thanh Oai',
        wards: [
          {
            id: '807',
            name: 'Bích Hòa',
            prefix: 'Xã',
          },
          {
            id: '808',
            name: 'Bình Minh',
            prefix: 'Xã',
          },
          {
            id: '809',
            name: 'Cao Dương',
            prefix: 'Xã',
          },
          {
            id: '810',
            name: 'Cao Viên',
            prefix: 'Xã',
          },
          {
            id: '811',
            name: 'Cự Khê',
            prefix: 'Xã',
          },
          {
            id: '812',
            name: 'Dân Hòa',
            prefix: 'Xã',
          },
          {
            id: '813',
            name: 'Đỗ Động',
            prefix: 'Xã',
          },
          {
            id: '814',
            name: 'Hồng Dương',
            prefix: 'Xã',
          },
          {
            id: '815',
            name: 'Kim An',
            prefix: 'Xã',
          },
          {
            id: '816',
            name: 'Kim Bài',
            prefix: 'Thị trấn',
          },
          {
            id: '817',
            name: 'Kim Thư',
            prefix: 'Xã',
          },
          {
            id: '818',
            name: 'Liên Châu',
            prefix: 'Xã',
          },
          {
            id: '819',
            name: 'Mỹ Hưng',
            prefix: 'Xã',
          },
          {
            id: '820',
            name: 'Phương Trung',
            prefix: 'Xã',
          },
          {
            id: '821',
            name: 'Tam Hưng',
            prefix: 'Xã',
          },
          {
            id: '822',
            name: 'Tân Ước',
            prefix: 'Xã',
          },
          {
            id: '823',
            name: 'Thanh Cao',
            prefix: 'Xã',
          },
          {
            id: '824',
            name: 'Thanh Mai',
            prefix: 'Xã',
          },
          {
            id: '825',
            name: 'Thanh Thùy',
            prefix: 'Xã',
          },
          {
            id: '826',
            name: 'Thanh Văn',
            prefix: 'Xã',
          },
          {
            id: '827',
            name: 'Xuân Dương',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '51',
        name: 'Thanh Trì',
        wards: [
          {
            id: '830',
            name: 'Duyên Hà',
            prefix: 'Xã',
          },
          {
            id: '828',
            name: 'Đại Áng',
            prefix: 'Xã',
          },
          {
            id: '829',
            name: 'Đông Mỹ',
            prefix: 'Xã',
          },
          {
            id: '831',
            name: 'Hữu Hòa',
            prefix: 'Xã',
          },
          {
            id: '832',
            name: 'Liên Ninh',
            prefix: 'Xã',
          },
          {
            id: '833',
            name: 'Ngọc Hồi',
            prefix: 'Xã',
          },
          {
            id: '834',
            name: 'Ngũ Hiệp',
            prefix: 'Xã',
          },
          {
            id: '835',
            name: 'Tả Thanh Oai',
            prefix: 'Xã',
          },
          {
            id: '836',
            name: 'Tam Hiệp',
            prefix: 'Xã',
          },
          {
            id: '837',
            name: 'Tân Triều',
            prefix: 'Xã',
          },
          {
            id: '838',
            name: 'Thanh Liệt',
            prefix: 'Xã',
          },
          {
            id: '839',
            name: 'Tứ Hiệp',
            prefix: 'Xã',
          },
          {
            id: '840',
            name: 'Văn Điển',
            prefix: 'Thị trấn',
          },
          {
            id: '841',
            name: 'Vạn Phúc',
            prefix: 'Xã',
          },
          {
            id: '842',
            name: 'Vĩnh Quỳnh',
            prefix: 'Xã',
          },
          {
            id: '843',
            name: 'Yên Mỹ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '52',
        name: 'Thanh Xuân',
        wards: [
          {
            id: '844',
            name: 'Hạ Đình',
            prefix: 'Phường',
          },
          {
            id: '845',
            name: 'Khương Đình',
            prefix: 'Phường',
          },
          {
            id: '846',
            name: 'Khương Mai',
            prefix: 'Phường',
          },
          {
            id: '847',
            name: 'Khương Trung',
            prefix: 'Phường',
          },
          {
            id: '848',
            name: 'Kim Giang',
            prefix: 'Phường',
          },
          {
            id: '849',
            name: 'Nhân Chính',
            prefix: 'Phường',
          },
          {
            id: '850',
            name: 'Phương Liệt',
            prefix: 'Phường',
          },
          {
            id: '851',
            name: 'Thanh Xuân Bắc',
            prefix: 'Phường',
          },
          {
            id: '852',
            name: 'Thanh Xuân Nam',
            prefix: 'Phường',
          },
          {
            id: '853',
            name: 'Thanh Xuân Trung',
            prefix: 'Phường',
          },
          {
            id: '854',
            name: 'Thượng Đình',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '53',
        name: 'Thường Tín',
        wards: [
          {
            id: '855',
            name: 'Chương Dương',
            prefix: 'Xã',
          },
          {
            id: '856',
            name: 'Dũng Tiến',
            prefix: 'Xã',
          },
          {
            id: '857',
            name: 'Duyên Thái',
            prefix: 'Xã',
          },
          {
            id: '858',
            name: 'Hà Hồi',
            prefix: 'Xã',
          },
          {
            id: '859',
            name: 'Hiền Giang',
            prefix: 'Xã',
          },
          {
            id: '860',
            name: 'Hòa Bình',
            prefix: 'Xã',
          },
          {
            id: '861',
            name: 'Hồng Vân',
            prefix: 'Xã',
          },
          {
            id: '862',
            name: 'Khánh Hà',
            prefix: 'Xã',
          },
          {
            id: '863',
            name: 'Lê Lợi',
            prefix: 'Xã',
          },
          {
            id: '864',
            name: 'Liên Phương',
            prefix: 'Xã',
          },
          {
            id: '865',
            name: 'Minh Cường',
            prefix: 'Xã',
          },
          {
            id: '866',
            name: 'Nghiêm Xuyên',
            prefix: 'Xã',
          },
          {
            id: '867',
            name: 'Nguyễn Trãi',
            prefix: 'Xã',
          },
          {
            id: '868',
            name: 'Nhị Khê',
            prefix: 'Xã',
          },
          {
            id: '869',
            name: 'Ninh Sở',
            prefix: 'Xã',
          },
          {
            id: '870',
            name: 'Quất Động',
            prefix: 'Xã',
          },
          {
            id: '871',
            name: 'Tân Minh',
            prefix: 'Xã',
          },
          {
            id: '872',
            name: 'Thắng Lợi',
            prefix: 'Xã',
          },
          {
            id: '873',
            name: 'Thống Nhất',
            prefix: 'Xã',
          },
          {
            id: '874',
            name: 'Thư Phú',
            prefix: 'Xã',
          },
          {
            id: '875',
            name: 'Thường Tín',
            prefix: 'Thị trấn',
          },
          {
            id: '876',
            name: 'Tiền Phong',
            prefix: 'Xã',
          },
          {
            id: '877',
            name: 'Tô Hiệu',
            prefix: 'Xã',
          },
          {
            id: '878',
            name: 'Tự Nhiên',
            prefix: 'Xã',
          },
          {
            id: '879',
            name: 'Văn Bình',
            prefix: 'Xã',
          },
          {
            id: '880',
            name: 'Vạn Điểm',
            prefix: 'Xã',
          },
          {
            id: '881',
            name: 'Văn Phú',
            prefix: 'Xã',
          },
          {
            id: '882',
            name: 'Vân Tảo',
            prefix: 'Xã',
          },
          {
            id: '883',
            name: 'Văn Tự',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '54',
        name: 'Ứng Hòa',
        wards: [
          {
            id: '884',
            name: 'Cao Thành',
            prefix: 'Xã',
          },
          {
            id: '885',
            name: 'Đại Cường',
            prefix: 'Xã',
          },
          {
            id: '886',
            name: 'Đại Hùng',
            prefix: 'Xã',
          },
          {
            id: '887',
            name: 'Đội Bình',
            prefix: 'Xã',
          },
          {
            id: '888',
            name: 'Đông Lỗ',
            prefix: 'Xã',
          },
          {
            id: '889',
            name: 'Đồng Tân',
            prefix: 'Xã',
          },
          {
            id: '890',
            name: 'Đồng Tiến',
            prefix: 'Xã',
          },
          {
            id: '891',
            name: 'Hòa Lâm',
            prefix: 'Xã',
          },
          {
            id: '892',
            name: 'Hòa Nam',
            prefix: 'Xã',
          },
          {
            id: '893',
            name: 'Hòa Phú',
            prefix: 'Xã',
          },
          {
            id: '894',
            name: 'Hoa Sơn',
            prefix: 'Xã',
          },
          {
            id: '895',
            name: 'Hòa Xá',
            prefix: 'Xã',
          },
          {
            id: '896',
            name: 'Hồng Quang',
            prefix: 'Xã',
          },
          {
            id: '897',
            name: 'Kim Đường',
            prefix: 'Xã',
          },
          {
            id: '898',
            name: 'Liên Bạt',
            prefix: 'Xã',
          },
          {
            id: '899',
            name: 'Lưu Hoàng',
            prefix: 'Xã',
          },
          {
            id: '900',
            name: 'Minh Đức',
            prefix: 'Xã',
          },
          {
            id: '901',
            name: 'Phù Lưu',
            prefix: 'Xã',
          },
          {
            id: '902',
            name: 'Phương Tú',
            prefix: 'Xã',
          },
          {
            id: '903',
            name: 'Quảng Phú Cầu',
            prefix: 'Xã',
          },
          {
            id: '904',
            name: 'Sơn Công',
            prefix: 'Xã',
          },
          {
            id: '905',
            name: 'Tân Phương',
            prefix: 'Xã',
          },
          {
            id: '906',
            name: 'Tảo Dương Văn',
            prefix: 'Xã',
          },
          {
            id: '907',
            name: 'Trầm Lộng',
            prefix: 'Xã',
          },
          {
            id: '908',
            name: 'Trung Tú',
            prefix: 'Xã',
          },
          {
            id: '909',
            name: 'Trường Thịnh',
            prefix: 'Xã',
          },
          {
            id: '910',
            name: 'Vân Đình',
            prefix: 'Thị trấn',
          },
          {
            id: '911',
            name: 'Vạn Thái',
            prefix: 'Xã',
          },
          {
            id: '912',
            name: 'Viên An',
            prefix: 'Xã',
          },
          {
            id: '913',
            name: 'Viên Nội',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '3',
    code: 'DDN',
    name: 'Đà Nẵng',
    districts: [
      {
        id: '55',
        name: 'Cẩm Lệ',
        wards: [
          {
            id: '914',
            name: 'Hòa An',
            prefix: 'Phường',
          },
          {
            id: '915',
            name: 'Hòa Phát',
            prefix: 'Phường',
          },
          {
            id: '916',
            name: 'Hòa Thọ Đông',
            prefix: 'Phường',
          },
          {
            id: '917',
            name: 'Hòa Thọ Tây',
            prefix: 'Phường',
          },
          {
            id: '918',
            name: 'Hòa Xuân',
            prefix: 'Phường',
          },
          {
            id: '919',
            name: 'Khuê Trung',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '56',
        name: 'Hải Châu',
        wards: [
          {
            id: '920',
            name: ' Hải Châu I',
            prefix: 'Phường',
          },
          {
            id: '921',
            name: ' Hòa Thuận Đông',
            prefix: 'Phường',
          },
          {
            id: '922',
            name: 'Bình Hiên',
            prefix: 'Phường',
          },
          {
            id: '923',
            name: 'Bình Thuận',
            prefix: 'Phường',
          },
          {
            id: '924',
            name: 'Hải Châu II',
            prefix: 'Phường',
          },
          {
            id: '925',
            name: 'Hòa Cường Bắc',
            prefix: 'Phường',
          },
          {
            id: '926',
            name: 'Hòa Cường Nam',
            prefix: 'Phường',
          },
          {
            id: '927',
            name: 'Hòa Thuận Tây',
            prefix: 'Phường',
          },
          {
            id: '928',
            name: 'Nam Dương',
            prefix: 'Phường',
          },
          {
            id: '929',
            name: 'Phước Ninh',
            prefix: 'Phường',
          },
          {
            id: '930',
            name: 'Thạch Thang',
            prefix: 'Phường',
          },
          {
            id: '931',
            name: 'Thanh Bình',
            prefix: 'Phường',
          },
          {
            id: '932',
            name: 'Thuận Phước',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '57',
        name: 'Hòa Vang',
        wards: [
          {
            id: '933',
            name: 'Hòa Bắc',
            prefix: 'Phường',
          },
          {
            id: '934',
            name: 'Hòa Châu',
            prefix: 'Phường',
          },
          {
            id: '935',
            name: 'Hòa Khương',
            prefix: 'Phường',
          },
          {
            id: '936',
            name: 'Hòa Liên',
            prefix: 'Phường',
          },
          {
            id: '937',
            name: 'Hòa Nhơn',
            prefix: 'Phường',
          },
          {
            id: '938',
            name: 'Hòa Ninh',
            prefix: 'Xã',
          },
          {
            id: '939',
            name: 'Hòa Phong',
            prefix: 'Xã',
          },
          {
            id: '940',
            name: 'Hòa Phú',
            prefix: 'Xã',
          },
          {
            id: '941',
            name: 'Hòa Phước',
            prefix: 'Xã',
          },
          {
            id: '942',
            name: 'Hòa Sơn',
            prefix: 'Xã',
          },
          {
            id: '943',
            name: 'Hòa Tiến',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '58',
        name: 'Hoàng Sa',
        wards: [],
      },
      {
        id: '59',
        name: 'Liên Chiểu',
        wards: [
          {
            id: '944',
            name: 'Hòa Hiệp Bắc',
            prefix: 'Phường',
          },
          {
            id: '945',
            name: 'Hòa Hiệp Nam',
            prefix: 'Phường',
          },
          {
            id: '946',
            name: 'Hòa Khánh Bắc',
            prefix: 'Phường',
          },
          {
            id: '947',
            name: 'Hòa Khánh Nam',
            prefix: 'Phường',
          },
          {
            id: '948',
            name: 'Hòa Minh',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '60',
        name: 'Ngũ Hành Sơn',
        wards: [
          {
            id: '949',
            name: ' Khuê Mỹ',
            prefix: 'Phường',
          },
          {
            id: '950',
            name: 'Hòa Hải',
            prefix: 'Phường',
          },
          {
            id: '951',
            name: 'Hòa Quý',
            prefix: 'Phường',
          },
          {
            id: '952',
            name: 'Mỹ An',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '61',
        name: 'Sơn Trà',
        wards: [
          {
            id: '953',
            name: ' An Hải Bắc',
            prefix: 'Phường',
          },
          {
            id: '954',
            name: 'An Hải Đông',
            prefix: 'Phường',
          },
          {
            id: '955',
            name: 'An Hải Tây',
            prefix: 'Phường',
          },
          {
            id: '956',
            name: 'Mân Thái',
            prefix: 'Phường',
          },
          {
            id: '957',
            name: 'Nại Hiên Đông ',
            prefix: 'Phường',
          },
          {
            id: '958',
            name: 'Phước Mỹ',
            prefix: 'Phường',
          },
          {
            id: '959',
            name: 'Thọ Quang',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '62',
        name: 'Thanh Khê',
        wards: [
          {
            id: '960',
            name: 'An Khê',
            prefix: 'Phường',
          },
          {
            id: '961',
            name: 'Chính Gián',
            prefix: 'Phường',
          },
          {
            id: '962',
            name: 'Hòa Khê',
            prefix: 'Phường',
          },
          {
            id: '963',
            name: 'Tam Thuận',
            prefix: 'Phường',
          },
          {
            id: '964',
            name: 'Tân Chính',
            prefix: 'Phường',
          },
          {
            id: '965',
            name: 'Thạc Gián',
            prefix: 'Phường',
          },
          {
            id: '966',
            name: 'Thanh Khê Đông',
            prefix: 'Phường',
          },
          {
            id: '967',
            name: 'Thanh Khê Tây',
            prefix: 'Phường',
          },
          {
            id: '968',
            name: 'Thanh Lộc Đán',
            prefix: 'Phường',
          },
          {
            id: '969',
            name: 'Vĩnh Trung',
            prefix: 'Phường',
          },
          {
            id: '970',
            name: 'Xuân Hà',
            prefix: 'Phường',
          },
        ],
      },
    ],
  },
  {
    id: '4',
    code: 'BD',
    name: 'Bình Dương',
    districts: [
      {
        id: '63',
        name: 'Bàu Bàng',
        wards: [
          {
            id: '971',
            name: 'Cây Trường II',
            prefix: 'Xã',
          },
          {
            id: '972',
            name: 'Hưng Hòa',
            prefix: 'Xã',
          },
          {
            id: '973',
            name: 'Lai Hưng',
            prefix: 'Xã',
          },
          {
            id: '974',
            name: 'Lai Uyên',
            prefix: 'Xã',
          },
          {
            id: '975',
            name: 'Lai Uyên',
            prefix: 'Xã',
          },
          {
            id: '976',
            name: 'Long Nguyên',
            prefix: 'Xã',
          },
          {
            id: '977',
            name: 'Tân Hưng',
            prefix: 'Xã',
          },
          {
            id: '978',
            name: 'Trừ Văn Thố',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '64',
        name: 'Bến Cát',
        wards: [
          {
            id: '979',
            name: 'An Điền',
            prefix: 'Xã',
          },
          {
            id: '980',
            name: 'An Tây',
            prefix: 'Xã',
          },
          {
            id: '981',
            name: 'Cây Trường',
            prefix: 'Xã',
          },
          {
            id: '982',
            name: 'Chánh Phú Hòa',
            prefix: 'Xã',
          },
          {
            id: '983',
            name: 'Hòa Lợi',
            prefix: 'Phường',
          },
          {
            id: '984',
            name: 'Mỹ Phước',
            prefix: 'Phường',
          },
          {
            id: '985',
            name: 'Phú An',
            prefix: 'Xã',
          },
          {
            id: '986',
            name: 'Tân Định',
            prefix: 'Xã',
          },
          {
            id: '987',
            name: 'Thới Hòa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '65',
        name: 'Dầu Tiếng',
        wards: [
          {
            id: '988',
            name: 'An Lập',
            prefix: 'Xã',
          },
          {
            id: '989',
            name: 'Dầu Tiếng',
            prefix: 'Phường',
          },
          {
            id: '990',
            name: 'Định  Hiệp',
            prefix: 'Xã',
          },
          {
            id: '991',
            name: 'Định An',
            prefix: 'Xã',
          },
          {
            id: '992',
            name: 'Định Thành',
            prefix: 'Xã',
          },
          {
            id: '993',
            name: 'Long Hòa',
            prefix: 'Xã',
          },
          {
            id: '994',
            name: 'Long Tân',
            prefix: 'Xã',
          },
          {
            id: '995',
            name: 'Minh Hòa',
            prefix: 'Xã',
          },
          {
            id: '996',
            name: 'Minh Tân',
            prefix: 'Xã',
          },
          {
            id: '997',
            name: 'Minh Thạnh',
            prefix: 'Xã',
          },
          {
            id: '998',
            name: 'Thanh An',
            prefix: 'Xã',
          },
          {
            id: '999',
            name: 'Thanh Tuyền',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '66',
        name: 'Dĩ An',
        wards: [
          {
            id: '1000',
            name: 'An Bình',
            prefix: 'Phường',
          },
          {
            id: '1001',
            name: 'Bình An',
            prefix: 'Phường',
          },
          {
            id: '1002',
            name: 'Bình Thắng',
            prefix: 'Phường',
          },
          {
            id: '1003',
            name: 'Dĩ An',
            prefix: 'Phường',
          },
          {
            id: '1004',
            name: 'Đông Hòa',
            prefix: 'Phường',
          },
          {
            id: '1005',
            name: 'Tân Bình',
            prefix: 'Phường',
          },
          {
            id: '1006',
            name: 'Tân Đông Hiệp',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '67',
        name: 'Phú Giáo',
        wards: [
          {
            id: '1007',
            name: 'An Bình',
            prefix: 'Xã',
          },
          {
            id: '1008',
            name: 'An Linh',
            prefix: 'Xã',
          },
          {
            id: '1009',
            name: 'An Long',
            prefix: 'Xã',
          },
          {
            id: '1010',
            name: 'An Thái',
            prefix: 'Xã',
          },
          {
            id: '1011',
            name: 'Phước Hòa',
            prefix: 'Xã',
          },
          {
            id: '1012',
            name: 'Phước Sang',
            prefix: 'Xã',
          },
          {
            id: '1013',
            name: 'Phước Vĩnh',
            prefix: 'Phường',
          },
          {
            id: '1014',
            name: 'Tam Lập',
            prefix: 'Xã',
          },
          {
            id: '1015',
            name: 'Tân Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1016',
            name: 'Tân Long',
            prefix: 'Xã',
          },
          {
            id: '1017',
            name: 'Vĩnh Hòa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '68',
        name: 'Tân Uyên',
        wards: [
          {
            id: '1018',
            name: 'Bạch Đằng',
            prefix: 'Xã',
          },
          {
            id: '1019',
            name: 'Bình Mỹ',
            prefix: 'Xã',
          },
          {
            id: '1020',
            name: 'Đất Cuốc',
            prefix: 'Xã',
          },
          {
            id: '1021',
            name: 'Hiếu Liêm',
            prefix: 'Xã',
          },
          {
            id: '1022',
            name: 'Hội Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '1023',
            name: 'Khánh Bình',
            prefix: 'Xã',
          },
          {
            id: '1024',
            name: 'Lạc An',
            prefix: 'Xã',
          },
          {
            id: '1025',
            name: 'Phú Chánh',
            prefix: 'Xã',
          },
          {
            id: '1026',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '1027',
            name: 'Tân Định',
            prefix: 'Xã',
          },
          {
            id: '1028',
            name: 'Tân Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1029',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '1030',
            name: 'Tân Mỹ',
            prefix: 'Xã',
          },
          {
            id: '1031',
            name: 'Tân Phước Khánh',
            prefix: 'Phường',
          },
          {
            id: '1032',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '1033',
            name: 'Tân Vĩnh Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1034',
            name: 'Thái Hòa',
            prefix: 'Phường',
          },
          {
            id: '1035',
            name: 'Thạnh Hội',
            prefix: 'Xã',
          },
          {
            id: '1036',
            name: 'Thạnh Phước',
            prefix: 'Xã',
          },
          {
            id: '1037',
            name: 'Thường Tân',
            prefix: 'Xã',
          },
          {
            id: '1038',
            name: 'Uyên Hưng',
            prefix: 'Phường',
          },
          {
            id: '1039',
            name: 'Vĩnh Tân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '69',
        name: 'Thủ Dầu Một',
        wards: [
          {
            id: '1040',
            name: 'Chánh Mỹ',
            prefix: 'Xã',
          },
          {
            id: '1041',
            name: 'Chánh Nghĩa',
            prefix: 'Phường',
          },
          {
            id: '1042',
            name: 'Định Hòa',
            prefix: 'Phường',
          },
          {
            id: '1043',
            name: 'Hiệp An',
            prefix: 'Phường',
          },
          {
            id: '1044',
            name: 'Hiệp Thành',
            prefix: 'Phường',
          },
          {
            id: '1045',
            name: 'Hòa Phú',
            prefix: 'Phường',
          },
          {
            id: '1046',
            name: 'Phú Cường',
            prefix: 'Phường',
          },
          {
            id: '1047',
            name: 'Phú Hòa',
            prefix: 'Phường',
          },
          {
            id: '1048',
            name: 'Phú Lợi',
            prefix: 'Phường',
          },
          {
            id: '1049',
            name: 'Phú Mỹ',
            prefix: 'Phường',
          },
          {
            id: '1050',
            name: 'Phú Tân',
            prefix: 'Phường',
          },
          {
            id: '1051',
            name: 'Phú Thọ',
            prefix: 'Phường',
          },
          {
            id: '1052',
            name: 'Tân An',
            prefix: 'Xã',
          },
          {
            id: '1053',
            name: 'Tương Bình Hiệp',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '70',
        name: 'Thuận An',
        wards: [
          {
            id: '1054',
            name: 'An Phú',
            prefix: 'Phường',
          },
          {
            id: '1055',
            name: 'An Sơn',
            prefix: 'Xã',
          },
          {
            id: '1056',
            name: 'An Thạnh',
            prefix: 'Phường',
          },
          {
            id: '1057',
            name: 'Bình Chuẩn',
            prefix: 'Phường',
          },
          {
            id: '1058',
            name: 'Bình Hòa',
            prefix: 'Phường',
          },
          {
            id: '1059',
            name: 'Bình Nhâm',
            prefix: 'Xã',
          },
          {
            id: '1060',
            name: 'Hưng Định',
            prefix: 'Xã',
          },
          {
            id: '1061',
            name: 'Lái Thiêu',
            prefix: 'Phường',
          },
          {
            id: '1062',
            name: 'Thuận Giao',
            prefix: 'Phường',
          },
          {
            id: '1063',
            name: 'Vĩnh Phú',
            prefix: 'Phường',
          },
        ],
      },
    ],
  },
  {
    id: '5',
    code: 'DNA',
    name: 'Đồng Nai',
    districts: [
      {
        id: '71',
        name: 'Biên Hòa',
        wards: [
          {
            id: '1064',
            name: 'An Bình',
            prefix: 'Phường',
          },
          {
            id: '1065',
            name: 'An Hòa',
            prefix: 'Xã',
          },
          {
            id: '1066',
            name: 'Bàu Hang',
            prefix: 'Phường',
          },
          {
            id: '1067',
            name: 'Bình Đa',
            prefix: 'Phường',
          },
          {
            id: '1068',
            name: 'Bửu Hòa',
            prefix: 'Phường',
          },
          {
            id: '1069',
            name: 'Bửu Long',
            prefix: 'Phường',
          },
          {
            id: '1070',
            name: 'Hiệp Hòa',
            prefix: 'Xã',
          },
          {
            id: '1071',
            name: 'Hố Cạn',
            prefix: 'Phường',
          },
          {
            id: '1072',
            name: 'Hố Nai',
            prefix: 'Phường',
          },
          {
            id: '1073',
            name: 'Hóa An',
            prefix: 'Phường',
          },
          {
            id: '1074',
            name: 'Hòa Bình',
            prefix: 'Phường',
          },
          {
            id: '1075',
            name: 'Long Bình',
            prefix: 'Phường',
          },
          {
            id: '1076',
            name: 'Long Bình Tân',
            prefix: 'Phường',
          },
          {
            id: '1077',
            name: 'Long Hưng',
            prefix: 'Xã',
          },
          {
            id: '1078',
            name: 'Phước Tân',
            prefix: 'Xã',
          },
          {
            id: '1079',
            name: 'Quang Vinh',
            prefix: 'Phường',
          },
          {
            id: '1080',
            name: 'Quyết Thắng',
            prefix: 'Phường',
          },
          {
            id: '1081',
            name: 'Tam Hiệp',
            prefix: 'Phường',
          },
          {
            id: '1082',
            name: 'Tam Hòa',
            prefix: 'Phường',
          },
          {
            id: '1083',
            name: 'Tam Phước',
            prefix: 'Xã',
          },
          {
            id: '1084',
            name: 'Tân Biên',
            prefix: 'Phường',
          },
          {
            id: '1085',
            name: 'Tân Hạnh',
            prefix: 'Xã',
          },
          {
            id: '1086',
            name: 'Tân Hiệp',
            prefix: 'Phường',
          },
          {
            id: '1087',
            name: 'Tân Hòa',
            prefix: 'Phường',
          },
          {
            id: '1088',
            name: 'Tân Long',
            prefix: 'Phường',
          },
          {
            id: '1089',
            name: 'Tân Mai',
            prefix: 'Phường',
          },
          {
            id: '1090',
            name: 'Tân Phong',
            prefix: 'Phường',
          },
          {
            id: '1091',
            name: 'Tân Tiến',
            prefix: 'Phường',
          },
          {
            id: '1092',
            name: 'Tân Vạn',
            prefix: 'Phường',
          },
          {
            id: '1093',
            name: 'Thanh Bình',
            prefix: 'Phường',
          },
          {
            id: '1094',
            name: 'Thống Nhất',
            prefix: 'Phường',
          },
          {
            id: '1095',
            name: 'Trảng Dài',
            prefix: 'Phường',
          },
          {
            id: '1096',
            name: 'Trung Dũng',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '72',
        name: 'Cẩm Mỹ',
        wards: [
          {
            id: '1097',
            name: 'Bảo Bình',
            prefix: 'Xã',
          },
          {
            id: '1098',
            name: 'Lâm San',
            prefix: 'Xã',
          },
          {
            id: '1099',
            name: 'Long Giao',
            prefix: 'Thị trấn',
          },
          {
            id: '1100',
            name: 'Nhân Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '1101',
            name: 'Sông Nhạn',
            prefix: 'Xã',
          },
          {
            id: '1102',
            name: 'Sông Ray',
            prefix: 'Xã',
          },
          {
            id: '1103',
            name: 'Thừa Đức',
            prefix: 'Xã',
          },
          {
            id: '1104',
            name: 'Xuân Bảo',
            prefix: 'Xã',
          },
          {
            id: '1105',
            name: 'Xuân Đông',
            prefix: 'Xã',
          },
          {
            id: '1106',
            name: 'Xuân Đường',
            prefix: 'Xã',
          },
          {
            id: '1107',
            name: 'Xuân Mỹ',
            prefix: 'Xã',
          },
          {
            id: '1108',
            name: 'Xuân Quế',
            prefix: 'Xã',
          },
          {
            id: '1109',
            name: 'Xuân Tây',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '73',
        name: 'Định Quán',
        wards: [
          {
            id: '1110',
            name: 'Định Quán',
            prefix: 'Thị trấn',
          },
          {
            id: '1111',
            name: 'Gia Canh',
            prefix: 'Xã',
          },
          {
            id: '1112',
            name: 'La Ngà',
            prefix: 'Xã',
          },
          {
            id: '1113',
            name: 'Ngọc Định',
            prefix: 'Xã',
          },
          {
            id: '1114',
            name: 'Phú Cường',
            prefix: 'Xã',
          },
          {
            id: '1115',
            name: 'Phú Hoà',
            prefix: 'Xã',
          },
          {
            id: '1116',
            name: 'Phú Lợi',
            prefix: 'Xã',
          },
          {
            id: '1117',
            name: 'Phú Ngọc',
            prefix: 'Xã',
          },
          {
            id: '1118',
            name: 'Phú Tân',
            prefix: 'Xã',
          },
          {
            id: '1119',
            name: 'Phú Túc',
            prefix: 'Xã',
          },
          {
            id: '1120',
            name: 'Phú Vinh',
            prefix: 'Xã',
          },
          {
            id: '1121',
            name: 'Suối Nho',
            prefix: 'Xã',
          },
          {
            id: '1122',
            name: 'Thanh Sơn',
            prefix: 'Xã',
          },
          {
            id: '1123',
            name: 'Túc Trưng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '74',
        name: 'Long Khánh',
        wards: [
          {
            id: '1124',
            name: 'Bảo Hoà',
            prefix: 'Xã',
          },
          {
            id: '1125',
            name: 'Bảo Quang',
            prefix: 'Xã',
          },
          {
            id: '1126',
            name: 'Bảo Vinh',
            prefix: 'Xã',
          },
          {
            id: '1127',
            name: 'Bàu Sen',
            prefix: 'Xã',
          },
          {
            id: '1128',
            name: 'Bàu Trâm',
            prefix: 'Xã',
          },
          {
            id: '1129',
            name: 'Bình Lộc',
            prefix: 'Xã',
          },
          {
            id: '1130',
            name: 'Hàng Gòn',
            prefix: 'Xã',
          },
          {
            id: '1131',
            name: 'Phú Bình',
            prefix: 'Phường',
          },
          {
            id: '1132',
            name: 'Suối Tre',
            prefix: 'Xã',
          },
          {
            id: '1133',
            name: 'Xuân An',
            prefix: 'Phường',
          },
          {
            id: '1134',
            name: 'Xuân Bình',
            prefix: 'Phường',
          },
          {
            id: '1135',
            name: 'Xuân Hòa',
            prefix: 'Phường',
          },
          {
            id: '1136',
            name: 'Xuân Lập',
            prefix: 'Xã',
          },
          {
            id: '1137',
            name: 'Xuân Tân',
            prefix: 'Xã',
          },
          {
            id: '1138',
            name: 'Xuân Thanh',
            prefix: 'Phường',
          },
          {
            id: '1139',
            name: 'Xuân Trung',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '75',
        name: 'Long Thành',
        wards: [
          {
            id: '1140',
            name: 'An Phước',
            prefix: 'Xã',
          },
          {
            id: '1141',
            name: 'Bàu Cạn',
            prefix: 'Xã',
          },
          {
            id: '1142',
            name: 'Bình An',
            prefix: 'Xã',
          },
          {
            id: '1143',
            name: 'Bình Sơn',
            prefix: 'Xã',
          },
          {
            id: '1144',
            name: 'Cẩm Đường',
            prefix: 'Xã',
          },
          {
            id: '1145',
            name: 'Lộc An',
            prefix: 'Xã',
          },
          {
            id: '1146',
            name: 'Long An',
            prefix: 'Xã',
          },
          {
            id: '1147',
            name: 'Long Đức',
            prefix: 'Xã',
          },
          {
            id: '1148',
            name: 'Long Phước',
            prefix: 'Xã',
          },
          {
            id: '1149',
            name: 'Long Thành',
            prefix: 'Thị trấn',
          },
          {
            id: '1150',
            name: 'Phước Bình',
            prefix: 'Xã',
          },
          {
            id: '1151',
            name: 'Phước Tân',
            prefix: 'Xã',
          },
          {
            id: '1152',
            name: 'Phước Thái',
            prefix: 'Xã',
          },
          {
            id: '1153',
            name: 'Suối Trầu',
            prefix: 'Xã',
          },
          {
            id: '1154',
            name: 'Tam An',
            prefix: 'Xã',
          },
          {
            id: '1155',
            name: 'Tân Hiệp',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '76',
        name: 'Nhơn Trạch',
        wards: [
          {
            id: '1156',
            name: 'Đại Phước',
            prefix: 'Xã',
          },
          {
            id: '1157',
            name: 'Hiệp Phước',
            prefix: 'Xã',
          },
          {
            id: '1158',
            name: 'Long Tân',
            prefix: 'Xã',
          },
          {
            id: '1159',
            name: 'Long Thọ',
            prefix: 'Xã',
          },
          {
            id: '1160',
            name: 'Phú Đông',
            prefix: 'Xã',
          },
          {
            id: '1161',
            name: 'Phú Hội',
            prefix: 'Xã',
          },
          {
            id: '1162',
            name: 'Phú Hữu',
            prefix: 'Xã',
          },
          {
            id: '1163',
            name: 'Phú Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1164',
            name: 'Phước An',
            prefix: 'Xã',
          },
          {
            id: '1165',
            name: 'Phước Khánh',
            prefix: 'Xã',
          },
          {
            id: '1166',
            name: 'Phước Thiền',
            prefix: 'Xã',
          },
          {
            id: '1167',
            name: 'Vĩnh Thanh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '77',
        name: 'Tân Phú',
        wards: [
          {
            id: '1168',
            name: 'Đăk Lua',
            prefix: 'Xã',
          },
          {
            id: '1169',
            name: 'Nam Cát Tiên',
            prefix: 'Xã',
          },
          {
            id: '1170',
            name: 'Núi Tượng',
            prefix: 'Xã',
          },
          {
            id: '1171',
            name: 'Phú An',
            prefix: 'Xã',
          },
          {
            id: '1172',
            name: 'Phú Bình',
            prefix: 'Xã',
          },
          {
            id: '1173',
            name: 'Phú Điền',
            prefix: 'Xã',
          },
          {
            id: '1174',
            name: 'Phú Lâm',
            prefix: 'Xã',
          },
          {
            id: '1175',
            name: 'Phú Lập',
            prefix: 'Xã',
          },
          {
            id: '1176',
            name: 'Phú Lộc',
            prefix: 'Xã',
          },
          {
            id: '1177',
            name: 'Phú Sơn',
            prefix: 'Xã',
          },
          {
            id: '1178',
            name: 'Phú Thanh',
            prefix: 'Xã',
          },
          {
            id: '1179',
            name: 'Phú Thịnh',
            prefix: 'Xã',
          },
          {
            id: '1180',
            name: 'Phú Trung',
            prefix: 'Xã',
          },
          {
            id: '1181',
            name: 'Phú Xuân',
            prefix: 'Xã',
          },
          {
            id: '1182',
            name: 'Tà Lài',
            prefix: 'Xã',
          },
          {
            id: '1183',
            name: 'Tân Phú',
            prefix: 'Thị trấn',
          },
          {
            id: '1184',
            name: 'Thanh Sơn',
            prefix: 'Xã',
          },
          {
            id: '1185',
            name: 'Trà Cổ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '78',
        name: 'Thống Nhất',
        wards: [
          {
            id: '1186',
            name: 'Bàu Hàm 2',
            prefix: 'Xã',
          },
          {
            id: '1187',
            name: 'Dầu Giây',
            prefix: 'Thị trấn',
          },
          {
            id: '1188',
            name: 'Gia Kiệm',
            prefix: 'Xã',
          },
          {
            id: '1189',
            name: 'Gia Tân 1',
            prefix: 'Xã',
          },
          {
            id: '1190',
            name: 'Gia Tân 2',
            prefix: 'Xã',
          },
          {
            id: '1191',
            name: 'Gia Tân 3',
            prefix: 'Xã',
          },
          {
            id: '1192',
            name: 'Hưng Lộc',
            prefix: 'Xã',
          },
          {
            id: '1193',
            name: 'Lộ 25',
            prefix: 'Xã',
          },
          {
            id: '1194',
            name: 'Quang Trung',
            prefix: 'Xã',
          },
          {
            id: '1195',
            name: 'Xuân Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1196',
            name: 'Xuân Thiện',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '79',
        name: 'Trảng Bom',
        wards: [
          {
            id: '1197',
            name: 'An Viễn',
            prefix: 'Xã',
          },
          {
            id: '1198',
            name: 'Bắc Sơn',
            prefix: 'Xã',
          },
          {
            id: '1199',
            name: 'Bàu Hàm',
            prefix: 'Xã',
          },
          {
            id: '1200',
            name: 'Bình Minh',
            prefix: 'Xã',
          },
          {
            id: '1201',
            name: 'Cây Gáo',
            prefix: 'Xã',
          },
          {
            id: '1202',
            name: 'Đồi 61',
            prefix: 'Xã',
          },
          {
            id: '1203',
            name: 'Đông Hòa',
            prefix: 'Xã',
          },
          {
            id: '1204',
            name: 'Giang Điền',
            prefix: 'Xã',
          },
          {
            id: '1205',
            name: 'Hố Nai 3',
            prefix: 'Xã',
          },
          {
            id: '1206',
            name: 'Hòa Trung',
            prefix: 'Xã',
          },
          {
            id: '1207',
            name: 'Hưng Thịnh',
            prefix: 'Xã',
          },
          {
            id: '1208',
            name: 'Quảng Tiến',
            prefix: 'Xã',
          },
          {
            id: '1209',
            name: 'Sông Thao',
            prefix: 'Xã',
          },
          {
            id: '1210',
            name: 'Sông Trầu',
            prefix: 'Xã',
          },
          {
            id: '1211',
            name: 'Tây Hòa',
            prefix: 'Xã',
          },
          {
            id: '1212',
            name: 'Thanh Bình',
            prefix: 'Xã',
          },
          {
            id: '1213',
            name: 'Trảng Bom',
            prefix: 'Thị trấn',
          },
          {
            id: '1214',
            name: 'Trung Hòa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '80',
        name: 'Vĩnh Cửu',
        wards: [
          {
            id: '1215',
            name: 'Bình Hòa',
            prefix: 'Xã',
          },
          {
            id: '1216',
            name: 'Bình Lợi',
            prefix: 'Xã',
          },
          {
            id: '1217',
            name: 'Hiếu Liêm',
            prefix: 'Xã',
          },
          {
            id: '1218',
            name: 'Mã Đà',
            prefix: 'Xã',
          },
          {
            id: '1219',
            name: 'Phú Lý',
            prefix: 'Xã',
          },
          {
            id: '1220',
            name: 'Tân An',
            prefix: 'Xã',
          },
          {
            id: '1221',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '1222',
            name: 'Thạnh Phú',
            prefix: 'Xã',
          },
          {
            id: '1223',
            name: 'Thiện Tân',
            prefix: 'Xã',
          },
          {
            id: '1224',
            name: 'Trị An',
            prefix: 'Xã',
          },
          {
            id: '1225',
            name: 'Vĩnh An',
            prefix: 'Thị trấn',
          },
          {
            id: '1226',
            name: 'Vĩnh Tân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '81',
        name: 'Xuân Lộc',
        wards: [
          {
            id: '1227',
            name: 'Bảo Hòa',
            prefix: 'Xã',
          },
          {
            id: '1228',
            name: 'Gia Ray',
            prefix: 'Thị trấn',
          },
          {
            id: '1229',
            name: 'Lang Minh',
            prefix: 'Xã',
          },
          {
            id: '1230',
            name: 'Suối Cao',
            prefix: 'Xã',
          },
          {
            id: '1231',
            name: 'Suối Cát',
            prefix: 'Xã',
          },
          {
            id: '1232',
            name: 'Xuân Bắc',
            prefix: 'Xã',
          },
          {
            id: '1233',
            name: 'Xuân Định',
            prefix: 'Xã',
          },
          {
            id: '1234',
            name: 'Xuân Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1235',
            name: 'Xuân Hòa',
            prefix: 'Xã',
          },
          {
            id: '1236',
            name: 'Xuân Hưng',
            prefix: 'Xã',
          },
          {
            id: '1237',
            name: 'Xuân Phú',
            prefix: 'Xã',
          },
          {
            id: '1238',
            name: 'Xuân Tâm',
            prefix: 'Xã',
          },
          {
            id: '1239',
            name: 'Xuân Thành',
            prefix: 'Xã',
          },
          {
            id: '1240',
            name: 'Xuân Thọ',
            prefix: 'Xã',
          },
          {
            id: '1241',
            name: 'Xuân Trường',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '6',
    code: 'KH',
    name: 'Khánh Hòa',
    districts: [
      {
        id: '82',
        name: 'Cam Lâm',
        wards: [
          {
            id: '1242',
            name: 'Cam An Bắc',
            prefix: 'Xã',
          },
          {
            id: '1243',
            name: 'Cam An Nam',
            prefix: 'Xã',
          },
          {
            id: '1244',
            name: 'Cam Đức',
            prefix: 'Thị trấn',
          },
          {
            id: '1245',
            name: 'Cam Hải Đông',
            prefix: 'Xã',
          },
          {
            id: '1246',
            name: 'Cam Hải Tây',
            prefix: 'Xã',
          },
          {
            id: '1247',
            name: 'Cam Hiệp Bắc',
            prefix: 'Xã',
          },
          {
            id: '1248',
            name: 'Cam Hiệp Nam',
            prefix: 'Xã',
          },
          {
            id: '1249',
            name: 'Cam Hòa',
            prefix: 'Xã',
          },
          {
            id: '1250',
            name: 'Cam Phước Tây',
            prefix: 'Xã',
          },
          {
            id: '1251',
            name: 'Cam Tân',
            prefix: 'Xã',
          },
          {
            id: '1252',
            name: 'Cam Thành Bắc',
            prefix: 'Xã',
          },
          {
            id: '1253',
            name: 'Sơn Tân',
            prefix: 'Xã',
          },
          {
            id: '1254',
            name: 'Suối Cát',
            prefix: 'Xã',
          },
          {
            id: '1255',
            name: 'Suối Tân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '83',
        name: 'Cam Ranh',
        wards: [
          {
            id: '1256',
            name: 'Ba Ngòi',
            prefix: 'Phường',
          },
          {
            id: '1257',
            name: 'Cam Bình',
            prefix: 'Xã',
          },
          {
            id: '1258',
            name: 'Cam Lập',
            prefix: 'Xã',
          },
          {
            id: '1259',
            name: 'Cam Linh',
            prefix: 'Phường',
          },
          {
            id: '1260',
            name: 'Cam Lộc',
            prefix: 'Phường',
          },
          {
            id: '1261',
            name: 'Cam Lợi',
            prefix: 'Phường',
          },
          {
            id: '1262',
            name: 'Cam Nghĩa',
            prefix: 'Phường',
          },
          {
            id: '1263',
            name: 'Cam Phú',
            prefix: 'Phường',
          },
          {
            id: '1264',
            name: 'Cam Phúc Bắc',
            prefix: 'Phường',
          },
          {
            id: '1265',
            name: 'Cam Phúc Nam',
            prefix: 'Phường',
          },
          {
            id: '1266',
            name: 'Cam Phước Đông',
            prefix: 'Xã',
          },
          {
            id: '1267',
            name: 'Cam Thành Nam',
            prefix: 'Xã',
          },
          {
            id: '1268',
            name: 'Cam Thịnh Đông',
            prefix: 'Xã',
          },
          {
            id: '1269',
            name: 'Cam Thịnh Tây',
            prefix: 'Xã',
          },
          {
            id: '1270',
            name: 'Cam Thuận',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '84',
        name: 'Diên Khánh',
        wards: [
          {
            id: '1271',
            name: 'Diên An',
            prefix: 'Xã',
          },
          {
            id: '1272',
            name: 'Diên Bình',
            prefix: 'Xã',
          },
          {
            id: '1273',
            name: 'Diên Điền',
            prefix: 'Xã',
          },
          {
            id: '1274',
            name: 'Diên Đồng',
            prefix: 'Xã',
          },
          {
            id: '1275',
            name: 'Diên Hòa',
            prefix: 'Xã',
          },
          {
            id: '1276',
            name: 'Diên Khánh ',
            prefix: 'Phường',
          },
          {
            id: '1277',
            name: 'Diên Lạc',
            prefix: 'Xã',
          },
          {
            id: '1278',
            name: 'Diên Lâm',
            prefix: 'Xã',
          },
          {
            id: '1279',
            name: 'Diên Lộc',
            prefix: 'Xã',
          },
          {
            id: '1280',
            name: 'Diên Phú',
            prefix: 'Xã',
          },
          {
            id: '1281',
            name: 'Diên Phước',
            prefix: 'Xã',
          },
          {
            id: '1282',
            name: 'Diên Sơn',
            prefix: 'Xã',
          },
          {
            id: '1283',
            name: 'Diên Tân',
            prefix: 'Xã',
          },
          {
            id: '1284',
            name: 'Diên Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1285',
            name: 'Diên Thọ',
            prefix: 'Xã',
          },
          {
            id: '1286',
            name: 'Diên Toàn',
            prefix: 'Xã',
          },
          {
            id: '1287',
            name: 'Diên Xuân',
            prefix: 'Xã',
          },
          {
            id: '1288',
            name: 'Suối Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1289',
            name: 'Suối Tiên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '85',
        name: 'Khánh Sơn',
        wards: [
          {
            id: '1290',
            name: 'Ba Cụm Bắc',
            prefix: 'Xã',
          },
          {
            id: '1291',
            name: 'Ba Cụm Nam',
            prefix: 'Xã',
          },
          {
            id: '1292',
            name: 'Sơn Bình',
            prefix: 'Xã',
          },
          {
            id: '1293',
            name: 'Sơn Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1294',
            name: 'Sơn Lâm',
            prefix: 'Xã',
          },
          {
            id: '1295',
            name: 'Sơn Trung',
            prefix: 'Xã',
          },
          {
            id: '1296',
            name: 'Thành Sơn',
            prefix: 'Xã',
          },
          {
            id: '1297',
            name: 'Tô Hạp',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '86',
        name: 'Khánh Vĩnh',
        wards: [
          {
            id: '1298',
            name: 'Cầu Bà',
            prefix: 'Xã',
          },
          {
            id: '1299',
            name: 'Giang Ly',
            prefix: 'Xã',
          },
          {
            id: '1300',
            name: 'Khánh Bình',
            prefix: 'Xã',
          },
          {
            id: '1301',
            name: 'Khánh Đông',
            prefix: 'Xã',
          },
          {
            id: '1302',
            name: 'Khánh Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1303',
            name: 'Khánh Nam',
            prefix: 'Xã',
          },
          {
            id: '1304',
            name: 'Khánh Phú',
            prefix: 'Xã',
          },
          {
            id: '1305',
            name: 'Khánh Thành',
            prefix: 'Xã',
          },
          {
            id: '1306',
            name: 'Khánh Thượng',
            prefix: 'Xã',
          },
          {
            id: '1307',
            name: 'Khánh Trung',
            prefix: 'Xã',
          },
          {
            id: '1308',
            name: 'Khánh Vĩnh',
            prefix: 'Thị trấn',
          },
          {
            id: '1309',
            name: 'Liên Sang',
            prefix: 'Xã',
          },
          {
            id: '1310',
            name: 'Sơn Thái',
            prefix: 'Xã',
          },
          {
            id: '1311',
            name: 'Sông Cầu',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '87',
        name: 'Nha Trang',
        wards: [
          {
            id: '1312',
            name: 'Lộc Thọ',
            prefix: 'Phường',
          },
          {
            id: '1313',
            name: 'Ngọc Hiệp',
            prefix: 'Phường',
          },
          {
            id: '1314',
            name: 'Phước Đồng',
            prefix: 'Xã',
          },
          {
            id: '1315',
            name: 'Phước Hải',
            prefix: 'Phường',
          },
          {
            id: '1316',
            name: 'Phước Hòa',
            prefix: 'Phường',
          },
          {
            id: '1317',
            name: 'Phước Long ',
            prefix: 'Phường',
          },
          {
            id: '1318',
            name: 'Phước Tân',
            prefix: 'Phường',
          },
          {
            id: '1319',
            name: 'Phước Tiến',
            prefix: 'Phường',
          },
          {
            id: '1320',
            name: 'Phương Sài',
            prefix: 'Phường',
          },
          {
            id: '1321',
            name: 'Phương Sơn',
            prefix: 'Phường',
          },
          {
            id: '1322',
            name: 'Tân Lập',
            prefix: 'Phường',
          },
          {
            id: '1323',
            name: 'Vạn Thắng',
            prefix: 'Phường',
          },
          {
            id: '1324',
            name: 'Vạn Thạnh',
            prefix: 'Phường',
          },
          {
            id: '1325',
            name: 'Vĩnh Hải',
            prefix: 'Phường',
          },
          {
            id: '1326',
            name: 'Vĩnh Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1327',
            name: 'Vĩnh Hòa',
            prefix: 'Phường',
          },
          {
            id: '1328',
            name: 'Vĩnh Lương',
            prefix: 'Xã',
          },
          {
            id: '1329',
            name: 'Vĩnh Ngọc',
            prefix: 'Xã',
          },
          {
            id: '1330',
            name: 'Vĩnh Nguyên',
            prefix: 'Phường',
          },
          {
            id: '1331',
            name: 'Vĩnh Phước',
            prefix: 'Phường',
          },
          {
            id: '1332',
            name: 'Vĩnh Phương',
            prefix: 'Xã',
          },
          {
            id: '1333',
            name: 'Vĩnh Thái',
            prefix: 'Xã',
          },
          {
            id: '1334',
            name: 'Vĩnh Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1335',
            name: 'Vĩnh Thọ',
            prefix: 'Phường',
          },
          {
            id: '1336',
            name: 'Vĩnh Trung',
            prefix: 'Xã',
          },
          {
            id: '1337',
            name: 'Vĩnh Trường',
            prefix: 'Phường',
          },
          {
            id: '1338',
            name: 'Xương Huân',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '88',
        name: 'Ninh Hòa',
        wards: [
          {
            id: '1339',
            name: 'Diên Toàn',
            prefix: 'Xã',
          },
          {
            id: '1340',
            name: 'Ninh An',
            prefix: 'Xã',
          },
          {
            id: '1341',
            name: 'Ninh Bình',
            prefix: 'Xã',
          },
          {
            id: '1343',
            name: 'Ninh Diêm',
            prefix: 'Phường',
          },
          {
            id: '1342',
            name: 'Ninh Đa',
            prefix: 'Phường',
          },
          {
            id: '1344',
            name: 'Ninh Đông',
            prefix: 'Xã',
          },
          {
            id: '1345',
            name: 'Ninh Giang',
            prefix: 'Phường',
          },
          {
            id: '1346',
            name: 'Ninh Hà',
            prefix: 'Phường',
          },
          {
            id: '1347',
            name: 'Ninh Hải',
            prefix: 'Phường',
          },
          {
            id: '1348',
            name: 'Ninh Hiệp',
            prefix: 'Phường',
          },
          {
            id: '1349',
            name: 'Ninh Hưng',
            prefix: 'Xã',
          },
          {
            id: '1350',
            name: 'Ninh Ích',
            prefix: 'Xã',
          },
          {
            id: '1351',
            name: 'Ninh Lộc',
            prefix: 'Xã',
          },
          {
            id: '1352',
            name: 'Ninh Phú',
            prefix: 'Xã',
          },
          {
            id: '1353',
            name: 'Ninh Phụng',
            prefix: 'Xã',
          },
          {
            id: '1354',
            name: 'Ninh Phước',
            prefix: 'Xã',
          },
          {
            id: '1355',
            name: 'Ninh Quang',
            prefix: 'Xã',
          },
          {
            id: '1356',
            name: 'Ninh Sim',
            prefix: 'Xã',
          },
          {
            id: '1357',
            name: 'Ninh Sơn',
            prefix: 'Xã',
          },
          {
            id: '1358',
            name: 'Ninh Tân',
            prefix: 'Xã',
          },
          {
            id: '1359',
            name: 'Ninh Tây',
            prefix: 'Xã',
          },
          {
            id: '1360',
            name: 'Ninh Thân',
            prefix: 'Xã',
          },
          {
            id: '1361',
            name: 'Ninh Thọ',
            prefix: 'Xã',
          },
          {
            id: '1362',
            name: 'Ninh Thượng',
            prefix: 'Xã',
          },
          {
            id: '1363',
            name: 'Ninh Thủy',
            prefix: 'Phường',
          },
          {
            id: '1364',
            name: 'Ninh Trung',
            prefix: 'Xã',
          },
          {
            id: '1365',
            name: 'Ninh Vân',
            prefix: 'Xã',
          },
          {
            id: '1366',
            name: 'Ninh Xuân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '89',
        name: 'Trường Sa',
        wards: [
          {
            id: '1367',
            name: 'Sinh Tồn',
            prefix: 'Xã',
          },
          {
            id: '1368',
            name: 'Song Tử Tây',
            prefix: 'Xã',
          },
          {
            id: '1369',
            name: 'Trường Sa',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '90',
        name: 'Vạn Ninh',
        wards: [
          {
            id: '1370',
            name: 'Đại Lãnh',
            prefix: 'Xã',
          },
          {
            id: '1371',
            name: 'Vạn Bình',
            prefix: 'Xã',
          },
          {
            id: '1372',
            name: 'Vạn Giã',
            prefix: 'Thị trấn',
          },
          {
            id: '1373',
            name: 'Vạn Hưng',
            prefix: 'Xã',
          },
          {
            id: '1374',
            name: 'Vạn Khánh',
            prefix: 'Xã',
          },
          {
            id: '1375',
            name: 'Vạn Long',
            prefix: 'Xã',
          },
          {
            id: '1376',
            name: 'Vạn Lương',
            prefix: 'Xã',
          },
          {
            id: '1377',
            name: 'Vạn Phú',
            prefix: 'Xã',
          },
          {
            id: '1378',
            name: 'Vạn Phước',
            prefix: 'Xã',
          },
          {
            id: '1379',
            name: 'Vạn Thắng',
            prefix: 'Xã',
          },
          {
            id: '1380',
            name: 'Vạn Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1381',
            name: 'Vạn Thọ',
            prefix: 'Xã',
          },
          {
            id: '1382',
            name: 'Xuân Sơn',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '7',
    code: 'HP',
    name: 'Hải Phòng',
    districts: [
      {
        id: '91',
        name: 'An Dương',
        wards: [
          {
            id: '1384',
            name: 'An Dương',
            prefix: 'Thị trấn',
          },
          {
            id: '1383',
            name: 'An Đồng',
            prefix: 'Xã',
          },
          {
            id: '1385',
            name: 'An Hải',
            prefix: 'Phường',
          },
          {
            id: '1386',
            name: 'An Hòa',
            prefix: 'Xã',
          },
          {
            id: '1387',
            name: 'An Hồng',
            prefix: 'Phường',
          },
          {
            id: '1388',
            name: 'An Hưng',
            prefix: 'Xã',
          },
          {
            id: '1389',
            name: 'Bắc Sơn',
            prefix: 'Xã',
          },
          {
            id: '1390',
            name: 'Đại Bản',
            prefix: 'Xã',
          },
          {
            id: '1391',
            name: 'Đặng Cương',
            prefix: 'Xã',
          },
          {
            id: '1392',
            name: 'Đồng Thái',
            prefix: 'Xã',
          },
          {
            id: '1393',
            name: 'Hồng phong',
            prefix: 'Xã',
          },
          {
            id: '1394',
            name: 'Hồng Thái',
            prefix: 'Xã',
          },
          {
            id: '1395',
            name: 'Hồng Tiến',
            prefix: 'Xã',
          },
          {
            id: '1396',
            name: 'Lê Lợi',
            prefix: 'Xã',
          },
          {
            id: '1397',
            name: 'Lê Thiên',
            prefix: 'Xã',
          },
          {
            id: '1398',
            name: 'Nam Sơn',
            prefix: 'Xã',
          },
          {
            id: '1399',
            name: 'Quốc Tuấn',
            prefix: 'Xã',
          },
          {
            id: '1400',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '92',
        name: 'An Lão',
        wards: [
          {
            id: '1401',
            name: 'An Lão',
            prefix: 'Xã',
          },
          {
            id: '1402',
            name: 'An Thái',
            prefix: 'Xã',
          },
          {
            id: '1403',
            name: 'An Thắng',
            prefix: 'Xã',
          },
          {
            id: '1404',
            name: 'An Thọ',
            prefix: 'Xã',
          },
          {
            id: '1405',
            name: 'An Tiến',
            prefix: 'Xã',
          },
          {
            id: '1406',
            name: 'Bát Trang',
            prefix: 'Xã',
          },
          {
            id: '1407',
            name: 'Chiến Thắng',
            prefix: 'Xã',
          },
          {
            id: '1408',
            name: 'Mỹ Đức',
            prefix: 'Xã',
          },
          {
            id: '1409',
            name: 'Quang Hưng',
            prefix: 'Xã',
          },
          {
            id: '1410',
            name: 'Quang Trung',
            prefix: 'Xã',
          },
          {
            id: '1411',
            name: 'Quốc Tuấn',
            prefix: 'Xã',
          },
          {
            id: '1412',
            name: 'Tân Dân',
            prefix: 'Xã',
          },
          {
            id: '1413',
            name: 'Tân Viên',
            prefix: 'Xã',
          },
          {
            id: '1414',
            name: 'Thái Sơn',
            prefix: 'Xã',
          },
          {
            id: '1415',
            name: 'Trường Sơn',
            prefix: 'Xã',
          },
          {
            id: '1416',
            name: 'Trường Thành',
            prefix: 'Xã',
          },
          {
            id: '1417',
            name: 'Trường Thọ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '93',
        name: 'Bạch Long Vĩ',
        wards: [],
      },
      {
        id: '94',
        name: 'Cát Hải',
        wards: [
          {
            id: '1418',
            name: ' Đồng Bài',
            prefix: 'Xã',
          },
          {
            id: '1419',
            name: 'Cát Bà',
            prefix: 'Xã',
          },
          {
            id: '1420',
            name: 'Cát Hải',
            prefix: 'Xã',
          },
          {
            id: '1421',
            name: 'Gia Luận',
            prefix: 'Xã',
          },
          {
            id: '1422',
            name: 'Hiền Hào',
            prefix: 'Xã',
          },
          {
            id: '1423',
            name: 'Hoàng Châu',
            prefix: 'Xã',
          },
          {
            id: '1424',
            name: 'Nghĩa Lộ',
            prefix: 'Xã',
          },
          {
            id: '1425',
            name: 'Phù Long',
            prefix: 'Xã',
          },
          {
            id: '1426',
            name: 'Trân Châu',
            prefix: 'Xã',
          },
          {
            id: '1427',
            name: 'Văn Phong',
            prefix: 'Xã',
          },
          {
            id: '1428',
            name: 'Việt Hải',
            prefix: 'Xã',
          },
          {
            id: '1429',
            name: 'Xuân Đám',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '96',
        name: 'Dương Kinh',
        wards: [
          {
            id: '1437',
            name: 'Anh Dũng',
            prefix: 'Phường',
          },
          {
            id: '1438',
            name: 'Đa Phúc',
            prefix: 'Phường',
          },
          {
            id: '1439',
            name: 'Hải Thành',
            prefix: 'Phường',
          },
          {
            id: '1440',
            name: 'Hòa Nghĩa',
            prefix: 'Phường',
          },
          {
            id: '1441',
            name: 'Hưng Đạo',
            prefix: 'Phường',
          },
          {
            id: '1442',
            name: 'Tân Thành',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '95',
        name: 'Đồ Sơn',
        wards: [
          {
            id: '1430',
            name: 'Bàng La',
            prefix: 'Phường',
          },
          {
            id: '1431',
            name: 'Hợp Đức',
            prefix: 'Phường',
          },
          {
            id: '1432',
            name: 'Minh Đức',
            prefix: 'Phường',
          },
          {
            id: '1433',
            name: 'Ngọc Hải',
            prefix: 'Phường',
          },
          {
            id: '1434',
            name: 'Ngọc Xuyên',
            prefix: 'Phường',
          },
          {
            id: '1435',
            name: 'Vạn Hương',
            prefix: 'Phường',
          },
          {
            id: '1436',
            name: 'Vạn Sơn',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '97',
        name: 'Hải An',
        wards: [
          {
            id: '1443',
            name: ' Đằng Hải',
            prefix: 'Phường',
          },
          {
            id: '1444',
            name: 'An Khê',
            prefix: 'Xã',
          },
          {
            id: '1445',
            name: 'Cát Bi',
            prefix: 'Phường',
          },
          {
            id: '1446',
            name: 'Đằng Lâm',
            prefix: 'Phường',
          },
          {
            id: '1447',
            name: 'Đông Hải 1',
            prefix: 'Phường',
          },
          {
            id: '1448',
            name: 'Đông Hải 2',
            prefix: 'Phường',
          },
          {
            id: '1449',
            name: 'Nam Hải',
            prefix: 'Phường',
          },
          {
            id: '1450',
            name: 'Thành Tô',
            prefix: 'Phường',
          },
          {
            id: '1451',
            name: 'Tràng Cát',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '98',
        name: 'Hồng Bàng',
        wards: [
          {
            id: '1452',
            name: 'Hạ Lý',
            prefix: 'Phường',
          },
          {
            id: '1453',
            name: 'Hoàng Văn Thụ',
            prefix: 'Phường',
          },
          {
            id: '1454',
            name: 'Hùng Vương',
            prefix: 'Phường',
          },
          {
            id: '1455',
            name: 'Minh Khai',
            prefix: 'Phường',
          },
          {
            id: '1456',
            name: 'Nam Sơn',
            prefix: 'Phường',
          },
          {
            id: '1457',
            name: 'Phạm Hồng Thái',
            prefix: 'Phường',
          },
          {
            id: '1458',
            name: 'Phan Bội Châu',
            prefix: 'Phường',
          },
          {
            id: '1459',
            name: 'Quán Toan',
            prefix: 'Phường',
          },
          {
            id: '1460',
            name: 'Quang Trung',
            prefix: 'Phường',
          },
          {
            id: '1461',
            name: 'Sở Dầu',
            prefix: 'Phường',
          },
          {
            id: '1462',
            name: 'Thượng Lý',
            prefix: 'Phường',
          },
          {
            id: '1463',
            name: 'Trại Chuối',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '99',
        name: 'Kiến An',
        wards: [
          {
            id: '1464',
            name: 'Bắc Sơn',
            prefix: 'Phường',
          },
          {
            id: '1465',
            name: 'Đồng Hòa',
            prefix: 'Phường',
          },
          {
            id: '1466',
            name: 'Lãm Hà',
            prefix: 'Phường',
          },
          {
            id: '1467',
            name: 'Lãm Khê',
            prefix: 'Phường',
          },
          {
            id: '1468',
            name: 'Nam Sơn',
            prefix: 'Phường',
          },
          {
            id: '1469',
            name: 'Ngọc Sơn',
            prefix: 'Phường',
          },
          {
            id: '1470',
            name: 'Phù Liễn',
            prefix: 'Phường',
          },
          {
            id: '1471',
            name: 'Quán Trữ',
            prefix: 'Phường',
          },
          {
            id: '1472',
            name: 'Trần Thành Ngọ',
            prefix: 'Phường',
          },
          {
            id: '1473',
            name: 'Tràng Minh',
            prefix: 'Phường',
          },
          {
            id: '1474',
            name: 'Văn Đẩu',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '100',
        name: 'Kiến Thụy',
        wards: [
          {
            id: '1481',
            name: 'Du Lễ',
            prefix: 'Xã',
          },
          {
            id: '1475',
            name: 'Đa Phúc',
            prefix: 'Xã',
          },
          {
            id: '1476',
            name: 'Đại Đồng',
            prefix: 'Xã',
          },
          {
            id: '1477',
            name: 'Đại Hà',
            prefix: 'Xã',
          },
          {
            id: '1478',
            name: 'Đại Hợp',
            prefix: 'Xã',
          },
          {
            id: '1479',
            name: 'Đoàn Xá',
            prefix: 'Xã',
          },
          {
            id: '1480',
            name: 'Đông Phương',
            prefix: 'Xã',
          },
          {
            id: '1482',
            name: 'Hữu Bằng',
            prefix: 'Xã',
          },
          {
            id: '1483',
            name: 'Kiến Quốc',
            prefix: 'Xã',
          },
          {
            id: '1484',
            name: 'Minh Tân',
            prefix: 'Xã',
          },
          {
            id: '1485',
            name: 'Ngũ Đoan',
            prefix: 'Xã',
          },
          {
            id: '1486',
            name: 'Ngũ Phúc',
            prefix: 'Xã',
          },
          {
            id: '1487',
            name: 'Núi Đối',
            prefix: 'Phường',
          },
          {
            id: '1488',
            name: 'Tân Phong',
            prefix: 'Xã',
          },
          {
            id: '1489',
            name: 'Tân Trào',
            prefix: 'Xã',
          },
          {
            id: '1490',
            name: 'Thanh Sơn',
            prefix: 'Xã',
          },
          {
            id: '1491',
            name: 'Thuận Thiên',
            prefix: 'Xã',
          },
          {
            id: '1492',
            name: 'Thụy Hương',
            prefix: 'Xã',
          },
          {
            id: '1493',
            name: 'Tú Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '101',
        name: 'Lê Chân',
        wards: [
          {
            id: '1494',
            name: ' An Dương',
            prefix: 'Phường',
          },
          {
            id: '1495',
            name: ' Kênh Dương',
            prefix: 'Phường',
          },
          {
            id: '1496',
            name: 'An Biên',
            prefix: 'Phường',
          },
          {
            id: '1497',
            name: 'Cát Dài',
            prefix: 'Phường',
          },
          {
            id: '1499',
            name: 'Dư Hàng',
            prefix: 'Phường',
          },
          {
            id: '1500',
            name: 'Dư Hàng Kênh \t',
            prefix: 'Phường',
          },
          {
            id: '1498',
            name: 'Đông Hải',
            prefix: 'Phường',
          },
          {
            id: '1501',
            name: 'Hàng Kênh',
            prefix: 'Phường',
          },
          {
            id: '1502',
            name: 'Hồ Nam',
            prefix: 'Phường',
          },
          {
            id: '1503',
            name: 'Lam Sơn',
            prefix: 'Phường',
          },
          {
            id: '1504',
            name: 'Nghĩa Xá',
            prefix: 'Phường',
          },
          {
            id: '1505',
            name: 'Niệm Nghĩa',
            prefix: 'Phường',
          },
          {
            id: '1506',
            name: 'Trại Cau',
            prefix: 'Phường',
          },
          {
            id: '1507',
            name: 'Trần Nguyên Hãn',
            prefix: 'Phường',
          },
          {
            id: '1508',
            name: 'Vĩnh Niệm',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '102',
        name: 'Ngô Quyền',
        wards: [
          {
            id: '1509',
            name: ' Cầu Đất',
            prefix: 'Phường',
          },
          {
            id: '1510',
            name: ' Gia Viên',
            prefix: 'Phường',
          },
          {
            id: '1511',
            name: ' Lạc Viên',
            prefix: 'Phường',
          },
          {
            id: '1512',
            name: ' Lê Lợi',
            prefix: 'Phường',
          },
          {
            id: '1513',
            name: 'Cầu Tre',
            prefix: 'Phường',
          },
          {
            id: '1514',
            name: 'Đằng Giang',
            prefix: 'Phường',
          },
          {
            id: '1515',
            name: 'Đông Khê',
            prefix: 'Phường',
          },
          {
            id: '1516',
            name: 'Đổng Quốc Bình',
            prefix: 'Phường',
          },
          {
            id: '1517',
            name: 'Lạch Tray',
            prefix: 'Phường',
          },
          {
            id: '1518',
            name: 'Lương Khánh Thiện',
            prefix: 'Phường',
          },
          {
            id: '1519',
            name: 'Máy Chai',
            prefix: 'Phường',
          },
          {
            id: '1520',
            name: 'Máy Tơ',
            prefix: 'Phường',
          },
          {
            id: '1521',
            name: 'Vạn Mỹ',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '103',
        name: 'Thủy Nguyên',
        wards: [
          {
            id: '1522',
            name: ' Cao Nhân',
            prefix: 'Xã',
          },
          {
            id: '1523',
            name: ' Đông Sơn',
            prefix: 'Xã',
          },
          {
            id: '1524',
            name: ' Gia Minh',
            prefix: 'Xã',
          },
          {
            id: '1525',
            name: ' Hòa Bình',
            prefix: 'Xã',
          },
          {
            id: '1526',
            name: ' Kênh Giang',
            prefix: 'Xã',
          },
          {
            id: '1527',
            name: ' Kiền Bái',
            prefix: 'Xã',
          },
          {
            id: '1528',
            name: ' Lâm Động',
            prefix: 'Xã',
          },
          {
            id: '1529',
            name: ' Phục Lễ',
            prefix: 'Xã',
          },
          {
            id: '1530',
            name: ' Tam Hưng',
            prefix: 'Xã',
          },
          {
            id: '1531',
            name: ' Thủy Đường',
            prefix: 'Xã',
          },
          {
            id: '1532',
            name: 'An Lư',
            prefix: 'Xã',
          },
          {
            id: '1533',
            name: 'An Sơn',
            prefix: 'Xã',
          },
          {
            id: '1534',
            name: 'Chính Mỹ',
            prefix: 'Xã',
          },
          {
            id: '1535',
            name: 'Dương Quan',
            prefix: 'Xã',
          },
          {
            id: '1536',
            name: 'Gia Đức',
            prefix: 'Xã',
          },
          {
            id: '1537',
            name: 'Hoa Động',
            prefix: 'Xã',
          },
          {
            id: '1538',
            name: 'Hoàng Động',
            prefix: 'Xã',
          },
          {
            id: '1539',
            name: 'Hợp Thành',
            prefix: 'Xã',
          },
          {
            id: '1540',
            name: 'Kỳ Sơn',
            prefix: 'Xã',
          },
          {
            id: '1541',
            name: 'Lại Xuân',
            prefix: 'Xã',
          },
          {
            id: '1542',
            name: 'Lập Lễ',
            prefix: 'Xã',
          },
          {
            id: '1543',
            name: 'Liên Khê',
            prefix: 'Xã',
          },
          {
            id: '1544',
            name: 'Lưu Kiếm',
            prefix: 'Xã',
          },
          {
            id: '1545',
            name: 'Lưu Kỳ',
            prefix: 'Xã',
          },
          {
            id: '1546',
            name: 'Minh Đức',
            prefix: 'Xã',
          },
          {
            id: '1547',
            name: 'Minh Tân',
            prefix: 'Xã',
          },
          {
            id: '1548',
            name: 'Mỹ Đồng',
            prefix: 'Xã',
          },
          {
            id: '1549',
            name: 'Ngũ Lão',
            prefix: 'Xã',
          },
          {
            id: '1550',
            name: 'Núi Đèo',
            prefix: 'Xã',
          },
          {
            id: '1551',
            name: 'Phả Lễ',
            prefix: 'Xã',
          },
          {
            id: '1552',
            name: 'Phù Ninh',
            prefix: 'Xã',
          },
          {
            id: '1553',
            name: 'Quảng Thanh',
            prefix: 'Xã',
          },
          {
            id: '1554',
            name: 'Tân Dương',
            prefix: 'Xã',
          },
          {
            id: '1555',
            name: 'Thiên Hương',
            prefix: 'Xã',
          },
          {
            id: '1556',
            name: 'Thủy Sơn',
            prefix: 'Xã',
          },
          {
            id: '1557',
            name: 'Thủy Triều',
            prefix: 'Xã',
          },
          {
            id: '1558',
            name: 'Trung Hà',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '104',
        name: 'Tiên Lãng',
        wards: [
          {
            id: '1559',
            name: ' Đông Hưng',
            prefix: 'Xã',
          },
          {
            id: '1560',
            name: 'Bắc Hưng',
            prefix: 'Xã',
          },
          {
            id: '1561',
            name: 'Bạch Đằng',
            prefix: 'Xã',
          },
          {
            id: '1562',
            name: 'Cấp Tiến',
            prefix: 'Xã',
          },
          {
            id: '1563',
            name: 'Đại Thắng',
            prefix: 'Xã',
          },
          {
            id: '1564',
            name: 'Đoàn Lập',
            prefix: 'Xã',
          },
          {
            id: '1565',
            name: 'Hùng Thắng',
            prefix: 'Xã',
          },
          {
            id: '1566',
            name: 'Khởi Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '1567',
            name: 'Kiến Thiết',
            prefix: 'Xã',
          },
          {
            id: '1568',
            name: 'Nam Hưng',
            prefix: 'Xã',
          },
          {
            id: '1569',
            name: 'Quang Phục',
            prefix: 'Xã',
          },
          {
            id: '1570',
            name: 'Quyết Tiến',
            prefix: 'Xã',
          },
          {
            id: '1571',
            name: 'Tây Hưng',
            prefix: 'Xã',
          },
          {
            id: '1572',
            name: 'Tiên Cường',
            prefix: 'Xã',
          },
          {
            id: '1573',
            name: 'Tiên Hưng',
            prefix: 'Xã',
          },
          {
            id: '1574',
            name: 'Tiên Lãng',
            prefix: 'Xã',
          },
          {
            id: '1575',
            name: 'Tiên Minh',
            prefix: 'Xã',
          },
          {
            id: '1576',
            name: 'Tiên Thắng',
            prefix: 'Xã',
          },
          {
            id: '1577',
            name: 'Tiên Thanh',
            prefix: 'Xã',
          },
          {
            id: '1578',
            name: 'Tiên Tiến',
            prefix: 'Xã',
          },
          {
            id: '1579',
            name: 'Toàn Thắng',
            prefix: 'Xã',
          },
          {
            id: '1580',
            name: 'Tự Cường',
            prefix: 'Xã',
          },
          {
            id: '1581',
            name: 'Vinh Quang',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '105',
        name: 'Vĩnh Bảo',
        wards: [
          {
            id: '1582',
            name: 'An Hòa',
            prefix: 'Xã',
          },
          {
            id: '1583',
            name: 'Cao Minh',
            prefix: 'Xã',
          },
          {
            id: '1584',
            name: 'Cổ Am',
            prefix: 'Xã',
          },
          {
            id: '1585',
            name: 'Cộng Hiền',
            prefix: 'Xã',
          },
          {
            id: '1587',
            name: 'Dũng Tiến',
            prefix: 'Xã',
          },
          {
            id: '1586',
            name: 'Đồng Minh',
            prefix: 'Xã',
          },
          {
            id: '1588',
            name: 'Giang Biên',
            prefix: 'Xã',
          },
          {
            id: '1589',
            name: 'Hiệp Hòa',
            prefix: 'Xã',
          },
          {
            id: '1590',
            name: 'Hòa Bình',
            prefix: 'Xã',
          },
          {
            id: '1591',
            name: 'Hưng Nhân',
            prefix: 'Xã',
          },
          {
            id: '1592',
            name: 'Hùng Tiến',
            prefix: 'Xã',
          },
          {
            id: '1593',
            name: 'Liên Am',
            prefix: 'Xã',
          },
          {
            id: '1594',
            name: 'Lý Học',
            prefix: 'Xã',
          },
          {
            id: '1595',
            name: 'Nhân Hòa',
            prefix: 'Xã',
          },
          {
            id: '1596',
            name: 'Tam Cường',
            prefix: 'Xã',
          },
          {
            id: '1597',
            name: 'Tam Đa',
            prefix: 'Xã',
          },
          {
            id: '1598',
            name: 'Tân Hưng',
            prefix: 'Xã',
          },
          {
            id: '1599',
            name: 'Tân Liên',
            prefix: 'Xã',
          },
          {
            id: '1600',
            name: 'Thắng Thủy',
            prefix: 'Xã',
          },
          {
            id: '1601',
            name: 'Thanh Lương',
            prefix: 'Xã',
          },
          {
            id: '1602',
            name: 'Tiền Phong',
            prefix: 'Xã',
          },
          {
            id: '1603',
            name: 'Trấn Dương',
            prefix: 'Xã',
          },
          {
            id: '1604',
            name: 'Trung Lập',
            prefix: 'Xã',
          },
          {
            id: '1605',
            name: 'Việt Tiến',
            prefix: 'Xã',
          },
          {
            id: '1606',
            name: 'Vĩnh An',
            prefix: 'Xã',
          },
          {
            id: '1607',
            name: 'Vĩnh Bảo',
            prefix: 'Xã',
          },
          {
            id: '1608',
            name: 'Vĩnh Long',
            prefix: 'Xã',
          },
          {
            id: '1609',
            name: 'Vĩnh Phong',
            prefix: 'Xã',
          },
          {
            id: '1610',
            name: 'Vinh Quang',
            prefix: 'Xã',
          },
          {
            id: '1611',
            name: 'Vĩnh Tiến',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '8',
    code: 'LA',
    name: 'Long An',
    districts: [
      {
        id: '106',
        name: 'Bến Lức',
        wards: [
          {
            id: '1612',
            name: 'An Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1613',
            name: 'Bến Lức',
            prefix: 'Thị trấn',
          },
          {
            id: '1614',
            name: 'Bình Đức',
            prefix: 'Xã',
          },
          {
            id: '1615',
            name: 'Long Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1616',
            name: 'Lương Bình',
            prefix: 'Xã',
          },
          {
            id: '1617',
            name: 'Lương Hòa',
            prefix: 'Xã',
          },
          {
            id: '1618',
            name: 'Mỹ Yên',
            prefix: 'Xã',
          },
          {
            id: '1619',
            name: 'Nhựt Chánh',
            prefix: 'Xã',
          },
          {
            id: '1620',
            name: 'Phước Lợi',
            prefix: 'Xã',
          },
          {
            id: '1621',
            name: 'Tân Bửu',
            prefix: 'Xã',
          },
          {
            id: '1622',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
          {
            id: '1623',
            name: 'Thạnh Đức',
            prefix: 'Xã',
          },
          {
            id: '1624',
            name: 'Thạnh Hòa',
            prefix: 'Xã',
          },
          {
            id: '1625',
            name: 'Thạnh Lợi',
            prefix: 'Xã',
          },
          {
            id: '1626',
            name: 'Thanh Phú',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '107',
        name: 'Cần Đước',
        wards: [
          {
            id: '1627',
            name: 'Cần Đước',
            prefix: 'Thị trấn',
          },
          {
            id: '1628',
            name: 'Long Cang',
            prefix: 'Xã',
          },
          {
            id: '1629',
            name: 'Long Định',
            prefix: 'Xã',
          },
          {
            id: '1630',
            name: 'Long Hòa',
            prefix: 'Xã',
          },
          {
            id: '1631',
            name: 'Long Hựu Đông',
            prefix: 'Xã',
          },
          {
            id: '1632',
            name: 'Long Hựu Tây',
            prefix: 'Xã',
          },
          {
            id: '1633',
            name: 'Long Khê',
            prefix: 'Xã',
          },
          {
            id: '1634',
            name: 'Long Sơn',
            prefix: 'Xã',
          },
          {
            id: '1635',
            name: 'Long Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1636',
            name: 'Long Trạch',
            prefix: 'Xã',
          },
          {
            id: '1637',
            name: 'Mỹ Lệ',
            prefix: 'Xã',
          },
          {
            id: '1638',
            name: 'Phước Đông',
            prefix: 'Xã',
          },
          {
            id: '1639',
            name: 'Phước Tuy',
            prefix: 'Xã',
          },
          {
            id: '1640',
            name: 'Phước Vân',
            prefix: 'Xã',
          },
          {
            id: '1641',
            name: 'Tân Ân',
            prefix: 'Xã',
          },
          {
            id: '1642',
            name: 'Tân Chánh',
            prefix: 'Xã',
          },
          {
            id: '1643',
            name: 'Tân Lân',
            prefix: 'Xã',
          },
          {
            id: '1644',
            name: 'Tân Trạch',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '108',
        name: 'Cần Giuộc',
        wards: [
          {
            id: '1645',
            name: 'Cần Giuộc',
            prefix: 'Thị trấn',
          },
          {
            id: '1646',
            name: 'Đông Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1647',
            name: 'Long An',
            prefix: 'Xã',
          },
          {
            id: '1648',
            name: 'Long Hậu',
            prefix: 'Xã',
          },
          {
            id: '1649',
            name: 'Long Phụng',
            prefix: 'Xã',
          },
          {
            id: '1650',
            name: 'Long Thượng',
            prefix: 'Xã',
          },
          {
            id: '1651',
            name: 'Mỹ Lộc',
            prefix: 'Xã',
          },
          {
            id: '1652',
            name: 'Phước Hậu',
            prefix: 'Xã',
          },
          {
            id: '1653',
            name: 'Phước Lại',
            prefix: 'Xã',
          },
          {
            id: '1654',
            name: 'Phước Lâm',
            prefix: 'Xã',
          },
          {
            id: '1655',
            name: 'Phước Lý',
            prefix: 'Xã',
          },
          {
            id: '1656',
            name: 'Phước Vĩnh Đông',
            prefix: 'Xã',
          },
          {
            id: '1657',
            name: 'Phước Vĩnh Tây',
            prefix: 'Xã',
          },
          {
            id: '1658',
            name: 'Tân Kim',
            prefix: 'Xã',
          },
          {
            id: '1659',
            name: 'Tân Tập',
            prefix: 'Xã',
          },
          {
            id: '1660',
            name: 'Thuận Thành',
            prefix: 'Xã',
          },
          {
            id: '1661',
            name: 'Trường Bình',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '109',
        name: 'Châu Thành',
        wards: [
          {
            id: '1662',
            name: 'An Lục Long',
            prefix: 'Xã',
          },
          {
            id: '1663',
            name: 'Bình Quới',
            prefix: 'Xã',
          },
          {
            id: '1664',
            name: 'Bình Quới.',
            prefix: 'Xã',
          },
          {
            id: '1665',
            name: 'Dương Xuân Hội',
            prefix: 'Xã',
          },
          {
            id: '1666',
            name: 'Hiệp Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1667',
            name: 'Hòa Phú',
            prefix: 'Xã',
          },
          {
            id: '1668',
            name: 'Long Trì',
            prefix: 'Xã',
          },
          {
            id: '1669',
            name: 'Phú Ngãi Trị',
            prefix: 'Xã',
          },
          {
            id: '1670',
            name: 'Phước Tân Hưng',
            prefix: 'Xã',
          },
          {
            id: '1671',
            name: 'Tầm Vu',
            prefix: 'Thị trấn',
          },
          {
            id: '1672',
            name: 'Thanh Phú Long',
            prefix: 'Xã',
          },
          {
            id: '1673',
            name: 'Thanh Vĩnh Đông',
            prefix: 'Xã',
          },
          {
            id: '1674',
            name: 'Thuận Mỹ',
            prefix: 'Xã',
          },
          {
            id: '1675',
            name: 'Vĩnh Công',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '110',
        name: 'Đức Hòa',
        wards: [
          {
            id: '1676',
            name: 'An Ninh Đông',
            prefix: 'Xã',
          },
          {
            id: '1677',
            name: 'An Ninh Tây',
            prefix: 'Xã',
          },
          {
            id: '1678',
            name: 'Đức Hòa',
            prefix: 'Thị trấn',
          },
          {
            id: '1679',
            name: 'Đức Hoà Đông',
            prefix: 'Xã',
          },
          {
            id: '1680',
            name: 'Đức Hoà Hạ',
            prefix: 'Xã',
          },
          {
            id: '1681',
            name: 'Đức Hoà Thượng',
            prefix: 'Xã',
          },
          {
            id: '1682',
            name: 'Đức Lập Hạ',
            prefix: 'Xã',
          },
          {
            id: '1683',
            name: 'Đức Lập Thượng',
            prefix: 'Xã',
          },
          {
            id: '1684',
            name: 'Hậu Nghĩa',
            prefix: 'Thị trấn',
          },
          {
            id: '1685',
            name: 'Hiệp Hòa',
            prefix: 'Thị trấn',
          },
          {
            id: '1686',
            name: 'Hiệp Hòa',
            prefix: 'Xã',
          },
          {
            id: '1687',
            name: 'Hoà Khánh Đông',
            prefix: 'Xã',
          },
          {
            id: '1688',
            name: 'Hoà Khánh Nam',
            prefix: 'Xã',
          },
          {
            id: '1689',
            name: 'Hòa Khánh Tây',
            prefix: 'Xã',
          },
          {
            id: '1690',
            name: 'Hựu Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1691',
            name: 'Lộc Giang',
            prefix: 'Xã',
          },
          {
            id: '1692',
            name: 'Mỹ Hạnh Bắc',
            prefix: 'Xã',
          },
          {
            id: '1693',
            name: 'Mỹ Hạnh Nam',
            prefix: 'Xã',
          },
          {
            id: '1694',
            name: 'Tân Mỹ',
            prefix: 'Xã',
          },
          {
            id: '1695',
            name: 'Tân Phú',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '111',
        name: 'Đức Huệ',
        wards: [
          {
            id: '1696',
            name: 'Bình Hòa Bắc',
            prefix: 'Xã',
          },
          {
            id: '1697',
            name: 'Bình Hòa Hưng',
            prefix: 'Xã',
          },
          {
            id: '1698',
            name: 'Bình Hòa Nam',
            prefix: 'Xã',
          },
          {
            id: '1699',
            name: 'Bình Thành',
            prefix: 'Xã',
          },
          {
            id: '1700',
            name: 'Đông Thành',
            prefix: 'Thị trấn',
          },
          {
            id: '1701',
            name: 'Mỹ Bình',
            prefix: 'Xã',
          },
          {
            id: '1702',
            name: 'Mỹ Quý Đông',
            prefix: 'Xã',
          },
          {
            id: '1703',
            name: 'Mỹ Quý Tây',
            prefix: 'Xã',
          },
          {
            id: '1704',
            name: 'Mỹ Thạnh Bắc',
            prefix: 'Xã',
          },
          {
            id: '1705',
            name: 'Mỹ Thạnh Đông',
            prefix: 'Xã',
          },
          {
            id: '1706',
            name: 'Mỹ Thạnh Tây',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '112',
        name: 'Kiến Tường',
        wards: [
          {
            id: '1707',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '1708',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '1709',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '1710',
            name: 'Bình Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1711',
            name: 'Bình Tân',
            prefix: 'Xã',
          },
          {
            id: '1712',
            name: 'Thạnh Hưng',
            prefix: 'Xã',
          },
          {
            id: '1713',
            name: 'Thạnh Trị',
            prefix: 'Xã',
          },
          {
            id: '1714',
            name: 'Tuyên Thạnh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '113',
        name: 'Mộc Hóa',
        wards: [
          {
            id: '1715',
            name: 'Bình Hòa Đông',
            prefix: 'Xã',
          },
          {
            id: '1716',
            name: 'Bình Hòa Tây',
            prefix: 'Xã',
          },
          {
            id: '1717',
            name: 'Bình Hòa Trung',
            prefix: 'Xã',
          },
          {
            id: '1718',
            name: 'Bình Phong Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1719',
            name: 'Bình Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1720',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '1721',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '114',
        name: 'Tân An',
        wards: [
          {
            id: '1722',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '1723',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '1724',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '1725',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '1726',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '1727',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '1728',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '1729',
            name: 'An Vĩnh Ngãi',
            prefix: 'Xã',
          },
          {
            id: '1730',
            name: 'Bình Tâm',
            prefix: 'Xã',
          },
          {
            id: '1731',
            name: 'Hướng Thọ Phú',
            prefix: 'Xã',
          },
          {
            id: '1732',
            name: 'Khánh Hậu',
            prefix: 'Phường',
          },
          {
            id: '1733',
            name: 'Lợi Bình Nhơn',
            prefix: 'Xã',
          },
          {
            id: '1734',
            name: 'Nhơn Thạnh Trung',
            prefix: 'Xã',
          },
          {
            id: '1735',
            name: 'Tân Khánh',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '115',
        name: 'Tân Hưng',
        wards: [
          {
            id: '1736',
            name: 'Bình Thạnh',
            prefix: 'Thị trấn',
          },
          {
            id: '1737',
            name: 'Hưng Điền',
            prefix: 'Xã',
          },
          {
            id: '1738',
            name: 'Hưng Điền B',
            prefix: 'Xã',
          },
          {
            id: '1739',
            name: 'Hưng Hà',
            prefix: 'Xã',
          },
          {
            id: '1740',
            name: 'Hưng Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1741',
            name: 'Tân Hưng',
            prefix: 'Thị trấn',
          },
          {
            id: '1742',
            name: 'Thạnh Hưng',
            prefix: 'Xã',
          },
          {
            id: '1743',
            name: 'Vĩnh Bữu',
            prefix: 'Xã',
          },
          {
            id: '1744',
            name: 'Vĩnh Châu A',
            prefix: 'Xã',
          },
          {
            id: '1745',
            name: 'Vĩnh Châu B',
            prefix: 'Xã',
          },
          {
            id: '1746',
            name: 'Vĩnh Đại',
            prefix: 'Xã',
          },
          {
            id: '1747',
            name: 'Vĩnh Lợi',
            prefix: 'Xã',
          },
          {
            id: '1748',
            name: 'Vĩnh Thạnh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '116',
        name: 'Tân Thạnh',
        wards: [
          {
            id: '1749',
            name: 'Bắc Hoà',
            prefix: 'Xã',
          },
          {
            id: '1750',
            name: 'Hậu Thạnh Đông',
            prefix: 'Xã',
          },
          {
            id: '1751',
            name: 'Hậu Thạnh Tây',
            prefix: 'Xã',
          },
          {
            id: '1752',
            name: 'Kiến Bình',
            prefix: 'Xã',
          },
          {
            id: '1753',
            name: 'Nhơn Hoà',
            prefix: 'Xã',
          },
          {
            id: '1754',
            name: 'Nhơn Hoà Lập',
            prefix: 'Xã',
          },
          {
            id: '1755',
            name: 'Nhơn Ninh',
            prefix: 'Xã',
          },
          {
            id: '1756',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '1757',
            name: 'Tân Hoà',
            prefix: 'Xã',
          },
          {
            id: '1758',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '1759',
            name: 'Tân Ninh',
            prefix: 'Xã',
          },
          {
            id: '1760',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '1761',
            name: 'Tân Thạnh',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '117',
        name: 'Tân Trụ',
        wards: [
          {
            id: '1762',
            name: 'An Nhựt Tân',
            prefix: 'Xã',
          },
          {
            id: '1763',
            name: 'Bình Lãng',
            prefix: 'Xã',
          },
          {
            id: '1764',
            name: 'Bình Tịnh',
            prefix: 'Xã',
          },
          {
            id: '1765',
            name: 'Bình Trinh Đông',
            prefix: 'Xã',
          },
          {
            id: '1766',
            name: 'Đức Tân',
            prefix: 'Xã',
          },
          {
            id: '1767',
            name: 'Lạc Tấn',
            prefix: 'Xã',
          },
          {
            id: '1768',
            name: 'Mỹ Bình',
            prefix: 'Xã',
          },
          {
            id: '1769',
            name: 'Nhựt Ninh',
            prefix: 'Xã',
          },
          {
            id: '1770',
            name: 'Quê Mỹ Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1771',
            name: 'Tân Phước Tây',
            prefix: 'Xã',
          },
          {
            id: '1772',
            name: 'Tân Trụ',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '118',
        name: 'Thạnh Hóa',
        wards: [
          {
            id: '1773',
            name: 'Tân Đông',
            prefix: 'Xã',
          },
          {
            id: '1774',
            name: 'Tân Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1775',
            name: 'Tân Tây',
            prefix: 'Xã',
          },
          {
            id: '1776',
            name: 'Thạnh An',
            prefix: 'Xã',
          },
          {
            id: '1777',
            name: 'Thạnh Hóa',
            prefix: 'Thị trấn',
          },
          {
            id: '1778',
            name: 'Thạnh Phú',
            prefix: 'Xã',
          },
          {
            id: '1779',
            name: 'Thạnh Phước',
            prefix: 'Xã',
          },
          {
            id: '1780',
            name: 'Thuận Bình',
            prefix: 'Xã',
          },
          {
            id: '1781',
            name: 'Thuận Nghĩa Hòa',
            prefix: 'Xã',
          },
          {
            id: '1782',
            name: 'Thủy Đông',
            prefix: 'Xã',
          },
          {
            id: '1783',
            name: 'Thủy Tây',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '119',
        name: 'Thủ Thừa',
        wards: [
          {
            id: '1784',
            name: 'Bình An',
            prefix: 'Xã',
          },
          {
            id: '1785',
            name: 'Bình Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1786',
            name: 'Long Thành',
            prefix: 'Xã',
          },
          {
            id: '1787',
            name: 'Long Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1788',
            name: 'Long Thuận',
            prefix: 'Xã',
          },
          {
            id: '1789',
            name: 'Mỹ An',
            prefix: 'Xã',
          },
          {
            id: '1790',
            name: 'Mỹ Lạc',
            prefix: 'Xã',
          },
          {
            id: '1791',
            name: 'Mỹ Phú',
            prefix: 'Xã',
          },
          {
            id: '1792',
            name: 'Mỹ Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1793',
            name: 'Nhị Thành',
            prefix: 'Xã',
          },
          {
            id: '1794',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '1795',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '1796',
            name: 'Thủ Thừa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '120',
        name: 'Vĩnh Hưng',
        wards: [
          {
            id: '1797',
            name: 'Hưng Điền A',
            prefix: 'Xã',
          },
          {
            id: '1798',
            name: 'Khánh Hưng',
            prefix: 'Xã',
          },
          {
            id: '1799',
            name: 'Thái Bình Trung',
            prefix: 'Xã',
          },
          {
            id: '1800',
            name: 'Thái Trị',
            prefix: 'Xã',
          },
          {
            id: '1801',
            name: 'Tuyên Bình',
            prefix: 'Xã',
          },
          {
            id: '1802',
            name: 'Tuyên Bình Tây',
            prefix: 'Xã',
          },
          {
            id: '1803',
            name: 'Vĩnh Bình',
            prefix: 'Xã',
          },
          {
            id: '1804',
            name: 'Vĩnh Hưng',
            prefix: 'Thị trấn',
          },
          {
            id: '1805',
            name: 'Vĩnh Thuận',
            prefix: 'Xã',
          },
          {
            id: '1806',
            name: 'Vĩnh Trị',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '9',
    code: 'QNA',
    name: 'Quảng Nam',
    districts: [
      {
        id: '121',
        name: 'Bắc Trà My',
        wards: [
          {
            id: '1807',
            name: 'Trà Bui',
            prefix: 'Xã',
          },
          {
            id: '1810',
            name: 'Trà Dương',
            prefix: 'Xã',
          },
          {
            id: '1808',
            name: 'Trà Đốc',
            prefix: 'Xã',
          },
          {
            id: '1809',
            name: 'Trà Đông',
            prefix: 'Xã',
          },
          {
            id: '1811',
            name: 'Trà Giác',
            prefix: 'Xã',
          },
          {
            id: '1812',
            name: 'Trà Giang',
            prefix: 'Xã',
          },
          {
            id: '1813',
            name: 'Trà Giáp',
            prefix: 'Xã',
          },
          {
            id: '1814',
            name: 'Trà Ka',
            prefix: 'Xã',
          },
          {
            id: '1815',
            name: 'Trà Kót',
            prefix: 'Xã',
          },
          {
            id: '1816',
            name: 'Trà My',
            prefix: 'Thị trấn',
          },
          {
            id: '1817',
            name: 'Trà Nú',
            prefix: 'Xã',
          },
          {
            id: '1818',
            name: 'Trà Sơn',
            prefix: 'Xã',
          },
          {
            id: '1819',
            name: 'Trà Tân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '125',
        name: 'Duy Xuyên',
        wards: [
          {
            id: '1869',
            name: 'Duy Châu',
            prefix: 'Xã',
          },
          {
            id: '1870',
            name: 'Duy Hải',
            prefix: 'Xã',
          },
          {
            id: '1871',
            name: 'Duy Hòa',
            prefix: 'Xã',
          },
          {
            id: '1872',
            name: 'Duy Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '1873',
            name: 'Duy Phú',
            prefix: 'Xã',
          },
          {
            id: '1874',
            name: 'Duy Phước',
            prefix: 'Xã',
          },
          {
            id: '1875',
            name: 'Duy Sơn',
            prefix: 'Xã',
          },
          {
            id: '1876',
            name: 'Duy Tân',
            prefix: 'Xã',
          },
          {
            id: '1877',
            name: 'Duy Thành',
            prefix: 'Xã',
          },
          {
            id: '1878',
            name: 'Duy Thu',
            prefix: 'Xã',
          },
          {
            id: '1879',
            name: 'Duy Trinh',
            prefix: 'Xã',
          },
          {
            id: '1880',
            name: 'Duy Trung',
            prefix: 'Xã',
          },
          {
            id: '1881',
            name: 'Duy Vinh',
            prefix: 'Xã',
          },
          {
            id: '1882',
            name: 'Nam Phước',
            prefix: 'Thị trấn',
          },
          {
            id: '1883',
            name: 'Phước Nam',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '122',
        name: 'Đại Lộc',
        wards: [
          {
            id: '1820',
            name: 'Ái Nghĩa',
            prefix: 'Thị trấn',
          },
          {
            id: '1821',
            name: 'Đại An',
            prefix: 'Xã',
          },
          {
            id: '1822',
            name: 'Đại Chánh',
            prefix: 'Xã',
          },
          {
            id: '1823',
            name: 'Đại Cường',
            prefix: 'Xã',
          },
          {
            id: '1824',
            name: 'Đại Đồng',
            prefix: 'Xã',
          },
          {
            id: '1825',
            name: 'Đại Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1826',
            name: 'Đại Hòa',
            prefix: 'Xã',
          },
          {
            id: '1827',
            name: 'Đại Hồng',
            prefix: 'Xã',
          },
          {
            id: '1828',
            name: 'Đại Hưng',
            prefix: 'Xã',
          },
          {
            id: '1829',
            name: 'Đại Lãnh',
            prefix: 'Xã',
          },
          {
            id: '1830',
            name: 'Đại Minh',
            prefix: 'Xã',
          },
          {
            id: '1831',
            name: 'Đại Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '1832',
            name: 'Đại Phong',
            prefix: 'Xã',
          },
          {
            id: '1833',
            name: 'Đại Quang',
            prefix: 'Xã',
          },
          {
            id: '1834',
            name: 'Đại Sơn',
            prefix: 'Xã',
          },
          {
            id: '1835',
            name: 'Đại Tân',
            prefix: 'Xã',
          },
          {
            id: '1836',
            name: 'Đại Thắng',
            prefix: 'Xã',
          },
          {
            id: '1837',
            name: 'Đại Thạnh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '123',
        name: 'Điện Bàn',
        wards: [
          {
            id: '1838',
            name: 'Điện An',
            prefix: 'Xã',
          },
          {
            id: '1839',
            name: 'Điện Dương',
            prefix: 'Xã',
          },
          {
            id: '1840',
            name: 'Điện Hòa',
            prefix: 'Xã',
          },
          {
            id: '1841',
            name: 'Điện Hồng',
            prefix: 'Xã',
          },
          {
            id: '1842',
            name: 'Điện Minh',
            prefix: 'Xã',
          },
          {
            id: '1843',
            name: 'Điện Nam Bắc',
            prefix: 'Xã',
          },
          {
            id: '1844',
            name: 'Điện Nam Đông',
            prefix: 'Xã',
          },
          {
            id: '1845',
            name: 'Điện Nam Trung',
            prefix: 'Xã',
          },
          {
            id: '1846',
            name: 'Điện Ngọc',
            prefix: 'Xã',
          },
          {
            id: '1847',
            name: 'Điện Phong',
            prefix: 'Xã',
          },
          {
            id: '1848',
            name: 'Điện Phước',
            prefix: 'Xã',
          },
          {
            id: '1849',
            name: 'Điện Phương',
            prefix: 'Xã',
          },
          {
            id: '1850',
            name: 'Điện Quang',
            prefix: 'Xã',
          },
          {
            id: '1851',
            name: 'Điện Thắng Bắc',
            prefix: 'Xã',
          },
          {
            id: '1852',
            name: 'Điện Thắng Nam',
            prefix: 'Xã',
          },
          {
            id: '1853',
            name: 'Điện Thắng Trung',
            prefix: 'Xã',
          },
          {
            id: '1854',
            name: 'Điện Thọ',
            prefix: 'Xã',
          },
          {
            id: '1855',
            name: 'Điện Tiến',
            prefix: 'Xã',
          },
          {
            id: '1856',
            name: 'Điện Trung',
            prefix: 'Xã',
          },
          {
            id: '1857',
            name: 'Vĩnh Điện',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '124',
        name: 'Đông Giang',
        wards: [
          {
            id: '1858',
            name: 'A Rooi',
            prefix: 'Xã',
          },
          {
            id: '1859',
            name: 'A Ting',
            prefix: 'Xã',
          },
          {
            id: '1860',
            name: 'Ba',
            prefix: 'Xã',
          },
          {
            id: '1861',
            name: 'Jơ Ngây',
            prefix: 'Xã',
          },
          {
            id: '1862',
            name: 'Ka Dăng',
            prefix: 'Xã',
          },
          {
            id: '1863',
            name: 'Mà Cooi',
            prefix: 'Xã',
          },
          {
            id: '1864',
            name: 'Prao',
            prefix: 'Xã',
          },
          {
            id: '1865',
            name: 'Sông Kôn',
            prefix: 'Xã',
          },
          {
            id: '1866',
            name: 'Tà Lu',
            prefix: 'Xã',
          },
          {
            id: '1867',
            name: 'Tư',
            prefix: 'Xã',
          },
          {
            id: '1868',
            name: 'Za Hung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '126',
        name: 'Hiệp Đức',
        wards: [
          {
            id: '1884',
            name: 'Bình Lâm',
            prefix: 'Xã',
          },
          {
            id: '1885',
            name: 'Bình Sơn',
            prefix: 'Xã',
          },
          {
            id: '1886',
            name: 'Hiệp Hòa',
            prefix: 'Xã',
          },
          {
            id: '1887',
            name: 'Hiệp Thuận',
            prefix: 'Xã',
          },
          {
            id: '1888',
            name: 'Phước Gia',
            prefix: 'Xã',
          },
          {
            id: '1889',
            name: 'Phước Trà',
            prefix: 'Xã',
          },
          {
            id: '1890',
            name: 'Quế Bình',
            prefix: 'Xã',
          },
          {
            id: '1891',
            name: 'Quế Lưu',
            prefix: 'Xã',
          },
          {
            id: '1892',
            name: 'Quế Thọ',
            prefix: 'Xã',
          },
          {
            id: '1893',
            name: 'Sông Trà',
            prefix: 'Xã',
          },
          {
            id: '1894',
            name: 'Tân An',
            prefix: 'Thị trấn',
          },
          {
            id: '1895',
            name: 'Thăng Phước',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '127',
        name: 'Hội An',
        wards: [
          {
            id: '1896',
            name: 'Cẩm An',
            prefix: 'Phường',
          },
          {
            id: '1897',
            name: 'Cẩm Châu',
            prefix: 'Phường',
          },
          {
            id: '1898',
            name: 'Cẩm Hà',
            prefix: 'Xã',
          },
          {
            id: '1899',
            name: 'Cẩm Kim',
            prefix: 'Xã',
          },
          {
            id: '1900',
            name: 'Cẩm Nam',
            prefix: 'Phường',
          },
          {
            id: '1901',
            name: 'Cẩm Phô',
            prefix: 'Phường',
          },
          {
            id: '1902',
            name: 'Cẩm Thanh',
            prefix: 'Xã',
          },
          {
            id: '1903',
            name: 'Cửa Đại',
            prefix: 'Phường',
          },
          {
            id: '1904',
            name: 'Minh An',
            prefix: 'Phường',
          },
          {
            id: '1905',
            name: 'Sơn Phong',
            prefix: 'Phường',
          },
          {
            id: '1906',
            name: 'Tân An',
            prefix: 'Phường',
          },
          {
            id: '1907',
            name: 'Tân Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1908',
            name: 'Thanh Hà',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '128',
        name: 'Nam Giang',
        wards: [
          {
            id: '1909',
            name: 'Cà Dy',
            prefix: 'Xã',
          },
          {
            id: '1910',
            name: 'Chà Vàl',
            prefix: 'Xã',
          },
          {
            id: '1911',
            name: 'Chơ Chun',
            prefix: 'Xã',
          },
          {
            id: '1912',
            name: 'Đăk Pree',
            prefix: 'Xã',
          },
          {
            id: '1913',
            name: 'Đắk Pring',
            prefix: 'Xã',
          },
          {
            id: '1914',
            name: 'Đắk Tôi',
            prefix: 'Xã',
          },
          {
            id: '1915',
            name: 'La Dêê',
            prefix: 'Xã',
          },
          {
            id: '1916',
            name: 'La Êê',
            prefix: 'Xã',
          },
          {
            id: '1917',
            name: 'Tà Bhing',
            prefix: 'Xã',
          },
          {
            id: '1918',
            name: 'Tà Pơơ',
            prefix: 'Xã',
          },
          {
            id: '1919',
            name: 'Thạnh Mỹ',
            prefix: 'Thị trấn',
          },
          {
            id: '1920',
            name: 'Zuôih',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '129',
        name: 'Nam Trà My',
        wards: [
          {
            id: '1921',
            name: 'Trà Cang',
            prefix: 'Xã',
          },
          {
            id: '1922',
            name: 'Trà Don',
            prefix: 'Xã',
          },
          {
            id: '1923',
            name: 'Trà Dơn',
            prefix: 'Xã',
          },
          {
            id: '1924',
            name: 'Trà Leng',
            prefix: 'Xã',
          },
          {
            id: '1925',
            name: 'Trà Linh',
            prefix: 'Xã',
          },
          {
            id: '1926',
            name: 'Trà Mai',
            prefix: 'Xã',
          },
          {
            id: '1927',
            name: 'Trà Nam',
            prefix: 'Xã',
          },
          {
            id: '1928',
            name: 'Trà Tập',
            prefix: 'Xã',
          },
          {
            id: '1929',
            name: 'Trà Vân',
            prefix: 'Xã',
          },
          {
            id: '1930',
            name: 'Trà Vinh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '130',
        name: 'Nông Sơn',
        wards: [
          {
            id: '1931',
            name: 'Phước Ninh',
            prefix: 'Xã',
          },
          {
            id: '1932',
            name: 'Quế Lâm',
            prefix: 'Xã',
          },
          {
            id: '1933',
            name: 'Quế Lộc',
            prefix: 'Xã',
          },
          {
            id: '1934',
            name: 'Quế Ninh',
            prefix: 'Xã',
          },
          {
            id: '1935',
            name: 'Quế Phước',
            prefix: 'Xã',
          },
          {
            id: '1936',
            name: 'Quế Trung',
            prefix: 'Xã',
          },
          {
            id: '1937',
            name: 'Sơn Viên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '131',
        name: 'Núi Thành',
        wards: [
          {
            id: '1938',
            name: 'Núi Thành',
            prefix: 'Thị trấn',
          },
          {
            id: '1939',
            name: 'Tam Anh Bắc',
            prefix: 'Xã',
          },
          {
            id: '1940',
            name: 'Tam Anh Nam',
            prefix: 'Xã',
          },
          {
            id: '1941',
            name: 'Tam Giang',
            prefix: 'Xã',
          },
          {
            id: '1942',
            name: 'Tam Hải',
            prefix: 'Xã',
          },
          {
            id: '1943',
            name: 'Tam Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1944',
            name: 'Tam Hòa',
            prefix: 'Xã',
          },
          {
            id: '1945',
            name: 'Tam Mỹ Đông',
            prefix: 'Xã',
          },
          {
            id: '1946',
            name: 'Tam Mỹ Tây',
            prefix: 'Xã',
          },
          {
            id: '1947',
            name: 'Tam Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '1948',
            name: 'Tam Quang',
            prefix: 'Xã',
          },
          {
            id: '1949',
            name: 'Tam Sơn',
            prefix: 'Xã',
          },
          {
            id: '1950',
            name: 'Tam Thạnh',
            prefix: 'Xã',
          },
          {
            id: '1951',
            name: 'Tam Tiến',
            prefix: 'Xã',
          },
          {
            id: '1952',
            name: 'Tam Trà',
            prefix: 'Xã',
          },
          {
            id: '1953',
            name: 'Tam Xuân 1',
            prefix: 'Xã',
          },
          {
            id: '1954',
            name: 'Tam Xuân 2',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '132',
        name: 'Phú Ninh',
        wards: [
          {
            id: '1955',
            name: 'Phú Thịnh',
            prefix: 'Thị trấn',
          },
          {
            id: '1956',
            name: 'Tam An',
            prefix: 'Xã',
          },
          {
            id: '1958',
            name: 'Tam Dân',
            prefix: 'Xã',
          },
          {
            id: '1957',
            name: 'Tam Đại',
            prefix: 'Xã',
          },
          {
            id: '1959',
            name: 'Tam Đàn',
            prefix: 'Xã',
          },
          {
            id: '1960',
            name: 'Tam Lãnh',
            prefix: 'Xã',
          },
          {
            id: '1961',
            name: 'Tam Lộc',
            prefix: 'Xã',
          },
          {
            id: '1962',
            name: 'Tam Phước',
            prefix: 'Xã',
          },
          {
            id: '1963',
            name: 'Tam Thái',
            prefix: 'Xã',
          },
          {
            id: '1964',
            name: 'Tam Thành',
            prefix: 'Xã',
          },
          {
            id: '1965',
            name: 'Tam Vinh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '133',
        name: 'Phước Sơn',
        wards: [
          {
            id: '1966',
            name: 'Khâm Đức',
            prefix: 'Thị trấn',
          },
          {
            id: '1967',
            name: 'Phước Chánh',
            prefix: 'Xã',
          },
          {
            id: '1968',
            name: 'Phước Công',
            prefix: 'Xã',
          },
          {
            id: '1969',
            name: 'Phước Đức',
            prefix: 'Xã',
          },
          {
            id: '1970',
            name: 'Phước Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1971',
            name: 'Phước Hòa',
            prefix: 'Xã',
          },
          {
            id: '1972',
            name: 'Phước Kim',
            prefix: 'Xã',
          },
          {
            id: '1973',
            name: 'Phước Lộc',
            prefix: 'Xã',
          },
          {
            id: '1974',
            name: 'Phước Mỹ',
            prefix: 'Xã',
          },
          {
            id: '1975',
            name: 'Phước Năng',
            prefix: 'Xã',
          },
          {
            id: '1976',
            name: 'Phước Thành',
            prefix: 'Xã',
          },
          {
            id: '1977',
            name: 'Phước Xuân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '134',
        name: 'Quế Sơn',
        wards: [
          {
            id: '1978',
            name: 'Đông Phú',
            prefix: 'Thị trấn',
          },
          {
            id: '1979',
            name: 'Hương An',
            prefix: 'Xã',
          },
          {
            id: '1980',
            name: 'Phú Thọ',
            prefix: 'Xã',
          },
          {
            id: '1981',
            name: 'Quế An',
            prefix: 'Xã',
          },
          {
            id: '1982',
            name: 'Quế Châu',
            prefix: 'Xã',
          },
          {
            id: '1983',
            name: 'Quế Cường',
            prefix: 'Xã',
          },
          {
            id: '1984',
            name: 'Quế Hiệp',
            prefix: 'Xã',
          },
          {
            id: '1985',
            name: 'Quế Long',
            prefix: 'Xã',
          },
          {
            id: '1986',
            name: 'Quế Minh',
            prefix: 'Xã',
          },
          {
            id: '1987',
            name: 'Quế Phong',
            prefix: 'Xã',
          },
          {
            id: '1988',
            name: 'Quế Phú',
            prefix: 'Xã',
          },
          {
            id: '1989',
            name: 'Quế Thuận',
            prefix: 'Xã',
          },
          {
            id: '1990',
            name: 'Quế Xuân 1',
            prefix: 'Xã',
          },
          {
            id: '1991',
            name: 'Quế Xuân 2',
            prefix: 'Xã',
          },
          {
            id: '1992',
            name: 'Quý Thuận',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '135',
        name: 'Tam Kỳ',
        wards: [
          {
            id: '1993',
            name: 'An Mỹ',
            prefix: 'Phường',
          },
          {
            id: '1994',
            name: 'An Phú',
            prefix: 'Phường',
          },
          {
            id: '1995',
            name: 'An Sơn',
            prefix: 'Phường',
          },
          {
            id: '1996',
            name: 'An Xuân',
            prefix: 'Phường',
          },
          {
            id: '1997',
            name: 'Hòa Hương',
            prefix: 'Phường',
          },
          {
            id: '1998',
            name: 'Hòa Thuận',
            prefix: 'Phường',
          },
          {
            id: '1999',
            name: 'Phước Hòa',
            prefix: 'Phường',
          },
          {
            id: '2000',
            name: 'Tam Ngọc',
            prefix: 'Xã',
          },
          {
            id: '2001',
            name: 'Tam Phú',
            prefix: 'Xã',
          },
          {
            id: '2002',
            name: 'Tam Thăng',
            prefix: 'Xã',
          },
          {
            id: '2003',
            name: 'Tam Thanh',
            prefix: 'Xã',
          },
          {
            id: '2004',
            name: 'Tân Thạnh',
            prefix: 'Phường',
          },
          {
            id: '2005',
            name: 'Trường Xuân',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '136',
        name: 'Tây Giang',
        wards: [
          {
            id: '2006',
            name: 'A Nông',
            prefix: 'Xã',
          },
          {
            id: '2007',
            name: 'A Tiêng',
            prefix: 'Xã',
          },
          {
            id: '2008',
            name: 'A Vương',
            prefix: 'Xã',
          },
          {
            id: '2009',
            name: 'A Xan',
            prefix: 'Xã',
          },
          {
            id: '2010',
            name: 'Bha Lê',
            prefix: 'Xã',
          },
          {
            id: '2011',
            name: "Ch'ơm",
            prefix: 'Xã',
          },
          {
            id: '2012',
            name: 'Dang',
            prefix: 'Xã',
          },
          {
            id: '2013',
            name: 'Ga Ri',
            prefix: 'Xã',
          },
          {
            id: '2014',
            name: 'Lăng',
            prefix: 'Xã',
          },
          {
            id: '2015',
            name: "Tr'hy",
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '137',
        name: 'Thăng Bình',
        wards: [
          {
            id: '2016',
            name: 'Bình An',
            prefix: 'Xã',
          },
          {
            id: '2017',
            name: 'Bình Chánh',
            prefix: 'Xã',
          },
          {
            id: '2021',
            name: 'Bình Dương',
            prefix: 'Xã',
          },
          {
            id: '2018',
            name: 'Bình Đào',
            prefix: 'Xã',
          },
          {
            id: '2019',
            name: 'Bình Định Bắc',
            prefix: 'Xã',
          },
          {
            id: '2020',
            name: 'Bình Định Nam',
            prefix: 'Xã',
          },
          {
            id: '2022',
            name: 'Bình Giang',
            prefix: 'Xã',
          },
          {
            id: '2023',
            name: 'Bình Hải',
            prefix: 'Xã',
          },
          {
            id: '2024',
            name: 'Bình Lãnh',
            prefix: 'Xã',
          },
          {
            id: '2025',
            name: 'Bình Minh',
            prefix: 'Xã',
          },
          {
            id: '2026',
            name: 'Bình Nam',
            prefix: 'Xã',
          },
          {
            id: '2027',
            name: 'Bình Nguyên',
            prefix: 'Xã',
          },
          {
            id: '2028',
            name: 'Bình Phú',
            prefix: 'Xã',
          },
          {
            id: '2029',
            name: 'Bình Phục',
            prefix: 'Xã',
          },
          {
            id: '2030',
            name: 'Bình Quế',
            prefix: 'Xã',
          },
          {
            id: '2031',
            name: 'Bình Quý',
            prefix: 'Xã',
          },
          {
            id: '2032',
            name: 'Bình Sa',
            prefix: 'Xã',
          },
          {
            id: '2033',
            name: 'Bình Trị',
            prefix: 'Xã',
          },
          {
            id: '2034',
            name: 'Bình Triều',
            prefix: 'Xã',
          },
          {
            id: '2035',
            name: 'Bình Trung',
            prefix: 'Xã',
          },
          {
            id: '2036',
            name: 'Bình Tú',
            prefix: 'Xã',
          },
          {
            id: '2037',
            name: 'Hà Lam',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '138',
        name: 'Tiên Phước',
        wards: [
          {
            id: '2038',
            name: 'Tiên An',
            prefix: 'Xã',
          },
          {
            id: '2039',
            name: 'Tiên Cẩm',
            prefix: 'Xã',
          },
          {
            id: '2040',
            name: 'Tiên Cảnh',
            prefix: 'Xã',
          },
          {
            id: '2041',
            name: 'Tiên Châu',
            prefix: 'Xã',
          },
          {
            id: '2042',
            name: 'Tiên Hà',
            prefix: 'Xã',
          },
          {
            id: '2043',
            name: 'Tiên Hiệp',
            prefix: 'Xã',
          },
          {
            id: '2044',
            name: 'Tiên Kỳ',
            prefix: 'Thị trấn',
          },
          {
            id: '2045',
            name: 'Tiên Lãnh',
            prefix: 'Xã',
          },
          {
            id: '2046',
            name: 'Tiên Lập',
            prefix: 'Xã',
          },
          {
            id: '2047',
            name: 'Tiên Lộc',
            prefix: 'Xã',
          },
          {
            id: '2048',
            name: 'Tiên Mỹ',
            prefix: 'Xã',
          },
          {
            id: '2049',
            name: 'Tiên Ngọc',
            prefix: 'Xã',
          },
          {
            id: '2050',
            name: 'Tiên Phong',
            prefix: 'Xã',
          },
          {
            id: '2051',
            name: 'Tiên Sơn',
            prefix: 'Xã',
          },
          {
            id: '2052',
            name: 'Tiên Thọ',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '10',
    code: 'VT',
    name: 'Bà Rịa Vũng Tàu',
    districts: [
      {
        id: '139',
        name: 'Bà Rịa',
        wards: [
          {
            id: '2053',
            name: 'Hòa Long',
            prefix: 'Xã',
          },
          {
            id: '2054',
            name: 'Kim Dinh',
            prefix: 'Phường',
          },
          {
            id: '2055',
            name: 'Long Hương',
            prefix: 'Phường',
          },
          {
            id: '2056',
            name: 'Long Phước',
            prefix: 'Xã',
          },
          {
            id: '2057',
            name: 'Long Tâm',
            prefix: 'Phường',
          },
          {
            id: '2058',
            name: 'Long Toàn',
            prefix: 'Phường',
          },
          {
            id: '2059',
            name: 'Phước Hiệp',
            prefix: 'Phường',
          },
          {
            id: '2060',
            name: 'Phước Hưng',
            prefix: 'Phường',
          },
          {
            id: '2061',
            name: 'Phước Nguyên',
            prefix: 'Phường',
          },
          {
            id: '2062',
            name: 'Phước Trung',
            prefix: 'Phường',
          },
          {
            id: '2063',
            name: 'Tân Hưng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '140',
        name: 'Châu Đức',
        wards: [
          {
            id: '2064',
            name: 'Bàu Chinh',
            prefix: 'Xã',
          },
          {
            id: '2065',
            name: 'Bình Ba',
            prefix: 'Xã',
          },
          {
            id: '2066',
            name: 'Bình Giã',
            prefix: 'Xã',
          },
          {
            id: '2067',
            name: 'Bình Trung',
            prefix: 'Xã',
          },
          {
            id: '2068',
            name: 'Cù Bị',
            prefix: 'Xã',
          },
          {
            id: '2069',
            name: 'Đá Bạc',
            prefix: 'Xã',
          },
          {
            id: '2070',
            name: 'Kim Long',
            prefix: 'Xã',
          },
          {
            id: '2071',
            name: 'Láng Lớn',
            prefix: 'Xã',
          },
          {
            id: '2072',
            name: 'Ngãi Giao',
            prefix: 'Thị trấn',
          },
          {
            id: '2073',
            name: 'Nghĩa Thành',
            prefix: 'Xã',
          },
          {
            id: '2074',
            name: 'Quảng Thành',
            prefix: 'Xã',
          },
          {
            id: '2075',
            name: 'Sơn Bình',
            prefix: 'Xã',
          },
          {
            id: '2076',
            name: 'Suối Nghệ',
            prefix: 'Xã',
          },
          {
            id: '2077',
            name: 'Suối Rao',
            prefix: 'Xã',
          },
          {
            id: '2078',
            name: 'Xà Bang',
            prefix: 'Xã',
          },
          {
            id: '2079',
            name: 'Xuân Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '141',
        name: 'Côn Đảo',
        wards: [],
      },
      {
        id: '142',
        name: 'Đất Đỏ',
        wards: [
          {
            id: '2080',
            name: 'Đất Đỏ',
            prefix: 'Thị trấn',
          },
          {
            id: '2081',
            name: 'Láng Dài',
            prefix: 'Xã',
          },
          {
            id: '2082',
            name: 'Lộc An',
            prefix: 'Xã',
          },
          {
            id: '2083',
            name: 'Long Mỹ',
            prefix: 'Xã',
          },
          {
            id: '2084',
            name: 'Long Tân',
            prefix: 'Xã',
          },
          {
            id: '2085',
            name: 'Phước Hải',
            prefix: 'Thị trấn',
          },
          {
            id: '2086',
            name: 'Phước Hội',
            prefix: 'Xã',
          },
          {
            id: '2087',
            name: 'Phước Long Thọ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '143',
        name: 'Long Điền',
        wards: [
          {
            id: '2088',
            name: 'An Ngãi',
            prefix: 'Xã',
          },
          {
            id: '2089',
            name: 'An Nhứt',
            prefix: 'Xã',
          },
          {
            id: '2090',
            name: 'Long Điền',
            prefix: 'Xã',
          },
          {
            id: '2091',
            name: 'Long Hải',
            prefix: 'Thị trấn',
          },
          {
            id: '2092',
            name: 'Phước Hưng',
            prefix: 'Xã',
          },
          {
            id: '2093',
            name: 'Phước Tỉnh',
            prefix: 'Xã',
          },
          {
            id: '2094',
            name: 'Tam Phước',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '144',
        name: 'Tân Thành',
        wards: [
          {
            id: '2095',
            name: 'Châu Pha',
            prefix: 'Xã',
          },
          {
            id: '2096',
            name: 'Hắc Dịch',
            prefix: 'Xã',
          },
          {
            id: '2097',
            name: 'Mỹ Xuân',
            prefix: 'Xã',
          },
          {
            id: '2098',
            name: 'Phú Mỹ',
            prefix: 'Xã',
          },
          {
            id: '2099',
            name: 'Phước Hòa',
            prefix: 'Xã',
          },
          {
            id: '2100',
            name: 'Phước Lộc',
            prefix: 'Xã',
          },
          {
            id: '2101',
            name: 'Sông Xoài',
            prefix: 'Xã',
          },
          {
            id: '2102',
            name: 'Tân Hải',
            prefix: 'Xã',
          },
          {
            id: '2103',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
          {
            id: '2104',
            name: 'Tân Phước',
            prefix: 'Phường',
          },
          {
            id: '2105',
            name: 'Tóc Tiên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '145',
        name: 'Vũng Tàu',
        wards: [
          {
            id: '2106',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '2107',
            name: '10',
            prefix: 'Phường',
          },
          {
            id: '2108',
            name: '11',
            prefix: 'Phường',
          },
          {
            id: '2109',
            name: '12',
            prefix: 'Phường',
          },
          {
            id: '2110',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '2111',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '2112',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '2113',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '2114',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '2115',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '2116',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '2117',
            name: '9',
            prefix: 'Phường',
          },
          {
            id: '2118',
            name: 'Long Sơn',
            prefix: 'Xã',
          },
          {
            id: '2119',
            name: 'Nguyễn An Ninh',
            prefix: 'Phường',
          },
          {
            id: '2120',
            name: 'Rạch Dừa',
            prefix: 'Phường',
          },
          {
            id: '2121',
            name: 'Thắng Nhất',
            prefix: 'Phường',
          },
          {
            id: '2122',
            name: 'Thắng Nhì',
            prefix: 'Phường',
          },
          {
            id: '2123',
            name: 'Thắng Tam',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '146',
        name: 'Xuyên Mộc',
        wards: [
          {
            id: '2124',
            name: 'Bàu Lâm',
            prefix: 'Xã',
          },
          {
            id: '2125',
            name: 'Bình Châu',
            prefix: 'Xã',
          },
          {
            id: '2126',
            name: 'Bông Trang',
            prefix: 'Xã',
          },
          {
            id: '2127',
            name: 'Bưng Riềng',
            prefix: 'Xã',
          },
          {
            id: '2128',
            name: 'Hòa Bình',
            prefix: 'Xã',
          },
          {
            id: '2129',
            name: 'Hòa Hiệp',
            prefix: 'Xã',
          },
          {
            id: '2130',
            name: 'Hòa Hội',
            prefix: 'Xã',
          },
          {
            id: '2131',
            name: 'Hòa Hưng ',
            prefix: 'Xã',
          },
          {
            id: '2132',
            name: 'Phước Bửu',
            prefix: 'Xã',
          },
          {
            id: '2133',
            name: 'Phước Tân',
            prefix: 'Xã',
          },
          {
            id: '2134',
            name: 'Phước Thuận',
            prefix: 'Xã',
          },
          {
            id: '2135',
            name: 'Tân Lâm',
            prefix: 'Xã',
          },
          {
            id: '2136',
            name: 'Xuyên Mộc',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '11',
    code: 'DDL',
    name: 'Đắk Lắk',
    districts: [
      {
        id: '147',
        name: 'Buôn Đôn',
        wards: [
          {
            id: '2137',
            name: 'Cuôr Knia',
            prefix: 'Xã',
          },
          {
            id: '2138',
            name: 'Ea Bar',
            prefix: 'Xã',
          },
          {
            id: '2139',
            name: 'Ea Huar',
            prefix: 'Xã',
          },
          {
            id: '2140',
            name: 'Ea Nuôl',
            prefix: 'Xã',
          },
          {
            id: '2141',
            name: 'Ea Wer',
            prefix: 'Xã',
          },
          {
            id: '2142',
            name: 'Krông Na',
            prefix: 'Xã',
          },
          {
            id: '2143',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '148',
        name: 'Buôn Hồ',
        wards: [
          {
            id: '2144',
            name: 'An Bình',
            prefix: 'Phường',
          },
          {
            id: '2145',
            name: 'An Lạc',
            prefix: 'Phường',
          },
          {
            id: '2146',
            name: 'Bình Tân',
            prefix: 'Phường',
          },
          {
            id: '2147',
            name: 'Bình Thuận',
            prefix: 'Xã',
          },
          {
            id: '2148',
            name: 'Cư Bao',
            prefix: 'Xã',
          },
          {
            id: '2149',
            name: 'Đạt Hiếu',
            prefix: 'Phường',
          },
          {
            id: '2150',
            name: 'Đoàn Kết',
            prefix: 'Phường',
          },
          {
            id: '2151',
            name: 'Ea Blang',
            prefix: 'Xã',
          },
          {
            id: '2152',
            name: 'Ea Drông',
            prefix: 'Xã',
          },
          {
            id: '2153',
            name: 'Ea Siên',
            prefix: 'Xã',
          },
          {
            id: '2154',
            name: 'Thiện An',
            prefix: 'Phường',
          },
          {
            id: '2155',
            name: 'Thống Nhất',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '149',
        name: 'Buôn Ma Thuột',
        wards: [
          {
            id: '2156',
            name: 'Cư Ebur',
            prefix: 'Xã',
          },
          {
            id: '2157',
            name: 'Ea Kao',
            prefix: 'Phường',
          },
          {
            id: '2158',
            name: 'Ea Tam',
            prefix: 'Phường',
          },
          {
            id: '2159',
            name: 'Ea Tu',
            prefix: 'Xã',
          },
          {
            id: '2160',
            name: 'Hòa Khánh',
            prefix: 'Xã',
          },
          {
            id: '2161',
            name: 'Hòa Phú',
            prefix: 'Xã',
          },
          {
            id: '2162',
            name: 'Hòa Thắng',
            prefix: 'Xã',
          },
          {
            id: '2163',
            name: 'Hòa Thuận',
            prefix: 'Xã',
          },
          {
            id: '2164',
            name: 'Hòa Xuân',
            prefix: 'Xã',
          },
          {
            id: '2165',
            name: 'Khánh Xuân',
            prefix: 'Phường',
          },
          {
            id: '2166',
            name: 'Tân An',
            prefix: 'Xã',
          },
          {
            id: '2167',
            name: 'Tân Hoà',
            prefix: 'Xã',
          },
          {
            id: '2168',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '2169',
            name: 'Tân Lợi',
            prefix: 'Xã',
          },
          {
            id: '2170',
            name: 'Tân Thành',
            prefix: 'Phường',
          },
          {
            id: '2171',
            name: 'Tân Tiến',
            prefix: 'Phường',
          },
          {
            id: '2172',
            name: 'Thắng Lợi',
            prefix: 'Phường',
          },
          {
            id: '2173',
            name: 'Thành Công',
            prefix: 'Phường',
          },
          {
            id: '2174',
            name: 'Thành Nhất',
            prefix: 'Phường',
          },
          {
            id: '2175',
            name: 'Thống Nhất',
            prefix: 'Phường',
          },
          {
            id: '2176',
            name: 'Tự An',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '150',
        name: 'Cư Kuin',
        wards: [
          {
            id: '2177',
            name: 'Cư Ê Wi',
            prefix: 'Xã',
          },
          {
            id: '2178',
            name: 'Dray Bhăng',
            prefix: 'Xã',
          },
          {
            id: '2179',
            name: 'Ea Bhôk',
            prefix: 'Xã',
          },
          {
            id: '2180',
            name: 'Ea Hu',
            prefix: 'Xã',
          },
          {
            id: '2181',
            name: 'Ea Ktur',
            prefix: 'Xã',
          },
          {
            id: '2182',
            name: 'Ea Ning',
            prefix: 'Xã',
          },
          {
            id: '2183',
            name: 'Ea Tiêu',
            prefix: 'Xã',
          },
          {
            id: '2184',
            name: 'Hòa Hiệp',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '151',
        name: "Cư M'gar",
        wards: [
          {
            id: '2185',
            name: "Cư Dliê M'nông",
            prefix: 'Xã',
          },
          {
            id: '2186',
            name: "Cư M'gar",
            prefix: 'Xã',
          },
          {
            id: '2187',
            name: 'Cư Suê',
            prefix: 'Xã',
          },
          {
            id: '2188',
            name: 'Cuor Đăng',
            prefix: 'Xã',
          },
          {
            id: '2189',
            name: "Ea D'rơng",
            prefix: 'Xã',
          },
          {
            id: '2190',
            name: "Ea H'đing",
            prefix: 'Xã',
          },
          {
            id: '2191',
            name: 'Ea Kiết',
            prefix: 'Xã',
          },
          {
            id: '2192',
            name: 'Ea Kpam',
            prefix: 'Xã',
          },
          {
            id: '2193',
            name: 'Ea Kuếh',
            prefix: 'Xã',
          },
          {
            id: '2194',
            name: "Ea M'dróh",
            prefix: 'Xã',
          },
          {
            id: '2195',
            name: "Ea M'nang",
            prefix: 'Xã',
          },
          {
            id: '2196',
            name: 'Ea Pốk',
            prefix: 'Thị trấn',
          },
          {
            id: '2197',
            name: 'Ea Tar',
            prefix: 'Xã',
          },
          {
            id: '2198',
            name: 'Ea Tul',
            prefix: 'Xã',
          },
          {
            id: '2199',
            name: 'Quảng Hiệp',
            prefix: 'Xã',
          },
          {
            id: '2200',
            name: 'Quảng Phú',
            prefix: 'Thị trấn',
          },
          {
            id: '2201',
            name: 'Quảng Tiến',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '152',
        name: "Ea H'Leo",
        wards: [
          {
            id: '2202',
            name: 'Cư A Mung',
            prefix: 'Xã',
          },
          {
            id: '2203',
            name: 'Cư Mốt',
            prefix: 'Xã',
          },
          {
            id: '2204',
            name: 'Dlê Yang',
            prefix: 'Xã',
          },
          {
            id: '2205',
            name: 'Ea Drăng',
            prefix: 'Thị trấn',
          },
          {
            id: '2207',
            name: "Ea H'leo",
            prefix: 'Xã',
          },
          {
            id: '2206',
            name: 'Ea Hiao',
            prefix: 'Xã',
          },
          {
            id: '2208',
            name: 'Ea Khăl',
            prefix: 'Xã',
          },
          {
            id: '2209',
            name: 'Ea Nam',
            prefix: 'Xã',
          },
          {
            id: '2210',
            name: 'Ea Ral',
            prefix: 'Xã',
          },
          {
            id: '2211',
            name: 'Ea Sol',
            prefix: 'Xã',
          },
          {
            id: '2212',
            name: 'Ea Tir',
            prefix: 'Xã',
          },
          {
            id: '2213',
            name: 'Ea Wy',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '153',
        name: 'Ea Kar',
        wards: [
          {
            id: '2214',
            name: 'Cư Bông',
            prefix: 'Xã',
          },
          {
            id: '2215',
            name: 'Cư Elang',
            prefix: 'Xã',
          },
          {
            id: '2216',
            name: 'Cư Huê',
            prefix: 'Xã',
          },
          {
            id: '2217',
            name: 'Cư Ni',
            prefix: 'Xã',
          },
          {
            id: '2218',
            name: 'Cư Prông',
            prefix: 'Xã',
          },
          {
            id: '2219',
            name: 'Cư Yang',
            prefix: 'Xã',
          },
          {
            id: '2220',
            name: 'Ea Đar',
            prefix: 'Xã',
          },
          {
            id: '2221',
            name: 'Ea Kar',
            prefix: 'Thị trấn',
          },
          {
            id: '2222',
            name: 'Ea Kmút',
            prefix: 'Xã',
          },
          {
            id: '2223',
            name: 'Ea Knốp',
            prefix: 'Thị trấn',
          },
          {
            id: '2224',
            name: 'Ea Ô',
            prefix: 'Xã',
          },
          {
            id: '2225',
            name: 'Ea Păl',
            prefix: 'Xã',
          },
          {
            id: '2226',
            name: 'Ea Sar',
            prefix: 'Xã',
          },
          {
            id: '2227',
            name: 'Ea Sô',
            prefix: 'Xã',
          },
          {
            id: '2228',
            name: 'Ea Tíh',
            prefix: 'Xã',
          },
          {
            id: '2229',
            name: 'Xuân Phú',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '154',
        name: 'Ea Súp',
        wards: [
          {
            id: '2230',
            name: 'Cư Kbang',
            prefix: 'Xã',
          },
          {
            id: '2231',
            name: "Cư M'lan",
            prefix: 'Xã',
          },
          {
            id: '2232',
            name: 'Ea Bung',
            prefix: 'Xã',
          },
          {
            id: '2233',
            name: 'Ea Lê',
            prefix: 'Xã',
          },
          {
            id: '2234',
            name: 'Ea Rốk',
            prefix: 'Xã',
          },
          {
            id: '2235',
            name: 'Ea Súp',
            prefix: 'Thị trấn',
          },
          {
            id: '2236',
            name: 'Ia Jlơi',
            prefix: 'Xã',
          },
          {
            id: '2237',
            name: 'Ia Lốp',
            prefix: 'Xã',
          },
          {
            id: '2238',
            name: 'Ia Rvê',
            prefix: 'Xã',
          },
          {
            id: '2239',
            name: 'Ya Tờ Mốt',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '155',
        name: 'Krông Ana',
        wards: [
          {
            id: '2240',
            name: 'Băng A Drênh',
            prefix: 'Xã',
          },
          {
            id: '2241',
            name: 'Bình Hòa',
            prefix: 'Xã',
          },
          {
            id: '2242',
            name: 'Buôn Trấp',
            prefix: 'Thị trấn',
          },
          {
            id: '2243',
            name: 'Dray Sáp',
            prefix: 'Xã',
          },
          {
            id: '2244',
            name: 'Dur Kmăl',
            prefix: 'Xã',
          },
          {
            id: '2245',
            name: 'Ea Bông',
            prefix: 'Xã',
          },
          {
            id: '2246',
            name: 'Ea Na',
            prefix: 'Xã',
          },
          {
            id: '2247',
            name: 'Quảng Điền',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '156',
        name: 'Krông Bông',
        wards: [
          {
            id: '2248',
            name: 'Cư Drăm',
            prefix: 'Xã',
          },
          {
            id: '2249',
            name: 'Cư Kty',
            prefix: 'Xã',
          },
          {
            id: '2250',
            name: 'Cư Pui',
            prefix: 'Xã',
          },
          {
            id: '2251',
            name: 'Dang Kang',
            prefix: 'Xã',
          },
          {
            id: '2252',
            name: 'Ea Trul',
            prefix: 'Xã',
          },
          {
            id: '2253',
            name: 'Hòa Lễ',
            prefix: 'Xã',
          },
          {
            id: '2254',
            name: 'Hòa Phong',
            prefix: 'Xã',
          },
          {
            id: '2255',
            name: 'Hòa Sơn',
            prefix: 'Xã',
          },
          {
            id: '2256',
            name: 'Hòa Tân',
            prefix: 'Xã',
          },
          {
            id: '2257',
            name: 'Hòa Thành',
            prefix: 'Xã',
          },
          {
            id: '2258',
            name: 'Khuê Ngọc Điền',
            prefix: 'Xã',
          },
          {
            id: '2259',
            name: 'Krông Kmar',
            prefix: 'Thị trấn',
          },
          {
            id: '2260',
            name: 'Yang Mao',
            prefix: 'Xã',
          },
          {
            id: '2261',
            name: 'Yang Reh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '157',
        name: 'Krông Buk',
        wards: [
          {
            id: '2262',
            name: 'Chứ Kbô',
            prefix: 'Xã',
          },
          {
            id: '2263',
            name: 'Cư Né',
            prefix: 'Xã',
          },
          {
            id: '2264',
            name: 'Cư Pơng',
            prefix: 'Xã',
          },
          {
            id: '2265',
            name: 'Ea Ngai',
            prefix: 'Xã',
          },
          {
            id: '2266',
            name: 'Ea Sin',
            prefix: 'Xã',
          },
          {
            id: '2267',
            name: 'Ea Sin',
            prefix: 'Xã',
          },
          {
            id: '2268',
            name: 'Pơng Drang',
            prefix: 'Xã',
          },
          {
            id: '2269',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '158',
        name: 'Krông Năng',
        wards: [
          {
            id: '2270',
            name: 'Cư Klông',
            prefix: 'Xã',
          },
          {
            id: '2271',
            name: 'Dliê Ya',
            prefix: 'Xã',
          },
          {
            id: '2272',
            name: 'Ea Dăh',
            prefix: 'Xã',
          },
          {
            id: '2273',
            name: 'Ea Hồ',
            prefix: 'Xã',
          },
          {
            id: '2274',
            name: 'Ea Púk',
            prefix: 'Xã',
          },
          {
            id: '2275',
            name: 'Ea Tam',
            prefix: 'Xã',
          },
          {
            id: '2276',
            name: 'Ea Tân',
            prefix: 'Xã',
          },
          {
            id: '2277',
            name: 'Ea Tóh',
            prefix: 'Xã',
          },
          {
            id: '2278',
            name: 'Krông Năng',
            prefix: 'Thị trấn',
          },
          {
            id: '2279',
            name: 'Phú Lộc',
            prefix: 'Xã',
          },
          {
            id: '2280',
            name: 'Phú Xuân',
            prefix: 'Xã',
          },
          {
            id: '2281',
            name: 'Tam Giang',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '159',
        name: 'Krông Pắc',
        wards: [
          {
            id: '2282',
            name: 'Ea Hiu',
            prefix: 'Xã',
          },
          {
            id: '2283',
            name: 'Ea Kênh',
            prefix: 'Xã',
          },
          {
            id: '2284',
            name: 'Ea Kly',
            prefix: 'Xã',
          },
          {
            id: '2285',
            name: 'Ea Knuec',
            prefix: 'Xã',
          },
          {
            id: '2286',
            name: 'Ea Kuăng',
            prefix: 'Xã',
          },
          {
            id: '2287',
            name: 'Ea Phê',
            prefix: 'Xã',
          },
          {
            id: '2288',
            name: 'Ea Uy',
            prefix: 'Xã',
          },
          {
            id: '2289',
            name: 'Ea Yiêng',
            prefix: 'Xã',
          },
          {
            id: '2290',
            name: 'Ea Yông',
            prefix: 'Xã',
          },
          {
            id: '2291',
            name: 'Hòa An',
            prefix: 'Xã',
          },
          {
            id: '2292',
            name: 'Hoà Đông',
            prefix: 'Xã',
          },
          {
            id: '2293',
            name: 'Hòa Tiến',
            prefix: 'Xã',
          },
          {
            id: '2294',
            name: 'Krông Búk',
            prefix: 'Xã',
          },
          {
            id: '2295',
            name: 'Phước An',
            prefix: 'Thị trấn',
          },
          {
            id: '2296',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '2297',
            name: 'Vụ Bổn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '160',
        name: 'Lăk',
        wards: [
          {
            id: '2298',
            name: 'Bông Krang',
            prefix: 'Xã',
          },
          {
            id: '2299',
            name: 'Buôn Tría',
            prefix: 'Xã',
          },
          {
            id: '2300',
            name: 'Buôn Triết',
            prefix: 'Xã',
          },
          {
            id: '2301',
            name: 'Đắk Liêng',
            prefix: 'Xã',
          },
          {
            id: '2302',
            name: 'Đắk Nuê',
            prefix: 'Xã',
          },
          {
            id: '2303',
            name: 'Đắk Phơi',
            prefix: 'Xã',
          },
          {
            id: '2304',
            name: "Ea R'bin",
            prefix: 'Xã',
          },
          {
            id: '2305',
            name: 'Krông Nô',
            prefix: 'Xã',
          },
          {
            id: '2306',
            name: 'Liên Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '2307',
            name: 'Nam Ka',
            prefix: 'Xã',
          },
          {
            id: '2308',
            name: 'Yang Tao',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '161',
        name: "M'Đrăk",
        wards: [
          {
            id: '2309',
            name: 'Cư Króa',
            prefix: 'Xã',
          },
          {
            id: '2310',
            name: "Cư M'ta",
            prefix: 'Xã',
          },
          {
            id: '2311',
            name: 'Cư Prao',
            prefix: 'Xã',
          },
          {
            id: '2312',
            name: 'Cư San',
            prefix: 'Xã',
          },
          {
            id: '2313',
            name: "Ea H'mlay",
            prefix: 'Xã',
          },
          {
            id: '2314',
            name: 'Ea Lai',
            prefix: 'Xã',
          },
          {
            id: '2315',
            name: "Ea M' Doal",
            prefix: 'Xã',
          },
          {
            id: '2316',
            name: 'Ea Pil',
            prefix: 'Xã',
          },
          {
            id: '2317',
            name: 'Ea Riêng',
            prefix: 'Xã',
          },
          {
            id: '2318',
            name: 'Ea Trang',
            prefix: 'Xã',
          },
          {
            id: '2319',
            name: 'Krông Á',
            prefix: 'Xã',
          },
          {
            id: '2320',
            name: 'Krông Jing',
            prefix: 'Xã',
          },
          {
            id: '2321',
            name: "M'Drắk",
            prefix: 'Thị trấn',
          },
        ],
      },
    ],
  },
  {
    id: '12',
    code: 'CT',
    name: 'Cần Thơ',
    districts: [
      {
        id: '162',
        name: ' Thới Lai',
        wards: [
          {
            id: '2322',
            name: 'Định Môn',
            prefix: 'Xã',
          },
          {
            id: '2323',
            name: 'Đông Bình',
            prefix: 'Xã',
          },
          {
            id: '2324',
            name: 'Đông Thuận',
            prefix: 'Xã',
          },
          {
            id: '2325',
            name: 'Tân Thạnh',
            prefix: 'Xã',
          },
          {
            id: '2326',
            name: 'Thới Lai',
            prefix: 'Thị trấn',
          },
          {
            id: '2327',
            name: 'Thới Tân',
            prefix: 'Xã',
          },
          {
            id: '2328',
            name: 'Thới Thạnh',
            prefix: 'Xã',
          },
          {
            id: '2329',
            name: 'Trường Thắng',
            prefix: 'Xã',
          },
          {
            id: '2330',
            name: 'Trường Thành',
            prefix: 'Xã',
          },
          {
            id: '2331',
            name: 'Trường Xuân',
            prefix: 'Xã',
          },
          {
            id: '2332',
            name: 'Trường Xuân A',
            prefix: 'Xã',
          },
          {
            id: '2333',
            name: 'Trường Xuân B',
            prefix: 'Xã',
          },
          {
            id: '2334',
            name: 'Xuân Thắng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '163',
        name: 'Bình Thủy',
        wards: [
          {
            id: '2335',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '2336',
            name: 'An Thới',
            prefix: 'Phường',
          },
          {
            id: '2337',
            name: 'An Thới',
            prefix: 'Phường',
          },
          {
            id: '2338',
            name: 'Bình Thủy',
            prefix: 'Phường',
          },
          {
            id: '2339',
            name: 'Bùi Hữu Nghĩa',
            prefix: 'Phường',
          },
          {
            id: '2340',
            name: 'Long Hòa',
            prefix: 'Phường',
          },
          {
            id: '2341',
            name: 'Long Tuyền',
            prefix: 'Phường',
          },
          {
            id: '2342',
            name: 'Thới An Đông',
            prefix: 'Phường',
          },
          {
            id: '2343',
            name: 'Trà An',
            prefix: 'Phường',
          },
          {
            id: '2344',
            name: 'Trà Nóc',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '164',
        name: 'Cái Răng',
        wards: [
          {
            id: '2345',
            name: 'Ba Láng',
            prefix: 'Phường',
          },
          {
            id: '2346',
            name: 'Hưng Phú',
            prefix: 'Phường',
          },
          {
            id: '2347',
            name: 'Hưng Thạnh',
            prefix: 'Phường',
          },
          {
            id: '2348',
            name: 'Lê Bình',
            prefix: 'Phường',
          },
          {
            id: '2349',
            name: 'Phú Thứ',
            prefix: 'Phường',
          },
          {
            id: '2350',
            name: 'Tân Phú',
            prefix: 'Phường',
          },
          {
            id: '2351',
            name: 'Thường Thạnh',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '165',
        name: 'Cờ Đỏ',
        wards: [
          {
            id: '2352',
            name: 'Cờ Đỏ',
            prefix: 'Thị trấn',
          },
          {
            id: '2353',
            name: 'Đông Hiệp',
            prefix: 'Xã',
          },
          {
            id: '2354',
            name: 'Đông Thắng',
            prefix: 'Xã',
          },
          {
            id: '2355',
            name: 'Thạnh Phú',
            prefix: 'Xã',
          },
          {
            id: '2356',
            name: 'Thới Đông',
            prefix: 'Xã',
          },
          {
            id: '2357',
            name: 'Thới Hưng',
            prefix: 'Xã',
          },
          {
            id: '2358',
            name: 'Thới Xuân',
            prefix: 'Xã',
          },
          {
            id: '2359',
            name: 'Trung An',
            prefix: 'Xã',
          },
          {
            id: '2360',
            name: 'Trung Hưng',
            prefix: 'Xã',
          },
          {
            id: '2361',
            name: 'Trung Thạnh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '166',
        name: 'Ninh Kiều',
        wards: [
          {
            id: '2362',
            name: 'An Bình',
            prefix: 'Phường',
          },
          {
            id: '2363',
            name: 'An Cư',
            prefix: 'Phường',
          },
          {
            id: '2364',
            name: 'An Hòa',
            prefix: 'Phường',
          },
          {
            id: '2365',
            name: 'An Hội',
            prefix: 'Phường',
          },
          {
            id: '2366',
            name: 'An Khánh',
            prefix: 'Phường',
          },
          {
            id: '2367',
            name: 'An Lạc',
            prefix: 'Phường',
          },
          {
            id: '2368',
            name: 'An Nghiệp',
            prefix: 'Phường',
          },
          {
            id: '2369',
            name: 'An Phú',
            prefix: 'Phường',
          },
          {
            id: '2370',
            name: 'An Thạnh',
            prefix: 'Phường',
          },
          {
            id: '2371',
            name: 'Cái Khế',
            prefix: 'Phường',
          },
          {
            id: '2372',
            name: 'Hưng Lợi',
            prefix: 'Phường',
          },
          {
            id: '2373',
            name: 'Tân An',
            prefix: 'Phường',
          },
          {
            id: '2374',
            name: 'Thới Bình',
            prefix: 'Phường',
          },
          {
            id: '2375',
            name: 'Xuân Khánh',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '167',
        name: 'Ô Môn',
        wards: [
          {
            id: '2376',
            name: 'Châu Văn Liêm',
            prefix: 'Phường',
          },
          {
            id: '2377',
            name: 'Long Hưng',
            prefix: 'Phường',
          },
          {
            id: '2378',
            name: 'Phước Thới',
            prefix: 'Phường',
          },
          {
            id: '2379',
            name: 'Thới An',
            prefix: 'Phường',
          },
          {
            id: '2380',
            name: 'Thới Hòa',
            prefix: 'Phường',
          },
          {
            id: '2381',
            name: 'Thới Long',
            prefix: 'Phường',
          },
          {
            id: '2382',
            name: 'Trường Lạc',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '168',
        name: 'Phong Điền',
        wards: [
          {
            id: '2383',
            name: 'Giai Xuân',
            prefix: 'Xã',
          },
          {
            id: '2384',
            name: 'Mỹ Khánh',
            prefix: 'Xã',
          },
          {
            id: '2385',
            name: 'Nhơn Ái',
            prefix: 'Xã',
          },
          {
            id: '2386',
            name: 'Nhơn Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '2387',
            name: 'Phong Điền',
            prefix: 'Thị trấn',
          },
          {
            id: '2388',
            name: 'Tân Thới',
            prefix: 'Xã',
          },
          {
            id: '2389',
            name: 'Trường Long',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '169',
        name: 'Thốt Nốt',
        wards: [
          {
            id: '2390',
            name: 'Tân Hưng',
            prefix: 'Phường',
          },
          {
            id: '2391',
            name: 'Tân Lộc',
            prefix: 'Phường',
          },
          {
            id: '2392',
            name: 'Thạnh Hòa',
            prefix: 'Phường',
          },
          {
            id: '2393',
            name: 'Thạnh Lộc',
            prefix: 'Xã',
          },
          {
            id: '2394',
            name: 'Thới Thuận',
            prefix: 'Phường',
          },
          {
            id: '2395',
            name: 'Thốt Nốt',
            prefix: 'Phường',
          },
          {
            id: '2396',
            name: 'Thuận An',
            prefix: 'Phường',
          },
          {
            id: '2397',
            name: 'Thuận Hưng',
            prefix: 'Phường',
          },
          {
            id: '2398',
            name: 'Trung Kiên',
            prefix: 'Phường',
          },
          {
            id: '2399',
            name: 'Trung Nhứt',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '170',
        name: 'Vĩnh Thạnh',
        wards: [
          {
            id: '2400',
            name: 'Thạnh An',
            prefix: 'Thị trấn',
          },
          {
            id: '2401',
            name: 'Thạnh An',
            prefix: 'Xã',
          },
          {
            id: '2402',
            name: 'Thạnh Lộc',
            prefix: 'Xã',
          },
          {
            id: '2403',
            name: 'Thạnh Lợi',
            prefix: 'Xã',
          },
          {
            id: '2404',
            name: 'Thạnh Mỹ',
            prefix: 'Xã',
          },
          {
            id: '2405',
            name: 'Thạnh Quới',
            prefix: 'Xã',
          },
          {
            id: '2406',
            name: 'Thạnh Thắng',
            prefix: 'Xã',
          },
          {
            id: '2407',
            name: 'Thạnh Tiến',
            prefix: 'Xã',
          },
          {
            id: '2408',
            name: 'Vĩnh Bình',
            prefix: 'Xã',
          },
          {
            id: '2409',
            name: 'Vĩnh Thạnh',
            prefix: 'Thị trấn',
          },
          {
            id: '2410',
            name: 'Vĩnh Trinh',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '13',
    code: 'BTH',
    name: 'Bình Thuận  ',
    districts: [
      {
        id: '171',
        name: 'Bắc Bình',
        wards: [
          {
            id: '2411',
            name: 'Bình An',
            prefix: 'Xã',
          },
          {
            id: '2412',
            name: 'Bình Tân',
            prefix: 'Xã',
          },
          {
            id: '2413',
            name: 'Chợ Lầu',
            prefix: 'Thị trấn',
          },
          {
            id: '2414',
            name: 'Hải Ninh',
            prefix: 'Xã',
          },
          {
            id: '2415',
            name: 'Hoà Thắng',
            prefix: 'Xã',
          },
          {
            id: '2416',
            name: 'Hồng Phong',
            prefix: 'Xã',
          },
          {
            id: '2417',
            name: 'Hồng Thái',
            prefix: 'Xã',
          },
          {
            id: '2418',
            name: 'Lương Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '2419',
            name: 'Phan Điền',
            prefix: 'Xã',
          },
          {
            id: '2420',
            name: 'Phan Hiệp',
            prefix: 'Xã',
          },
          {
            id: '2421',
            name: 'Phan Hoà',
            prefix: 'Xã',
          },
          {
            id: '2422',
            name: 'Phan Lâm',
            prefix: 'Xã',
          },
          {
            id: '2423',
            name: 'Phan Rí Thành',
            prefix: 'Xã',
          },
          {
            id: '2424',
            name: 'Phan Sơn',
            prefix: 'Xã',
          },
          {
            id: '2425',
            name: 'Phan Thanh',
            prefix: 'Xã',
          },
          {
            id: '2426',
            name: 'Phan Tiến',
            prefix: 'Xã',
          },
          {
            id: '2427',
            name: 'Sông Bình',
            prefix: 'Xã',
          },
          {
            id: '2428',
            name: 'Sông Lũy',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '172',
        name: 'Đảo Phú Quý',
        wards: [
          {
            id: '2429',
            name: 'Long Hải',
            prefix: 'Xã',
          },
          {
            id: '2430',
            name: 'Ngũ Phụng',
            prefix: 'Xã',
          },
          {
            id: '2431',
            name: 'Tam Thanh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '173',
        name: 'Đức Linh',
        wards: [
          {
            id: '2432',
            name: 'Đa Kai',
            prefix: 'Xã',
          },
          {
            id: '2433',
            name: 'Đông Hà',
            prefix: 'Xã',
          },
          {
            id: '2434',
            name: 'Đức Chính',
            prefix: 'Xã',
          },
          {
            id: '2435',
            name: 'Đức Hạnh',
            prefix: 'Xã',
          },
          {
            id: '2436',
            name: 'Đức Tài',
            prefix: 'Thị trấn',
          },
          {
            id: '2437',
            name: 'Đức Tín',
            prefix: 'Xã',
          },
          {
            id: '2438',
            name: 'Mê Pu',
            prefix: 'Xã',
          },
          {
            id: '2439',
            name: 'Nam Chính',
            prefix: 'Xã',
          },
          {
            id: '2440',
            name: 'Sùng Nhơn',
            prefix: 'Xã',
          },
          {
            id: '2441',
            name: 'Tân Hà',
            prefix: 'Xã',
          },
          {
            id: '2442',
            name: 'Trà Tân',
            prefix: 'Xã',
          },
          {
            id: '2443',
            name: 'Võ Xu',
            prefix: 'Thị trấn',
          },
          {
            id: '2444',
            name: 'Vũ Hòa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '174',
        name: 'Hàm Tân',
        wards: [
          {
            id: '2445',
            name: 'Sơn Mỹ',
            prefix: 'Xã',
          },
          {
            id: '2446',
            name: 'Sông Phan',
            prefix: 'Xã',
          },
          {
            id: '2447',
            name: 'Tân Đức',
            prefix: 'Xã',
          },
          {
            id: '2448',
            name: 'Tân Hà',
            prefix: 'Xã',
          },
          {
            id: '2449',
            name: 'Tân Minh',
            prefix: 'Thị trấn',
          },
          {
            id: '2450',
            name: 'Tân Nghĩa',
            prefix: 'Thị trấn',
          },
          {
            id: '2451',
            name: 'Tân Phúc',
            prefix: 'Xã',
          },
          {
            id: '2452',
            name: 'Tân Thắng',
            prefix: 'Xã',
          },
          {
            id: '2453',
            name: 'Tân Xuân',
            prefix: 'Xã',
          },
          {
            id: '2454',
            name: 'Thắng Hải',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '175',
        name: 'Hàm Thuận Bắc',
        wards: [
          {
            id: '2455',
            name: 'Đa Mi',
            prefix: 'Xã',
          },
          {
            id: '2456',
            name: 'Đông Giang',
            prefix: 'Xã',
          },
          {
            id: '2457',
            name: 'Đông Tiến',
            prefix: 'Xã',
          },
          {
            id: '2458',
            name: 'Hàm Chính',
            prefix: 'Xã',
          },
          {
            id: '2459',
            name: 'Hàm Đức',
            prefix: 'Xã',
          },
          {
            id: '2460',
            name: 'Hàm Hiệp',
            prefix: 'Xã',
          },
          {
            id: '2461',
            name: 'Hàm Liêm',
            prefix: 'Xã',
          },
          {
            id: '2462',
            name: 'Hàm Phú',
            prefix: 'Xã',
          },
          {
            id: '2463',
            name: 'Hàm Thắng',
            prefix: 'Xã',
          },
          {
            id: '2464',
            name: 'Hàm Trí',
            prefix: 'Xã',
          },
          {
            id: '2465',
            name: 'Hồng Liêm',
            prefix: 'Xã',
          },
          {
            id: '2466',
            name: 'Hồng Sơn',
            prefix: 'Xã',
          },
          {
            id: '2467',
            name: 'La Dạ',
            prefix: 'Xã',
          },
          {
            id: '2468',
            name: 'Ma Lâm',
            prefix: 'Thị trấn',
          },
          {
            id: '2469',
            name: 'Mỹ Thạnh',
            prefix: 'Xã',
          },
          {
            id: '2470',
            name: 'Phú Long',
            prefix: 'Thị trấn',
          },
          {
            id: '2471',
            name: 'Thuận Hòa',
            prefix: 'Xã',
          },
          {
            id: '2472',
            name: 'Thuận Minh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '176',
        name: 'Hàm Thuận Nam',
        wards: [
          {
            id: '2473',
            name: 'Hàm Cần',
            prefix: 'Xã',
          },
          {
            id: '2474',
            name: 'Hàm Cường',
            prefix: 'Xã',
          },
          {
            id: '2475',
            name: 'Hàm Kiệm',
            prefix: 'Xã',
          },
          {
            id: '2476',
            name: 'Hàm Minh',
            prefix: 'Xã',
          },
          {
            id: '2477',
            name: 'Hàm Mỹ',
            prefix: 'Xã',
          },
          {
            id: '2478',
            name: 'Hàm Thạnh',
            prefix: 'Xã',
          },
          {
            id: '2479',
            name: 'Mương Mán',
            prefix: 'Xã',
          },
          {
            id: '2480',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '2481',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '2482',
            name: 'Tân Thuận',
            prefix: 'Xã',
          },
          {
            id: '2483',
            name: 'Thuận Nam',
            prefix: 'Thị trấn',
          },
          {
            id: '2484',
            name: 'Thuận Quý',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '177',
        name: 'La Gi',
        wards: [
          {
            id: '2485',
            name: 'Bình Tân',
            prefix: 'Phường',
          },
          {
            id: '2486',
            name: 'Phước Hội',
            prefix: 'Phường',
          },
          {
            id: '2487',
            name: 'Phước Lộc',
            prefix: 'Phường',
          },
          {
            id: '2488',
            name: 'Tân An',
            prefix: 'Phường',
          },
          {
            id: '2489',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '2490',
            name: 'Tân Hải',
            prefix: 'Xã',
          },
          {
            id: '2491',
            name: 'Tân Phước',
            prefix: 'Xã',
          },
          {
            id: '2492',
            name: 'Tân Thiện',
            prefix: 'Phường',
          },
          {
            id: '2493',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '178',
        name: 'Phan Thiết',
        wards: [
          {
            id: '2494',
            name: 'Bình Hưng',
            prefix: 'Phường',
          },
          {
            id: '2495',
            name: 'Đức Long',
            prefix: 'Phường',
          },
          {
            id: '2496',
            name: 'Đức Nghĩa',
            prefix: 'Phường',
          },
          {
            id: '2497',
            name: 'Đức Thắng',
            prefix: 'Phường',
          },
          {
            id: '2498',
            name: 'Hàm Tiến',
            prefix: 'Phường',
          },
          {
            id: '2499',
            name: 'Hưng Long',
            prefix: 'Phường',
          },
          {
            id: '2500',
            name: 'Lạc Đạo',
            prefix: 'Phường',
          },
          {
            id: '2501',
            name: 'Mũi Né',
            prefix: 'Phường',
          },
          {
            id: '2502',
            name: 'Phong Nẫm',
            prefix: 'Xã',
          },
          {
            id: '2503',
            name: 'Phong Nẫm',
            prefix: 'Xã',
          },
          {
            id: '2504',
            name: 'Phú Hài',
            prefix: 'Phường',
          },
          {
            id: '2505',
            name: 'Phú Tài',
            prefix: 'Phường',
          },
          {
            id: '2506',
            name: 'Phú Thủy',
            prefix: 'Phường',
          },
          {
            id: '2507',
            name: 'Phú Trinh',
            prefix: 'Phường',
          },
          {
            id: '2508',
            name: 'Thanh Hải',
            prefix: 'Phường',
          },
          {
            id: '2509',
            name: 'Thiện Nghiệp',
            prefix: 'Xã',
          },
          {
            id: '2510',
            name: 'Tiến Lợi',
            prefix: 'Xã',
          },
          {
            id: '2511',
            name: 'Tiến Thành',
            prefix: 'Xã',
          },
          {
            id: '2512',
            name: 'Xuân An',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '179',
        name: 'Tánh Linh',
        wards: [
          {
            id: '2513',
            name: 'Bắc Ruộng',
            prefix: 'Xã',
          },
          {
            id: '2514',
            name: 'Đồng Kho',
            prefix: 'Xã',
          },
          {
            id: '2515',
            name: 'Đức Bình',
            prefix: 'Xã',
          },
          {
            id: '2516',
            name: 'Đức Phú',
            prefix: 'Xã',
          },
          {
            id: '2517',
            name: 'Đức Tân',
            prefix: 'Xã',
          },
          {
            id: '2518',
            name: 'Đức Thuận',
            prefix: 'Xã',
          },
          {
            id: '2519',
            name: 'Gia An',
            prefix: 'Xã',
          },
          {
            id: '2520',
            name: 'Gia Huynh',
            prefix: 'Xã',
          },
          {
            id: '2521',
            name: 'Huy Khiêm',
            prefix: 'Xã',
          },
          {
            id: '2522',
            name: 'La Ngâu',
            prefix: 'Xã',
          },
          {
            id: '2523',
            name: 'Lạc Tánh',
            prefix: 'Thị trấn',
          },
          {
            id: '2524',
            name: 'Măng Tố',
            prefix: 'Xã',
          },
          {
            id: '2525',
            name: 'Nghị Đức',
            prefix: 'Xã',
          },
          {
            id: '2526',
            name: 'Suối Kiết',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '180',
        name: 'Tuy Phong',
        wards: [
          {
            id: '2527',
            name: 'Bình Thạnh',
            prefix: 'Xã',
          },
          {
            id: '2528',
            name: 'Chí Công',
            prefix: 'Xã',
          },
          {
            id: '2529',
            name: 'Hoà Minh',
            prefix: 'Xã',
          },
          {
            id: '2530',
            name: 'Hoà Phú',
            prefix: 'Xã',
          },
          {
            id: '2531',
            name: 'Liên Hương',
            prefix: 'Thị trấn',
          },
          {
            id: '2532',
            name: 'Phan Dũng',
            prefix: 'Xã',
          },
          {
            id: '2533',
            name: 'Phan Rí Cửa',
            prefix: 'Thị trấn',
          },
          {
            id: '2534',
            name: 'Phong Phú',
            prefix: 'Xã',
          },
          {
            id: '2535',
            name: 'Phú Lạc',
            prefix: 'Xã',
          },
          {
            id: '2536',
            name: 'Phước Thể',
            prefix: 'Xã',
          },
          {
            id: '2537',
            name: 'Vĩnh Hảo',
            prefix: 'Xã',
          },
          {
            id: '2538',
            name: 'Vĩnh Tân',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '14',
    code: 'LDD',
    name: 'Lâm Đồng',
    districts: [
      {
        id: '181',
        name: 'Bảo Lâm',
        wards: [
          {
            id: '2539',
            name: "B'Lá",
            prefix: 'Xã',
          },
          {
            id: '2540',
            name: 'Lộc An',
            prefix: 'Xã',
          },
          {
            id: '2541',
            name: 'Lộc Bắc',
            prefix: 'Xã',
          },
          {
            id: '2542',
            name: 'Lộc Bảo',
            prefix: 'Xã',
          },
          {
            id: '2543',
            name: 'Lộc Đức',
            prefix: 'Xã',
          },
          {
            id: '2544',
            name: 'Lộc Lâm',
            prefix: 'Xã',
          },
          {
            id: '2545',
            name: 'Lộc Nam',
            prefix: 'Xã',
          },
          {
            id: '2546',
            name: 'Lộc Ngãi',
            prefix: 'Xã',
          },
          {
            id: '2547',
            name: 'Lộc Phú',
            prefix: 'Xã',
          },
          {
            id: '2548',
            name: 'Lộc Quảng',
            prefix: 'Xã',
          },
          {
            id: '2549',
            name: 'Lộc Tân',
            prefix: 'Xã',
          },
          {
            id: '2550',
            name: 'Lộc Thắng',
            prefix: 'Thị trấn',
          },
          {
            id: '2551',
            name: 'Lộc Thành',
            prefix: 'Xã',
          },
          {
            id: '2552',
            name: 'Tân Hương',
            prefix: 'Xã',
          },
          {
            id: '2553',
            name: 'Tân Lạc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '182',
        name: 'Bảo Lộc',
        wards: [
          {
            id: '2554',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '2555',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '2556',
            name: "B'Lao",
            prefix: 'Phường',
          },
          {
            id: '2557',
            name: 'Đại Lào',
            prefix: 'Xã',
          },
          {
            id: '2558',
            name: 'Đam Bri',
            prefix: 'Xã',
          },
          {
            id: '2559',
            name: 'Lộc Châu',
            prefix: 'Xã',
          },
          {
            id: '2560',
            name: 'Lộc Nga',
            prefix: 'Xã',
          },
          {
            id: '2561',
            name: 'Lộc Phát',
            prefix: 'Phường',
          },
          {
            id: '2562',
            name: 'Lộc Sơn',
            prefix: 'Phường',
          },
          {
            id: '2563',
            name: 'Lộc Thanh',
            prefix: 'Xã',
          },
          {
            id: '2564',
            name: 'Lộc Tiến',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '183',
        name: 'Cát Tiên',
        wards: [
          {
            id: '2565',
            name: 'Đồng Nai',
            prefix: 'Thị trấn',
          },
          {
            id: '2566',
            name: 'Đồng Nai Thượng',
            prefix: 'Xã',
          },
          {
            id: '2567',
            name: 'Đức Phổ',
            prefix: 'Xã',
          },
          {
            id: '2568',
            name: 'Gia Viễn',
            prefix: 'Xã',
          },
          {
            id: '2569',
            name: 'Mỹ Lâm',
            prefix: 'Xã',
          },
          {
            id: '2570',
            name: 'Nam Ninh',
            prefix: 'Xã',
          },
          {
            id: '2571',
            name: 'Phù Mỹ',
            prefix: 'Xã',
          },
          {
            id: '2572',
            name: 'Phước Cát 1',
            prefix: 'Xã',
          },
          {
            id: '2573',
            name: 'Phước Cát 2',
            prefix: 'Xã',
          },
          {
            id: '2574',
            name: 'Quảng Ngãi',
            prefix: 'Xã',
          },
          {
            id: '2575',
            name: 'Tiên Hoàng',
            prefix: 'Xã',
          },
          {
            id: '2576',
            name: 'Tư Nghĩa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '188',
        name: 'Di Linh',
        wards: [
          {
            id: '2622',
            name: 'Bảo Thuận',
            prefix: 'Xã',
          },
          {
            id: '2623',
            name: 'Di Linh',
            prefix: 'Thị trấn',
          },
          {
            id: '2624',
            name: 'Đinh Lạc',
            prefix: 'Xã',
          },
          {
            id: '2625',
            name: 'Đinh Trang Hoà',
            prefix: 'Xã',
          },
          {
            id: '2626',
            name: 'Đinh Trang Thượng',
            prefix: 'Xã',
          },
          {
            id: '2627',
            name: 'Gia Bắc',
            prefix: 'Xã',
          },
          {
            id: '2628',
            name: 'Gia Hiệp',
            prefix: 'Xã',
          },
          {
            id: '2629',
            name: 'Gung Ré',
            prefix: 'Xã',
          },
          {
            id: '2630',
            name: 'Hoà Bắc',
            prefix: 'Xã',
          },
          {
            id: '2631',
            name: 'Hoà Nam',
            prefix: 'Xã',
          },
          {
            id: '2632',
            name: 'Hoà Ninh',
            prefix: 'Xã',
          },
          {
            id: '2633',
            name: 'Hoà Trung',
            prefix: 'Xã',
          },
          {
            id: '2634',
            name: 'Liên Đầm',
            prefix: 'Xã',
          },
          {
            id: '2635',
            name: 'Sơn Điền',
            prefix: 'Xã',
          },
          {
            id: '2636',
            name: 'Tam Bố',
            prefix: 'Xã',
          },
          {
            id: '2637',
            name: 'Tân Châu',
            prefix: 'Xã',
          },
          {
            id: '2638',
            name: 'Tân Lâm',
            prefix: 'Xã',
          },
          {
            id: '2639',
            name: 'Tân Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '2640',
            name: 'Tân Thượng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '184',
        name: 'Đạ Huoai',
        wards: [
          {
            id: '2577',
            name: "Đạ M'Ri",
            prefix: 'Thị trấn',
          },
          {
            id: '2578',
            name: "Đạ M'Ri",
            prefix: 'Xã',
          },
          {
            id: '2579',
            name: 'Đạ Oai',
            prefix: 'Xã',
          },
          {
            id: '2580',
            name: 'Đạ Ploa',
            prefix: 'Xã',
          },
          {
            id: '2581',
            name: 'Đạ Tồn',
            prefix: 'Xã',
          },
          {
            id: '2582',
            name: 'Đoàn Kết',
            prefix: 'Xã',
          },
          {
            id: '2583',
            name: 'Hà Lâm',
            prefix: 'Xã',
          },
          {
            id: '2584',
            name: 'Ma Đa Guôi',
            prefix: 'Thị trấn',
          },
          {
            id: '2585',
            name: 'Ma Đa Guôi',
            prefix: 'Xã',
          },
          {
            id: '2586',
            name: 'Phước Lộc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '185',
        name: 'Đà Lạt',
        wards: [
          {
            id: '2587',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '2588',
            name: '10',
            prefix: 'Phường',
          },
          {
            id: '2589',
            name: '11',
            prefix: 'Phường',
          },
          {
            id: '2590',
            name: '12',
            prefix: 'Phường',
          },
          {
            id: '2591',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '2592',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '2593',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '2594',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '2595',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '2596',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '2597',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '2598',
            name: '9',
            prefix: 'Phường',
          },
          {
            id: '2599',
            name: 'Tà Nung',
            prefix: 'Xã',
          },
          {
            id: '2600',
            name: 'Trạm Hành',
            prefix: 'Xã',
          },
          {
            id: '2601',
            name: 'Xuân Thọ',
            prefix: 'Xã',
          },
          {
            id: '2602',
            name: 'Xuân Trường',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '186',
        name: 'Đạ Tẻh',
        wards: [
          {
            id: '2603',
            name: 'An Nhơn',
            prefix: 'Xã',
          },
          {
            id: '2604',
            name: 'Đạ Kho',
            prefix: 'Xã',
          },
          {
            id: '2605',
            name: 'Đạ Lây',
            prefix: 'Xã',
          },
          {
            id: '2606',
            name: 'Đạ Pal',
            prefix: 'Xã',
          },
          {
            id: '2607',
            name: 'Đạ Tẻh',
            prefix: 'Thị trấn',
          },
          {
            id: '2608',
            name: 'Hà Đông',
            prefix: 'Xã',
          },
          {
            id: '2609',
            name: 'Hương Lâm',
            prefix: 'Xã',
          },
          {
            id: '2610',
            name: 'Mỹ Đức',
            prefix: 'Xã',
          },
          {
            id: '2611',
            name: 'Quảng Trị',
            prefix: 'Xã',
          },
          {
            id: '2612',
            name: 'Quốc Oai',
            prefix: 'Xã',
          },
          {
            id: '2613',
            name: 'Triệu Hải',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '187',
        name: 'Đam Rông',
        wards: [
          {
            id: '2614',
            name: 'Đạ K’Nàng',
            prefix: 'Xã',
          },
          {
            id: '2615',
            name: 'Đạ Long',
            prefix: 'Xã',
          },
          {
            id: '2616',
            name: "Đạ M'Rông",
            prefix: 'Xã',
          },
          {
            id: '2617',
            name: 'Đạ Rsal',
            prefix: 'Xã',
          },
          {
            id: '2618',
            name: 'Đạ Tông',
            prefix: 'Xã',
          },
          {
            id: '2619',
            name: 'Liêng S’Roin',
            prefix: 'Xã',
          },
          {
            id: '2620',
            name: 'Phi Liêng',
            prefix: 'Xã',
          },
          {
            id: '2621',
            name: 'Rô Men',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '189',
        name: 'Đơn Dương',
        wards: [
          {
            id: '2642',
            name: "D'ran",
            prefix: 'Thị trấn',
          },
          {
            id: '2641',
            name: 'Đạ Ròn',
            prefix: 'Xã',
          },
          {
            id: '2643',
            name: 'Ka Đô',
            prefix: 'Xã',
          },
          {
            id: '2644',
            name: 'Ka Đơn',
            prefix: 'Xã',
          },
          {
            id: '2645',
            name: 'Lạc Lâm',
            prefix: 'Xã',
          },
          {
            id: '2646',
            name: 'Lạc Xuân',
            prefix: 'Xã',
          },
          {
            id: '2647',
            name: 'Pró',
            prefix: 'Xã',
          },
          {
            id: '2648',
            name: 'Quảng Lập',
            prefix: 'Xã',
          },
          {
            id: '2649',
            name: 'Thạnh Mỹ',
            prefix: 'Thị trấn',
          },
          {
            id: '2650',
            name: 'Tu Tra',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '190',
        name: 'Đức Trọng',
        wards: [
          {
            id: '2651',
            name: 'Bình Thạnh',
            prefix: 'Xã',
          },
          {
            id: '2652',
            name: 'Đà Loan',
            prefix: 'Xã',
          },
          {
            id: '2653',
            name: 'Đa Quyn',
            prefix: 'Xã',
          },
          {
            id: '2654',
            name: 'Hiệp An',
            prefix: 'Xã',
          },
          {
            id: '2655',
            name: 'Hiệp Thạnh',
            prefix: 'Xã',
          },
          {
            id: '2656',
            name: 'Liên Hiệp',
            prefix: 'Xã',
          },
          {
            id: '2657',
            name: 'Liên Nghĩa',
            prefix: 'Thị trấn',
          },
          {
            id: '2660',
            name: "N'Thol Hạ",
            prefix: 'Xã',
          },
          {
            id: '2658',
            name: 'Ninh Gia',
            prefix: 'Xã',
          },
          {
            id: '2659',
            name: 'Ninh Loan',
            prefix: 'Xã',
          },
          {
            id: '2661',
            name: 'Phú Hội',
            prefix: 'Xã',
          },
          {
            id: '2662',
            name: 'Tà Hine',
            prefix: 'Xã',
          },
          {
            id: '2663',
            name: 'Tà Năng',
            prefix: 'Xã',
          },
          {
            id: '2664',
            name: 'Tân Hội',
            prefix: 'Xã',
          },
          {
            id: '2665',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '191',
        name: 'Lạc Dương',
        wards: [
          {
            id: '2666',
            name: 'Đạ Chais',
            prefix: 'Xã',
          },
          {
            id: '2667',
            name: 'Đạ Nhim',
            prefix: 'Xã',
          },
          {
            id: '2668',
            name: 'Đạ Sar',
            prefix: 'Xã',
          },
          {
            id: '2669',
            name: 'Đưng KNớ',
            prefix: 'Xã',
          },
          {
            id: '2670',
            name: 'Lạc Dương',
            prefix: 'Thị trấn',
          },
          {
            id: '2671',
            name: 'Lát',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '192',
        name: 'Lâm Hà',
        wards: [
          {
            id: '2672',
            name: 'Đạ Đờn',
            prefix: 'Xã',
          },
          {
            id: '2673',
            name: 'Đan Phượng',
            prefix: 'Xã',
          },
          {
            id: '2674',
            name: 'Đinh Văn',
            prefix: 'Thị trấn',
          },
          {
            id: '2675',
            name: 'Đông Thanh',
            prefix: 'Xã',
          },
          {
            id: '2676',
            name: 'Gia Lâm',
            prefix: 'Xã',
          },
          {
            id: '2677',
            name: 'Hoài Đức',
            prefix: 'Xã',
          },
          {
            id: '2678',
            name: 'Liên Hà',
            prefix: 'Xã',
          },
          {
            id: '2679',
            name: 'Mê Linh',
            prefix: 'Xã',
          },
          {
            id: '2680',
            name: 'Nam Ban',
            prefix: 'Thị trấn',
          },
          {
            id: '2681',
            name: 'Nam Hà',
            prefix: 'Xã',
          },
          {
            id: '2682',
            name: 'Phi Tô',
            prefix: 'Xã',
          },
          {
            id: '2683',
            name: 'Phú Sơn',
            prefix: 'Xã',
          },
          {
            id: '2684',
            name: 'Phúc Thọ',
            prefix: 'Xã',
          },
          {
            id: '2685',
            name: 'Tân Hà',
            prefix: 'Xã',
          },
          {
            id: '2686',
            name: 'Tân Thanh',
            prefix: 'Xã',
          },
          {
            id: '2687',
            name: 'Tân Văn',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '15',
    code: 'TTH',
    name: 'Thừa Thiên Huế',
    districts: [
      {
        id: '193',
        name: 'A Lưới',
        wards: [
          {
            id: '2688',
            name: 'A Đớt',
            prefix: 'Xã',
          },
          {
            id: '2689',
            name: 'A Lưới',
            prefix: 'Thị trấn',
          },
          {
            id: '2690',
            name: 'A Ngo',
            prefix: 'Xã',
          },
          {
            id: '2691',
            name: 'A Roằng',
            prefix: 'Xã',
          },
          {
            id: '2692',
            name: 'Bắc Sơn',
            prefix: 'Xã',
          },
          {
            id: '2693',
            name: 'Đông Sơn',
            prefix: 'Xã',
          },
          {
            id: '2694',
            name: 'Hồng Bắc',
            prefix: 'Xã',
          },
          {
            id: '2695',
            name: 'Hồng Hạ',
            prefix: 'Xã',
          },
          {
            id: '2696',
            name: 'Hồng Kim',
            prefix: 'Xã',
          },
          {
            id: '2697',
            name: 'Hồng Nam',
            prefix: 'Xã',
          },
          {
            id: '2698',
            name: 'Hồng Quảng',
            prefix: 'Xã',
          },
          {
            id: '2699',
            name: 'Hồng Thái',
            prefix: 'Xã',
          },
          {
            id: '2700',
            name: 'Hồng Thượng',
            prefix: 'Xã',
          },
          {
            id: '2701',
            name: 'Hồng Thủy',
            prefix: 'Xã',
          },
          {
            id: '2702',
            name: 'Hồng Trung',
            prefix: 'Xã',
          },
          {
            id: '2703',
            name: 'Hồng Vân',
            prefix: 'Xã',
          },
          {
            id: '2704',
            name: 'Hương Lâm',
            prefix: 'Xã',
          },
          {
            id: '2705',
            name: 'Hương Nguyên',
            prefix: 'Xã',
          },
          {
            id: '2706',
            name: 'Hương Phong',
            prefix: 'Xã',
          },
          {
            id: '2707',
            name: 'Nhâm',
            prefix: 'Xã',
          },
          {
            id: '2708',
            name: 'Phú Vinh',
            prefix: 'Xã',
          },
          {
            id: '2709',
            name: 'Sơn Thủy',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '194',
        name: 'Huế',
        wards: [
          {
            id: '2710',
            name: 'An Cựu',
            prefix: 'Phường',
          },
          {
            id: '2711',
            name: 'An Đông',
            prefix: 'Phường',
          },
          {
            id: '2712',
            name: 'An Hòa',
            prefix: 'Phường',
          },
          {
            id: '2713',
            name: 'An Tây',
            prefix: 'Phường',
          },
          {
            id: '2714',
            name: 'Đúc',
            prefix: 'Phường',
          },
          {
            id: '2715',
            name: 'Hương Long',
            prefix: 'Phường',
          },
          {
            id: '2716',
            name: 'Hương Sơ',
            prefix: 'Phường',
          },
          {
            id: '2717',
            name: 'Kim Long',
            prefix: 'Phường',
          },
          {
            id: '2718',
            name: 'Phú Bình',
            prefix: 'Phường',
          },
          {
            id: '2719',
            name: 'Phú Cát',
            prefix: 'Phường',
          },
          {
            id: '2720',
            name: 'Phú Hậu',
            prefix: 'Phường',
          },
          {
            id: '2721',
            name: 'Phú Hiệp',
            prefix: 'Phường',
          },
          {
            id: '2722',
            name: 'Phú Hòa',
            prefix: 'Phường',
          },
          {
            id: '2723',
            name: 'Phú Hội',
            prefix: 'Phường',
          },
          {
            id: '2724',
            name: 'Phú Nhuận',
            prefix: 'Phường',
          },
          {
            id: '2725',
            name: 'Phú Thuận',
            prefix: 'Phường',
          },
          {
            id: '2726',
            name: 'Phước Vĩnh',
            prefix: 'Phường',
          },
          {
            id: '2727',
            name: 'Phường Đúc',
            prefix: 'Phường',
          },
          {
            id: '2728',
            name: 'Tây Lộc',
            prefix: 'Phường',
          },
          {
            id: '2729',
            name: 'Thuận Hòa',
            prefix: 'Phường',
          },
          {
            id: '2730',
            name: 'Thuận Lộc',
            prefix: 'Phường',
          },
          {
            id: '2731',
            name: 'Thuận Thành',
            prefix: 'Phường',
          },
          {
            id: '2732',
            name: 'Thủy An',
            prefix: 'Xã',
          },
          {
            id: '2733',
            name: 'Thủy Biều',
            prefix: 'Phường',
          },
          {
            id: '2734',
            name: 'Thủy Xuân',
            prefix: 'Phường',
          },
          {
            id: '2735',
            name: 'Trường An',
            prefix: 'Phường',
          },
          {
            id: '2736',
            name: 'Vĩ Dạ',
            prefix: 'Phường',
          },
          {
            id: '2737',
            name: 'Vĩnh Ninh',
            prefix: 'Phường',
          },
          {
            id: '2738',
            name: 'Xuân Phú',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '195',
        name: 'Hương Thủy',
        wards: [
          {
            id: '2739',
            name: 'Dương Hòa',
            prefix: 'Xã',
          },
          {
            id: '2740',
            name: 'Phú Bài',
            prefix: 'Phường',
          },
          {
            id: '2741',
            name: 'Phú Sơn',
            prefix: 'Xã',
          },
          {
            id: '2742',
            name: 'Thủy Bằng',
            prefix: 'Xã',
          },
          {
            id: '2743',
            name: 'Thủy Châu',
            prefix: 'Phường',
          },
          {
            id: '2744',
            name: 'Thuỷ Dương',
            prefix: 'Phường',
          },
          {
            id: '2745',
            name: 'Thủy Dương',
            prefix: 'Phường',
          },
          {
            id: '2746',
            name: 'Thủy Lương',
            prefix: 'Phường',
          },
          {
            id: '2747',
            name: 'Thủy Phù',
            prefix: 'Xã',
          },
          {
            id: '2748',
            name: 'Thủy Phương',
            prefix: 'Phường',
          },
          {
            id: '2749',
            name: 'Thủy Tân',
            prefix: 'Xã',
          },
          {
            id: '2750',
            name: 'Thủy Thanh',
            prefix: 'Xã',
          },
          {
            id: '2751',
            name: 'Thuỷ Vân',
            prefix: 'Xã',
          },
          {
            id: '2752',
            name: 'Thủy Vân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '196',
        name: 'Hương Trà',
        wards: [
          {
            id: '2753',
            name: 'Bình Điền',
            prefix: 'Xã',
          },
          {
            id: '2754',
            name: 'Bình Thành',
            prefix: 'Phường',
          },
          {
            id: '2755',
            name: 'Hải Dương',
            prefix: 'Xã',
          },
          {
            id: '2756',
            name: 'Hồng Tiến',
            prefix: 'Phường',
          },
          {
            id: '2757',
            name: 'Hương An',
            prefix: 'Phường',
          },
          {
            id: '2758',
            name: 'Hương Bình',
            prefix: 'Xã',
          },
          {
            id: '2759',
            name: 'Hương Chữ',
            prefix: 'Phường',
          },
          {
            id: '2760',
            name: 'Hương Hồ',
            prefix: 'Phường',
          },
          {
            id: '2761',
            name: 'Hương Phong',
            prefix: 'Xã',
          },
          {
            id: '2762',
            name: 'Hương Thọ',
            prefix: 'Phường',
          },
          {
            id: '2763',
            name: 'Hương Toàn',
            prefix: 'Xã',
          },
          {
            id: '2764',
            name: 'Hương Vân',
            prefix: 'Phường',
          },
          {
            id: '2765',
            name: 'Hương Văn',
            prefix: 'Phường',
          },
          {
            id: '2766',
            name: 'Hương Vinh',
            prefix: 'Xã',
          },
          {
            id: '2767',
            name: 'Hương Xuân',
            prefix: 'Phường',
          },
          {
            id: '2768',
            name: 'Tứ Hạ',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '197',
        name: 'Nam Đông',
        wards: [
          {
            id: '2769',
            name: 'Hương Giang',
            prefix: 'Xã',
          },
          {
            id: '2770',
            name: 'Hương Hoà',
            prefix: 'Xã',
          },
          {
            id: '2771',
            name: 'Hương Hữu',
            prefix: 'Xã',
          },
          {
            id: '2772',
            name: 'Hương Lộc',
            prefix: 'Xã',
          },
          {
            id: '2773',
            name: 'Hương Phú',
            prefix: 'Xã',
          },
          {
            id: '2774',
            name: 'Hương Sơn',
            prefix: 'Xã',
          },
          {
            id: '2775',
            name: 'Khe Tre',
            prefix: 'Thị trấn',
          },
          {
            id: '2776',
            name: 'Thượng Lộ',
            prefix: 'Xã',
          },
          {
            id: '2777',
            name: 'Thượng Long',
            prefix: 'Xã',
          },
          {
            id: '2778',
            name: 'Thượng Nhật',
            prefix: 'Xã',
          },
          {
            id: '2779',
            name: 'Thượng Quảng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '198',
        name: 'Phong Điền',
        wards: [
          {
            id: '2780',
            name: 'Điền Hải',
            prefix: 'Xã',
          },
          {
            id: '2781',
            name: 'Điền Hoà',
            prefix: 'Xã',
          },
          {
            id: '2782',
            name: 'Điền Hương',
            prefix: 'Xã',
          },
          {
            id: '2783',
            name: 'Điền Lộc',
            prefix: 'Xã',
          },
          {
            id: '2784',
            name: 'Điền Môn',
            prefix: 'Xã',
          },
          {
            id: '2785',
            name: 'Phong An',
            prefix: 'Xã',
          },
          {
            id: '2786',
            name: 'Phong Bình',
            prefix: 'Xã',
          },
          {
            id: '2787',
            name: 'Phong Chương',
            prefix: 'Xã',
          },
          {
            id: '2788',
            name: 'Phong Điền',
            prefix: 'Thị trấn',
          },
          {
            id: '2789',
            name: 'Phong Hải',
            prefix: 'Xã',
          },
          {
            id: '2790',
            name: 'Phong Hiền',
            prefix: 'Xã',
          },
          {
            id: '2791',
            name: 'Phong Hoà',
            prefix: 'Xã',
          },
          {
            id: '2792',
            name: 'Phong Mỹ',
            prefix: 'Xã',
          },
          {
            id: '2793',
            name: 'Phong Sơn',
            prefix: 'Xã',
          },
          {
            id: '2794',
            name: 'Phong Th',
            prefix: 'Xã',
          },
          {
            id: '2795',
            name: 'Phong Thu',
            prefix: 'Xã',
          },
          {
            id: '2796',
            name: 'Phong Xuân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '199',
        name: 'Phú Lộc',
        wards: [
          {
            id: '2797',
            name: 'Lăng Cô',
            prefix: 'Thị trấn',
          },
          {
            id: '2798',
            name: 'Lộc An',
            prefix: 'Xã',
          },
          {
            id: '2799',
            name: 'Lộc Bình',
            prefix: 'Xã',
          },
          {
            id: '2800',
            name: 'Lộc Bổn',
            prefix: 'Xã',
          },
          {
            id: '2801',
            name: 'Lộc Điền',
            prefix: 'Xã',
          },
          {
            id: '2802',
            name: 'Lộc Hòa',
            prefix: 'Xã',
          },
          {
            id: '2803',
            name: 'Lộc Sơn',
            prefix: 'Xã',
          },
          {
            id: '2804',
            name: 'Lộc Thủy',
            prefix: 'Xã',
          },
          {
            id: '2805',
            name: 'Lộc Tiến',
            prefix: 'Xã',
          },
          {
            id: '2806',
            name: 'Lộc Trì',
            prefix: 'Xã',
          },
          {
            id: '2807',
            name: 'Lộc Vĩnh',
            prefix: 'Xã',
          },
          {
            id: '2808',
            name: 'Phú Lộc',
            prefix: 'Thị trấn',
          },
          {
            id: '2809',
            name: 'Vinh Giang',
            prefix: 'Xã',
          },
          {
            id: '2810',
            name: 'Vinh Hải',
            prefix: 'Xã',
          },
          {
            id: '2811',
            name: 'Vinh Hiền',
            prefix: 'Xã',
          },
          {
            id: '2812',
            name: 'Vinh Hưng',
            prefix: 'Xã',
          },
          {
            id: '2813',
            name: 'Vinh Mỹ',
            prefix: 'Xã',
          },
          {
            id: '2814',
            name: 'Xuân Lộc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '200',
        name: 'Phú Vang',
        wards: [
          {
            id: '2815',
            name: 'Phú An',
            prefix: 'Xã',
          },
          {
            id: '2817',
            name: 'Phú Diên',
            prefix: 'Xã',
          },
          {
            id: '2818',
            name: 'Phú Dương',
            prefix: 'Xã',
          },
          {
            id: '2816',
            name: 'Phú Đa',
            prefix: 'Thị trấn',
          },
          {
            id: '2819',
            name: 'Phú Hải',
            prefix: 'Xã',
          },
          {
            id: '2820',
            name: 'Phú Hồ',
            prefix: 'Xã',
          },
          {
            id: '2821',
            name: 'Phú Lương',
            prefix: 'Xã',
          },
          {
            id: '2822',
            name: 'Phú Mậu',
            prefix: 'Xã',
          },
          {
            id: '2823',
            name: 'Phú Mỹ',
            prefix: 'Xã',
          },
          {
            id: '2824',
            name: 'Phú Thanh',
            prefix: 'Xã',
          },
          {
            id: '2825',
            name: 'Phú Thuận',
            prefix: 'Xã',
          },
          {
            id: '2826',
            name: 'Phú Thượng',
            prefix: 'Xã',
          },
          {
            id: '2827',
            name: 'Phú Xuân',
            prefix: 'Xã',
          },
          {
            id: '2828',
            name: 'Thuận An',
            prefix: 'Thị trấn',
          },
          {
            id: '2829',
            name: 'Vinh An',
            prefix: 'Xã',
          },
          {
            id: '2830',
            name: 'Vinh Hà',
            prefix: 'Xã',
          },
          {
            id: '2831',
            name: 'Vinh Phú',
            prefix: 'Xã',
          },
          {
            id: '2832',
            name: 'Vinh Thái',
            prefix: 'Xã',
          },
          {
            id: '2833',
            name: 'Vinh Thanh',
            prefix: 'Xã',
          },
          {
            id: '2834',
            name: 'Vinh Xuân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '201',
        name: 'Quảng Điền',
        wards: [
          {
            id: '2835',
            name: 'Quảng An',
            prefix: 'Xã',
          },
          {
            id: '2836',
            name: 'Quảng Công',
            prefix: 'Xã',
          },
          {
            id: '2837',
            name: 'Quảng Lợi',
            prefix: 'Xã',
          },
          {
            id: '2838',
            name: 'Quảng Ngạn',
            prefix: 'Xã',
          },
          {
            id: '2839',
            name: 'Quảng Phú',
            prefix: 'Xã',
          },
          {
            id: '2840',
            name: 'Quảng Phước',
            prefix: 'Xã',
          },
          {
            id: '2841',
            name: 'Quảng Thái',
            prefix: 'Xã',
          },
          {
            id: '2842',
            name: 'Quảng Thành',
            prefix: 'Xã',
          },
          {
            id: '2843',
            name: 'Quảng Thọ',
            prefix: 'Xã',
          },
          {
            id: '2844',
            name: 'Quảng Vinh',
            prefix: 'Xã',
          },
          {
            id: '2845',
            name: 'Sịa',
            prefix: 'Thị trấn',
          },
        ],
      },
    ],
  },
  {
    id: '16',
    code: 'KG',
    name: 'Kiên Giang',
    districts: [
      {
        id: '202',
        name: 'An Biên',
        wards: [
          {
            id: '2846',
            name: 'Đông Thái',
            prefix: 'Xã',
          },
          {
            id: '2847',
            name: 'Đông Yên',
            prefix: 'Xã',
          },
          {
            id: '2848',
            name: 'Hưng Yên',
            prefix: 'Xã',
          },
          {
            id: '2849',
            name: 'Nam Thái',
            prefix: 'Xã',
          },
          {
            id: '2850',
            name: 'Nam Thái A',
            prefix: 'Xã',
          },
          {
            id: '2851',
            name: 'Nam Yên',
            prefix: 'Xã',
          },
          {
            id: '2852',
            name: 'Tây Yên',
            prefix: 'Xã',
          },
          {
            id: '2853',
            name: 'Tây Yên A',
            prefix: 'Xã',
          },
          {
            id: '2854',
            name: 'Thứ Ba',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '203',
        name: 'An Minh',
        wards: [
          {
            id: '2855',
            name: 'Đông Hoà',
            prefix: 'Xã',
          },
          {
            id: '2856',
            name: 'Đông Hưng',
            prefix: 'Xã',
          },
          {
            id: '2857',
            name: 'Đông Hưng A',
            prefix: 'Xã',
          },
          {
            id: '2858',
            name: 'Đông Hưng B',
            prefix: 'Xã',
          },
          {
            id: '2859',
            name: 'Đông Thạnh',
            prefix: 'Xã',
          },
          {
            id: '2860',
            name: 'Tân Thạnh',
            prefix: 'Xã',
          },
          {
            id: '2861',
            name: 'Thứ Mười Một',
            prefix: 'Thị trấn',
          },
          {
            id: '2862',
            name: 'Thuận Hoà',
            prefix: 'Xã',
          },
          {
            id: '2863',
            name: 'Vân Khánh',
            prefix: 'Xã',
          },
          {
            id: '2864',
            name: 'Vân Khánh Đông',
            prefix: 'Xã',
          },
          {
            id: '2865',
            name: 'Vân Khánh Tây',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '204',
        name: 'Châu Thành',
        wards: [
          {
            id: '2866',
            name: 'Bình An',
            prefix: 'Xã',
          },
          {
            id: '2867',
            name: 'Giục Tượng',
            prefix: 'Xã',
          },
          {
            id: '2868',
            name: 'Minh Hoà',
            prefix: 'Xã',
          },
          {
            id: '2869',
            name: 'Minh Lương',
            prefix: 'Thị trấn',
          },
          {
            id: '2870',
            name: 'Mong Thọ',
            prefix: 'Xã',
          },
          {
            id: '2871',
            name: 'Mong Thọ A',
            prefix: 'Xã',
          },
          {
            id: '2872',
            name: 'Mong Thọ B',
            prefix: 'Xã',
          },
          {
            id: '2873',
            name: 'Thanh Lộc',
            prefix: 'Xã',
          },
          {
            id: '2874',
            name: 'Vĩnh Hoà Hiệp',
            prefix: 'Xã',
          },
          {
            id: '2875',
            name: 'Vĩnh Hòa Phú',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '205',
        name: 'Giang Thành',
        wards: [
          {
            id: '2876',
            name: 'Phú Lợi',
            prefix: 'Xã',
          },
          {
            id: '2877',
            name: 'Phú Mỹ',
            prefix: 'Xã',
          },
          {
            id: '2878',
            name: 'Tân Khánh Hoà',
            prefix: 'Xã',
          },
          {
            id: '2879',
            name: 'Vĩnh Điều',
            prefix: 'Xã',
          },
          {
            id: '2880',
            name: 'Vĩnh Phú ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '206',
        name: 'Giồng Riềng',
        wards: [
          {
            id: '2881',
            name: 'Bàn Tân Định',
            prefix: 'Xã',
          },
          {
            id: '2882',
            name: 'Bàn Thạch',
            prefix: 'Xã',
          },
          {
            id: '2883',
            name: 'Giồng Riềng',
            prefix: 'Thị trấn',
          },
          {
            id: '2884',
            name: 'Hoà An',
            prefix: 'Xã',
          },
          {
            id: '2885',
            name: 'Hoà Hưng',
            prefix: 'Xã',
          },
          {
            id: '2886',
            name: 'Hoà Lợi',
            prefix: 'Xã',
          },
          {
            id: '2887',
            name: 'Hoà Thuận',
            prefix: 'Xã',
          },
          {
            id: '2888',
            name: 'Long Thạnh',
            prefix: 'Xã',
          },
          {
            id: '2889',
            name: 'Ngọc Chúc',
            prefix: 'Xã',
          },
          {
            id: '2890',
            name: 'Ngọc Hoà',
            prefix: 'Xã',
          },
          {
            id: '2891',
            name: 'Ngọc Thành',
            prefix: 'Xã',
          },
          {
            id: '2892',
            name: 'Ngọc Thuận',
            prefix: 'Xã',
          },
          {
            id: '2893',
            name: 'Thạnh Bình',
            prefix: 'Xã',
          },
          {
            id: '2894',
            name: 'Thạnh Hoà',
            prefix: 'Xã',
          },
          {
            id: '2895',
            name: 'Thạnh Hưng',
            prefix: 'Xã',
          },
          {
            id: '2896',
            name: 'Thạnh Lộc',
            prefix: 'Xã',
          },
          {
            id: '2897',
            name: 'Thạnh Phước',
            prefix: 'Xã',
          },
          {
            id: '2898',
            name: 'Vĩnh Phú',
            prefix: 'Xã',
          },
          {
            id: '2899',
            name: 'Vĩnh Thạnh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '207',
        name: 'Gò Quao',
        wards: [
          {
            id: '2900',
            name: 'Định An',
            prefix: 'Xã',
          },
          {
            id: '2901',
            name: 'Định Hòa',
            prefix: 'Xã',
          },
          {
            id: '2902',
            name: 'Gò Quao',
            prefix: 'Thị trấn',
          },
          {
            id: '2903',
            name: 'Thới Quản',
            prefix: 'Xã',
          },
          {
            id: '2904',
            name: 'Thủy Liểu',
            prefix: 'Xã',
          },
          {
            id: '2905',
            name: 'Vĩnh Hòa Hưng Bắc',
            prefix: 'Xã',
          },
          {
            id: '2906',
            name: 'Vĩnh Hòa Hưng Nam',
            prefix: 'Xã',
          },
          {
            id: '2907',
            name: 'Vĩnh Phước A',
            prefix: 'Xã',
          },
          {
            id: '2908',
            name: 'Vĩnh Phước B',
            prefix: 'Xã',
          },
          {
            id: '2909',
            name: 'Vĩnh Thắng ',
            prefix: 'Xã',
          },
          {
            id: '2910',
            name: 'Vĩnh Tuy',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '208',
        name: 'Hà Tiên',
        wards: [
          {
            id: '2911',
            name: 'Bình San',
            prefix: 'Phường',
          },
          {
            id: '2912',
            name: 'Đông Hồ',
            prefix: 'Phường',
          },
          {
            id: '2913',
            name: 'Mỹ Đức',
            prefix: 'Xã',
          },
          {
            id: '2914',
            name: 'Pháo Đài',
            prefix: 'Phường',
          },
          {
            id: '2915',
            name: 'Thuận Yên',
            prefix: 'Xã',
          },
          {
            id: '2916',
            name: 'Tiên Hải',
            prefix: 'Xã',
          },
          {
            id: '2917',
            name: 'Tô Châu',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '209',
        name: 'Hòn Đất',
        wards: [
          {
            id: '2918',
            name: 'Bình Giang',
            prefix: 'Xã',
          },
          {
            id: '2919',
            name: 'Bình Sơn',
            prefix: 'Xã',
          },
          {
            id: '2920',
            name: 'Hòn Đất',
            prefix: 'Thị trấn',
          },
          {
            id: '2921',
            name: 'Lình Huỳnh',
            prefix: 'Xã',
          },
          {
            id: '2922',
            name: 'Mỹ Hiệp Sơn',
            prefix: 'Xã',
          },
          {
            id: '2923',
            name: 'Mỹ Lâm',
            prefix: 'Xã',
          },
          {
            id: '2924',
            name: 'Mỹ Phước',
            prefix: 'Xã',
          },
          {
            id: '2925',
            name: 'Mỹ Thái',
            prefix: 'Xã',
          },
          {
            id: '2926',
            name: 'Mỹ Thuận',
            prefix: 'Xã',
          },
          {
            id: '2927',
            name: 'Nam Thái Sơn',
            prefix: 'Xã',
          },
          {
            id: '2928',
            name: 'Sóc Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '2929',
            name: 'Sơn Bình',
            prefix: 'Xã',
          },
          {
            id: '2930',
            name: 'Sơn Kiên',
            prefix: 'Xã',
          },
          {
            id: '2931',
            name: 'Thổ Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '210',
        name: 'Kiên Hải',
        wards: [
          {
            id: '2932',
            name: 'An Sơn',
            prefix: 'Xã',
          },
          {
            id: '2933',
            name: 'Hòn Tre',
            prefix: 'Xã',
          },
          {
            id: '2934',
            name: 'Lại Sơn',
            prefix: 'Xã',
          },
          {
            id: '2935',
            name: 'Nam Du',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '211',
        name: 'Kiên Lương',
        wards: [
          {
            id: '2936',
            name: 'Bình An',
            prefix: 'Xã',
          },
          {
            id: '2937',
            name: 'Bình Trị',
            prefix: 'Xã',
          },
          {
            id: '2938',
            name: 'Dương Hoà',
            prefix: 'Xã',
          },
          {
            id: '2939',
            name: 'Hoà Điền',
            prefix: 'Xã',
          },
          {
            id: '2940',
            name: 'Hòn Nghệ ',
            prefix: 'Xã',
          },
          {
            id: '2941',
            name: 'Kiên Bình',
            prefix: 'Xã',
          },
          {
            id: '2942',
            name: 'Kiên Lương',
            prefix: 'Thị trấn',
          },
          {
            id: '2943',
            name: 'Sơn Hải',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '212',
        name: 'Phú Quốc',
        wards: [
          {
            id: '2944',
            name: 'An Thới',
            prefix: 'Thị trấn',
          },
          {
            id: '2945',
            name: 'Bãi Thơm',
            prefix: 'Xã',
          },
          {
            id: '2946',
            name: 'Cửa Cạn',
            prefix: 'Xã',
          },
          {
            id: '2947',
            name: 'Cửa Dương',
            prefix: 'Xã',
          },
          {
            id: '2948',
            name: 'Dương Đông',
            prefix: 'Thị trấn',
          },
          {
            id: '2949',
            name: 'Dương Tơ',
            prefix: 'Xã',
          },
          {
            id: '2950',
            name: 'Gành Dầu',
            prefix: 'Xã',
          },
          {
            id: '2951',
            name: 'Hàm Ninh',
            prefix: 'Xã',
          },
          {
            id: '2952',
            name: 'Hòn Thơm',
            prefix: 'Xã',
          },
          {
            id: '2953',
            name: 'Thổ Châu',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '213',
        name: 'Rạch Giá',
        wards: [
          {
            id: '2954',
            name: ' Vĩnh Thanh Vân',
            prefix: 'Phường',
          },
          {
            id: '2955',
            name: 'An Bình',
            prefix: 'Phường',
          },
          {
            id: '2956',
            name: 'An Hòa',
            prefix: 'Phường',
          },
          {
            id: '2957',
            name: 'Phi Thông',
            prefix: 'Xã',
          },
          {
            id: '2958',
            name: 'Rạch Sỏi',
            prefix: 'Phường',
          },
          {
            id: '2959',
            name: 'Vĩnh Bảo',
            prefix: 'Phường',
          },
          {
            id: '2960',
            name: 'Vĩnh Hiệp',
            prefix: 'Phường',
          },
          {
            id: '2961',
            name: 'Vĩnh Lạc',
            prefix: 'Phường',
          },
          {
            id: '2962',
            name: 'Vĩnh Lợi',
            prefix: 'Phường',
          },
          {
            id: '2963',
            name: 'Vĩnh Quang',
            prefix: 'Phường',
          },
          {
            id: '2964',
            name: 'Vĩnh Thanh',
            prefix: 'Phường',
          },
          {
            id: '2965',
            name: 'Vĩnh Thông',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '214',
        name: 'Tân Hiệp',
        wards: [
          {
            id: '2966',
            name: 'Tân An',
            prefix: 'Xã',
          },
          {
            id: '2967',
            name: 'Tân Hiệp',
            prefix: 'Thị trấn',
          },
          {
            id: '2968',
            name: 'Tân Hiệp A',
            prefix: 'Xã',
          },
          {
            id: '2969',
            name: 'Tân Hiệp B',
            prefix: 'Xã',
          },
          {
            id: '2970',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
          {
            id: '2971',
            name: 'Tân Hội',
            prefix: 'Xã',
          },
          {
            id: '2972',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '2973',
            name: 'Thạnh Đông',
            prefix: 'Xã',
          },
          {
            id: '2974',
            name: 'Thạnh Đông A',
            prefix: 'Xã',
          },
          {
            id: '2975',
            name: 'Thạnh Đông B',
            prefix: 'Xã',
          },
          {
            id: '2976',
            name: 'Thạnh Trị',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '215',
        name: 'U minh Thượng',
        wards: [
          {
            id: '2977',
            name: 'An Minh Bắc',
            prefix: 'Xã',
          },
          {
            id: '2978',
            name: 'Hòa Chánh',
            prefix: 'Xã',
          },
          {
            id: '2979',
            name: 'Minh Thuận',
            prefix: 'Xã',
          },
          {
            id: '2980',
            name: 'Thạnh Yên ',
            prefix: 'Xã',
          },
          {
            id: '2981',
            name: 'Thạnh Yên A',
            prefix: 'Xã',
          },
          {
            id: '2982',
            name: 'Vĩnh Hòa ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '216',
        name: 'Vĩnh Thuận',
        wards: [
          {
            id: '2983',
            name: 'Bình Minh',
            prefix: 'Xã',
          },
          {
            id: '2984',
            name: 'Phong Đông',
            prefix: 'Xã',
          },
          {
            id: '2985',
            name: 'Tân Thuận',
            prefix: 'Xã',
          },
          {
            id: '2986',
            name: 'Vĩnh Bình Bắc',
            prefix: 'Xã',
          },
          {
            id: '2987',
            name: 'Vĩnh Bình Nam',
            prefix: 'Xã',
          },
          {
            id: '2988',
            name: 'Vĩnh Phong',
            prefix: 'Xã',
          },
          {
            id: '2989',
            name: 'Vĩnh Thuận',
            prefix: 'Thị trấn',
          },
          {
            id: '2990',
            name: 'Vĩnh Thuận',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '17',
    code: 'BN',
    name: 'Bắc Ninh',
    districts: [
      {
        id: '217',
        name: 'Bắc Ninh',
        wards: [
          {
            id: '2991',
            name: 'Đại Phúc',
            prefix: 'Phường',
          },
          {
            id: '2992',
            name: 'Đáp Cầu',
            prefix: 'Phường',
          },
          {
            id: '2993',
            name: 'Hạp Lĩnh',
            prefix: 'Phường',
          },
          {
            id: '2994',
            name: 'Hòa Long',
            prefix: 'Xã',
          },
          {
            id: '2995',
            name: 'Khắc Niệm',
            prefix: 'Xã',
          },
          {
            id: '2996',
            name: 'Khúc Xuyên',
            prefix: 'Xã',
          },
          {
            id: '2997',
            name: 'Kim Chân',
            prefix: 'Xã',
          },
          {
            id: '2998',
            name: 'Kinh Bắc',
            prefix: 'Phường',
          },
          {
            id: '2999',
            name: 'Nam Sơn',
            prefix: 'Xã',
          },
          {
            id: '3000',
            name: 'Ninh Xá',
            prefix: 'Phường',
          },
          {
            id: '3001',
            name: 'Phong Khê',
            prefix: 'Xã',
          },
          {
            id: '3002',
            name: 'Suối Hoa',
            prefix: 'Phường',
          },
          {
            id: '3003',
            name: 'Thị Cầu',
            prefix: 'Xã',
          },
          {
            id: '3004',
            name: 'Tiền An',
            prefix: 'Xã',
          },
          {
            id: '3005',
            name: 'Vạn An',
            prefix: 'Phường',
          },
          {
            id: '3006',
            name: 'Vân Dương',
            prefix: 'Phường',
          },
          {
            id: '3007',
            name: 'Vệ An',
            prefix: 'Phường',
          },
          {
            id: '3008',
            name: 'Võ Cường',
            prefix: 'Phường',
          },
          {
            id: '3009',
            name: 'Vũ Ninh',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '218',
        name: 'Gia Bình',
        wards: [
          {
            id: '3010',
            name: 'Bình Dương',
            prefix: 'Xã',
          },
          {
            id: '3011',
            name: 'Cao Đức',
            prefix: 'Xã',
          },
          {
            id: '3012',
            name: 'Đại Bái',
            prefix: 'Xã',
          },
          {
            id: '3013',
            name: 'Đại Lai',
            prefix: 'Xã',
          },
          {
            id: '3014',
            name: 'Đông Cứu',
            prefix: 'Xã',
          },
          {
            id: '3015',
            name: 'Gia Bình',
            prefix: 'Thị trấn',
          },
          {
            id: '3016',
            name: 'Giang Sơn',
            prefix: 'Xã',
          },
          {
            id: '3017',
            name: 'Lãng Ngâm',
            prefix: 'Xã',
          },
          {
            id: '3018',
            name: 'Nhân Thắng',
            prefix: 'Xã',
          },
          {
            id: '3019',
            name: 'Quỳnh Phú',
            prefix: 'Xã',
          },
          {
            id: '3020',
            name: 'Song Giang',
            prefix: 'Xã',
          },
          {
            id: '3021',
            name: 'Thái Bảo',
            prefix: 'Xã',
          },
          {
            id: '3022',
            name: 'Vạn Ninh',
            prefix: 'Xã',
          },
          {
            id: '3023',
            name: 'Xuân Lai',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '219',
        name: 'Lương Tài',
        wards: [
          {
            id: '3024',
            name: 'An Thịnh',
            prefix: 'Xã',
          },
          {
            id: '3025',
            name: 'Bình Định',
            prefix: 'Xã',
          },
          {
            id: '3026',
            name: 'Lai Hạ',
            prefix: 'Xã',
          },
          {
            id: '3027',
            name: 'Lâm Thao',
            prefix: 'Xã',
          },
          {
            id: '3028',
            name: 'Minh Tân',
            prefix: 'Xã',
          },
          {
            id: '3029',
            name: 'Mỹ Hương',
            prefix: 'Xã',
          },
          {
            id: '3030',
            name: 'Phú Hòa',
            prefix: 'Xã',
          },
          {
            id: '3031',
            name: 'Phú Lương',
            prefix: 'Xã',
          },
          {
            id: '3032',
            name: 'Quảng Phú',
            prefix: 'Xã',
          },
          {
            id: '3033',
            name: 'Tân Lãng',
            prefix: 'Xã',
          },
          {
            id: '3034',
            name: 'Thứa',
            prefix: 'Thị trấn',
          },
          {
            id: '3035',
            name: 'Trung Chính',
            prefix: 'Xã',
          },
          {
            id: '3036',
            name: 'Trung Kênh',
            prefix: 'Xã',
          },
          {
            id: '3037',
            name: 'Trừng Xá',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '220',
        name: 'Quế Võ',
        wards: [
          {
            id: '3038',
            name: 'Bằng An',
            prefix: 'Xã',
          },
          {
            id: '3039',
            name: 'Bồng Lai',
            prefix: 'Xã',
          },
          {
            id: '3040',
            name: 'Cách Bi',
            prefix: 'Xã',
          },
          {
            id: '3041',
            name: 'Châu Phong',
            prefix: 'Xã',
          },
          {
            id: '3042',
            name: 'Chi Lăng',
            prefix: 'Xã',
          },
          {
            id: '3043',
            name: 'Đại Xuân',
            prefix: 'Xã',
          },
          {
            id: '3044',
            name: 'Đào Viên',
            prefix: 'Xã',
          },
          {
            id: '3045',
            name: 'Đức Long',
            prefix: 'Xã',
          },
          {
            id: '3046',
            name: 'Hán Quảng',
            prefix: 'Xã',
          },
          {
            id: '3047',
            name: 'Mộ Đạo',
            prefix: 'Xã',
          },
          {
            id: '3048',
            name: 'Ngọc Xá',
            prefix: 'Xã',
          },
          {
            id: '3049',
            name: 'Nhân Hoà',
            prefix: 'Xã',
          },
          {
            id: '3050',
            name: 'Phố Mới',
            prefix: 'Thị trấn',
          },
          {
            id: '3051',
            name: 'Phù Lãng',
            prefix: 'Xã',
          },
          {
            id: '3052',
            name: 'Phù Lương',
            prefix: 'Xã',
          },
          {
            id: '3053',
            name: 'Phương Liễu',
            prefix: 'Xã',
          },
          {
            id: '3054',
            name: 'Phượng Mao',
            prefix: 'Xã',
          },
          {
            id: '3055',
            name: 'Quế Tân',
            prefix: 'Xã',
          },
          {
            id: '3056',
            name: 'Việt Hùng',
            prefix: 'Xã',
          },
          {
            id: '3057',
            name: 'Việt Thống',
            prefix: 'Xã',
          },
          {
            id: '3058',
            name: 'Yên Giả',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '221',
        name: 'Thuận Thành',
        wards: [
          {
            id: '3059',
            name: 'An Bình',
            prefix: 'Xã',
          },
          {
            id: '3060',
            name: 'Đại Đồng Thành',
            prefix: 'Xã',
          },
          {
            id: '3061',
            name: 'Đình Tổ',
            prefix: 'Xã',
          },
          {
            id: '3062',
            name: 'Gia Đông',
            prefix: 'Xã',
          },
          {
            id: '3063',
            name: 'Hà Mãn',
            prefix: 'Xã',
          },
          {
            id: '3064',
            name: 'Hồ',
            prefix: 'Thị trấn',
          },
          {
            id: '3065',
            name: 'Hồ Huyện',
            prefix: 'Thị trấn',
          },
          {
            id: '3066',
            name: 'Hoài Thượng',
            prefix: 'Xã',
          },
          {
            id: '3067',
            name: 'Mão Điền',
            prefix: 'Xã',
          },
          {
            id: '3068',
            name: 'Nghĩa Đạo',
            prefix: 'Xã',
          },
          {
            id: '3069',
            name: 'Ngũ Thái',
            prefix: 'Xã',
          },
          {
            id: '3070',
            name: 'Nguyệt Đức',
            prefix: 'Xã',
          },
          {
            id: '3071',
            name: 'Ninh Xá',
            prefix: 'Xã',
          },
          {
            id: '3072',
            name: 'Song Hồ',
            prefix: 'Xã',
          },
          {
            id: '3073',
            name: 'Song Liễu',
            prefix: 'Xã',
          },
          {
            id: '3074',
            name: 'Thanh Khương',
            prefix: 'Xã',
          },
          {
            id: '3075',
            name: 'Trạm Lộ',
            prefix: 'Xã',
          },
          {
            id: '3076',
            name: 'Trí Quả',
            prefix: 'Xã',
          },
          {
            id: '3077',
            name: 'Xuân Lâm',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '222',
        name: 'Tiên Du',
        wards: [
          {
            id: '3078',
            name: 'Cảnh Hưng',
            prefix: 'Xã',
          },
          {
            id: '3079',
            name: 'Đại Đồng',
            prefix: 'Xã',
          },
          {
            id: '3080',
            name: 'Hiên Vân',
            prefix: 'Xã',
          },
          {
            id: '3081',
            name: 'Hoàn Sơn',
            prefix: 'Xã',
          },
          {
            id: '3082',
            name: 'Lạc Vệ',
            prefix: 'Xã',
          },
          {
            id: '3083',
            name: 'Liên Bão',
            prefix: 'Xã',
          },
          {
            id: '3084',
            name: 'Lim',
            prefix: 'Thị trấn',
          },
          {
            id: '3085',
            name: 'Minh Đạo',
            prefix: 'Xã',
          },
          {
            id: '3086',
            name: 'Nội Duệ',
            prefix: 'Xã',
          },
          {
            id: '3087',
            name: 'Phật Tích',
            prefix: 'Xã',
          },
          {
            id: '3088',
            name: 'Phú Lâm',
            prefix: 'Xã',
          },
          {
            id: '3089',
            name: 'Tân Chi',
            prefix: 'Xã',
          },
          {
            id: '3090',
            name: 'Tri Phương',
            prefix: 'Xã',
          },
          {
            id: '3091',
            name: 'Việt Đoàn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '223',
        name: 'Từ Sơn',
        wards: [
          {
            id: '3092',
            name: 'Châu Khê',
            prefix: 'Phường',
          },
          {
            id: '3093',
            name: 'Đình Bảng',
            prefix: 'Phường',
          },
          {
            id: '3094',
            name: 'Đồng Kỵ',
            prefix: 'Phường',
          },
          {
            id: '3095',
            name: 'Đông Ngàn',
            prefix: 'Phường',
          },
          {
            id: '3096',
            name: 'Đồng Nguyên',
            prefix: 'Phường',
          },
          {
            id: '3097',
            name: 'Đồng Nguyên',
            prefix: 'Xã',
          },
          {
            id: '3098',
            name: 'Hương Mạc',
            prefix: 'Xã',
          },
          {
            id: '3099',
            name: 'Phù Chẩn',
            prefix: 'Xã',
          },
          {
            id: '3100',
            name: 'Phù Khê',
            prefix: 'Xã',
          },
          {
            id: '3101',
            name: 'Tam Sơn',
            prefix: 'Xã',
          },
          {
            id: '3102',
            name: 'Tân Hồng',
            prefix: 'Phường',
          },
          {
            id: '3103',
            name: 'Trang Hạ',
            prefix: 'Phường',
          },
          {
            id: '3104',
            name: 'Tương Giang',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '224',
        name: 'Yên Phong',
        wards: [
          {
            id: '3105',
            name: 'Chờ',
            prefix: 'Thị trấn',
          },
          {
            id: '3109',
            name: 'Dũng Liệt',
            prefix: 'Xã',
          },
          {
            id: '3106',
            name: 'Đông Phong',
            prefix: 'Xã',
          },
          {
            id: '3107',
            name: 'Đông Thọ',
            prefix: 'Xã',
          },
          {
            id: '3108',
            name: 'Đông Tiến',
            prefix: 'Xã',
          },
          {
            id: '3110',
            name: 'Hòa Tiến',
            prefix: 'Xã',
          },
          {
            id: '3111',
            name: 'Long Châu',
            prefix: 'Xã',
          },
          {
            id: '3112',
            name: 'Tam Đa',
            prefix: 'Xã',
          },
          {
            id: '3113',
            name: 'Tam Giang',
            prefix: 'Xã',
          },
          {
            id: '3114',
            name: 'Thụy Hòa',
            prefix: 'Xã',
          },
          {
            id: '3115',
            name: 'Trung Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '3116',
            name: 'Văn Môn',
            prefix: 'Xã',
          },
          {
            id: '3117',
            name: 'Yên Phụ',
            prefix: 'Xã',
          },
          {
            id: '3118',
            name: 'Yên Trung',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '18',
    code: 'QNI',
    name: 'Quảng Ninh',
    districts: [
      {
        id: '225',
        name: 'Ba Chẽ',
        wards: [
          {
            id: '3119',
            name: 'Ba Chẽ',
            prefix: 'Thị trấn',
          },
          {
            id: '3120',
            name: 'Đạp Thanh',
            prefix: 'Xã',
          },
          {
            id: '3121',
            name: 'Đồn Đạc',
            prefix: 'Xã',
          },
          {
            id: '3122',
            name: 'Lương Mông',
            prefix: 'Xã',
          },
          {
            id: '3123',
            name: 'Minh Cầm',
            prefix: 'Xã',
          },
          {
            id: '3124',
            name: 'Nam Sơn',
            prefix: 'Xã',
          },
          {
            id: '3125',
            name: 'Thanh Lâm',
            prefix: 'Xã',
          },
          {
            id: '3126',
            name: 'Thanh Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '226',
        name: 'Bình Liêu',
        wards: [
          {
            id: '3127',
            name: 'Bình Liêu',
            prefix: 'Thị trấn',
          },
          {
            id: '3128',
            name: 'Đồng Tâm',
            prefix: 'Xã',
          },
          {
            id: '3129',
            name: 'Đồng Văn',
            prefix: 'Xã',
          },
          {
            id: '3130',
            name: 'Hoành Mô',
            prefix: 'Xã',
          },
          {
            id: '3131',
            name: 'Húc Động',
            prefix: 'Xã',
          },
          {
            id: '3132',
            name: 'Lục Hồn',
            prefix: 'Xã',
          },
          {
            id: '3133',
            name: 'Tình Húc',
            prefix: 'Xã',
          },
          {
            id: '3134',
            name: 'Vô Ngại',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '227',
        name: 'Cẩm Phả',
        wards: [
          {
            id: '3135',
            name: 'Cẩm Bình',
            prefix: 'Phường',
          },
          {
            id: '3136',
            name: 'Cẩm Đông',
            prefix: 'Phường',
          },
          {
            id: '3137',
            name: 'Cẩm Hải',
            prefix: 'Xã',
          },
          {
            id: '3138',
            name: 'Cẩm Phú',
            prefix: 'Phường',
          },
          {
            id: '3139',
            name: 'Cẩm Sơn',
            prefix: 'Phường',
          },
          {
            id: '3140',
            name: 'Cẩm Tây',
            prefix: 'Phường',
          },
          {
            id: '3141',
            name: 'Cẩm Thạch',
            prefix: 'Phường',
          },
          {
            id: '3142',
            name: 'Cẩm Thành',
            prefix: 'Phường',
          },
          {
            id: '3143',
            name: 'Cẩm Thịnh',
            prefix: 'Phường',
          },
          {
            id: '3144',
            name: 'Cẩm Thuỷ',
            prefix: 'Phường',
          },
          {
            id: '3145',
            name: 'Cẩm Trung',
            prefix: 'Phường',
          },
          {
            id: '3146',
            name: 'Cộng Hoà',
            prefix: 'Xã',
          },
          {
            id: '3147',
            name: 'Cửa Ông',
            prefix: 'Phường',
          },
          {
            id: '3148',
            name: 'Dương Huy',
            prefix: 'Xã',
          },
          {
            id: '3149',
            name: 'Mông Dương',
            prefix: 'Phường',
          },
          {
            id: '3150',
            name: 'Quang Hanh',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '228',
        name: 'Cô Tô',
        wards: [
          {
            id: '3151',
            name: 'Cô Tô',
            prefix: 'Thị trấn',
          },
          {
            id: '3152',
            name: 'Đảo Trần',
            prefix: 'Xã',
          },
          {
            id: '3153',
            name: 'Đồng Tiến',
            prefix: 'Xã',
          },
          {
            id: '3154',
            name: 'Thanh Lân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '229',
        name: 'Đầm Hà',
        wards: [
          {
            id: '3158',
            name: 'Dực Yên',
            prefix: 'Xã',
          },
          {
            id: '3155',
            name: 'Đại Bình',
            prefix: 'Xã',
          },
          {
            id: '3156',
            name: 'Đầm Hà',
            prefix: 'Thị trấn',
          },
          {
            id: '3157',
            name: 'Đầm Hà',
            prefix: 'Xã',
          },
          {
            id: '3159',
            name: 'Quảng An',
            prefix: 'Xã',
          },
          {
            id: '3160',
            name: 'Quảng Lâm',
            prefix: 'Xã',
          },
          {
            id: '3161',
            name: 'Quảng Lợi',
            prefix: 'Xã',
          },
          {
            id: '3162',
            name: 'Quảng Tân',
            prefix: 'Xã',
          },
          {
            id: '3163',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '3164',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '230',
        name: 'Đông Triều',
        wards: [
          {
            id: '3165',
            name: 'An Sinh',
            prefix: 'Xã',
          },
          {
            id: '3166',
            name: 'Bình Dương',
            prefix: 'Xã',
          },
          {
            id: '3167',
            name: 'Bình Khê',
            prefix: 'Xã',
          },
          {
            id: '3168',
            name: 'Đông Triều',
            prefix: 'Thị trấn',
          },
          {
            id: '3169',
            name: 'Đức Chính',
            prefix: 'Xã',
          },
          {
            id: '3170',
            name: 'Hoàng Quế',
            prefix: 'Xã',
          },
          {
            id: '3171',
            name: 'Hồng Phong',
            prefix: 'Xã',
          },
          {
            id: '3172',
            name: 'Hồng Thái Đông',
            prefix: 'Xã',
          },
          {
            id: '3173',
            name: 'Hồng Thái Tây',
            prefix: 'Xã',
          },
          {
            id: '3174',
            name: 'Hưng Đạo',
            prefix: 'Xã',
          },
          {
            id: '3175',
            name: 'Kim Sơn',
            prefix: 'Xã',
          },
          {
            id: '3176',
            name: 'Mạo Khê',
            prefix: 'Thị trấn',
          },
          {
            id: '3177',
            name: 'Nguyễn Huệ',
            prefix: 'Xã',
          },
          {
            id: '3178',
            name: 'Tân Việt',
            prefix: 'Xã',
          },
          {
            id: '3179',
            name: 'Thủy An',
            prefix: 'Xã',
          },
          {
            id: '3180',
            name: 'Tràng An',
            prefix: 'Xã',
          },
          {
            id: '3181',
            name: 'Tràng Lương',
            prefix: 'Xã',
          },
          {
            id: '3182',
            name: 'Việt Dân',
            prefix: 'Xã',
          },
          {
            id: '3183',
            name: 'Xuân Sơn',
            prefix: 'Xã',
          },
          {
            id: '3184',
            name: 'Yên Đức',
            prefix: 'Xã',
          },
          {
            id: '3185',
            name: 'Yên Thọ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '231',
        name: 'Hạ Long',
        wards: [
          {
            id: '3186',
            name: 'Bạch Đằng',
            prefix: 'Phường',
          },
          {
            id: '3187',
            name: 'Bãi Cháy',
            prefix: 'Phường',
          },
          {
            id: '3188',
            name: 'Cao Thắng',
            prefix: 'Phường',
          },
          {
            id: '3189',
            name: 'Cao Xanh',
            prefix: 'Phường',
          },
          {
            id: '3190',
            name: 'Đại Yên',
            prefix: 'Phường',
          },
          {
            id: '3191',
            name: 'Giếng Đáy',
            prefix: 'Phường',
          },
          {
            id: '3192',
            name: 'Hà Khánh',
            prefix: 'Phường',
          },
          {
            id: '3193',
            name: 'Hà Khẩu',
            prefix: 'Phường',
          },
          {
            id: '3194',
            name: 'Hà Lầm',
            prefix: 'Phường',
          },
          {
            id: '3195',
            name: 'Hà Phong',
            prefix: 'Phường',
          },
          {
            id: '3196',
            name: 'Hà Trung',
            prefix: 'Phường',
          },
          {
            id: '3197',
            name: 'Hà Tu',
            prefix: 'Phường',
          },
          {
            id: '3198',
            name: 'Hồng Gai',
            prefix: 'Phường',
          },
          {
            id: '3199',
            name: 'Hồng Hà',
            prefix: 'Phường',
          },
          {
            id: '3200',
            name: 'Hồng Hải',
            prefix: 'Phường',
          },
          {
            id: '3201',
            name: 'Hùng Thắng',
            prefix: 'Phường',
          },
          {
            id: '3202',
            name: 'Trần Hưng Đạo',
            prefix: 'Phường',
          },
          {
            id: '3203',
            name: 'Tuần Châu',
            prefix: 'Phường',
          },
          {
            id: '3204',
            name: 'Việt Hưng',
            prefix: 'Phường',
          },
          {
            id: '3205',
            name: 'Yết Kiêu',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '232',
        name: 'Hải Hà',
        wards: [
          {
            id: '3206',
            name: 'Cái Chiên',
            prefix: 'Xã',
          },
          {
            id: '3207',
            name: 'Đảo Cái Chiên',
            prefix: 'Xã',
          },
          {
            id: '3208',
            name: 'Đường Hoa',
            prefix: 'Xã',
          },
          {
            id: '3209',
            name: 'Phú Hải',
            prefix: 'Xã',
          },
          {
            id: '3210',
            name: 'Quảng Chính',
            prefix: 'Xã',
          },
          {
            id: '3211',
            name: 'Quảng Điền',
            prefix: 'Xã',
          },
          {
            id: '3212',
            name: 'Quảng Đức',
            prefix: 'Xã',
          },
          {
            id: '3213',
            name: 'Quảng Hà',
            prefix: 'Thị trấn',
          },
          {
            id: '3214',
            name: 'Quảng Long',
            prefix: 'Xã',
          },
          {
            id: '3215',
            name: 'Quảng Minh',
            prefix: 'Xã',
          },
          {
            id: '3216',
            name: 'Quảng Phong',
            prefix: 'Xã',
          },
          {
            id: '3217',
            name: 'Quảng Sơn',
            prefix: 'Xã',
          },
          {
            id: '3218',
            name: 'Quảng Thắng',
            prefix: 'Xã',
          },
          {
            id: '3219',
            name: 'Quảng Thành',
            prefix: 'Xã',
          },
          {
            id: '3220',
            name: 'Quảng Thịnh',
            prefix: 'Xã',
          },
          {
            id: '3221',
            name: 'Quảng Trung',
            prefix: 'Xã',
          },
          {
            id: '3222',
            name: 'Tiến Tới',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '233',
        name: 'Hoành Bồ',
        wards: [
          {
            id: '3223',
            name: 'Bằng Cả',
            prefix: 'Xã',
          },
          {
            id: '3224',
            name: 'Dân Chủ',
            prefix: 'Xã',
          },
          {
            id: '3225',
            name: 'Đồng Lâm',
            prefix: 'Xã',
          },
          {
            id: '3226',
            name: 'Đồng Sơn',
            prefix: 'Xã',
          },
          {
            id: '3227',
            name: 'Hoà Bình',
            prefix: 'Xã',
          },
          {
            id: '3228',
            name: 'Kỳ Thượng',
            prefix: 'Xã',
          },
          {
            id: '3229',
            name: 'Lê Lợi',
            prefix: 'Xã',
          },
          {
            id: '3230',
            name: 'Quảng La',
            prefix: 'Xã',
          },
          {
            id: '3231',
            name: 'Sơn Dương',
            prefix: 'Xã',
          },
          {
            id: '3232',
            name: 'Tân Dân',
            prefix: 'Xã',
          },
          {
            id: '3233',
            name: 'Thống Nhất',
            prefix: 'Xã',
          },
          {
            id: '3234',
            name: 'Trới',
            prefix: 'Thị trấn',
          },
          {
            id: '3235',
            name: 'Vũ Oai',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '234',
        name: 'Móng Cái',
        wards: [
          {
            id: '3236',
            name: 'Bắc Sơn',
            prefix: 'Xã',
          },
          {
            id: '3237',
            name: 'Bình Ngọc',
            prefix: 'Phường',
          },
          {
            id: '3238',
            name: 'Hải Đông',
            prefix: 'Xã',
          },
          {
            id: '3239',
            name: 'Hải Hòa',
            prefix: 'Phường',
          },
          {
            id: '3240',
            name: 'Hải Sơn',
            prefix: 'Xã',
          },
          {
            id: '3241',
            name: 'Hải Tiến',
            prefix: 'Xã',
          },
          {
            id: '3242',
            name: 'Hải Xuân',
            prefix: 'Xã',
          },
          {
            id: '3243',
            name: 'Hải Yên',
            prefix: 'Phường',
          },
          {
            id: '3244',
            name: 'Hòa Lạc',
            prefix: 'Phường',
          },
          {
            id: '3245',
            name: 'Ka Long',
            prefix: 'Phường',
          },
          {
            id: '3246',
            name: 'Ninh Dương',
            prefix: 'Phường',
          },
          {
            id: '3247',
            name: 'Quảng Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '3248',
            name: 'Trà Cổ',
            prefix: 'Phường',
          },
          {
            id: '3249',
            name: 'Trần Phú',
            prefix: 'Phường',
          },
          {
            id: '3250',
            name: 'Vạn Ninh',
            prefix: 'Xã',
          },
          {
            id: '3251',
            name: 'Vĩnh Thực',
            prefix: 'Xã',
          },
          {
            id: '3252',
            name: 'Vĩnh Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '235',
        name: 'Quảng Yên',
        wards: [
          {
            id: '3253',
            name: 'Cẩm La',
            prefix: 'Xã',
          },
          {
            id: '3254',
            name: 'Cộng Hòa',
            prefix: 'Phường',
          },
          {
            id: '3255',
            name: 'Đông Mai',
            prefix: 'Phường',
          },
          {
            id: '3256',
            name: 'Hà An',
            prefix: 'Phường',
          },
          {
            id: '3257',
            name: 'Hiệp Hòa',
            prefix: 'Xã',
          },
          {
            id: '3258',
            name: 'Hoàng Tân',
            prefix: 'Xã',
          },
          {
            id: '3259',
            name: 'Liên Hòa',
            prefix: 'Xã',
          },
          {
            id: '3260',
            name: 'Liên Vị',
            prefix: 'Xã',
          },
          {
            id: '3261',
            name: 'Minh Thành',
            prefix: 'Phường',
          },
          {
            id: '3262',
            name: 'Nam Hòa',
            prefix: 'Phường',
          },
          {
            id: '3263',
            name: 'Phong Cốc',
            prefix: 'Phường',
          },
          {
            id: '3264',
            name: 'Phong Hải',
            prefix: 'Phường',
          },
          {
            id: '3265',
            name: 'Quảng Yên',
            prefix: 'Phường',
          },
          {
            id: '3266',
            name: 'Sông Khoai',
            prefix: 'Xã',
          },
          {
            id: '3267',
            name: 'Tân An',
            prefix: 'Phường',
          },
          {
            id: '3268',
            name: 'Tiền An',
            prefix: 'Xã',
          },
          {
            id: '3269',
            name: 'Tiền Phong',
            prefix: 'Xã',
          },
          {
            id: '3270',
            name: 'Yên Giang',
            prefix: 'Phường',
          },
          {
            id: '3271',
            name: 'Yên Hải',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '236',
        name: 'Tiên Yên',
        wards: [
          {
            id: '3272',
            name: 'Đại Dực',
            prefix: 'Xã',
          },
          {
            id: '3273',
            name: 'Đại Thành',
            prefix: 'Xã',
          },
          {
            id: '3274',
            name: 'Điền Xá',
            prefix: 'Xã',
          },
          {
            id: '3275',
            name: 'Đông Hải',
            prefix: 'Xã',
          },
          {
            id: '3276',
            name: 'Đông Ngũ',
            prefix: 'Xã',
          },
          {
            id: '3277',
            name: 'Đồng Rui',
            prefix: 'Xã',
          },
          {
            id: '3278',
            name: 'Hà Lâu',
            prefix: 'Xã',
          },
          {
            id: '3279',
            name: 'Hải Lạng',
            prefix: 'Xã',
          },
          {
            id: '3280',
            name: 'Phong Dụ',
            prefix: 'Xã',
          },
          {
            id: '3281',
            name: 'Tiên Lãng',
            prefix: 'Xã',
          },
          {
            id: '3282',
            name: 'Tiên Yên',
            prefix: 'Thị trấn',
          },
          {
            id: '3283',
            name: 'Yên Than',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '237',
        name: 'Uông Bí',
        wards: [
          {
            id: '3284',
            name: 'Bắc Sơn',
            prefix: 'Phường',
          },
          {
            id: '3285',
            name: 'Điền Công',
            prefix: 'Xã',
          },
          {
            id: '3286',
            name: 'Nam Khê',
            prefix: 'Phường',
          },
          {
            id: '3287',
            name: 'Phương Đông',
            prefix: 'Phường',
          },
          {
            id: '3288',
            name: 'Phương Nam',
            prefix: 'Phường',
          },
          {
            id: '3289',
            name: 'Quang Trung',
            prefix: 'Phường',
          },
          {
            id: '3290',
            name: 'Thanh Sơn',
            prefix: 'Phường',
          },
          {
            id: '3291',
            name: 'Thượng Yên Công',
            prefix: 'Xã',
          },
          {
            id: '3292',
            name: 'Trưng Vương',
            prefix: 'Phường',
          },
          {
            id: '3293',
            name: 'Vàng Danh',
            prefix: 'Phường',
          },
          {
            id: '3294',
            name: 'Yên Thanh',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '238',
        name: 'Vân Đồn',
        wards: [
          {
            id: '3295',
            name: 'Bản Sen',
            prefix: 'Xã',
          },
          {
            id: '3296',
            name: 'Bình Dân',
            prefix: 'Xã',
          },
          {
            id: '3297',
            name: 'Cái Rồng',
            prefix: 'Thị trấn',
          },
          {
            id: '3298',
            name: 'Đài Xuyên',
            prefix: 'Xã',
          },
          {
            id: '3299',
            name: 'Đoàn Kết',
            prefix: 'Xã',
          },
          {
            id: '3300',
            name: 'Đông Xá',
            prefix: 'Xã',
          },
          {
            id: '3301',
            name: 'Hạ Long',
            prefix: 'Xã',
          },
          {
            id: '3302',
            name: 'Minh Châu',
            prefix: 'Xã',
          },
          {
            id: '3303',
            name: 'Ngọc Vừng',
            prefix: 'Xã',
          },
          {
            id: '3304',
            name: 'Quan Lạn',
            prefix: 'Xã',
          },
          {
            id: '3305',
            name: 'Thắng Lợi',
            prefix: 'Xã',
          },
          {
            id: '3306',
            name: 'Vạn Yên',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '19',
    code: 'TH',
    name: 'Thanh Hóa',
    districts: [
      {
        id: '239',
        name: 'Bá Thước',
        wards: [
          {
            id: '3307',
            name: 'Ái Thượng',
            prefix: 'Xã',
          },
          {
            id: '3308',
            name: 'Ban Công',
            prefix: 'Xã',
          },
          {
            id: '3309',
            name: 'Cành Nàng',
            prefix: 'Thị trấn',
          },
          {
            id: '3310',
            name: 'Cổ Lũng',
            prefix: 'Xã',
          },
          {
            id: '3311',
            name: 'Điền Hạ',
            prefix: 'Xã',
          },
          {
            id: '3312',
            name: 'Điền Lư',
            prefix: 'Xã',
          },
          {
            id: '3313',
            name: 'Điền Quang',
            prefix: 'Xã',
          },
          {
            id: '3314',
            name: 'Điền Thượng',
            prefix: 'Xã',
          },
          {
            id: '3315',
            name: 'Điền Trung',
            prefix: 'Xã',
          },
          {
            id: '3316',
            name: 'Hạ Trung',
            prefix: 'Xã',
          },
          {
            id: '3317',
            name: 'Kỳ Tân',
            prefix: 'Xã',
          },
          {
            id: '3318',
            name: 'Lâm Xa',
            prefix: 'Xã',
          },
          {
            id: '3319',
            name: 'Lũng Cao',
            prefix: 'Xã',
          },
          {
            id: '3320',
            name: 'Lũng Niêm',
            prefix: 'Xã',
          },
          {
            id: '3321',
            name: 'Lương Ngoại',
            prefix: 'Xã',
          },
          {
            id: '3322',
            name: 'Lương Nội',
            prefix: 'Xã',
          },
          {
            id: '3323',
            name: 'Lương Trung',
            prefix: 'Xã',
          },
          {
            id: '3324',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '3325',
            name: 'Thành Lâm',
            prefix: 'Xã',
          },
          {
            id: '3326',
            name: 'Thánh Sơn',
            prefix: 'Xã',
          },
          {
            id: '3327',
            name: 'Thiết Kế',
            prefix: 'Xã',
          },
          {
            id: '3328',
            name: 'Thiết Ống',
            prefix: 'Xã',
          },
          {
            id: '3329',
            name: 'Văn Nho',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '240',
        name: 'Bỉm Sơn',
        wards: [
          {
            id: '3330',
            name: 'Ba Đình',
            prefix: 'Phường',
          },
          {
            id: '3331',
            name: 'Bắc Sơn',
            prefix: 'Phường',
          },
          {
            id: '3332',
            name: 'Đông Sơn',
            prefix: 'Phường',
          },
          {
            id: '3333',
            name: 'Hà Lan',
            prefix: 'Xã',
          },
          {
            id: '3334',
            name: 'Lam Sơn',
            prefix: 'Phường',
          },
          {
            id: '3335',
            name: 'Ngọc Trạo',
            prefix: 'Phường',
          },
          {
            id: '3336',
            name: 'Phú Sơn',
            prefix: 'Phường',
          },
          {
            id: '3337',
            name: 'Quang Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '241',
        name: 'Cẩm Thủy',
        wards: [
          {
            id: '3338',
            name: 'Cẩm Bình',
            prefix: 'Xã',
          },
          {
            id: '3339',
            name: 'Cẩm Châu',
            prefix: 'Xã',
          },
          {
            id: '3340',
            name: 'Cẩm Giang',
            prefix: 'Xã',
          },
          {
            id: '3341',
            name: 'Cẩm Liên',
            prefix: 'Xã',
          },
          {
            id: '3342',
            name: 'Cẩm Long',
            prefix: 'Xã',
          },
          {
            id: '3343',
            name: 'Cẩm Lương',
            prefix: 'Xã',
          },
          {
            id: '3344',
            name: 'Cẩm Ngọc',
            prefix: 'Xã',
          },
          {
            id: '3345',
            name: 'Cẩm Phong',
            prefix: 'Xã',
          },
          {
            id: '3346',
            name: 'Cẩm Phú',
            prefix: 'Xã',
          },
          {
            id: '3347',
            name: 'Cẩm Quý',
            prefix: 'Xã',
          },
          {
            id: '3348',
            name: 'Cẩm Sơn',
            prefix: 'Xã',
          },
          {
            id: '3349',
            name: 'Cẩm Tâm',
            prefix: 'Xã',
          },
          {
            id: '3350',
            name: 'Cẩm Tân',
            prefix: 'Xã',
          },
          {
            id: '3351',
            name: 'Cẩm Thạch',
            prefix: 'Xã',
          },
          {
            id: '3352',
            name: 'Cẩm Thành',
            prefix: 'Xã',
          },
          {
            id: '3353',
            name: 'Cẩm Thủy',
            prefix: 'Thị trấn',
          },
          {
            id: '3354',
            name: 'Cẩm Tú',
            prefix: 'Xã',
          },
          {
            id: '3355',
            name: 'Cẩm Vân',
            prefix: 'Xã',
          },
          {
            id: '3356',
            name: 'Cẩm Yên',
            prefix: 'Xã',
          },
          {
            id: '3357',
            name: 'Phúc Do',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '242',
        name: 'Đông Sơn',
        wards: [
          {
            id: '3358',
            name: 'Đông Anh',
            prefix: 'Xã',
          },
          {
            id: '3359',
            name: 'Đông Hòa',
            prefix: 'Xã',
          },
          {
            id: '3360',
            name: 'Đông Hoàng',
            prefix: 'Xã',
          },
          {
            id: '3361',
            name: 'Đông Khê',
            prefix: 'Xã',
          },
          {
            id: '3362',
            name: 'Đông Minh',
            prefix: 'Xã',
          },
          {
            id: '3363',
            name: 'Đông Nam',
            prefix: 'Xã',
          },
          {
            id: '3364',
            name: 'Đông Ninh',
            prefix: 'Xã',
          },
          {
            id: '3365',
            name: 'Đông Phú',
            prefix: 'Xã',
          },
          {
            id: '3366',
            name: 'Đông Quang',
            prefix: 'Xã',
          },
          {
            id: '3367',
            name: 'Đông Thanh',
            prefix: 'Xã',
          },
          {
            id: '3368',
            name: 'Đông Thịnh',
            prefix: 'Xã',
          },
          {
            id: '3369',
            name: 'Đông Tiến',
            prefix: 'Xã',
          },
          {
            id: '3370',
            name: 'Đông Văn',
            prefix: 'Xã',
          },
          {
            id: '3371',
            name: 'Đông Xuân',
            prefix: 'Xã',
          },
          {
            id: '3372',
            name: 'Đông Yên',
            prefix: 'Xã',
          },
          {
            id: '3373',
            name: 'Rừng Thông',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '243',
        name: 'Hà Trung',
        wards: [
          {
            id: '3374',
            name: 'Hà Bắc',
            prefix: 'Xã',
          },
          {
            id: '3375',
            name: 'Hà Bình',
            prefix: 'Xã',
          },
          {
            id: '3376',
            name: 'Hà Châu',
            prefix: 'Xã',
          },
          {
            id: '3378',
            name: 'Hà Dương',
            prefix: 'Xã',
          },
          {
            id: '3377',
            name: 'Hà Đông',
            prefix: 'Xã',
          },
          {
            id: '3379',
            name: 'Hà Giang',
            prefix: 'Xã',
          },
          {
            id: '3380',
            name: 'Hà Hải',
            prefix: 'Xã',
          },
          {
            id: '3381',
            name: 'Hà Lai',
            prefix: 'Xã',
          },
          {
            id: '3382',
            name: 'Hà Lâm',
            prefix: 'Xã',
          },
          {
            id: '3383',
            name: 'Hà Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '3384',
            name: 'Hà Long',
            prefix: 'Xã',
          },
          {
            id: '3385',
            name: 'Hà Ngọc',
            prefix: 'Xã',
          },
          {
            id: '3386',
            name: 'Hà Ninh',
            prefix: 'Xã',
          },
          {
            id: '3387',
            name: 'Hà Phong',
            prefix: 'Xã',
          },
          {
            id: '3388',
            name: 'Hà Phú',
            prefix: 'Xã',
          },
          {
            id: '3389',
            name: 'Hà Sơn',
            prefix: 'Xã',
          },
          {
            id: '3390',
            name: 'Hà Tân',
            prefix: 'Xã',
          },
          {
            id: '3391',
            name: 'Hà Thái',
            prefix: 'Xã',
          },
          {
            id: '3392',
            name: 'Hà Thanh',
            prefix: 'Xã',
          },
          {
            id: '3393',
            name: 'Hà Tiến',
            prefix: 'Xã',
          },
          {
            id: '3394',
            name: 'Hà Toại',
            prefix: 'Xã',
          },
          {
            id: '3395',
            name: 'Hà Trung',
            prefix: 'Thị trấn',
          },
          {
            id: '3396',
            name: 'Hà Vân',
            prefix: 'Xã',
          },
          {
            id: '3397',
            name: 'Hà Vinh',
            prefix: 'Xã',
          },
          {
            id: '3398',
            name: 'Hà Yên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '244',
        name: 'Hậu Lộc',
        wards: [
          {
            id: '3399',
            name: 'Cầu Lộc',
            prefix: 'Xã',
          },
          {
            id: '3400',
            name: 'Châu Lộc',
            prefix: 'Xã',
          },
          {
            id: '3401',
            name: 'Đa Lộc',
            prefix: 'Xã',
          },
          {
            id: '3402',
            name: 'Đại Lộc',
            prefix: 'Xã',
          },
          {
            id: '3403',
            name: 'Đồng Lộc',
            prefix: 'Xã',
          },
          {
            id: '3404',
            name: 'Hải Lộc',
            prefix: 'Xã',
          },
          {
            id: '3405',
            name: 'Hậu Lộc',
            prefix: 'Thị trấn',
          },
          {
            id: '3406',
            name: 'Hoa Lộc',
            prefix: 'Xã',
          },
          {
            id: '3407',
            name: 'Hòa Lộc',
            prefix: 'Xã',
          },
          {
            id: '3408',
            name: 'Hưng Lộc',
            prefix: 'Xã',
          },
          {
            id: '3409',
            name: 'Liên Lộc',
            prefix: 'Xã',
          },
          {
            id: '3410',
            name: 'Lộc Sơn',
            prefix: 'Xã',
          },
          {
            id: '3411',
            name: 'Lộc Tân',
            prefix: 'Xã',
          },
          {
            id: '3412',
            name: 'Minh Lộc',
            prefix: 'Xã',
          },
          {
            id: '3413',
            name: 'Mỹ Lộc',
            prefix: 'Xã',
          },
          {
            id: '3414',
            name: 'Ngư Lộc',
            prefix: 'Xã',
          },
          {
            id: '3415',
            name: 'Phong Lộc',
            prefix: 'Xã',
          },
          {
            id: '3416',
            name: 'Phú Lộc',
            prefix: 'Xã',
          },
          {
            id: '3417',
            name: 'Quang Lộc',
            prefix: 'Xã',
          },
          {
            id: '3418',
            name: 'Thành Lộc',
            prefix: 'Xã',
          },
          {
            id: '3419',
            name: 'Thịnh Lộc',
            prefix: 'Xã',
          },
          {
            id: '3420',
            name: 'Thuần Lộc',
            prefix: 'Xã',
          },
          {
            id: '3421',
            name: 'Tiến Lộc',
            prefix: 'Xã',
          },
          {
            id: '3422',
            name: 'Triệu Lộc',
            prefix: 'Xã',
          },
          {
            id: '3423',
            name: 'Tuy Lộc',
            prefix: 'Xã',
          },
          {
            id: '3424',
            name: 'Văn Lộc',
            prefix: 'Xã',
          },
          {
            id: '3425',
            name: 'Xuân Lộc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '245',
        name: 'Hoằng Hóa',
        wards: [
          {
            id: '3426',
            name: 'Bút Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '3427',
            name: 'Hoằng Cát',
            prefix: 'Xã',
          },
          {
            id: '3428',
            name: 'Hoằng Châu',
            prefix: 'Xã',
          },
          {
            id: '3429',
            name: 'Hoằng Đạo',
            prefix: 'Xã',
          },
          {
            id: '3430',
            name: 'Hoằng Đạt',
            prefix: 'Xã',
          },
          {
            id: '3431',
            name: 'Hoằng Đông',
            prefix: 'Xã',
          },
          {
            id: '3432',
            name: 'Hoằng Đồng',
            prefix: 'Xã',
          },
          {
            id: '3433',
            name: 'Hoằng Đức',
            prefix: 'Xã',
          },
          {
            id: '3434',
            name: 'Hoằng Giang',
            prefix: 'Xã',
          },
          {
            id: '3435',
            name: 'Hoằng Hà',
            prefix: 'Xã',
          },
          {
            id: '3436',
            name: 'Hoằng Hải',
            prefix: 'Xã',
          },
          {
            id: '3437',
            name: 'Hoằng Hợp',
            prefix: 'Xã',
          },
          {
            id: '3438',
            name: 'Hoằng Khánh',
            prefix: 'Xã',
          },
          {
            id: '3439',
            name: 'Hoằng Khê',
            prefix: 'Xã',
          },
          {
            id: '3440',
            name: 'Hoằng Kim',
            prefix: 'Xã',
          },
          {
            id: '3441',
            name: 'Hoằng Lộc',
            prefix: 'Xã',
          },
          {
            id: '3442',
            name: 'Hoằng Lương',
            prefix: 'Xã',
          },
          {
            id: '3443',
            name: 'Hoằng Lưu',
            prefix: 'Xã',
          },
          {
            id: '3444',
            name: 'Hoằng Minh',
            prefix: 'Xã',
          },
          {
            id: '3445',
            name: 'Hoằng Ngọc',
            prefix: 'Xã',
          },
          {
            id: '3446',
            name: 'Hoằng Phong',
            prefix: 'Xã',
          },
          {
            id: '3447',
            name: 'Hoằng Phú',
            prefix: 'Xã',
          },
          {
            id: '3448',
            name: 'Hoằng Phụ',
            prefix: 'Xã',
          },
          {
            id: '3449',
            name: 'Hoằng Phúc',
            prefix: 'Xã',
          },
          {
            id: '3450',
            name: 'Hoằng Phượng',
            prefix: 'Xã',
          },
          {
            id: '3451',
            name: 'Hoằng Quý',
            prefix: 'Xã',
          },
          {
            id: '3452',
            name: 'Hoằng Quỳ',
            prefix: 'Xã',
          },
          {
            id: '3453',
            name: 'Hoằng Sơn',
            prefix: 'Xã',
          },
          {
            id: '3454',
            name: 'Hoằng Tân',
            prefix: 'Xã',
          },
          {
            id: '3455',
            name: 'Hoằng Thái',
            prefix: 'Xã',
          },
          {
            id: '3456',
            name: 'Hoằng Thắng',
            prefix: 'Xã',
          },
          {
            id: '3457',
            name: 'Hoằng Thanh',
            prefix: 'Xã',
          },
          {
            id: '3458',
            name: 'Hoằng Thành',
            prefix: 'Xã',
          },
          {
            id: '3459',
            name: 'Hoằng Thịnh',
            prefix: 'Xã',
          },
          {
            id: '3460',
            name: 'Hoằng Tiến',
            prefix: 'Xã',
          },
          {
            id: '3461',
            name: 'Hoằng Trạch',
            prefix: 'Xã',
          },
          {
            id: '3462',
            name: 'Hoằng Trinh',
            prefix: 'Xã',
          },
          {
            id: '3463',
            name: 'Hoằng Trung',
            prefix: 'Xã',
          },
          {
            id: '3464',
            name: 'Hoằng Trường',
            prefix: 'Xã',
          },
          {
            id: '3465',
            name: 'Hoằng Vinh',
            prefix: 'Xã',
          },
          {
            id: '3466',
            name: 'Hoằng Xuân',
            prefix: 'Xã',
          },
          {
            id: '3467',
            name: 'Hoằng Xuyên',
            prefix: 'Xã',
          },
          {
            id: '3468',
            name: 'Hoằng Yến',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '246',
        name: 'Lang Chánh',
        wards: [
          {
            id: '3469',
            name: 'Đồng Lương',
            prefix: 'Xã',
          },
          {
            id: '3470',
            name: 'Giao An',
            prefix: 'Xã',
          },
          {
            id: '3471',
            name: 'Giao Thiện',
            prefix: 'Xã',
          },
          {
            id: '3472',
            name: 'Lâm Phú',
            prefix: 'Xã',
          },
          {
            id: '3473',
            name: 'Lang Chánh',
            prefix: 'Thị trấn',
          },
          {
            id: '3474',
            name: 'Quang Hiến',
            prefix: 'Xã',
          },
          {
            id: '3475',
            name: 'Tam Văn',
            prefix: 'Xã',
          },
          {
            id: '3476',
            name: 'Tân Phúc',
            prefix: 'Xã',
          },
          {
            id: '3477',
            name: 'Trí Nang',
            prefix: 'Xã',
          },
          {
            id: '3478',
            name: 'Yên Khương',
            prefix: 'Xã',
          },
          {
            id: '3479',
            name: 'Yên Thắng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '247',
        name: 'Mường Lát',
        wards: [
          {
            id: '3480',
            name: 'Mường Chanh',
            prefix: 'Xã',
          },
          {
            id: '3481',
            name: 'Mường Lát',
            prefix: 'Thị trấn',
          },
          {
            id: '3482',
            name: 'Mường Lý',
            prefix: 'Xã',
          },
          {
            id: '3483',
            name: 'Nhi Sơn',
            prefix: 'Xã',
          },
          {
            id: '3484',
            name: 'Pù Nhi',
            prefix: 'Xã',
          },
          {
            id: '3485',
            name: 'Quang Chiểu',
            prefix: 'Xã',
          },
          {
            id: '3486',
            name: 'Tam Chung',
            prefix: 'Xã',
          },
          {
            id: '3487',
            name: 'Tén Tằn',
            prefix: 'Xã',
          },
          {
            id: '3488',
            name: 'Trung Lý',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '248',
        name: 'Nga Sơn',
        wards: [
          {
            id: '3489',
            name: 'Ba Đình',
            prefix: 'Xã',
          },
          {
            id: '3490',
            name: 'Nga An',
            prefix: 'Xã',
          },
          {
            id: '3491',
            name: 'Nga Bạch',
            prefix: 'Xã',
          },
          {
            id: '3492',
            name: 'Nga Điền',
            prefix: 'Xã',
          },
          {
            id: '3493',
            name: 'Nga Giáp',
            prefix: 'Xã',
          },
          {
            id: '3494',
            name: 'Nga Hải',
            prefix: 'Xã',
          },
          {
            id: '3495',
            name: 'Nga Hưng',
            prefix: 'Xã',
          },
          {
            id: '3496',
            name: 'Nga Liên',
            prefix: 'Xã',
          },
          {
            id: '3497',
            name: 'Nga Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '3498',
            name: 'Nga Mỹ',
            prefix: 'Xã',
          },
          {
            id: '3499',
            name: 'Nga Nhân',
            prefix: 'Xã',
          },
          {
            id: '3500',
            name: 'Nga Phú',
            prefix: 'Xã',
          },
          {
            id: '3501',
            name: 'Nga Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '3502',
            name: 'Nga Tân',
            prefix: 'Xã',
          },
          {
            id: '3503',
            name: 'Nga Thạch',
            prefix: 'Xã',
          },
          {
            id: '3504',
            name: 'Nga Thái',
            prefix: 'Xã',
          },
          {
            id: '3505',
            name: 'Nga Thắng',
            prefix: 'Xã',
          },
          {
            id: '3506',
            name: 'Nga Thanh',
            prefix: 'Xã',
          },
          {
            id: '3507',
            name: 'Nga Thành',
            prefix: 'Xã',
          },
          {
            id: '3508',
            name: 'Nga Thiện',
            prefix: 'Xã',
          },
          {
            id: '3509',
            name: 'Nga Thuỷ',
            prefix: 'Xã',
          },
          {
            id: '3510',
            name: 'Nga Tiến',
            prefix: 'Xã',
          },
          {
            id: '3511',
            name: 'Nga Trung',
            prefix: 'Xã',
          },
          {
            id: '3512',
            name: 'Nga Trường',
            prefix: 'Xã',
          },
          {
            id: '3513',
            name: 'Nga Văn',
            prefix: 'Xã',
          },
          {
            id: '3514',
            name: 'Nga Vịnh',
            prefix: 'Xã',
          },
          {
            id: '3515',
            name: 'Nga Yên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '249',
        name: 'Ngọc Lặc',
        wards: [
          {
            id: '3516',
            name: 'Cao Ngọc',
            prefix: 'Xã',
          },
          {
            id: '3517',
            name: 'Cao Thịnh',
            prefix: 'Xã',
          },
          {
            id: '3518',
            name: 'Đồng Thịnh',
            prefix: 'Xã',
          },
          {
            id: '3519',
            name: 'Kiên Thọ',
            prefix: 'Xã',
          },
          {
            id: '3520',
            name: 'Lam Sơn',
            prefix: 'Xã',
          },
          {
            id: '3521',
            name: 'Lộc Thịnh',
            prefix: 'Xã',
          },
          {
            id: '3522',
            name: 'Minh Sơn',
            prefix: 'Xã',
          },
          {
            id: '3523',
            name: 'Minh Tiến',
            prefix: 'Xã',
          },
          {
            id: '3524',
            name: 'Mỹ Tân',
            prefix: 'Xã',
          },
          {
            id: '3525',
            name: 'Ngọc Khê',
            prefix: 'Xã',
          },
          {
            id: '3526',
            name: 'Ngọc Lặc',
            prefix: 'Thị trấn',
          },
          {
            id: '3527',
            name: 'Ngọc Liên',
            prefix: 'Xã',
          },
          {
            id: '3528',
            name: 'Ngọc Sơn',
            prefix: 'Xã',
          },
          {
            id: '3529',
            name: 'Ngọc Trung',
            prefix: 'Xã',
          },
          {
            id: '3530',
            name: 'Nguyệt Ấn',
            prefix: 'Xã',
          },
          {
            id: '3531',
            name: 'Phúc Thịnh',
            prefix: 'Xã',
          },
          {
            id: '3532',
            name: 'Phùng Giáo',
            prefix: 'Xã',
          },
          {
            id: '3533',
            name: 'Phùng Minh',
            prefix: 'Xã',
          },
          {
            id: '3534',
            name: 'Quang Trung',
            prefix: 'Xã',
          },
          {
            id: '3535',
            name: 'Thạch Lập',
            prefix: 'Xã',
          },
          {
            id: '3536',
            name: 'Thúy Sơn',
            prefix: 'Xã',
          },
          {
            id: '3537',
            name: 'Vân Âm',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '250',
        name: 'Như Thanh',
        wards: [
          {
            id: '3538',
            name: 'Bến Sung',
            prefix: 'Thị trấn',
          },
          {
            id: '3539',
            name: 'Cán Khê',
            prefix: 'Xã',
          },
          {
            id: '3540',
            name: 'Hải Long',
            prefix: 'Xã',
          },
          {
            id: '3541',
            name: 'Hải Vân',
            prefix: 'Xã',
          },
          {
            id: '3542',
            name: 'Mậu Lâm',
            prefix: 'Xã',
          },
          {
            id: '3543',
            name: 'Phú Nhuận',
            prefix: 'Xã',
          },
          {
            id: '3544',
            name: 'Phúc Đường',
            prefix: 'Xã',
          },
          {
            id: '3545',
            name: 'Phượng Nghi',
            prefix: 'Xã',
          },
          {
            id: '3546',
            name: 'Thanh Kỳ',
            prefix: 'Xã',
          },
          {
            id: '3547',
            name: 'Thanh Tân',
            prefix: 'Xã',
          },
          {
            id: '3548',
            name: 'Xuân Du',
            prefix: 'Xã',
          },
          {
            id: '3549',
            name: 'Xuân Khang',
            prefix: 'Xã',
          },
          {
            id: '3550',
            name: 'Xuân Phúc',
            prefix: 'Xã',
          },
          {
            id: '3551',
            name: 'Xuân Thái',
            prefix: 'Xã',
          },
          {
            id: '3552',
            name: 'Xuân Thọ',
            prefix: 'Xã',
          },
          {
            id: '3553',
            name: 'Yên Lạc',
            prefix: 'Xã',
          },
          {
            id: '3554',
            name: 'Yên Thọ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '251',
        name: 'Như Xuân',
        wards: [
          {
            id: '3555',
            name: 'Bãi Trành',
            prefix: 'Xã',
          },
          {
            id: '3556',
            name: 'Bình Lương',
            prefix: 'Xã',
          },
          {
            id: '3557',
            name: 'Cát Tân',
            prefix: 'Xã',
          },
          {
            id: '3558',
            name: 'Cát Vân',
            prefix: 'Xã',
          },
          {
            id: '3559',
            name: 'Hóa Quỳ',
            prefix: 'Xã',
          },
          {
            id: '3560',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '3561',
            name: 'Thanh Hòa',
            prefix: 'Xã',
          },
          {
            id: '3562',
            name: 'Thanh Lâm',
            prefix: 'Xã',
          },
          {
            id: '3563',
            name: 'Thanh Phong',
            prefix: 'Xã',
          },
          {
            id: '3564',
            name: 'Thanh Quân',
            prefix: 'Xã',
          },
          {
            id: '3565',
            name: 'Thanh Sơn',
            prefix: 'Xã',
          },
          {
            id: '3566',
            name: 'Thanh Xuân',
            prefix: 'Xã',
          },
          {
            id: '3567',
            name: 'Thượng Ninh',
            prefix: 'Xã',
          },
          {
            id: '3568',
            name: 'Xuân Bình',
            prefix: 'Xã',
          },
          {
            id: '3569',
            name: 'Xuân Hòa',
            prefix: 'Xã',
          },
          {
            id: '3570',
            name: 'Xuân Quỳ',
            prefix: 'Xã',
          },
          {
            id: '3571',
            name: 'Yên Cát',
            prefix: 'Thị trấn',
          },
          {
            id: '3572',
            name: 'Yên Lễ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '252',
        name: 'Nông Cống',
        wards: [
          {
            id: '3573',
            name: 'Công Bình',
            prefix: 'Xã',
          },
          {
            id: '3574',
            name: 'Công Chính',
            prefix: 'Xã',
          },
          {
            id: '3575',
            name: 'Công Liêm',
            prefix: 'Xã',
          },
          {
            id: '3576',
            name: 'Hoàng Giang',
            prefix: 'Xã',
          },
          {
            id: '3577',
            name: 'Hoàng Sơn',
            prefix: 'Xã',
          },
          {
            id: '3578',
            name: 'Minh Khôi',
            prefix: 'Xã',
          },
          {
            id: '3579',
            name: 'Minh Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '3580',
            name: 'Minh Thọ',
            prefix: 'Xã',
          },
          {
            id: '3581',
            name: 'Nông Cống',
            prefix: 'Thị trấn',
          },
          {
            id: '3582',
            name: 'Tân Khang',
            prefix: 'Xã',
          },
          {
            id: '3583',
            name: 'Tân Phúc',
            prefix: 'Xã',
          },
          {
            id: '3584',
            name: 'Tân Thọ',
            prefix: 'Xã',
          },
          {
            id: '3585',
            name: 'Tế Lợi',
            prefix: 'Xã',
          },
          {
            id: '3586',
            name: 'Tế Nông',
            prefix: 'Xã',
          },
          {
            id: '3587',
            name: 'Tế Tân',
            prefix: 'Xã',
          },
          {
            id: '3588',
            name: 'Tế Thắng',
            prefix: 'Xã',
          },
          {
            id: '3589',
            name: 'Thăng Bình',
            prefix: 'Xã',
          },
          {
            id: '3590',
            name: 'Thăng Long',
            prefix: 'Xã',
          },
          {
            id: '3591',
            name: 'Thăng Thọ',
            prefix: 'Xã',
          },
          {
            id: '3592',
            name: 'Trung Chính',
            prefix: 'Xã',
          },
          {
            id: '3593',
            name: 'Trung Thành',
            prefix: 'Xã',
          },
          {
            id: '3594',
            name: 'Trung Ý',
            prefix: 'Xã',
          },
          {
            id: '3595',
            name: 'Trường Giang',
            prefix: 'Xã',
          },
          {
            id: '3596',
            name: 'Trường Minh',
            prefix: 'Xã',
          },
          {
            id: '3597',
            name: 'Trường Sơn',
            prefix: 'Xã',
          },
          {
            id: '3598',
            name: 'Trường Trung',
            prefix: 'Xã',
          },
          {
            id: '3599',
            name: 'Tượng Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '3600',
            name: 'Tượng Sơn',
            prefix: 'Xã',
          },
          {
            id: '3601',
            name: 'Tượng Văn',
            prefix: 'Xã',
          },
          {
            id: '3602',
            name: 'Vạn Hoà',
            prefix: 'Xã',
          },
          {
            id: '3603',
            name: 'Vạn Thắng',
            prefix: 'Xã',
          },
          {
            id: '3604',
            name: 'Vạn Thiện',
            prefix: 'Xã',
          },
          {
            id: '3605',
            name: 'Yên Mỹ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '253',
        name: 'Quan Hóa',
        wards: [
          {
            id: '3606',
            name: 'Hiền Chung',
            prefix: 'Xã',
          },
          {
            id: '3607',
            name: 'Hiền Kiệt',
            prefix: 'Xã',
          },
          {
            id: '3608',
            name: 'Hồi Xuân',
            prefix: 'Xã',
          },
          {
            id: '3609',
            name: 'Nam Động',
            prefix: 'Xã',
          },
          {
            id: '3610',
            name: 'Nam Tiến',
            prefix: 'Xã',
          },
          {
            id: '3611',
            name: 'Nam Xuân',
            prefix: 'Xã',
          },
          {
            id: '3612',
            name: 'Phú Lệ',
            prefix: 'Xã',
          },
          {
            id: '3613',
            name: 'Phú Nghiêm',
            prefix: 'Xã',
          },
          {
            id: '3614',
            name: 'Phú Sơn',
            prefix: 'Xã',
          },
          {
            id: '3615',
            name: 'Phú Thanh',
            prefix: 'Xã',
          },
          {
            id: '3616',
            name: 'Phú Xuân',
            prefix: 'Xã',
          },
          {
            id: '3617',
            name: 'Quan Hóa',
            prefix: 'Thị trấn',
          },
          {
            id: '3618',
            name: 'Thành Sơn',
            prefix: 'Xã',
          },
          {
            id: '3619',
            name: 'Thanh Xuân',
            prefix: 'Xã',
          },
          {
            id: '3620',
            name: 'Thiên Phủ',
            prefix: 'Xã',
          },
          {
            id: '3621',
            name: 'Trung Sơn',
            prefix: 'Xã',
          },
          {
            id: '3622',
            name: 'Trung Thành',
            prefix: 'Xã',
          },
          {
            id: '3623',
            name: 'Xuân Phú',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '254',
        name: 'Quan Sơn',
        wards: [
          {
            id: '3624',
            name: 'Mường Mìn',
            prefix: 'Xã',
          },
          {
            id: '3625',
            name: 'Na Mèo',
            prefix: 'Xã',
          },
          {
            id: '3626',
            name: 'Quan Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '3627',
            name: 'Sơn Điện',
            prefix: 'Xã',
          },
          {
            id: '3628',
            name: 'Sơn Hà',
            prefix: 'Xã',
          },
          {
            id: '3629',
            name: 'Sơn Lư',
            prefix: 'Xã',
          },
          {
            id: '3630',
            name: 'Sơn Thủy',
            prefix: 'Xã',
          },
          {
            id: '3631',
            name: 'Tam Lư',
            prefix: 'Xã',
          },
          {
            id: '3632',
            name: 'Tam Thanh',
            prefix: 'Xã',
          },
          {
            id: '3633',
            name: 'Trung Hạ',
            prefix: 'Xã',
          },
          {
            id: '3634',
            name: 'Trung Thượng',
            prefix: 'Xã',
          },
          {
            id: '3635',
            name: 'Trung Tiến',
            prefix: 'Xã',
          },
          {
            id: '3636',
            name: 'Trung Xuân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '255',
        name: 'Quảng Xương',
        wards: [
          {
            id: '3637',
            name: 'Quảng Bình',
            prefix: 'Xã',
          },
          {
            id: '3638',
            name: 'Quảng Chính',
            prefix: 'Xã',
          },
          {
            id: '3639',
            name: 'Quảng Định',
            prefix: 'Xã',
          },
          {
            id: '3640',
            name: 'Quảng Đức',
            prefix: 'Xã',
          },
          {
            id: '3641',
            name: 'Quảng Giao',
            prefix: 'Xã',
          },
          {
            id: '3642',
            name: 'Quảng Hải',
            prefix: 'Xã',
          },
          {
            id: '3643',
            name: 'Quảng Hòa',
            prefix: 'Xã',
          },
          {
            id: '3644',
            name: 'Quảng Hợp',
            prefix: 'Xã',
          },
          {
            id: '3645',
            name: 'Quảng Khê',
            prefix: 'Xã',
          },
          {
            id: '3646',
            name: 'Quảng Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '3647',
            name: 'Quảng Lộc',
            prefix: 'Xã',
          },
          {
            id: '3648',
            name: 'Quảng Lợi',
            prefix: 'Xã',
          },
          {
            id: '3649',
            name: 'Quảng Long',
            prefix: 'Xã',
          },
          {
            id: '3650',
            name: 'Quảng Lưu',
            prefix: 'Xã',
          },
          {
            id: '3651',
            name: 'Quảng Ngọc',
            prefix: 'Xã',
          },
          {
            id: '3652',
            name: 'Quảng Nham',
            prefix: 'Xã',
          },
          {
            id: '3653',
            name: 'Quảng Nhân',
            prefix: 'Xã',
          },
          {
            id: '3654',
            name: 'Quảng Ninh',
            prefix: 'Xã',
          },
          {
            id: '3655',
            name: 'Quảng Phong',
            prefix: 'Xã',
          },
          {
            id: '3656',
            name: 'Quảng Phúc',
            prefix: 'Xã',
          },
          {
            id: '3657',
            name: 'Quảng Tân',
            prefix: 'Xã',
          },
          {
            id: '3658',
            name: 'Quảng Thạch',
            prefix: 'Xã',
          },
          {
            id: '3659',
            name: 'Quảng Thái',
            prefix: 'Xã',
          },
          {
            id: '3660',
            name: 'Quảng Trạch',
            prefix: 'Xã',
          },
          {
            id: '3661',
            name: 'Quảng Trung',
            prefix: 'Xã',
          },
          {
            id: '3662',
            name: 'Quảng Trường',
            prefix: 'Xã',
          },
          {
            id: '3663',
            name: 'Quảng Văn',
            prefix: 'Xã',
          },
          {
            id: '3664',
            name: 'Quảng Vọng',
            prefix: 'Xã',
          },
          {
            id: '3665',
            name: 'Quảng Xương',
            prefix: 'Thị trấn',
          },
          {
            id: '3666',
            name: 'Quảng Yên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '256',
        name: 'Sầm Sơn',
        wards: [
          {
            id: '3667',
            name: 'Bắc Sơn',
            prefix: 'Phường',
          },
          {
            id: '3668',
            name: 'Quảng Châu',
            prefix: 'Xã',
          },
          {
            id: '3669',
            name: 'Quảng Cư',
            prefix: 'Xã',
          },
          {
            id: '3670',
            name: 'Quảng Đại',
            prefix: 'Xã',
          },
          {
            id: '3671',
            name: 'Quảng Hùng',
            prefix: 'Xã',
          },
          {
            id: '3672',
            name: 'Quảng Minh',
            prefix: 'Xã',
          },
          {
            id: '3673',
            name: 'Quảng Thọ',
            prefix: 'Xã',
          },
          {
            id: '3674',
            name: 'Quảng Tiến',
            prefix: 'Phường',
          },
          {
            id: '3675',
            name: 'Quảng Vinh',
            prefix: 'Xã',
          },
          {
            id: '3676',
            name: 'Trung Sơn',
            prefix: 'Phường',
          },
          {
            id: '3677',
            name: 'Trường Sơn',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '257',
        name: 'Thạch Thành',
        wards: [
          {
            id: '3678',
            name: 'Kim Tân',
            prefix: 'Thị trấn',
          },
          {
            id: '3679',
            name: 'Ngọc Trạo',
            prefix: 'Xã',
          },
          {
            id: '3680',
            name: 'Thạch Bình',
            prefix: 'Xã',
          },
          {
            id: '3681',
            name: 'Thạch Cẩm',
            prefix: 'Xã',
          },
          {
            id: '3682',
            name: 'Thạch Định',
            prefix: 'Xã',
          },
          {
            id: '3683',
            name: 'Thạch Đồng',
            prefix: 'Xã',
          },
          {
            id: '3684',
            name: 'Thạch Lâm',
            prefix: 'Xã',
          },
          {
            id: '3685',
            name: 'Thạch Long',
            prefix: 'Xã',
          },
          {
            id: '3686',
            name: 'Thạch Quảng',
            prefix: 'Xã',
          },
          {
            id: '3687',
            name: 'Thạch Sơn',
            prefix: 'Xã',
          },
          {
            id: '3688',
            name: 'Thạch Tân',
            prefix: 'Xã',
          },
          {
            id: '3689',
            name: 'Thạch Tượng',
            prefix: 'Xã',
          },
          {
            id: '3690',
            name: 'Thành An',
            prefix: 'Xã',
          },
          {
            id: '3691',
            name: 'Thành Công',
            prefix: 'Xã',
          },
          {
            id: '3692',
            name: 'Thành Hưng',
            prefix: 'Xã',
          },
          {
            id: '3693',
            name: 'Thành Kim',
            prefix: 'Xã',
          },
          {
            id: '3694',
            name: 'Thành Long',
            prefix: 'Xã',
          },
          {
            id: '3695',
            name: 'Thành Minh',
            prefix: 'Xã',
          },
          {
            id: '3696',
            name: 'Thành Mỹ',
            prefix: 'Xã',
          },
          {
            id: '3697',
            name: 'Thành Tâm',
            prefix: 'Xã',
          },
          {
            id: '3698',
            name: 'Thành Tân',
            prefix: 'Xã',
          },
          {
            id: '3699',
            name: 'Thành Thọ',
            prefix: 'Xã',
          },
          {
            id: '3700',
            name: 'Thành Tiến',
            prefix: 'Xã',
          },
          {
            id: '3701',
            name: 'Thành Trực',
            prefix: 'Xã',
          },
          {
            id: '3702',
            name: 'Thành Vân',
            prefix: 'Xã',
          },
          {
            id: '3703',
            name: 'Thành Vinh',
            prefix: 'Xã',
          },
          {
            id: '3704',
            name: 'Thành Yên',
            prefix: 'Xã',
          },
          {
            id: '3705',
            name: 'Vân Du',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '258',
        name: 'Thanh Hóa',
        wards: [
          {
            id: '3706',
            name: 'An Hoạch',
            prefix: 'Phường',
          },
          {
            id: '3707',
            name: 'Ba Đình',
            prefix: 'Phường',
          },
          {
            id: '3708',
            name: 'Điện Biên',
            prefix: 'Phường',
          },
          {
            id: '3709',
            name: 'Đông Cương',
            prefix: 'Xã',
          },
          {
            id: '3710',
            name: 'Đông Hải',
            prefix: 'Xã',
          },
          {
            id: '3711',
            name: 'Đông Hưng',
            prefix: 'Xã',
          },
          {
            id: '3712',
            name: 'Đông Hương',
            prefix: 'Phường',
          },
          {
            id: '3713',
            name: 'Đông Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '3714',
            name: 'Đông Sơn',
            prefix: 'Phường',
          },
          {
            id: '3715',
            name: 'Đông Tân',
            prefix: 'Xã',
          },
          {
            id: '3716',
            name: 'Đông Thọ',
            prefix: 'Phường',
          },
          {
            id: '3717',
            name: 'Đông Vệ',
            prefix: 'Phường',
          },
          {
            id: '3718',
            name: 'Đông Vinh',
            prefix: 'Xã',
          },
          {
            id: '3719',
            name: 'Hàm Rồng',
            prefix: 'Phường',
          },
          {
            id: '3720',
            name: 'Hoằng Anh',
            prefix: 'Xã',
          },
          {
            id: '3721',
            name: 'Hoằng Đại',
            prefix: 'Xã',
          },
          {
            id: '3722',
            name: 'Hoằng Long',
            prefix: 'Xã',
          },
          {
            id: '3723',
            name: 'Hoằng Lý',
            prefix: 'Xã',
          },
          {
            id: '3724',
            name: 'Hoằng Quang',
            prefix: 'Xã',
          },
          {
            id: '3725',
            name: 'Lam Sơn',
            prefix: 'Phường',
          },
          {
            id: '3726',
            name: 'Nam Ngạn',
            prefix: 'Phường',
          },
          {
            id: '3727',
            name: 'Ngọc Trạo',
            prefix: 'Phường',
          },
          {
            id: '3728',
            name: 'Phú Sơn',
            prefix: 'Phường',
          },
          {
            id: '3729',
            name: 'Quảng Cát',
            prefix: 'Xã',
          },
          {
            id: '3730',
            name: 'Quảng Đông',
            prefix: 'Xã',
          },
          {
            id: '3731',
            name: 'Quảng Hưng',
            prefix: 'Xã',
          },
          {
            id: '3732',
            name: 'Quảng Phú',
            prefix: 'Xã',
          },
          {
            id: '3733',
            name: 'Quảng Tâm',
            prefix: 'Xã',
          },
          {
            id: '3734',
            name: 'Quảng Thắng',
            prefix: 'Xã',
          },
          {
            id: '3735',
            name: 'Quảng Thành',
            prefix: 'Xã',
          },
          {
            id: '3736',
            name: 'Quảng Thịnh',
            prefix: 'Xã',
          },
          {
            id: '3737',
            name: 'Tân Sơn',
            prefix: 'Phường',
          },
          {
            id: '3738',
            name: 'Tào Xuyên',
            prefix: 'Phường',
          },
          {
            id: '3739',
            name: 'Thành Trọng',
            prefix: 'Xã',
          },
          {
            id: '3740',
            name: 'Thiệu Dương',
            prefix: 'Xã',
          },
          {
            id: '3741',
            name: 'Thiệu Khánh',
            prefix: 'Xã',
          },
          {
            id: '3742',
            name: 'Thiệu Vân',
            prefix: 'Xã',
          },
          {
            id: '3743',
            name: 'Trường Thi',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '259',
        name: 'Thiệu Hóa',
        wards: [
          {
            id: '3744',
            name: 'Thiệu Châu',
            prefix: 'Xã',
          },
          {
            id: '3745',
            name: 'Thiệu Chính',
            prefix: 'Xã',
          },
          {
            id: '3746',
            name: 'Thiệu Công',
            prefix: 'Xã',
          },
          {
            id: '3748',
            name: 'Thiệu Duy',
            prefix: 'Xã',
          },
          {
            id: '3747',
            name: 'Thiệu Đô',
            prefix: 'Xã',
          },
          {
            id: '3749',
            name: 'Thiệu Giang',
            prefix: 'Xã',
          },
          {
            id: '3750',
            name: 'Thiệu Giao',
            prefix: 'Xã',
          },
          {
            id: '3751',
            name: 'Thiệu Hòa',
            prefix: 'Xã',
          },
          {
            id: '3752',
            name: 'Thiệu Hợp',
            prefix: 'Xã',
          },
          {
            id: '3753',
            name: 'Thiệu Long',
            prefix: 'Xã',
          },
          {
            id: '3754',
            name: 'Thiệu Lý',
            prefix: 'Xã',
          },
          {
            id: '3755',
            name: 'Thiệu Minh',
            prefix: 'Xã',
          },
          {
            id: '3756',
            name: 'Thiệu Ngọc',
            prefix: 'Xã',
          },
          {
            id: '3757',
            name: 'Thiệu Nguyên',
            prefix: 'Xã',
          },
          {
            id: '3758',
            name: 'Thiệu Phú',
            prefix: 'Xã',
          },
          {
            id: '3759',
            name: 'Thiệu Phúc',
            prefix: 'Xã',
          },
          {
            id: '3760',
            name: 'Thiệu Quang',
            prefix: 'Xã',
          },
          {
            id: '3761',
            name: 'Thiệu Tâm',
            prefix: 'Xã',
          },
          {
            id: '3762',
            name: 'Thiệu Tân',
            prefix: 'Xã',
          },
          {
            id: '3763',
            name: 'Thiệu Thành',
            prefix: 'Xã',
          },
          {
            id: '3764',
            name: 'Thiệu Thịnh',
            prefix: 'Xã',
          },
          {
            id: '3765',
            name: 'Thiệu Tiến',
            prefix: 'Xã',
          },
          {
            id: '3766',
            name: 'Thiệu Toán',
            prefix: 'Xã',
          },
          {
            id: '3767',
            name: 'Thiệu Trung',
            prefix: 'Xã',
          },
          {
            id: '3768',
            name: 'Thiệu Vận',
            prefix: 'Xã',
          },
          {
            id: '3769',
            name: 'Thiệu Viên',
            prefix: 'Xã',
          },
          {
            id: '3770',
            name: 'Thiệu Vũ',
            prefix: 'Xã',
          },
          {
            id: '3771',
            name: 'Vạn Hà',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '260',
        name: 'Thọ Xuân',
        wards: [
          {
            id: '3772',
            name: 'Bắc Lương',
            prefix: 'Xã',
          },
          {
            id: '3773',
            name: 'Hạnh Phúc',
            prefix: 'Xã',
          },
          {
            id: '3774',
            name: 'Lam Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '3775',
            name: 'Nam Giang',
            prefix: 'Xã',
          },
          {
            id: '3776',
            name: 'Phú Yên',
            prefix: 'Xã',
          },
          {
            id: '3777',
            name: 'Quảng Phú',
            prefix: 'Xã',
          },
          {
            id: '3778',
            name: 'Sao Vàng',
            prefix: 'Thị trấn',
          },
          {
            id: '3779',
            name: 'Tây Hồ',
            prefix: 'Xã',
          },
          {
            id: '3780',
            name: 'Thọ Diên',
            prefix: 'Xã',
          },
          {
            id: '3781',
            name: 'Thọ Hải',
            prefix: 'Xã',
          },
          {
            id: '3782',
            name: 'Thọ Lâm',
            prefix: 'Xã',
          },
          {
            id: '3783',
            name: 'Thọ Lập',
            prefix: 'Xã',
          },
          {
            id: '3784',
            name: 'Thọ Lộc',
            prefix: 'Xã',
          },
          {
            id: '3785',
            name: 'Thọ Minh',
            prefix: 'Xã',
          },
          {
            id: '3786',
            name: 'Thọ Nguyên',
            prefix: 'Xã',
          },
          {
            id: '3787',
            name: 'Thọ Thắng',
            prefix: 'Xã',
          },
          {
            id: '3788',
            name: 'Thọ Trường',
            prefix: 'Xã',
          },
          {
            id: '3789',
            name: 'Thọ Xuân',
            prefix: 'Thị trấn',
          },
          {
            id: '3790',
            name: 'Thọ Xương',
            prefix: 'Xã',
          },
          {
            id: '3791',
            name: 'Xuân Bái',
            prefix: 'Xã',
          },
          {
            id: '3792',
            name: 'Xuân Châu',
            prefix: 'Xã',
          },
          {
            id: '3793',
            name: 'Xuân Giang',
            prefix: 'Xã',
          },
          {
            id: '3794',
            name: 'Xuân Hòa',
            prefix: 'Xã',
          },
          {
            id: '3795',
            name: 'Xuân Hưng',
            prefix: 'Xã',
          },
          {
            id: '3796',
            name: 'Xuân Khánh',
            prefix: 'Xã',
          },
          {
            id: '3797',
            name: 'Xuân Lai',
            prefix: 'Xã',
          },
          {
            id: '3798',
            name: 'Xuân Lam',
            prefix: 'Xã',
          },
          {
            id: '3799',
            name: 'Xuân Lập',
            prefix: 'Xã',
          },
          {
            id: '3800',
            name: 'Xuân Minh',
            prefix: 'Xã',
          },
          {
            id: '3801',
            name: 'Xuân Phong',
            prefix: 'Xã',
          },
          {
            id: '3802',
            name: 'Xuân Phú',
            prefix: 'Xã',
          },
          {
            id: '3803',
            name: 'Xuân Quang',
            prefix: 'Xã',
          },
          {
            id: '3804',
            name: 'Xuân Sơn',
            prefix: 'Xã',
          },
          {
            id: '3805',
            name: 'Xuân Tân',
            prefix: 'Xã',
          },
          {
            id: '3806',
            name: 'Xuân Thắng',
            prefix: 'Xã',
          },
          {
            id: '3807',
            name: 'Xuân Thành',
            prefix: 'Xã',
          },
          {
            id: '3808',
            name: 'Xuân Thiên',
            prefix: 'Xã',
          },
          {
            id: '3809',
            name: 'Xuân Tín',
            prefix: 'Xã',
          },
          {
            id: '3810',
            name: 'Xuân Trường',
            prefix: 'Xã',
          },
          {
            id: '3811',
            name: 'Xuân Vinh',
            prefix: 'Xã',
          },
          {
            id: '3812',
            name: 'Xuân Yên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '261',
        name: 'Thường Xuân',
        wards: [
          {
            id: '3813',
            name: 'Bát Mọt',
            prefix: 'Xã',
          },
          {
            id: '3814',
            name: 'Luận Khê',
            prefix: 'Xã',
          },
          {
            id: '3815',
            name: 'Luận Thành',
            prefix: 'Xã',
          },
          {
            id: '3816',
            name: 'Lương Sơn',
            prefix: 'Xã',
          },
          {
            id: '3817',
            name: 'Ngọc Phụng',
            prefix: 'Xã',
          },
          {
            id: '3818',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '3819',
            name: 'Thọ Thanh',
            prefix: 'Xã',
          },
          {
            id: '3820',
            name: 'Thường Xuân',
            prefix: 'Thị trấn',
          },
          {
            id: '3821',
            name: 'Vạn Xuân',
            prefix: 'Xã',
          },
          {
            id: '3822',
            name: 'Xuân Cẩm',
            prefix: 'Xã',
          },
          {
            id: '3823',
            name: 'Xuân Cao',
            prefix: 'Xã',
          },
          {
            id: '3824',
            name: 'Xuân Chinh',
            prefix: 'Xã',
          },
          {
            id: '3825',
            name: 'Xuân Dương',
            prefix: 'Xã',
          },
          {
            id: '3826',
            name: 'Xuân Lẹ',
            prefix: 'Xã',
          },
          {
            id: '3827',
            name: 'Xuân Lộc',
            prefix: 'Xã',
          },
          {
            id: '3828',
            name: 'Xuân Thắng',
            prefix: 'Xã',
          },
          {
            id: '3829',
            name: 'Yên Nhân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '262',
        name: 'Tĩnh Gia',
        wards: [
          {
            id: '3830',
            name: 'Anh Sơn',
            prefix: 'Xã',
          },
          {
            id: '3831',
            name: 'Bình Minh',
            prefix: 'Xã',
          },
          {
            id: '3832',
            name: 'Các Sơn',
            prefix: 'Xã',
          },
          {
            id: '3833',
            name: 'Định Hải',
            prefix: 'Xã',
          },
          {
            id: '3834',
            name: 'Hải An',
            prefix: 'Xã',
          },
          {
            id: '3835',
            name: 'Hải Bình',
            prefix: 'Xã',
          },
          {
            id: '3836',
            name: 'Hải Châu',
            prefix: 'Xã',
          },
          {
            id: '3837',
            name: 'Hải Hà',
            prefix: 'Xã',
          },
          {
            id: '3838',
            name: 'Hải Hòa',
            prefix: 'Xã',
          },
          {
            id: '3839',
            name: 'Hải Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '3840',
            name: 'Hải Nhân',
            prefix: 'Xã',
          },
          {
            id: '3841',
            name: 'Hải Ninh',
            prefix: 'Xã',
          },
          {
            id: '3842',
            name: 'Hải Thanh',
            prefix: 'Xã',
          },
          {
            id: '3843',
            name: 'Hải Thượng',
            prefix: 'Xã',
          },
          {
            id: '3844',
            name: 'Hải Yến',
            prefix: 'Xã',
          },
          {
            id: '3845',
            name: 'Hùng Sơn',
            prefix: 'Xã',
          },
          {
            id: '3846',
            name: 'Mai Lâm',
            prefix: 'Xã',
          },
          {
            id: '3847',
            name: 'Nghi Sơn',
            prefix: 'Xã',
          },
          {
            id: '3848',
            name: 'Ngọc Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '3849',
            name: 'Nguyên Bình',
            prefix: 'Xã',
          },
          {
            id: '3850',
            name: 'Ninh Hải',
            prefix: 'Xã',
          },
          {
            id: '3851',
            name: 'Phú Lâm',
            prefix: 'Xã',
          },
          {
            id: '3852',
            name: 'Phú Sơn',
            prefix: 'Xã',
          },
          {
            id: '3853',
            name: 'Tân Dân',
            prefix: 'Xã',
          },
          {
            id: '3854',
            name: 'Tân Trường',
            prefix: 'Xã',
          },
          {
            id: '3855',
            name: 'Thanh Sơn',
            prefix: 'Xã',
          },
          {
            id: '3856',
            name: 'Thanh Thủy',
            prefix: 'Xã',
          },
          {
            id: '3857',
            name: 'Tĩnh Gia',
            prefix: 'Thị trấn',
          },
          {
            id: '3858',
            name: 'Tĩnh Hải',
            prefix: 'Xã',
          },
          {
            id: '3859',
            name: 'Triêu Dương',
            prefix: 'Xã',
          },
          {
            id: '3860',
            name: 'Trúc Lâm',
            prefix: 'Xã',
          },
          {
            id: '3861',
            name: 'Trường Lâm',
            prefix: 'Xã',
          },
          {
            id: '3862',
            name: 'Tùng Lâm',
            prefix: 'Xã',
          },
          {
            id: '3863',
            name: 'Xuân Lâm',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '263',
        name: 'Triệu Sơn',
        wards: [
          {
            id: '3864',
            name: 'An Nông',
            prefix: 'Xã',
          },
          {
            id: '3865',
            name: 'Bình Sơn',
            prefix: 'Xã',
          },
          {
            id: '3866',
            name: 'Dân Lực',
            prefix: 'Xã',
          },
          {
            id: '3867',
            name: 'Dân Lý',
            prefix: 'Xã',
          },
          {
            id: '3868',
            name: 'Dân Quyền',
            prefix: 'Xã',
          },
          {
            id: '3869',
            name: 'Đồng Lợi',
            prefix: 'Xã',
          },
          {
            id: '3870',
            name: 'Đồng Thắng',
            prefix: 'Xã',
          },
          {
            id: '3871',
            name: 'Đồng Tiến',
            prefix: 'Xã',
          },
          {
            id: '3872',
            name: 'Hợp lý',
            prefix: 'Xã',
          },
          {
            id: '3873',
            name: 'Hợp Thắng',
            prefix: 'Xã',
          },
          {
            id: '3874',
            name: 'Hợp Thành',
            prefix: 'Xã',
          },
          {
            id: '3875',
            name: 'Hợp Tiến',
            prefix: 'Xã',
          },
          {
            id: '3876',
            name: 'Khuyến Nông',
            prefix: 'Xã',
          },
          {
            id: '3877',
            name: 'Minh Châu',
            prefix: 'Xã',
          },
          {
            id: '3878',
            name: 'Minh Dân',
            prefix: 'Xã',
          },
          {
            id: '3879',
            name: 'Minh Sơn',
            prefix: 'Xã',
          },
          {
            id: '3880',
            name: 'Nông Trường',
            prefix: 'Xã',
          },
          {
            id: '3881',
            name: 'Tân Ninh',
            prefix: 'Xã',
          },
          {
            id: '3882',
            name: 'Thái Hoà',
            prefix: 'Xã',
          },
          {
            id: '3883',
            name: 'Thọ Bình',
            prefix: 'Xã',
          },
          {
            id: '3884',
            name: 'Thọ Cường',
            prefix: 'Xã',
          },
          {
            id: '3885',
            name: 'Thọ Dân',
            prefix: 'Xã',
          },
          {
            id: '3886',
            name: 'Thọ Ngọc',
            prefix: 'Xã',
          },
          {
            id: '3887',
            name: 'Thọ Phú',
            prefix: 'Xã',
          },
          {
            id: '3888',
            name: 'Thọ Sơn',
            prefix: 'Xã',
          },
          {
            id: '3889',
            name: 'Thọ Tân',
            prefix: 'Xã',
          },
          {
            id: '3890',
            name: 'Thọ Thế',
            prefix: 'Xã',
          },
          {
            id: '3891',
            name: 'Thọ Tiến',
            prefix: 'Xã',
          },
          {
            id: '3892',
            name: 'Thọ Vực',
            prefix: 'Xã',
          },
          {
            id: '3893',
            name: 'Tiến Nông',
            prefix: 'Xã',
          },
          {
            id: '3894',
            name: 'Triệu Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '3895',
            name: 'Triệu Thành',
            prefix: 'Xã',
          },
          {
            id: '3896',
            name: 'Văn Sơn',
            prefix: 'Xã',
          },
          {
            id: '3897',
            name: 'Xuân Lộc',
            prefix: 'Xã',
          },
          {
            id: '3898',
            name: 'Xuân Thịnh',
            prefix: 'Xã',
          },
          {
            id: '3899',
            name: 'Xuân Thọ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '264',
        name: 'Vĩnh Lộc',
        wards: [
          {
            id: '3900',
            name: 'Vĩnh An',
            prefix: 'Xã',
          },
          {
            id: '3901',
            name: 'Vĩnh Hòa',
            prefix: 'Xã',
          },
          {
            id: '3902',
            name: 'Vĩnh Hùng',
            prefix: 'Xã',
          },
          {
            id: '3903',
            name: 'Vĩnh Hưng',
            prefix: 'Xã',
          },
          {
            id: '3904',
            name: 'Vĩnh Khang',
            prefix: 'Xã',
          },
          {
            id: '3905',
            name: 'Vĩnh Lộc',
            prefix: 'Thị trấn',
          },
          {
            id: '3906',
            name: 'Vĩnh Long',
            prefix: 'Xã',
          },
          {
            id: '3907',
            name: 'Vĩnh Minh',
            prefix: 'Xã',
          },
          {
            id: '3908',
            name: 'Vĩnh Ninh',
            prefix: 'Xã',
          },
          {
            id: '3909',
            name: 'Vĩnh Phúc',
            prefix: 'Xã',
          },
          {
            id: '3910',
            name: 'Vĩnh Quang',
            prefix: 'Xã',
          },
          {
            id: '3911',
            name: 'Vĩnh Tân',
            prefix: 'Xã',
          },
          {
            id: '3912',
            name: 'Vĩnh Thành',
            prefix: 'Xã',
          },
          {
            id: '3913',
            name: 'Vĩnh Thịnh',
            prefix: 'Xã',
          },
          {
            id: '3914',
            name: 'Vĩnh Tiến',
            prefix: 'Xã',
          },
          {
            id: '3915',
            name: 'Vĩnh Yên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '265',
        name: 'Yên Định',
        wards: [
          {
            id: '3916',
            name: 'Định Bình',
            prefix: 'Xã',
          },
          {
            id: '3917',
            name: 'Định Công',
            prefix: 'Xã',
          },
          {
            id: '3918',
            name: 'Định Hải',
            prefix: 'Xã',
          },
          {
            id: '3919',
            name: 'Định Hòa',
            prefix: 'Xã',
          },
          {
            id: '3920',
            name: 'Định Hưng',
            prefix: 'Xã',
          },
          {
            id: '3921',
            name: 'Định Liên',
            prefix: 'Xã',
          },
          {
            id: '3922',
            name: 'Định Long',
            prefix: 'Xã',
          },
          {
            id: '3923',
            name: 'Định Tân',
            prefix: 'Xã',
          },
          {
            id: '3924',
            name: 'Định Tăng',
            prefix: 'Xã',
          },
          {
            id: '3925',
            name: 'Định Thành',
            prefix: 'Xã',
          },
          {
            id: '3926',
            name: 'Định Tiến',
            prefix: 'Xã',
          },
          {
            id: '3927',
            name: 'Định Tường',
            prefix: 'Xã',
          },
          {
            id: '3928',
            name: 'Kiểu',
            prefix: 'Thị trấn',
          },
          {
            id: '3929',
            name: 'Quán Lào',
            prefix: 'Thị trấn',
          },
          {
            id: '3930',
            name: 'Quý Lộc',
            prefix: 'Xã',
          },
          {
            id: '3931',
            name: 'Thống Nhất',
            prefix: 'Thị trấn',
          },
          {
            id: '3932',
            name: 'Yên Bái',
            prefix: 'Xã',
          },
          {
            id: '3933',
            name: 'Yên Giang',
            prefix: 'Xã',
          },
          {
            id: '3934',
            name: 'Yên Hùng',
            prefix: 'Xã',
          },
          {
            id: '3935',
            name: 'Yên Lạc',
            prefix: 'Xã',
          },
          {
            id: '3936',
            name: 'Yên Lâm',
            prefix: 'Xã',
          },
          {
            id: '3937',
            name: 'Yên Ninh',
            prefix: 'Xã',
          },
          {
            id: '3938',
            name: 'Yên Phong',
            prefix: 'Xã',
          },
          {
            id: '3939',
            name: 'Yên Phú',
            prefix: 'Xã',
          },
          {
            id: '3940',
            name: 'Yên Tâm',
            prefix: 'Xã',
          },
          {
            id: '3941',
            name: 'Yên Thái',
            prefix: 'Xã',
          },
          {
            id: '3942',
            name: 'Yên Thịnh',
            prefix: 'Xã',
          },
          {
            id: '3943',
            name: 'Yên Thọ',
            prefix: 'Xã',
          },
          {
            id: '3944',
            name: 'Yên Trung',
            prefix: 'Xã',
          },
          {
            id: '3945',
            name: 'Yên Trường',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '20',
    code: 'NA',
    name: 'Nghệ An',
    districts: [
      {
        id: '266',
        name: 'Anh Sơn',
        wards: [
          {
            id: '3946',
            name: ' Hùng Sơn',
            prefix: 'Xã',
          },
          {
            id: '3947',
            name: ' Khai Sơn',
            prefix: 'Xã',
          },
          {
            id: '3948',
            name: ' Long Sơn',
            prefix: 'Xã',
          },
          {
            id: '3949',
            name: ' Thọ Sơn ',
            prefix: 'Xã',
          },
          {
            id: '3950',
            name: 'Anh Sơn',
            prefix: 'Xã',
          },
          {
            id: '3951',
            name: 'Bình Sơn ',
            prefix: 'Xã',
          },
          {
            id: '3952',
            name: 'Cẩm Sơn ',
            prefix: 'Xã',
          },
          {
            id: '3953',
            name: 'Cao Sơn ',
            prefix: 'Xã',
          },
          {
            id: '3954',
            name: 'Đỉnh Sơn ',
            prefix: 'Xã',
          },
          {
            id: '3955',
            name: 'Đức Sơn ',
            prefix: 'Xã',
          },
          {
            id: '3956',
            name: 'Hoa Sơn',
            prefix: 'Xã',
          },
          {
            id: '3957',
            name: 'Hội Sơn ',
            prefix: 'Xã',
          },
          {
            id: '3958',
            name: 'Lạng Sơn',
            prefix: 'Xã',
          },
          {
            id: '3959',
            name: 'Lĩnh Sơn ',
            prefix: 'Xã',
          },
          {
            id: '3960',
            name: 'Phúc Sơn',
            prefix: 'Xã',
          },
          {
            id: '3961',
            name: 'Tam Sơn',
            prefix: 'Xã',
          },
          {
            id: '3962',
            name: 'Tào Sơn ',
            prefix: 'Xã',
          },
          {
            id: '3963',
            name: 'Thạch Sơn',
            prefix: 'Xã',
          },
          {
            id: '3964',
            name: 'Thành Sơn ',
            prefix: 'Xã',
          },
          {
            id: '3965',
            name: 'Tường Sơn ',
            prefix: 'Xã',
          },
          {
            id: '3966',
            name: 'Vĩnh Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '267',
        name: 'Con Cuông',
        wards: [
          {
            id: '3967',
            name: ' Chi Khê',
            prefix: 'Xã',
          },
          {
            id: '3968',
            name: 'Bình Chuẩn',
            prefix: 'Xã',
          },
          {
            id: '3969',
            name: 'Bồng Khê',
            prefix: 'Xã',
          },
          {
            id: '3970',
            name: 'Cam Lâm',
            prefix: 'Xã',
          },
          {
            id: '3971',
            name: 'Châu Khê',
            prefix: 'Xã',
          },
          {
            id: '3972',
            name: 'Con Cuông',
            prefix: 'Thị trấn',
          },
          {
            id: '3973',
            name: 'Đôn Phục',
            prefix: 'Xã',
          },
          {
            id: '3974',
            name: 'Lạng Khê',
            prefix: 'Xã',
          },
          {
            id: '3975',
            name: 'Lục Dạ',
            prefix: 'Xã',
          },
          {
            id: '3976',
            name: 'Mậu Đức',
            prefix: 'Xã',
          },
          {
            id: '3977',
            name: 'Môn Sơn',
            prefix: 'Xã',
          },
          {
            id: '3978',
            name: 'Thạch Ngàn',
            prefix: 'Xã',
          },
          {
            id: '3979',
            name: 'Yên Khê',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '268',
        name: 'Cửa Lò',
        wards: [
          {
            id: '3980',
            name: 'Nghi Hải',
            prefix: 'Phường',
          },
          {
            id: '3981',
            name: 'Nghi Hòa',
            prefix: 'Phường',
          },
          {
            id: '3982',
            name: 'Nghi Hương',
            prefix: 'Phường',
          },
          {
            id: '3983',
            name: 'Nghi Tân',
            prefix: 'Phường',
          },
          {
            id: '3984',
            name: 'Nghi Thu',
            prefix: 'Phường',
          },
          {
            id: '3985',
            name: 'Nghi Thủy',
            prefix: 'Phường',
          },
          {
            id: '3986',
            name: 'Thu Thủy',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '269',
        name: 'Diễn Châu',
        wards: [
          {
            id: '3987',
            name: 'Diễn An',
            prefix: 'Xã',
          },
          {
            id: '3988',
            name: 'Diễn Bích',
            prefix: 'Xã',
          },
          {
            id: '3989',
            name: 'Diễn Bình',
            prefix: 'Xã',
          },
          {
            id: '3990',
            name: 'Diễn Cát',
            prefix: 'Xã',
          },
          {
            id: '3991',
            name: 'Diễn Châu',
            prefix: 'Thị trấn',
          },
          {
            id: '3992',
            name: 'Diễn Đoài',
            prefix: 'Xã',
          },
          {
            id: '3993',
            name: 'Diễn Đồng',
            prefix: 'Xã',
          },
          {
            id: '3994',
            name: 'Diễn Hải',
            prefix: 'Xã',
          },
          {
            id: '3995',
            name: 'Diễn Hạnh',
            prefix: 'Xã',
          },
          {
            id: '3996',
            name: 'Diễn Hoa',
            prefix: 'Xã',
          },
          {
            id: '3997',
            name: 'Diễn Hoàng',
            prefix: 'Xã',
          },
          {
            id: '3998',
            name: 'Diễn Hồng',
            prefix: 'Xã',
          },
          {
            id: '3999',
            name: 'Diễn Hùng',
            prefix: 'Xã',
          },
          {
            id: '4000',
            name: 'Diễn Kim',
            prefix: 'Xã',
          },
          {
            id: '4001',
            name: 'Diễn Kỷ',
            prefix: 'Xã',
          },
          {
            id: '4002',
            name: 'Diễn Lâm',
            prefix: 'Xã',
          },
          {
            id: '4003',
            name: 'Diễn Liên',
            prefix: 'Xã',
          },
          {
            id: '4004',
            name: 'Diễn Lộc',
            prefix: 'Xã',
          },
          {
            id: '4005',
            name: 'Diễn Lợi',
            prefix: 'Xã',
          },
          {
            id: '4006',
            name: 'Diễn Minh',
            prefix: 'Xã',
          },
          {
            id: '4007',
            name: 'Diễn Mỹ',
            prefix: 'Xã',
          },
          {
            id: '4008',
            name: 'Diễn Ngọc',
            prefix: 'Xã',
          },
          {
            id: '4009',
            name: 'Diễn Nguyên',
            prefix: 'Xã',
          },
          {
            id: '4010',
            name: 'Diễn Phong',
            prefix: 'Xã',
          },
          {
            id: '4011',
            name: 'Diễn Phú',
            prefix: 'Xã',
          },
          {
            id: '4012',
            name: 'Diễn Phúc',
            prefix: 'Xã',
          },
          {
            id: '4013',
            name: 'Diễn Quảng',
            prefix: 'Xã',
          },
          {
            id: '4014',
            name: 'Diễn Tân',
            prefix: 'Xã',
          },
          {
            id: '4015',
            name: 'Diễn Thái',
            prefix: 'Xã',
          },
          {
            id: '4016',
            name: 'Diễn Thắng',
            prefix: 'Xã',
          },
          {
            id: '4017',
            name: 'Diễn Thành',
            prefix: 'Xã',
          },
          {
            id: '4018',
            name: 'Diễn Tháp',
            prefix: 'Xã',
          },
          {
            id: '4019',
            name: 'Diễn Thịnh',
            prefix: 'Xã',
          },
          {
            id: '4020',
            name: 'Diễn Thọ',
            prefix: 'Xã',
          },
          {
            id: '4021',
            name: 'Diễn Trung',
            prefix: 'Xã',
          },
          {
            id: '4022',
            name: 'Diễn Trường',
            prefix: 'Xã',
          },
          {
            id: '4023',
            name: 'Diễn Vạn',
            prefix: 'Xã',
          },
          {
            id: '4024',
            name: 'Diễn Xuân',
            prefix: 'Xã',
          },
          {
            id: '4025',
            name: 'Diễn Yên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '270',
        name: 'Đô Lương',
        wards: [
          {
            id: '4026',
            name: ' Lạc Sơn',
            prefix: 'Xã',
          },
          {
            id: '4027',
            name: ' Nhân Sơn',
            prefix: 'Xã',
          },
          {
            id: '4028',
            name: ' Trù Sơn',
            prefix: 'Xã',
          },
          {
            id: '4029',
            name: 'Bắc Sơn',
            prefix: 'Xã',
          },
          {
            id: '4030',
            name: 'Bài Sơn',
            prefix: 'Xã',
          },
          {
            id: '4031',
            name: 'Bồi Sơn',
            prefix: 'Xã',
          },
          {
            id: '4032',
            name: 'Đà Sơn',
            prefix: 'Xã',
          },
          {
            id: '4033',
            name: 'Đại Sơn',
            prefix: 'Xã',
          },
          {
            id: '4034',
            name: 'Đặng Sơn',
            prefix: 'Xã',
          },
          {
            id: '4035',
            name: 'Đô Lương',
            prefix: 'Thị trấn',
          },
          {
            id: '4036',
            name: 'Đông Sơn',
            prefix: 'Xã',
          },
          {
            id: '4037',
            name: 'Giang Sơn Đông',
            prefix: 'Xã',
          },
          {
            id: '4038',
            name: 'Giang Sơn Tây',
            prefix: 'Xã',
          },
          {
            id: '4039',
            name: 'Hiến Sơn',
            prefix: 'Xã',
          },
          {
            id: '4040',
            name: 'Hòa Sơn',
            prefix: 'Xã',
          },
          {
            id: '4041',
            name: 'Hồng Sơn',
            prefix: 'Xã',
          },
          {
            id: '4042',
            name: 'Lam Sơn',
            prefix: 'Xã',
          },
          {
            id: '4043',
            name: 'Lưu Sơn',
            prefix: 'Xã',
          },
          {
            id: '4044',
            name: 'Minh Sơn',
            prefix: 'Xã',
          },
          {
            id: '4045',
            name: 'Mỹ Sơn',
            prefix: 'Xã',
          },
          {
            id: '4046',
            name: 'Nam Sơn',
            prefix: 'Xã',
          },
          {
            id: '4047',
            name: 'Ngọc Sơn',
            prefix: 'Xã',
          },
          {
            id: '4048',
            name: 'Quang Sơn',
            prefix: 'Xã',
          },
          {
            id: '4049',
            name: 'Tân Sơn',
            prefix: 'Xã',
          },
          {
            id: '4050',
            name: 'Thái Sơn',
            prefix: 'Xã',
          },
          {
            id: '4051',
            name: 'Thịnh Sơn',
            prefix: 'Xã',
          },
          {
            id: '4052',
            name: 'Thuận Sơn',
            prefix: 'Xã',
          },
          {
            id: '4053',
            name: 'Thượng Sơn',
            prefix: 'Xã',
          },
          {
            id: '4054',
            name: 'Tràng Sơn',
            prefix: 'Xã',
          },
          {
            id: '4055',
            name: 'Trung Sơn',
            prefix: 'Xã',
          },
          {
            id: '4056',
            name: 'Văn Sơn',
            prefix: 'Xã',
          },
          {
            id: '4057',
            name: 'Xuân Sơn',
            prefix: 'Xã',
          },
          {
            id: '4058',
            name: 'Yên Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '271',
        name: 'Hoàng Mai',
        wards: [
          {
            id: '4059',
            name: 'Mai Hùng',
            prefix: 'Xã',
          },
          {
            id: '4060',
            name: 'Quỳnh Dị',
            prefix: 'Xã',
          },
          {
            id: '4061',
            name: 'Quỳnh Lập',
            prefix: 'Xã',
          },
          {
            id: '4062',
            name: 'Quỳnh Liên',
            prefix: 'Xã',
          },
          {
            id: '4063',
            name: 'Quỳnh Lộc',
            prefix: 'Xã',
          },
          {
            id: '4064',
            name: 'Quỳnh Phương',
            prefix: 'Xã',
          },
          {
            id: '4065',
            name: 'Quỳnh Thiện',
            prefix: 'Xã',
          },
          {
            id: '4066',
            name: 'Quỳnh Trang',
            prefix: 'Xã',
          },
          {
            id: '4067',
            name: 'Quỳnh Vinh',
            prefix: 'Xã',
          },
          {
            id: '4068',
            name: 'Quỳnh Xuân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '272',
        name: 'Hưng Nguyên',
        wards: [
          {
            id: '4069',
            name: ' Hưng Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '4070',
            name: ' Hưng Mỹ',
            prefix: 'Xã',
          },
          {
            id: '4071',
            name: 'Hưng Châu',
            prefix: 'Xã',
          },
          {
            id: '4072',
            name: 'Hưng Đạo',
            prefix: 'Xã',
          },
          {
            id: '4073',
            name: 'Hưng Khánh',
            prefix: 'Xã',
          },
          {
            id: '4074',
            name: 'Hưng Lam',
            prefix: 'Xã',
          },
          {
            id: '4075',
            name: 'Hưng Lợi',
            prefix: 'Xã',
          },
          {
            id: '4076',
            name: 'Hưng Long',
            prefix: 'Xã',
          },
          {
            id: '4077',
            name: 'Hưng Nguyên',
            prefix: 'Thị trấn',
          },
          {
            id: '4078',
            name: 'Hưng Nhân',
            prefix: 'Xã',
          },
          {
            id: '4079',
            name: 'Hưng Phú',
            prefix: 'Xã',
          },
          {
            id: '4080',
            name: 'Hưng Phúc',
            prefix: 'Xã',
          },
          {
            id: '4081',
            name: 'Hưng Tân',
            prefix: 'Xã',
          },
          {
            id: '4082',
            name: 'Hưng Tây',
            prefix: 'Xã',
          },
          {
            id: '4083',
            name: 'Hưng Thắng',
            prefix: 'Xã',
          },
          {
            id: '4084',
            name: 'Hưng Thịnh',
            prefix: 'Xã',
          },
          {
            id: '4085',
            name: 'Hưng Thông',
            prefix: 'Xã',
          },
          {
            id: '4086',
            name: 'Hưng Tiến',
            prefix: 'Xã',
          },
          {
            id: '4087',
            name: 'Hưng Trung',
            prefix: 'Xã',
          },
          {
            id: '4088',
            name: 'Hưng Xá',
            prefix: 'Xã',
          },
          {
            id: '4089',
            name: 'Hưng Xuân',
            prefix: 'Xã',
          },
          {
            id: '4090',
            name: 'Hưng Yên Bắc',
            prefix: 'Xã',
          },
          {
            id: '4091',
            name: 'Hưng Yên Nam ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '273',
        name: 'Kỳ Sơn',
        wards: [
          {
            id: '4092',
            name: ' Mường Típ',
            prefix: 'Xã',
          },
          {
            id: '4093',
            name: ' Phà Đánh',
            prefix: 'Xã',
          },
          {
            id: '4094',
            name: ' Tà Cạ',
            prefix: 'Xã',
          },
          {
            id: '4095',
            name: 'Bắc Lý',
            prefix: 'Xã',
          },
          {
            id: '4096',
            name: 'Bảo Nam',
            prefix: 'Xã',
          },
          {
            id: '4097',
            name: 'Bảo Thắng',
            prefix: 'Xã',
          },
          {
            id: '4098',
            name: 'Chiêu Lưu',
            prefix: 'Xã',
          },
          {
            id: '4099',
            name: 'Đoọc Mạy',
            prefix: 'Xã',
          },
          {
            id: '4100',
            name: 'Huồi Tụ',
            prefix: 'Xã',
          },
          {
            id: '4101',
            name: 'Hữu Kiệm',
            prefix: 'Xã',
          },
          {
            id: '4102',
            name: 'Hữu Lập',
            prefix: 'Xã',
          },
          {
            id: '4103',
            name: 'Keng Đu',
            prefix: 'Xã',
          },
          {
            id: '4104',
            name: 'Mường Ải',
            prefix: 'Xã',
          },
          {
            id: '4105',
            name: 'Mường Lống',
            prefix: 'Xã',
          },
          {
            id: '4106',
            name: 'Mường Xén',
            prefix: 'Thị trấn',
          },
          {
            id: '4107',
            name: 'Mỹ Lý',
            prefix: 'Xã',
          },
          {
            id: '4108',
            name: 'Na Loi',
            prefix: 'Xã',
          },
          {
            id: '4109',
            name: 'Na Ngoi',
            prefix: 'Xã',
          },
          {
            id: '4110',
            name: 'Nậm Càn',
            prefix: 'Xã',
          },
          {
            id: '4111',
            name: 'Nậm Cắn',
            prefix: 'Xã',
          },
          {
            id: '4112',
            name: 'Tây Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '274',
        name: 'Nam Đàn',
        wards: [
          {
            id: '4113',
            name: ' Kim Liên',
            prefix: 'Xã',
          },
          {
            id: '4114',
            name: ' Nam Anh',
            prefix: 'Xã',
          },
          {
            id: '4115',
            name: ' Nam Trung',
            prefix: 'Xã',
          },
          {
            id: '4116',
            name: 'Hồng Long',
            prefix: 'Xã',
          },
          {
            id: '4117',
            name: 'Hùng Tiến ',
            prefix: 'Xã',
          },
          {
            id: '4118',
            name: 'Khánh Sơn',
            prefix: 'Xã',
          },
          {
            id: '4119',
            name: 'Nam Cát',
            prefix: 'Xã',
          },
          {
            id: '4120',
            name: 'Nam Cường',
            prefix: 'Xã',
          },
          {
            id: '4121',
            name: 'Nam Đàn',
            prefix: 'Thị trấn',
          },
          {
            id: '4122',
            name: 'Nam Giang',
            prefix: 'Xã',
          },
          {
            id: '4123',
            name: 'Nam Hưng',
            prefix: 'Xã',
          },
          {
            id: '4124',
            name: 'Nam Kim',
            prefix: 'Xã',
          },
          {
            id: '4125',
            name: 'Nam Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '4126',
            name: 'Nam Lộc',
            prefix: 'Xã',
          },
          {
            id: '4127',
            name: 'Nam Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '4128',
            name: 'Nam Phúc',
            prefix: 'Xã',
          },
          {
            id: '4129',
            name: 'Nam Tân',
            prefix: 'Xã',
          },
          {
            id: '4130',
            name: 'Nam Thái',
            prefix: 'Xã',
          },
          {
            id: '4131',
            name: 'Nam Thanh',
            prefix: 'Xã',
          },
          {
            id: '4132',
            name: 'Nam Thượng',
            prefix: 'Xã',
          },
          {
            id: '4133',
            name: 'Nam Xuân',
            prefix: 'Xã',
          },
          {
            id: '4134',
            name: 'Vân Diên',
            prefix: 'Xã',
          },
          {
            id: '4135',
            name: 'Xuân Hòa',
            prefix: 'Xã',
          },
          {
            id: '4136',
            name: 'Xuân Lâm',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '275',
        name: 'Nghi Lộc',
        wards: [
          {
            id: '4137',
            name: ' Nghi Tiến',
            prefix: 'Xã',
          },
          {
            id: '4138',
            name: 'Nghi Công bắc',
            prefix: 'Xã',
          },
          {
            id: '4139',
            name: 'Nghi Công nam',
            prefix: 'Xã',
          },
          {
            id: '4140',
            name: 'Nghi Diên',
            prefix: 'Xã',
          },
          {
            id: '4141',
            name: 'Nghi Đồng',
            prefix: 'Xã',
          },
          {
            id: '4142',
            name: 'Nghi Hoa',
            prefix: 'Xã',
          },
          {
            id: '4143',
            name: 'Nghi Hợp',
            prefix: 'Xã',
          },
          {
            id: '4144',
            name: 'Nghi Hưng',
            prefix: 'Xã',
          },
          {
            id: '4145',
            name: 'Nghi Khánh',
            prefix: 'Xã',
          },
          {
            id: '4146',
            name: 'Nghi Kiều',
            prefix: 'Xã',
          },
          {
            id: '4147',
            name: 'Nghi Lâm',
            prefix: 'Xã',
          },
          {
            id: '4148',
            name: 'Nghi Liên',
            prefix: 'Xã',
          },
          {
            id: '4149',
            name: 'Nghi Long',
            prefix: 'Xã',
          },
          {
            id: '4150',
            name: 'Nghi Mỹ',
            prefix: 'Xã',
          },
          {
            id: '4151',
            name: 'Nghi Phong',
            prefix: 'Xã',
          },
          {
            id: '4152',
            name: 'Nghi Phương',
            prefix: 'Xã',
          },
          {
            id: '4153',
            name: 'Nghi Quang',
            prefix: 'Xã',
          },
          {
            id: '4154',
            name: 'Nghi Thạch',
            prefix: 'Xã',
          },
          {
            id: '4155',
            name: 'Nghi Thái',
            prefix: 'Xã',
          },
          {
            id: '4156',
            name: 'Nghi Thiết',
            prefix: 'Xã',
          },
          {
            id: '4157',
            name: 'Nghi Thịnh',
            prefix: 'Xã',
          },
          {
            id: '4158',
            name: 'Nghi Thuận',
            prefix: 'Xã',
          },
          {
            id: '4159',
            name: 'Nghi Trung',
            prefix: 'Xã',
          },
          {
            id: '4160',
            name: 'Nghi Trường',
            prefix: 'Xã',
          },
          {
            id: '4161',
            name: 'Nghi Văn',
            prefix: 'Xã',
          },
          {
            id: '4162',
            name: 'Nghi Vạn',
            prefix: 'Xã',
          },
          {
            id: '4163',
            name: 'Nghi Xá',
            prefix: 'Xã',
          },
          {
            id: '4164',
            name: 'Nghi Xuân',
            prefix: 'Xã',
          },
          {
            id: '4165',
            name: 'Nghi Yên',
            prefix: 'Xã',
          },
          {
            id: '4166',
            name: 'Phúc Thọ',
            prefix: 'Xã',
          },
          {
            id: '4167',
            name: 'Quán Hành',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '276',
        name: 'Nghĩa Đàn',
        wards: [
          {
            id: '4168',
            name: 'Nghĩa An',
            prefix: 'Xã',
          },
          {
            id: '4169',
            name: 'Nghĩa Bình',
            prefix: 'Xã',
          },
          {
            id: '4170',
            name: 'Nghĩa Đàn',
            prefix: 'Thị trấn',
          },
          {
            id: '4171',
            name: 'Nghĩa Đức',
            prefix: 'Xã',
          },
          {
            id: '4172',
            name: 'Nghĩa Hiếu',
            prefix: 'Xã',
          },
          {
            id: '4173',
            name: 'Nghĩa Hội',
            prefix: 'Xã',
          },
          {
            id: '4174',
            name: 'Nghĩa Hồng',
            prefix: 'Xã',
          },
          {
            id: '4175',
            name: 'Nghĩa Hưng',
            prefix: 'Xã',
          },
          {
            id: '4176',
            name: 'Nghĩa Khánh',
            prefix: 'Xã',
          },
          {
            id: '4177',
            name: 'Nghĩa Lạc',
            prefix: 'Xã',
          },
          {
            id: '4178',
            name: 'Nghĩa Lâm',
            prefix: 'Xã',
          },
          {
            id: '4179',
            name: 'Nghĩa Liên',
            prefix: 'Xã',
          },
          {
            id: '4180',
            name: 'Nghĩa Lộc',
            prefix: 'Xã',
          },
          {
            id: '4181',
            name: 'Nghĩa Lợi',
            prefix: 'Xã',
          },
          {
            id: '4182',
            name: 'Nghĩa Long',
            prefix: 'Xã',
          },
          {
            id: '4183',
            name: 'Nghĩa Mai',
            prefix: 'Xã',
          },
          {
            id: '4184',
            name: 'Nghĩa Minh',
            prefix: 'Xã',
          },
          {
            id: '4185',
            name: 'Nghĩa Phú',
            prefix: 'Xã',
          },
          {
            id: '4186',
            name: 'Nghĩa Sơn',
            prefix: 'Xã',
          },
          {
            id: '4187',
            name: 'Nghĩa Tân',
            prefix: 'Xã',
          },
          {
            id: '4188',
            name: 'Nghĩa Thắng',
            prefix: 'Xã',
          },
          {
            id: '4189',
            name: 'Nghĩa Thịnh',
            prefix: 'Xã',
          },
          {
            id: '4190',
            name: 'Nghĩa Thọ',
            prefix: 'Xã',
          },
          {
            id: '4191',
            name: 'Nghĩa Trung',
            prefix: 'Xã',
          },
          {
            id: '4192',
            name: 'Nghĩa Yên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '277',
        name: 'Quế Phong',
        wards: [
          {
            id: '4193',
            name: 'Cắm Muộn',
            prefix: 'Xã',
          },
          {
            id: '4194',
            name: 'Châu Kim',
            prefix: 'Xã',
          },
          {
            id: '4195',
            name: 'Châu Thôn',
            prefix: 'Xã',
          },
          {
            id: '4196',
            name: 'Đồng Văn',
            prefix: 'Xã',
          },
          {
            id: '4197',
            name: 'Hạnh Dịch',
            prefix: 'Xã',
          },
          {
            id: '4198',
            name: 'Kim Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '4199',
            name: 'Mường Nọc',
            prefix: 'Xã',
          },
          {
            id: '4200',
            name: 'Nậm Giải',
            prefix: 'Xã',
          },
          {
            id: '4201',
            name: 'Nậm Nhoóng',
            prefix: 'Xã',
          },
          {
            id: '4202',
            name: 'Quang Phong',
            prefix: 'Xã',
          },
          {
            id: '4203',
            name: 'Quế Sơn',
            prefix: 'Xã',
          },
          {
            id: '4204',
            name: 'Thông Thụ',
            prefix: 'Xã',
          },
          {
            id: '4205',
            name: 'Tiền Phong',
            prefix: 'Xã',
          },
          {
            id: '4206',
            name: 'Tri Lễ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '278',
        name: 'Quỳ Châu',
        wards: [
          {
            id: '4207',
            name: 'Châu Bính',
            prefix: 'Xã',
          },
          {
            id: '4208',
            name: 'Châu Bình',
            prefix: 'Xã',
          },
          {
            id: '4209',
            name: 'Châu Hạnh',
            prefix: 'Xã',
          },
          {
            id: '4210',
            name: 'Châu Hoàn',
            prefix: 'Xã',
          },
          {
            id: '4211',
            name: 'Châu Hội',
            prefix: 'Xã',
          },
          {
            id: '4212',
            name: 'Châu Nga',
            prefix: 'Xã',
          },
          {
            id: '4213',
            name: 'Châu Phong',
            prefix: 'Xã',
          },
          {
            id: '4214',
            name: 'Châu Thắng',
            prefix: 'Xã',
          },
          {
            id: '4215',
            name: 'Châu Thuận',
            prefix: 'Xã',
          },
          {
            id: '4216',
            name: 'Châu Tiến',
            prefix: 'Xã',
          },
          {
            id: '4217',
            name: 'Diên Lãm',
            prefix: 'Xã',
          },
          {
            id: '4218',
            name: 'Tân Lạc',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '279',
        name: 'Quỳ Hợp',
        wards: [
          {
            id: '4219',
            name: 'Bắc Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '4220',
            name: 'Châu Cường',
            prefix: 'Thị trấn',
          },
          {
            id: '4221',
            name: 'Châu Đình',
            prefix: 'Thị trấn',
          },
          {
            id: '4222',
            name: 'Châu Hồng',
            prefix: 'Thị trấn',
          },
          {
            id: '4223',
            name: 'Châu Lộc',
            prefix: 'Thị trấn',
          },
          {
            id: '4224',
            name: 'Châu Lý',
            prefix: 'Thị trấn',
          },
          {
            id: '4225',
            name: 'Châu Quang',
            prefix: 'Thị trấn',
          },
          {
            id: '4226',
            name: 'Châu Thái',
            prefix: 'Thị trấn',
          },
          {
            id: '4227',
            name: 'Châu Thành',
            prefix: 'Thị trấn',
          },
          {
            id: '4228',
            name: 'Châu Tiến',
            prefix: 'Thị trấn',
          },
          {
            id: '4229',
            name: 'Đồng Hợp',
            prefix: 'Thị trấn',
          },
          {
            id: '4230',
            name: 'Hạ Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '4231',
            name: 'Liên Hợp',
            prefix: 'Thị trấn',
          },
          {
            id: '4232',
            name: 'Minh Hợp',
            prefix: 'Thị trấn',
          },
          {
            id: '4233',
            name: 'Nam Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '4234',
            name: 'Nghĩa Xuân',
            prefix: 'Thị trấn',
          },
          {
            id: '4235',
            name: 'Quỳ Hợp',
            prefix: 'Thị trấn',
          },
          {
            id: '4236',
            name: 'Tam Hợp',
            prefix: 'Thị trấn',
          },
          {
            id: '4237',
            name: 'Thọ Hợp',
            prefix: 'Thị trấn',
          },
          {
            id: '4238',
            name: 'Văn Lợi',
            prefix: 'Thị trấn',
          },
          {
            id: '4239',
            name: 'Yên Hợp',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '280',
        name: 'Quỳnh Lưu',
        wards: [
          {
            id: '4240',
            name: 'An Hòa',
            prefix: 'Xã',
          },
          {
            id: '4241',
            name: 'Cầu Giát',
            prefix: 'Thị trấn',
          },
          {
            id: '4242',
            name: 'Ngọc Sơn',
            prefix: 'Xã',
          },
          {
            id: '4243',
            name: 'Quỳnh Bá',
            prefix: 'Xã',
          },
          {
            id: '4244',
            name: 'Quỳnh Bảng',
            prefix: 'Xã',
          },
          {
            id: '4245',
            name: 'Quỳnh Châu',
            prefix: 'Xã',
          },
          {
            id: '4246',
            name: 'Quỳnh Diện',
            prefix: 'Xã',
          },
          {
            id: '4247',
            name: 'Quỳnh Đôi',
            prefix: 'Xã',
          },
          {
            id: '4248',
            name: 'Quỳnh Giang',
            prefix: 'Xã',
          },
          {
            id: '4249',
            name: 'Quỳnh Hậu',
            prefix: 'Xã',
          },
          {
            id: '4250',
            name: 'Quỳnh Hoa',
            prefix: 'Xã',
          },
          {
            id: '4251',
            name: 'Quỳnh Hồng',
            prefix: 'Xã',
          },
          {
            id: '4252',
            name: 'Quỳnh Hưng',
            prefix: 'Xã',
          },
          {
            id: '4253',
            name: 'Quỳnh Lâm',
            prefix: 'Xã',
          },
          {
            id: '4254',
            name: 'Quỳnh Long',
            prefix: 'Xã',
          },
          {
            id: '4255',
            name: 'Quỳnh Lương',
            prefix: 'Xã',
          },
          {
            id: '4256',
            name: 'Quỳnh Minh',
            prefix: 'Xã',
          },
          {
            id: '4257',
            name: 'Quỳnh Mỹ',
            prefix: 'Xã',
          },
          {
            id: '4258',
            name: 'Quỳnh Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '4259',
            name: 'Quỳnh Ngọc',
            prefix: 'Xã',
          },
          {
            id: '4260',
            name: 'Quỳnh Tam',
            prefix: 'Xã',
          },
          {
            id: '4261',
            name: 'Quỳnh Tân',
            prefix: 'Xã',
          },
          {
            id: '4262',
            name: 'Quỳnh Thạch',
            prefix: 'Xã',
          },
          {
            id: '4263',
            name: 'Quỳnh Thắng',
            prefix: 'Xã',
          },
          {
            id: '4264',
            name: 'Quỳnh Thanh',
            prefix: 'Xã',
          },
          {
            id: '4265',
            name: 'Quỳnh Thọ',
            prefix: 'Xã',
          },
          {
            id: '4266',
            name: 'Quỳnh Thuận',
            prefix: 'Xã',
          },
          {
            id: '4267',
            name: 'Quỳnh Văn',
            prefix: 'Xã',
          },
          {
            id: '4268',
            name: 'Quỳnh Yên',
            prefix: 'Xã',
          },
          {
            id: '4269',
            name: 'Sơn Hải',
            prefix: 'Xã',
          },
          {
            id: '4270',
            name: 'Tân Sơn',
            prefix: 'Xã',
          },
          {
            id: '4271',
            name: 'Tân Thắng',
            prefix: 'Xã',
          },
          {
            id: '4272',
            name: 'Tiến Thủy',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '281',
        name: 'Tân Kỳ',
        wards: [
          {
            id: '4273',
            name: 'Đồng Văn',
            prefix: 'Xã',
          },
          {
            id: '4274',
            name: 'Giai Xuân',
            prefix: 'Xã',
          },
          {
            id: '4275',
            name: 'Hương Sơn',
            prefix: 'Xã',
          },
          {
            id: '4276',
            name: 'Kỳ Sơn',
            prefix: 'Xã',
          },
          {
            id: '4277',
            name: 'Kỳ Tân',
            prefix: 'Xã',
          },
          {
            id: '4278',
            name: 'Nghĩa Bình',
            prefix: 'Xã',
          },
          {
            id: '4280',
            name: 'Nghĩa Dũng',
            prefix: 'Xã',
          },
          {
            id: '4279',
            name: 'Nghĩa Đồng',
            prefix: 'Xã',
          },
          {
            id: '4281',
            name: 'Nghĩa Hành',
            prefix: 'Xã',
          },
          {
            id: '4282',
            name: 'Nghĩa Hoàn',
            prefix: 'Xã',
          },
          {
            id: '4283',
            name: 'Nghĩa Hợp',
            prefix: 'Xã',
          },
          {
            id: '4284',
            name: 'Nghĩa Phúc',
            prefix: 'Xã',
          },
          {
            id: '4285',
            name: 'Nghĩa Thái',
            prefix: 'Xã',
          },
          {
            id: '4286',
            name: 'Phú Sơn',
            prefix: 'Xã',
          },
          {
            id: '4287',
            name: 'Tân An',
            prefix: 'Xã',
          },
          {
            id: '4288',
            name: 'Tân Hợp',
            prefix: 'Xã',
          },
          {
            id: '4289',
            name: 'Tân Hương',
            prefix: 'Xã',
          },
          {
            id: '4290',
            name: 'Tân Kỳ',
            prefix: 'Thị trấn',
          },
          {
            id: '4291',
            name: 'Tân Long',
            prefix: 'Xã',
          },
          {
            id: '4292',
            name: 'Tân Phú',
            prefix: 'Xã',
          },
          {
            id: '4293',
            name: 'Tân Xuân',
            prefix: 'Xã',
          },
          {
            id: '4294',
            name: 'Tiên Kỳ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '282',
        name: 'Thái Hòa',
        wards: [
          {
            id: '4295',
            name: 'Đông Hiếu',
            prefix: 'Xã',
          },
          {
            id: '4296',
            name: 'Hòa Hiếu',
            prefix: 'Phường',
          },
          {
            id: '4297',
            name: 'Long Sơn',
            prefix: 'Phường',
          },
          {
            id: '4298',
            name: 'Nghĩa Hòa',
            prefix: 'Xã',
          },
          {
            id: '4299',
            name: 'Nghĩa Mỹ',
            prefix: 'Xã',
          },
          {
            id: '4300',
            name: 'Nghĩa Thuận',
            prefix: 'Xã',
          },
          {
            id: '4301',
            name: 'Nghĩa Tiến',
            prefix: 'Xã',
          },
          {
            id: '4302',
            name: 'Quang Phong',
            prefix: 'Phường',
          },
          {
            id: '4303',
            name: 'Quang Tiến',
            prefix: 'Phường',
          },
          {
            id: '4304',
            name: 'Tây Hiếu',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '283',
        name: 'Thanh Chương',
        wards: [
          {
            id: '4305',
            name: 'Cát Văn',
            prefix: 'Xã',
          },
          {
            id: '4307',
            name: 'Dùng',
            prefix: 'Thị trấn',
          },
          {
            id: '4306',
            name: 'Đồng Văn',
            prefix: 'Xã',
          },
          {
            id: '4308',
            name: 'Hạnh Lâm',
            prefix: 'Xã',
          },
          {
            id: '4309',
            name: 'Ngọc Lâm',
            prefix: 'Xã',
          },
          {
            id: '4310',
            name: 'Ngọc Sơn',
            prefix: 'Xã',
          },
          {
            id: '4311',
            name: 'Phong Thịnh',
            prefix: 'Xã',
          },
          {
            id: '4312',
            name: 'Thanh An',
            prefix: 'Xã',
          },
          {
            id: '4313',
            name: 'Thanh Chi',
            prefix: 'Xã',
          },
          {
            id: '4314',
            name: 'Thanh Chương',
            prefix: 'Thị trấn',
          },
          {
            id: '4317',
            name: 'Thanh Dương',
            prefix: 'Xã',
          },
          {
            id: '4315',
            name: 'Thanh Đồng',
            prefix: 'Xã',
          },
          {
            id: '4316',
            name: 'Thanh Đức',
            prefix: 'Xã',
          },
          {
            id: '4318',
            name: 'Thanh Giang',
            prefix: 'Xã',
          },
          {
            id: '4319',
            name: 'Thanh Hà',
            prefix: 'Xã',
          },
          {
            id: '4320',
            name: 'Thanh Hoà',
            prefix: 'Xã',
          },
          {
            id: '4321',
            name: 'Thanh Hưng',
            prefix: 'Xã',
          },
          {
            id: '4322',
            name: 'Thanh Hương',
            prefix: 'Xã',
          },
          {
            id: '4323',
            name: 'Thanh Khai',
            prefix: 'Xã',
          },
          {
            id: '4324',
            name: 'Thanh Khê',
            prefix: 'Xã',
          },
          {
            id: '4325',
            name: 'Thanh Lâm',
            prefix: 'Xã',
          },
          {
            id: '4326',
            name: 'Thanh Liên',
            prefix: 'Xã',
          },
          {
            id: '4327',
            name: 'Thanh Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '4328',
            name: 'Thanh Long',
            prefix: 'Xã',
          },
          {
            id: '4329',
            name: 'Thanh Lương',
            prefix: 'Xã',
          },
          {
            id: '4330',
            name: 'Thanh Mai',
            prefix: 'Xã',
          },
          {
            id: '4331',
            name: 'Thanh Mỹ',
            prefix: 'Xã',
          },
          {
            id: '4332',
            name: 'Thanh Ngọc',
            prefix: 'Xã',
          },
          {
            id: '4333',
            name: 'Thanh Nho',
            prefix: 'Xã',
          },
          {
            id: '4334',
            name: 'Thanh Phong',
            prefix: 'Xã',
          },
          {
            id: '4335',
            name: 'Thanh Sơn',
            prefix: 'Xã',
          },
          {
            id: '4336',
            name: 'Thanh Thịnh',
            prefix: 'Xã',
          },
          {
            id: '4337',
            name: 'Thanh Thuỷ',
            prefix: 'Xã',
          },
          {
            id: '4338',
            name: 'Thanh Tiên',
            prefix: 'Xã',
          },
          {
            id: '4339',
            name: 'Thanh Tùng',
            prefix: 'Xã',
          },
          {
            id: '4340',
            name: 'Thanh Tường',
            prefix: 'Xã',
          },
          {
            id: '4341',
            name: 'Thanh Văn',
            prefix: 'Xã',
          },
          {
            id: '4342',
            name: 'Thanh Xuân',
            prefix: 'Xã',
          },
          {
            id: '4343',
            name: 'Thanh Yên',
            prefix: 'Xã',
          },
          {
            id: '4344',
            name: 'Võ Liệt',
            prefix: 'Xã',
          },
          {
            id: '4345',
            name: 'Xuân Tường',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '284',
        name: 'Tương Dương',
        wards: [
          {
            id: '4346',
            name: 'Hòa Bình',
            prefix: 'Thị trấn',
          },
          {
            id: '4347',
            name: 'Hữu Khuông',
            prefix: 'Thị trấn',
          },
          {
            id: '4348',
            name: 'Lượng Minh',
            prefix: 'Thị trấn',
          },
          {
            id: '4349',
            name: 'Lưu Kiền',
            prefix: 'Thị trấn',
          },
          {
            id: '4350',
            name: 'Mai Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '4351',
            name: 'Nga My',
            prefix: 'Thị trấn',
          },
          {
            id: '4352',
            name: 'Nhôn Mai',
            prefix: 'Thị trấn',
          },
          {
            id: '4353',
            name: 'Tam Đình',
            prefix: 'Thị trấn',
          },
          {
            id: '4354',
            name: 'Tam Hợp',
            prefix: 'Thị trấn',
          },
          {
            id: '4355',
            name: 'Tam Quang',
            prefix: 'Thị trấn',
          },
          {
            id: '4356',
            name: 'Tam Thái',
            prefix: 'Thị trấn',
          },
          {
            id: '4357',
            name: 'Thạch Giám',
            prefix: 'Thị trấn',
          },
          {
            id: '4358',
            name: 'Xá Lượng',
            prefix: 'Thị trấn',
          },
          {
            id: '4359',
            name: 'Xiêng My',
            prefix: 'Thị trấn',
          },
          {
            id: '4360',
            name: 'Yên Hòa',
            prefix: 'Thị trấn',
          },
          {
            id: '4361',
            name: 'Yên Na',
            prefix: 'Thị trấn',
          },
          {
            id: '4362',
            name: 'Yên Thắng',
            prefix: 'Thị trấn',
          },
          {
            id: '4363',
            name: 'Yên Tĩnh',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '285',
        name: 'Vinh',
        wards: [
          {
            id: '4364',
            name: ' Bến Thuỷ',
            prefix: 'Phường',
          },
          {
            id: '4365',
            name: 'Cửa Nam',
            prefix: 'Phường',
          },
          {
            id: '4366',
            name: 'Đội Cung',
            prefix: 'Phường',
          },
          {
            id: '4367',
            name: 'Đông Vĩnh',
            prefix: 'Phường',
          },
          {
            id: '4368',
            name: 'Hà Huy Tập',
            prefix: 'Phường',
          },
          {
            id: '4369',
            name: 'Hồng Sơn',
            prefix: 'Phường',
          },
          {
            id: '4370',
            name: 'Hưng Bình',
            prefix: 'Phường',
          },
          {
            id: '4371',
            name: 'Hưng Chính',
            prefix: 'Xã',
          },
          {
            id: '4373',
            name: 'Hưng Dũng',
            prefix: 'Phường',
          },
          {
            id: '4372',
            name: 'Hưng Đông',
            prefix: 'Xã',
          },
          {
            id: '4374',
            name: 'Hưng Hòa',
            prefix: 'Xã',
          },
          {
            id: '4375',
            name: 'Hưng Lộc',
            prefix: 'Xã',
          },
          {
            id: '4376',
            name: 'Hưng Phúc',
            prefix: 'Phường',
          },
          {
            id: '4377',
            name: 'Hưng Thịnh',
            prefix: 'Xã',
          },
          {
            id: '4378',
            name: 'Lê Lợi',
            prefix: 'Phường',
          },
          {
            id: '4379',
            name: 'Lê Mao',
            prefix: 'Phường',
          },
          {
            id: '4380',
            name: 'Nghi Ân',
            prefix: 'Xã',
          },
          {
            id: '4381',
            name: 'Nghi Đức',
            prefix: 'Xã',
          },
          {
            id: '4382',
            name: 'Nghi Kim',
            prefix: 'Xã',
          },
          {
            id: '4383',
            name: 'Nghi Liên',
            prefix: 'Xã',
          },
          {
            id: '4384',
            name: 'Nghi Phong',
            prefix: 'Xã',
          },
          {
            id: '4385',
            name: 'Nghi Phú',
            prefix: 'Xã',
          },
          {
            id: '4386',
            name: 'Quán Bàu',
            prefix: 'Phường',
          },
          {
            id: '4387',
            name: 'Quang Trung',
            prefix: 'Phường',
          },
          {
            id: '4388',
            name: 'Trung Đô',
            prefix: 'Phường',
          },
          {
            id: '4389',
            name: 'Trường Thi',
            prefix: 'Phường',
          },
          {
            id: '4390',
            name: 'Vinh Tân',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '286',
        name: 'Yên Thành',
        wards: [
          {
            id: '4391',
            name: 'Bắc Thành',
            prefix: 'Xã',
          },
          {
            id: '4392',
            name: 'Bảo Thành',
            prefix: 'Xã',
          },
          {
            id: '4393',
            name: 'Công Thành',
            prefix: 'Xã',
          },
          {
            id: '4394',
            name: 'Đại Thành',
            prefix: 'Xã',
          },
          {
            id: '4395',
            name: 'Đô Thành',
            prefix: 'Xã',
          },
          {
            id: '4396',
            name: 'Đồng Thành',
            prefix: 'Xã',
          },
          {
            id: '4397',
            name: 'Đức Thành',
            prefix: 'Xã',
          },
          {
            id: '4398',
            name: 'Hậu Thành',
            prefix: 'Xã',
          },
          {
            id: '4399',
            name: 'Hoa Thành',
            prefix: 'Xã',
          },
          {
            id: '4400',
            name: 'Hồng Thành',
            prefix: 'Xã',
          },
          {
            id: '4401',
            name: 'Hợp Thành',
            prefix: 'Xã',
          },
          {
            id: '4402',
            name: 'Hùng Thành',
            prefix: 'Xã',
          },
          {
            id: '4403',
            name: 'Khánh Dương',
            prefix: 'Xã',
          },
          {
            id: '4404',
            name: 'Khánh Thành',
            prefix: 'Xã',
          },
          {
            id: '4405',
            name: 'Kim Thành',
            prefix: 'Xã',
          },
          {
            id: '4406',
            name: 'Lăng Thành',
            prefix: 'Xã',
          },
          {
            id: '4407',
            name: 'Liên Thành',
            prefix: 'Xã',
          },
          {
            id: '4408',
            name: 'Long Thành',
            prefix: 'Xã',
          },
          {
            id: '4409',
            name: 'Lý Thành',
            prefix: 'Xã',
          },
          {
            id: '4410',
            name: 'Mã Thành',
            prefix: 'Xã',
          },
          {
            id: '4411',
            name: 'Minh Thành',
            prefix: 'Xã',
          },
          {
            id: '4412',
            name: 'Mỹ Thành',
            prefix: 'Xã',
          },
          {
            id: '4413',
            name: 'Nam Thành',
            prefix: 'Xã',
          },
          {
            id: '4414',
            name: 'Nhân Thành',
            prefix: 'Xã',
          },
          {
            id: '4415',
            name: 'Phú Thành',
            prefix: 'Xã',
          },
          {
            id: '4416',
            name: 'Phúc Thành',
            prefix: 'Xã',
          },
          {
            id: '4417',
            name: 'Quang Thành',
            prefix: 'Xã',
          },
          {
            id: '4418',
            name: 'Sơn Thành',
            prefix: 'Xã',
          },
          {
            id: '4419',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '4420',
            name: 'Tăng Thành',
            prefix: 'Xã',
          },
          {
            id: '4421',
            name: 'Tây Thành',
            prefix: 'Xã',
          },
          {
            id: '4422',
            name: 'Thịnh Thành',
            prefix: 'Xã',
          },
          {
            id: '4423',
            name: 'Thọ Thành',
            prefix: 'Xã',
          },
          {
            id: '4424',
            name: 'Tiến Thành',
            prefix: 'Xã',
          },
          {
            id: '4425',
            name: 'Trung Thành',
            prefix: 'Xã',
          },
          {
            id: '4426',
            name: 'Văn Thành',
            prefix: 'Xã',
          },
          {
            id: '4427',
            name: 'Viên Thành',
            prefix: 'Xã',
          },
          {
            id: '4428',
            name: 'Vĩnh Thành',
            prefix: 'Xã',
          },
          {
            id: '4429',
            name: 'Xuân Thành',
            prefix: 'Xã',
          },
          {
            id: '4430',
            name: 'Yên Thành',
            prefix: 'Thị trấn',
          },
        ],
      },
    ],
  },
  {
    id: '21',
    code: 'HD',
    name: 'Hải Dương',
    districts: [
      {
        id: '287',
        name: 'Bình Giang',
        wards: [
          {
            id: '4431',
            name: 'Bình Minh',
            prefix: 'Xã',
          },
          {
            id: '4432',
            name: 'Bình Xuyên',
            prefix: 'Xã',
          },
          {
            id: '4433',
            name: 'Cổ Bi',
            prefix: 'Xã',
          },
          {
            id: '4434',
            name: 'Hồng Khê',
            prefix: 'Xã',
          },
          {
            id: '4435',
            name: 'Hùng Thắng',
            prefix: 'Xã',
          },
          {
            id: '4436',
            name: 'Hưng Thịnh',
            prefix: 'Xã',
          },
          {
            id: '4437',
            name: 'Kẻ Sặt',
            prefix: 'Thị trấn',
          },
          {
            id: '4438',
            name: 'Long Xuyên',
            prefix: 'Xã',
          },
          {
            id: '4439',
            name: 'Nhân Quyền',
            prefix: 'Xã',
          },
          {
            id: '4440',
            name: 'Tân Hồng',
            prefix: 'Xã',
          },
          {
            id: '4441',
            name: 'Tân Việt',
            prefix: 'Xã',
          },
          {
            id: '4442',
            name: 'Thái Dương',
            prefix: 'Xã',
          },
          {
            id: '4443',
            name: 'Thái Hòa',
            prefix: 'Xã',
          },
          {
            id: '4444',
            name: 'Thái Học',
            prefix: 'Xã',
          },
          {
            id: '4445',
            name: 'Thúc Kháng',
            prefix: 'Xã',
          },
          {
            id: '4446',
            name: 'Tráng Liệt',
            prefix: 'Xã',
          },
          {
            id: '4447',
            name: 'Vĩnh Hồng',
            prefix: 'Xã',
          },
          {
            id: '4448',
            name: 'Vĩnh Tuy',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '288',
        name: 'Cẩm Giàng',
        wards: [
          {
            id: '4449',
            name: 'Cẩm Điền',
            prefix: 'Xã',
          },
          {
            id: '4450',
            name: 'Cẩm Định',
            prefix: 'Xã',
          },
          {
            id: '4451',
            name: 'Cẩm Đoài',
            prefix: 'Xã',
          },
          {
            id: '4452',
            name: 'Cẩm Đông',
            prefix: 'Xã',
          },
          {
            id: '4453',
            name: 'Cẩm Giàng',
            prefix: 'Thị trấn',
          },
          {
            id: '4454',
            name: 'Cẩm Hoàng',
            prefix: 'Xã',
          },
          {
            id: '4455',
            name: 'Cẩm Hưng',
            prefix: 'Xã',
          },
          {
            id: '4456',
            name: 'Cẩm Phúc',
            prefix: 'Xã',
          },
          {
            id: '4457',
            name: 'Cẩm Sơn',
            prefix: 'Xã',
          },
          {
            id: '4458',
            name: 'Cẩm Văn',
            prefix: 'Xã',
          },
          {
            id: '4459',
            name: 'Cẩm Vũ',
            prefix: 'Xã',
          },
          {
            id: '4460',
            name: 'Cao An',
            prefix: 'Xã',
          },
          {
            id: '4461',
            name: 'Đức Chính',
            prefix: 'Xã',
          },
          {
            id: '4462',
            name: 'Kim Giang',
            prefix: 'Xã',
          },
          {
            id: '4463',
            name: 'Lai Cách',
            prefix: 'Thị trấn',
          },
          {
            id: '4464',
            name: 'Lương Điền',
            prefix: 'Xã',
          },
          {
            id: '4465',
            name: 'Ngọc Liên',
            prefix: 'Xã',
          },
          {
            id: '4466',
            name: 'Tân Trường',
            prefix: 'Xã',
          },
          {
            id: '4467',
            name: 'Thạch Lỗi',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '289',
        name: 'Chí Linh',
        wards: [
          {
            id: '4468',
            name: 'An Lạc',
            prefix: 'Xã',
          },
          {
            id: '4469',
            name: 'Bắc An',
            prefix: 'Phường',
          },
          {
            id: '4470',
            name: 'Bến Tắm',
            prefix: 'Phường',
          },
          {
            id: '4471',
            name: 'Chí Minh',
            prefix: 'Phường',
          },
          {
            id: '4472',
            name: 'Cổ Thành',
            prefix: 'Xã',
          },
          {
            id: '4473',
            name: 'Cộng Hòa',
            prefix: 'Phường',
          },
          {
            id: '4474',
            name: 'Đồng Lạc',
            prefix: 'Xã',
          },
          {
            id: '4475',
            name: 'Hoàng Hoa Thám',
            prefix: 'Phường',
          },
          {
            id: '4476',
            name: 'Hoàng Tân',
            prefix: 'Phường',
          },
          {
            id: '4477',
            name: 'Hoàng Tiến',
            prefix: 'Xã',
          },
          {
            id: '4478',
            name: 'Hưng Đạo',
            prefix: 'Xã',
          },
          {
            id: '4479',
            name: 'Kênh Giang',
            prefix: 'Xã',
          },
          {
            id: '4480',
            name: 'Lê Lợi',
            prefix: 'Phường',
          },
          {
            id: '4481',
            name: 'Nhân Huệ',
            prefix: 'Xã',
          },
          {
            id: '4482',
            name: 'Phả Lại',
            prefix: 'Phường',
          },
          {
            id: '4483',
            name: 'Sao Đỏ',
            prefix: 'Phường',
          },
          {
            id: '4484',
            name: 'Tân Dân',
            prefix: 'Xã',
          },
          {
            id: '4485',
            name: 'Thái Học',
            prefix: 'Phường',
          },
          {
            id: '4486',
            name: 'Văn An',
            prefix: 'Phường',
          },
          {
            id: '4487',
            name: 'Văn Đức',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '290',
        name: 'Gia Lộc',
        wards: [
          {
            id: '4488',
            name: 'Đoàn Thượng',
            prefix: 'Xã',
          },
          {
            id: '4489',
            name: 'Đồng Quang',
            prefix: 'Xã',
          },
          {
            id: '4490',
            name: 'Đức Xương',
            prefix: 'Xã',
          },
          {
            id: '4491',
            name: 'Gia Hòa',
            prefix: 'Xã',
          },
          {
            id: '4492',
            name: 'Gia Khánh',
            prefix: 'Xã',
          },
          {
            id: '4493',
            name: 'Gia Lộc',
            prefix: 'Thị trấn',
          },
          {
            id: '4494',
            name: 'Gia Lương',
            prefix: 'Xã',
          },
          {
            id: '4495',
            name: 'Gia Tân',
            prefix: 'Xã',
          },
          {
            id: '4496',
            name: 'Gia Xuyên',
            prefix: 'Xã',
          },
          {
            id: '4497',
            name: 'Hoàng Diệu',
            prefix: 'Xã',
          },
          {
            id: '4498',
            name: 'Hồng Hưng',
            prefix: 'Xã',
          },
          {
            id: '4499',
            name: 'Lê Lợi',
            prefix: 'Xã',
          },
          {
            id: '4500',
            name: 'Liên Hồng',
            prefix: 'Xã',
          },
          {
            id: '4501',
            name: 'Nhật Tân',
            prefix: 'Xã',
          },
          {
            id: '4502',
            name: 'Phạm Trấn',
            prefix: 'Xã',
          },
          {
            id: '4503',
            name: 'Phương Hưng',
            prefix: 'Xã',
          },
          {
            id: '4504',
            name: 'Quang Minh',
            prefix: 'Xã',
          },
          {
            id: '4505',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '4506',
            name: 'Thống Kênh',
            prefix: 'Xã',
          },
          {
            id: '4507',
            name: 'Thống Nhất',
            prefix: 'Xã',
          },
          {
            id: '4508',
            name: 'Toàn Thắng',
            prefix: 'Xã',
          },
          {
            id: '4509',
            name: 'Trùng Khánh',
            prefix: 'Xã',
          },
          {
            id: '4510',
            name: 'Yết Kiêu',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '291',
        name: 'Hải Dương',
        wards: [
          {
            id: '4511',
            name: 'Ái Quốc',
            prefix: 'Xã',
          },
          {
            id: '4512',
            name: 'An Châu',
            prefix: 'Xã',
          },
          {
            id: '4513',
            name: 'Bình Hàn',
            prefix: 'Phường',
          },
          {
            id: '4514',
            name: 'Cẩm Thượng',
            prefix: 'Phường',
          },
          {
            id: '4515',
            name: 'Hải Tân',
            prefix: 'Phường',
          },
          {
            id: '4516',
            name: 'Lê Thanh Nghị',
            prefix: 'Phường',
          },
          {
            id: '4517',
            name: 'Nam Đồng',
            prefix: 'Xã',
          },
          {
            id: '4518',
            name: 'Ngọc Châu',
            prefix: 'Phường',
          },
          {
            id: '4519',
            name: 'Nguyễn Trãi',
            prefix: 'Phường',
          },
          {
            id: '4520',
            name: 'Nhị Châu',
            prefix: 'Phường',
          },
          {
            id: '4521',
            name: 'Phạm Ngũ Lão',
            prefix: 'Phường',
          },
          {
            id: '4522',
            name: 'Quang Trung',
            prefix: 'Phường',
          },
          {
            id: '4523',
            name: 'Tân Bình',
            prefix: 'Phường',
          },
          {
            id: '4524',
            name: 'Tân Hưng',
            prefix: 'Xã',
          },
          {
            id: '4525',
            name: 'Thạch Khôi',
            prefix: 'Xã',
          },
          {
            id: '4526',
            name: 'Thanh Bình',
            prefix: 'Phường',
          },
          {
            id: '4527',
            name: 'Thượng Đạt',
            prefix: 'Xã',
          },
          {
            id: '4528',
            name: 'Trần Hưng Đạo',
            prefix: 'Phường',
          },
          {
            id: '4529',
            name: 'Trần Phú',
            prefix: 'Phường',
          },
          {
            id: '4530',
            name: 'Tứ Minh',
            prefix: 'Phường',
          },
          {
            id: '4531',
            name: 'Việt Hòa',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '292',
        name: 'Kim Thành',
        wards: [
          {
            id: '4532',
            name: 'Bình Dân',
            prefix: 'Xã',
          },
          {
            id: '4533',
            name: 'Cẩm La',
            prefix: 'Xã',
          },
          {
            id: '4534',
            name: 'Cổ Dũng',
            prefix: 'Xã',
          },
          {
            id: '4535',
            name: 'Cộng Hòa',
            prefix: 'Xã',
          },
          {
            id: '4536',
            name: 'Đại Đức',
            prefix: 'Xã',
          },
          {
            id: '4537',
            name: 'Đồng Gia',
            prefix: 'Xã',
          },
          {
            id: '4538',
            name: 'Kim Anh',
            prefix: 'Xã',
          },
          {
            id: '4539',
            name: 'Kim Đính',
            prefix: 'Xã',
          },
          {
            id: '4540',
            name: 'Kim Khê',
            prefix: 'Xã',
          },
          {
            id: '4541',
            name: 'Kim Lương',
            prefix: 'Xã',
          },
          {
            id: '4542',
            name: 'Kim Tân',
            prefix: 'Xã',
          },
          {
            id: '4543',
            name: 'Kim Xuyên',
            prefix: 'Xã',
          },
          {
            id: '4544',
            name: 'Lai Vu',
            prefix: 'Xã',
          },
          {
            id: '4545',
            name: 'Liên Hòa',
            prefix: 'Xã',
          },
          {
            id: '4546',
            name: 'Ngũ Phúc',
            prefix: 'Xã',
          },
          {
            id: '4547',
            name: 'Phú Thái',
            prefix: 'Thị trấn',
          },
          {
            id: '4548',
            name: 'Phúc Thành A',
            prefix: 'Xã',
          },
          {
            id: '4549',
            name: 'Tam Kỳ',
            prefix: 'Xã',
          },
          {
            id: '4550',
            name: 'Thượng Vũ',
            prefix: 'Xã',
          },
          {
            id: '4551',
            name: 'Tuấn Hưng',
            prefix: 'Xã',
          },
          {
            id: '4552',
            name: 'Việt Hưng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '293',
        name: 'Kinh Môn',
        wards: [
          {
            id: '4553',
            name: 'An Phụ',
            prefix: 'Xã',
          },
          {
            id: '4554',
            name: 'An Sinh',
            prefix: 'Xã',
          },
          {
            id: '4555',
            name: 'Bạch Đằng',
            prefix: 'Xã',
          },
          {
            id: '4556',
            name: 'Duy Tân',
            prefix: 'Xã',
          },
          {
            id: '4557',
            name: 'Hiến Thành',
            prefix: 'Xã',
          },
          {
            id: '4558',
            name: 'Hiệp An',
            prefix: 'Xã',
          },
          {
            id: '4559',
            name: 'Hiệp Hòa',
            prefix: 'Xã',
          },
          {
            id: '4560',
            name: 'Hiệp Sơn',
            prefix: 'Xã',
          },
          {
            id: '4561',
            name: 'Hoành Sơn',
            prefix: 'Xã',
          },
          {
            id: '4562',
            name: 'Hưng Đạo',
            prefix: 'Xã',
          },
          {
            id: '4563',
            name: 'Kinh Môn',
            prefix: 'Thị trấn',
          },
          {
            id: '4564',
            name: 'Lạc Long',
            prefix: 'Xã',
          },
          {
            id: '4565',
            name: 'Lê Ninh',
            prefix: 'Xã',
          },
          {
            id: '4566',
            name: 'Long Xuyên',
            prefix: 'Xã',
          },
          {
            id: '4567',
            name: 'Minh Hòa',
            prefix: 'Xã',
          },
          {
            id: '4568',
            name: 'Minh Tân',
            prefix: 'Thị trấn',
          },
          {
            id: '4569',
            name: 'Phạm Mệnh',
            prefix: 'Xã',
          },
          {
            id: '4570',
            name: 'Phú Thứ',
            prefix: 'Thị trấn',
          },
          {
            id: '4571',
            name: 'Phúc Thành B',
            prefix: 'Xã',
          },
          {
            id: '4572',
            name: 'Quang Trung',
            prefix: 'Xã',
          },
          {
            id: '4573',
            name: 'Tân Dân',
            prefix: 'Xã',
          },
          {
            id: '4574',
            name: 'Thái Hòa',
            prefix: 'Xã',
          },
          {
            id: '4575',
            name: 'Thái Sơn',
            prefix: 'Xã',
          },
          {
            id: '4576',
            name: 'Thái Thịnh',
            prefix: 'Xã',
          },
          {
            id: '4577',
            name: 'Thăng Long',
            prefix: 'Xã',
          },
          {
            id: '4578',
            name: 'Thất Hùng',
            prefix: 'Xã',
          },
          {
            id: '4579',
            name: 'Thượng Quận',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '294',
        name: 'Nam Sách',
        wards: [
          {
            id: '4580',
            name: 'An Bình',
            prefix: 'Xã',
          },
          {
            id: '4581',
            name: 'An Lâm',
            prefix: 'Xã',
          },
          {
            id: '4582',
            name: 'An Sơn',
            prefix: 'Xã',
          },
          {
            id: '4583',
            name: 'Cộng Hòa',
            prefix: 'Xã',
          },
          {
            id: '4584',
            name: 'Đồng Lạc',
            prefix: 'Xã',
          },
          {
            id: '4585',
            name: 'Hiệp Cát',
            prefix: 'Xã',
          },
          {
            id: '4586',
            name: 'Hồng Phong',
            prefix: 'Xã',
          },
          {
            id: '4587',
            name: 'Hợp Tiến',
            prefix: 'Xã',
          },
          {
            id: '4588',
            name: 'Minh Tân',
            prefix: 'Xã',
          },
          {
            id: '4589',
            name: 'Nam Chính',
            prefix: 'Xã',
          },
          {
            id: '4590',
            name: 'Nam Hồng',
            prefix: 'Xã',
          },
          {
            id: '4591',
            name: 'Nam Hưng',
            prefix: 'Xã',
          },
          {
            id: '4592',
            name: 'Nam Sách',
            prefix: 'Thị trấn',
          },
          {
            id: '4593',
            name: 'Nam Tân',
            prefix: 'Xã',
          },
          {
            id: '4594',
            name: 'Nam Trung',
            prefix: 'Xã',
          },
          {
            id: '4595',
            name: 'Phú Điền',
            prefix: 'Xã',
          },
          {
            id: '4596',
            name: 'Quốc Tuấn',
            prefix: 'Xã',
          },
          {
            id: '4597',
            name: 'Thái Tân',
            prefix: 'Xã',
          },
          {
            id: '4598',
            name: 'Thanh Quang',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '295',
        name: 'Ninh Giang',
        wards: [
          {
            id: '4599',
            name: 'An Đức',
            prefix: 'Xã',
          },
          {
            id: '4600',
            name: 'Đồng Tâm',
            prefix: 'Xã',
          },
          {
            id: '4601',
            name: 'Đông Xuyên',
            prefix: 'Xã',
          },
          {
            id: '4602',
            name: 'Hiệp Lực',
            prefix: 'Xã',
          },
          {
            id: '4603',
            name: 'Hoàng Hanh',
            prefix: 'Xã',
          },
          {
            id: '4604',
            name: 'Hồng Dụ',
            prefix: 'Xã',
          },
          {
            id: '4605',
            name: 'Hồng Đức',
            prefix: 'Xã',
          },
          {
            id: '4606',
            name: 'Hồng Phong',
            prefix: 'Xã',
          },
          {
            id: '4607',
            name: 'Hồng Phúc',
            prefix: 'Xã',
          },
          {
            id: '4608',
            name: 'Hồng Thái',
            prefix: 'Xã',
          },
          {
            id: '4609',
            name: 'Hưng Long',
            prefix: 'Xã',
          },
          {
            id: '4610',
            name: 'Hưng Thái',
            prefix: 'Xã',
          },
          {
            id: '4611',
            name: 'Kiến Quốc',
            prefix: 'Xã',
          },
          {
            id: '4612',
            name: 'Nghĩa An',
            prefix: 'Xã',
          },
          {
            id: '4613',
            name: 'Ninh Giang',
            prefix: 'Thị trấn',
          },
          {
            id: '4614',
            name: 'Ninh Hải',
            prefix: 'Xã',
          },
          {
            id: '4615',
            name: 'Ninh Hoà',
            prefix: 'Xã',
          },
          {
            id: '4616',
            name: 'Ninh Thành',
            prefix: 'Xã',
          },
          {
            id: '4617',
            name: 'Quang Hưng',
            prefix: 'Xã',
          },
          {
            id: '4618',
            name: 'Quyết Thắng',
            prefix: 'Xã',
          },
          {
            id: '4619',
            name: 'Tân Hương',
            prefix: 'Xã',
          },
          {
            id: '4620',
            name: 'Tân Phong',
            prefix: 'Xã',
          },
          {
            id: '4621',
            name: 'Tân Quang',
            prefix: 'Xã',
          },
          {
            id: '4622',
            name: 'Ứng Hoè',
            prefix: 'Xã',
          },
          {
            id: '4623',
            name: 'Văn Giang',
            prefix: 'Xã',
          },
          {
            id: '4624',
            name: 'Văn Hội',
            prefix: 'Xã',
          },
          {
            id: '4625',
            name: 'Vạn Phúc',
            prefix: 'Xã',
          },
          {
            id: '4626',
            name: 'Vĩnh Hoà',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '296',
        name: 'Thanh Hà',
        wards: [
          {
            id: '4627',
            name: 'An Lương',
            prefix: 'Xã',
          },
          {
            id: '4628',
            name: 'Cẩm Chế',
            prefix: 'Xã',
          },
          {
            id: '4629',
            name: 'Hồng Lạc',
            prefix: 'Xã',
          },
          {
            id: '4630',
            name: 'Hợp Đức',
            prefix: 'Xã',
          },
          {
            id: '4631',
            name: 'Liên Mạc',
            prefix: 'Xã',
          },
          {
            id: '4632',
            name: 'Phượng Hoàng',
            prefix: 'Xã',
          },
          {
            id: '4633',
            name: 'Quyết Thắng',
            prefix: 'Xã',
          },
          {
            id: '4634',
            name: 'Tân An',
            prefix: 'Xã',
          },
          {
            id: '4635',
            name: 'Tân Việt',
            prefix: 'Xã',
          },
          {
            id: '4636',
            name: 'Thanh An',
            prefix: 'Xã',
          },
          {
            id: '4637',
            name: 'Thanh Bính',
            prefix: 'Xã',
          },
          {
            id: '4638',
            name: 'Thanh Cường',
            prefix: 'Xã',
          },
          {
            id: '4639',
            name: 'Thanh Hà',
            prefix: 'Xã',
          },
          {
            id: '4640',
            name: 'Thanh Hải',
            prefix: 'Xã',
          },
          {
            id: '4641',
            name: 'Thanh Hồng',
            prefix: 'Xã',
          },
          {
            id: '4642',
            name: 'Thanh Khê',
            prefix: 'Xã',
          },
          {
            id: '4643',
            name: 'Thanh Lang',
            prefix: 'Xã',
          },
          {
            id: '4644',
            name: 'Thanh Sơn',
            prefix: 'Xã',
          },
          {
            id: '4645',
            name: 'Thanh Thuỷ',
            prefix: 'Xã',
          },
          {
            id: '4646',
            name: 'Thanh Xá',
            prefix: 'Xã',
          },
          {
            id: '4647',
            name: 'Thanh Xuân',
            prefix: 'Xã',
          },
          {
            id: '4648',
            name: 'Tiền Tiến',
            prefix: 'Xã',
          },
          {
            id: '4649',
            name: 'Trường Thành',
            prefix: 'Xã',
          },
          {
            id: '4650',
            name: 'Việt Hồng',
            prefix: 'Xã',
          },
          {
            id: '4651',
            name: 'Vĩnh Lập',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '297',
        name: 'Thanh Miện',
        wards: [
          {
            id: '4652',
            name: 'Cao Thắng',
            prefix: 'Xã',
          },
          {
            id: '4653',
            name: 'Chi Lăng Bắc',
            prefix: 'Xã',
          },
          {
            id: '4654',
            name: 'Chi Lăng Nam',
            prefix: 'Xã',
          },
          {
            id: '4655',
            name: 'Diên Hồng',
            prefix: 'Xã',
          },
          {
            id: '4656',
            name: 'Đoàn Kết',
            prefix: 'Xã',
          },
          {
            id: '4657',
            name: 'Đoàn Tùng',
            prefix: 'Xã',
          },
          {
            id: '4658',
            name: 'Hồng Quang',
            prefix: 'Xã',
          },
          {
            id: '4659',
            name: 'Hùng Sơn',
            prefix: 'Xã',
          },
          {
            id: '4660',
            name: 'Lam Sơn',
            prefix: 'Xã',
          },
          {
            id: '4661',
            name: 'Lê Hồng',
            prefix: 'Xã',
          },
          {
            id: '4662',
            name: 'Ngô Quyền',
            prefix: 'Xã',
          },
          {
            id: '4663',
            name: 'Ngũ Hùng',
            prefix: 'Xã',
          },
          {
            id: '4664',
            name: 'Phạm Kha',
            prefix: 'Xã',
          },
          {
            id: '4665',
            name: 'Tân Trào',
            prefix: 'Xã',
          },
          {
            id: '4666',
            name: 'Thanh Giang',
            prefix: 'Xã',
          },
          {
            id: '4667',
            name: 'Thanh Miện',
            prefix: 'Thị trấn',
          },
          {
            id: '4668',
            name: 'Thanh Tùng',
            prefix: 'Xã',
          },
          {
            id: '4669',
            name: 'Tiền Phong',
            prefix: 'Xã',
          },
          {
            id: '4670',
            name: 'Tứ Cường',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '298',
        name: 'Tứ Kỳ',
        wards: [
          {
            id: '4671',
            name: 'An Thanh',
            prefix: 'Xã',
          },
          {
            id: '4672',
            name: 'Bình Lãng',
            prefix: 'Xã',
          },
          {
            id: '4673',
            name: 'Cộng Lạc',
            prefix: 'Xã',
          },
          {
            id: '4676',
            name: 'Dân Chủ',
            prefix: 'Xã',
          },
          {
            id: '4674',
            name: 'Đại Đồng',
            prefix: 'Xã',
          },
          {
            id: '4675',
            name: 'Đại Hợp',
            prefix: 'Xã',
          },
          {
            id: '4677',
            name: 'Đông Kỳ',
            prefix: 'Xã',
          },
          {
            id: '4678',
            name: 'Hà Kỳ',
            prefix: 'Xã',
          },
          {
            id: '4679',
            name: 'Hà Thanh',
            prefix: 'Xã',
          },
          {
            id: '4680',
            name: 'Hưng Đạo',
            prefix: 'Xã',
          },
          {
            id: '4681',
            name: 'Kỳ Sơn',
            prefix: 'Xã',
          },
          {
            id: '4682',
            name: 'Minh Đức',
            prefix: 'Xã',
          },
          {
            id: '4683',
            name: 'Ngọc Kỳ',
            prefix: 'Xã',
          },
          {
            id: '4684',
            name: 'Ngọc Sơn',
            prefix: 'Xã',
          },
          {
            id: '4685',
            name: 'Nguyên Giáp',
            prefix: 'Xã',
          },
          {
            id: '4686',
            name: 'Phượng Kỳ',
            prefix: 'Xã',
          },
          {
            id: '4687',
            name: 'Quang Khải',
            prefix: 'Xã',
          },
          {
            id: '4688',
            name: 'Quảng Nghiệp',
            prefix: 'Xã',
          },
          {
            id: '4689',
            name: 'Quang Phục',
            prefix: 'Xã',
          },
          {
            id: '4690',
            name: 'Quang Trung',
            prefix: 'Xã',
          },
          {
            id: '4691',
            name: 'Tái Sơn',
            prefix: 'Xã',
          },
          {
            id: '4692',
            name: 'Tân Kỳ',
            prefix: 'Xã',
          },
          {
            id: '4693',
            name: 'Tây Kỳ',
            prefix: 'Xã',
          },
          {
            id: '4694',
            name: 'Tiên Động',
            prefix: 'Xã',
          },
          {
            id: '4695',
            name: 'Tứ Kỳ',
            prefix: 'Thị trấn',
          },
          {
            id: '4696',
            name: 'Tứ Xuyên',
            prefix: 'Xã',
          },
          {
            id: '4697',
            name: 'Văn Tố',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '22',
    code: 'GL',
    name: 'Gia Lai',
    districts: [
      {
        id: '299',
        name: 'An Khê',
        wards: [
          {
            id: '4698',
            name: 'An Bình',
            prefix: 'Phường',
          },
          {
            id: '4699',
            name: 'An Phú',
            prefix: 'Phường',
          },
          {
            id: '4700',
            name: 'An Phước',
            prefix: 'Phường',
          },
          {
            id: '4701',
            name: 'An Tân',
            prefix: 'Phường',
          },
          {
            id: '4702',
            name: 'Cửu An',
            prefix: 'Xã',
          },
          {
            id: '4703',
            name: 'Ngô Mây',
            prefix: 'Phường',
          },
          {
            id: '4704',
            name: 'Song An',
            prefix: 'Xã',
          },
          {
            id: '4705',
            name: 'Tây Sơn',
            prefix: 'Phường',
          },
          {
            id: '4706',
            name: 'Thành An',
            prefix: 'Xã',
          },
          {
            id: '4707',
            name: 'Tú An',
            prefix: 'Xã',
          },
          {
            id: '4708',
            name: 'Xuân An',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '300',
        name: 'AYun Pa',
        wards: [
          {
            id: '4709',
            name: 'Cheo Reo',
            prefix: 'Phường',
          },
          {
            id: '4710',
            name: 'Chư Băh',
            prefix: 'Xã',
          },
          {
            id: '4711',
            name: 'Đoàn Kết',
            prefix: 'Phường',
          },
          {
            id: '4712',
            name: 'Hòa Bình',
            prefix: 'Phường',
          },
          {
            id: '4713',
            name: 'Ia Rbol',
            prefix: 'Xã',
          },
          {
            id: '4714',
            name: 'Ia RTô',
            prefix: 'Xã',
          },
          {
            id: '4715',
            name: 'Ia Sao',
            prefix: 'Xã',
          },
          {
            id: '4716',
            name: 'Sông Bờ',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '301',
        name: 'Chư Păh',
        wards: [
          {
            id: '4717',
            name: 'Chư Đăng Ya',
            prefix: 'Xã',
          },
          {
            id: '4718',
            name: 'Chư Jôr',
            prefix: 'Xã',
          },
          {
            id: '4719',
            name: 'Đăk Tơ Ver',
            prefix: 'Xã',
          },
          {
            id: '4720',
            name: 'Hà Tây',
            prefix: 'Xã',
          },
          {
            id: '4721',
            name: 'Hòa Phú',
            prefix: 'Xã',
          },
          {
            id: '4722',
            name: 'Ia Ka',
            prefix: 'Xã',
          },
          {
            id: '4723',
            name: 'Ia Khươl',
            prefix: 'Xã',
          },
          {
            id: '4724',
            name: 'Ia Kreng',
            prefix: 'Xã',
          },
          {
            id: '4725',
            name: 'Ia Ly',
            prefix: 'Xã',
          },
          {
            id: '4726',
            name: 'Ia Mơ Nông',
            prefix: 'Xã',
          },
          {
            id: '4727',
            name: 'Ia Nhin',
            prefix: 'Xã',
          },
          {
            id: '4728',
            name: 'Ia Phí',
            prefix: 'Xã',
          },
          {
            id: '4729',
            name: 'Nghĩa Hòa',
            prefix: 'Xã',
          },
          {
            id: '4730',
            name: 'Nghĩa Hưng',
            prefix: 'Xã',
          },
          {
            id: '4731',
            name: 'Phú Hòa',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '302',
        name: 'Chư Pưh',
        wards: [
          {
            id: '4732',
            name: 'Chư Don',
            prefix: 'Xã',
          },
          {
            id: '4733',
            name: 'Ia BLứ',
            prefix: 'Xã',
          },
          {
            id: '4734',
            name: 'Ia Dreng',
            prefix: 'Xã',
          },
          {
            id: '4735',
            name: 'Ia Hla',
            prefix: 'Xã',
          },
          {
            id: '4736',
            name: 'Ia Hrú',
            prefix: 'Xã',
          },
          {
            id: '4737',
            name: 'Ia Le',
            prefix: 'Xã',
          },
          {
            id: '4738',
            name: 'Ia Phang',
            prefix: 'Xã',
          },
          {
            id: '4739',
            name: 'Ia Rong',
            prefix: 'Xã',
          },
          {
            id: '4740',
            name: 'Nhơn Hòa',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '303',
        name: 'Chư Sê',
        wards: [
          {
            id: '4741',
            name: 'Al Bá',
            prefix: 'Xã',
          },
          {
            id: '4742',
            name: 'AYun',
            prefix: 'Xã',
          },
          {
            id: '4743',
            name: 'Bar Măih',
            prefix: 'Xã',
          },
          {
            id: '4744',
            name: 'Bờ Ngoong',
            prefix: 'Xã',
          },
          {
            id: '4745',
            name: 'Chư Pơng',
            prefix: 'Xã',
          },
          {
            id: '4746',
            name: 'Chư Sê',
            prefix: 'Thị trấn',
          },
          {
            id: '4747',
            name: 'Dun',
            prefix: 'Xã',
          },
          {
            id: '4748',
            name: 'H Bông',
            prefix: 'Xã',
          },
          {
            id: '4749',
            name: 'Ia Blang',
            prefix: 'Xã',
          },
          {
            id: '4750',
            name: 'Ia Dreng',
            prefix: 'Xã',
          },
          {
            id: '4751',
            name: 'Ia Glai',
            prefix: 'Xã',
          },
          {
            id: '4752',
            name: 'Ia Hlốp',
            prefix: 'Xã',
          },
          {
            id: '4753',
            name: 'Ia Ko',
            prefix: 'Xã',
          },
          {
            id: '4754',
            name: 'Ia Pal',
            prefix: 'Xã',
          },
          {
            id: '4755',
            name: 'Ia Tiêm',
            prefix: 'Xã',
          },
          {
            id: '4756',
            name: 'Kông Htok',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '304',
        name: 'ChưPRông',
        wards: [
          {
            id: '4757',
            name: 'Bàu Cạn',
            prefix: 'Xã',
          },
          {
            id: '4758',
            name: 'Bình Giáo',
            prefix: 'Xã',
          },
          {
            id: '4759',
            name: 'Chư Prông',
            prefix: 'Thị trấn',
          },
          {
            id: '4760',
            name: 'Ia Bang',
            prefix: 'Xã',
          },
          {
            id: '4761',
            name: 'Ia Băng',
            prefix: 'Xã',
          },
          {
            id: '4762',
            name: 'Ia Boòng',
            prefix: 'Xã',
          },
          {
            id: '4763',
            name: 'Ia Drang',
            prefix: 'Xã',
          },
          {
            id: '4764',
            name: 'Ia Ga',
            prefix: 'Xã',
          },
          {
            id: '4765',
            name: 'Ia Kly',
            prefix: 'Xã',
          },
          {
            id: '4766',
            name: 'Ia Lâu',
            prefix: 'Xã',
          },
          {
            id: '4767',
            name: 'Ia Me',
            prefix: 'Xã',
          },
          {
            id: '4768',
            name: 'Ia Mơ',
            prefix: 'Xã',
          },
          {
            id: '4769',
            name: 'Ia O',
            prefix: 'Xã',
          },
          {
            id: '4770',
            name: 'Ia Phìn',
            prefix: 'Xã',
          },
          {
            id: '4771',
            name: 'Ia Pia',
            prefix: 'Xã',
          },
          {
            id: '4772',
            name: 'Ia Piơr',
            prefix: 'Xã',
          },
          {
            id: '4773',
            name: 'Ia Púch',
            prefix: 'Xã',
          },
          {
            id: '4774',
            name: 'Ia Tôr',
            prefix: 'Xã',
          },
          {
            id: '4775',
            name: 'Ia Vê',
            prefix: 'Xã',
          },
          {
            id: '4776',
            name: 'Thăng Hưng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '305',
        name: 'Đăk Đoa',
        wards: [
          {
            id: '4777',
            name: 'A Dơk',
            prefix: 'Xã',
          },
          {
            id: '4778',
            name: 'Đak Đoa',
            prefix: 'Thị trấn',
          },
          {
            id: '4779',
            name: 'Đăk Krong',
            prefix: 'Xã',
          },
          {
            id: '4780',
            name: 'Đăk Sơ Mei',
            prefix: 'Xã',
          },
          {
            id: '4781',
            name: 'GLar',
            prefix: 'Xã',
          },
          {
            id: '4782',
            name: "H' Neng",
            prefix: 'Xã',
          },
          {
            id: '4783',
            name: 'Hà Bầu',
            prefix: 'Xã',
          },
          {
            id: '4784',
            name: 'Hà Đông',
            prefix: 'Xã',
          },
          {
            id: '4785',
            name: 'Hải Yang',
            prefix: 'Xã',
          },
          {
            id: '4786',
            name: 'HNol',
            prefix: 'Xã',
          },
          {
            id: '4787',
            name: 'Ia Băng',
            prefix: 'Xã',
          },
          {
            id: '4788',
            name: 'Ia Pết',
            prefix: 'Xã',
          },
          {
            id: '4789',
            name: "K' Dang",
            prefix: 'Xã',
          },
          {
            id: '4790',
            name: 'Kon Gang',
            prefix: 'Xã',
          },
          {
            id: '4791',
            name: 'Nam Yang',
            prefix: 'Xã',
          },
          {
            id: '4792',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '4793',
            name: 'Trang',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '306',
        name: 'Đăk Pơ',
        wards: [
          {
            id: '4794',
            name: 'An Thành',
            prefix: 'Xã',
          },
          {
            id: '4795',
            name: 'Cư An',
            prefix: 'Xã',
          },
          {
            id: '4796',
            name: 'Đak Pơ',
            prefix: 'Xã',
          },
          {
            id: '4797',
            name: 'Hà Tam',
            prefix: 'Xã',
          },
          {
            id: '4798',
            name: 'Phú An',
            prefix: 'Xã',
          },
          {
            id: '4799',
            name: 'Tân An',
            prefix: 'Xã',
          },
          {
            id: '4800',
            name: 'Ya Hội',
            prefix: 'Xã',
          },
          {
            id: '4801',
            name: 'Yang Bắc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '307',
        name: 'Đức Cơ',
        wards: [
          {
            id: '4802',
            name: 'Chư Ty',
            prefix: 'Thị trấn',
          },
          {
            id: '4803',
            name: 'Ia  Din',
            prefix: 'Xã',
          },
          {
            id: '4804',
            name: 'Ia Dơk',
            prefix: 'Xã',
          },
          {
            id: '4805',
            name: 'Ia Dom',
            prefix: 'Xã',
          },
          {
            id: '4806',
            name: 'Ia Kla',
            prefix: 'Xã',
          },
          {
            id: '4807',
            name: 'Ia Krêl',
            prefix: 'Xã',
          },
          {
            id: '4808',
            name: 'Ia Kriêng',
            prefix: 'Xã',
          },
          {
            id: '4809',
            name: 'Ia Lang',
            prefix: 'Xã',
          },
          {
            id: '4810',
            name: 'Ia Nan',
            prefix: 'Xã',
          },
          {
            id: '4811',
            name: 'Ia Pnôn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '308',
        name: 'Ia Grai',
        wards: [
          {
            id: '4812',
            name: 'Ia Bá',
            prefix: 'Xã',
          },
          {
            id: '4813',
            name: 'Ia Chia',
            prefix: 'Xã',
          },
          {
            id: '4814',
            name: 'Ia Dêr',
            prefix: 'Xã',
          },
          {
            id: '4815',
            name: 'Ia Grăng',
            prefix: 'Xã',
          },
          {
            id: '4816',
            name: 'Ia Hrung',
            prefix: 'Xã',
          },
          {
            id: '4817',
            name: 'Ia Kha',
            prefix: 'Thị trấn',
          },
          {
            id: '4818',
            name: 'Ia Khai',
            prefix: 'Xã',
          },
          {
            id: '4819',
            name: 'Ia Krai',
            prefix: 'Xã',
          },
          {
            id: '4820',
            name: 'Ia O',
            prefix: 'Xã',
          },
          {
            id: '4821',
            name: 'Ia Pếch',
            prefix: 'Xã',
          },
          {
            id: '4822',
            name: 'Ia Sao',
            prefix: 'Xã',
          },
          {
            id: '4823',
            name: 'Ia Tô',
            prefix: 'Xã',
          },
          {
            id: '4824',
            name: 'Ia Yok',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '309',
        name: 'Ia Pa',
        wards: [
          {
            id: '4825',
            name: 'Chư Mố',
            prefix: 'Xã',
          },
          {
            id: '4826',
            name: 'Chư Răng',
            prefix: 'Xã',
          },
          {
            id: '4827',
            name: 'Ia Broăi',
            prefix: 'Xã',
          },
          {
            id: '4828',
            name: 'Ia Kdăm',
            prefix: 'Xã',
          },
          {
            id: '4829',
            name: 'Ia Mrơn',
            prefix: 'Xã',
          },
          {
            id: '4830',
            name: 'Ia Pa',
            prefix: 'Thị trấn',
          },
          {
            id: '4831',
            name: 'Ia Trôk',
            prefix: 'Xã',
          },
          {
            id: '4832',
            name: 'Ia Tul',
            prefix: 'Xã',
          },
          {
            id: '4833',
            name: 'Kim Tân',
            prefix: 'Xã',
          },
          {
            id: '4834',
            name: 'Pờ tó',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '310',
        name: 'KBang',
        wards: [
          {
            id: '4835',
            name: 'Đắk HLơ',
            prefix: 'Xã',
          },
          {
            id: '4836',
            name: 'Đắk Rong',
            prefix: 'Xã',
          },
          {
            id: '4837',
            name: 'Đắk Smar',
            prefix: 'Xã',
          },
          {
            id: '4838',
            name: 'Đông',
            prefix: 'Xã',
          },
          {
            id: '4839',
            name: 'KBang',
            prefix: 'Thị trấn',
          },
          {
            id: '4840',
            name: 'Kon PNe',
            prefix: 'Xã',
          },
          {
            id: '4841',
            name: 'Kông Lơng Khơng',
            prefix: 'Xã',
          },
          {
            id: '4842',
            name: 'Kông PLa',
            prefix: 'Xã',
          },
          {
            id: '4843',
            name: 'KRong',
            prefix: 'Xã',
          },
          {
            id: '4844',
            name: 'Lơ Ku',
            prefix: 'Xã',
          },
          {
            id: '4845',
            name: 'Nghĩa An',
            prefix: 'Xã',
          },
          {
            id: '4846',
            name: 'Sơ Pai',
            prefix: 'Xã',
          },
          {
            id: '4847',
            name: 'Sơn Lang',
            prefix: 'Xã',
          },
          {
            id: '4848',
            name: 'Tơ Tung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '311',
        name: 'Kông Chro',
        wards: [
          {
            id: '4849',
            name: 'An Trung',
            prefix: 'Xã',
          },
          {
            id: '4850',
            name: 'Chơ Long',
            prefix: 'Xã',
          },
          {
            id: '4851',
            name: 'Chư Krêy',
            prefix: 'Xã',
          },
          {
            id: '4852',
            name: 'Đăk Kơ Ning',
            prefix: 'Xã',
          },
          {
            id: '4853',
            name: 'Đắk Pling',
            prefix: 'Xã',
          },
          {
            id: '4854',
            name: 'Đăk Pơ Pho',
            prefix: 'Xã',
          },
          {
            id: '4855',
            name: 'Đắk Sông',
            prefix: 'Xã',
          },
          {
            id: '4856',
            name: 'Đắk Tơ Pang',
            prefix: 'Xã',
          },
          {
            id: '4857',
            name: 'Kông Chro',
            prefix: 'Thị trấn',
          },
          {
            id: '4858',
            name: 'Kông Yang',
            prefix: 'Xã',
          },
          {
            id: '4859',
            name: 'Sró',
            prefix: 'Xã',
          },
          {
            id: '4860',
            name: 'Ya Ma',
            prefix: 'Xã',
          },
          {
            id: '4861',
            name: 'Yang Nam',
            prefix: 'Xã',
          },
          {
            id: '4862',
            name: 'Yang Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '312',
        name: 'Krông Pa',
        wards: [
          {
            id: '4863',
            name: 'Chư Drăng',
            prefix: 'Xã',
          },
          {
            id: '4864',
            name: 'Chư Gu',
            prefix: 'Xã',
          },
          {
            id: '4865',
            name: 'Chư Ngọc',
            prefix: 'Xã',
          },
          {
            id: '4866',
            name: 'Chư Rcăm',
            prefix: 'Xã',
          },
          {
            id: '4867',
            name: 'Đất Bằng',
            prefix: 'Xã',
          },
          {
            id: '4868',
            name: 'Ia Hdreh',
            prefix: 'Xã',
          },
          {
            id: '4869',
            name: 'Ia Mlah',
            prefix: 'Xã',
          },
          {
            id: '4870',
            name: 'Ia Rmok',
            prefix: 'Xã',
          },
          {
            id: '4871',
            name: 'Ia Rsai',
            prefix: 'Xã',
          },
          {
            id: '4872',
            name: 'Ia Rsươm',
            prefix: 'Xã',
          },
          {
            id: '4873',
            name: 'Krông Năng',
            prefix: 'Xã',
          },
          {
            id: '4874',
            name: 'Phú Cần',
            prefix: 'Xã',
          },
          {
            id: '4875',
            name: 'Phú Túc',
            prefix: 'Thị trấn',
          },
          {
            id: '4876',
            name: 'Uar',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '313',
        name: 'Mang Yang',
        wards: [
          {
            id: '4877',
            name: 'Ayun',
            prefix: 'Xã',
          },
          {
            id: '4878',
            name: 'Ðăk Drjăng',
            prefix: 'Xã',
          },
          {
            id: '4879',
            name: 'Ðak Jơ Ta',
            prefix: 'Xã',
          },
          {
            id: '4880',
            name: 'Ðak Ta Ley',
            prefix: 'Xã',
          },
          {
            id: '4881',
            name: 'Ðăk Trôi',
            prefix: 'Xã',
          },
          {
            id: '4882',
            name: 'Ðăk Yă',
            prefix: 'Xã',
          },
          {
            id: '4883',
            name: 'Ðê Ar',
            prefix: 'Xã',
          },
          {
            id: '4884',
            name: 'Hra',
            prefix: 'Xã',
          },
          {
            id: '4885',
            name: 'Kon Chiêng',
            prefix: 'Xã',
          },
          {
            id: '4886',
            name: 'Kon Dơng',
            prefix: 'Thị trấn',
          },
          {
            id: '4887',
            name: 'Kon Thụp',
            prefix: 'Xã',
          },
          {
            id: '4888',
            name: 'Lo Pang',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '314',
        name: 'Phú Thiện',
        wards: [
          {
            id: '4889',
            name: 'Ayun Hạ',
            prefix: 'Xã',
          },
          {
            id: '4890',
            name: 'Chrôh Pơnan',
            prefix: 'Xã',
          },
          {
            id: '4891',
            name: 'Chư A Thai',
            prefix: 'Xã',
          },
          {
            id: '4892',
            name: 'Ia Ake',
            prefix: 'Xã',
          },
          {
            id: '4893',
            name: 'Ia Hiao',
            prefix: 'Xã',
          },
          {
            id: '4894',
            name: 'Ia Peng',
            prefix: 'Xã',
          },
          {
            id: '4895',
            name: 'Ia Piar',
            prefix: 'Xã',
          },
          {
            id: '4896',
            name: 'Ia Sol',
            prefix: 'Xã',
          },
          {
            id: '4897',
            name: 'Ia Yeng',
            prefix: 'Xã',
          },
          {
            id: '4898',
            name: 'Phú Thiện',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '315',
        name: 'Plei Ku',
        wards: [
          {
            id: '4899',
            name: 'An Phú',
            prefix: 'Xã',
          },
          {
            id: '4900',
            name: 'Biển Hồ',
            prefix: 'Xã',
          },
          {
            id: '4901',
            name: 'Chi Lăng',
            prefix: 'Phường',
          },
          {
            id: '4902',
            name: 'Chư Á',
            prefix: 'Xã',
          },
          {
            id: '4903',
            name: 'Chư HDrông',
            prefix: 'Xã',
          },
          {
            id: '4904',
            name: 'Diên Hồng',
            prefix: 'Phường',
          },
          {
            id: '4905',
            name: 'Diên Phú',
            prefix: 'Xã',
          },
          {
            id: '4906',
            name: 'Đống Đa',
            prefix: 'Phường',
          },
          {
            id: '4907',
            name: 'Gào',
            prefix: 'Xã',
          },
          {
            id: '4908',
            name: 'Hoa Lư',
            prefix: 'Phường',
          },
          {
            id: '4909',
            name: 'Hội Phú',
            prefix: 'Phường',
          },
          {
            id: '4910',
            name: 'Hội Thương',
            prefix: 'Phường',
          },
          {
            id: '4911',
            name: 'Ia Kênh',
            prefix: 'Xã',
          },
          {
            id: '4912',
            name: 'Ia Kring­',
            prefix: 'Phường',
          },
          {
            id: '4913',
            name: 'Phù Đổng',
            prefix: 'Phường',
          },
          {
            id: '4914',
            name: 'Tân Sơn',
            prefix: 'Xã',
          },
          {
            id: '4915',
            name: 'Tây Sơn',
            prefix: 'Phường',
          },
          {
            id: '4916',
            name: 'Thắng Lợi',
            prefix: 'Phường',
          },
          {
            id: '4917',
            name: 'Thống Nhất',
            prefix: 'Phường',
          },
          {
            id: '4918',
            name: 'Trà Bá',
            prefix: 'Phường',
          },
          {
            id: '4919',
            name: 'Trà Đa',
            prefix: 'Xã',
          },
          {
            id: '4920',
            name: 'Yên Đỗ',
            prefix: 'Phường',
          },
          {
            id: '4921',
            name: 'Yên Thế',
            prefix: 'Phường',
          },
        ],
      },
    ],
  },
  {
    id: '23',
    code: 'BP',
    name: 'Bình Phước',
    districts: [
      {
        id: '316',
        name: 'Bình Long',
        wards: [
          {
            id: '4922',
            name: 'An Lộc',
            prefix: 'Phường',
          },
          {
            id: '4923',
            name: 'An Phú',
            prefix: 'Xã',
          },
          {
            id: '4924',
            name: 'Hưng Chiến',
            prefix: 'Phường',
          },
          {
            id: '4925',
            name: 'Phú Đức',
            prefix: 'Phường',
          },
          {
            id: '4926',
            name: 'Phú Thịnh',
            prefix: 'Phường',
          },
          {
            id: '4927',
            name: 'Thanh Lương',
            prefix: 'Xã',
          },
          {
            id: '4928',
            name: 'Thanh Phú',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '317',
        name: 'Bù Đăng',
        wards: [
          {
            id: '4929',
            name: 'Bình Minh',
            prefix: 'Xã',
          },
          {
            id: '4930',
            name: 'Bom Bo',
            prefix: 'Xã',
          },
          {
            id: '4931',
            name: 'Đắk Nhau',
            prefix: 'Xã',
          },
          {
            id: '4932',
            name: 'Đăng Hà',
            prefix: 'Xã',
          },
          {
            id: '4933',
            name: 'Đoàn Kết',
            prefix: 'Xã',
          },
          {
            id: '4934',
            name: 'Đồng Nai',
            prefix: 'Xã',
          },
          {
            id: '4935',
            name: 'Đức Liễu',
            prefix: 'Xã',
          },
          {
            id: '4936',
            name: 'Đức Phong',
            prefix: 'Thị trấn',
          },
          {
            id: '4937',
            name: 'Đường 10',
            prefix: 'Xã',
          },
          {
            id: '4938',
            name: 'Minh Hưng',
            prefix: 'Xã',
          },
          {
            id: '4939',
            name: 'Nghĩa Bình',
            prefix: 'Xã',
          },
          {
            id: '4940',
            name: 'Nghĩa Trung',
            prefix: 'Xã',
          },
          {
            id: '4941',
            name: 'Phú Sơn',
            prefix: 'Xã',
          },
          {
            id: '4942',
            name: 'Phước Sơn',
            prefix: 'Xã',
          },
          {
            id: '4943',
            name: 'Thọ Sơn',
            prefix: 'Xã',
          },
          {
            id: '4944',
            name: 'Thống Nhất',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '318',
        name: 'Bù Đốp',
        wards: [
          {
            id: '4945',
            name: 'Hưng Phước',
            prefix: 'Xã',
          },
          {
            id: '4946',
            name: 'Phước Thiện',
            prefix: 'Xã',
          },
          {
            id: '4947',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '4948',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '4949',
            name: 'Thanh Bình',
            prefix: 'Thị trấn',
          },
          {
            id: '4950',
            name: 'Thanh Hoà',
            prefix: 'Xã',
          },
          {
            id: '4951',
            name: 'Thiện Hưng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '319',
        name: 'Bù Gia Mập',
        wards: [
          {
            id: '4952',
            name: 'Bình Thắng',
            prefix: 'Xã',
          },
          {
            id: '4953',
            name: 'Bù Gia Mập',
            prefix: 'Xã',
          },
          {
            id: '4954',
            name: 'Đa Kia',
            prefix: 'Xã',
          },
          {
            id: '4955',
            name: 'Đắk Ơ',
            prefix: 'Xã',
          },
          {
            id: '4956',
            name: 'Đức Hạnh',
            prefix: 'Xã',
          },
          {
            id: '4957',
            name: 'Đức Phước',
            prefix: 'Xã',
          },
          {
            id: '4958',
            name: 'Đức Văn',
            prefix: 'Xã',
          },
          {
            id: '4959',
            name: 'Phú Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '4960',
            name: 'Phú Văn',
            prefix: 'Xã',
          },
          {
            id: '4961',
            name: 'Phước Minh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '320',
        name: 'Chơn Thành',
        wards: [
          {
            id: '4962',
            name: 'Chơn Thành',
            prefix: 'Thị trấn',
          },
          {
            id: '4963',
            name: 'Minh Hưng',
            prefix: 'Xã',
          },
          {
            id: '4964',
            name: 'Minh Lập',
            prefix: 'Xã',
          },
          {
            id: '4965',
            name: 'Minh Long',
            prefix: 'Xã',
          },
          {
            id: '4966',
            name: 'Minh Thắng',
            prefix: 'Xã',
          },
          {
            id: '4967',
            name: 'Minh Thành',
            prefix: 'Xã',
          },
          {
            id: '4968',
            name: 'Nha Bích',
            prefix: 'Xã',
          },
          {
            id: '4969',
            name: 'Quang Minh',
            prefix: 'Xã',
          },
          {
            id: '4970',
            name: 'Thành Tâm',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '321',
        name: 'Đồng Phú',
        wards: [
          {
            id: '4971',
            name: 'Đồng Tâm',
            prefix: 'Xã',
          },
          {
            id: '4972',
            name: 'Đồng Tiến',
            prefix: 'Xã',
          },
          {
            id: '4973',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
          {
            id: '4974',
            name: 'Tân Hưng',
            prefix: 'Xã',
          },
          {
            id: '4975',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '4976',
            name: 'Tân Lợi',
            prefix: 'Xã',
          },
          {
            id: '4977',
            name: 'Tân phú',
            prefix: 'Thị trấn',
          },
          {
            id: '4978',
            name: 'Tân Phước',
            prefix: 'Xã',
          },
          {
            id: '4979',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '4980',
            name: 'Thuận Lợi',
            prefix: 'Xã',
          },
          {
            id: '4981',
            name: 'Thuận Phú',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '322',
        name: 'Đồng Xoài',
        wards: [
          {
            id: '4982',
            name: 'Tân Bình',
            prefix: 'Phường',
          },
          {
            id: '4983',
            name: 'Tân Đồng',
            prefix: 'Phường',
          },
          {
            id: '4984',
            name: 'Tân Phú',
            prefix: 'Phường',
          },
          {
            id: '4985',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '4986',
            name: 'Tân Thiện',
            prefix: 'Phường',
          },
          {
            id: '4987',
            name: 'Tân Xuân',
            prefix: 'Phường',
          },
          {
            id: '4988',
            name: 'Tiến Hưng',
            prefix: 'Xã',
          },
          {
            id: '4989',
            name: 'Tiến Thành',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '323',
        name: 'Hớn Quản',
        wards: [
          {
            id: '4990',
            name: 'An Khương',
            prefix: 'Xã',
          },
          {
            id: '4991',
            name: 'An Phú',
            prefix: 'Xã',
          },
          {
            id: '4992',
            name: 'Đồng Nơ',
            prefix: 'Xã',
          },
          {
            id: '4993',
            name: 'Minh Đức',
            prefix: 'Xã',
          },
          {
            id: '4994',
            name: 'Minh Tâm',
            prefix: 'Xã',
          },
          {
            id: '4995',
            name: 'Phước An',
            prefix: 'Xã',
          },
          {
            id: '4996',
            name: 'Tân Hiệp',
            prefix: 'Xã',
          },
          {
            id: '4997',
            name: 'Tân Hưng',
            prefix: 'Xã',
          },
          {
            id: '4998',
            name: 'Tân Khai',
            prefix: 'Xã',
          },
          {
            id: '4999',
            name: 'Tân Lợi',
            prefix: 'Xã',
          },
          {
            id: '5000',
            name: 'Tân Quan',
            prefix: 'Xã',
          },
          {
            id: '5001',
            name: 'Thanh An',
            prefix: 'Xã',
          },
          {
            id: '5002',
            name: 'Thanh Bình',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '324',
        name: 'Lộc Ninh',
        wards: [
          {
            id: '5003',
            name: 'Lộc An',
            prefix: 'Xã',
          },
          {
            id: '5004',
            name: 'Lộc Điền',
            prefix: 'Xã',
          },
          {
            id: '5005',
            name: 'Lộc Hiệp',
            prefix: 'Xã',
          },
          {
            id: '5006',
            name: 'Lộc Hoà',
            prefix: 'Xã',
          },
          {
            id: '5007',
            name: 'Lộc Hưng',
            prefix: 'Xã',
          },
          {
            id: '5008',
            name: 'Lộc Khánh',
            prefix: 'Xã',
          },
          {
            id: '5009',
            name: 'Lộc Ninh',
            prefix: 'Thị trấn',
          },
          {
            id: '5010',
            name: 'Lộc Phú',
            prefix: 'Xã',
          },
          {
            id: '5011',
            name: 'Lộc Quang',
            prefix: 'Xã',
          },
          {
            id: '5012',
            name: 'Lộc Tấn',
            prefix: 'Xã',
          },
          {
            id: '5013',
            name: 'Lộc Thái',
            prefix: 'Xã',
          },
          {
            id: '5014',
            name: 'Lộc Thành',
            prefix: 'Xã',
          },
          {
            id: '5015',
            name: 'Lộc Thạnh',
            prefix: 'Xã',
          },
          {
            id: '5016',
            name: 'Lộc Thiện',
            prefix: 'Xã',
          },
          {
            id: '5017',
            name: 'Lộc Thịnh',
            prefix: 'Xã',
          },
          {
            id: '5018',
            name: 'Lộc Thuận',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '325',
        name: 'Phú Riềng',
        wards: [
          {
            id: '5019',
            name: 'Bình Sơn',
            prefix: 'Xã',
          },
          {
            id: '5020',
            name: 'Bình Tân',
            prefix: 'Xã',
          },
          {
            id: '5021',
            name: 'Bù Nho',
            prefix: 'Xã',
          },
          {
            id: '5022',
            name: 'Long Bình',
            prefix: 'Xã',
          },
          {
            id: '5023',
            name: 'Long Hà',
            prefix: 'Xã',
          },
          {
            id: '5024',
            name: 'Long Hưng',
            prefix: 'Xã',
          },
          {
            id: '5025',
            name: 'Long Tân',
            prefix: 'Xã',
          },
          {
            id: '5026',
            name: 'Phú Riềng',
            prefix: 'Xã',
          },
          {
            id: '5027',
            name: 'Phú Trung',
            prefix: 'Xã',
          },
          {
            id: '5028',
            name: 'Phước Tân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '326',
        name: 'Phước Long',
        wards: [
          {
            id: '5029',
            name: 'Long Giang',
            prefix: 'Xã',
          },
          {
            id: '5030',
            name: 'Long Phước',
            prefix: 'Phường',
          },
          {
            id: '5031',
            name: 'Long Thủy',
            prefix: 'Phường',
          },
          {
            id: '5032',
            name: 'Phước Bình',
            prefix: 'Phường',
          },
          {
            id: '5033',
            name: 'Phước Tín',
            prefix: 'Xã',
          },
          {
            id: '5034',
            name: 'Sơn Giang',
            prefix: 'Phường',
          },
          {
            id: '5035',
            name: 'Thác Mơ',
            prefix: 'Phường',
          },
        ],
      },
    ],
  },
  {
    id: '24',
    code: 'HY',
    name: 'Hưng Yên',
    districts: [
      {
        id: '327',
        name: 'Ân Thi',
        wards: [
          {
            id: '5036',
            name: ' Hồng Quang',
            prefix: 'Xã',
          },
          {
            id: '5037',
            name: 'Ân Thi',
            prefix: 'Thị trấn',
          },
          {
            id: '5038',
            name: 'Bắc Sơn',
            prefix: 'Xã',
          },
          {
            id: '5039',
            name: 'Bãi Sậy',
            prefix: 'Xã',
          },
          {
            id: '5040',
            name: 'Cẩm Ninh',
            prefix: 'Xã',
          },
          {
            id: '5041',
            name: 'Đa Lộc',
            prefix: 'Xã',
          },
          {
            id: '5042',
            name: 'Đặng Lễ',
            prefix: 'Xã',
          },
          {
            id: '5043',
            name: 'Đào Dương',
            prefix: 'Xã',
          },
          {
            id: '5044',
            name: 'Hạ Lễ',
            prefix: 'Xã',
          },
          {
            id: '5045',
            name: 'Hồ Tùng Mậu',
            prefix: 'Xã',
          },
          {
            id: '5046',
            name: 'Hoàng Hoa Thám',
            prefix: 'Xã',
          },
          {
            id: '5047',
            name: 'Hồng Vân',
            prefix: 'Xã',
          },
          {
            id: '5048',
            name: 'Nguyễn Trãi',
            prefix: 'Xã',
          },
          {
            id: '5049',
            name: 'Phù Ủng',
            prefix: 'Xã',
          },
          {
            id: '5050',
            name: 'Quảng Lãng',
            prefix: 'Xã',
          },
          {
            id: '5051',
            name: 'Quang Vinh',
            prefix: 'Xã',
          },
          {
            id: '5052',
            name: 'Tân Phúc',
            prefix: 'Xã',
          },
          {
            id: '5053',
            name: 'Tiền Phong',
            prefix: 'Xã',
          },
          {
            id: '5054',
            name: 'Vân Du',
            prefix: 'Xã',
          },
          {
            id: '5055',
            name: 'Văn Nhuệ',
            prefix: 'Xã',
          },
          {
            id: '5056',
            name: 'Xuân Trúc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '328',
        name: 'Hưng Yên',
        wards: [
          {
            id: '5057',
            name: ' Lam Sơn',
            prefix: 'Phường',
          },
          {
            id: '5058',
            name: ' Lê Lợi',
            prefix: 'Phường',
          },
          {
            id: '5059',
            name: ' Liên Phương',
            prefix: 'Xã',
          },
          {
            id: '5060',
            name: ' Trung Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '5061',
            name: 'An Tảo',
            prefix: 'Phường',
          },
          {
            id: '5062',
            name: 'Bảo Khê',
            prefix: 'Xã',
          },
          {
            id: '5063',
            name: 'Hiến Nam',
            prefix: 'Phường',
          },
          {
            id: '5064',
            name: 'Hoàng Hanh',
            prefix: 'Xã',
          },
          {
            id: '5065',
            name: 'Hồng Châu',
            prefix: 'Phường',
          },
          {
            id: '5066',
            name: 'Hồng Nam',
            prefix: 'Xã',
          },
          {
            id: '5067',
            name: 'Hùng Cường',
            prefix: 'Xã',
          },
          {
            id: '5068',
            name: 'Minh Khai',
            prefix: 'Phường',
          },
          {
            id: '5069',
            name: 'Phú Cường',
            prefix: 'Xã',
          },
          {
            id: '5070',
            name: 'Phương Chiểu',
            prefix: 'Xã',
          },
          {
            id: '5071',
            name: 'Quảng Châu',
            prefix: 'Xã',
          },
          {
            id: '5072',
            name: 'Quang Trung',
            prefix: 'Phường',
          },
          {
            id: '5073',
            name: 'Tân Hưng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '329',
        name: 'Khoái Châu',
        wards: [
          {
            id: '5074',
            name: ' Chí Tân',
            prefix: 'Xã',
          },
          {
            id: '5075',
            name: ' Đại Hưng',
            prefix: 'Xã',
          },
          {
            id: '5076',
            name: ' Nhuế Dương',
            prefix: 'Xã',
          },
          {
            id: '5077',
            name: ' Thành Công',
            prefix: 'Xã',
          },
          {
            id: '5078',
            name: ' Việt Hòa',
            prefix: 'Xã',
          },
          {
            id: '5079',
            name: 'An Vĩ',
            prefix: 'Xã',
          },
          {
            id: '5080',
            name: 'Bình Kiều',
            prefix: 'Xã',
          },
          {
            id: '5081',
            name: 'Bình Minh',
            prefix: 'Xã',
          },
          {
            id: '5082',
            name: 'Dạ Trạch',
            prefix: 'Xã',
          },
          {
            id: '5084',
            name: 'Dân Tiến',
            prefix: 'Xã',
          },
          {
            id: '5083',
            name: 'Đại Tập',
            prefix: 'Xã',
          },
          {
            id: '5085',
            name: 'Đông Kết',
            prefix: 'Xã',
          },
          {
            id: '5086',
            name: 'Đông Ninh',
            prefix: 'Xã',
          },
          {
            id: '5087',
            name: 'Đông Tảo',
            prefix: 'Xã',
          },
          {
            id: '5088',
            name: 'Đồng Tiến',
            prefix: 'Xã',
          },
          {
            id: '5089',
            name: 'Hàm Tử',
            prefix: 'Xã',
          },
          {
            id: '5090',
            name: 'Hồng Tiến',
            prefix: 'Xã',
          },
          {
            id: '5091',
            name: 'Khoái Châu',
            prefix: 'Thị trấn',
          },
          {
            id: '5092',
            name: 'Liên Khê',
            prefix: 'Xã',
          },
          {
            id: '5093',
            name: 'Ông Đình',
            prefix: 'Xã',
          },
          {
            id: '5094',
            name: 'Phùng Hưng',
            prefix: 'Xã',
          },
          {
            id: '5095',
            name: 'Tân Châu',
            prefix: 'Xã',
          },
          {
            id: '5096',
            name: 'Tân Dân',
            prefix: 'Xã',
          },
          {
            id: '5097',
            name: 'Thuần Hưng',
            prefix: 'Xã',
          },
          {
            id: '5098',
            name: 'Tứ Dân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '330',
        name: 'Kim Động',
        wards: [
          {
            id: '5099',
            name: 'Chính Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '5100',
            name: 'Đồng Thanh',
            prefix: 'Xã',
          },
          {
            id: '5101',
            name: 'Đức Hợp',
            prefix: 'Xã',
          },
          {
            id: '5102',
            name: 'Hiệp Cường',
            prefix: 'Xã',
          },
          {
            id: '5103',
            name: 'Hùng An',
            prefix: 'Xã',
          },
          {
            id: '5104',
            name: 'Lương Bằng',
            prefix: 'Thị trấn',
          },
          {
            id: '5105',
            name: 'Mai Động',
            prefix: 'Xã',
          },
          {
            id: '5106',
            name: 'Nghĩa Dân',
            prefix: 'Xã',
          },
          {
            id: '5107',
            name: 'Ngọc Thanh',
            prefix: 'Xã',
          },
          {
            id: '5108',
            name: 'Nhân La',
            prefix: 'Xã',
          },
          {
            id: '5109',
            name: 'Phạm Ngũ Lão',
            prefix: 'Xã',
          },
          {
            id: '5110',
            name: 'Phú Thịnh',
            prefix: 'Xã',
          },
          {
            id: '5111',
            name: 'Song Mai',
            prefix: 'Xã',
          },
          {
            id: '5112',
            name: 'Thọ Vinh',
            prefix: 'Xã',
          },
          {
            id: '5113',
            name: 'Toàn Thắng',
            prefix: 'Xã',
          },
          {
            id: '5114',
            name: 'Vĩnh Xá',
            prefix: 'Xã',
          },
          {
            id: '5115',
            name: 'Vũ Xá',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '331',
        name: 'Mỹ Hào',
        wards: [
          {
            id: '5116',
            name: 'Bạch Sam',
            prefix: 'Xã',
          },
          {
            id: '5117',
            name: 'Bần Yên Nhân',
            prefix: 'Thị trấn',
          },
          {
            id: '5118',
            name: 'Cẩm Xá',
            prefix: 'Xã',
          },
          {
            id: '5119',
            name: 'Dị Sử',
            prefix: 'Xã',
          },
          {
            id: '5120',
            name: 'Dương Quang',
            prefix: 'Xã',
          },
          {
            id: '5121',
            name: 'Hòa Phong',
            prefix: 'Xã',
          },
          {
            id: '5122',
            name: 'Hưng Long',
            prefix: 'Xã',
          },
          {
            id: '5123',
            name: 'Minh Đức',
            prefix: 'Xã',
          },
          {
            id: '5124',
            name: 'Ngọc Lâm',
            prefix: 'Xã',
          },
          {
            id: '5125',
            name: 'Nhân Hòa',
            prefix: 'Xã',
          },
          {
            id: '5126',
            name: 'Phan Đình Phùng',
            prefix: 'Xã',
          },
          {
            id: '5127',
            name: 'Phùng Chí Kiên',
            prefix: 'Xã',
          },
          {
            id: '5128',
            name: 'Xuân Dục',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '332',
        name: 'Phù Cừ',
        wards: [
          {
            id: '5129',
            name: ' Tống Trân',
            prefix: 'Xã',
          },
          {
            id: '5130',
            name: 'Đình Cao',
            prefix: 'Xã',
          },
          {
            id: '5131',
            name: 'Đoàn Đào',
            prefix: 'Xã',
          },
          {
            id: '5132',
            name: 'Minh Hoàng',
            prefix: 'Xã',
          },
          {
            id: '5133',
            name: 'Minh Tân',
            prefix: 'Xã',
          },
          {
            id: '5134',
            name: 'Minh Tiến',
            prefix: 'Xã',
          },
          {
            id: '5135',
            name: 'Nguyên Hoà',
            prefix: 'Xã',
          },
          {
            id: '5136',
            name: 'Nhật Quang',
            prefix: 'Xã',
          },
          {
            id: '5137',
            name: 'Phan Sào Nam',
            prefix: 'Xã',
          },
          {
            id: '5138',
            name: 'Quang Hưng',
            prefix: 'Xã',
          },
          {
            id: '5139',
            name: 'Tam Đa',
            prefix: 'Xã',
          },
          {
            id: '5140',
            name: 'Tiên Tiến',
            prefix: 'Xã',
          },
          {
            id: '5141',
            name: 'Tống Phan',
            prefix: 'Xã',
          },
          {
            id: '5142',
            name: 'Trần Cao',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '333',
        name: 'Tiên Lữ',
        wards: [
          {
            id: '5143',
            name: 'An Viên',
            prefix: 'Xã',
          },
          {
            id: '5144',
            name: 'Cương Chính',
            prefix: 'Xã',
          },
          {
            id: '5145',
            name: 'Dị Chế',
            prefix: 'Xã',
          },
          {
            id: '5146',
            name: 'Đức Thắng',
            prefix: 'Xã',
          },
          {
            id: '5147',
            name: 'Hải Triều',
            prefix: 'Xã',
          },
          {
            id: '5148',
            name: 'Hưng Đạo',
            prefix: 'Xã',
          },
          {
            id: '5149',
            name: 'Lệ Xá',
            prefix: 'Xã',
          },
          {
            id: '5150',
            name: 'Minh Phượng',
            prefix: 'Xã',
          },
          {
            id: '5151',
            name: 'Ngô Quyền',
            prefix: 'Xã',
          },
          {
            id: '5152',
            name: 'Nhật Tân',
            prefix: 'Xã',
          },
          {
            id: '5153',
            name: 'Thiện Phiến',
            prefix: 'Xã',
          },
          {
            id: '5154',
            name: 'Thủ Sỹ',
            prefix: 'Xã',
          },
          {
            id: '5155',
            name: 'Thụy Lôi',
            prefix: 'Xã',
          },
          {
            id: '5156',
            name: 'Trung Dũng',
            prefix: 'Xã',
          },
          {
            id: '5157',
            name: 'Vương',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '334',
        name: 'Văn Giang',
        wards: [
          {
            id: '5158',
            name: ' Mễ Sở',
            prefix: 'Xã',
          },
          {
            id: '5159',
            name: 'Cửu Cao',
            prefix: 'Xã',
          },
          {
            id: '5160',
            name: 'Liên Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '5161',
            name: 'Long Hưng',
            prefix: 'Xã',
          },
          {
            id: '5162',
            name: 'Nghĩa Trụ',
            prefix: 'Xã',
          },
          {
            id: '5163',
            name: 'Phụng Công',
            prefix: 'Xã',
          },
          {
            id: '5164',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '5165',
            name: 'Thắng Lợi',
            prefix: 'Xã',
          },
          {
            id: '5166',
            name: 'Văn Giang',
            prefix: 'Thị trấn',
          },
          {
            id: '5167',
            name: 'Vĩnh Khúc',
            prefix: 'Xã',
          },
          {
            id: '5168',
            name: 'Xuân Quan',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '335',
        name: 'Văn Lâm',
        wards: [
          {
            id: '5169',
            name: ' Lương Tài',
            prefix: 'Xã',
          },
          {
            id: '5170',
            name: ' Việt Hưng',
            prefix: 'Xã',
          },
          {
            id: '5171',
            name: 'Chỉ Đạo',
            prefix: 'Xã',
          },
          {
            id: '5172',
            name: 'Đại Đồng',
            prefix: 'Xã',
          },
          {
            id: '5173',
            name: 'Đình Dù',
            prefix: 'Xã',
          },
          {
            id: '5174',
            name: 'Lạc Đạo',
            prefix: 'Xã',
          },
          {
            id: '5175',
            name: 'Lạc Hồng',
            prefix: 'Xã',
          },
          {
            id: '5176',
            name: 'Minh Hải',
            prefix: 'Xã',
          },
          {
            id: '5177',
            name: 'Như Quỳnh',
            prefix: 'Thị trấn',
          },
          {
            id: '5178',
            name: 'Tân Quang',
            prefix: 'Xã',
          },
          {
            id: '5179',
            name: 'Trưng Trắc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '336',
        name: 'Yên Mỹ',
        wards: [
          {
            id: '5180',
            name: ' Yên Hòa',
            prefix: 'Xã',
          },
          {
            id: '5181',
            name: 'Đồng Than',
            prefix: 'Xã',
          },
          {
            id: '5182',
            name: 'Giai Phạm',
            prefix: 'Xã',
          },
          {
            id: '5183',
            name: 'Hoàn Long',
            prefix: 'Xã',
          },
          {
            id: '5184',
            name: 'Liêu Xá',
            prefix: 'Xã',
          },
          {
            id: '5185',
            name: 'Lý Thường Kiệt',
            prefix: 'Xã',
          },
          {
            id: '5186',
            name: 'Minh Châu',
            prefix: 'Xã',
          },
          {
            id: '5187',
            name: 'Nghĩa Hiệp',
            prefix: 'Xã',
          },
          {
            id: '5188',
            name: 'Ngọc Long',
            prefix: 'Xã',
          },
          {
            id: '5189',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '5190',
            name: 'Tân Việt',
            prefix: 'Xã',
          },
          {
            id: '5191',
            name: 'Thanh Long',
            prefix: 'Xã',
          },
          {
            id: '5192',
            name: 'Trai Trang',
            prefix: 'Xã',
          },
          {
            id: '5193',
            name: 'Trung Hòa',
            prefix: 'Xã',
          },
          {
            id: '5194',
            name: 'Trung Hưng',
            prefix: 'Xã',
          },
          {
            id: '5195',
            name: 'Việt Cường',
            prefix: 'Xã',
          },
          {
            id: '5196',
            name: 'Yên Mỹ',
            prefix: 'Thị trấn',
          },
          {
            id: '5197',
            name: 'Yên Phú',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '25',
    code: 'BDD',
    name: 'Bình Định',
    districts: [
      {
        id: '337',
        name: 'An Lão',
        wards: [
          {
            id: '5198',
            name: 'An Dũng',
            prefix: 'Xã',
          },
          {
            id: '5199',
            name: 'An Hòa',
            prefix: 'Xã',
          },
          {
            id: '5200',
            name: 'An Hưng',
            prefix: 'Xã',
          },
          {
            id: '5201',
            name: 'An Lão',
            prefix: 'Thị trấn',
          },
          {
            id: '5202',
            name: 'An Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '5203',
            name: 'An Quang',
            prefix: 'Xã',
          },
          {
            id: '5204',
            name: 'An Tân',
            prefix: 'Xã',
          },
          {
            id: '5205',
            name: 'An Toàn',
            prefix: 'Xã',
          },
          {
            id: '5206',
            name: 'An Trung',
            prefix: 'Xã',
          },
          {
            id: '5207',
            name: 'An Vinh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '338',
        name: 'An Nhơn',
        wards: [
          {
            id: '5208',
            name: 'Bình Định',
            prefix: 'Phường',
          },
          {
            id: '5209',
            name: 'Đập Đá',
            prefix: 'Phường',
          },
          {
            id: '5210',
            name: 'Nhơn An',
            prefix: 'Xã',
          },
          {
            id: '5211',
            name: 'Nhơn Hạnh',
            prefix: 'Xã',
          },
          {
            id: '5212',
            name: 'Nhơn Hậu',
            prefix: 'Xã',
          },
          {
            id: '5213',
            name: 'Nhơn Hòa',
            prefix: 'Phường',
          },
          {
            id: '5214',
            name: 'Nhơn Hưng',
            prefix: 'Phường',
          },
          {
            id: '5215',
            name: 'Nhơn Khánh',
            prefix: 'Xã',
          },
          {
            id: '5216',
            name: 'Nhơn Lộc',
            prefix: 'Xã',
          },
          {
            id: '5217',
            name: 'Nhơn Mỹ',
            prefix: 'Xã',
          },
          {
            id: '5218',
            name: 'Nhơn Phong',
            prefix: 'Xã',
          },
          {
            id: '5219',
            name: 'Nhơn Phúc',
            prefix: 'Xã',
          },
          {
            id: '5220',
            name: 'Nhơn Tân',
            prefix: 'Xã',
          },
          {
            id: '5221',
            name: 'Nhơn Thành',
            prefix: 'Phường',
          },
          {
            id: '5222',
            name: 'Nhơn Thọ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '339',
        name: 'Hoài Ân',
        wards: [
          {
            id: '5223',
            name: 'Ân Đức',
            prefix: 'Xã',
          },
          {
            id: '5224',
            name: 'Ân Hảo Đông',
            prefix: 'Xã',
          },
          {
            id: '5225',
            name: 'Ân Hảo Tây',
            prefix: 'Xã',
          },
          {
            id: '5226',
            name: 'Ân Hữu',
            prefix: 'Xã',
          },
          {
            id: '5227',
            name: 'Ân Mỹ',
            prefix: 'Xã',
          },
          {
            id: '5228',
            name: 'Ân Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '5229',
            name: 'Ân Phong',
            prefix: 'Xã',
          },
          {
            id: '5230',
            name: 'Ân Sơn',
            prefix: 'Xã',
          },
          {
            id: '5231',
            name: 'Ân Thạnh',
            prefix: 'Xã',
          },
          {
            id: '5232',
            name: 'Ân Tín',
            prefix: 'Xã',
          },
          {
            id: '5233',
            name: 'Ân Tường Đông',
            prefix: 'Xã',
          },
          {
            id: '5234',
            name: 'Ân Tường Tây',
            prefix: 'Xã',
          },
          {
            id: '5235',
            name: 'BokTơi',
            prefix: 'Xã',
          },
          {
            id: '5236',
            name: 'ĐakMang',
            prefix: 'Xã',
          },
          {
            id: '5237',
            name: 'Tăng Bạt Hổ',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '340',
        name: 'Hoài Nhơn',
        wards: [
          {
            id: '5238',
            name: 'Bồng Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '5239',
            name: 'Hoài Châu',
            prefix: 'Xã',
          },
          {
            id: '5240',
            name: 'Hoài Châu Bắc',
            prefix: 'Xã',
          },
          {
            id: '5241',
            name: 'Hoài Đức',
            prefix: 'Xã',
          },
          {
            id: '5242',
            name: 'Hoài Hải',
            prefix: 'Xã',
          },
          {
            id: '5243',
            name: 'Hoài Hảo',
            prefix: 'Xã',
          },
          {
            id: '5244',
            name: 'Hoài Hương',
            prefix: 'Xã',
          },
          {
            id: '5245',
            name: 'Hoài Mỹ',
            prefix: 'Xã',
          },
          {
            id: '5246',
            name: 'Hoài Phú',
            prefix: 'Xã',
          },
          {
            id: '5247',
            name: 'Hoài Sơn',
            prefix: 'Xã',
          },
          {
            id: '5248',
            name: 'Hoài Tân',
            prefix: 'Xã',
          },
          {
            id: '5249',
            name: 'Hoài Thanh',
            prefix: 'Xã',
          },
          {
            id: '5250',
            name: 'Hoài Thanh Tây',
            prefix: 'Xã',
          },
          {
            id: '5251',
            name: 'Hoài Xuân',
            prefix: 'Xã',
          },
          {
            id: '5252',
            name: 'Tam Quan',
            prefix: 'Thị trấn',
          },
          {
            id: '5253',
            name: 'Tam Quan Bắc',
            prefix: 'Xã',
          },
          {
            id: '5254',
            name: 'Tam Quan Nam',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '341',
        name: 'Phù Cát',
        wards: [
          {
            id: '5255',
            name: 'Cát Chánh',
            prefix: 'Xã',
          },
          {
            id: '5256',
            name: 'Cát Hải',
            prefix: 'Xã',
          },
          {
            id: '5257',
            name: 'Cát Hanh',
            prefix: 'Xã',
          },
          {
            id: '5258',
            name: 'Cát Hiệp',
            prefix: 'Xã',
          },
          {
            id: '5259',
            name: 'Cát Hưng',
            prefix: 'Xã',
          },
          {
            id: '5260',
            name: 'Cát Khánh',
            prefix: 'Xã',
          },
          {
            id: '5261',
            name: 'Cát Lâm',
            prefix: 'Xã',
          },
          {
            id: '5262',
            name: 'Cát Minh',
            prefix: 'Xã',
          },
          {
            id: '5263',
            name: 'Cát Nhơn',
            prefix: 'Xã',
          },
          {
            id: '5264',
            name: 'Cát Tài',
            prefix: 'Xã',
          },
          {
            id: '5265',
            name: 'Cát Thắng',
            prefix: 'Xã',
          },
          {
            id: '5266',
            name: 'Cát Thành',
            prefix: 'Xã',
          },
          {
            id: '5267',
            name: 'Cát Tiến',
            prefix: 'Xã',
          },
          {
            id: '5268',
            name: 'Cát Trinh',
            prefix: 'Xã',
          },
          {
            id: '5269',
            name: 'Cát Tường',
            prefix: 'Xã',
          },
          {
            id: '5270',
            name: 'Ngô Mây',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '342',
        name: 'Phù Mỹ',
        wards: [
          {
            id: '5271',
            name: 'Bình Dương',
            prefix: 'Thị trấn',
          },
          {
            id: '5272',
            name: 'Cát Khánh',
            prefix: 'Xã',
          },
          {
            id: '5273',
            name: 'Cát Sơn',
            prefix: 'Xã',
          },
          {
            id: '5274',
            name: 'Cát Tân',
            prefix: 'Xã',
          },
          {
            id: '5275',
            name: 'Mỹ An',
            prefix: 'Xã',
          },
          {
            id: '5276',
            name: 'Mỹ Cát',
            prefix: 'Xã',
          },
          {
            id: '5277',
            name: 'Mỹ Chánh',
            prefix: 'Xã',
          },
          {
            id: '5278',
            name: 'Mỹ Chánh Tây',
            prefix: 'Xã',
          },
          {
            id: '5279',
            name: 'Mỹ Châu',
            prefix: 'Xã',
          },
          {
            id: '5280',
            name: 'Mỹ Đức',
            prefix: 'Xã',
          },
          {
            id: '5281',
            name: 'Mỹ Hiệp',
            prefix: 'Xã',
          },
          {
            id: '5282',
            name: 'Mỹ Hòa',
            prefix: 'Xã',
          },
          {
            id: '5283',
            name: 'Mỹ Lộc',
            prefix: 'Xã',
          },
          {
            id: '5284',
            name: 'Mỹ Lợi',
            prefix: 'Xã',
          },
          {
            id: '5285',
            name: 'Mỹ Phong',
            prefix: 'Xã',
          },
          {
            id: '5286',
            name: 'Mỹ Quang',
            prefix: 'Xã',
          },
          {
            id: '5287',
            name: 'Mỹ Tài',
            prefix: 'Xã',
          },
          {
            id: '5288',
            name: 'Mỹ Thắng',
            prefix: 'Xã',
          },
          {
            id: '5289',
            name: 'Mỹ Thành',
            prefix: 'Xã',
          },
          {
            id: '5290',
            name: 'Mỹ Thọ',
            prefix: 'Xã',
          },
          {
            id: '5291',
            name: 'Mỹ Trinh',
            prefix: 'Xã',
          },
          {
            id: '5292',
            name: 'Phù Mỹ',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '343',
        name: 'Quy Nhơn',
        wards: [
          {
            id: '5293',
            name: 'Bùi Thị Xuân',
            prefix: 'Phường',
          },
          {
            id: '5294',
            name: 'Đống Đa',
            prefix: 'Phường',
          },
          {
            id: '5295',
            name: 'Ghềnh Ráng',
            prefix: 'Phường',
          },
          {
            id: '5296',
            name: 'Hải Cảng',
            prefix: 'Phường',
          },
          {
            id: '5297',
            name: 'Lê Hồng Phong',
            prefix: 'Phường',
          },
          {
            id: '5298',
            name: 'Lê Lợi',
            prefix: 'Phường',
          },
          {
            id: '5299',
            name: 'Lý Thường Kiệt',
            prefix: 'Phường',
          },
          {
            id: '5300',
            name: 'Ngô Mây',
            prefix: 'Phường',
          },
          {
            id: '5301',
            name: 'Nguyễn Văn Cừ',
            prefix: 'Phường',
          },
          {
            id: '5302',
            name: 'Nhơn Bình',
            prefix: 'Xã',
          },
          {
            id: '5303',
            name: 'Nhơn Châu',
            prefix: 'Xã',
          },
          {
            id: '5304',
            name: 'Nhơn Hải',
            prefix: 'Xã',
          },
          {
            id: '5305',
            name: 'Nhơn Hội',
            prefix: 'Xã',
          },
          {
            id: '5306',
            name: 'Nhơn Lý',
            prefix: 'Xã',
          },
          {
            id: '5307',
            name: 'Nhơn Phú',
            prefix: 'Phường',
          },
          {
            id: '5308',
            name: 'Phước Mỹ',
            prefix: 'Xã',
          },
          {
            id: '5309',
            name: 'Quang Trung',
            prefix: 'Phường',
          },
          {
            id: '5310',
            name: 'Thị Nại',
            prefix: 'Phường',
          },
          {
            id: '5311',
            name: 'Trần Hưng Đạo',
            prefix: 'Phường',
          },
          {
            id: '5312',
            name: 'Trần Phú',
            prefix: 'Phường',
          },
          {
            id: '5313',
            name: 'Trần Quang Diệu',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '344',
        name: 'Tây Sơn',
        wards: [
          {
            id: '5314',
            name: 'Bình Hòa',
            prefix: 'Xã',
          },
          {
            id: '5315',
            name: 'Bình Nghi',
            prefix: 'Xã',
          },
          {
            id: '5316',
            name: 'Bình Tân',
            prefix: 'Xã',
          },
          {
            id: '5317',
            name: 'Bình Thành',
            prefix: 'Xã',
          },
          {
            id: '5318',
            name: 'Bình Thuận',
            prefix: 'Xã',
          },
          {
            id: '5319',
            name: 'Bình Tường',
            prefix: 'Xã',
          },
          {
            id: '5320',
            name: 'Phú Phong',
            prefix: 'Thị trấn',
          },
          {
            id: '5321',
            name: 'Tây An',
            prefix: 'Xã',
          },
          {
            id: '5322',
            name: 'Tây Bình',
            prefix: 'Xã',
          },
          {
            id: '5323',
            name: 'Tây Giang',
            prefix: 'Xã',
          },
          {
            id: '5324',
            name: 'Tây Phú',
            prefix: 'Xã',
          },
          {
            id: '5325',
            name: 'Tây Thuận',
            prefix: 'Xã',
          },
          {
            id: '5326',
            name: 'Tây Vinh',
            prefix: 'Xã',
          },
          {
            id: '5327',
            name: 'Tây Xuân',
            prefix: 'Xã',
          },
          {
            id: '5328',
            name: 'Vĩnh An',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '345',
        name: 'Tuy Phước',
        wards: [
          {
            id: '5329',
            name: 'Diêu Trì',
            prefix: 'Thị trấn',
          },
          {
            id: '5330',
            name: 'Phước An',
            prefix: 'Xã',
          },
          {
            id: '5331',
            name: 'Phước Hiệp',
            prefix: 'Xã',
          },
          {
            id: '5332',
            name: 'Phước Hòa',
            prefix: 'Xã',
          },
          {
            id: '5333',
            name: 'Phước Hưng',
            prefix: 'Xã',
          },
          {
            id: '5334',
            name: 'Phước Lộc',
            prefix: 'Xã',
          },
          {
            id: '5335',
            name: 'Phước Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '5336',
            name: 'Phước Quang',
            prefix: 'Xã',
          },
          {
            id: '5337',
            name: 'Phước Sơn',
            prefix: 'Xã',
          },
          {
            id: '5338',
            name: 'Phước Thắng',
            prefix: 'Xã',
          },
          {
            id: '5339',
            name: 'Phước Thành',
            prefix: 'Xã',
          },
          {
            id: '5340',
            name: 'Phước Thuận',
            prefix: 'Xã',
          },
          {
            id: '5341',
            name: 'Tuy Phước',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '346',
        name: 'Vân Canh',
        wards: [
          {
            id: '5342',
            name: 'Canh Hiển',
            prefix: 'Xã',
          },
          {
            id: '5343',
            name: 'Canh Hiệp',
            prefix: 'Xã',
          },
          {
            id: '5344',
            name: 'Canh Hòa',
            prefix: 'Xã',
          },
          {
            id: '5345',
            name: 'Canh Liên',
            prefix: 'Xã',
          },
          {
            id: '5346',
            name: 'Canh Thuận',
            prefix: 'Xã',
          },
          {
            id: '5347',
            name: 'Canh Vinh',
            prefix: 'Xã',
          },
          {
            id: '5348',
            name: 'Vân Canh',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '347',
        name: 'Vĩnh Thạnh',
        wards: [
          {
            id: '5349',
            name: 'Vĩnh Hảo',
            prefix: 'Xã',
          },
          {
            id: '5350',
            name: 'Vĩnh Hiệp',
            prefix: 'Xã',
          },
          {
            id: '5351',
            name: 'Vĩnh Hòa',
            prefix: 'Xã',
          },
          {
            id: '5352',
            name: 'Vĩnh Kim',
            prefix: 'Xã',
          },
          {
            id: '5353',
            name: 'Vĩnh Quang',
            prefix: 'Xã',
          },
          {
            id: '5354',
            name: 'Vĩnh Sơn',
            prefix: 'Xã',
          },
          {
            id: '5355',
            name: 'Vĩnh Thạnh',
            prefix: 'Thị trấn',
          },
          {
            id: '5356',
            name: 'Vĩnh Thịnh',
            prefix: 'Xã',
          },
          {
            id: '5357',
            name: 'Vĩnh Thuận',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '26',
    code: 'TG',
    name: 'Tiền Giang',
    districts: [
      {
        id: '348',
        name: 'Cái Bè',
        wards: [
          {
            id: '5358',
            name: 'An Cư',
            prefix: 'Xã',
          },
          {
            id: '5359',
            name: 'An Hữu',
            prefix: 'Xã',
          },
          {
            id: '5360',
            name: 'An Thái Đông',
            prefix: 'Xã',
          },
          {
            id: '5361',
            name: 'An Thái Trung',
            prefix: 'Xã',
          },
          {
            id: '5362',
            name: 'Cái Bè',
            prefix: 'Thị trấn',
          },
          {
            id: '5363',
            name: 'Đông Hòa Hiệp',
            prefix: 'Xã',
          },
          {
            id: '5364',
            name: 'Hậu Mỹ Bắc A',
            prefix: 'Xã',
          },
          {
            id: '5365',
            name: 'Hậu Mỹ Bắc B',
            prefix: 'Xã',
          },
          {
            id: '5366',
            name: 'Hậu Mỹ Phú',
            prefix: 'Xã',
          },
          {
            id: '5367',
            name: 'Hậu Mỹ Trinh',
            prefix: 'Xã',
          },
          {
            id: '5368',
            name: 'Hậu Thành',
            prefix: 'Xã',
          },
          {
            id: '5369',
            name: 'Hòa Hưng',
            prefix: 'Xã',
          },
          {
            id: '5370',
            name: 'Hòa Khánh',
            prefix: 'Xã',
          },
          {
            id: '5371',
            name: 'Mỹ Đức Đông',
            prefix: 'Xã',
          },
          {
            id: '5372',
            name: 'Mỹ Đức Tây',
            prefix: 'Xã',
          },
          {
            id: '5373',
            name: 'Mỹ Hội',
            prefix: 'Xã',
          },
          {
            id: '5374',
            name: 'Mỹ Lợi A',
            prefix: 'Xã',
          },
          {
            id: '5375',
            name: 'Mỹ Lợi B',
            prefix: 'Xã',
          },
          {
            id: '5376',
            name: 'Mỹ Lương',
            prefix: 'Xã',
          },
          {
            id: '5377',
            name: 'Mỹ Tân',
            prefix: 'Xã',
          },
          {
            id: '5378',
            name: 'Mỹ Trung',
            prefix: 'Xã',
          },
          {
            id: '5379',
            name: 'Tân Hưng',
            prefix: 'Xã',
          },
          {
            id: '5380',
            name: 'Tân Thanh',
            prefix: 'Xã',
          },
          {
            id: '5381',
            name: 'Thiện Trí',
            prefix: 'Xã',
          },
          {
            id: '5382',
            name: 'Thiện Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '349',
        name: 'Cai Lậy',
        wards: [
          {
            id: '5383',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '5384',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '5385',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '5386',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '5387',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '5388',
            name: 'Long Khánh',
            prefix: 'Xã',
          },
          {
            id: '5389',
            name: 'Mỹ Hạnh Đông',
            prefix: 'Xã',
          },
          {
            id: '5390',
            name: 'Mỹ Hạnh Tây',
            prefix: 'Xã',
          },
          {
            id: '5391',
            name: 'Mỹ Phước Tây',
            prefix: 'Xã',
          },
          {
            id: '5392',
            name: 'Nhi Mỹ',
            prefix: 'Phường',
          },
          {
            id: '5393',
            name: 'Nhị Quý',
            prefix: 'Xã',
          },
          {
            id: '5394',
            name: 'Phú Quý',
            prefix: 'Xã',
          },
          {
            id: '5395',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '5396',
            name: 'Tân Hội',
            prefix: 'Xã',
          },
          {
            id: '5397',
            name: 'Tân Phú',
            prefix: 'Xã',
          },
          {
            id: '5398',
            name: 'Thanh Hòa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '350',
        name: 'Châu Thành',
        wards: [
          {
            id: '5399',
            name: 'Bàn Long',
            prefix: 'Xã',
          },
          {
            id: '5400',
            name: 'Bình Đức',
            prefix: 'Xã',
          },
          {
            id: '5401',
            name: 'Bình Trưng',
            prefix: 'Xã',
          },
          {
            id: '5404',
            name: 'Dưỡng Điềm',
            prefix: 'Xã',
          },
          {
            id: '5402',
            name: 'Điềm Hy',
            prefix: 'Xã',
          },
          {
            id: '5403',
            name: 'Đông Hòa',
            prefix: 'Xã',
          },
          {
            id: '5405',
            name: 'Hựu Đạo',
            prefix: 'Xã',
          },
          {
            id: '5406',
            name: 'Kim Sơn',
            prefix: 'Xã',
          },
          {
            id: '5407',
            name: 'Long An',
            prefix: 'Xã',
          },
          {
            id: '5408',
            name: 'Long Định',
            prefix: 'Xã',
          },
          {
            id: '5409',
            name: 'Long Hưng',
            prefix: 'Xã',
          },
          {
            id: '5410',
            name: 'Nhị Bình',
            prefix: 'Xã',
          },
          {
            id: '5411',
            name: 'Phú Phong',
            prefix: 'Xã',
          },
          {
            id: '5412',
            name: 'Song Thuận',
            prefix: 'Xã',
          },
          {
            id: '5413',
            name: 'Tam Hiệp',
            prefix: 'Xã',
          },
          {
            id: '5414',
            name: 'Tân Hiệp',
            prefix: 'Thị trấn',
          },
          {
            id: '5415',
            name: 'Tân Hội Đông',
            prefix: 'Xã',
          },
          {
            id: '5416',
            name: 'Tân Hương',
            prefix: 'Xã',
          },
          {
            id: '5417',
            name: 'Tân Lý Đông',
            prefix: 'Xã',
          },
          {
            id: '5418',
            name: 'Tân Lý Tây',
            prefix: 'Xã',
          },
          {
            id: '5419',
            name: 'Thân Cửu Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '5420',
            name: 'Thạnh Phú',
            prefix: 'Xã',
          },
          {
            id: '5421',
            name: 'Vĩnh Kim',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '351',
        name: 'Chợ Gạo',
        wards: [
          {
            id: '5422',
            name: 'An Thạnh Thủy',
            prefix: 'Xã',
          },
          {
            id: '5423',
            name: 'Bình Ninh',
            prefix: 'Xã',
          },
          {
            id: '5424',
            name: 'Bình Phan',
            prefix: 'Xã',
          },
          {
            id: '5425',
            name: 'Bình Phục Nhứt',
            prefix: 'Xã',
          },
          {
            id: '5426',
            name: 'Chợ Gạo',
            prefix: 'Thị trấn',
          },
          {
            id: '5427',
            name: 'Đăng Hưng Phước',
            prefix: 'Xã',
          },
          {
            id: '5428',
            name: 'Hòa Định',
            prefix: 'Xã',
          },
          {
            id: '5429',
            name: 'Hòa Tịnh',
            prefix: 'Xã',
          },
          {
            id: '5430',
            name: 'Long Bình Điền',
            prefix: 'Xã',
          },
          {
            id: '5431',
            name: 'Lương Hòa Lạc',
            prefix: 'Xã',
          },
          {
            id: '5432',
            name: 'Mỹ Tịnh An',
            prefix: 'Xã',
          },
          {
            id: '5433',
            name: 'Phú Kiết',
            prefix: 'Xã',
          },
          {
            id: '5434',
            name: 'Quơn Long',
            prefix: 'Xã',
          },
          {
            id: '5435',
            name: 'Song Bình',
            prefix: 'Xã',
          },
          {
            id: '5436',
            name: 'Tân Bình Thạnh',
            prefix: 'Xã',
          },
          {
            id: '5437',
            name: 'Tân Thuận Bình',
            prefix: 'Xã',
          },
          {
            id: '5438',
            name: 'Thanh Bình',
            prefix: 'Xã',
          },
          {
            id: '5439',
            name: 'Trung Hòa',
            prefix: 'Xã',
          },
          {
            id: '5440',
            name: 'Xuân Đông',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '352',
        name: 'Gò Công',
        wards: [
          {
            id: '5441',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '5442',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '5443',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '5444',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '5445',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '5446',
            name: 'Bình Đông',
            prefix: 'Xã',
          },
          {
            id: '5447',
            name: 'Bình Xuân',
            prefix: 'Xã',
          },
          {
            id: '5448',
            name: 'Long Chánh',
            prefix: 'Xã',
          },
          {
            id: '5449',
            name: 'Long Hòa',
            prefix: 'Xã',
          },
          {
            id: '5450',
            name: 'Long Hưng',
            prefix: 'Xã',
          },
          {
            id: '5451',
            name: 'Long Thành',
            prefix: 'Xã',
          },
          {
            id: '5452',
            name: 'Long Thuận',
            prefix: 'Xã',
          },
          {
            id: '5453',
            name: 'Tân Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '353',
        name: 'Gò Công Đông',
        wards: [
          {
            id: '5454',
            name: 'Bình Ân',
            prefix: 'Xã',
          },
          {
            id: '5455',
            name: 'Bình Nghị',
            prefix: 'Xã',
          },
          {
            id: '5456',
            name: 'Gia Thuận',
            prefix: 'Xã',
          },
          {
            id: '5457',
            name: 'Kiểng Phước',
            prefix: 'Xã',
          },
          {
            id: '5458',
            name: 'Phước Trung',
            prefix: 'Xã',
          },
          {
            id: '5459',
            name: 'Tân Điền',
            prefix: 'Xã',
          },
          {
            id: '5460',
            name: 'Tân Đông',
            prefix: 'Xã',
          },
          {
            id: '5461',
            name: 'Tân Hòa',
            prefix: 'Thị trấn',
          },
          {
            id: '5462',
            name: 'Tân Phước',
            prefix: 'Xã',
          },
          {
            id: '5463',
            name: 'Tân Tây',
            prefix: 'Xã',
          },
          {
            id: '5464',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '5465',
            name: 'Tăng Hòa',
            prefix: 'Xã',
          },
          {
            id: '5466',
            name: 'Vàm Láng',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '354',
        name: 'Gò Công Tây',
        wards: [
          {
            id: '5467',
            name: 'Bình Nhì',
            prefix: 'Xã',
          },
          {
            id: '5468',
            name: 'Bình Phú',
            prefix: 'Xã',
          },
          {
            id: '5469',
            name: 'Bình Tân',
            prefix: 'Xã',
          },
          {
            id: '5470',
            name: 'Đồng Sơn',
            prefix: 'Xã',
          },
          {
            id: '5471',
            name: 'Đồng Thạnh',
            prefix: 'Xã',
          },
          {
            id: '5472',
            name: 'Long Bình',
            prefix: 'Xã',
          },
          {
            id: '5473',
            name: 'Long Vĩnh',
            prefix: 'Xã',
          },
          {
            id: '5474',
            name: 'Thành Công',
            prefix: 'Xã',
          },
          {
            id: '5475',
            name: 'Thạnh Nhựt',
            prefix: 'Xã',
          },
          {
            id: '5476',
            name: 'Thạnh Trị',
            prefix: 'Xã',
          },
          {
            id: '5477',
            name: 'Vĩnh Bình',
            prefix: 'Thị trấn',
          },
          {
            id: '5478',
            name: 'Vĩnh Hữu',
            prefix: 'Xã',
          },
          {
            id: '5479',
            name: 'Yên Luông',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '355',
        name: 'Huyện Cai Lậy',
        wards: [
          {
            id: '5480',
            name: 'Bình Phú',
            prefix: 'Xã',
          },
          {
            id: '5481',
            name: 'Cai Lậy',
            prefix: 'Thị trấn',
          },
          {
            id: '5482',
            name: 'Cẩm Sơn',
            prefix: 'Xã',
          },
          {
            id: '5483',
            name: 'Hiệp Đức',
            prefix: 'Xã',
          },
          {
            id: '5484',
            name: 'Hội Xuân',
            prefix: 'Xã',
          },
          {
            id: '5485',
            name: 'Long Tiên',
            prefix: 'Xã',
          },
          {
            id: '5486',
            name: 'Long Trung',
            prefix: 'Xã',
          },
          {
            id: '5487',
            name: 'Mỹ Hạnh Trung',
            prefix: 'Xã',
          },
          {
            id: '5488',
            name: 'Mỹ Long',
            prefix: 'Xã',
          },
          {
            id: '5489',
            name: 'Mỹ Thành Bắc',
            prefix: 'Xã',
          },
          {
            id: '5490',
            name: 'Mỹ Thành Nam',
            prefix: 'Xã',
          },
          {
            id: '5491',
            name: 'Ngũ Hiệp',
            prefix: 'Xã',
          },
          {
            id: '5492',
            name: 'Nhị Mỹ',
            prefix: 'Xã',
          },
          {
            id: '5493',
            name: 'Phú An',
            prefix: 'Xã',
          },
          {
            id: '5494',
            name: 'Phú Cường',
            prefix: 'Xã',
          },
          {
            id: '5495',
            name: 'Phú Nhuận',
            prefix: 'Xã',
          },
          {
            id: '5496',
            name: 'Quý Thạnh',
            prefix: 'Xã',
          },
          {
            id: '5497',
            name: 'Tam Bình',
            prefix: 'Xã',
          },
          {
            id: '5498',
            name: 'Tân Hội',
            prefix: 'Xã',
          },
          {
            id: '5499',
            name: 'Tân Phong',
            prefix: 'Xã',
          },
          {
            id: '5500',
            name: 'Thạnh Lộc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '356',
        name: 'Mỹ Tho',
        wards: [
          {
            id: '5501',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '5502',
            name: '10',
            prefix: 'Phường',
          },
          {
            id: '5503',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '5504',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '5505',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '5506',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '5507',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '5508',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '5509',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '5510',
            name: '9',
            prefix: 'Phường',
          },
          {
            id: '5511',
            name: 'Đạo Thạnh',
            prefix: 'Xã',
          },
          {
            id: '5512',
            name: 'Mỹ Phong',
            prefix: 'Xã',
          },
          {
            id: '5513',
            name: 'Phước Thạnh',
            prefix: 'Xã',
          },
          {
            id: '5514',
            name: 'Tân Long',
            prefix: 'Phường',
          },
          {
            id: '5515',
            name: 'Tân Mỹ Chánh',
            prefix: 'Xã',
          },
          {
            id: '5516',
            name: 'Thới Sơn',
            prefix: 'Xã',
          },
          {
            id: '5517',
            name: 'Trung An',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '357',
        name: 'Tân Phú Đông',
        wards: [
          {
            id: '5518',
            name: 'Phú Đông',
            prefix: 'Xã',
          },
          {
            id: '5519',
            name: 'Phú Tân',
            prefix: 'Xã',
          },
          {
            id: '5520',
            name: 'Phú Thạnh',
            prefix: 'Xã',
          },
          {
            id: '5521',
            name: 'Tân Phú',
            prefix: 'Xã',
          },
          {
            id: '5522',
            name: 'Tân Thạnh',
            prefix: 'Xã',
          },
          {
            id: '5523',
            name: 'Tân Thới',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '358',
        name: 'Tân Phước',
        wards: [
          {
            id: '5524',
            name: 'Hưng Thạnh',
            prefix: 'Xã',
          },
          {
            id: '5525',
            name: 'Mỹ Phước',
            prefix: 'Thị trấn',
          },
          {
            id: '5526',
            name: 'Mỹ Phước',
            prefix: 'Xã',
          },
          {
            id: '5527',
            name: 'Phú Mỹ',
            prefix: 'Xã',
          },
          {
            id: '5528',
            name: 'Phước Lập',
            prefix: 'Xã',
          },
          {
            id: '5529',
            name: 'Tân Hòa Đông',
            prefix: 'Xã',
          },
          {
            id: '5530',
            name: 'Tân Hòa Tây',
            prefix: 'Xã',
          },
          {
            id: '5531',
            name: 'Tân Hòa Thành',
            prefix: 'Xã',
          },
          {
            id: '5532',
            name: 'Tân Lập 1',
            prefix: 'Xã',
          },
          {
            id: '5533',
            name: 'Tân Lập 2',
            prefix: 'Xã',
          },
          {
            id: '5534',
            name: 'Thạnh Hòa',
            prefix: 'Xã',
          },
          {
            id: '5535',
            name: 'Thạnh Mỹ',
            prefix: 'Xã',
          },
          {
            id: '5536',
            name: 'Thạnh Tân',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '27',
    code: 'TB',
    name: 'Thái Bình',
    districts: [
      {
        id: '359',
        name: 'Đông Hưng',
        wards: [
          {
            id: '5537',
            name: 'An Châu',
            prefix: 'Xã',
          },
          {
            id: '5538',
            name: 'Bạch Đằng',
            prefix: 'Xã',
          },
          {
            id: '5539',
            name: 'Chương Dương',
            prefix: 'Xã',
          },
          {
            id: '5540',
            name: 'Đô Lương',
            prefix: 'Xã',
          },
          {
            id: '5541',
            name: 'Đông Á',
            prefix: 'Xã',
          },
          {
            id: '5542',
            name: 'Đông Các',
            prefix: 'Xã',
          },
          {
            id: '5543',
            name: 'Đông Cường',
            prefix: 'Xã',
          },
          {
            id: '5545',
            name: 'Đông Dương',
            prefix: 'Xã',
          },
          {
            id: '5544',
            name: 'Đông Động',
            prefix: 'Xã',
          },
          {
            id: '5546',
            name: 'Đông Giang',
            prefix: 'Xã',
          },
          {
            id: '5547',
            name: 'Đông Hà',
            prefix: 'Xã',
          },
          {
            id: '5548',
            name: 'Đông Hoàng',
            prefix: 'Xã',
          },
          {
            id: '5549',
            name: 'Đông Hợp',
            prefix: 'Xã',
          },
          {
            id: '5550',
            name: 'Đông Hưng',
            prefix: 'Thị trấn',
          },
          {
            id: '5551',
            name: 'Đông Huy',
            prefix: 'Xã',
          },
          {
            id: '5552',
            name: 'Đông Kinh',
            prefix: 'Xã',
          },
          {
            id: '5553',
            name: 'Đông La',
            prefix: 'Xã',
          },
          {
            id: '5554',
            name: 'Đông Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '5555',
            name: 'Đông Phong',
            prefix: 'Xã',
          },
          {
            id: '5556',
            name: 'Đồng Phú',
            prefix: 'Xã',
          },
          {
            id: '5557',
            name: 'Đông Phương',
            prefix: 'Xã',
          },
          {
            id: '5558',
            name: 'Đông Quang',
            prefix: 'Xã',
          },
          {
            id: '5559',
            name: 'Đông Sơn',
            prefix: 'Xã',
          },
          {
            id: '5560',
            name: 'Đông Tân',
            prefix: 'Xã',
          },
          {
            id: '5561',
            name: 'Đông Vinh',
            prefix: 'Xã',
          },
          {
            id: '5562',
            name: 'Đông Xá',
            prefix: 'Xã',
          },
          {
            id: '5563',
            name: 'Đông Xuân',
            prefix: 'Xã',
          },
          {
            id: '5564',
            name: 'Hoa Lư',
            prefix: 'Xã',
          },
          {
            id: '5565',
            name: 'Hoa Nam',
            prefix: 'Xã',
          },
          {
            id: '5566',
            name: 'Hồng Châu',
            prefix: 'Xã',
          },
          {
            id: '5567',
            name: 'Hồng Giang',
            prefix: 'Xã',
          },
          {
            id: '5568',
            name: 'Hồng Việt',
            prefix: 'Xã',
          },
          {
            id: '5569',
            name: 'Hợp Tiến',
            prefix: 'Xã',
          },
          {
            id: '5570',
            name: 'Liên Giang',
            prefix: 'Xã',
          },
          {
            id: '5571',
            name: 'Lô Giang',
            prefix: 'Xã',
          },
          {
            id: '5572',
            name: 'Mê Linh',
            prefix: 'Xã',
          },
          {
            id: '5573',
            name: 'Minh Châu',
            prefix: 'Xã',
          },
          {
            id: '5574',
            name: 'Minh Tân',
            prefix: 'Xã',
          },
          {
            id: '5575',
            name: 'Nguyên Xá',
            prefix: 'Xã',
          },
          {
            id: '5576',
            name: 'Phong Châu',
            prefix: 'Xã',
          },
          {
            id: '5577',
            name: 'Phú Châu',
            prefix: 'Xã',
          },
          {
            id: '5578',
            name: 'Phú Lương',
            prefix: 'Xã',
          },
          {
            id: '5579',
            name: 'Thăng Long',
            prefix: 'Xã',
          },
          {
            id: '5580',
            name: 'Trọng Quan',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '360',
        name: 'Hưng Hà',
        wards: [
          {
            id: '5581',
            name: 'Bắc Sơn',
            prefix: 'Xã',
          },
          {
            id: '5582',
            name: 'Canh Tân',
            prefix: 'Xã',
          },
          {
            id: '5583',
            name: 'Chí Hòa',
            prefix: 'Xã',
          },
          {
            id: '5584',
            name: 'Chi Lăng',
            prefix: 'Xã',
          },
          {
            id: '5585',
            name: 'Cộng Hòa',
            prefix: 'Xã',
          },
          {
            id: '5586',
            name: 'Dân Chủ',
            prefix: 'Xã',
          },
          {
            id: '5591',
            name: 'Duyên Hải',
            prefix: 'Xã',
          },
          {
            id: '5587',
            name: 'Điệp Nông',
            prefix: 'Xã',
          },
          {
            id: '5588',
            name: 'Đoan Hùng',
            prefix: 'Xã',
          },
          {
            id: '5589',
            name: 'Độc Lập',
            prefix: 'Xã',
          },
          {
            id: '5590',
            name: 'Đông Đô',
            prefix: 'Xã',
          },
          {
            id: '5592',
            name: 'Hòa Bình',
            prefix: 'Xã',
          },
          {
            id: '5593',
            name: 'Hòa Tiến',
            prefix: 'Xã',
          },
          {
            id: '5594',
            name: 'Hồng An',
            prefix: 'Xã',
          },
          {
            id: '5595',
            name: 'Hồng Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '5596',
            name: 'Hồng Minh',
            prefix: 'Xã',
          },
          {
            id: '5597',
            name: 'Hùng Dũng',
            prefix: 'Xã',
          },
          {
            id: '5598',
            name: 'Hưng Hà',
            prefix: 'Thị trấn',
          },
          {
            id: '5599',
            name: 'Hưng Nhân',
            prefix: 'Thị trấn',
          },
          {
            id: '5600',
            name: 'Kim Chung',
            prefix: 'Xã',
          },
          {
            id: '5601',
            name: 'Liên Hiệp',
            prefix: 'Xã',
          },
          {
            id: '5602',
            name: 'Minh Hòa',
            prefix: 'Xã',
          },
          {
            id: '5603',
            name: 'Minh Khai',
            prefix: 'Xã',
          },
          {
            id: '5604',
            name: 'Minh Tân',
            prefix: 'Xã',
          },
          {
            id: '5605',
            name: 'Phúc Khánh',
            prefix: 'Xã',
          },
          {
            id: '5606',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
          {
            id: '5607',
            name: 'Tân Lễ',
            prefix: 'Xã',
          },
          {
            id: '5608',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '5609',
            name: 'Tây Đô',
            prefix: 'Xã',
          },
          {
            id: '5610',
            name: 'Thái Hưng',
            prefix: 'Xã',
          },
          {
            id: '5611',
            name: 'Thái Phương',
            prefix: 'Xã',
          },
          {
            id: '5612',
            name: 'Thống Nhất',
            prefix: 'Xã',
          },
          {
            id: '5613',
            name: 'Tiến Đức',
            prefix: 'Xã',
          },
          {
            id: '5614',
            name: 'Văn Cẩm',
            prefix: 'Xã',
          },
          {
            id: '5615',
            name: 'Văn Lang',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '361',
        name: 'Kiến Xương',
        wards: [
          {
            id: '5616',
            name: 'An Bình',
            prefix: 'Xã',
          },
          {
            id: '5617',
            name: 'An Bồi',
            prefix: 'Xã',
          },
          {
            id: '5618',
            name: 'Bình Định',
            prefix: 'Xã',
          },
          {
            id: '5619',
            name: 'Bình Minh',
            prefix: 'Xã',
          },
          {
            id: '5620',
            name: 'Bình Nguyên',
            prefix: 'Xã',
          },
          {
            id: '5621',
            name: 'Bình Thanh',
            prefix: 'Xã',
          },
          {
            id: '5622',
            name: 'Đình Phùng',
            prefix: 'Xã',
          },
          {
            id: '5623',
            name: 'Hoà Bình',
            prefix: 'Xã',
          },
          {
            id: '5624',
            name: 'Hồng Thái',
            prefix: 'Xã',
          },
          {
            id: '5625',
            name: 'Hồng Tiến',
            prefix: 'Xã',
          },
          {
            id: '5626',
            name: 'Lê Lợi',
            prefix: 'Xã',
          },
          {
            id: '5627',
            name: 'Minh Hưng',
            prefix: 'Xã',
          },
          {
            id: '5628',
            name: 'Minh Tân',
            prefix: 'Xã',
          },
          {
            id: '5629',
            name: 'Nam Bình',
            prefix: 'Xã',
          },
          {
            id: '5630',
            name: 'Nam Cao',
            prefix: 'Xã',
          },
          {
            id: '5631',
            name: 'Quang Bình',
            prefix: 'Xã',
          },
          {
            id: '5632',
            name: 'Quang Hưng',
            prefix: 'Xã',
          },
          {
            id: '5633',
            name: 'Quang Lịch',
            prefix: 'Xã',
          },
          {
            id: '5634',
            name: 'Quang Minh',
            prefix: 'Xã',
          },
          {
            id: '5635',
            name: 'Quang Trung',
            prefix: 'Xã',
          },
          {
            id: '5636',
            name: 'Quốc Tuấn',
            prefix: 'Xã',
          },
          {
            id: '5637',
            name: 'Quyết Tiến',
            prefix: 'Xã',
          },
          {
            id: '5638',
            name: 'Thanh Nê',
            prefix: 'Thị trấn',
          },
          {
            id: '5639',
            name: 'Thanh Tân',
            prefix: 'Xã',
          },
          {
            id: '5640',
            name: 'Thượng Hiền',
            prefix: 'Xã',
          },
          {
            id: '5641',
            name: 'Trà Giang',
            prefix: 'Xã',
          },
          {
            id: '5642',
            name: 'Vũ An',
            prefix: 'Xã',
          },
          {
            id: '5643',
            name: 'Vũ Bình',
            prefix: 'Xã',
          },
          {
            id: '5644',
            name: 'Vũ Công',
            prefix: 'Xã',
          },
          {
            id: '5645',
            name: 'Vũ Hoà',
            prefix: 'Xã',
          },
          {
            id: '5646',
            name: 'Vũ Lạc',
            prefix: 'Xã',
          },
          {
            id: '5647',
            name: 'Vũ Lễ',
            prefix: 'Xã',
          },
          {
            id: '5648',
            name: 'Vũ Ninh',
            prefix: 'Xã',
          },
          {
            id: '5649',
            name: 'Vũ Quý',
            prefix: 'Thị trấn',
          },
          {
            id: '5650',
            name: 'Vũ Sơn',
            prefix: 'Xã',
          },
          {
            id: '5651',
            name: 'Vũ Tây',
            prefix: 'Xã',
          },
          {
            id: '5652',
            name: 'Vũ Thắng',
            prefix: 'Xã',
          },
          {
            id: '5653',
            name: 'Vũ Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '362',
        name: 'Quỳnh Phụ',
        wards: [
          {
            id: '5654',
            name: 'An Ấp',
            prefix: 'Xã',
          },
          {
            id: '5655',
            name: 'An Bài',
            prefix: 'Thị trấn',
          },
          {
            id: '5656',
            name: 'An Cầu',
            prefix: 'Xã',
          },
          {
            id: '5658',
            name: 'An Dục',
            prefix: 'Xã',
          },
          {
            id: '5657',
            name: 'An Đồng',
            prefix: 'Xã',
          },
          {
            id: '5659',
            name: 'An Hiệp',
            prefix: 'Xã',
          },
          {
            id: '5660',
            name: 'An Khê',
            prefix: 'Xã',
          },
          {
            id: '5661',
            name: 'An Lễ',
            prefix: 'Xã',
          },
          {
            id: '5662',
            name: 'An Mỹ',
            prefix: 'Xã',
          },
          {
            id: '5663',
            name: 'An Ninh',
            prefix: 'Xã',
          },
          {
            id: '5664',
            name: 'An Quý',
            prefix: 'Xã',
          },
          {
            id: '5665',
            name: 'An Thái',
            prefix: 'Xã',
          },
          {
            id: '5666',
            name: 'An Thanh',
            prefix: 'Xã',
          },
          {
            id: '5667',
            name: 'An Tràng',
            prefix: 'Xã',
          },
          {
            id: '5668',
            name: 'An Vinh',
            prefix: 'Xã',
          },
          {
            id: '5669',
            name: 'An Vũ',
            prefix: 'Xã',
          },
          {
            id: '5670',
            name: 'Đông Hải',
            prefix: 'Xã',
          },
          {
            id: '5671',
            name: 'Đồng Tiến',
            prefix: 'Xã',
          },
          {
            id: '5672',
            name: 'Quỳnh Bảo',
            prefix: 'Xã',
          },
          {
            id: '5673',
            name: 'Quỳnh Châu',
            prefix: 'Xã',
          },
          {
            id: '5674',
            name: 'Quỳnh Côi',
            prefix: 'Thị trấn',
          },
          {
            id: '5675',
            name: 'Quỳnh Giao',
            prefix: 'Xã',
          },
          {
            id: '5676',
            name: 'Quỳnh Hải',
            prefix: 'Xã',
          },
          {
            id: '5677',
            name: 'Quỳnh Hoa',
            prefix: 'Xã',
          },
          {
            id: '5678',
            name: 'Quỳnh Hoàng',
            prefix: 'Xã',
          },
          {
            id: '5679',
            name: 'Quỳnh Hội',
            prefix: 'Xã',
          },
          {
            id: '5680',
            name: 'Quỳnh Hồng',
            prefix: 'Xã',
          },
          {
            id: '5681',
            name: 'Quỳnh Hưng',
            prefix: 'Xã',
          },
          {
            id: '5682',
            name: 'Quỳnh Khê',
            prefix: 'Xã',
          },
          {
            id: '5683',
            name: 'Quỳnh Lâm',
            prefix: 'Xã',
          },
          {
            id: '5684',
            name: 'Quỳnh Minh',
            prefix: 'Xã',
          },
          {
            id: '5685',
            name: 'Quỳnh Mỹ',
            prefix: 'Xã',
          },
          {
            id: '5686',
            name: 'Quỳnh Ngọc',
            prefix: 'Xã',
          },
          {
            id: '5687',
            name: 'Quỳnh Nguyên',
            prefix: 'Xã',
          },
          {
            id: '5688',
            name: 'Quỳnh Sơn',
            prefix: 'Xã',
          },
          {
            id: '5689',
            name: 'Quỳnh Thọ',
            prefix: 'Xã',
          },
          {
            id: '5690',
            name: 'Quỳnh Trang',
            prefix: 'Xã',
          },
          {
            id: '5691',
            name: 'Quỳnh Xá',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '363',
        name: 'Thái Bình',
        wards: [
          {
            id: '5692',
            name: 'Bồ Xuyên',
            prefix: 'Phường',
          },
          {
            id: '5693',
            name: 'Đề Thám',
            prefix: 'Phường',
          },
          {
            id: '5694',
            name: 'Đông Hòa',
            prefix: 'Xã',
          },
          {
            id: '5695',
            name: 'Đông Mỹ',
            prefix: 'Xã',
          },
          {
            id: '5696',
            name: 'Đông Thọ',
            prefix: 'Xã',
          },
          {
            id: '5697',
            name: 'Hoàng Diệu',
            prefix: 'Phường',
          },
          {
            id: '5698',
            name: 'Kỳ Bá',
            prefix: 'Phường',
          },
          {
            id: '5699',
            name: 'Lê Hồng Phong',
            prefix: 'Phường',
          },
          {
            id: '5700',
            name: 'Phú Khánh',
            prefix: 'Phường',
          },
          {
            id: '5701',
            name: 'Phú Xuân',
            prefix: 'Xã',
          },
          {
            id: '5702',
            name: 'Quang Trung',
            prefix: 'Phường',
          },
          {
            id: '5703',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '5704',
            name: 'Tiền Phong',
            prefix: 'Phường',
          },
          {
            id: '5705',
            name: 'Trần Hưng Đạo',
            prefix: 'Phường',
          },
          {
            id: '5706',
            name: 'Trần Lãm',
            prefix: 'Phường',
          },
          {
            id: '5707',
            name: 'Vũ Chính',
            prefix: 'Xã',
          },
          {
            id: '5708',
            name: 'Vũ Đông',
            prefix: 'Xã',
          },
          {
            id: '5709',
            name: 'Vũ Lạc',
            prefix: 'Xã',
          },
          {
            id: '5710',
            name: 'Vũ Phúc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '364',
        name: 'Thái Thuỵ',
        wards: [
          {
            id: '5711',
            name: 'Diêm Điền',
            prefix: 'Thị trấn',
          },
          {
            id: '5712',
            name: 'Hồng Quỳnh',
            prefix: 'Xã',
          },
          {
            id: '5713',
            name: 'Mỹ Lộc',
            prefix: 'Xã',
          },
          {
            id: '5714',
            name: 'Thái An',
            prefix: 'Xã',
          },
          {
            id: '5716',
            name: 'Thái Dương',
            prefix: 'Xã',
          },
          {
            id: '5715',
            name: 'Thái Đô',
            prefix: 'Xã',
          },
          {
            id: '5717',
            name: 'Thái Giang',
            prefix: 'Xã',
          },
          {
            id: '5718',
            name: 'Thái Hà',
            prefix: 'Xã',
          },
          {
            id: '5719',
            name: 'Thái Hòa',
            prefix: 'Xã',
          },
          {
            id: '5720',
            name: 'Thái Học',
            prefix: 'Xã',
          },
          {
            id: '5721',
            name: 'Thái Hồng',
            prefix: 'Xã',
          },
          {
            id: '5722',
            name: 'Thái Hưng',
            prefix: 'Xã',
          },
          {
            id: '5723',
            name: 'Thái Nguyên',
            prefix: 'Xã',
          },
          {
            id: '5724',
            name: 'Thái Phúc',
            prefix: 'Xã',
          },
          {
            id: '5725',
            name: 'Thái Sơn',
            prefix: 'Xã',
          },
          {
            id: '5726',
            name: 'Thái Tân',
            prefix: 'Xã',
          },
          {
            id: '5727',
            name: 'Thái Thành',
            prefix: 'Xã',
          },
          {
            id: '5728',
            name: 'Thái Thịnh',
            prefix: 'Xã',
          },
          {
            id: '5729',
            name: 'Thái Thọ',
            prefix: 'Xã',
          },
          {
            id: '5730',
            name: 'Thái Thuần',
            prefix: 'Xã',
          },
          {
            id: '5731',
            name: 'Thái Thượng',
            prefix: 'Xã',
          },
          {
            id: '5732',
            name: 'Thái Thủy',
            prefix: 'Xã',
          },
          {
            id: '5733',
            name: 'Thái Xuyên',
            prefix: 'Xã',
          },
          {
            id: '5734',
            name: 'Thụy An',
            prefix: 'Xã',
          },
          {
            id: '5735',
            name: 'Thụy Bình',
            prefix: 'Xã',
          },
          {
            id: '5736',
            name: 'Thụy Chính',
            prefix: 'Xã',
          },
          {
            id: '5737',
            name: 'Thụy Dân',
            prefix: 'Xã',
          },
          {
            id: '5738',
            name: 'Thụy Dũng',
            prefix: 'Xã',
          },
          {
            id: '5739',
            name: 'Thụy Dương',
            prefix: 'Xã',
          },
          {
            id: '5740',
            name: 'Thụy Duyên',
            prefix: 'Xã',
          },
          {
            id: '5741',
            name: 'Thụy Hà',
            prefix: 'Xã',
          },
          {
            id: '5742',
            name: 'Thụy Hải',
            prefix: 'Xã',
          },
          {
            id: '5743',
            name: 'Thụy Hồng',
            prefix: 'Xã',
          },
          {
            id: '5744',
            name: 'Thụy Hưng',
            prefix: 'Xã',
          },
          {
            id: '5745',
            name: 'Thụy Liên',
            prefix: 'Xã',
          },
          {
            id: '5746',
            name: 'Thụy Lương',
            prefix: 'Xã',
          },
          {
            id: '5747',
            name: 'Thụy Ninh',
            prefix: 'Xã',
          },
          {
            id: '5748',
            name: 'Thụy Phong',
            prefix: 'Xã',
          },
          {
            id: '5749',
            name: 'Thụy Phúc',
            prefix: 'Xã',
          },
          {
            id: '5750',
            name: 'Thụy Quỳnh',
            prefix: 'Xã',
          },
          {
            id: '5751',
            name: 'Thụy Sơn',
            prefix: 'Xã',
          },
          {
            id: '5752',
            name: 'Thụy Tân',
            prefix: 'Xã',
          },
          {
            id: '5753',
            name: 'Thụy Thanh',
            prefix: 'Xã',
          },
          {
            id: '5754',
            name: 'Thụy Trình',
            prefix: 'Xã',
          },
          {
            id: '5755',
            name: 'Thụy Trường',
            prefix: 'Xã',
          },
          {
            id: '5756',
            name: 'Thụy Văn',
            prefix: 'Xã',
          },
          {
            id: '5757',
            name: 'Thụy Việt',
            prefix: 'Xã',
          },
          {
            id: '5758',
            name: 'Thụy Xuân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '365',
        name: 'Tiền Hải',
        wards: [
          {
            id: '5759',
            name: 'An Ninh',
            prefix: 'Xã',
          },
          {
            id: '5760',
            name: 'Bắc Hải',
            prefix: 'Xã',
          },
          {
            id: '5761',
            name: 'Đông Cơ',
            prefix: 'Xã',
          },
          {
            id: '5762',
            name: 'Đông Hải',
            prefix: 'Xã',
          },
          {
            id: '5763',
            name: 'Đông Hoàng',
            prefix: 'Xã',
          },
          {
            id: '5764',
            name: 'Đông Lâm',
            prefix: 'Xã',
          },
          {
            id: '5765',
            name: 'Đông Long',
            prefix: 'Xã',
          },
          {
            id: '5766',
            name: 'Đông Minh',
            prefix: 'Xã',
          },
          {
            id: '5767',
            name: 'Đông Phong',
            prefix: 'Xã',
          },
          {
            id: '5768',
            name: 'Đông Quý',
            prefix: 'Xã',
          },
          {
            id: '5769',
            name: 'Đông Trà',
            prefix: 'Xã',
          },
          {
            id: '5770',
            name: 'Đông Trung',
            prefix: 'Xã',
          },
          {
            id: '5771',
            name: 'Đông Xuyên',
            prefix: 'Xã',
          },
          {
            id: '5772',
            name: 'Nam Chính',
            prefix: 'Xã',
          },
          {
            id: '5773',
            name: 'Nam Cường',
            prefix: 'Xã',
          },
          {
            id: '5774',
            name: 'Nam Hà',
            prefix: 'Xã',
          },
          {
            id: '5775',
            name: 'Nam Hải',
            prefix: 'Xã',
          },
          {
            id: '5776',
            name: 'Nam Hồng',
            prefix: 'Xã',
          },
          {
            id: '5777',
            name: 'Nam Hưng',
            prefix: 'Xã',
          },
          {
            id: '5778',
            name: 'Nam Phú',
            prefix: 'Xã',
          },
          {
            id: '5779',
            name: 'Nam Thắng',
            prefix: 'Xã',
          },
          {
            id: '5780',
            name: 'Nam Thanh',
            prefix: 'Xã',
          },
          {
            id: '5781',
            name: 'Nam Thịnh',
            prefix: 'Xã',
          },
          {
            id: '5782',
            name: 'Nam Trung',
            prefix: 'Xã',
          },
          {
            id: '5783',
            name: 'Phương Công',
            prefix: 'Xã',
          },
          {
            id: '5784',
            name: 'Tây An',
            prefix: 'Xã',
          },
          {
            id: '5785',
            name: 'Tây Giang',
            prefix: 'Xã',
          },
          {
            id: '5786',
            name: 'Tây Lương',
            prefix: 'Xã',
          },
          {
            id: '5787',
            name: 'Tây Ninh',
            prefix: 'Xã',
          },
          {
            id: '5788',
            name: 'Tây Phong',
            prefix: 'Xã',
          },
          {
            id: '5789',
            name: 'Tây Sơn',
            prefix: 'Xã',
          },
          {
            id: '5790',
            name: 'Tây Tiến',
            prefix: 'Xã',
          },
          {
            id: '5791',
            name: 'Tiền Hải',
            prefix: 'Thị trấn',
          },
          {
            id: '5792',
            name: 'Vân Trường',
            prefix: 'Xã',
          },
          {
            id: '5793',
            name: 'Vũ Lăng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '366',
        name: 'Vũ Thư',
        wards: [
          {
            id: '5794',
            name: 'Bách Thuận',
            prefix: 'Xã',
          },
          {
            id: '5796',
            name: 'Dũng Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '5797',
            name: 'Duy Nhất',
            prefix: 'Xã',
          },
          {
            id: '5795',
            name: 'Đồng Thanh',
            prefix: 'Xã',
          },
          {
            id: '5798',
            name: 'Hiệp Hòa',
            prefix: 'Xã',
          },
          {
            id: '5799',
            name: 'Hòa Bình',
            prefix: 'Xã',
          },
          {
            id: '5800',
            name: 'Hồng Lý',
            prefix: 'Xã',
          },
          {
            id: '5801',
            name: 'Hồng Phong',
            prefix: 'Xã',
          },
          {
            id: '5802',
            name: 'Minh Khai',
            prefix: 'Xã',
          },
          {
            id: '5803',
            name: 'Minh Lãng',
            prefix: 'Xã',
          },
          {
            id: '5804',
            name: 'Minh Quang',
            prefix: 'Xã',
          },
          {
            id: '5805',
            name: 'Nguyên Xá',
            prefix: 'Xã',
          },
          {
            id: '5806',
            name: 'Phúc Thành',
            prefix: 'Xã',
          },
          {
            id: '5807',
            name: 'Song An',
            prefix: 'Xã',
          },
          {
            id: '5808',
            name: 'Song Lãng',
            prefix: 'Xã',
          },
          {
            id: '5809',
            name: 'Tam Quang',
            prefix: 'Xã',
          },
          {
            id: '5810',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
          {
            id: '5811',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '5812',
            name: 'Tân Phong',
            prefix: 'Xã',
          },
          {
            id: '5813',
            name: 'Trung An',
            prefix: 'Xã',
          },
          {
            id: '5814',
            name: 'Tự Tân',
            prefix: 'Xã',
          },
          {
            id: '5815',
            name: 'Việt Hùng',
            prefix: 'Xã',
          },
          {
            id: '5816',
            name: 'Việt Thuận',
            prefix: 'Xã',
          },
          {
            id: '5817',
            name: 'Vũ Đoài',
            prefix: 'Xã',
          },
          {
            id: '5818',
            name: 'Vũ Hội',
            prefix: 'Xã',
          },
          {
            id: '5819',
            name: 'Vũ Thư',
            prefix: 'Thị trấn',
          },
          {
            id: '5820',
            name: 'Vũ Tiến',
            prefix: 'Xã',
          },
          {
            id: '5821',
            name: 'Vũ Vân',
            prefix: 'Xã',
          },
          {
            id: '5822',
            name: 'Vũ Vinh',
            prefix: 'Xã',
          },
          {
            id: '5823',
            name: 'Xuân Hòa',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '28',
    code: 'BG',
    name: 'Bắc Giang',
    districts: [
      {
        id: '367',
        name: 'Bắc Giang',
        wards: [
          {
            id: '5825',
            name: 'Dĩnh Kế',
            prefix: 'Xã',
          },
          {
            id: '5826',
            name: 'Dĩnh Trì',
            prefix: 'Xã',
          },
          {
            id: '5824',
            name: 'Đa Mai',
            prefix: 'Xã',
          },
          {
            id: '5827',
            name: 'Đồng Sơn',
            prefix: 'Xã',
          },
          {
            id: '5828',
            name: 'Hoàng Văn Thụ',
            prefix: 'Phường',
          },
          {
            id: '5829',
            name: 'Lê Lợi',
            prefix: 'Phường',
          },
          {
            id: '5830',
            name: 'Mỹ Độ',
            prefix: 'Phường',
          },
          {
            id: '5831',
            name: 'Ngô Quyền',
            prefix: 'Phường',
          },
          {
            id: '5832',
            name: 'Song Khê',
            prefix: 'Xã',
          },
          {
            id: '5833',
            name: 'Song Mai',
            prefix: 'Xã',
          },
          {
            id: '5834',
            name: 'Tân Mỹ',
            prefix: 'Xã',
          },
          {
            id: '5835',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '5836',
            name: 'Thọ Xương',
            prefix: 'Phường',
          },
          {
            id: '5837',
            name: 'Trần Nguyên Hãn',
            prefix: 'Phường',
          },
          {
            id: '5838',
            name: 'Trần Phú',
            prefix: 'Phường',
          },
          {
            id: '5839',
            name: 'Xương Giang',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '368',
        name: 'Hiệp Hòa',
        wards: [
          {
            id: '5840',
            name: 'Bắc Lý',
            prefix: 'Xã',
          },
          {
            id: '5841',
            name: 'Bách Nhẫn',
            prefix: 'Thị trấn',
          },
          {
            id: '5842',
            name: 'Châu Minh',
            prefix: 'Xã',
          },
          {
            id: '5844',
            name: 'Danh Thắng',
            prefix: 'Xã',
          },
          {
            id: '5843',
            name: 'Đại Thành',
            prefix: 'Xã',
          },
          {
            id: '5845',
            name: 'Đoan Bái',
            prefix: 'Xã',
          },
          {
            id: '5846',
            name: 'Đông Lỗ',
            prefix: 'Xã',
          },
          {
            id: '5847',
            name: 'Đồng Tân',
            prefix: 'Xã',
          },
          {
            id: '5848',
            name: 'Đức Thắng',
            prefix: 'Xã',
          },
          {
            id: '5849',
            name: 'Hòa Sơn',
            prefix: 'Xã',
          },
          {
            id: '5850',
            name: 'Hoàng An',
            prefix: 'Xã',
          },
          {
            id: '5851',
            name: 'Hoàng Lương',
            prefix: 'Xã',
          },
          {
            id: '5852',
            name: 'Hoàng Thanh',
            prefix: 'Xã',
          },
          {
            id: '5853',
            name: 'Hoàng Vân',
            prefix: 'Xã',
          },
          {
            id: '5854',
            name: 'Hợp Thịnh',
            prefix: 'Xã',
          },
          {
            id: '5855',
            name: 'Hùng Sơn',
            prefix: 'Xã',
          },
          {
            id: '5856',
            name: 'Hương Lâm',
            prefix: 'Xã',
          },
          {
            id: '5857',
            name: 'Lương Phong',
            prefix: 'Xã',
          },
          {
            id: '5858',
            name: 'Mai Đình',
            prefix: 'Xã',
          },
          {
            id: '5859',
            name: 'Mai Trung',
            prefix: 'Xã',
          },
          {
            id: '5860',
            name: 'Ngọc Sơn',
            prefix: 'Xã',
          },
          {
            id: '5861',
            name: 'Quang Minh',
            prefix: 'Xã',
          },
          {
            id: '5862',
            name: 'Thái Sơn',
            prefix: 'Xã',
          },
          {
            id: '5863',
            name: 'Thắng',
            prefix: 'Thị trấn',
          },
          {
            id: '5864',
            name: 'Thanh Vân',
            prefix: 'Xã',
          },
          {
            id: '5865',
            name: 'Thường Thắng',
            prefix: 'Xã',
          },
          {
            id: '5866',
            name: 'Xuân Cẩm',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '369',
        name: 'Lạng Giang',
        wards: [
          {
            id: '5867',
            name: 'An Hà',
            prefix: 'Xã',
          },
          {
            id: '5870',
            name: 'Dương Đức',
            prefix: 'Xã',
          },
          {
            id: '5868',
            name: 'Đại Lâm',
            prefix: 'Xã',
          },
          {
            id: '5869',
            name: 'Đào Mỹ',
            prefix: 'Xã',
          },
          {
            id: '5871',
            name: 'Hương Lạc',
            prefix: 'Xã',
          },
          {
            id: '5872',
            name: 'Hương Sơn',
            prefix: 'Xã',
          },
          {
            id: '5873',
            name: 'Kép',
            prefix: 'Thị trấn',
          },
          {
            id: '5874',
            name: 'Mỹ Hà',
            prefix: 'Xã',
          },
          {
            id: '5875',
            name: 'Mỹ Thái',
            prefix: 'Xã',
          },
          {
            id: '5876',
            name: 'Nghĩa Hòa',
            prefix: 'Xã',
          },
          {
            id: '5877',
            name: 'Nghĩa Hưng',
            prefix: 'Xã',
          },
          {
            id: '5878',
            name: 'Phi Mô',
            prefix: 'Xã',
          },
          {
            id: '5879',
            name: 'Quang Thịnh',
            prefix: 'Xã',
          },
          {
            id: '5880',
            name: 'Tân Dĩnh',
            prefix: 'Xã',
          },
          {
            id: '5881',
            name: 'Tân Hưng',
            prefix: 'Xã',
          },
          {
            id: '5882',
            name: 'Tân Thanh',
            prefix: 'Xã',
          },
          {
            id: '5883',
            name: 'Tân Thịnh',
            prefix: 'Xã',
          },
          {
            id: '5884',
            name: 'Thái Đào',
            prefix: 'Xã',
          },
          {
            id: '5885',
            name: 'Tiên Lục',
            prefix: 'Xã',
          },
          {
            id: '5886',
            name: 'Vôi',
            prefix: 'Thị trấn',
          },
          {
            id: '5887',
            name: 'Xuân Hương',
            prefix: 'Xã',
          },
          {
            id: '5888',
            name: 'Xương Lâm',
            prefix: 'Xã',
          },
          {
            id: '5889',
            name: 'Yên Mỹ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '370',
        name: 'Lục Nam',
        wards: [
          {
            id: '5890',
            name: 'Bắc Lũng',
            prefix: 'Xã',
          },
          {
            id: '5891',
            name: 'Bảo Đài',
            prefix: 'Xã',
          },
          {
            id: '5892',
            name: 'Bảo Sơn',
            prefix: 'Xã',
          },
          {
            id: '5893',
            name: 'Bình Sơn',
            prefix: 'Xã',
          },
          {
            id: '5894',
            name: 'Cẩm Lý',
            prefix: 'Xã',
          },
          {
            id: '5895',
            name: 'Chu Điện',
            prefix: 'Xã',
          },
          {
            id: '5896',
            name: 'Cương Sơn',
            prefix: 'Xã',
          },
          {
            id: '5897',
            name: 'Đan Hội',
            prefix: 'Xã',
          },
          {
            id: '5898',
            name: 'Đồi Ngô',
            prefix: 'Thị trấn',
          },
          {
            id: '5899',
            name: 'Đông Hưng',
            prefix: 'Xã',
          },
          {
            id: '5900',
            name: 'Đông Phú',
            prefix: 'Xã',
          },
          {
            id: '5901',
            name: 'Huyền Sơn',
            prefix: 'Xã',
          },
          {
            id: '5902',
            name: 'Khám Lạng',
            prefix: 'Xã',
          },
          {
            id: '5903',
            name: 'Lan Mẫu',
            prefix: 'Xã',
          },
          {
            id: '5904',
            name: 'Lục Nam',
            prefix: 'Thị trấn',
          },
          {
            id: '5905',
            name: 'Lục Sơn',
            prefix: 'Xã',
          },
          {
            id: '5906',
            name: 'Nghĩa Phương',
            prefix: 'Xã',
          },
          {
            id: '5907',
            name: 'Phương Sơn',
            prefix: 'Xã',
          },
          {
            id: '5908',
            name: 'Tam Dị',
            prefix: 'Xã',
          },
          {
            id: '5909',
            name: 'Thanh Lâm',
            prefix: 'Xã',
          },
          {
            id: '5910',
            name: 'Tiên Hưng',
            prefix: 'Xã',
          },
          {
            id: '5911',
            name: 'Tiên Nha',
            prefix: 'Xã',
          },
          {
            id: '5912',
            name: 'Trường Giang',
            prefix: 'Xã',
          },
          {
            id: '5913',
            name: 'Trường Sơn',
            prefix: 'Xã',
          },
          {
            id: '5914',
            name: 'Vô Tranh',
            prefix: 'Xã',
          },
          {
            id: '5915',
            name: 'Vũ Xá',
            prefix: 'Xã',
          },
          {
            id: '5916',
            name: 'Yên Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '371',
        name: 'Lục Ngạn',
        wards: [
          {
            id: '5917',
            name: 'Biển Động',
            prefix: 'Xã',
          },
          {
            id: '5918',
            name: 'Biên Sơn',
            prefix: 'Xã',
          },
          {
            id: '5919',
            name: 'Cấm Sơn',
            prefix: 'Xã',
          },
          {
            id: '5920',
            name: 'Chũ',
            prefix: 'Thị trấn',
          },
          {
            id: '5921',
            name: 'Đèo Gia',
            prefix: 'Xã',
          },
          {
            id: '5922',
            name: 'Đồng Cốc',
            prefix: 'Xã',
          },
          {
            id: '5923',
            name: 'Giáp Sơn',
            prefix: 'Xã',
          },
          {
            id: '5924',
            name: 'Hộ Đáp',
            prefix: 'Xã',
          },
          {
            id: '5925',
            name: 'Hồng Giang',
            prefix: 'Xã',
          },
          {
            id: '5926',
            name: 'Kiên Lao',
            prefix: 'Xã',
          },
          {
            id: '5927',
            name: 'Kiên Thành',
            prefix: 'Xã',
          },
          {
            id: '5928',
            name: 'Kim Sơn',
            prefix: 'Xã',
          },
          {
            id: '5929',
            name: 'Mỹ An',
            prefix: 'Xã',
          },
          {
            id: '5930',
            name: 'Nam Dương',
            prefix: 'Xã',
          },
          {
            id: '5931',
            name: 'Nghĩa Hồ',
            prefix: 'Xã',
          },
          {
            id: '5932',
            name: 'Phì Điền',
            prefix: 'Xã',
          },
          {
            id: '5933',
            name: 'Phong Minh',
            prefix: 'Xã',
          },
          {
            id: '5934',
            name: 'Phong Vân',
            prefix: 'Xã',
          },
          {
            id: '5935',
            name: 'Phú Nhuận',
            prefix: 'Xã',
          },
          {
            id: '5936',
            name: 'Phượng Sơn',
            prefix: 'Xã',
          },
          {
            id: '5937',
            name: 'Quý Sơn',
            prefix: 'Xã',
          },
          {
            id: '5938',
            name: 'Sa Lý',
            prefix: 'Xã',
          },
          {
            id: '5939',
            name: 'Sơn Hải',
            prefix: 'Xã',
          },
          {
            id: '5940',
            name: 'Tân Hoa',
            prefix: 'Xã',
          },
          {
            id: '5941',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '5942',
            name: 'Tân Mộc',
            prefix: 'Xã',
          },
          {
            id: '5943',
            name: 'Tân Quang',
            prefix: 'Xã',
          },
          {
            id: '5944',
            name: 'Tân Sơn',
            prefix: 'Xã',
          },
          {
            id: '5945',
            name: 'Thanh Hải',
            prefix: 'Xã',
          },
          {
            id: '5946',
            name: 'Trù Hựu',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '372',
        name: 'Sơn Động',
        wards: [
          {
            id: '5947',
            name: 'An Bá',
            prefix: 'Xã',
          },
          {
            id: '5948',
            name: 'An Châu',
            prefix: 'Thị trấn',
          },
          {
            id: '5949',
            name: 'An Châu',
            prefix: 'Xã',
          },
          {
            id: '5950',
            name: 'An Lạc',
            prefix: 'Xã',
          },
          {
            id: '5951',
            name: 'An Lập',
            prefix: 'Xã',
          },
          {
            id: '5952',
            name: 'Bồng Am',
            prefix: 'Xã',
          },
          {
            id: '5953',
            name: 'Cẩm Đàn',
            prefix: 'Xã',
          },
          {
            id: '5954',
            name: 'Chiên Sơn',
            prefix: 'Xã',
          },
          {
            id: '5955',
            name: 'Dương Hưu',
            prefix: 'Xã',
          },
          {
            id: '5956',
            name: 'Giáo Liêm',
            prefix: 'Xã',
          },
          {
            id: '5957',
            name: 'Hữu Sản',
            prefix: 'Xã',
          },
          {
            id: '5958',
            name: 'Lệ Viễn',
            prefix: 'Xã',
          },
          {
            id: '5959',
            name: 'Long Sơn',
            prefix: 'Xã',
          },
          {
            id: '5960',
            name: 'Ngọc Châu',
            prefix: 'Xã',
          },
          {
            id: '5961',
            name: 'Phúc Thắng',
            prefix: 'Xã',
          },
          {
            id: '5962',
            name: 'Quế Sơn',
            prefix: 'Xã',
          },
          {
            id: '5963',
            name: 'Thạch Sơn',
            prefix: 'Xã',
          },
          {
            id: '5964',
            name: 'Thanh Luận',
            prefix: 'Xã',
          },
          {
            id: '5965',
            name: 'Thanh Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '5966',
            name: 'Tuấn Đạo',
            prefix: 'Xã',
          },
          {
            id: '5967',
            name: 'Tuấn Mậu',
            prefix: 'Xã',
          },
          {
            id: '5968',
            name: 'Vân Sơn',
            prefix: 'Xã',
          },
          {
            id: '5969',
            name: 'Vĩnh Khương',
            prefix: 'Xã',
          },
          {
            id: '5970',
            name: 'Yên Định',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '373',
        name: 'Tân Yên',
        wards: [
          {
            id: '5971',
            name: 'An Dương',
            prefix: 'Xã',
          },
          {
            id: '5972',
            name: 'Cao Thượng',
            prefix: 'Thị trấn',
          },
          {
            id: '5973',
            name: 'Cao Thượng',
            prefix: 'Xã',
          },
          {
            id: '5974',
            name: 'Cao Xá',
            prefix: 'Xã',
          },
          {
            id: '5975',
            name: 'Đại Hóa',
            prefix: 'Xã',
          },
          {
            id: '5976',
            name: 'Hợp Đức',
            prefix: 'Xã',
          },
          {
            id: '5977',
            name: 'Lam Cốt',
            prefix: 'Xã',
          },
          {
            id: '5978',
            name: 'Lan Giới',
            prefix: 'Xã',
          },
          {
            id: '5979',
            name: 'Liên Chung',
            prefix: 'Xã',
          },
          {
            id: '5980',
            name: 'Liên Sơn',
            prefix: 'Xã',
          },
          {
            id: '5981',
            name: 'Ngọc Châu',
            prefix: 'Xã',
          },
          {
            id: '5982',
            name: 'Ngọc Lý',
            prefix: 'Xã',
          },
          {
            id: '5983',
            name: 'Ngọc Thiện',
            prefix: 'Xã',
          },
          {
            id: '5984',
            name: 'Ngọc Vân',
            prefix: 'Xã',
          },
          {
            id: '5985',
            name: 'Nhã Nam',
            prefix: 'Thị trấn',
          },
          {
            id: '5986',
            name: 'Nhã Nam',
            prefix: 'Xã',
          },
          {
            id: '5987',
            name: 'Phúc Hòa',
            prefix: 'Xã',
          },
          {
            id: '5988',
            name: 'Phúc Sơn',
            prefix: 'Xã',
          },
          {
            id: '5989',
            name: 'Quang Tiến',
            prefix: 'Xã',
          },
          {
            id: '5990',
            name: 'Quế Nham',
            prefix: 'Xã',
          },
          {
            id: '5991',
            name: 'Song Vân',
            prefix: 'Xã',
          },
          {
            id: '5992',
            name: 'Tân Trung',
            prefix: 'Xã',
          },
          {
            id: '5993',
            name: 'Việt Lập',
            prefix: 'Xã',
          },
          {
            id: '5994',
            name: 'Việt Ngọc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '374',
        name: 'Việt Yên',
        wards: [
          {
            id: '5995',
            name: 'Bích Động',
            prefix: 'Thị trấn',
          },
          {
            id: '5996',
            name: 'Bích Sơn',
            prefix: 'Xã',
          },
          {
            id: '5997',
            name: 'Hoàng Ninh',
            prefix: 'Xã',
          },
          {
            id: '5998',
            name: 'Hồng Thái',
            prefix: 'Xã',
          },
          {
            id: '5999',
            name: 'Hương Mai',
            prefix: 'Xã',
          },
          {
            id: '6000',
            name: 'Minh Đức',
            prefix: 'Xã',
          },
          {
            id: '6001',
            name: 'Nếnh',
            prefix: 'Thị trấn',
          },
          {
            id: '6002',
            name: 'Nếnh',
            prefix: 'Xã',
          },
          {
            id: '6003',
            name: 'Nghĩa Trung',
            prefix: 'Xã',
          },
          {
            id: '6004',
            name: 'Ninh Sơn',
            prefix: 'Xã',
          },
          {
            id: '6005',
            name: 'Quang Châu',
            prefix: 'Xã',
          },
          {
            id: '6006',
            name: 'Quảng Minh',
            prefix: 'Xã',
          },
          {
            id: '6007',
            name: 'Tăng Tiến',
            prefix: 'Xã',
          },
          {
            id: '6008',
            name: 'Thượng Lan',
            prefix: 'Xã',
          },
          {
            id: '6009',
            name: 'Tiên Sơn',
            prefix: 'Xã',
          },
          {
            id: '6010',
            name: 'Trung Sơn',
            prefix: 'Xã',
          },
          {
            id: '6011',
            name: 'Tự Lan',
            prefix: 'Xã',
          },
          {
            id: '6012',
            name: 'Vân Hà',
            prefix: 'Xã',
          },
          {
            id: '6013',
            name: 'Vân Trung',
            prefix: 'Xã',
          },
          {
            id: '6014',
            name: 'Việt Tiến',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '375',
        name: 'Yên Dũng',
        wards: [
          {
            id: '6015',
            name: 'Cảnh Thụy',
            prefix: 'Xã',
          },
          {
            id: '6016',
            name: 'Đồng Phúc',
            prefix: 'Xã',
          },
          {
            id: '6017',
            name: 'Đồng Tâm',
            prefix: 'Xã',
          },
          {
            id: '6018',
            name: 'Đồng Việt',
            prefix: 'Xã',
          },
          {
            id: '6019',
            name: 'Đức Giang',
            prefix: 'Xã',
          },
          {
            id: '6020',
            name: 'Hồng Kỳ',
            prefix: 'Xã',
          },
          {
            id: '6021',
            name: 'Hương Gián',
            prefix: 'Xã',
          },
          {
            id: '6022',
            name: 'Lãng Sơn',
            prefix: 'Xã',
          },
          {
            id: '6023',
            name: 'Lão Hộ',
            prefix: 'Xã',
          },
          {
            id: '6024',
            name: 'Neo',
            prefix: 'Thị trấn',
          },
          {
            id: '6025',
            name: 'Nham Sơn',
            prefix: 'Xã',
          },
          {
            id: '6026',
            name: 'Nội Hoàng',
            prefix: 'Xã',
          },
          {
            id: '6027',
            name: 'Quỳnh Sơn',
            prefix: 'Xã',
          },
          {
            id: '6028',
            name: 'Tân An',
            prefix: 'Xã',
          },
          {
            id: '6029',
            name: 'Tân Dân',
            prefix: 'Thị trấn',
          },
          {
            id: '6030',
            name: 'Tân Liễu',
            prefix: 'Xã',
          },
          {
            id: '6031',
            name: 'Thắng Cương',
            prefix: 'Xã',
          },
          {
            id: '6032',
            name: 'Tiến Dũng',
            prefix: 'Xã',
          },
          {
            id: '6033',
            name: 'Tiền Phong',
            prefix: 'Xã',
          },
          {
            id: '6034',
            name: 'Trí Yên',
            prefix: 'Xã',
          },
          {
            id: '6035',
            name: 'Tư Mại',
            prefix: 'Xã',
          },
          {
            id: '6036',
            name: 'Xuân Phú',
            prefix: 'Xã',
          },
          {
            id: '6037',
            name: 'Yên Lư',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '376',
        name: 'Yên Thế',
        wards: [
          {
            id: '6038',
            name: 'An Thượng',
            prefix: 'Xã',
          },
          {
            id: '6039',
            name: 'Bố Hạ',
            prefix: 'Thị trấn',
          },
          {
            id: '6040',
            name: 'Bố Hạ',
            prefix: 'Xã',
          },
          {
            id: '6041',
            name: 'Canh Nậu',
            prefix: 'Xã',
          },
          {
            id: '6042',
            name: 'Cầu Gồ',
            prefix: 'Thị trấn',
          },
          {
            id: '6043',
            name: 'Đồng Hưu',
            prefix: 'Xã',
          },
          {
            id: '6044',
            name: 'Đồng Kỳ',
            prefix: 'Xã',
          },
          {
            id: '6045',
            name: 'Đồng Lạc',
            prefix: 'Xã',
          },
          {
            id: '6046',
            name: 'Đông Sơn',
            prefix: 'Xã',
          },
          {
            id: '6047',
            name: 'Đồng Tiến',
            prefix: 'Xã',
          },
          {
            id: '6048',
            name: 'Đồng Vương',
            prefix: 'Xã',
          },
          {
            id: '6049',
            name: 'Hương Vĩ',
            prefix: 'Thị trấn',
          },
          {
            id: '6050',
            name: 'Phồn Xương',
            prefix: 'Xã',
          },
          {
            id: '6051',
            name: 'Tam Hiệp',
            prefix: 'Xã',
          },
          {
            id: '6052',
            name: 'Tam Tiến',
            prefix: 'Xã',
          },
          {
            id: '6053',
            name: 'Tân Hiệp',
            prefix: 'Xã',
          },
          {
            id: '6054',
            name: 'Tân Sỏi',
            prefix: 'Xã',
          },
          {
            id: '6055',
            name: 'Tiến Thắng',
            prefix: 'Xã',
          },
          {
            id: '6056',
            name: 'Xuân Lương',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '29',
    code: 'HB',
    name: 'Hòa Bình',
    districts: [
      {
        id: '377',
        name: 'Cao Phong',
        wards: [
          {
            id: '6057',
            name: 'Bắc Phong',
            prefix: 'Xã',
          },
          {
            id: '6058',
            name: 'Bình Thanh',
            prefix: 'Xã',
          },
          {
            id: '6059',
            name: 'Cao Phong',
            prefix: 'Thị trấn',
          },
          {
            id: '6061',
            name: 'Dũng Phong',
            prefix: 'Xã',
          },
          {
            id: '6060',
            name: 'Đông Phong',
            prefix: 'Xã',
          },
          {
            id: '6062',
            name: 'Nam Phong',
            prefix: 'Xã',
          },
          {
            id: '6063',
            name: 'Tân Phong',
            prefix: 'Xã',
          },
          {
            id: '6064',
            name: 'Tây Phong',
            prefix: 'Xã',
          },
          {
            id: '6065',
            name: 'Thu Phong',
            prefix: 'Xã',
          },
          {
            id: '6066',
            name: 'Thung Nai',
            prefix: 'Xã',
          },
          {
            id: '6067',
            name: 'Xuân Phong',
            prefix: 'Xã',
          },
          {
            id: '6068',
            name: 'Yên Lập',
            prefix: 'Xã',
          },
          {
            id: '6069',
            name: 'Yên Thượng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '378',
        name: 'Đà Bắc',
        wards: [
          {
            id: '6070',
            name: 'Cao Sơn',
            prefix: 'Xã',
          },
          {
            id: '6071',
            name: 'Đà Bắc',
            prefix: 'Thị trấn',
          },
          {
            id: '6072',
            name: 'Đoàn Kết',
            prefix: 'Xã',
          },
          {
            id: '6073',
            name: 'Đồng Chum',
            prefix: 'Xã',
          },
          {
            id: '6074',
            name: 'Đồng Nghê',
            prefix: 'Xã',
          },
          {
            id: '6075',
            name: 'Đồng Ruộng',
            prefix: 'Xã',
          },
          {
            id: '6076',
            name: 'Giáp Đắt',
            prefix: 'Xã',
          },
          {
            id: '6077',
            name: 'Hào Lý',
            prefix: 'Xã',
          },
          {
            id: '6078',
            name: 'Hiền Lương',
            prefix: 'Xã',
          },
          {
            id: '6079',
            name: 'Mường Chiềng',
            prefix: 'Xã',
          },
          {
            id: '6080',
            name: 'Mường Tuổng',
            prefix: 'Xã',
          },
          {
            id: '6081',
            name: 'Suối Nánh',
            prefix: 'Xã',
          },
          {
            id: '6082',
            name: 'Tân Minh',
            prefix: 'Xã',
          },
          {
            id: '6083',
            name: 'Tân Pheo',
            prefix: 'Xã',
          },
          {
            id: '6084',
            name: 'Tiền Phong',
            prefix: 'Xã',
          },
          {
            id: '6085',
            name: 'Toàn Sơn',
            prefix: 'Xã',
          },
          {
            id: '6086',
            name: 'Trung Thành',
            prefix: 'Xã',
          },
          {
            id: '6087',
            name: 'Tu Lý',
            prefix: 'Xã',
          },
          {
            id: '6088',
            name: 'Vầy Nưa',
            prefix: 'Xã',
          },
          {
            id: '6089',
            name: 'Yên Hoà',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '379',
        name: 'Hòa Bình',
        wards: [
          {
            id: '6090',
            name: 'Chăm Mát',
            prefix: 'Phường',
          },
          {
            id: '6091',
            name: 'Dân Chủ',
            prefix: 'Xã',
          },
          {
            id: '6092',
            name: 'Đồng Tiến',
            prefix: 'Phường',
          },
          {
            id: '6093',
            name: 'Hòa Bình',
            prefix: 'Xã',
          },
          {
            id: '6094',
            name: 'Hữu Nghị',
            prefix: 'Phường',
          },
          {
            id: '6095',
            name: 'Phương Lâm',
            prefix: 'Phường',
          },
          {
            id: '6096',
            name: 'Sủ Ngòi',
            prefix: 'Xã',
          },
          {
            id: '6097',
            name: 'Tân Hòa',
            prefix: 'Phường',
          },
          {
            id: '6098',
            name: 'Tân Thịnh',
            prefix: 'Phường',
          },
          {
            id: '6099',
            name: 'Thái Bình',
            prefix: 'Phường',
          },
          {
            id: '6100',
            name: 'Thái Thịnh',
            prefix: 'Xã',
          },
          {
            id: '6101',
            name: 'Thịnh Lang',
            prefix: 'Phường',
          },
          {
            id: '6102',
            name: 'Thống Nhất',
            prefix: 'Xã',
          },
          {
            id: '6103',
            name: 'Trung Minh',
            prefix: 'Xã',
          },
          {
            id: '6104',
            name: 'Yên Mông',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '380',
        name: 'Kim Bôi',
        wards: [
          {
            id: '6105',
            name: 'Bắc Sơn',
            prefix: 'Xã',
          },
          {
            id: '6106',
            name: 'Bình Sơn',
            prefix: 'Xã',
          },
          {
            id: '6107',
            name: 'Bo',
            prefix: 'Thị trấn',
          },
          {
            id: '6108',
            name: 'Cuối Hạ',
            prefix: 'Xã',
          },
          {
            id: '6109',
            name: 'Đông Bắc',
            prefix: 'Xã',
          },
          {
            id: '6110',
            name: 'Đú Sáng',
            prefix: 'Xã',
          },
          {
            id: '6111',
            name: 'Hạ Bì',
            prefix: 'Xã',
          },
          {
            id: '6112',
            name: 'Hợp Đồng',
            prefix: 'Xã',
          },
          {
            id: '6113',
            name: 'Hợp Kim',
            prefix: 'Xã',
          },
          {
            id: '6114',
            name: 'Hùng Tiến',
            prefix: 'Xã',
          },
          {
            id: '6115',
            name: 'Kim Bình',
            prefix: 'Xã',
          },
          {
            id: '6116',
            name: 'Kim Bôi',
            prefix: 'Xã',
          },
          {
            id: '6117',
            name: 'Kim Sơn',
            prefix: 'Xã',
          },
          {
            id: '6118',
            name: 'Kim Tiến',
            prefix: 'Xã',
          },
          {
            id: '6119',
            name: 'Kim Truy',
            prefix: 'Xã',
          },
          {
            id: '6120',
            name: 'Lập Chiệng',
            prefix: 'Xã',
          },
          {
            id: '6121',
            name: 'Mị Hòa',
            prefix: 'Xã',
          },
          {
            id: '6122',
            name: 'Nam Thượng',
            prefix: 'Xã',
          },
          {
            id: '6123',
            name: 'Nật Sơn',
            prefix: 'Xã',
          },
          {
            id: '6124',
            name: 'Nuông Dăm',
            prefix: 'Xã',
          },
          {
            id: '6125',
            name: 'Sào Báy',
            prefix: 'Xã',
          },
          {
            id: '6126',
            name: 'Sơn Thủy',
            prefix: 'Xã',
          },
          {
            id: '6127',
            name: 'Thượng Bì',
            prefix: 'Xã',
          },
          {
            id: '6128',
            name: 'Thượng Tiến',
            prefix: 'Xã',
          },
          {
            id: '6129',
            name: 'Trung Bì',
            prefix: 'Xã',
          },
          {
            id: '6130',
            name: 'Tú Sơn',
            prefix: 'Xã',
          },
          {
            id: '6131',
            name: 'Vĩnh Đồng',
            prefix: 'Xã',
          },
          {
            id: '6132',
            name: 'Vĩnh Tiến',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '381',
        name: 'Kỳ Sơn',
        wards: [
          {
            id: '6133',
            name: 'Dân Hạ',
            prefix: 'Xã',
          },
          {
            id: '6134',
            name: 'Dân Hòa',
            prefix: 'Xã',
          },
          {
            id: '6135',
            name: 'Độc Lập',
            prefix: 'Xã',
          },
          {
            id: '6136',
            name: 'Hợp Thành',
            prefix: 'Xã',
          },
          {
            id: '6137',
            name: 'Hợp Thịnh',
            prefix: 'Xã',
          },
          {
            id: '6138',
            name: 'Kỳ Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '6139',
            name: 'Mông Hóa',
            prefix: 'Xã',
          },
          {
            id: '6140',
            name: 'Phú Minh',
            prefix: 'Xã',
          },
          {
            id: '6141',
            name: 'Phúc Tiến',
            prefix: 'Xã',
          },
          {
            id: '6142',
            name: 'Yên Quang',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '382',
        name: 'Lạc Sơn',
        wards: [
          {
            id: '6143',
            name: 'Ân Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '6144',
            name: 'Bình Cảng',
            prefix: 'Xã',
          },
          {
            id: '6145',
            name: 'Bình Chân',
            prefix: 'Xã',
          },
          {
            id: '6146',
            name: 'Bình Hẻm',
            prefix: 'Xã',
          },
          {
            id: '6147',
            name: 'Chí Đạo',
            prefix: 'Xã',
          },
          {
            id: '6148',
            name: 'Chí Thiện',
            prefix: 'Xã',
          },
          {
            id: '6149',
            name: 'Định Cư',
            prefix: 'Xã',
          },
          {
            id: '6150',
            name: 'Hương Nhượng',
            prefix: 'Xã',
          },
          {
            id: '6151',
            name: 'Liên Vũ',
            prefix: 'Xã',
          },
          {
            id: '6152',
            name: 'Miền Đồi',
            prefix: 'Xã',
          },
          {
            id: '6153',
            name: 'Mỹ Thành',
            prefix: 'Xã',
          },
          {
            id: '6154',
            name: 'Ngọc Lâu',
            prefix: 'Xã',
          },
          {
            id: '6155',
            name: 'Ngọc Sơn',
            prefix: 'Xã',
          },
          {
            id: '6156',
            name: 'Nhân Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '6157',
            name: 'Phú Lương',
            prefix: 'Xã',
          },
          {
            id: '6158',
            name: 'Phúc Tuy',
            prefix: 'Xã',
          },
          {
            id: '6159',
            name: 'Quý Hoà',
            prefix: 'Xã',
          },
          {
            id: '6160',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '6161',
            name: 'Tân Mỹ',
            prefix: 'Xã',
          },
          {
            id: '6162',
            name: 'Thượng Cốc',
            prefix: 'Xã',
          },
          {
            id: '6163',
            name: 'Tự Do',
            prefix: 'Xã',
          },
          {
            id: '6164',
            name: 'Tuân Đạo',
            prefix: 'Xã',
          },
          {
            id: '6165',
            name: 'Văn Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '6166',
            name: 'Văn Sơn',
            prefix: 'Xã',
          },
          {
            id: '6167',
            name: 'Vụ Bản',
            prefix: 'Thị trấn',
          },
          {
            id: '6168',
            name: 'Vũ Lâm',
            prefix: 'Xã',
          },
          {
            id: '6169',
            name: 'Xuất Hóa',
            prefix: 'Xã',
          },
          {
            id: '6170',
            name: 'Yên Nghiệp',
            prefix: 'Xã',
          },
          {
            id: '6171',
            name: 'Yên Phú',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '383',
        name: 'Lạc Thủy',
        wards: [
          {
            id: '6172',
            name: 'An Bình',
            prefix: 'Xã',
          },
          {
            id: '6173',
            name: 'An Lạc',
            prefix: 'Xã',
          },
          {
            id: '6174',
            name: 'Chi Nê',
            prefix: 'Thị trấn',
          },
          {
            id: '6175',
            name: 'Cố Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '6176',
            name: 'Đồng Môn',
            prefix: 'Xã',
          },
          {
            id: '6177',
            name: 'Đồng Tâm',
            prefix: 'Xã',
          },
          {
            id: '6178',
            name: 'Hưng Thi',
            prefix: 'Xã',
          },
          {
            id: '6179',
            name: 'Khoan Dụ',
            prefix: 'Xã',
          },
          {
            id: '6180',
            name: 'Lạc Long',
            prefix: 'Xã',
          },
          {
            id: '6181',
            name: 'Liên Hòa',
            prefix: 'Xã',
          },
          {
            id: '6182',
            name: 'Phú Lão',
            prefix: 'Xã',
          },
          {
            id: '6183',
            name: 'Phú Thành',
            prefix: 'Xã',
          },
          {
            id: '6184',
            name: 'Thanh Hà',
            prefix: 'Thị trấn',
          },
          {
            id: '6185',
            name: 'Thanh Nông',
            prefix: 'Xã',
          },
          {
            id: '6186',
            name: 'Yên Bồng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '384',
        name: 'Lương Sơn',
        wards: [
          {
            id: '6187',
            name: 'Cao Dương',
            prefix: 'Xã',
          },
          {
            id: '6188',
            name: 'Cao Răm',
            prefix: 'Xã',
          },
          {
            id: '6189',
            name: 'Cao Thắng',
            prefix: 'Xã',
          },
          {
            id: '6190',
            name: 'Cư Yên',
            prefix: 'Xã',
          },
          {
            id: '6191',
            name: 'Hoà Hợp',
            prefix: 'Xã',
          },
          {
            id: '6192',
            name: 'Hòa Sơn',
            prefix: 'Xã',
          },
          {
            id: '6193',
            name: 'Hợp Châu',
            prefix: 'Xã',
          },
          {
            id: '6194',
            name: 'Hợp Hòa',
            prefix: 'Xã',
          },
          {
            id: '6195',
            name: 'Hợp Thanh',
            prefix: 'Xã',
          },
          {
            id: '6196',
            name: 'Lâm Sơn',
            prefix: 'Xã',
          },
          {
            id: '6197',
            name: 'Liên Sơn',
            prefix: 'Xã',
          },
          {
            id: '6198',
            name: 'Long Sơn',
            prefix: 'Xã',
          },
          {
            id: '6199',
            name: 'Lương Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '6200',
            name: 'Nhuận Trạch',
            prefix: 'Xã',
          },
          {
            id: '6201',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '6202',
            name: 'Tân Vinh',
            prefix: 'Xã',
          },
          {
            id: '6203',
            name: 'Thành Lập',
            prefix: 'Xã',
          },
          {
            id: '6204',
            name: 'Thanh Lương',
            prefix: 'Xã',
          },
          {
            id: '6205',
            name: 'Tiến Sơn',
            prefix: 'Xã',
          },
          {
            id: '6206',
            name: 'Trung Sơn',
            prefix: 'Xã',
          },
          {
            id: '6207',
            name: 'Trường Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '385',
        name: 'Mai Châu',
        wards: [
          {
            id: '6208',
            name: 'Ba Khan',
            prefix: 'Xã',
          },
          {
            id: '6209',
            name: 'Bao La',
            prefix: 'Xã',
          },
          {
            id: '6210',
            name: 'Chiềng Châu',
            prefix: 'Xã',
          },
          {
            id: '6211',
            name: 'Cun Pheo',
            prefix: 'Xã',
          },
          {
            id: '6212',
            name: 'Đồng Bảng',
            prefix: 'Xã',
          },
          {
            id: '6213',
            name: 'Hang Kia',
            prefix: 'Xã',
          },
          {
            id: '6214',
            name: 'Mai Châu',
            prefix: 'Thị trấn',
          },
          {
            id: '6215',
            name: 'Mai Hạ',
            prefix: 'Xã',
          },
          {
            id: '6216',
            name: 'Mai Hịch',
            prefix: 'Xã',
          },
          {
            id: '6217',
            name: 'Nà Mèo',
            prefix: 'Xã',
          },
          {
            id: '6218',
            name: 'Nà Phòn',
            prefix: 'Xã',
          },
          {
            id: '6219',
            name: 'Noong Luông',
            prefix: 'Xã',
          },
          {
            id: '6220',
            name: 'Pà Cò',
            prefix: 'Xã',
          },
          {
            id: '6221',
            name: 'Phúc Sạn',
            prefix: 'Xã',
          },
          {
            id: '6222',
            name: 'Piềng Vế',
            prefix: 'Xã',
          },
          {
            id: '6223',
            name: 'Pù Pin',
            prefix: 'Xã',
          },
          {
            id: '6224',
            name: 'Tân Dân',
            prefix: 'Xã',
          },
          {
            id: '6225',
            name: 'Tân Mai',
            prefix: 'Xã',
          },
          {
            id: '6226',
            name: 'Tân Sơn',
            prefix: 'Xã',
          },
          {
            id: '6227',
            name: 'Thung Khe',
            prefix: 'Xã',
          },
          {
            id: '6228',
            name: 'Tòng Đậu',
            prefix: 'Xã',
          },
          {
            id: '6229',
            name: 'Vạn Mai',
            prefix: 'Xã',
          },
          {
            id: '6230',
            name: 'Xăm Khòe',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '386',
        name: 'Tân Lạc',
        wards: [
          {
            id: '6231',
            name: 'Bắc Sơn',
            prefix: 'Xã',
          },
          {
            id: '6233',
            name: 'Do Nhân',
            prefix: 'Xã',
          },
          {
            id: '6232',
            name: 'Địch Giáo',
            prefix: 'Xã',
          },
          {
            id: '6234',
            name: 'Đông Lai',
            prefix: 'Xã',
          },
          {
            id: '6235',
            name: 'Gia Mô',
            prefix: 'Xã',
          },
          {
            id: '6236',
            name: 'Lỗ Sơn',
            prefix: 'Xã',
          },
          {
            id: '6237',
            name: 'Lũng Vân',
            prefix: 'Xã',
          },
          {
            id: '6238',
            name: 'Mãn Đức',
            prefix: 'Xã',
          },
          {
            id: '6239',
            name: 'Mường Khến',
            prefix: 'Thị trấn',
          },
          {
            id: '6240',
            name: 'Mỹ Hoà',
            prefix: 'Xã',
          },
          {
            id: '6241',
            name: 'Nam Sơn',
            prefix: 'Xã',
          },
          {
            id: '6242',
            name: 'Ngổ Luông',
            prefix: 'Xã',
          },
          {
            id: '6243',
            name: 'Ngọc Mỹ',
            prefix: 'Xã',
          },
          {
            id: '6244',
            name: 'Ngòi Hoa',
            prefix: 'Xã',
          },
          {
            id: '6245',
            name: 'Phong Phú',
            prefix: 'Xã',
          },
          {
            id: '6246',
            name: 'Phú Cường',
            prefix: 'Xã',
          },
          {
            id: '6247',
            name: 'Phú Vinh',
            prefix: 'Xã',
          },
          {
            id: '6248',
            name: 'Quy Hậu',
            prefix: 'Xã',
          },
          {
            id: '6249',
            name: 'Quy Mỹ',
            prefix: 'Xã',
          },
          {
            id: '6250',
            name: 'Quyết Chiến',
            prefix: 'Xã',
          },
          {
            id: '6251',
            name: 'Thanh Hối',
            prefix: 'Xã',
          },
          {
            id: '6252',
            name: 'Trung Hoà',
            prefix: 'Xã',
          },
          {
            id: '6253',
            name: 'Tử Nê',
            prefix: 'Xã',
          },
          {
            id: '6254',
            name: 'Tuân Lộ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '387',
        name: 'Yên Thủy',
        wards: [
          {
            id: '6255',
            name: 'Bảo Hiệu',
            prefix: 'Xã',
          },
          {
            id: '6256',
            name: 'Đa Phúc',
            prefix: 'Xã',
          },
          {
            id: '6257',
            name: 'Đoàn Kết',
            prefix: 'Xã',
          },
          {
            id: '6258',
            name: 'Hàng Trạm',
            prefix: 'Thị trấn',
          },
          {
            id: '6259',
            name: 'Hữu Lợi',
            prefix: 'Xã',
          },
          {
            id: '6260',
            name: 'Lạc Hưng',
            prefix: 'Xã',
          },
          {
            id: '6261',
            name: 'Lạc Lương',
            prefix: 'Xã',
          },
          {
            id: '6262',
            name: 'Lạc Sỹ',
            prefix: 'Xã',
          },
          {
            id: '6263',
            name: 'Lạc Thịnh',
            prefix: 'Xã',
          },
          {
            id: '6264',
            name: 'Ngọc Lương',
            prefix: 'Xã',
          },
          {
            id: '6265',
            name: 'Phú Lai',
            prefix: 'Xã',
          },
          {
            id: '6266',
            name: 'Yên Lạc',
            prefix: 'Xã',
          },
          {
            id: '6267',
            name: 'Yên Trị',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '30',
    code: 'AG',
    name: 'An Giang',
    districts: [
      {
        id: '388',
        name: 'An Phú',
        wards: [
          {
            id: '6268',
            name: 'An Phú',
            prefix: 'Thị trấn',
          },
          {
            id: '6269',
            name: 'Đa Phước',
            prefix: 'Xã',
          },
          {
            id: '6270',
            name: 'Khánh An',
            prefix: 'Xã',
          },
          {
            id: '6271',
            name: 'Khánh Bình',
            prefix: 'Xã',
          },
          {
            id: '6272',
            name: 'Long Bình',
            prefix: 'Thị trấn',
          },
          {
            id: '6273',
            name: 'Nhơn Hội',
            prefix: 'Xã',
          },
          {
            id: '6274',
            name: 'Phú Hội',
            prefix: 'Xã',
          },
          {
            id: '6275',
            name: 'Phú Hữu',
            prefix: 'Xã',
          },
          {
            id: '6276',
            name: 'Phước Hưng',
            prefix: 'Xã',
          },
          {
            id: '6277',
            name: 'Quốc Thái',
            prefix: 'Xã',
          },
          {
            id: '6278',
            name: 'Vĩnh Hậu',
            prefix: 'Xã',
          },
          {
            id: '6279',
            name: 'Vĩnh Hội Đông',
            prefix: 'Xã',
          },
          {
            id: '6280',
            name: 'Vĩnh Lộc',
            prefix: 'Xã',
          },
          {
            id: '6281',
            name: 'Vĩnh Trường',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '389',
        name: 'Châu Đốc',
        wards: [
          {
            id: '6282',
            name: 'Châu Phú A',
            prefix: 'Phường',
          },
          {
            id: '6283',
            name: 'Châu Phú B',
            prefix: 'Phường',
          },
          {
            id: '6284',
            name: 'Núi Sam',
            prefix: 'Phường',
          },
          {
            id: '6285',
            name: 'Vĩnh Châu',
            prefix: 'Xã',
          },
          {
            id: '6286',
            name: 'Vĩnh Mỹ',
            prefix: 'Phường',
          },
          {
            id: '6287',
            name: 'Vĩnh Ngươn',
            prefix: 'Xã',
          },
          {
            id: '6288',
            name: 'Vĩnh Tế',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '390',
        name: 'Châu Phú',
        wards: [
          {
            id: '6289',
            name: 'Bình Chánh',
            prefix: 'Xã',
          },
          {
            id: '6290',
            name: 'Bình Long',
            prefix: 'Xã',
          },
          {
            id: '6291',
            name: 'Bình Mỹ',
            prefix: 'Xã',
          },
          {
            id: '6292',
            name: 'Bình Phú',
            prefix: 'Xã',
          },
          {
            id: '6293',
            name: 'Bình Thủy',
            prefix: 'Xã',
          },
          {
            id: '6294',
            name: 'Cái Dầu',
            prefix: 'Thị trấn',
          },
          {
            id: '6295',
            name: 'Đạo Hữu Cảnh',
            prefix: 'Xã',
          },
          {
            id: '6296',
            name: 'Khánh Hòa',
            prefix: 'Xã',
          },
          {
            id: '6297',
            name: 'Mỹ Đức',
            prefix: 'Xã',
          },
          {
            id: '6298',
            name: 'Mỹ Phú',
            prefix: 'Xã',
          },
          {
            id: '6299',
            name: 'Ô Long Vĩ',
            prefix: 'Xã',
          },
          {
            id: '6300',
            name: 'Thạnh Mỹ Tây',
            prefix: 'Xã',
          },
          {
            id: '6301',
            name: 'Vĩnh Thạnh Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '391',
        name: 'Châu Thành',
        wards: [
          {
            id: '6302',
            name: 'An Châu',
            prefix: 'Thị trấn',
          },
          {
            id: '6303',
            name: 'An Hòa',
            prefix: 'Xã',
          },
          {
            id: '6304',
            name: 'Bình Hòa',
            prefix: 'Xã',
          },
          {
            id: '6305',
            name: 'Bình Thạnh',
            prefix: 'Xã',
          },
          {
            id: '6306',
            name: 'Cần Đăng',
            prefix: 'Xã',
          },
          {
            id: '6307',
            name: 'Hòa Bình Thạnh',
            prefix: 'Xã',
          },
          {
            id: '6308',
            name: 'Tân Phú',
            prefix: 'Xã',
          },
          {
            id: '6309',
            name: 'Vĩnh An',
            prefix: 'Xã',
          },
          {
            id: '6310',
            name: 'Vĩnh Bình',
            prefix: 'Xã',
          },
          {
            id: '6311',
            name: 'Vĩnh Hanh',
            prefix: 'Xã',
          },
          {
            id: '6312',
            name: 'Vĩnh Lợi',
            prefix: 'Xã',
          },
          {
            id: '6313',
            name: 'Vĩnh Nhuận',
            prefix: 'Xã',
          },
          {
            id: '6314',
            name: 'Vĩnh Thành',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '392',
        name: 'Chợ Mới',
        wards: [
          {
            id: '6315',
            name: 'An Thạnh Trung',
            prefix: 'Xã',
          },
          {
            id: '6316',
            name: 'Bình Phước Xuân',
            prefix: 'Xã',
          },
          {
            id: '6317',
            name: 'Chợ Mới',
            prefix: 'Thị trấn',
          },
          {
            id: '6318',
            name: 'Hòa An',
            prefix: 'Xã',
          },
          {
            id: '6319',
            name: 'Hòa Bình',
            prefix: 'Xã',
          },
          {
            id: '6320',
            name: 'Hội An',
            prefix: 'Xã',
          },
          {
            id: '6321',
            name: 'Kiến An',
            prefix: 'Xã',
          },
          {
            id: '6322',
            name: 'Kiến Thành',
            prefix: 'Xã',
          },
          {
            id: '6323',
            name: 'Long Điền A',
            prefix: 'Xã',
          },
          {
            id: '6324',
            name: 'Long Điền B',
            prefix: 'Xã',
          },
          {
            id: '6325',
            name: 'Long Giang',
            prefix: 'Xã',
          },
          {
            id: '6326',
            name: 'Long Kiến',
            prefix: 'Xã',
          },
          {
            id: '6327',
            name: 'Mỹ An',
            prefix: 'Xã',
          },
          {
            id: '6328',
            name: 'Mỹ Hiệp',
            prefix: 'Xã',
          },
          {
            id: '6329',
            name: 'Mỹ Hội Đông',
            prefix: 'Xã',
          },
          {
            id: '6330',
            name: 'Mỹ Luông',
            prefix: 'Thị trấn',
          },
          {
            id: '6331',
            name: 'Nhơn Mỹ',
            prefix: 'Xã',
          },
          {
            id: '6332',
            name: 'Tấn Mỹ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '393',
        name: 'Long Xuyên',
        wards: [
          {
            id: '6333',
            name: 'Bình Đức',
            prefix: 'Phường',
          },
          {
            id: '6334',
            name: 'Bình Khánh',
            prefix: 'Phường',
          },
          {
            id: '6335',
            name: 'Đông Xuyên',
            prefix: 'Phường',
          },
          {
            id: '6336',
            name: 'Mỹ Bình',
            prefix: 'Phường',
          },
          {
            id: '6337',
            name: 'Mỹ Hòa',
            prefix: 'Phường',
          },
          {
            id: '6338',
            name: 'Mỹ Hòa Hưng',
            prefix: 'Xã',
          },
          {
            id: '6339',
            name: 'Mỹ Khánh',
            prefix: 'Xã',
          },
          {
            id: '6340',
            name: 'Mỹ Long',
            prefix: 'Phường',
          },
          {
            id: '6341',
            name: 'Mỹ Phước',
            prefix: 'Phường',
          },
          {
            id: '6342',
            name: 'Mỹ Quý',
            prefix: 'Phường',
          },
          {
            id: '6343',
            name: 'Mỹ Thạnh',
            prefix: 'Phường',
          },
          {
            id: '6344',
            name: 'Mỹ Thới',
            prefix: 'Phường',
          },
          {
            id: '6345',
            name: 'Mỹ Xuyên',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '394',
        name: 'Phú Tân',
        wards: [
          {
            id: '6346',
            name: 'Bình Thạnh Đông',
            prefix: 'Xã',
          },
          {
            id: '6347',
            name: 'Chợ Vàm',
            prefix: 'Thị trấn',
          },
          {
            id: '6348',
            name: 'Hiệp Xương',
            prefix: 'Xã',
          },
          {
            id: '6349',
            name: 'Hòa Lạc',
            prefix: 'Xã',
          },
          {
            id: '6350',
            name: 'Long Hòa',
            prefix: 'Xã',
          },
          {
            id: '6351',
            name: 'Phú An',
            prefix: 'Xã',
          },
          {
            id: '6352',
            name: 'Phú Bình',
            prefix: 'Xã',
          },
          {
            id: '6353',
            name: 'Phú Hiệp',
            prefix: 'Xã',
          },
          {
            id: '6354',
            name: 'Phú Hưng',
            prefix: 'Xã',
          },
          {
            id: '6355',
            name: 'Phú Lâm',
            prefix: 'Xã',
          },
          {
            id: '6356',
            name: 'Phú Long',
            prefix: 'Xã',
          },
          {
            id: '6357',
            name: 'Phú Mỹ',
            prefix: 'Thị trấn',
          },
          {
            id: '6358',
            name: 'Phú Thành',
            prefix: 'Xã',
          },
          {
            id: '6359',
            name: 'Phú Thạnh',
            prefix: 'Xã',
          },
          {
            id: '6360',
            name: 'Phú Thọ',
            prefix: 'Xã',
          },
          {
            id: '6361',
            name: 'Phú Xuân',
            prefix: 'Xã',
          },
          {
            id: '6362',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
          {
            id: '6363',
            name: 'Tân Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '395',
        name: 'Tân Châu',
        wards: [
          {
            id: '6364',
            name: 'Châu Phong',
            prefix: 'Xã',
          },
          {
            id: '6365',
            name: 'Lê Chánh',
            prefix: 'Xã',
          },
          {
            id: '6366',
            name: 'Long An',
            prefix: 'Xã',
          },
          {
            id: '6367',
            name: 'Long Châu',
            prefix: 'Phường',
          },
          {
            id: '6368',
            name: 'Long Hưng',
            prefix: 'Phường',
          },
          {
            id: '6369',
            name: 'Long Phú',
            prefix: 'Phường',
          },
          {
            id: '6370',
            name: 'Long Sơn',
            prefix: 'Phường',
          },
          {
            id: '6371',
            name: 'Long Thạnh',
            prefix: 'Phường',
          },
          {
            id: '6372',
            name: 'Phú Lộc',
            prefix: 'Xã',
          },
          {
            id: '6373',
            name: 'Phú Vĩnh',
            prefix: 'Xã',
          },
          {
            id: '6374',
            name: 'Tân An',
            prefix: 'Xã',
          },
          {
            id: '6375',
            name: 'Tân Thạnh',
            prefix: 'Xã',
          },
          {
            id: '6376',
            name: 'Vĩnh Hòa',
            prefix: 'Xã',
          },
          {
            id: '6377',
            name: 'Vĩnh Xương',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '396',
        name: 'Thoại Sơn',
        wards: [
          {
            id: '6378',
            name: 'An Bình',
            prefix: 'Xã',
          },
          {
            id: '6379',
            name: 'Bình Thành',
            prefix: 'Xã',
          },
          {
            id: '6380',
            name: 'Định Mỹ',
            prefix: 'Xã',
          },
          {
            id: '6381',
            name: 'Định Thành',
            prefix: 'Xã',
          },
          {
            id: '6382',
            name: 'Mỹ Phú Đông',
            prefix: 'Xã',
          },
          {
            id: '6383',
            name: 'Núi Sập',
            prefix: 'Thị trấn',
          },
          {
            id: '6384',
            name: 'Óc Eo',
            prefix: 'Thị trấn',
          },
          {
            id: '6385',
            name: 'Phú Hòa',
            prefix: 'Thị trấn',
          },
          {
            id: '6386',
            name: 'Phú Thuận',
            prefix: 'Xã',
          },
          {
            id: '6387',
            name: 'Tây Phú',
            prefix: 'Xã',
          },
          {
            id: '6388',
            name: 'Thoại Giang',
            prefix: 'Xã',
          },
          {
            id: '6389',
            name: 'Vĩnh Chánh',
            prefix: 'Xã',
          },
          {
            id: '6390',
            name: 'Vĩnh Khánh',
            prefix: 'Xã',
          },
          {
            id: '6391',
            name: 'Vĩnh Phú',
            prefix: 'Xã',
          },
          {
            id: '6392',
            name: 'Vĩnh Trạch',
            prefix: 'Xã',
          },
          {
            id: '6393',
            name: 'Vọng Đông',
            prefix: 'Xã',
          },
          {
            id: '6394',
            name: 'Vọng Thê',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '397',
        name: 'Tịnh Biên',
        wards: [
          {
            id: '6395',
            name: 'An Cư',
            prefix: 'Xã',
          },
          {
            id: '6396',
            name: 'An Hảo',
            prefix: 'Xã',
          },
          {
            id: '6397',
            name: 'An Nông',
            prefix: 'Xã',
          },
          {
            id: '6398',
            name: 'An Phú',
            prefix: 'Xã',
          },
          {
            id: '6399',
            name: 'Chi Lăng',
            prefix: 'Thị trấn',
          },
          {
            id: '6400',
            name: 'Nhà Bàng',
            prefix: 'Thị trấn',
          },
          {
            id: '6401',
            name: 'Nhơn Hưng',
            prefix: 'Xã',
          },
          {
            id: '6402',
            name: 'Núi Voi',
            prefix: 'Xã',
          },
          {
            id: '6403',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '6404',
            name: 'Tân Lợi',
            prefix: 'Xã',
          },
          {
            id: '6405',
            name: 'Thới Sơn',
            prefix: 'Xã',
          },
          {
            id: '6406',
            name: 'Tịnh Biên',
            prefix: 'Thị trấn',
          },
          {
            id: '6407',
            name: 'Văn Giáo',
            prefix: 'Xã',
          },
          {
            id: '6408',
            name: 'Vĩnh Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '398',
        name: 'Tri Tôn',
        wards: [
          {
            id: '6409',
            name: 'An Tức',
            prefix: 'Xã',
          },
          {
            id: '6410',
            name: 'Ba Chúc',
            prefix: 'Thị trấn',
          },
          {
            id: '6411',
            name: 'Châu Lăng',
            prefix: 'Xã',
          },
          {
            id: '6412',
            name: 'Cô Tô',
            prefix: 'Xã',
          },
          {
            id: '6413',
            name: 'Lạc Quới',
            prefix: 'Xã',
          },
          {
            id: '6414',
            name: 'Lê Trì',
            prefix: 'Xã',
          },
          {
            id: '6415',
            name: 'Lương An Trà',
            prefix: 'Xã',
          },
          {
            id: '6416',
            name: 'Lương Phi',
            prefix: 'Xã',
          },
          {
            id: '6417',
            name: 'Núi Tô',
            prefix: 'Xã',
          },
          {
            id: '6418',
            name: 'Ô Lâm',
            prefix: 'Xã',
          },
          {
            id: '6419',
            name: 'Tà Đảnh',
            prefix: 'Xã',
          },
          {
            id: '6420',
            name: 'Tân Tuyến',
            prefix: 'Xã',
          },
          {
            id: '6421',
            name: 'Tri Tôn',
            prefix: 'Thị trấn',
          },
          {
            id: '6422',
            name: 'Vĩnh Gia',
            prefix: 'Xã',
          },
          {
            id: '6423',
            name: 'Vĩnh Phước',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '31',
    code: 'VP',
    name: 'Vĩnh Phúc',
    districts: [
      {
        id: '399',
        name: 'Bình Xuyên',
        wards: [
          {
            id: '6424',
            name: 'Bá Hiến',
            prefix: 'Xã',
          },
          {
            id: '6425',
            name: 'Đạo Đức',
            prefix: 'Xã',
          },
          {
            id: '6426',
            name: 'Gia Khánh',
            prefix: 'Thị trấn',
          },
          {
            id: '6427',
            name: 'Hương Canh',
            prefix: 'Thị trấn',
          },
          {
            id: '6428',
            name: 'Hương Sơn',
            prefix: 'Xã',
          },
          {
            id: '6429',
            name: 'Phú Xuân',
            prefix: 'Xã',
          },
          {
            id: '6430',
            name: 'Quất Lưu',
            prefix: 'Xã',
          },
          {
            id: '6431',
            name: 'Sơn Lôi',
            prefix: 'Xã',
          },
          {
            id: '6432',
            name: 'Tam Hợp',
            prefix: 'Xã',
          },
          {
            id: '6433',
            name: 'Tân Phong',
            prefix: 'Xã',
          },
          {
            id: '6434',
            name: 'Thanh Lãng',
            prefix: 'Thị trấn',
          },
          {
            id: '6435',
            name: 'Thiện Kế',
            prefix: 'Xã',
          },
          {
            id: '6436',
            name: 'Trung Mỹ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '400',
        name: 'Lập Thạch',
        wards: [
          {
            id: '6437',
            name: 'Bắc Bình',
            prefix: 'Xã',
          },
          {
            id: '6438',
            name: 'Bàn Giản',
            prefix: 'Xã',
          },
          {
            id: '6439',
            name: 'Đình Chu',
            prefix: 'Xã',
          },
          {
            id: '6440',
            name: 'Đồng Ích',
            prefix: 'Xã',
          },
          {
            id: '6441',
            name: 'Hoa Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '6442',
            name: 'Hợp Lý',
            prefix: 'Xã',
          },
          {
            id: '6443',
            name: 'Lập Thạch',
            prefix: 'Thị trấn',
          },
          {
            id: '6444',
            name: 'Liên Hòa',
            prefix: 'Xã',
          },
          {
            id: '6445',
            name: 'Liễn Sơn',
            prefix: 'Xã',
          },
          {
            id: '6446',
            name: 'Ngọc Mỹ',
            prefix: 'Xã',
          },
          {
            id: '6447',
            name: 'Quang Sơn',
            prefix: 'Xã',
          },
          {
            id: '6448',
            name: 'Sơn Đông',
            prefix: 'Xã',
          },
          {
            id: '6449',
            name: 'Thái Hòa',
            prefix: 'Xã',
          },
          {
            id: '6450',
            name: 'Tiên Lữ',
            prefix: 'Xã',
          },
          {
            id: '6451',
            name: 'Triệu Đề',
            prefix: 'Xã',
          },
          {
            id: '6452',
            name: 'Tử Du',
            prefix: 'Xã',
          },
          {
            id: '6453',
            name: 'Văn Quán',
            prefix: 'Xã',
          },
          {
            id: '6454',
            name: 'Vân Trục',
            prefix: 'Xã',
          },
          {
            id: '6455',
            name: 'Xuân Hòa',
            prefix: 'Xã',
          },
          {
            id: '6456',
            name: 'Xuân Lôi',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '401',
        name: 'Phúc Yên',
        wards: [
          {
            id: '6457',
            name: 'Cao Minh',
            prefix: 'Xã',
          },
          {
            id: '6458',
            name: 'Đồng Xuân',
            prefix: 'Phường',
          },
          {
            id: '6459',
            name: 'Hùng Vương',
            prefix: 'Phường',
          },
          {
            id: '6460',
            name: 'Nam Viêm',
            prefix: 'Xã',
          },
          {
            id: '6461',
            name: 'Ngọc Thanh',
            prefix: 'Xã',
          },
          {
            id: '6462',
            name: 'Phúc Thắng',
            prefix: 'Phường',
          },
          {
            id: '6463',
            name: 'Tiền Châu',
            prefix: 'Xã',
          },
          {
            id: '6464',
            name: 'Trưng Nhị',
            prefix: 'Phường',
          },
          {
            id: '6465',
            name: 'Trưng Trắc',
            prefix: 'Phường',
          },
          {
            id: '6466',
            name: 'Xuân Hòa',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '402',
        name: 'Sông Lô',
        wards: [
          {
            id: '6467',
            name: 'Bạch Lưu',
            prefix: 'Xã',
          },
          {
            id: '6468',
            name: 'Cao Phong',
            prefix: 'Xã',
          },
          {
            id: '6469',
            name: 'Đôn Nhân',
            prefix: 'Xã',
          },
          {
            id: '6470',
            name: 'Đồng Quế',
            prefix: 'Xã',
          },
          {
            id: '6471',
            name: 'Đồng Thịnh',
            prefix: 'Xã',
          },
          {
            id: '6472',
            name: 'Đức Bác',
            prefix: 'Xã',
          },
          {
            id: '6473',
            name: 'Hải Lựu',
            prefix: 'Xã',
          },
          {
            id: '6474',
            name: 'Lãng Công',
            prefix: 'Xã',
          },
          {
            id: '6475',
            name: 'Nhân Đạo',
            prefix: 'Xã',
          },
          {
            id: '6476',
            name: 'Nhạo Sơn',
            prefix: 'Xã',
          },
          {
            id: '6477',
            name: 'Như Thụy',
            prefix: 'Xã',
          },
          {
            id: '6478',
            name: 'Phương Khoan',
            prefix: 'Xã',
          },
          {
            id: '6479',
            name: 'Quang Yên',
            prefix: 'Xã',
          },
          {
            id: '6480',
            name: 'Tam Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '6481',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '6482',
            name: 'Tứ Yên',
            prefix: 'Xã',
          },
          {
            id: '6483',
            name: 'Yên Thạch',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '404',
        name: 'Tam Dương',
        wards: [
          {
            id: '6493',
            name: 'An Hòa',
            prefix: 'Xã',
          },
          {
            id: '6496',
            name: 'Duy Phiên',
            prefix: 'Xã',
          },
          {
            id: '6494',
            name: 'Đạo Tú',
            prefix: 'Xã',
          },
          {
            id: '6495',
            name: 'Đồng Tĩnh',
            prefix: 'Xã',
          },
          {
            id: '6497',
            name: 'Hoàng Đan',
            prefix: 'Xã',
          },
          {
            id: '6498',
            name: 'Hoàng Hoa',
            prefix: 'Xã',
          },
          {
            id: '6499',
            name: 'Hoàng Lâu',
            prefix: 'Xã',
          },
          {
            id: '6500',
            name: 'Hợp Hòa',
            prefix: 'Thị trấn',
          },
          {
            id: '6501',
            name: 'Hợp Thịnh',
            prefix: 'Xã',
          },
          {
            id: '6502',
            name: 'Hướng Đạo',
            prefix: 'Xã',
          },
          {
            id: '6503',
            name: 'Kim Long',
            prefix: 'Xã',
          },
          {
            id: '6504',
            name: 'Thanh Vân',
            prefix: 'Xã',
          },
          {
            id: '6505',
            name: 'Vân Hội',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '403',
        name: 'Tam Đảo',
        wards: [
          {
            id: '6484',
            name: 'Bồ Lý',
            prefix: 'Xã',
          },
          {
            id: '6485',
            name: 'Đại Đình',
            prefix: 'Xã',
          },
          {
            id: '6486',
            name: 'Đạo Trù',
            prefix: 'Xã',
          },
          {
            id: '6487',
            name: 'Hồ Sơn',
            prefix: 'Xã',
          },
          {
            id: '6488',
            name: 'Hợp Châu',
            prefix: 'Xã',
          },
          {
            id: '6489',
            name: 'Minh Quang',
            prefix: 'Xã',
          },
          {
            id: '6490',
            name: 'Tam Đảo',
            prefix: 'Thị trấn',
          },
          {
            id: '6491',
            name: 'Tam Quan',
            prefix: 'Xã',
          },
          {
            id: '6492',
            name: 'Yên Dương',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '405',
        name: 'Vĩnh Tường',
        wards: [
          {
            id: '6506',
            name: 'An Tường',
            prefix: 'Xã',
          },
          {
            id: '6507',
            name: 'Bình Dương',
            prefix: 'Xã',
          },
          {
            id: '6508',
            name: 'Bồ Sao',
            prefix: 'Xã',
          },
          {
            id: '6509',
            name: 'Cao Đại',
            prefix: 'Xã',
          },
          {
            id: '6510',
            name: 'Chấn Hưng',
            prefix: 'Xã',
          },
          {
            id: '6511',
            name: 'Đại Đồng',
            prefix: 'Xã',
          },
          {
            id: '6512',
            name: 'Kim Xá',
            prefix: 'Xã',
          },
          {
            id: '6513',
            name: 'Lũng Hoà',
            prefix: 'Xã',
          },
          {
            id: '6514',
            name: 'Lý Nhân',
            prefix: 'Xã',
          },
          {
            id: '6515',
            name: 'Nghĩa Hưng',
            prefix: 'Xã',
          },
          {
            id: '6516',
            name: 'Ngũ Kiên',
            prefix: 'Xã',
          },
          {
            id: '6517',
            name: 'Phú Đa',
            prefix: 'Xã',
          },
          {
            id: '6518',
            name: 'Phú Thịnh',
            prefix: 'Xã',
          },
          {
            id: '6519',
            name: 'Tam Phúc',
            prefix: 'Xã',
          },
          {
            id: '6520',
            name: 'Tân Cương',
            prefix: 'Xã',
          },
          {
            id: '6521',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '6522',
            name: 'Thổ Tang',
            prefix: 'Thị trấn',
          },
          {
            id: '6523',
            name: 'Thượng Trưng',
            prefix: 'Xã',
          },
          {
            id: '6524',
            name: 'Tứ Trưng',
            prefix: 'Thị trấn',
          },
          {
            id: '6525',
            name: 'Tuân Chính',
            prefix: 'Xã',
          },
          {
            id: '6526',
            name: 'Vân Xuân',
            prefix: 'Xã',
          },
          {
            id: '6527',
            name: 'Việt Xuân',
            prefix: 'Xã',
          },
          {
            id: '6528',
            name: 'Vĩnh Ninh',
            prefix: 'Xã',
          },
          {
            id: '6529',
            name: 'Vĩnh Sơn',
            prefix: 'Xã',
          },
          {
            id: '6530',
            name: 'Vĩnh Thịnh',
            prefix: 'Xã',
          },
          {
            id: '6531',
            name: 'Vĩnh Tường',
            prefix: 'Thị trấn',
          },
          {
            id: '6532',
            name: 'Vũ Di',
            prefix: 'Xã',
          },
          {
            id: '6533',
            name: 'Yên Bình',
            prefix: 'Xã',
          },
          {
            id: '6534',
            name: 'Yên Lập',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '406',
        name: 'Vĩnh Yên',
        wards: [
          {
            id: '6535',
            name: 'Định Trung',
            prefix: 'Xã',
          },
          {
            id: '6536',
            name: 'Đống Đa',
            prefix: 'Phường',
          },
          {
            id: '6537',
            name: 'Đồng Tâm',
            prefix: 'Phường',
          },
          {
            id: '6538',
            name: 'Hội Hợp',
            prefix: 'Phường',
          },
          {
            id: '6539',
            name: 'Khai Quang',
            prefix: 'Phường',
          },
          {
            id: '6540',
            name: 'Liên Bảo',
            prefix: 'Phường',
          },
          {
            id: '6541',
            name: 'Ngô Quyền',
            prefix: 'Phường',
          },
          {
            id: '6542',
            name: 'Thanh Trù',
            prefix: 'Xã',
          },
          {
            id: '6543',
            name: 'Tích Sơn',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '407',
        name: 'Yên Lạc',
        wards: [
          {
            id: '6544',
            name: 'Bình Định',
            prefix: 'Xã',
          },
          {
            id: '6545',
            name: 'Đại Tự',
            prefix: 'Xã',
          },
          {
            id: '6546',
            name: 'Đồng Cương',
            prefix: 'Xã',
          },
          {
            id: '6547',
            name: 'Đồng Văn',
            prefix: 'Xã',
          },
          {
            id: '6548',
            name: 'Hồng Châu',
            prefix: 'Xã',
          },
          {
            id: '6549',
            name: 'Hồng Phương',
            prefix: 'Xã',
          },
          {
            id: '6550',
            name: 'Liên Châu',
            prefix: 'Xã',
          },
          {
            id: '6551',
            name: 'Nguyệt Đức',
            prefix: 'Xã',
          },
          {
            id: '6552',
            name: 'Tam Hồng',
            prefix: 'Xã',
          },
          {
            id: '6553',
            name: 'Tề Lỗ',
            prefix: 'Xã',
          },
          {
            id: '6554',
            name: 'Trung Hà',
            prefix: 'Xã',
          },
          {
            id: '6555',
            name: 'Trung Kiên',
            prefix: 'Xã',
          },
          {
            id: '6556',
            name: 'Trung Nguyên',
            prefix: 'Xã',
          },
          {
            id: '6557',
            name: 'Văn Tiến',
            prefix: 'Xã',
          },
          {
            id: '6558',
            name: 'Yên Đồng',
            prefix: 'Xã',
          },
          {
            id: '6559',
            name: 'Yên Lạc',
            prefix: 'Thị trấn',
          },
          {
            id: '6560',
            name: 'Yên Phương',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '32',
    code: 'TNI',
    name: 'Tây Ninh',
    districts: [
      {
        id: '408',
        name: 'Bến Cầu',
        wards: [
          {
            id: '6561',
            name: 'An Thạnh',
            prefix: 'Xã',
          },
          {
            id: '6562',
            name: 'Bến Cầu',
            prefix: 'Thị trấn',
          },
          {
            id: '6563',
            name: 'Lợi Thuận',
            prefix: 'Xã',
          },
          {
            id: '6564',
            name: 'Long Chữ',
            prefix: 'Xã',
          },
          {
            id: '6565',
            name: 'Long Giang',
            prefix: 'Xã',
          },
          {
            id: '6566',
            name: 'Long Khánh',
            prefix: 'Xã',
          },
          {
            id: '6567',
            name: 'Long Phước',
            prefix: 'Xã',
          },
          {
            id: '6568',
            name: 'Long Thuận',
            prefix: 'Xã',
          },
          {
            id: '6569',
            name: 'Tiên Thuận',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '409',
        name: 'Châu Thành',
        wards: [
          {
            id: '6570',
            name: 'An Bình',
            prefix: 'Xã',
          },
          {
            id: '6571',
            name: 'An Cơ',
            prefix: 'Xã',
          },
          {
            id: '6572',
            name: 'Biên Giới',
            prefix: 'Xã',
          },
          {
            id: '6573',
            name: 'Châu Thành',
            prefix: 'Thị trấn',
          },
          {
            id: '6574',
            name: 'Đồng Khởi',
            prefix: 'Xã',
          },
          {
            id: '6575',
            name: 'Hảo Đước',
            prefix: 'Xã',
          },
          {
            id: '6576',
            name: 'Hòa Hội',
            prefix: 'Xã',
          },
          {
            id: '6577',
            name: 'Hòa Thạnh',
            prefix: 'Xã',
          },
          {
            id: '6578',
            name: 'Long Vĩnh',
            prefix: 'Xã',
          },
          {
            id: '6579',
            name: 'Ninh Điền',
            prefix: 'Xã',
          },
          {
            id: '6580',
            name: 'Phước Vinh',
            prefix: 'Xã',
          },
          {
            id: '6581',
            name: 'Thái Bình',
            prefix: 'Xã',
          },
          {
            id: '6582',
            name: 'Thanh Điền',
            prefix: 'Xã',
          },
          {
            id: '6583',
            name: 'Thành Long',
            prefix: 'Xã',
          },
          {
            id: '6584',
            name: 'Trí Bình',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '410',
        name: 'Dương Minh Châu',
        wards: [
          {
            id: '6585',
            name: 'Bàu Năng',
            prefix: 'Xã',
          },
          {
            id: '6586',
            name: 'Bến Củi',
            prefix: 'Xã',
          },
          {
            id: '6587',
            name: 'Cầu Khởi',
            prefix: 'Xã',
          },
          {
            id: '6588',
            name: 'Chà Là',
            prefix: 'Xã',
          },
          {
            id: '6589',
            name: 'Dương Minh Châu',
            prefix: 'Thị trấn',
          },
          {
            id: '6590',
            name: 'Lộc Ninh',
            prefix: 'Xã',
          },
          {
            id: '6591',
            name: 'Phan',
            prefix: 'Xã',
          },
          {
            id: '6592',
            name: 'Phước Minh',
            prefix: 'Xã',
          },
          {
            id: '6593',
            name: 'Phước Ninh',
            prefix: 'Xã',
          },
          {
            id: '6594',
            name: 'Suối Đá',
            prefix: 'Xã',
          },
          {
            id: '6595',
            name: 'Truông Mít',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '411',
        name: 'Gò Dầu',
        wards: [
          {
            id: '6596',
            name: 'Bàu Đồn',
            prefix: 'Xã',
          },
          {
            id: '6597',
            name: 'Cẩm Giang',
            prefix: 'Xã',
          },
          {
            id: '6598',
            name: 'Gò Dầu',
            prefix: 'Thị trấn',
          },
          {
            id: '6599',
            name: 'Hiệp Thạnh',
            prefix: 'Xã',
          },
          {
            id: '6600',
            name: 'Phước Đông',
            prefix: 'Xã',
          },
          {
            id: '6601',
            name: 'Phước Thạnh',
            prefix: 'Xã',
          },
          {
            id: '6602',
            name: 'Phước Trạch',
            prefix: 'Xã',
          },
          {
            id: '6603',
            name: 'Thạnh Đức',
            prefix: 'Xã',
          },
          {
            id: '6604',
            name: 'Thanh Phước',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '412',
        name: 'Hòa Thành',
        wards: [
          {
            id: '6605',
            name: 'Hiệp Tân',
            prefix: 'Xã',
          },
          {
            id: '6606',
            name: 'Hòa Thành',
            prefix: 'Thị trấn',
          },
          {
            id: '6607',
            name: 'Long Thành Bắc',
            prefix: 'Xã',
          },
          {
            id: '6608',
            name: 'Long Thành Nam',
            prefix: 'Xã',
          },
          {
            id: '6609',
            name: 'Long Thành Trung',
            prefix: 'Xã',
          },
          {
            id: '6610',
            name: 'Trường Đông',
            prefix: 'Xã',
          },
          {
            id: '6611',
            name: 'Trường Hòa',
            prefix: 'Xã',
          },
          {
            id: '6612',
            name: 'Trường Tây',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '413',
        name: 'Tân Biên',
        wards: [
          {
            id: '6613',
            name: 'Hòa Hiệp',
            prefix: 'Xã',
          },
          {
            id: '6614',
            name: 'Mỏ Công',
            prefix: 'Xã',
          },
          {
            id: '6615',
            name: 'Tân Biên',
            prefix: 'Thị trấn',
          },
          {
            id: '6616',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '6617',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '6618',
            name: 'Tân Phong',
            prefix: 'Xã',
          },
          {
            id: '6619',
            name: 'Thạnh Bắc',
            prefix: 'Xã',
          },
          {
            id: '6620',
            name: 'Thạnh Bình',
            prefix: 'Xã',
          },
          {
            id: '6621',
            name: 'Thạnh Tây',
            prefix: 'Xã',
          },
          {
            id: '6622',
            name: 'Trà Vong',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '414',
        name: 'Tân Châu',
        wards: [
          {
            id: '6623',
            name: 'Suối Dây',
            prefix: 'Xã',
          },
          {
            id: '6624',
            name: 'Suối Ngô',
            prefix: 'Xã',
          },
          {
            id: '6625',
            name: 'Tân Châu',
            prefix: 'Thị trấn',
          },
          {
            id: '6626',
            name: 'Tân Đông',
            prefix: 'Xã',
          },
          {
            id: '6627',
            name: 'Tân Hà',
            prefix: 'Xã',
          },
          {
            id: '6628',
            name: 'Tân Hiệp',
            prefix: 'Xã',
          },
          {
            id: '6629',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
          {
            id: '6630',
            name: 'Tân Hội',
            prefix: 'Xã',
          },
          {
            id: '6631',
            name: 'Tân Hưng',
            prefix: 'Xã',
          },
          {
            id: '6632',
            name: 'Tân Phú',
            prefix: 'Xã',
          },
          {
            id: '6633',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '6634',
            name: 'Thạnh Đông',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '415',
        name: 'Tây Ninh',
        wards: [
          {
            id: '6635',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '6636',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '6637',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '6638',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '6639',
            name: 'Bình Minh',
            prefix: 'Xã',
          },
          {
            id: '6640',
            name: 'Hiệp Ninh',
            prefix: 'Phường',
          },
          {
            id: '6641',
            name: 'Ninh Sơn',
            prefix: 'Xã',
          },
          {
            id: '6642',
            name: 'Ninh Thạnh',
            prefix: 'Xã',
          },
          {
            id: '6643',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '6644',
            name: 'Thạnh Tân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '416',
        name: 'Trảng Bàng',
        wards: [
          {
            id: '6645',
            name: 'An Hòa',
            prefix: 'Xã',
          },
          {
            id: '6646',
            name: 'An Tịnh',
            prefix: 'Xã',
          },
          {
            id: '6647',
            name: 'Bình Thạnh',
            prefix: 'Xã',
          },
          {
            id: '6648',
            name: 'Đôn Thuận',
            prefix: 'Xã',
          },
          {
            id: '6649',
            name: 'Gia Bình',
            prefix: 'Xã',
          },
          {
            id: '6650',
            name: 'Gia Lộc',
            prefix: 'Xã',
          },
          {
            id: '6651',
            name: 'Hưng Thuận',
            prefix: 'Xã',
          },
          {
            id: '6652',
            name: 'Lộc Hưng',
            prefix: 'Xã',
          },
          {
            id: '6653',
            name: 'Phước Chỉ',
            prefix: 'Xã',
          },
          {
            id: '6654',
            name: 'Phước Lưu',
            prefix: 'Xã',
          },
          {
            id: '6655',
            name: 'Trảng Bàng',
            prefix: 'Thị trấn',
          },
        ],
      },
    ],
  },
  {
    id: '33',
    code: 'TN',
    name: 'Thái Nguyên',
    districts: [
      {
        id: '417',
        name: 'Đại Từ',
        wards: [
          {
            id: '6656',
            name: 'An Khánh',
            prefix: 'Xã',
          },
          {
            id: '6657',
            name: 'Bản Ngoại',
            prefix: 'Xã',
          },
          {
            id: '6658',
            name: 'Bình Thuận',
            prefix: 'Xã',
          },
          {
            id: '6659',
            name: 'Cát Nê',
            prefix: 'Xã',
          },
          {
            id: '6660',
            name: 'Cù Vân',
            prefix: 'Xã',
          },
          {
            id: '6661',
            name: 'Đại Từ',
            prefix: 'Thị trấn',
          },
          {
            id: '6662',
            name: 'Đức Lương',
            prefix: 'Xã',
          },
          {
            id: '6663',
            name: 'Hà Thượng',
            prefix: 'Xã',
          },
          {
            id: '6664',
            name: 'Hoàng Nông',
            prefix: 'Xã',
          },
          {
            id: '6665',
            name: 'Hùng Sơn',
            prefix: 'Xã',
          },
          {
            id: '6666',
            name: 'Khôi Kỳ',
            prefix: 'Xã',
          },
          {
            id: '6667',
            name: 'Ký Phú',
            prefix: 'Xã',
          },
          {
            id: '6668',
            name: 'La Bằng',
            prefix: 'Xã',
          },
          {
            id: '6669',
            name: 'Lục Ba',
            prefix: 'Xã',
          },
          {
            id: '6670',
            name: 'Minh Tiến',
            prefix: 'Xã',
          },
          {
            id: '6671',
            name: 'Mỹ Yên',
            prefix: 'Xã',
          },
          {
            id: '6672',
            name: 'Na Mao',
            prefix: 'Xã',
          },
          {
            id: '6673',
            name: 'Phú Cường',
            prefix: 'Xã',
          },
          {
            id: '6674',
            name: 'Phú Lạc',
            prefix: 'Xã',
          },
          {
            id: '6675',
            name: 'Phú Thịnh',
            prefix: 'Xã',
          },
          {
            id: '6676',
            name: 'Phú Xuyên',
            prefix: 'Xã',
          },
          {
            id: '6677',
            name: 'Phục Linh',
            prefix: 'Xã',
          },
          {
            id: '6678',
            name: 'Phúc Lương',
            prefix: 'Xã',
          },
          {
            id: '6679',
            name: 'Quân Chu',
            prefix: 'Thị trấn',
          },
          {
            id: '6680',
            name: 'Quân Chu',
            prefix: 'Xã',
          },
          {
            id: '6681',
            name: 'Tân Linh',
            prefix: 'Xã',
          },
          {
            id: '6682',
            name: 'Tân Thái',
            prefix: 'Xã',
          },
          {
            id: '6683',
            name: 'Tiên Hội',
            prefix: 'Xã',
          },
          {
            id: '6684',
            name: 'Vạn Thọ',
            prefix: 'Xã',
          },
          {
            id: '6685',
            name: 'Văn Yên',
            prefix: 'Xã',
          },
          {
            id: '6686',
            name: 'Yên Lãng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '418',
        name: 'Định Hóa',
        wards: [
          {
            id: '6687',
            name: 'Bảo Cường',
            prefix: 'Xã',
          },
          {
            id: '6688',
            name: 'Bảo Linh',
            prefix: 'Xã',
          },
          {
            id: '6689',
            name: 'Bình Thành',
            prefix: 'Xã',
          },
          {
            id: '6690',
            name: 'Bình Yên',
            prefix: 'Xã',
          },
          {
            id: '6691',
            name: 'Bộc Nhiêu',
            prefix: 'Xã',
          },
          {
            id: '6692',
            name: 'Chợ Chu',
            prefix: 'Thị trấn',
          },
          {
            id: '6693',
            name: 'Điềm Mặc',
            prefix: 'Xã',
          },
          {
            id: '6694',
            name: 'Định Biên',
            prefix: 'Xã',
          },
          {
            id: '6695',
            name: 'Đồng Thịnh',
            prefix: 'Xã',
          },
          {
            id: '6696',
            name: 'Kim Phượng',
            prefix: 'Xã',
          },
          {
            id: '6697',
            name: 'Kim Sơn',
            prefix: 'Xã',
          },
          {
            id: '6698',
            name: 'Lam Vỹ',
            prefix: 'Xã',
          },
          {
            id: '6699',
            name: 'Linh Thông',
            prefix: 'Xã',
          },
          {
            id: '6700',
            name: 'Phú Đình',
            prefix: 'Xã',
          },
          {
            id: '6701',
            name: 'Phú Tiến',
            prefix: 'Xã',
          },
          {
            id: '6702',
            name: 'Phúc Chu',
            prefix: 'Xã',
          },
          {
            id: '6703',
            name: 'Phượng Tiến',
            prefix: 'Xã',
          },
          {
            id: '6704',
            name: 'Quy Kỳ',
            prefix: 'Xã',
          },
          {
            id: '6705',
            name: 'Sơn Phú',
            prefix: 'Xã',
          },
          {
            id: '6706',
            name: 'Tân Dương',
            prefix: 'Xã',
          },
          {
            id: '6707',
            name: 'Tân Thịnh',
            prefix: 'Xã',
          },
          {
            id: '6708',
            name: 'Thanh Định',
            prefix: 'Xã',
          },
          {
            id: '6709',
            name: 'Trung Hội',
            prefix: 'Xã',
          },
          {
            id: '6710',
            name: 'Trung Lương',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '419',
        name: 'Đồng Hỷ',
        wards: [
          {
            id: '6711',
            name: 'Cây Thị',
            prefix: 'Xã',
          },
          {
            id: '6712',
            name: 'Chùa Hang',
            prefix: 'Thị trấn',
          },
          {
            id: '6713',
            name: 'Hòa Bình',
            prefix: 'Xã',
          },
          {
            id: '6714',
            name: 'Hóa Thượng',
            prefix: 'Xã',
          },
          {
            id: '6715',
            name: 'Hóa Trung',
            prefix: 'Xã',
          },
          {
            id: '6716',
            name: 'Hợp Tiến',
            prefix: 'Xã',
          },
          {
            id: '6717',
            name: 'Huống Thượng',
            prefix: 'Xã',
          },
          {
            id: '6718',
            name: 'Khe Mo',
            prefix: 'Xã',
          },
          {
            id: '6719',
            name: 'Linh Sơn',
            prefix: 'Xã',
          },
          {
            id: '6720',
            name: 'Minh Lập',
            prefix: 'Xã',
          },
          {
            id: '6721',
            name: 'Nam Hòa',
            prefix: 'Xã',
          },
          {
            id: '6722',
            name: 'Quang Sơn',
            prefix: 'Xã',
          },
          {
            id: '6723',
            name: 'Sông Cầu',
            prefix: 'Thị trấn',
          },
          {
            id: '6724',
            name: 'Tân Lợi',
            prefix: 'Xã',
          },
          {
            id: '6725',
            name: 'Tân Long',
            prefix: 'Xã',
          },
          {
            id: '6726',
            name: 'Trại Cau',
            prefix: 'Thị trấn',
          },
          {
            id: '6727',
            name: 'Văn Hán',
            prefix: 'Xã',
          },
          {
            id: '6728',
            name: 'Văn Lăng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '420',
        name: 'Phổ Yên',
        wards: [
          {
            id: '6729',
            name: 'Ba Hàng',
            prefix: 'Thị trấn',
          },
          {
            id: '6730',
            name: 'Bắc Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '6731',
            name: 'Bãi Bông',
            prefix: 'Thị trấn',
          },
          {
            id: '6732',
            name: 'Đắc Sơn',
            prefix: 'Xã',
          },
          {
            id: '6733',
            name: 'Đông Cao',
            prefix: 'Xã',
          },
          {
            id: '6734',
            name: 'Đồng Tiến',
            prefix: 'Xã',
          },
          {
            id: '6735',
            name: 'Hồng Tiến',
            prefix: 'Xã',
          },
          {
            id: '6736',
            name: 'Minh Đức',
            prefix: 'Xã',
          },
          {
            id: '6737',
            name: 'Nam Tiến',
            prefix: 'Xã',
          },
          {
            id: '6738',
            name: 'Phúc Tân',
            prefix: 'Xã',
          },
          {
            id: '6739',
            name: 'Phúc Thuận',
            prefix: 'Xã',
          },
          {
            id: '6740',
            name: 'Tân Hương',
            prefix: 'Xã',
          },
          {
            id: '6741',
            name: 'Tân Phú',
            prefix: 'Xã',
          },
          {
            id: '6742',
            name: 'Thành Công',
            prefix: 'Xã',
          },
          {
            id: '6743',
            name: 'Thuận Thành',
            prefix: 'Xã',
          },
          {
            id: '6744',
            name: 'Tiên Phong',
            prefix: 'Xã',
          },
          {
            id: '6745',
            name: 'Trung Thành',
            prefix: 'Xã',
          },
          {
            id: '6746',
            name: 'Vạn Phái',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '421',
        name: 'Phú Bình',
        wards: [
          {
            id: '6747',
            name: 'Bàn Đạt',
            prefix: 'Xã',
          },
          {
            id: '6748',
            name: 'Bảo Lý',
            prefix: 'Xã',
          },
          {
            id: '6752',
            name: 'Dương Thành',
            prefix: 'Xã',
          },
          {
            id: '6749',
            name: 'Đào Xá',
            prefix: 'Xã',
          },
          {
            id: '6750',
            name: 'Điềm Thụy',
            prefix: 'Xã',
          },
          {
            id: '6751',
            name: 'Đồng Liên',
            prefix: 'Xã',
          },
          {
            id: '6753',
            name: 'Hà Châu',
            prefix: 'Xã',
          },
          {
            id: '6754',
            name: 'Hương Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '6755',
            name: 'Kha Sơn',
            prefix: 'Xã',
          },
          {
            id: '6756',
            name: 'Lương Phú',
            prefix: 'Xã',
          },
          {
            id: '6757',
            name: 'Nga My',
            prefix: 'Xã',
          },
          {
            id: '6758',
            name: 'Nhã Lộng',
            prefix: 'Xã',
          },
          {
            id: '6759',
            name: 'Tân Đức',
            prefix: 'Xã',
          },
          {
            id: '6760',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
          {
            id: '6761',
            name: 'Tân Khánh',
            prefix: 'Xã',
          },
          {
            id: '6762',
            name: 'Tân Kim',
            prefix: 'Xã',
          },
          {
            id: '6763',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '6764',
            name: 'Thanh Ninh',
            prefix: 'Xã',
          },
          {
            id: '6765',
            name: 'Thượng Đình',
            prefix: 'Xã',
          },
          {
            id: '6766',
            name: 'Úc Kỳ',
            prefix: 'Xã',
          },
          {
            id: '6767',
            name: 'Xuân Phương',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '422',
        name: 'Phú Lương',
        wards: [
          {
            id: '6768',
            name: 'Cổ Lũng',
            prefix: 'Xã',
          },
          {
            id: '6769',
            name: 'Động Đạt',
            prefix: 'Xã',
          },
          {
            id: '6770',
            name: 'Đu',
            prefix: 'Thị trấn',
          },
          {
            id: '6771',
            name: 'Giang Tiên',
            prefix: 'Thị trấn',
          },
          {
            id: '6772',
            name: 'Hợp Thành',
            prefix: 'Xã',
          },
          {
            id: '6773',
            name: 'Ôn Lương',
            prefix: 'Xã',
          },
          {
            id: '6774',
            name: 'Phấn Mễ',
            prefix: 'Xã',
          },
          {
            id: '6775',
            name: 'Phú Đô',
            prefix: 'Xã',
          },
          {
            id: '6776',
            name: 'Phủ Lý',
            prefix: 'Xã',
          },
          {
            id: '6777',
            name: 'Sơn Cẩm',
            prefix: 'Xã',
          },
          {
            id: '6778',
            name: 'Tức Tranh',
            prefix: 'Xã',
          },
          {
            id: '6779',
            name: 'Vô Tranh',
            prefix: 'Xã',
          },
          {
            id: '6780',
            name: 'Yên Đổ',
            prefix: 'Xã',
          },
          {
            id: '6781',
            name: 'Yên Lạc',
            prefix: 'Xã',
          },
          {
            id: '6782',
            name: 'Yên Ninh',
            prefix: 'Xã',
          },
          {
            id: '6783',
            name: 'Yên Trạch',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '423',
        name: 'Sông Công',
        wards: [
          {
            id: '6784',
            name: 'Bá Xuyên',
            prefix: 'Xã',
          },
          {
            id: '6785',
            name: 'Bách Quang',
            prefix: 'Phường',
          },
          {
            id: '6786',
            name: 'Bình Sơn',
            prefix: 'Xã',
          },
          {
            id: '6787',
            name: 'Cải Đan',
            prefix: 'Phường',
          },
          {
            id: '6788',
            name: 'Lương Châu',
            prefix: 'Phường',
          },
          {
            id: '6789',
            name: 'Mỏ Chè',
            prefix: 'Phường',
          },
          {
            id: '6790',
            name: 'Phố Cò',
            prefix: 'Phường',
          },
          {
            id: '6791',
            name: 'Tân Quang',
            prefix: 'Xã',
          },
          {
            id: '6792',
            name: 'Thắng Lợi',
            prefix: 'Phường',
          },
          {
            id: '6793',
            name: 'Vinh Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '424',
        name: 'Thái Nguyên',
        wards: [
          {
            id: '6794',
            name: 'Cam Giá',
            prefix: 'Phường',
          },
          {
            id: '6795',
            name: 'Cao Ngạn',
            prefix: 'Xã',
          },
          {
            id: '6796',
            name: 'Đồng Bẩm',
            prefix: 'Xã',
          },
          {
            id: '6797',
            name: 'Đồng Quang',
            prefix: 'Phường',
          },
          {
            id: '6798',
            name: 'Gia Sàng',
            prefix: 'Phường',
          },
          {
            id: '6799',
            name: 'Hoàng Văn Thụ',
            prefix: 'Phường',
          },
          {
            id: '6800',
            name: 'Hương Sơn',
            prefix: 'Phường',
          },
          {
            id: '6801',
            name: 'Lương Sơn',
            prefix: 'Xã',
          },
          {
            id: '6802',
            name: 'Phan Đình Phùng',
            prefix: 'Phường',
          },
          {
            id: '6803',
            name: 'Phú Xá',
            prefix: 'Phường',
          },
          {
            id: '6804',
            name: 'Phúc Hà',
            prefix: 'Xã',
          },
          {
            id: '6805',
            name: 'Phúc Trìu',
            prefix: 'Xã',
          },
          {
            id: '6806',
            name: 'Phúc Xuân',
            prefix: 'Xã',
          },
          {
            id: '6807',
            name: 'Quan Triều',
            prefix: 'Phường',
          },
          {
            id: '6808',
            name: 'Quang Trung',
            prefix: 'Phường',
          },
          {
            id: '6809',
            name: 'Quang Vinh',
            prefix: 'Phường',
          },
          {
            id: '6810',
            name: 'Quyết Thắng',
            prefix: 'Xã',
          },
          {
            id: '6811',
            name: 'Tân Cương',
            prefix: 'Xã',
          },
          {
            id: '6812',
            name: 'Tân Lập',
            prefix: 'Phường',
          },
          {
            id: '6813',
            name: 'Tân Long',
            prefix: 'Phường',
          },
          {
            id: '6814',
            name: 'Tân Thành',
            prefix: 'Phường',
          },
          {
            id: '6815',
            name: 'Tân Thịnh',
            prefix: 'Phường',
          },
          {
            id: '6816',
            name: 'Thịnh Đán',
            prefix: 'Phường',
          },
          {
            id: '6817',
            name: 'Thịnh Đức',
            prefix: 'Xã',
          },
          {
            id: '6818',
            name: 'Thủy Đường',
            prefix: 'Xã',
          },
          {
            id: '6819',
            name: 'Tích Lương',
            prefix: 'Phường',
          },
          {
            id: '6820',
            name: 'Trung Thành',
            prefix: 'Phường',
          },
          {
            id: '6821',
            name: 'Trưng Vương',
            prefix: 'Phường',
          },
          {
            id: '6822',
            name: 'Túc Duyên',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '425',
        name: 'Võ Nhai',
        wards: [
          {
            id: '6823',
            name: 'Bình Long',
            prefix: 'Xã',
          },
          {
            id: '6824',
            name: 'Cúc Đường',
            prefix: 'Xã',
          },
          {
            id: '6825',
            name: 'Dân Tiến',
            prefix: 'Xã',
          },
          {
            id: '6826',
            name: 'Đình Cả',
            prefix: 'Thị trấn',
          },
          {
            id: '6827',
            name: 'La Hiên',
            prefix: 'Xã',
          },
          {
            id: '6828',
            name: 'Lâu Thượng',
            prefix: 'Xã',
          },
          {
            id: '6829',
            name: 'Liên Minh',
            prefix: 'Xã',
          },
          {
            id: '6830',
            name: 'Nghinh Tường',
            prefix: 'Xã',
          },
          {
            id: '6831',
            name: 'Phú Thượng',
            prefix: 'Xã',
          },
          {
            id: '6832',
            name: 'Phương Giao',
            prefix: 'Xã',
          },
          {
            id: '6833',
            name: 'Sảng Mộc',
            prefix: 'Xã',
          },
          {
            id: '6834',
            name: 'Thần Sa',
            prefix: 'Xã',
          },
          {
            id: '6835',
            name: 'Thượng Nung',
            prefix: 'Xã',
          },
          {
            id: '6836',
            name: 'Tràng Xá',
            prefix: 'Xã',
          },
          {
            id: '6837',
            name: 'Vũ Chấn',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '34',
    code: 'LCA',
    name: 'Lào Cai',
    districts: [
      {
        id: '426',
        name: 'Bắc Hà',
        wards: [
          {
            id: '6838',
            name: 'Bắc Hà',
            prefix: 'Thị trấn',
          },
          {
            id: '6839',
            name: 'Bản Cái',
            prefix: 'Xã',
          },
          {
            id: '6840',
            name: 'Bản Già',
            prefix: 'Xã',
          },
          {
            id: '6841',
            name: 'Bản Liền',
            prefix: 'Xã',
          },
          {
            id: '6842',
            name: 'Bản Phố',
            prefix: 'Xã',
          },
          {
            id: '6843',
            name: 'Bảo Nhai',
            prefix: 'Xã',
          },
          {
            id: '6844',
            name: 'Cốc Lầu',
            prefix: 'Xã',
          },
          {
            id: '6845',
            name: 'Cốc Ly',
            prefix: 'Xã',
          },
          {
            id: '6846',
            name: 'Hoàng Thu Phố',
            prefix: 'Xã',
          },
          {
            id: '6847',
            name: 'Lầu Thí Ngài',
            prefix: 'Xã',
          },
          {
            id: '6848',
            name: 'Lùng Cải',
            prefix: 'Xã',
          },
          {
            id: '6849',
            name: 'Lùng Phình',
            prefix: 'Xã',
          },
          {
            id: '6850',
            name: 'Na Hối',
            prefix: 'Thị trấn',
          },
          {
            id: '6851',
            name: 'Nậm Đét',
            prefix: 'Xã',
          },
          {
            id: '6852',
            name: 'Nậm Khánh',
            prefix: 'Xã',
          },
          {
            id: '6853',
            name: 'Nậm Lúc',
            prefix: 'Xã',
          },
          {
            id: '6854',
            name: 'Nậm Mòn',
            prefix: 'Xã',
          },
          {
            id: '6855',
            name: 'Tà Chải',
            prefix: 'Xã',
          },
          {
            id: '6856',
            name: 'Tả Củ Tỷ',
            prefix: 'Xã',
          },
          {
            id: '6857',
            name: 'Tả Van Chư',
            prefix: 'Xã',
          },
          {
            id: '6858',
            name: 'Thải Giàng Phố',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '427',
        name: 'Bảo Thắng',
        wards: [
          {
            id: '6859',
            name: 'Bản Cầm',
            prefix: 'Xã',
          },
          {
            id: '6860',
            name: 'Bản Phiệt',
            prefix: 'Xã',
          },
          {
            id: '6861',
            name: 'Gia Phú',
            prefix: 'Xã',
          },
          {
            id: '6862',
            name: 'Nông trường Phong Hải',
            prefix: 'Thị trấn',
          },
          {
            id: '6863',
            name: 'Phố Lu',
            prefix: 'Thị trấn',
          },
          {
            id: '6864',
            name: 'Phố Lu',
            prefix: 'Xã',
          },
          {
            id: '6865',
            name: 'Phong Niên',
            prefix: 'Xã',
          },
          {
            id: '6866',
            name: 'Phú Nhuận',
            prefix: 'Xã',
          },
          {
            id: '6867',
            name: 'Sơn Hà',
            prefix: 'Xã',
          },
          {
            id: '6868',
            name: 'Sơn Hải',
            prefix: 'Xã',
          },
          {
            id: '6869',
            name: 'Tằng Loỏng',
            prefix: 'Thị trấn',
          },
          {
            id: '6870',
            name: 'Thái Niên',
            prefix: 'Xã',
          },
          {
            id: '6871',
            name: 'Trì Quang',
            prefix: 'Xã',
          },
          {
            id: '6872',
            name: 'Xuân Giao',
            prefix: 'Xã',
          },
          {
            id: '6873',
            name: 'Xuân Quang',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '428',
        name: 'Bảo Yên',
        wards: [
          {
            id: '6874',
            name: 'Bảo Hà',
            prefix: 'Xã',
          },
          {
            id: '6875',
            name: 'Cam Con',
            prefix: 'Xã',
          },
          {
            id: '6876',
            name: 'Điện Quan',
            prefix: 'Xã',
          },
          {
            id: '6877',
            name: 'Kim Sơn',
            prefix: 'Xã',
          },
          {
            id: '6878',
            name: 'Long Khánh',
            prefix: 'Xã',
          },
          {
            id: '6879',
            name: 'Long Phúc',
            prefix: 'Xã',
          },
          {
            id: '6880',
            name: 'Lương Sơn',
            prefix: 'Xã',
          },
          {
            id: '6881',
            name: 'Minh Tân',
            prefix: 'Xã',
          },
          {
            id: '6882',
            name: 'Nghĩa Đô',
            prefix: 'Xã',
          },
          {
            id: '6883',
            name: 'Phố Ràng',
            prefix: 'Thị trấn',
          },
          {
            id: '6884',
            name: 'Tân Dương',
            prefix: 'Xã',
          },
          {
            id: '6885',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '6886',
            name: 'Thượng Hà',
            prefix: 'Xã',
          },
          {
            id: '6887',
            name: 'Việt Tiến',
            prefix: 'Xã',
          },
          {
            id: '6888',
            name: 'Vĩnh Yên',
            prefix: 'Xã',
          },
          {
            id: '6889',
            name: 'Xuân Hòa',
            prefix: 'Xã',
          },
          {
            id: '6890',
            name: 'Xuân Thượng',
            prefix: 'Xã',
          },
          {
            id: '6891',
            name: 'Yên Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '429',
        name: 'Bát Xát',
        wards: [
          {
            id: '6892',
            name: 'A Lù',
            prefix: 'Xã',
          },
          {
            id: '6893',
            name: 'A Mú Sung',
            prefix: 'Xã',
          },
          {
            id: '6894',
            name: 'Bản Qua',
            prefix: 'Xã',
          },
          {
            id: '6895',
            name: 'Bản Vược',
            prefix: 'Xã',
          },
          {
            id: '6896',
            name: 'Bản Xèo',
            prefix: 'Xã',
          },
          {
            id: '6897',
            name: 'Bát Xát',
            prefix: 'Thị trấn',
          },
          {
            id: '6898',
            name: 'Cốc Mỳ',
            prefix: 'Xã',
          },
          {
            id: '6899',
            name: 'Cốc San',
            prefix: 'Xã',
          },
          {
            id: '6900',
            name: 'Dền Sáng',
            prefix: 'Xã',
          },
          {
            id: '6901',
            name: 'Dền Thàng',
            prefix: 'Xã',
          },
          {
            id: '6902',
            name: 'Mường Hum',
            prefix: 'Xã',
          },
          {
            id: '6903',
            name: 'Mường Vi',
            prefix: 'Xã',
          },
          {
            id: '6904',
            name: 'Nậm Chạc',
            prefix: 'Xã',
          },
          {
            id: '6905',
            name: 'Nậm Pung',
            prefix: 'Xã',
          },
          {
            id: '6906',
            name: 'Ngải Thầu',
            prefix: 'Xã',
          },
          {
            id: '6907',
            name: 'Pa Cheo',
            prefix: 'Xã',
          },
          {
            id: '6908',
            name: 'Phìn Ngan',
            prefix: 'Xã',
          },
          {
            id: '6909',
            name: 'Quang Kim',
            prefix: 'Xã',
          },
          {
            id: '6910',
            name: 'Sàng Ma Sáo',
            prefix: 'Xã',
          },
          {
            id: '6911',
            name: 'Tòng Sanh',
            prefix: 'Xã',
          },
          {
            id: '6912',
            name: 'Trịnh Tường',
            prefix: 'Xã',
          },
          {
            id: '6913',
            name: 'Trung Lèng Hồ',
            prefix: 'Xã',
          },
          {
            id: '6914',
            name: 'Y Tý',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '430',
        name: 'Lào Cai',
        wards: [
          {
            id: '6915',
            name: 'Bắc Cường',
            prefix: 'Phường',
          },
          {
            id: '6916',
            name: 'Bắc Lệnh',
            prefix: 'Phường',
          },
          {
            id: '6917',
            name: 'Bình Minh',
            prefix: 'Phường',
          },
          {
            id: '6918',
            name: 'Cam Đường',
            prefix: 'Xã',
          },
          {
            id: '6919',
            name: 'Cốc Lếu',
            prefix: 'Phường',
          },
          {
            id: '6921',
            name: 'Duyên Hải',
            prefix: 'Phường',
          },
          {
            id: '6920',
            name: 'Đồng Tuyển',
            prefix: 'Xã',
          },
          {
            id: '6922',
            name: 'Hợp Thành',
            prefix: 'Xã',
          },
          {
            id: '6923',
            name: 'Kim Tân',
            prefix: 'Phường',
          },
          {
            id: '6924',
            name: 'Lào Cai',
            prefix: 'Phường',
          },
          {
            id: '6925',
            name: 'Nam Cường',
            prefix: 'Phường',
          },
          {
            id: '6926',
            name: 'Nam Cường',
            prefix: 'Phường',
          },
          {
            id: '6927',
            name: 'Phố Mới',
            prefix: 'Phường',
          },
          {
            id: '6928',
            name: 'Pom Hán',
            prefix: 'Phường',
          },
          {
            id: '6929',
            name: 'Tả Phời',
            prefix: 'Xã',
          },
          {
            id: '6930',
            name: 'Thống Nhất',
            prefix: 'Phường',
          },
          {
            id: '6931',
            name: 'Vạn Hòa',
            prefix: 'Xã',
          },
          {
            id: '6932',
            name: 'Xuân Tăng',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '431',
        name: 'Mường Khương',
        wards: [
          {
            id: '6933',
            name: 'Bản Lầu',
            prefix: 'Xã',
          },
          {
            id: '6934',
            name: 'Bản Sen',
            prefix: 'Xã',
          },
          {
            id: '6935',
            name: 'Cao Sơn',
            prefix: 'Xã',
          },
          {
            id: '6936',
            name: 'Dìn Chin',
            prefix: 'Xã',
          },
          {
            id: '6937',
            name: 'La Pan Tẩn',
            prefix: 'Xã',
          },
          {
            id: '6938',
            name: 'Lùng Khấu Nhin',
            prefix: 'Xã',
          },
          {
            id: '6939',
            name: 'Lùng Vai',
            prefix: 'Xã',
          },
          {
            id: '6940',
            name: 'Mường Khương',
            prefix: 'Thị trấn',
          },
          {
            id: '6941',
            name: 'Nậm Chảy',
            prefix: 'Xã',
          },
          {
            id: '6942',
            name: 'Nấm Lư',
            prefix: 'Xã',
          },
          {
            id: '6943',
            name: 'Pha Long',
            prefix: 'Xã',
          },
          {
            id: '6944',
            name: 'Tả Gia Khâu',
            prefix: 'Xã',
          },
          {
            id: '6945',
            name: 'Tả Ngải Chồ',
            prefix: 'Xã',
          },
          {
            id: '6946',
            name: 'Tả Thàng',
            prefix: 'Xã',
          },
          {
            id: '6947',
            name: 'Thanh Bình',
            prefix: 'Xã',
          },
          {
            id: '6948',
            name: 'Tung Chung Phố',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '432',
        name: 'Sa Pa',
        wards: [
          {
            id: '6949',
            name: 'Bản Hồ',
            prefix: 'Xã',
          },
          {
            id: '6950',
            name: 'Bản Khoang',
            prefix: 'Xã',
          },
          {
            id: '6951',
            name: 'Bản Phùng',
            prefix: 'Xã',
          },
          {
            id: '6952',
            name: 'Hầu Thào',
            prefix: 'Xã',
          },
          {
            id: '6953',
            name: 'Lao Chải',
            prefix: 'Xã',
          },
          {
            id: '6954',
            name: 'Nậm Cang',
            prefix: 'Xã',
          },
          {
            id: '6955',
            name: 'Nậm Sài',
            prefix: 'Xã',
          },
          {
            id: '6956',
            name: 'Sa Pa',
            prefix: 'Thị trấn',
          },
          {
            id: '6957',
            name: 'Sa Pả',
            prefix: 'Xã',
          },
          {
            id: '6958',
            name: 'San Sả Hồ',
            prefix: 'Xã',
          },
          {
            id: '6959',
            name: 'Sử Pán',
            prefix: 'Xã',
          },
          {
            id: '6960',
            name: 'Suối Thầu',
            prefix: 'Xã',
          },
          {
            id: '6961',
            name: 'Tả Giàng Phình',
            prefix: 'Xã',
          },
          {
            id: '6962',
            name: 'Tả Phìn',
            prefix: 'Xã',
          },
          {
            id: '6963',
            name: 'Tả Van',
            prefix: 'Xã',
          },
          {
            id: '6964',
            name: 'Thanh Kim',
            prefix: 'Xã',
          },
          {
            id: '6965',
            name: 'Thanh Phú',
            prefix: 'Xã',
          },
          {
            id: '6966',
            name: 'Trung Chải',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '433',
        name: 'Văn Bàn',
        wards: [
          {
            id: '6967',
            name: 'Chiềng Ken',
            prefix: 'Xã',
          },
          {
            id: '6968',
            name: 'Dần Thàng',
            prefix: 'Xã',
          },
          {
            id: '6969',
            name: 'Dương Qùy',
            prefix: 'Xã',
          },
          {
            id: '6970',
            name: 'Hòa Mạc',
            prefix: 'Xã',
          },
          {
            id: '6971',
            name: 'Khánh Yên',
            prefix: 'Thị trấn',
          },
          {
            id: '6972',
            name: 'Khánh Yên Hạ',
            prefix: 'Xã',
          },
          {
            id: '6973',
            name: 'Khánh Yên Thượng',
            prefix: 'Xã',
          },
          {
            id: '6974',
            name: 'Khánh Yên Trung',
            prefix: 'Xã',
          },
          {
            id: '6975',
            name: 'Làng Giàng',
            prefix: 'Xã',
          },
          {
            id: '6976',
            name: 'Liêm Phú',
            prefix: 'Xã',
          },
          {
            id: '6977',
            name: 'Minh Lương',
            prefix: 'Xã',
          },
          {
            id: '6978',
            name: 'Nậm Chày',
            prefix: 'Xã',
          },
          {
            id: '6979',
            name: 'Nậm Mả',
            prefix: 'Xã',
          },
          {
            id: '6980',
            name: 'Nậm Rạng',
            prefix: 'Xã',
          },
          {
            id: '6981',
            name: 'Nậm Tha',
            prefix: 'Xã',
          },
          {
            id: '6982',
            name: 'Nậm Xây',
            prefix: 'Xã',
          },
          {
            id: '6983',
            name: 'Nậm Xé',
            prefix: 'Xã',
          },
          {
            id: '6984',
            name: 'Sơn Thủy',
            prefix: 'Xã',
          },
          {
            id: '6985',
            name: 'Tân An',
            prefix: 'Xã',
          },
          {
            id: '6986',
            name: 'Tân Thượng',
            prefix: 'Xã',
          },
          {
            id: '6987',
            name: 'Thẳm Dương',
            prefix: 'Xã',
          },
          {
            id: '6988',
            name: 'Văn Sơn',
            prefix: 'Xã',
          },
          {
            id: '6989',
            name: 'Võ Lao',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '434',
        name: 'Xi Ma Cai',
        wards: [
          {
            id: '6990',
            name: 'Bản Mế',
            prefix: 'Xã',
          },
          {
            id: '6991',
            name: 'Cán Cấu',
            prefix: 'Xã',
          },
          {
            id: '6992',
            name: 'Cán Hồ',
            prefix: 'Xã',
          },
          {
            id: '6993',
            name: 'Lử Thẩn',
            prefix: 'Xã',
          },
          {
            id: '6994',
            name: 'Lùng Sui',
            prefix: 'Xã',
          },
          {
            id: '6995',
            name: 'Mản Thẩn',
            prefix: 'Xã',
          },
          {
            id: '6996',
            name: 'Nàn Sán',
            prefix: 'Xã',
          },
          {
            id: '6997',
            name: 'Nàn Xín',
            prefix: 'Xã',
          },
          {
            id: '6998',
            name: 'Quan Thần Sán',
            prefix: 'Xã',
          },
          {
            id: '6999',
            name: 'Sán Chải',
            prefix: 'Xã',
          },
          {
            id: '7000',
            name: 'Si Ma Cai',
            prefix: 'Xã',
          },
          {
            id: '7001',
            name: 'Sín Chéng',
            prefix: 'Xã',
          },
          {
            id: '7002',
            name: 'Thào Chư Phìn',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '35',
    code: 'NDD',
    name: 'Nam Định',
    districts: [
      {
        id: '435',
        name: 'Giao Thủy',
        wards: [
          {
            id: '7003',
            name: 'Bạch Long',
            prefix: 'Xã',
          },
          {
            id: '7004',
            name: 'Bình Hòa',
            prefix: 'Xã',
          },
          {
            id: '7005',
            name: 'Giao An',
            prefix: 'Xã',
          },
          {
            id: '7006',
            name: 'Giao Châu',
            prefix: 'Xã',
          },
          {
            id: '7007',
            name: 'Giao Hà',
            prefix: 'Xã',
          },
          {
            id: '7008',
            name: 'Giao Hải',
            prefix: 'Xã',
          },
          {
            id: '7009',
            name: 'Giao Hưng',
            prefix: 'Xã',
          },
          {
            id: '7010',
            name: 'Giao Hương',
            prefix: 'Xã',
          },
          {
            id: '7011',
            name: 'Giao Lạc',
            prefix: 'Xã',
          },
          {
            id: '7012',
            name: 'Giao Long',
            prefix: 'Xã',
          },
          {
            id: '7013',
            name: 'Giao Nhân',
            prefix: 'Xã',
          },
          {
            id: '7014',
            name: 'Giao Phong',
            prefix: 'Xã',
          },
          {
            id: '7015',
            name: 'Giao Tân',
            prefix: 'Xã',
          },
          {
            id: '7016',
            name: 'Giao Thanh',
            prefix: 'Xã',
          },
          {
            id: '7017',
            name: 'Giao Thiện',
            prefix: 'Xã',
          },
          {
            id: '7018',
            name: 'Giao Thịnh',
            prefix: 'Xã',
          },
          {
            id: '7019',
            name: 'Giao Tiến',
            prefix: 'Xã',
          },
          {
            id: '7020',
            name: 'Giao Xuân',
            prefix: 'Xã',
          },
          {
            id: '7021',
            name: 'Giao Yến',
            prefix: 'Xã',
          },
          {
            id: '7022',
            name: 'Hoành Sơn',
            prefix: 'Xã',
          },
          {
            id: '7023',
            name: 'Hồng Thuận',
            prefix: 'Xã',
          },
          {
            id: '7024',
            name: 'Ngô Đồng',
            prefix: 'Thị trấn',
          },
          {
            id: '7025',
            name: 'Quất Lâm',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '436',
        name: 'Hải Hậu',
        wards: [
          {
            id: '7026',
            name: 'Cồn',
            prefix: 'Thị trấn',
          },
          {
            id: '7027',
            name: 'Hải An',
            prefix: 'Xã',
          },
          {
            id: '7028',
            name: 'Hải Anh',
            prefix: 'Xã',
          },
          {
            id: '7029',
            name: 'Hải Bắc',
            prefix: 'Xã',
          },
          {
            id: '7030',
            name: 'Hải Châu',
            prefix: 'Xã',
          },
          {
            id: '7031',
            name: 'Hải Chính',
            prefix: 'Xã',
          },
          {
            id: '7032',
            name: 'Hải Cường',
            prefix: 'Xã',
          },
          {
            id: '7033',
            name: 'Hải Đông',
            prefix: 'Xã',
          },
          {
            id: '7034',
            name: 'Hải Đường',
            prefix: 'Xã',
          },
          {
            id: '7035',
            name: 'Hải Giang',
            prefix: 'Xã',
          },
          {
            id: '7036',
            name: 'Hải Hà',
            prefix: 'Xã',
          },
          {
            id: '7037',
            name: 'Hải Hòa',
            prefix: 'Xã',
          },
          {
            id: '7038',
            name: 'Hải Hưng',
            prefix: 'Xã',
          },
          {
            id: '7039',
            name: 'Hải Lộc',
            prefix: 'Xã',
          },
          {
            id: '7040',
            name: 'Hải Long',
            prefix: 'Xã',
          },
          {
            id: '7041',
            name: 'Hải Lý',
            prefix: 'Xã',
          },
          {
            id: '7042',
            name: 'Hải Minh',
            prefix: 'Xã',
          },
          {
            id: '7043',
            name: 'Hải Nam',
            prefix: 'Xã',
          },
          {
            id: '7044',
            name: 'Hải Ninh',
            prefix: 'Xã',
          },
          {
            id: '7045',
            name: 'Hải Phong',
            prefix: 'Xã',
          },
          {
            id: '7046',
            name: 'Hải Phú',
            prefix: 'Xã',
          },
          {
            id: '7047',
            name: 'Hải Phúc',
            prefix: 'Xã',
          },
          {
            id: '7048',
            name: 'Hải Phương',
            prefix: 'Xã',
          },
          {
            id: '7049',
            name: 'Hải Quang',
            prefix: 'Xã',
          },
          {
            id: '7050',
            name: 'Hải Sơn',
            prefix: 'Xã',
          },
          {
            id: '7051',
            name: 'Hải Tân',
            prefix: 'Xã',
          },
          {
            id: '7052',
            name: 'Hải Tây',
            prefix: 'Xã',
          },
          {
            id: '7053',
            name: 'Hải Thanh',
            prefix: 'Xã',
          },
          {
            id: '7054',
            name: 'Hải Toàn',
            prefix: 'Xã',
          },
          {
            id: '7055',
            name: 'Hải Triều',
            prefix: 'Xã',
          },
          {
            id: '7056',
            name: 'Hải Trung',
            prefix: 'Xã',
          },
          {
            id: '7057',
            name: 'Hải Vân',
            prefix: 'Xã',
          },
          {
            id: '7058',
            name: 'Hải Xuân',
            prefix: 'Xã',
          },
          {
            id: '7059',
            name: 'Thịnh Long',
            prefix: 'Thị trấn',
          },
          {
            id: '7060',
            name: 'Yên Định',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '437',
        name: 'Mỹ Lộc',
        wards: [
          {
            id: '7061',
            name: 'Mỹ Hà',
            prefix: 'Xã',
          },
          {
            id: '7062',
            name: 'Mỹ Hưng',
            prefix: 'Xã',
          },
          {
            id: '7063',
            name: 'Mỹ Lộc',
            prefix: 'Thị trấn',
          },
          {
            id: '7064',
            name: 'Mỹ Phúc',
            prefix: 'Xã',
          },
          {
            id: '7065',
            name: 'Mỹ Tân',
            prefix: 'Xã',
          },
          {
            id: '7066',
            name: 'Mỹ Thắng',
            prefix: 'Xã',
          },
          {
            id: '7067',
            name: 'Mỹ Thành',
            prefix: 'Xã',
          },
          {
            id: '7068',
            name: 'Mỹ Thịnh',
            prefix: 'Xã',
          },
          {
            id: '7069',
            name: 'Mỹ Thuận',
            prefix: 'Xã',
          },
          {
            id: '7070',
            name: 'Mỹ Tiến',
            prefix: 'Xã',
          },
          {
            id: '7071',
            name: 'Mỹ Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '438',
        name: 'Nam Định',
        wards: [
          {
            id: '7072',
            name: 'Bà Triệu',
            prefix: 'Phường',
          },
          {
            id: '7073',
            name: 'Cửa Bắc',
            prefix: 'Phường',
          },
          {
            id: '7074',
            name: 'Cửa Nam',
            prefix: 'Phường',
          },
          {
            id: '7075',
            name: 'Hạ Long',
            prefix: 'Phường',
          },
          {
            id: '7076',
            name: 'Lộc An',
            prefix: 'Xã',
          },
          {
            id: '7077',
            name: 'Lộc Hạ',
            prefix: 'Phường',
          },
          {
            id: '7078',
            name: 'Lộc Hòa',
            prefix: 'Xã',
          },
          {
            id: '7079',
            name: 'Lộc Vượng',
            prefix: 'Phường',
          },
          {
            id: '7080',
            name: 'Mỹ Xá',
            prefix: 'Xã',
          },
          {
            id: '7081',
            name: 'Nam Phong',
            prefix: 'Xã',
          },
          {
            id: '7082',
            name: 'Nam Vân',
            prefix: 'Xã',
          },
          {
            id: '7083',
            name: 'Năng Tĩnh',
            prefix: 'Phường',
          },
          {
            id: '7084',
            name: 'Ngô Quyền',
            prefix: 'Phường',
          },
          {
            id: '7085',
            name: 'Nguyễn Du',
            prefix: 'Phường',
          },
          {
            id: '7086',
            name: 'Phan Đình Phùng',
            prefix: 'Phường',
          },
          {
            id: '7087',
            name: 'Quang Trung',
            prefix: 'Phường',
          },
          {
            id: '7088',
            name: 'Thống Nhất',
            prefix: 'Phường',
          },
          {
            id: '7089',
            name: 'Trần Đăng Ninh',
            prefix: 'Phường',
          },
          {
            id: '7090',
            name: 'Trần Hưng Đạo',
            prefix: 'Phường',
          },
          {
            id: '7091',
            name: 'Trần Quang Khải',
            prefix: 'Phường',
          },
          {
            id: '7092',
            name: 'Trần Tế Xương',
            prefix: 'Phường',
          },
          {
            id: '7093',
            name: 'Trường Thi',
            prefix: 'Phường',
          },
          {
            id: '7094',
            name: 'Văn Miếu',
            prefix: 'Phường',
          },
          {
            id: '7095',
            name: 'Vị Hoàng',
            prefix: 'Phường',
          },
          {
            id: '7096',
            name: 'Vị Xuyên',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '439',
        name: 'Nam Trực',
        wards: [
          {
            id: '7097',
            name: 'Bình Minh',
            prefix: 'Xã',
          },
          {
            id: '7098',
            name: 'Điền Xá',
            prefix: 'Xã',
          },
          {
            id: '7099',
            name: 'Đồng Sơn',
            prefix: 'Xã',
          },
          {
            id: '7100',
            name: 'Hồng Quang',
            prefix: 'Xã',
          },
          {
            id: '7101',
            name: 'Nam Cường',
            prefix: 'Xã',
          },
          {
            id: '7102',
            name: 'Nam Dương',
            prefix: 'Xã',
          },
          {
            id: '7103',
            name: 'Nam Giang',
            prefix: 'Thị trấn',
          },
          {
            id: '7104',
            name: 'Nam Hải',
            prefix: 'Xã',
          },
          {
            id: '7105',
            name: 'Nam Hoa',
            prefix: 'Xã',
          },
          {
            id: '7106',
            name: 'Nam Hồng',
            prefix: 'Xã',
          },
          {
            id: '7107',
            name: 'Nam Hùng',
            prefix: 'Xã',
          },
          {
            id: '7108',
            name: 'Nam Lợi',
            prefix: 'Xã',
          },
          {
            id: '7109',
            name: 'Nam Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7110',
            name: 'Nam Thái',
            prefix: 'Xã',
          },
          {
            id: '7111',
            name: 'Nam Thắng',
            prefix: 'Xã',
          },
          {
            id: '7112',
            name: 'Nam Thanh',
            prefix: 'Xã',
          },
          {
            id: '7113',
            name: 'Nam Tiến',
            prefix: 'Xã',
          },
          {
            id: '7114',
            name: 'Nam Toàn',
            prefix: 'Xã',
          },
          {
            id: '7115',
            name: 'Nghĩa An',
            prefix: 'Xã',
          },
          {
            id: '7116',
            name: 'Tân Thịnh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '440',
        name: 'Nghĩa Hưng',
        wards: [
          {
            id: '7117',
            name: 'Hoàng Nam',
            prefix: 'Xã',
          },
          {
            id: '7118',
            name: 'Liễu Đề',
            prefix: 'Thị trấn',
          },
          {
            id: '7119',
            name: 'Nam Điền',
            prefix: 'Xã',
          },
          {
            id: '7120',
            name: 'Nghĩa Bình',
            prefix: 'Xã',
          },
          {
            id: '7121',
            name: 'Nghĩa Châu',
            prefix: 'Xã',
          },
          {
            id: '7122',
            name: 'Nghĩa Đồng',
            prefix: 'Xã',
          },
          {
            id: '7123',
            name: 'Nghĩa Hải',
            prefix: 'Xã',
          },
          {
            id: '7124',
            name: 'Nghĩa Hồng',
            prefix: 'Xã',
          },
          {
            id: '7125',
            name: 'Nghĩa Hùng',
            prefix: 'Xã',
          },
          {
            id: '7126',
            name: 'Nghĩa Lạc',
            prefix: 'Xã',
          },
          {
            id: '7127',
            name: 'Nghĩa Lâm',
            prefix: 'Xã',
          },
          {
            id: '7128',
            name: 'Nghĩa Lợi',
            prefix: 'Xã',
          },
          {
            id: '7129',
            name: 'Nghĩa Minh',
            prefix: 'Xã',
          },
          {
            id: '7130',
            name: 'Nghĩa Phong',
            prefix: 'Xã',
          },
          {
            id: '7131',
            name: 'Nghĩa Phú',
            prefix: 'Xã',
          },
          {
            id: '7132',
            name: 'Nghĩa Phúc',
            prefix: 'Xã',
          },
          {
            id: '7133',
            name: 'Nghĩa Sơn',
            prefix: 'Xã',
          },
          {
            id: '7134',
            name: 'Nghĩa Tân',
            prefix: 'Xã',
          },
          {
            id: '7135',
            name: 'Nghĩa Thái',
            prefix: 'Xã',
          },
          {
            id: '7136',
            name: 'Nghĩa Thắng',
            prefix: 'Xã',
          },
          {
            id: '7137',
            name: 'Nghĩa Thành',
            prefix: 'Xã',
          },
          {
            id: '7138',
            name: 'Nghĩa Thịnh',
            prefix: 'Xã',
          },
          {
            id: '7139',
            name: 'Nghĩa Trung',
            prefix: 'Xã',
          },
          {
            id: '7140',
            name: 'Quỹ Nhất',
            prefix: 'Thị trấn',
          },
          {
            id: '7141',
            name: 'Rạng Đông',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '441',
        name: 'Trực Ninh',
        wards: [
          {
            id: '7142',
            name: 'Cát Thành',
            prefix: 'Thị trấn',
          },
          {
            id: '7143',
            name: 'Cổ Lễ',
            prefix: 'Thị trấn',
          },
          {
            id: '7144',
            name: 'Liêm Hải',
            prefix: 'Xã',
          },
          {
            id: '7145',
            name: 'Phương Định',
            prefix: 'Xã',
          },
          {
            id: '7146',
            name: 'Trực Chính',
            prefix: 'Xã',
          },
          {
            id: '7147',
            name: 'Trực Cường',
            prefix: 'Xã',
          },
          {
            id: '7148',
            name: 'Trực Đại',
            prefix: 'Xã',
          },
          {
            id: '7149',
            name: 'Trực Đạo',
            prefix: 'Xã',
          },
          {
            id: '7150',
            name: 'Trực Hùng',
            prefix: 'Xã',
          },
          {
            id: '7151',
            name: 'Trực Hưng',
            prefix: 'Xã',
          },
          {
            id: '7152',
            name: 'Trực Khang',
            prefix: 'Xã',
          },
          {
            id: '7153',
            name: 'Trực Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7154',
            name: 'Trực Nội',
            prefix: 'Xã',
          },
          {
            id: '7155',
            name: 'Trực Phú',
            prefix: 'Xã',
          },
          {
            id: '7156',
            name: 'Trực Thái',
            prefix: 'Xã',
          },
          {
            id: '7157',
            name: 'Trực Thắng',
            prefix: 'Xã',
          },
          {
            id: '7158',
            name: 'Trực Thanh',
            prefix: 'Xã',
          },
          {
            id: '7159',
            name: 'Trực Thuận',
            prefix: 'Xã',
          },
          {
            id: '7160',
            name: 'Trực Tuấn',
            prefix: 'Xã',
          },
          {
            id: '7161',
            name: 'Trung Đông',
            prefix: 'Xã',
          },
          {
            id: '7162',
            name: 'Việt Hùng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '442',
        name: 'Vụ Bản',
        wards: [
          {
            id: '7163',
            name: 'Cộng Hòa',
            prefix: 'Xã',
          },
          {
            id: '7164',
            name: 'Đại An',
            prefix: 'Xã',
          },
          {
            id: '7165',
            name: 'Đại Thắng',
            prefix: 'Xã',
          },
          {
            id: '7166',
            name: 'Gôi',
            prefix: 'Thị trấn',
          },
          {
            id: '7167',
            name: 'Hiển Khánh',
            prefix: 'Xã',
          },
          {
            id: '7168',
            name: 'Hợp Hưng',
            prefix: 'Xã',
          },
          {
            id: '7169',
            name: 'Kim Thái',
            prefix: 'Xã',
          },
          {
            id: '7170',
            name: 'Liên Bảo',
            prefix: 'Xã',
          },
          {
            id: '7171',
            name: 'Liên Minh',
            prefix: 'Xã',
          },
          {
            id: '7172',
            name: 'Minh Tân',
            prefix: 'Xã',
          },
          {
            id: '7173',
            name: 'Minh Thuận',
            prefix: 'Xã',
          },
          {
            id: '7174',
            name: 'Quang Trung',
            prefix: 'Xã',
          },
          {
            id: '7175',
            name: 'Tam Thanh',
            prefix: 'Xã',
          },
          {
            id: '7176',
            name: 'Tân Khánh',
            prefix: 'Xã',
          },
          {
            id: '7177',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '7178',
            name: 'Thành Lợi',
            prefix: 'Xã',
          },
          {
            id: '7179',
            name: 'Trung Thành',
            prefix: 'Xã',
          },
          {
            id: '7180',
            name: 'Vĩnh Hào',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '443',
        name: 'Xuân Trường',
        wards: [
          {
            id: '7181',
            name: 'Thọ Nghiệp',
            prefix: 'Xã',
          },
          {
            id: '7182',
            name: 'Xuân Bắc',
            prefix: 'Xã',
          },
          {
            id: '7183',
            name: 'Xuân Châu',
            prefix: 'Xã',
          },
          {
            id: '7184',
            name: 'Xuân Đài',
            prefix: 'Xã',
          },
          {
            id: '7185',
            name: 'Xuân Hòa',
            prefix: 'Xã',
          },
          {
            id: '7186',
            name: 'Xuân Hồng',
            prefix: 'Xã',
          },
          {
            id: '7187',
            name: 'Xuân Kiên',
            prefix: 'Xã',
          },
          {
            id: '7188',
            name: 'Xuân Ngọc',
            prefix: 'Xã',
          },
          {
            id: '7189',
            name: 'Xuân Ninh',
            prefix: 'Xã',
          },
          {
            id: '7190',
            name: 'Xuân Phong',
            prefix: 'Xã',
          },
          {
            id: '7191',
            name: 'Xuân Phú',
            prefix: 'Xã',
          },
          {
            id: '7192',
            name: 'Xuân Phương',
            prefix: 'Xã',
          },
          {
            id: '7193',
            name: 'Xuân Tân',
            prefix: 'Xã',
          },
          {
            id: '7194',
            name: 'Xuân Thành',
            prefix: 'Xã',
          },
          {
            id: '7195',
            name: 'Xuân Thượng',
            prefix: 'Xã',
          },
          {
            id: '7196',
            name: 'Xuân Thủy',
            prefix: 'Xã',
          },
          {
            id: '7197',
            name: 'Xuân Tiến',
            prefix: 'Xã',
          },
          {
            id: '7198',
            name: 'Xuân Trung',
            prefix: 'Xã',
          },
          {
            id: '7199',
            name: 'Xuân Trường',
            prefix: 'Thị trấn',
          },
          {
            id: '7200',
            name: 'Xuân Vinh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '444',
        name: 'Ý Yên',
        wards: [
          {
            id: '7201',
            name: 'Lâm',
            prefix: 'Thị trấn',
          },
          {
            id: '7202',
            name: 'Yên Bằng',
            prefix: 'Xã',
          },
          {
            id: '7203',
            name: 'Yên Bình',
            prefix: 'Xã',
          },
          {
            id: '7204',
            name: 'Yên Chính',
            prefix: 'Xã',
          },
          {
            id: '7205',
            name: 'Yên Cường',
            prefix: 'Xã',
          },
          {
            id: '7207',
            name: 'Yên Dương',
            prefix: 'Xã',
          },
          {
            id: '7206',
            name: 'Yên Đồng',
            prefix: 'Xã',
          },
          {
            id: '7208',
            name: 'Yên Hồng',
            prefix: 'Xã',
          },
          {
            id: '7209',
            name: 'Yên Hưng',
            prefix: 'Xã',
          },
          {
            id: '7210',
            name: 'Yên Khang',
            prefix: 'Xã',
          },
          {
            id: '7211',
            name: 'Yên Khánh',
            prefix: 'Xã',
          },
          {
            id: '7212',
            name: 'Yên Lộc',
            prefix: 'Xã',
          },
          {
            id: '7213',
            name: 'Yên Lợi',
            prefix: 'Xã',
          },
          {
            id: '7214',
            name: 'Yên Lương',
            prefix: 'Xã',
          },
          {
            id: '7215',
            name: 'Yên Minh',
            prefix: 'Xã',
          },
          {
            id: '7216',
            name: 'Yên Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7217',
            name: 'Yên Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '7218',
            name: 'Yên Nhân',
            prefix: 'Xã',
          },
          {
            id: '7219',
            name: 'Yên Ninh',
            prefix: 'Xã',
          },
          {
            id: '7220',
            name: 'Yên Phong',
            prefix: 'Xã',
          },
          {
            id: '7221',
            name: 'Yên Phú',
            prefix: 'Xã',
          },
          {
            id: '7222',
            name: 'Yên Phúc',
            prefix: 'Xã',
          },
          {
            id: '7223',
            name: 'Yên Phương',
            prefix: 'Xã',
          },
          {
            id: '7224',
            name: 'Yên Quang',
            prefix: 'Xã',
          },
          {
            id: '7225',
            name: 'Yên Tân',
            prefix: 'Xã',
          },
          {
            id: '7226',
            name: 'Yên Thắng',
            prefix: 'Xã',
          },
          {
            id: '7227',
            name: 'Yên Thành',
            prefix: 'Xã',
          },
          {
            id: '7228',
            name: 'Yên Thọ',
            prefix: 'Xã',
          },
          {
            id: '7229',
            name: 'Yên Tiến',
            prefix: 'Xã',
          },
          {
            id: '7230',
            name: 'Yên Trị',
            prefix: 'Xã',
          },
          {
            id: '7231',
            name: 'Yên Trung',
            prefix: 'Xã',
          },
          {
            id: '7232',
            name: 'Yên Xá',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '36',
    code: 'QNG',
    name: 'Quảng Ngãi',
    districts: [
      {
        id: '445',
        name: 'Ba Tơ',
        wards: [
          {
            id: '7233',
            name: 'Ba Bích',
            prefix: 'Xã',
          },
          {
            id: '7234',
            name: 'Ba Chùa',
            prefix: 'Xã',
          },
          {
            id: '7235',
            name: 'Ba Cung',
            prefix: 'Xã',
          },
          {
            id: '7237',
            name: 'Ba Dinh',
            prefix: 'Xã',
          },
          {
            id: '7236',
            name: 'Ba Điền',
            prefix: 'Xã',
          },
          {
            id: '7238',
            name: 'Ba Động',
            prefix: 'Xã',
          },
          {
            id: '7239',
            name: 'Ba Giang',
            prefix: 'Xã',
          },
          {
            id: '7240',
            name: 'Ba Khâm',
            prefix: 'Xã',
          },
          {
            id: '7241',
            name: 'Ba Lế',
            prefix: 'Xã',
          },
          {
            id: '7242',
            name: 'Ba Liên',
            prefix: 'Xã',
          },
          {
            id: '7243',
            name: 'Ba Nam',
            prefix: 'Xã',
          },
          {
            id: '7244',
            name: 'Ba Ngạc',
            prefix: 'Xã',
          },
          {
            id: '7245',
            name: 'Ba Thành',
            prefix: 'Xã',
          },
          {
            id: '7246',
            name: 'Ba Tiêu',
            prefix: 'Xã',
          },
          {
            id: '7247',
            name: 'Ba Tô',
            prefix: 'Xã',
          },
          {
            id: '7248',
            name: 'Ba Tơ',
            prefix: 'Thị trấn',
          },
          {
            id: '7249',
            name: 'Ba Trang',
            prefix: 'Xã',
          },
          {
            id: '7250',
            name: 'Ba Vì',
            prefix: 'Xã',
          },
          {
            id: '7251',
            name: 'Ba Vinh',
            prefix: 'Xã',
          },
          {
            id: '7252',
            name: 'Ba Xa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '446',
        name: 'Bình Sơn',
        wards: [
          {
            id: '7253',
            name: 'Bình An',
            prefix: 'Xã',
          },
          {
            id: '7254',
            name: 'Bình Chánh',
            prefix: 'Xã',
          },
          {
            id: '7255',
            name: 'Bình Châu',
            prefix: 'Xã',
          },
          {
            id: '7256',
            name: 'Bình Chương',
            prefix: 'Xã',
          },
          {
            id: '7258',
            name: 'Bình Dương',
            prefix: 'Xã',
          },
          {
            id: '7257',
            name: 'Bình Đông',
            prefix: 'Xã',
          },
          {
            id: '7259',
            name: 'Bình Hải',
            prefix: 'Xã',
          },
          {
            id: '7260',
            name: 'Bình Hiệp',
            prefix: 'Xã',
          },
          {
            id: '7261',
            name: 'Bình Hòa',
            prefix: 'Xã',
          },
          {
            id: '7262',
            name: 'Bình Khương',
            prefix: 'Xã',
          },
          {
            id: '7263',
            name: 'Bình Long',
            prefix: 'Xã',
          },
          {
            id: '7264',
            name: 'Bình Minh',
            prefix: 'Xã',
          },
          {
            id: '7265',
            name: 'Bình Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7266',
            name: 'Bình Nguyên',
            prefix: 'Xã',
          },
          {
            id: '7267',
            name: 'Bình Phú',
            prefix: 'Xã',
          },
          {
            id: '7268',
            name: 'Bình Phước',
            prefix: 'Xã',
          },
          {
            id: '7269',
            name: 'Bình Tân',
            prefix: 'Xã',
          },
          {
            id: '7270',
            name: 'Bình Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7271',
            name: 'Bình Thanh Đông',
            prefix: 'Xã',
          },
          {
            id: '7272',
            name: 'Bình Thanh Tây',
            prefix: 'Xã',
          },
          {
            id: '7273',
            name: 'Bình Thới',
            prefix: 'Xã',
          },
          {
            id: '7274',
            name: 'Bình Thuận',
            prefix: 'Xã',
          },
          {
            id: '7275',
            name: 'Bình Trị',
            prefix: 'Xã',
          },
          {
            id: '7276',
            name: 'Bình Trung',
            prefix: 'Xã',
          },
          {
            id: '7277',
            name: 'Châu Ổ',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '447',
        name: 'Đức Phổ',
        wards: [
          {
            id: '7278',
            name: 'Đức Phổ',
            prefix: 'Thị trấn',
          },
          {
            id: '7279',
            name: 'Phổ An',
            prefix: 'Xã',
          },
          {
            id: '7280',
            name: 'Phổ Châu',
            prefix: 'Xã',
          },
          {
            id: '7281',
            name: 'Phổ Cường',
            prefix: 'Xã',
          },
          {
            id: '7282',
            name: 'Phổ Hòa',
            prefix: 'Xã',
          },
          {
            id: '7283',
            name: 'Phổ Khánh',
            prefix: 'Xã',
          },
          {
            id: '7284',
            name: 'Phổ Minh',
            prefix: 'Xã',
          },
          {
            id: '7285',
            name: 'Phổ Nhơn',
            prefix: 'Xã',
          },
          {
            id: '7286',
            name: 'Phổ Ninh',
            prefix: 'Xã',
          },
          {
            id: '7287',
            name: 'Phổ Phong',
            prefix: 'Xã',
          },
          {
            id: '7288',
            name: 'Phổ Quang',
            prefix: 'Xã',
          },
          {
            id: '7289',
            name: 'Phổ Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7290',
            name: 'Phổ Thuận',
            prefix: 'Xã',
          },
          {
            id: '7291',
            name: 'Phổ Văn',
            prefix: 'Xã',
          },
          {
            id: '7292',
            name: 'Phổ Vinh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '448',
        name: 'Lý Sơn',
        wards: [
          {
            id: '7293',
            name: 'An Bình',
            prefix: 'Xã',
          },
          {
            id: '7294',
            name: 'An Hải',
            prefix: 'Xã',
          },
          {
            id: '7295',
            name: 'An Vĩnh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '449',
        name: 'Minh Long',
        wards: [
          {
            id: '7296',
            name: 'Long Hiệp',
            prefix: 'Xã',
          },
          {
            id: '7297',
            name: 'Long Mai',
            prefix: 'Xã',
          },
          {
            id: '7298',
            name: 'Long Môn',
            prefix: 'Xã',
          },
          {
            id: '7299',
            name: 'Long Sơn',
            prefix: 'Xã',
          },
          {
            id: '7300',
            name: 'Thanh An',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '450',
        name: 'Mộ Đức',
        wards: [
          {
            id: '7301',
            name: 'Đức Chánh',
            prefix: 'Xã',
          },
          {
            id: '7302',
            name: 'Đức Hiệp',
            prefix: 'Xã',
          },
          {
            id: '7303',
            name: 'Đức Hòa',
            prefix: 'Xã',
          },
          {
            id: '7304',
            name: 'Đức Lân',
            prefix: 'Xã',
          },
          {
            id: '7305',
            name: 'Đức Lợi',
            prefix: 'Xã',
          },
          {
            id: '7306',
            name: 'Đức Minh',
            prefix: 'Xã',
          },
          {
            id: '7307',
            name: 'Đức Nhuận',
            prefix: 'Xã',
          },
          {
            id: '7308',
            name: 'Đức Phong',
            prefix: 'Xã',
          },
          {
            id: '7309',
            name: 'Đức Phú',
            prefix: 'Xã',
          },
          {
            id: '7310',
            name: 'Đức Tân',
            prefix: 'Xã',
          },
          {
            id: '7311',
            name: 'Đức Thắng',
            prefix: 'Xã',
          },
          {
            id: '7312',
            name: 'Đức Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7313',
            name: 'Mộ Đức',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '451',
        name: 'Nghĩa Hành',
        wards: [
          {
            id: '7314',
            name: 'Chợ Chùa',
            prefix: 'Thị trấn',
          },
          {
            id: '7316',
            name: 'Hành Dũng',
            prefix: 'Xã',
          },
          {
            id: '7315',
            name: 'Hành Đức',
            prefix: 'Xã',
          },
          {
            id: '7317',
            name: 'Hành Minh',
            prefix: 'Xã',
          },
          {
            id: '7318',
            name: 'Hành Nhân',
            prefix: 'Xã',
          },
          {
            id: '7319',
            name: 'Hành Phước',
            prefix: 'Xã',
          },
          {
            id: '7320',
            name: 'Hành Thiện',
            prefix: 'Xã',
          },
          {
            id: '7321',
            name: 'Hành Thịnh',
            prefix: 'Xã',
          },
          {
            id: '7322',
            name: 'Hành Thuận',
            prefix: 'Xã',
          },
          {
            id: '7323',
            name: 'Hành Tín Đông',
            prefix: 'Xã',
          },
          {
            id: '7324',
            name: 'Hành Tín Tây',
            prefix: 'Xã',
          },
          {
            id: '7325',
            name: 'Hành Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '452',
        name: 'Quảng Ngãi',
        wards: [
          {
            id: '7326',
            name: 'Chánh Lộ',
            prefix: 'Phường',
          },
          {
            id: '7327',
            name: 'Lê Hồng Phong',
            prefix: 'Phường',
          },
          {
            id: '7328',
            name: 'Nghĩa Chánh',
            prefix: 'Phường',
          },
          {
            id: '7329',
            name: 'Nghĩa Dõng',
            prefix: 'Xã',
          },
          {
            id: '7330',
            name: 'Nghĩa Dũng',
            prefix: 'Xã',
          },
          {
            id: '7331',
            name: 'Nghĩa Hà',
            prefix: 'Xã',
          },
          {
            id: '7332',
            name: 'Nghĩa Lộ',
            prefix: 'Phường',
          },
          {
            id: '7333',
            name: 'Nghĩa Phú',
            prefix: 'Xã',
          },
          {
            id: '7334',
            name: 'Nguyễn Nghiêm',
            prefix: 'Phường',
          },
          {
            id: '7335',
            name: 'Quảng Phú',
            prefix: 'Phường',
          },
          {
            id: '7336',
            name: 'Tịnh Ấn Tây',
            prefix: 'Xã',
          },
          {
            id: '7337',
            name: 'Trần Hưng Đạo',
            prefix: 'Phường',
          },
          {
            id: '7338',
            name: 'Trần Phú',
            prefix: 'Phường',
          },
          {
            id: '7339',
            name: 'Trương Quang Trọng',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '453',
        name: 'Sơn Hà',
        wards: [
          {
            id: '7340',
            name: 'Di Lăng',
            prefix: 'Thị trấn',
          },
          {
            id: '7341',
            name: 'Sơn Ba',
            prefix: 'Xã',
          },
          {
            id: '7342',
            name: 'Sơn Bao',
            prefix: 'Xã',
          },
          {
            id: '7343',
            name: 'Sơn Cao',
            prefix: 'Xã',
          },
          {
            id: '7344',
            name: 'Sơn Giang',
            prefix: 'Xã',
          },
          {
            id: '7345',
            name: 'Sơn Hạ',
            prefix: 'Xã',
          },
          {
            id: '7346',
            name: 'Sơn Hải',
            prefix: 'Xã',
          },
          {
            id: '7347',
            name: 'Sơn Kỳ',
            prefix: 'Xã',
          },
          {
            id: '7348',
            name: 'Sơn Linh',
            prefix: 'Xã',
          },
          {
            id: '7349',
            name: 'Sơn Nham',
            prefix: 'Xã',
          },
          {
            id: '7350',
            name: 'Sơn Thành',
            prefix: 'Xã',
          },
          {
            id: '7351',
            name: 'Sơn Thượng',
            prefix: 'Xã',
          },
          {
            id: '7352',
            name: 'Sơn Thủy',
            prefix: 'Xã',
          },
          {
            id: '7353',
            name: 'Sơn Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '454',
        name: 'Sơn Tây',
        wards: [
          {
            id: '7354',
            name: 'Sơn Bua',
            prefix: 'Xã',
          },
          {
            id: '7355',
            name: 'Sơn Dung',
            prefix: 'Xã',
          },
          {
            id: '7356',
            name: 'Sơn Lập',
            prefix: 'Xã',
          },
          {
            id: '7357',
            name: 'Sơn Liên',
            prefix: 'Xã',
          },
          {
            id: '7358',
            name: 'Sơn Long',
            prefix: 'Xã',
          },
          {
            id: '7359',
            name: 'Sơn Màu',
            prefix: 'Xã',
          },
          {
            id: '7360',
            name: 'Sơn Mùa',
            prefix: 'Xã',
          },
          {
            id: '7361',
            name: 'Sơn Tân',
            prefix: 'Xã',
          },
          {
            id: '7362',
            name: 'Sơn Tinh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '455',
        name: 'Sơn Tịnh',
        wards: [
          {
            id: '7363',
            name: 'Sơn Tịnh',
            prefix: 'Thị trấn',
          },
          {
            id: '7364',
            name: 'Tịnh An',
            prefix: 'Xã',
          },
          {
            id: '7365',
            name: 'Tịnh Ấn Đông',
            prefix: 'Xã',
          },
          {
            id: '7366',
            name: 'Tịnh Ấn Tây',
            prefix: 'Xã',
          },
          {
            id: '7367',
            name: 'Tịnh bắc',
            prefix: 'Xã',
          },
          {
            id: '7368',
            name: 'Tịnh Bình',
            prefix: 'Xã',
          },
          {
            id: '7369',
            name: 'Tịnh Châu',
            prefix: 'Xã',
          },
          {
            id: '7370',
            name: 'Tịnh Đông',
            prefix: 'Xã',
          },
          {
            id: '7371',
            name: 'Tịnh Giang',
            prefix: 'Xã',
          },
          {
            id: '7372',
            name: 'Tịnh Hà',
            prefix: 'Xã',
          },
          {
            id: '7373',
            name: 'Tịnh Hiệp',
            prefix: 'Xã',
          },
          {
            id: '7374',
            name: 'Tịnh Hòa',
            prefix: 'Xã',
          },
          {
            id: '7375',
            name: 'Tịnh Khê',
            prefix: 'Xã',
          },
          {
            id: '7376',
            name: 'Tịnh Kỳ',
            prefix: 'Xã',
          },
          {
            id: '7377',
            name: 'Tịnh Long',
            prefix: 'Xã',
          },
          {
            id: '7378',
            name: 'Tịnh Minh',
            prefix: 'Xã',
          },
          {
            id: '7379',
            name: 'Tịnh Phong',
            prefix: 'Xã',
          },
          {
            id: '7380',
            name: 'Tịnh Sơn',
            prefix: 'Xã',
          },
          {
            id: '7381',
            name: 'Tịnh Thiện',
            prefix: 'Xã',
          },
          {
            id: '7382',
            name: 'Tịnh Thọ',
            prefix: 'Xã',
          },
          {
            id: '7383',
            name: 'Tịnh Trà',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '456',
        name: 'Tây Trà',
        wards: [
          {
            id: '7384',
            name: 'Trà Khê',
            prefix: 'Xã',
          },
          {
            id: '7385',
            name: 'Trà Lãnh',
            prefix: 'Xã',
          },
          {
            id: '7386',
            name: 'Trà Nham',
            prefix: 'Xã',
          },
          {
            id: '7387',
            name: 'Trà Phong',
            prefix: 'Xã',
          },
          {
            id: '7388',
            name: 'Trà Quân',
            prefix: 'Xã',
          },
          {
            id: '7389',
            name: 'Trà Thanh',
            prefix: 'Xã',
          },
          {
            id: '7390',
            name: 'Trà Thọ',
            prefix: 'Xã',
          },
          {
            id: '7391',
            name: 'Trà Trung',
            prefix: 'Xã',
          },
          {
            id: '7392',
            name: 'Trà Xinh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '457',
        name: 'Trà Bồng',
        wards: [
          {
            id: '7393',
            name: 'Trà Bình',
            prefix: 'Xã',
          },
          {
            id: '7394',
            name: 'Trà Bùi',
            prefix: 'Xã',
          },
          {
            id: '7395',
            name: 'Trà Giang',
            prefix: 'Xã',
          },
          {
            id: '7396',
            name: 'Trà Hiệp',
            prefix: 'Xã',
          },
          {
            id: '7397',
            name: 'Trà Lâm',
            prefix: 'Xã',
          },
          {
            id: '7398',
            name: 'Trà Phú',
            prefix: 'Xã',
          },
          {
            id: '7399',
            name: 'Trà Sơn',
            prefix: 'Xã',
          },
          {
            id: '7400',
            name: 'Trà Tân',
            prefix: 'Xã',
          },
          {
            id: '7401',
            name: 'Trà Thủy',
            prefix: 'Xã',
          },
          {
            id: '7402',
            name: 'Trà Xuân',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '458',
        name: 'Tư Nghĩa',
        wards: [
          {
            id: '7403',
            name: 'La Hà',
            prefix: 'Thị trấn',
          },
          {
            id: '7404',
            name: 'Nghĩa An',
            prefix: 'Xã',
          },
          {
            id: '7405',
            name: 'Nghĩa Điền',
            prefix: 'Xã',
          },
          {
            id: '7406',
            name: 'Nghĩa Hiệp',
            prefix: 'Xã',
          },
          {
            id: '7407',
            name: 'Nghĩa Hòa',
            prefix: 'Xã',
          },
          {
            id: '7408',
            name: 'Nghĩa Kỳ',
            prefix: 'Xã',
          },
          {
            id: '7409',
            name: 'Nghĩa Lâm',
            prefix: 'Xã',
          },
          {
            id: '7410',
            name: 'Nghĩa Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7411',
            name: 'Nghĩa Phú',
            prefix: 'Xã',
          },
          {
            id: '7412',
            name: 'Nghĩa Phương',
            prefix: 'Xã',
          },
          {
            id: '7413',
            name: 'Nghĩa Sơn',
            prefix: 'Xã',
          },
          {
            id: '7414',
            name: 'Nghĩa Thắng',
            prefix: 'Xã',
          },
          {
            id: '7415',
            name: 'Nghĩa Thọ',
            prefix: 'Xã',
          },
          {
            id: '7416',
            name: 'Nghĩa Thuận',
            prefix: 'Xã',
          },
          {
            id: '7417',
            name: 'Nghĩa Thương',
            prefix: 'Xã',
          },
          {
            id: '7418',
            name: 'Nghĩa Trung',
            prefix: 'Xã',
          },
          {
            id: '7419',
            name: 'Sông Vệ',
            prefix: 'Thị trấn',
          },
        ],
      },
    ],
  },
  {
    id: '37',
    code: 'BTR',
    name: 'Bến Tre',
    districts: [
      {
        id: '459',
        name: 'Ba Tri',
        wards: [
          {
            id: '7420',
            name: 'An Bình Tây',
            prefix: 'Xã',
          },
          {
            id: '7421',
            name: 'An Đức',
            prefix: 'Xã',
          },
          {
            id: '7422',
            name: 'An Hiệp',
            prefix: 'Xã',
          },
          {
            id: '7423',
            name: 'An Hòa Tây',
            prefix: 'Xã',
          },
          {
            id: '7424',
            name: 'An Ngãi Tây',
            prefix: 'Xã',
          },
          {
            id: '7425',
            name: 'An Ngãi Trung',
            prefix: 'Xã',
          },
          {
            id: '7426',
            name: 'An Phú Trung',
            prefix: 'Xã',
          },
          {
            id: '7427',
            name: 'An Thủy',
            prefix: 'Xã',
          },
          {
            id: '7428',
            name: 'Ba Tri',
            prefix: 'Thị trấn',
          },
          {
            id: '7429',
            name: 'Bảo Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7430',
            name: 'Bảo Thuận',
            prefix: 'Xã',
          },
          {
            id: '7431',
            name: 'Mỹ Chánh',
            prefix: 'Xã',
          },
          {
            id: '7432',
            name: 'Mỹ Hòa',
            prefix: 'Xã',
          },
          {
            id: '7433',
            name: 'Mỹ Nhơn',
            prefix: 'Xã',
          },
          {
            id: '7434',
            name: 'Mỹ Thạn',
            prefix: 'Xã',
          },
          {
            id: '7435',
            name: 'Mỹ Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7436',
            name: 'Phú Lễ',
            prefix: 'Xã',
          },
          {
            id: '7437',
            name: 'Phú Ngãi',
            prefix: 'Xã',
          },
          {
            id: '7438',
            name: 'Phước Tuy',
            prefix: 'Xã',
          },
          {
            id: '7439',
            name: 'Tân Hưng',
            prefix: 'Xã',
          },
          {
            id: '7440',
            name: 'Tân Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7441',
            name: 'Tân Thủy',
            prefix: 'Xã',
          },
          {
            id: '7442',
            name: 'Tân Xuân',
            prefix: 'Xã',
          },
          {
            id: '7443',
            name: 'Vĩnh An',
            prefix: 'Xã',
          },
          {
            id: '7444',
            name: 'Vĩnh Hòa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '460',
        name: 'Bến Tre',
        wards: [
          {
            id: '7445',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '7446',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '7447',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '7448',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '7449',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '7450',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '7451',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '7452',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '7453',
            name: 'Bình Phú',
            prefix: 'Xã',
          },
          {
            id: '7454',
            name: 'Mỹ Thành',
            prefix: 'Xã',
          },
          {
            id: '7455',
            name: 'Mỹ Thạnh An',
            prefix: 'Xã',
          },
          {
            id: '7456',
            name: 'Nhơn Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7457',
            name: 'Phú Hưng',
            prefix: 'Xã',
          },
          {
            id: '7458',
            name: 'Phú Khương',
            prefix: 'Phường',
          },
          {
            id: '7459',
            name: 'Phú Nhuận',
            prefix: 'Xã',
          },
          {
            id: '7460',
            name: 'Phú Tân',
            prefix: 'Phường',
          },
          {
            id: '7461',
            name: 'Sơn Đông',
            prefix: 'Xã',
          },
          {
            id: '7462',
            name: 'Sơn Đông',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '461',
        name: 'Bình Đại',
        wards: [
          {
            id: '7463',
            name: 'Bình Đại',
            prefix: 'Thị trấn',
          },
          {
            id: '7464',
            name: 'Bình Thắng',
            prefix: 'Xã',
          },
          {
            id: '7465',
            name: 'Bình Thới',
            prefix: 'Xã',
          },
          {
            id: '7466',
            name: 'Châu Hưng',
            prefix: 'Xã',
          },
          {
            id: '7467',
            name: 'Đại Hòa Lộc',
            prefix: 'Xã',
          },
          {
            id: '7468',
            name: 'Định Trung',
            prefix: 'Xã',
          },
          {
            id: '7469',
            name: 'Lộc Thuận',
            prefix: 'Xã',
          },
          {
            id: '7470',
            name: 'Long Định',
            prefix: 'Xã',
          },
          {
            id: '7471',
            name: 'Long Hòa',
            prefix: 'Xã',
          },
          {
            id: '7472',
            name: 'Phú Long',
            prefix: 'Xã',
          },
          {
            id: '7473',
            name: 'Phú Thuận',
            prefix: 'Xã',
          },
          {
            id: '7474',
            name: 'Phú Vang',
            prefix: 'Xã',
          },
          {
            id: '7475',
            name: 'Tam Hiệp',
            prefix: 'Xã',
          },
          {
            id: '7476',
            name: 'Thạnh Phước',
            prefix: 'Xã',
          },
          {
            id: '7477',
            name: 'Thạnh Trị',
            prefix: 'Xã',
          },
          {
            id: '7478',
            name: 'Thới Lai',
            prefix: 'Xã',
          },
          {
            id: '7479',
            name: 'Thới Thuận',
            prefix: 'Xã',
          },
          {
            id: '7480',
            name: 'Thừa Đức',
            prefix: 'Xã',
          },
          {
            id: '7481',
            name: 'Vang Quới Đông',
            prefix: 'Xã',
          },
          {
            id: '7482',
            name: 'Vang Quới Tây',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '462',
        name: 'Châu Thành',
        wards: [
          {
            id: '7483',
            name: 'An Hiệp',
            prefix: 'Xã',
          },
          {
            id: '7484',
            name: 'An Hóa',
            prefix: 'Xã',
          },
          {
            id: '7485',
            name: 'An Khánh',
            prefix: 'Xã',
          },
          {
            id: '7486',
            name: 'An Phước',
            prefix: 'Xã',
          },
          {
            id: '7487',
            name: 'Châu Thành',
            prefix: 'Thị trấn',
          },
          {
            id: '7488',
            name: 'Giao Hòa',
            prefix: 'Xã',
          },
          {
            id: '7489',
            name: 'Giao Long',
            prefix: 'Xã',
          },
          {
            id: '7490',
            name: 'Hữu Định',
            prefix: 'Xã',
          },
          {
            id: '7491',
            name: 'Phú An Hòa',
            prefix: 'Xã',
          },
          {
            id: '7492',
            name: 'Phú Đức',
            prefix: 'Xã',
          },
          {
            id: '7493',
            name: 'Phú Túc',
            prefix: 'Xã',
          },
          {
            id: '7494',
            name: 'Phước Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7495',
            name: 'Quới Sơn',
            prefix: 'Xã',
          },
          {
            id: '7496',
            name: 'Quới Thành',
            prefix: 'Xã',
          },
          {
            id: '7497',
            name: 'Sơn Hòa',
            prefix: 'Xã',
          },
          {
            id: '7498',
            name: 'Tam Phước',
            prefix: 'Xã',
          },
          {
            id: '7499',
            name: 'Tân Phú',
            prefix: 'Xã',
          },
          {
            id: '7500',
            name: 'Tân Thạch',
            prefix: 'Xã',
          },
          {
            id: '7501',
            name: 'Thành Triệu',
            prefix: 'Xã',
          },
          {
            id: '7502',
            name: 'Tiên Long',
            prefix: 'Xã',
          },
          {
            id: '7503',
            name: 'Tiên Thủy',
            prefix: 'Xã',
          },
          {
            id: '7504',
            name: 'Tường Đa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '463',
        name: 'Chợ Lách',
        wards: [
          {
            id: '7505',
            name: 'Chợ Lách',
            prefix: 'Thị trấn',
          },
          {
            id: '7506',
            name: 'Hòa Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '7507',
            name: 'Hưng Khánh Trung B',
            prefix: 'Xã',
          },
          {
            id: '7508',
            name: 'Long Thới',
            prefix: 'Xã',
          },
          {
            id: '7509',
            name: 'Phú Phụng',
            prefix: 'Xã',
          },
          {
            id: '7510',
            name: 'Phú Sơn',
            prefix: 'Xã',
          },
          {
            id: '7511',
            name: 'Sơn Định',
            prefix: 'Xã',
          },
          {
            id: '7512',
            name: 'Tân Thiềng',
            prefix: 'Xã',
          },
          {
            id: '7513',
            name: 'Vĩnh Bình',
            prefix: 'Xã',
          },
          {
            id: '7514',
            name: 'Vĩnh Hòa',
            prefix: 'Xã',
          },
          {
            id: '7515',
            name: 'Vĩnh Thành',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '464',
        name: 'Giồng Trôm',
        wards: [
          {
            id: '7516',
            name: 'Bình Hòa',
            prefix: 'Xã',
          },
          {
            id: '7517',
            name: 'Bình Thành',
            prefix: 'Xã',
          },
          {
            id: '7518',
            name: 'Châu Bình',
            prefix: 'Xã',
          },
          {
            id: '7519',
            name: 'Châu Hòa',
            prefix: 'Xã',
          },
          {
            id: '7520',
            name: 'Giồng Trôm',
            prefix: 'Thị trấn',
          },
          {
            id: '7521',
            name: 'Hưng Lễ',
            prefix: 'Xã',
          },
          {
            id: '7522',
            name: 'Hưng Nhượng',
            prefix: 'Xã',
          },
          {
            id: '7523',
            name: 'Hưng Phong',
            prefix: 'Xã',
          },
          {
            id: '7524',
            name: 'Long Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7525',
            name: 'Lương Hòa',
            prefix: 'Xã',
          },
          {
            id: '7526',
            name: 'Lương Phú',
            prefix: 'Xã',
          },
          {
            id: '7527',
            name: 'Lương Quới',
            prefix: 'Xã',
          },
          {
            id: '7528',
            name: 'Mỹ Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7529',
            name: 'Phong Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7530',
            name: 'Phong Nẫm',
            prefix: 'Xã',
          },
          {
            id: '7531',
            name: 'Phước Long',
            prefix: 'Xã',
          },
          {
            id: '7532',
            name: 'Sơn Phú',
            prefix: 'Xã',
          },
          {
            id: '7533',
            name: 'Tân Hào',
            prefix: 'Xã',
          },
          {
            id: '7534',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
          {
            id: '7535',
            name: 'Tân Lợi Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7536',
            name: 'Tân Thanh',
            prefix: 'Xã',
          },
          {
            id: '7537',
            name: 'Thạnh Phú Đông',
            prefix: 'Xã',
          },
          {
            id: '7538',
            name: 'Thuận Điền',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '465',
        name: 'Mỏ Cày Bắc',
        wards: [
          {
            id: '7539',
            name: 'Hòa Lộc',
            prefix: 'Xã',
          },
          {
            id: '7540',
            name: 'Hưng Khánh Trung A',
            prefix: 'Xã',
          },
          {
            id: '7541',
            name: 'Khánh Thạnh Tân',
            prefix: 'Xã',
          },
          {
            id: '7542',
            name: 'Nhuận Phú Tân',
            prefix: 'Xã',
          },
          {
            id: '7543',
            name: 'Phú Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7544',
            name: 'Phước Mỹ Trung',
            prefix: 'Xã',
          },
          {
            id: '7545',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '7546',
            name: 'Tân Phú Tây',
            prefix: 'Xã',
          },
          {
            id: '7547',
            name: 'Tân Thành Bình',
            prefix: 'Xã',
          },
          {
            id: '7548',
            name: 'Tân Thanh Tây',
            prefix: 'Xã',
          },
          {
            id: '7549',
            name: 'Thành An',
            prefix: 'Xã',
          },
          {
            id: '7550',
            name: 'Thạnh Ngãi',
            prefix: 'Xã',
          },
          {
            id: '7551',
            name: 'Thanh Tân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '466',
        name: 'Mỏ Cày Nam',
        wards: [
          {
            id: '7552',
            name: 'An Định',
            prefix: 'Xã',
          },
          {
            id: '7553',
            name: 'An Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7554',
            name: 'An Thới',
            prefix: 'Xã',
          },
          {
            id: '7555',
            name: 'Bình Khánh Đông',
            prefix: 'Xã',
          },
          {
            id: '7556',
            name: 'Bình Khánh Tây',
            prefix: 'Xã',
          },
          {
            id: '7557',
            name: 'Cẩm Sơn',
            prefix: 'Xã',
          },
          {
            id: '7558',
            name: 'Đa Phước Hội',
            prefix: 'Xã',
          },
          {
            id: '7559',
            name: 'Định Thủy',
            prefix: 'Xã',
          },
          {
            id: '7560',
            name: 'Hương Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7561',
            name: 'Minh Đức',
            prefix: 'Xã',
          },
          {
            id: '7562',
            name: 'Mỏ Cày',
            prefix: 'Thị trấn',
          },
          {
            id: '7563',
            name: 'Ngãi Đăng',
            prefix: 'Xã',
          },
          {
            id: '7564',
            name: 'Phước Hiệp',
            prefix: 'Xã',
          },
          {
            id: '7565',
            name: 'Tân Hội',
            prefix: 'Xã',
          },
          {
            id: '7566',
            name: 'Tân Trung',
            prefix: 'Xã',
          },
          {
            id: '7567',
            name: 'Thành Thới A',
            prefix: 'Xã',
          },
          {
            id: '7568',
            name: 'Thành Thới B',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '467',
        name: 'Thạnh Phú',
        wards: [
          {
            id: '7569',
            name: 'An Điền',
            prefix: 'Xã',
          },
          {
            id: '7570',
            name: 'An Nhơn',
            prefix: 'Xã',
          },
          {
            id: '7571',
            name: 'An Quy',
            prefix: 'Xã',
          },
          {
            id: '7572',
            name: 'An Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7573',
            name: 'An Thuận',
            prefix: 'Xã',
          },
          {
            id: '7574',
            name: 'Bình Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7575',
            name: 'Đại Điền',
            prefix: 'Xã',
          },
          {
            id: '7576',
            name: 'Giao Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7577',
            name: 'Hòa Lợi',
            prefix: 'Xã',
          },
          {
            id: '7578',
            name: 'Mỹ An',
            prefix: 'Xã',
          },
          {
            id: '7579',
            name: 'Mỹ Hưng',
            prefix: 'Xã',
          },
          {
            id: '7580',
            name: 'Phú Khánh',
            prefix: 'Xã',
          },
          {
            id: '7581',
            name: 'Quới Điền',
            prefix: 'Xã',
          },
          {
            id: '7582',
            name: 'Tân Phong',
            prefix: 'Xã',
          },
          {
            id: '7583',
            name: 'Thạnh Hải',
            prefix: 'Xã',
          },
          {
            id: '7584',
            name: 'Thạnh Phong',
            prefix: 'Xã',
          },
          {
            id: '7585',
            name: 'Thạnh Phú',
            prefix: 'Thị trấn',
          },
          {
            id: '7586',
            name: 'Thới Thạnh',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '38',
    code: 'DNO',
    name: 'Đắk Nông',
    districts: [
      {
        id: '468',
        name: 'Cư Jút',
        wards: [
          {
            id: '7587',
            name: 'Cư KNia',
            prefix: 'Xã',
          },
          {
            id: '7588',
            name: 'Đăk Đrông',
            prefix: 'Xã',
          },
          {
            id: '7589',
            name: 'Đăk Wil',
            prefix: 'Xã',
          },
          {
            id: '7590',
            name: 'Ea Pô',
            prefix: 'Xã',
          },
          {
            id: '7591',
            name: "Ea T'ling",
            prefix: 'Thị trấn',
          },
          {
            id: '7592',
            name: 'Nam Dong',
            prefix: 'Xã',
          },
          {
            id: '7593',
            name: 'Tâm Thắng',
            prefix: 'Xã',
          },
          {
            id: '7594',
            name: 'Trúc Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '469',
        name: 'Dăk GLong',
        wards: [
          {
            id: '7595',
            name: 'Đắk Ha',
            prefix: 'Xã',
          },
          {
            id: '7596',
            name: 'Đắk PLao',
            prefix: 'Xã',
          },
          {
            id: '7597',
            name: "Đắk R'Măng",
            prefix: 'Xã',
          },
          {
            id: '7598',
            name: 'Đắk Som',
            prefix: 'Xã',
          },
          {
            id: '7599',
            name: 'Quảng Hòa',
            prefix: 'Xã',
          },
          {
            id: '7600',
            name: 'Quảng Khê',
            prefix: 'Thị trấn',
          },
          {
            id: '7601',
            name: 'Quảng Sơn',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '470',
        name: 'Dăk Mil',
        wards: [
          {
            id: '7602',
            name: 'Đắk Gằn',
            prefix: 'Xã',
          },
          {
            id: '7603',
            name: 'Đắk Lao',
            prefix: 'Xã',
          },
          {
            id: '7604',
            name: 'Đắk Mil',
            prefix: 'Thị trấn',
          },
          {
            id: '7605',
            name: "Đắk N'Drót",
            prefix: 'Xã',
          },
          {
            id: '7606',
            name: "Đắk R'La",
            prefix: 'Xã',
          },
          {
            id: '7607',
            name: 'Đắk Sắk',
            prefix: 'Xã',
          },
          {
            id: '7608',
            name: 'Đức Mạnh',
            prefix: 'Xã',
          },
          {
            id: '7609',
            name: 'Đức Minh',
            prefix: 'Xã',
          },
          {
            id: '7610',
            name: 'Long Sơn',
            prefix: 'Xã',
          },
          {
            id: '7611',
            name: 'Thuận An',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '471',
        name: "Dăk R'Lấp",
        wards: [
          {
            id: '7612',
            name: 'Đắk Ru',
            prefix: 'Xã',
          },
          {
            id: '7613',
            name: 'Đắk Sin',
            prefix: 'Xã',
          },
          {
            id: '7614',
            name: 'Đắk Wer',
            prefix: 'Xã',
          },
          {
            id: '7615',
            name: 'Đạo Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '7616',
            name: 'Hưng Bình',
            prefix: 'Xã',
          },
          {
            id: '7617',
            name: 'Kiến Đức',
            prefix: 'Thị trấn',
          },
          {
            id: '7618',
            name: 'Kiến Thành',
            prefix: 'Xã',
          },
          {
            id: '7619',
            name: 'Nghĩa Thắng',
            prefix: 'Xã',
          },
          {
            id: '7620',
            name: 'Nhân Cơ',
            prefix: 'Xã',
          },
          {
            id: '7621',
            name: 'Nhân Đạo',
            prefix: 'Xã',
          },
          {
            id: '7622',
            name: 'Quảng Tín',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '472',
        name: 'Dăk Song',
        wards: [
          {
            id: '7623',
            name: 'Đắk Hoà',
            prefix: 'Xã',
          },
          {
            id: '7624',
            name: 'Đắk Môl',
            prefix: 'Xã',
          },
          {
            id: '7625',
            name: "Đắk N'Drung",
            prefix: 'Xã',
          },
          {
            id: '7626',
            name: 'Đức An',
            prefix: 'Thị trấn',
          },
          {
            id: '7627',
            name: 'Nam Bình',
            prefix: 'Xã',
          },
          {
            id: '7628',
            name: "Nâm N'Jang",
            prefix: 'Xã',
          },
          {
            id: '7629',
            name: 'Thuận Hà',
            prefix: 'Xã',
          },
          {
            id: '7630',
            name: 'Thuận Hạnh',
            prefix: 'Xã',
          },
          {
            id: '7631',
            name: 'Trường Xuân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '473',
        name: 'Gia Nghĩa',
        wards: [
          {
            id: '7632',
            name: 'Đắk Nia',
            prefix: 'Xã',
          },
          {
            id: '7633',
            name: 'Đắk R’Moan',
            prefix: 'Xã',
          },
          {
            id: '7634',
            name: 'Nghĩa Đức',
            prefix: 'Phường',
          },
          {
            id: '7635',
            name: 'Nghĩa Phú',
            prefix: 'Phường',
          },
          {
            id: '7636',
            name: 'Nghĩa Tân',
            prefix: 'Phường',
          },
          {
            id: '7637',
            name: 'Nghĩa Thành',
            prefix: 'Phường',
          },
          {
            id: '7638',
            name: 'Nghĩa Trung',
            prefix: 'Phường',
          },
          {
            id: '7639',
            name: 'Quảng Thành',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '474',
        name: 'Krông Nô',
        wards: [
          {
            id: '7640',
            name: 'Buôn Choah',
            prefix: 'Xã',
          },
          {
            id: '7641',
            name: 'Đăk Drô',
            prefix: 'Xã',
          },
          {
            id: '7642',
            name: 'Đăk Mâm',
            prefix: 'Thị trấn',
          },
          {
            id: '7643',
            name: 'Đăk Nang',
            prefix: 'Xã',
          },
          {
            id: '7644',
            name: 'Đăk Sôr',
            prefix: 'Xã',
          },
          {
            id: '7645',
            name: 'Đức Xuyên',
            prefix: 'Xã',
          },
          {
            id: '7646',
            name: 'Nam Đà',
            prefix: 'Xã',
          },
          {
            id: '7647',
            name: "Nâm N'Đir",
            prefix: 'Xã',
          },
          {
            id: '7648',
            name: 'Nâm Nung',
            prefix: 'Xã',
          },
          {
            id: '7649',
            name: 'Nam Xuân',
            prefix: 'Xã',
          },
          {
            id: '7650',
            name: 'Quảng Phú',
            prefix: 'Xã',
          },
          {
            id: '7651',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '475',
        name: 'Tuy Đức',
        wards: [
          {
            id: '7652',
            name: 'Đắk Búk So',
            prefix: 'Thị trấn',
          },
          {
            id: '7653',
            name: 'Đắk Ngo',
            prefix: 'Xã',
          },
          {
            id: '7654',
            name: "Đắk R'Tíh",
            prefix: 'Xã',
          },
          {
            id: '7655',
            name: 'Quảng Tâm',
            prefix: 'Xã',
          },
          {
            id: '7656',
            name: 'Quảng Tân',
            prefix: 'Xã',
          },
          {
            id: '7657',
            name: 'Quảng Trực',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '39',
    code: 'CM',
    name: 'Cà Mau',
    districts: [
      {
        id: '476',
        name: 'Cà Mau',
        wards: [
          {
            id: '7658',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '7659',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '7660',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '7661',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '7662',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '7663',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '7664',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '7665',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '7666',
            name: '9',
            prefix: 'Phường',
          },
          {
            id: '7667',
            name: 'An Xuyên',
            prefix: 'Xã',
          },
          {
            id: '7668',
            name: 'Định Bình',
            prefix: 'Xã',
          },
          {
            id: '7669',
            name: 'Hòa Tân',
            prefix: 'Xã',
          },
          {
            id: '7670',
            name: 'Hòa Thành',
            prefix: 'Xã',
          },
          {
            id: '7671',
            name: 'Lý Văn Lâm',
            prefix: 'Xã',
          },
          {
            id: '7672',
            name: 'Tắc Vân',
            prefix: 'Xã',
          },
          {
            id: '7673',
            name: 'Tân Thành',
            prefix: 'Phường',
          },
          {
            id: '7674',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '7675',
            name: 'Tân Xuyên',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '477',
        name: 'Cái Nước',
        wards: [
          {
            id: '7676',
            name: 'Cái Nước',
            prefix: 'Thị trấn',
          },
          {
            id: '7677',
            name: 'Đông Hưng',
            prefix: 'Xã',
          },
          {
            id: '7678',
            name: 'Đông Thới',
            prefix: 'Xã',
          },
          {
            id: '7679',
            name: 'Hòa Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7680',
            name: 'Hưng Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7681',
            name: 'Lương Thế Trân',
            prefix: 'Xã',
          },
          {
            id: '7682',
            name: 'Phú Hưng',
            prefix: 'Xã',
          },
          {
            id: '7683',
            name: 'Tân Hưng',
            prefix: 'Xã',
          },
          {
            id: '7684',
            name: 'Tân Hưng Đông',
            prefix: 'Xã',
          },
          {
            id: '7685',
            name: 'Thạnh Phú',
            prefix: 'Xã',
          },
          {
            id: '7686',
            name: 'Trần Thới',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '478',
        name: 'Đầm Dơi',
        wards: [
          {
            id: '7687',
            name: 'Đầm Dơi',
            prefix: 'Thị trấn',
          },
          {
            id: '7688',
            name: 'Ngọc Chánh',
            prefix: 'Xã',
          },
          {
            id: '7689',
            name: 'Nguyễn Huân',
            prefix: 'Xã',
          },
          {
            id: '7690',
            name: 'Quách Phẩm',
            prefix: 'Xã',
          },
          {
            id: '7691',
            name: 'Quách Phẩm Bắc',
            prefix: 'Xã',
          },
          {
            id: '7692',
            name: 'Tạ An Khương',
            prefix: 'Xã',
          },
          {
            id: '7693',
            name: 'Tạ An Khương Đông',
            prefix: 'Xã',
          },
          {
            id: '7694',
            name: 'Tạ An Khương Nam',
            prefix: 'Xã',
          },
          {
            id: '7695',
            name: 'Tân Dân',
            prefix: 'Xã',
          },
          {
            id: '7697',
            name: 'Tân Duyệt',
            prefix: 'Xã',
          },
          {
            id: '7696',
            name: 'Tân Đức',
            prefix: 'Xã',
          },
          {
            id: '7698',
            name: 'Tân Thuận',
            prefix: 'Xã',
          },
          {
            id: '7699',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '7700',
            name: 'Tân Trung',
            prefix: 'Xã',
          },
          {
            id: '7701',
            name: 'Thanh Tùng',
            prefix: 'Xã',
          },
          {
            id: '7702',
            name: 'Trần Phán',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '479',
        name: 'Năm Căn',
        wards: [
          {
            id: '7703',
            name: 'Đất Mới',
            prefix: 'Xã',
          },
          {
            id: '7704',
            name: 'Hàm Rồng',
            prefix: 'Xã',
          },
          {
            id: '7705',
            name: 'Hàng Vịnh',
            prefix: 'Xã',
          },
          {
            id: '7706',
            name: 'Hiệp Tùng',
            prefix: 'Xã',
          },
          {
            id: '7707',
            name: 'Lâm Hải',
            prefix: 'Xã',
          },
          {
            id: '7708',
            name: 'Năm Căn',
            prefix: 'Thị trấn',
          },
          {
            id: '7709',
            name: 'Tam Giang',
            prefix: 'Xã',
          },
          {
            id: '7710',
            name: 'Tam Giang Đông',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '480',
        name: 'Ngọc Hiển',
        wards: [
          {
            id: '7711',
            name: 'Đất Mũi',
            prefix: 'Xã',
          },
          {
            id: '7712',
            name: 'Rạch Gốc',
            prefix: 'Thị trấn',
          },
          {
            id: '7713',
            name: 'Tam Giang Tây',
            prefix: 'Xã',
          },
          {
            id: '7714',
            name: 'Tân Ân',
            prefix: 'Xã',
          },
          {
            id: '7715',
            name: 'Tân Ân Tây',
            prefix: 'Xã',
          },
          {
            id: '7716',
            name: 'Viên An',
            prefix: 'Xã',
          },
          {
            id: '7717',
            name: 'Viên An Đông',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '481',
        name: 'Phú Tân',
        wards: [
          {
            id: '7718',
            name: 'Cái Đôi Vàm',
            prefix: 'Thị trấn',
          },
          {
            id: '7719',
            name: 'Nguyễn Việt Khái',
            prefix: 'Xã',
          },
          {
            id: '7720',
            name: 'Phú Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7721',
            name: 'Phú Tân',
            prefix: 'Xã',
          },
          {
            id: '7722',
            name: 'Phú Thuận',
            prefix: 'Xã',
          },
          {
            id: '7723',
            name: 'Rạch Chèo',
            prefix: 'Xã',
          },
          {
            id: '7724',
            name: 'Tân Hải',
            prefix: 'Xã',
          },
          {
            id: '7725',
            name: 'Tân Hưng Tây',
            prefix: 'Xã',
          },
          {
            id: '7726',
            name: 'Việt Thắng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '482',
        name: 'Thới Bình',
        wards: [
          {
            id: '7727',
            name: 'Biển Bạch',
            prefix: 'Xã',
          },
          {
            id: '7728',
            name: 'Biển Bạch Đông',
            prefix: 'Xã',
          },
          {
            id: '7729',
            name: 'Hồ Thị Kỷ',
            prefix: 'Xã',
          },
          {
            id: '7730',
            name: 'Tân Bằng',
            prefix: 'Xã',
          },
          {
            id: '7731',
            name: 'Tân Lộc',
            prefix: 'Xã',
          },
          {
            id: '7732',
            name: 'Tân Lộc Bắc',
            prefix: 'Xã',
          },
          {
            id: '7733',
            name: 'Tân Lộc Đông',
            prefix: 'Xã',
          },
          {
            id: '7734',
            name: 'Tân Phú',
            prefix: 'Xã',
          },
          {
            id: '7735',
            name: 'Thới Bình',
            prefix: 'Thị trấn',
          },
          {
            id: '7736',
            name: 'Thới Bình',
            prefix: 'Xã',
          },
          {
            id: '7737',
            name: 'Trí Lực',
            prefix: 'Xã',
          },
          {
            id: '7738',
            name: 'Trí Phải',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '483',
        name: 'Trần Văn Thời',
        wards: [
          {
            id: '7739',
            name: 'Khánh Bình',
            prefix: 'Xã',
          },
          {
            id: '7740',
            name: 'Khánh Bình Đông',
            prefix: 'Thị trấn',
          },
          {
            id: '7741',
            name: 'Khánh Bình Tây',
            prefix: 'Xã',
          },
          {
            id: '7742',
            name: 'Khánh Bình Tây Bắc',
            prefix: 'Xã',
          },
          {
            id: '7743',
            name: 'Khánh Hải',
            prefix: 'Xã',
          },
          {
            id: '7744',
            name: 'Khánh Hưng',
            prefix: 'Xã',
          },
          {
            id: '7745',
            name: 'Khánh Lộc',
            prefix: 'Xã',
          },
          {
            id: '7746',
            name: 'Lợi An',
            prefix: 'Xã',
          },
          {
            id: '7747',
            name: 'Phong Điền',
            prefix: 'Xã',
          },
          {
            id: '7748',
            name: 'Phong Lạc',
            prefix: 'Xã',
          },
          {
            id: '7749',
            name: 'Sông Đốc',
            prefix: 'Thị trấn',
          },
          {
            id: '7750',
            name: 'Trần Hợi',
            prefix: 'Xã',
          },
          {
            id: '7751',
            name: 'Trần Văn Thời',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '484',
        name: 'U Minh',
        wards: [
          {
            id: '7752',
            name: 'Khánh An',
            prefix: 'Xã',
          },
          {
            id: '7753',
            name: 'Khánh Hòa',
            prefix: 'Xã',
          },
          {
            id: '7754',
            name: 'Khánh Hội',
            prefix: 'Xã',
          },
          {
            id: '7755',
            name: 'Khánh Lâm',
            prefix: 'Xã',
          },
          {
            id: '7756',
            name: 'Khánh Thuận',
            prefix: 'Xã',
          },
          {
            id: '7757',
            name: 'Khánh Tiến',
            prefix: 'Xã',
          },
          {
            id: '7758',
            name: 'Nguyễn Phích',
            prefix: 'Xã',
          },
          {
            id: '7759',
            name: 'U Minh',
            prefix: 'Thị trấn',
          },
        ],
      },
    ],
  },
  {
    id: '40',
    code: 'VL',
    name: 'Vĩnh Long',
    districts: [
      {
        id: '485',
        name: 'Bình Minh',
        wards: [
          {
            id: '7760',
            name: 'Cái Vồn',
            prefix: 'Thị trấn',
          },
          {
            id: '7761',
            name: 'Đông Bình',
            prefix: 'Xã',
          },
          {
            id: '7762',
            name: 'Đông Thành',
            prefix: 'Xã',
          },
          {
            id: '7763',
            name: 'Đông Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7764',
            name: 'Đông Thuận',
            prefix: 'Phường',
          },
          {
            id: '7765',
            name: 'Mỹ Hòa',
            prefix: 'Xã',
          },
          {
            id: '7766',
            name: 'Thành Phước',
            prefix: 'Phường',
          },
          {
            id: '7767',
            name: 'Thuận An',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '486',
        name: 'Bình Tân',
        wards: [
          {
            id: '7768',
            name: 'Mỹ Thuận',
            prefix: 'Xã',
          },
          {
            id: '7769',
            name: 'Nguyễn Văn Thảnh',
            prefix: 'Xã',
          },
          {
            id: '7770',
            name: 'Tân An Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7771',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '7772',
            name: 'Tân Hưng',
            prefix: 'Xã',
          },
          {
            id: '7773',
            name: 'Tân Lược',
            prefix: 'Xã',
          },
          {
            id: '7774',
            name: 'Tân Quới',
            prefix: 'Thị trấn',
          },
          {
            id: '7775',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '7776',
            name: 'Thành Đông',
            prefix: 'Xã',
          },
          {
            id: '7777',
            name: 'Thành Lợi',
            prefix: 'Xã',
          },
          {
            id: '7778',
            name: 'Thành Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '487',
        name: 'Long Hồ',
        wards: [
          {
            id: '7779',
            name: 'An Bình',
            prefix: 'Xã',
          },
          {
            id: '7780',
            name: 'Bình Hoà Phước',
            prefix: 'Xã',
          },
          {
            id: '7781',
            name: 'Đồng Phú',
            prefix: 'Xã',
          },
          {
            id: '7782',
            name: 'Hoà Ninh',
            prefix: 'Xã',
          },
          {
            id: '7783',
            name: 'Hoà Phú',
            prefix: 'Xã',
          },
          {
            id: '7784',
            name: 'Lộc Hoà',
            prefix: 'Xã',
          },
          {
            id: '7785',
            name: 'Long An',
            prefix: 'Xã',
          },
          {
            id: '7786',
            name: 'Long Hồ',
            prefix: 'Thị trấn',
          },
          {
            id: '7787',
            name: 'Long Phước',
            prefix: 'Xã',
          },
          {
            id: '7788',
            name: 'Phú Đức',
            prefix: 'Xã',
          },
          {
            id: '7789',
            name: 'Phú Quới',
            prefix: 'Xã',
          },
          {
            id: '7790',
            name: 'Phước Hậu',
            prefix: 'Xã',
          },
          {
            id: '7791',
            name: 'Tân Hạnh',
            prefix: 'Xã',
          },
          {
            id: '7792',
            name: 'Thanh Đức',
            prefix: 'Xã',
          },
          {
            id: '7793',
            name: 'Thạnh Quới',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '488',
        name: 'Mang Thít',
        wards: [
          {
            id: '7794',
            name: 'An Phước',
            prefix: 'Xã',
          },
          {
            id: '7795',
            name: 'Bình Phước',
            prefix: 'Xã',
          },
          {
            id: '7796',
            name: 'Cái Nhum',
            prefix: 'Thị trấn',
          },
          {
            id: '7797',
            name: 'Chánh An',
            prefix: 'Xã',
          },
          {
            id: '7798',
            name: 'Chánh Hội',
            prefix: 'Xã',
          },
          {
            id: '7799',
            name: 'Hoà Tịnh',
            prefix: 'Xã',
          },
          {
            id: '7800',
            name: 'Long Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7801',
            name: 'Mỹ An',
            prefix: 'Xã',
          },
          {
            id: '7802',
            name: 'Mỹ Phước',
            prefix: 'Xã',
          },
          {
            id: '7803',
            name: 'Nhơn Phú',
            prefix: 'Xã',
          },
          {
            id: '7804',
            name: 'Tân An Hội',
            prefix: 'Xã',
          },
          {
            id: '7805',
            name: 'Tân Long',
            prefix: 'Xã',
          },
          {
            id: '7806',
            name: 'Tân Long Hội',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '489',
        name: 'Tam Bình',
        wards: [
          {
            id: '7807',
            name: 'Bình Ninh',
            prefix: 'Xã',
          },
          {
            id: '7808',
            name: 'Hậu Lộc',
            prefix: 'Xã',
          },
          {
            id: '7809',
            name: 'Hòa Hiệp',
            prefix: 'Xã',
          },
          {
            id: '7810',
            name: 'Hòa Lộc',
            prefix: 'Xã',
          },
          {
            id: '7811',
            name: 'Hòa Thạnh',
            prefix: 'Xã',
          },
          {
            id: '7812',
            name: 'Loan Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7813',
            name: 'Long Phú',
            prefix: 'Xã',
          },
          {
            id: '7814',
            name: 'Mỹ Lộc',
            prefix: 'Xã',
          },
          {
            id: '7815',
            name: 'Mỹ Thạnh Trung',
            prefix: 'Xã',
          },
          {
            id: '7816',
            name: 'Ngãi Tứ',
            prefix: 'Xã',
          },
          {
            id: '7817',
            name: 'Phú Lộc',
            prefix: 'Xã',
          },
          {
            id: '7818',
            name: 'Phú Thịnh',
            prefix: 'Xã',
          },
          {
            id: '7819',
            name: 'Song Phú',
            prefix: 'Xã',
          },
          {
            id: '7820',
            name: 'Tam Bình',
            prefix: 'Thị trấn',
          },
          {
            id: '7821',
            name: 'Tân Lộc',
            prefix: 'Xã',
          },
          {
            id: '7822',
            name: 'Tân Phú',
            prefix: 'Xã',
          },
          {
            id: '7823',
            name: 'Tường Lộc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '490',
        name: 'Trà Ôn',
        wards: [
          {
            id: '7824',
            name: 'Hoà Bình',
            prefix: 'Xã',
          },
          {
            id: '7825',
            name: 'Hựu Thành',
            prefix: 'Xã',
          },
          {
            id: '7826',
            name: 'Lục Sĩ Thành',
            prefix: 'Xã',
          },
          {
            id: '7827',
            name: 'Nhơn Bình',
            prefix: 'Xã',
          },
          {
            id: '7828',
            name: 'Phú Thành',
            prefix: 'Xã',
          },
          {
            id: '7829',
            name: 'Tân Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7830',
            name: 'Thiện Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7831',
            name: 'Thới Hoà',
            prefix: 'Xã',
          },
          {
            id: '7832',
            name: 'Thuận Thới',
            prefix: 'Xã',
          },
          {
            id: '7833',
            name: 'Tích Thiện',
            prefix: 'Xã',
          },
          {
            id: '7834',
            name: 'Trà Côn',
            prefix: 'Xã',
          },
          {
            id: '7835',
            name: 'Trà Ôn',
            prefix: 'Thị trấn',
          },
          {
            id: '7836',
            name: 'Vĩnh Xuân',
            prefix: 'Xã',
          },
          {
            id: '7837',
            name: 'Xuân Hiệp',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '491',
        name: 'Vĩnh Long',
        wards: [
          {
            id: '7838',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '7839',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '7840',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '7841',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '7842',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '7843',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '7844',
            name: '9',
            prefix: 'Phường',
          },
          {
            id: '7845',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
          {
            id: '7846',
            name: 'Tân Hội',
            prefix: 'Xã',
          },
          {
            id: '7847',
            name: 'Tân Ngãi',
            prefix: 'Xã',
          },
          {
            id: '7848',
            name: 'Trường An',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '492',
        name: 'Vũng Liêm',
        wards: [
          {
            id: '7849',
            name: 'Hiếu Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '7850',
            name: 'Hiếu Nhơn',
            prefix: 'Xã',
          },
          {
            id: '7851',
            name: 'Hiếu Phụng',
            prefix: 'Xã',
          },
          {
            id: '7852',
            name: 'Hiếu Thành',
            prefix: 'Xã',
          },
          {
            id: '7853',
            name: 'Hiếu Thuận',
            prefix: 'Xã',
          },
          {
            id: '7854',
            name: 'Quới An',
            prefix: 'Xã',
          },
          {
            id: '7855',
            name: 'Quới Thiện',
            prefix: 'Xã',
          },
          {
            id: '7856',
            name: 'Tân An Luông',
            prefix: 'Xã',
          },
          {
            id: '7857',
            name: 'Tân Quới Trung',
            prefix: 'Xã',
          },
          {
            id: '7858',
            name: 'Thanh Bình',
            prefix: 'Xã',
          },
          {
            id: '7859',
            name: 'Trung An',
            prefix: 'Xã',
          },
          {
            id: '7860',
            name: 'Trung Chánh',
            prefix: 'Xã',
          },
          {
            id: '7861',
            name: 'Trung Hiệp',
            prefix: 'Xã',
          },
          {
            id: '7862',
            name: 'Trung Hiếu',
            prefix: 'Xã',
          },
          {
            id: '7863',
            name: 'Trung Ngãi',
            prefix: 'Xã',
          },
          {
            id: '7864',
            name: 'Trung Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '7865',
            name: 'Trung Thành',
            prefix: 'Xã',
          },
          {
            id: '7866',
            name: 'Trung Thành Đông',
            prefix: 'Xã',
          },
          {
            id: '7867',
            name: 'Trung Thành Tây',
            prefix: 'Xã',
          },
          {
            id: '7868',
            name: 'Vũng Liêm',
            prefix: 'Thị trấn',
          },
        ],
      },
    ],
  },
  {
    id: '41',
    code: 'NB',
    name: 'Ninh Bình',
    districts: [
      {
        id: '493',
        name: 'Gia Viễn',
        wards: [
          {
            id: '7869',
            name: 'Gia Hoà',
            prefix: 'Xã',
          },
          {
            id: '7870',
            name: 'Gia Hưng',
            prefix: 'Xã',
          },
          {
            id: '7871',
            name: 'Gia Lạc',
            prefix: 'Xã',
          },
          {
            id: '7872',
            name: 'Gia Lập',
            prefix: 'Xã',
          },
          {
            id: '7873',
            name: 'Gia Minh',
            prefix: 'Xã',
          },
          {
            id: '7874',
            name: 'Gia Phong',
            prefix: 'Xã',
          },
          {
            id: '7875',
            name: 'Gia Phú',
            prefix: 'Xã',
          },
          {
            id: '7876',
            name: 'Gia Phương',
            prefix: 'Xã',
          },
          {
            id: '7877',
            name: 'Gia Sinh',
            prefix: 'Xã',
          },
          {
            id: '7878',
            name: 'Gia Tân',
            prefix: 'Xã',
          },
          {
            id: '7879',
            name: 'Gia Thắng',
            prefix: 'Xã',
          },
          {
            id: '7880',
            name: 'Gia Thanh',
            prefix: 'Xã',
          },
          {
            id: '7881',
            name: 'Gia Thịnh',
            prefix: 'Xã',
          },
          {
            id: '7882',
            name: 'Gia Tiến',
            prefix: 'Xã',
          },
          {
            id: '7883',
            name: 'Gia Trấn',
            prefix: 'Xã',
          },
          {
            id: '7884',
            name: 'Gia Trung',
            prefix: 'Xã',
          },
          {
            id: '7885',
            name: 'Gia Vân',
            prefix: 'Xã',
          },
          {
            id: '7886',
            name: 'Gia Vượng',
            prefix: 'Xã',
          },
          {
            id: '7887',
            name: 'Gia Xuân',
            prefix: 'Xã',
          },
          {
            id: '7888',
            name: 'Liên Sơn',
            prefix: 'Xã',
          },
          {
            id: '7889',
            name: 'Me',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '494',
        name: 'Hoa Lư',
        wards: [
          {
            id: '7890',
            name: 'Ninh An',
            prefix: 'Xã',
          },
          {
            id: '7891',
            name: 'Ninh Giang',
            prefix: 'Xã',
          },
          {
            id: '7892',
            name: 'Ninh Hải',
            prefix: 'Xã',
          },
          {
            id: '7893',
            name: 'Ninh Hòa',
            prefix: 'Xã',
          },
          {
            id: '7894',
            name: 'Ninh Khang',
            prefix: 'Xã',
          },
          {
            id: '7895',
            name: 'Ninh Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7896',
            name: 'Ninh Thắng',
            prefix: 'Xã',
          },
          {
            id: '7897',
            name: 'Ninh Vân',
            prefix: 'Xã',
          },
          {
            id: '7898',
            name: 'Ninh Xuân',
            prefix: 'Xã',
          },
          {
            id: '7899',
            name: 'Thiên Tôn',
            prefix: 'Thị trấn',
          },
          {
            id: '7900',
            name: 'Trường Yên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '495',
        name: 'Kim Sơn',
        wards: [
          {
            id: '7901',
            name: 'Ân Hòa',
            prefix: 'Xã',
          },
          {
            id: '7902',
            name: 'Bình Minh',
            prefix: 'Thị trấn',
          },
          {
            id: '7903',
            name: 'Chất Bình',
            prefix: 'Xã',
          },
          {
            id: '7904',
            name: 'Chính Tâm',
            prefix: 'Xã',
          },
          {
            id: '7905',
            name: 'Con Thoi',
            prefix: 'Xã',
          },
          {
            id: '7906',
            name: 'Định Hoá',
            prefix: 'Xã',
          },
          {
            id: '7907',
            name: 'Đồng Hướng',
            prefix: 'Xã',
          },
          {
            id: '7908',
            name: 'Hồi Ninh',
            prefix: 'Xã',
          },
          {
            id: '7909',
            name: 'Hùng Tiến',
            prefix: 'Xã',
          },
          {
            id: '7910',
            name: 'Kim Chính',
            prefix: 'Xã',
          },
          {
            id: '7911',
            name: 'Kim Định',
            prefix: 'Xã',
          },
          {
            id: '7912',
            name: 'Kim Đồng',
            prefix: 'Xã',
          },
          {
            id: '7913',
            name: 'Kim Hải',
            prefix: 'Xã',
          },
          {
            id: '7914',
            name: 'Kim Mỹ',
            prefix: 'Xã',
          },
          {
            id: '7915',
            name: 'Kim Tân',
            prefix: 'Xã',
          },
          {
            id: '7916',
            name: 'Kim Trung',
            prefix: 'Xã',
          },
          {
            id: '7917',
            name: 'Lai Thành',
            prefix: 'Xã',
          },
          {
            id: '7918',
            name: 'Lưu Phương',
            prefix: 'Xã',
          },
          {
            id: '7919',
            name: 'Như Hòa',
            prefix: 'Xã',
          },
          {
            id: '7920',
            name: 'Phát Diệm',
            prefix: 'Thị trấn',
          },
          {
            id: '7921',
            name: 'Quang Thiện',
            prefix: 'Xã',
          },
          {
            id: '7922',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '7923',
            name: 'Thượng Kiệm',
            prefix: 'Xã',
          },
          {
            id: '7924',
            name: 'Văn Hải',
            prefix: 'Xã',
          },
          {
            id: '7925',
            name: 'Xuân Thiện',
            prefix: 'Xã',
          },
          {
            id: '7926',
            name: 'Yên Lộc',
            prefix: 'Xã',
          },
          {
            id: '7927',
            name: 'Yên Mật',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '496',
        name: 'Nho Quan',
        wards: [
          {
            id: '7928',
            name: 'Cúc Phương',
            prefix: 'Xã',
          },
          {
            id: '7929',
            name: 'Đồng Phong',
            prefix: 'Xã',
          },
          {
            id: '7930',
            name: 'Đức Long',
            prefix: 'Xã',
          },
          {
            id: '7931',
            name: 'Gia Lâm',
            prefix: 'Xã',
          },
          {
            id: '7932',
            name: 'Gia Sơn',
            prefix: 'Xã',
          },
          {
            id: '7933',
            name: 'Gia Thủy',
            prefix: 'Xã',
          },
          {
            id: '7934',
            name: 'Gia Tường',
            prefix: 'Xã',
          },
          {
            id: '7935',
            name: 'Kỳ Phú',
            prefix: 'Xã',
          },
          {
            id: '7936',
            name: 'Lạc Vân',
            prefix: 'Xã',
          },
          {
            id: '7937',
            name: 'Lạng Phong',
            prefix: 'Xã',
          },
          {
            id: '7938',
            name: 'Nho Quan',
            prefix: 'Thị trấn',
          },
          {
            id: '7939',
            name: 'Phú Lộc',
            prefix: 'Xã',
          },
          {
            id: '7940',
            name: 'Phú Long',
            prefix: 'Xã',
          },
          {
            id: '7941',
            name: 'Phú Sơn',
            prefix: 'Xã',
          },
          {
            id: '7942',
            name: 'Quảng Lạc',
            prefix: 'Xã',
          },
          {
            id: '7943',
            name: 'Quỳnh Lưu',
            prefix: 'Xã',
          },
          {
            id: '7944',
            name: 'Sơn Hà',
            prefix: 'Xã',
          },
          {
            id: '7945',
            name: 'Sơn Lai',
            prefix: 'Xã',
          },
          {
            id: '7946',
            name: 'Sơn Thành',
            prefix: 'Xã',
          },
          {
            id: '7947',
            name: 'Thạch Bình',
            prefix: 'Xã',
          },
          {
            id: '7948',
            name: 'Thanh Lạc',
            prefix: 'Xã',
          },
          {
            id: '7949',
            name: 'Thượng Hoà',
            prefix: 'Xã',
          },
          {
            id: '7950',
            name: 'Văn Phong',
            prefix: 'Xã',
          },
          {
            id: '7951',
            name: 'Văn Phú',
            prefix: 'Xã',
          },
          {
            id: '7952',
            name: 'Văn Phương',
            prefix: 'Xã',
          },
          {
            id: '7953',
            name: 'Xích Thổ',
            prefix: 'Xã',
          },
          {
            id: '7954',
            name: 'Yên Quang',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '497',
        name: 'Ninh Bình',
        wards: [
          {
            id: '7955',
            name: 'Bích Đào',
            prefix: 'Phường',
          },
          {
            id: '7956',
            name: 'Đông Thành',
            prefix: 'Phường',
          },
          {
            id: '7957',
            name: 'Nam Bình',
            prefix: 'Phường',
          },
          {
            id: '7958',
            name: 'Nam Thành',
            prefix: 'Phường',
          },
          {
            id: '7959',
            name: 'Ninh Khánh',
            prefix: 'Phường',
          },
          {
            id: '7960',
            name: 'Ninh nhất',
            prefix: 'Xã',
          },
          {
            id: '7961',
            name: 'Ninh Phong',
            prefix: 'Phường',
          },
          {
            id: '7962',
            name: 'Ninh Phúc',
            prefix: 'Xã',
          },
          {
            id: '7963',
            name: 'Ninh Sơn',
            prefix: 'Phường',
          },
          {
            id: '7964',
            name: 'Ninh Tiến',
            prefix: 'Xã',
          },
          {
            id: '7965',
            name: 'Phúc Thành',
            prefix: 'Phường',
          },
          {
            id: '7966',
            name: 'Tân Thành',
            prefix: 'Phường',
          },
          {
            id: '7967',
            name: 'Thanh Bình',
            prefix: 'Phường',
          },
          {
            id: '7968',
            name: 'Vân Giang',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '498',
        name: 'Tam Điệp',
        wards: [
          {
            id: '7969',
            name: 'Bắc Sơn',
            prefix: 'Phường',
          },
          {
            id: '7970',
            name: 'Đông Sơn',
            prefix: 'Xã',
          },
          {
            id: '7971',
            name: 'Nam Sơn',
            prefix: 'Phường',
          },
          {
            id: '7972',
            name: 'Quang Sơn',
            prefix: 'Xã',
          },
          {
            id: '7973',
            name: 'Tân Bình',
            prefix: 'Phường',
          },
          {
            id: '7974',
            name: 'Tây Sơn',
            prefix: 'Phường',
          },
          {
            id: '7975',
            name: 'Trung Sơn',
            prefix: 'Phường',
          },
          {
            id: '7976',
            name: 'Yên Bình',
            prefix: 'Xã',
          },
          {
            id: '7977',
            name: 'Yên Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '499',
        name: 'Yên Khánh',
        wards: [
          {
            id: '7978',
            name: 'Khánh An',
            prefix: 'Xã',
          },
          {
            id: '7979',
            name: 'Khánh Công',
            prefix: 'Xã',
          },
          {
            id: '7980',
            name: 'Khánh Cư',
            prefix: 'Xã',
          },
          {
            id: '7981',
            name: 'Khánh Cường',
            prefix: 'Xã',
          },
          {
            id: '7982',
            name: 'Khánh Hải',
            prefix: 'Xã',
          },
          {
            id: '7983',
            name: 'Khánh Hòa',
            prefix: 'Xã',
          },
          {
            id: '7984',
            name: 'Khánh Hội',
            prefix: 'Xã',
          },
          {
            id: '7985',
            name: 'Khánh Hồng',
            prefix: 'Xã',
          },
          {
            id: '7986',
            name: 'Khánh Lợi',
            prefix: 'Xã',
          },
          {
            id: '7987',
            name: 'Khánh Mậu',
            prefix: 'Xã',
          },
          {
            id: '7988',
            name: 'Khánh Nhạc',
            prefix: 'Xã',
          },
          {
            id: '7989',
            name: 'Khánh Phú',
            prefix: 'Xã',
          },
          {
            id: '7990',
            name: 'Khánh Thành',
            prefix: 'Xã',
          },
          {
            id: '7991',
            name: 'Khánh Thiện',
            prefix: 'Xã',
          },
          {
            id: '7992',
            name: 'Khánh Thủy',
            prefix: 'Xã',
          },
          {
            id: '7993',
            name: 'Khánh Tiên',
            prefix: 'Xã',
          },
          {
            id: '7994',
            name: 'Khánh Trung',
            prefix: 'Xã',
          },
          {
            id: '7995',
            name: 'Khánh Vân',
            prefix: 'Xã',
          },
          {
            id: '7996',
            name: 'Yên Ninh',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '500',
        name: 'Yên Mô',
        wards: [
          {
            id: '7997',
            name: 'Khánh Dương',
            prefix: 'Xã',
          },
          {
            id: '7998',
            name: 'Khánh Thịnh',
            prefix: 'Xã',
          },
          {
            id: '7999',
            name: 'Khánh Thượng',
            prefix: 'Xã',
          },
          {
            id: '8000',
            name: 'Mai Sơn',
            prefix: 'Xã',
          },
          {
            id: '8001',
            name: 'Yên Đồng',
            prefix: 'Xã',
          },
          {
            id: '8002',
            name: 'Yên Hòa',
            prefix: 'Xã',
          },
          {
            id: '8003',
            name: 'Yên Hưng',
            prefix: 'Xã',
          },
          {
            id: '8004',
            name: 'Yên Lâm',
            prefix: 'Xã',
          },
          {
            id: '8005',
            name: 'Yên Mạc',
            prefix: 'Xã',
          },
          {
            id: '8006',
            name: 'Yên Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8007',
            name: 'Yên Nhân',
            prefix: 'Xã',
          },
          {
            id: '8008',
            name: 'Yên Phong',
            prefix: 'Xã',
          },
          {
            id: '8009',
            name: 'Yên Phú',
            prefix: 'Xã',
          },
          {
            id: '8010',
            name: 'Yên Thái',
            prefix: 'Xã',
          },
          {
            id: '8011',
            name: 'Yên Thắng',
            prefix: 'Xã',
          },
          {
            id: '8012',
            name: 'Yên Thành',
            prefix: 'Xã',
          },
          {
            id: '8013',
            name: 'Yên Thịnh',
            prefix: 'Thị trấn',
          },
          {
            id: '8014',
            name: 'Yên Từ',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '42',
    code: 'PT',
    name: 'Phú Thọ',
    districts: [
      {
        id: '501',
        name: 'Cẩm Khê',
        wards: [
          {
            id: '8015',
            name: 'Cấp Dẫn',
            prefix: 'Xã',
          },
          {
            id: '8016',
            name: 'Cát Trù',
            prefix: 'Xã',
          },
          {
            id: '8017',
            name: 'Chương Xá',
            prefix: 'Xã',
          },
          {
            id: '8018',
            name: 'Điêu Lương',
            prefix: 'Xã',
          },
          {
            id: '8019',
            name: 'Đồng Cam',
            prefix: 'Xã',
          },
          {
            id: '8020',
            name: 'Đồng Lương',
            prefix: 'Xã',
          },
          {
            id: '8021',
            name: 'Hiền Đa',
            prefix: 'Xã',
          },
          {
            id: '8022',
            name: 'Hương Lung',
            prefix: 'Xã',
          },
          {
            id: '8023',
            name: 'Ngô Xá',
            prefix: 'Xã',
          },
          {
            id: '8024',
            name: 'Phú Khê',
            prefix: 'Xã',
          },
          {
            id: '8025',
            name: 'Phú Lạc',
            prefix: 'Xã',
          },
          {
            id: '8026',
            name: 'Phùng Xá',
            prefix: 'Xã',
          },
          {
            id: '8027',
            name: 'Phượng Vĩ',
            prefix: 'Xã',
          },
          {
            id: '8028',
            name: 'Phương Xá',
            prefix: 'Xã',
          },
          {
            id: '8029',
            name: 'Sai Nga',
            prefix: 'Xã',
          },
          {
            id: '8030',
            name: 'Sơn Nga',
            prefix: 'Xã',
          },
          {
            id: '8031',
            name: 'Sơn Tịnh',
            prefix: 'Xã',
          },
          {
            id: '8032',
            name: 'Sông Thao',
            prefix: 'Thị trấn',
          },
          {
            id: '8033',
            name: 'Tạ Xá',
            prefix: 'Xã',
          },
          {
            id: '8034',
            name: 'Tam Sơn',
            prefix: 'Xã',
          },
          {
            id: '8035',
            name: 'Thanh Nga',
            prefix: 'Xã',
          },
          {
            id: '8036',
            name: 'Thụy Liễu',
            prefix: 'Xã',
          },
          {
            id: '8037',
            name: 'Tiên Lương',
            prefix: 'Xã',
          },
          {
            id: '8038',
            name: 'Tình Cương',
            prefix: 'Xã',
          },
          {
            id: '8039',
            name: 'Tùng Khê',
            prefix: 'Xã',
          },
          {
            id: '8040',
            name: 'Tuy Lộc',
            prefix: 'Xã',
          },
          {
            id: '8041',
            name: 'Văn Bán',
            prefix: 'Xã',
          },
          {
            id: '8042',
            name: 'Văn Khúc',
            prefix: 'Xã',
          },
          {
            id: '8043',
            name: 'Xương Thịnh',
            prefix: 'Xã',
          },
          {
            id: '8044',
            name: 'Yên Dưỡng',
            prefix: 'Xã',
          },
          {
            id: '8045',
            name: 'Yên Tập',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '502',
        name: 'Đoan Hùng',
        wards: [
          {
            id: '8046',
            name: 'Bằng Doãn',
            prefix: 'Xã',
          },
          {
            id: '8047',
            name: 'Bằng Luân',
            prefix: 'Xã',
          },
          {
            id: '8048',
            name: 'Ca Đình',
            prefix: 'Xã',
          },
          {
            id: '8049',
            name: 'Chân Mộng',
            prefix: 'Xã',
          },
          {
            id: '8050',
            name: 'Chí Đám',
            prefix: 'Xã',
          },
          {
            id: '8051',
            name: 'Đại Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '8052',
            name: 'Đoan Hùng',
            prefix: 'Thị trấn',
          },
          {
            id: '8053',
            name: 'Đông Khê',
            prefix: 'Xã',
          },
          {
            id: '8054',
            name: 'Hùng Long',
            prefix: 'Xã',
          },
          {
            id: '8055',
            name: 'Hùng Quan',
            prefix: 'Xã',
          },
          {
            id: '8056',
            name: 'Hữu Đô',
            prefix: 'Xã',
          },
          {
            id: '8057',
            name: 'Minh Lương',
            prefix: 'Xã',
          },
          {
            id: '8058',
            name: 'Minh Phú',
            prefix: 'Xã',
          },
          {
            id: '8059',
            name: 'Minh Tiến',
            prefix: 'Xã',
          },
          {
            id: '8060',
            name: 'Nghinh Xuyên',
            prefix: 'Xã',
          },
          {
            id: '8061',
            name: 'Ngọc Quan',
            prefix: 'Xã',
          },
          {
            id: '8062',
            name: 'Phong Phú',
            prefix: 'Xã',
          },
          {
            id: '8063',
            name: 'Phú Thứ',
            prefix: 'Xã',
          },
          {
            id: '8064',
            name: 'Phúc Lai',
            prefix: 'Xã',
          },
          {
            id: '8065',
            name: 'Phương Trung',
            prefix: 'Xã',
          },
          {
            id: '8066',
            name: 'Quế Lâm',
            prefix: 'Xã',
          },
          {
            id: '8067',
            name: 'Sóc Đăng',
            prefix: 'Xã',
          },
          {
            id: '8068',
            name: 'Tây Cốc',
            prefix: 'Xã',
          },
          {
            id: '8069',
            name: 'Tiêu Sơn',
            prefix: 'Xã',
          },
          {
            id: '8071',
            name: 'Vân Du',
            prefix: 'Xã',
          },
          {
            id: '8070',
            name: 'Vân Đồn',
            prefix: 'Xã',
          },
          {
            id: '8072',
            name: 'Vụ Quang',
            prefix: 'Xã',
          },
          {
            id: '8073',
            name: 'Yên Kiện',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '503',
        name: 'Hạ Hòa',
        wards: [
          {
            id: '8074',
            name: 'Ấm Hạ',
            prefix: 'Xã',
          },
          {
            id: '8075',
            name: 'Bằng Giã',
            prefix: 'Xã',
          },
          {
            id: '8076',
            name: 'Cáo Điền',
            prefix: 'Xã',
          },
          {
            id: '8077',
            name: 'Chính Công',
            prefix: 'Xã',
          },
          {
            id: '8078',
            name: 'Chuế Lưu',
            prefix: 'Xã',
          },
          {
            id: '8079',
            name: 'Đại Phạm',
            prefix: 'Xã',
          },
          {
            id: '8080',
            name: 'Đan Hà',
            prefix: 'Xã',
          },
          {
            id: '8081',
            name: 'Đan Thượng',
            prefix: 'Xã',
          },
          {
            id: '8082',
            name: 'Động Lâm',
            prefix: 'Xã',
          },
          {
            id: '8083',
            name: 'Gia Điền',
            prefix: 'Xã',
          },
          {
            id: '8084',
            name: 'Hạ Hòa',
            prefix: 'Thị trấn',
          },
          {
            id: '8085',
            name: 'Hà Lương',
            prefix: 'Xã',
          },
          {
            id: '8086',
            name: 'Hậu Bổng',
            prefix: 'Xã',
          },
          {
            id: '8087',
            name: 'Hiền Lương',
            prefix: 'Xã',
          },
          {
            id: '8088',
            name: 'Hương Xạ',
            prefix: 'Xã',
          },
          {
            id: '8089',
            name: 'Lâm Lợi',
            prefix: 'Xã',
          },
          {
            id: '8090',
            name: 'Lang Sơn',
            prefix: 'Xã',
          },
          {
            id: '8091',
            name: 'Lệnh Khanh',
            prefix: 'Xã',
          },
          {
            id: '8092',
            name: 'Liên Phương',
            prefix: 'Xã',
          },
          {
            id: '8093',
            name: 'Mai Tùng',
            prefix: 'Xã',
          },
          {
            id: '8094',
            name: 'Minh Côi',
            prefix: 'Xã',
          },
          {
            id: '8095',
            name: 'Minh Hạc',
            prefix: 'Xã',
          },
          {
            id: '8096',
            name: 'Phụ Khánh',
            prefix: 'Xã',
          },
          {
            id: '8097',
            name: 'Phương Viên',
            prefix: 'Xã',
          },
          {
            id: '8098',
            name: 'Quân Khê',
            prefix: 'Xã',
          },
          {
            id: '8099',
            name: 'Văn Lang',
            prefix: 'Xã',
          },
          {
            id: '8100',
            name: 'Vĩnh Chân',
            prefix: 'Xã',
          },
          {
            id: '8101',
            name: 'Vô Tranh',
            prefix: 'Xã',
          },
          {
            id: '8102',
            name: 'Vụ Cầu',
            prefix: 'Xã',
          },
          {
            id: '8103',
            name: 'Xuân Áng',
            prefix: 'Xã',
          },
          {
            id: '8104',
            name: 'Y Sơn',
            prefix: 'Xã',
          },
          {
            id: '8105',
            name: 'Yên Kỳ',
            prefix: 'Xã',
          },
          {
            id: '8106',
            name: 'Yên Luật',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '504',
        name: 'Lâm Thao',
        wards: [
          {
            id: '8107',
            name: 'Bản Nguyên',
            prefix: 'Xã',
          },
          {
            id: '8108',
            name: 'Cao Xá',
            prefix: 'Xã',
          },
          {
            id: '8109',
            name: 'Hợp Hải',
            prefix: 'Xã',
          },
          {
            id: '8110',
            name: 'Hùng Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '8111',
            name: 'Kinh Kệ',
            prefix: 'Xã',
          },
          {
            id: '8112',
            name: 'Lâm Thao',
            prefix: 'Thị trấn',
          },
          {
            id: '8113',
            name: 'Sơn Dương',
            prefix: 'Xã',
          },
          {
            id: '8114',
            name: 'Sơn Vi',
            prefix: 'Xã',
          },
          {
            id: '8115',
            name: 'Thạch Sơn',
            prefix: 'Xã',
          },
          {
            id: '8116',
            name: 'Tiên Kiên',
            prefix: 'Xã',
          },
          {
            id: '8117',
            name: 'Tứ Xã',
            prefix: 'Xã',
          },
          {
            id: '8118',
            name: 'Vĩnh Lại',
            prefix: 'Xã',
          },
          {
            id: '8119',
            name: 'Xuân Huy',
            prefix: 'Xã',
          },
          {
            id: '8120',
            name: 'Xuân Lũng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '505',
        name: 'Phù Ninh',
        wards: [
          {
            id: '8121',
            name: 'An Đạo',
            prefix: 'Xã',
          },
          {
            id: '8122',
            name: 'Bảo Thanh',
            prefix: 'Xã',
          },
          {
            id: '8123',
            name: 'Bình Bộ',
            prefix: 'Xã',
          },
          {
            id: '8124',
            name: 'Gia Thanh',
            prefix: 'Xã',
          },
          {
            id: '8125',
            name: 'Hạ Giáp',
            prefix: 'Xã',
          },
          {
            id: '8126',
            name: 'Lệ Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8127',
            name: 'Liên Hoa',
            prefix: 'Xã',
          },
          {
            id: '8128',
            name: 'Phong Châu',
            prefix: 'Thị trấn',
          },
          {
            id: '8129',
            name: 'Phú Lộc',
            prefix: 'Xã',
          },
          {
            id: '8130',
            name: 'Phú Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8131',
            name: 'Phú Nham',
            prefix: 'Xã',
          },
          {
            id: '8132',
            name: 'Phù Ninh',
            prefix: 'Xã',
          },
          {
            id: '8133',
            name: 'Tiên Du',
            prefix: 'Xã',
          },
          {
            id: '8134',
            name: 'Tiên Phú',
            prefix: 'Xã',
          },
          {
            id: '8135',
            name: 'Trạm Thản',
            prefix: 'Xã',
          },
          {
            id: '8136',
            name: 'Trị Quận',
            prefix: 'Xã',
          },
          {
            id: '8137',
            name: 'Trung Giáp',
            prefix: 'Xã',
          },
          {
            id: '8138',
            name: 'Tử Đà',
            prefix: 'Xã',
          },
          {
            id: '8139',
            name: 'Vĩnh Phú',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '506',
        name: 'Phú Thọ',
        wards: [
          {
            id: '8140',
            name: 'Âu Cơ',
            prefix: 'Phường',
          },
          {
            id: '8141',
            name: 'Hà Lộc',
            prefix: 'Xã',
          },
          {
            id: '8142',
            name: 'Hà Thạch',
            prefix: 'Xã',
          },
          {
            id: '8143',
            name: 'Hùng Vương',
            prefix: 'Phường',
          },
          {
            id: '8144',
            name: 'Phong Châu',
            prefix: 'Phường',
          },
          {
            id: '8145',
            name: 'Phú Hộ',
            prefix: 'Xã',
          },
          {
            id: '8146',
            name: 'Thanh Minh',
            prefix: 'Xã',
          },
          {
            id: '8147',
            name: 'Thanh Vinh',
            prefix: 'Xã',
          },
          {
            id: '8148',
            name: 'Trường Thịnh',
            prefix: 'Phường',
          },
          {
            id: '8149',
            name: 'Văn Lung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '507',
        name: 'Tam Nông',
        wards: [
          {
            id: '8150',
            name: 'Cổ Tiết',
            prefix: 'Xã',
          },
          {
            id: '8151',
            name: 'Dậu Dương',
            prefix: 'Xã',
          },
          {
            id: '8152',
            name: 'Dị Nậu',
            prefix: 'Xã',
          },
          {
            id: '8153',
            name: 'Hiền Quan',
            prefix: 'Xã',
          },
          {
            id: '8154',
            name: 'Hồng Đà',
            prefix: 'Xã',
          },
          {
            id: '8155',
            name: 'Hùng Đô',
            prefix: 'Xã',
          },
          {
            id: '8156',
            name: 'Hưng Hóa',
            prefix: 'Thị trấn',
          },
          {
            id: '8157',
            name: 'Hương Nha',
            prefix: 'Xã',
          },
          {
            id: '8158',
            name: 'Hương Nộn',
            prefix: 'Xã',
          },
          {
            id: '8159',
            name: 'Phương Thịnh',
            prefix: 'Xã',
          },
          {
            id: '8160',
            name: 'Quang Húc',
            prefix: 'Xã',
          },
          {
            id: '8161',
            name: 'Tam Cường',
            prefix: 'Xã',
          },
          {
            id: '8162',
            name: 'Tề Lễ',
            prefix: 'Xã',
          },
          {
            id: '8163',
            name: 'Thanh Uyên',
            prefix: 'Xã',
          },
          {
            id: '8164',
            name: 'Thọ Văn',
            prefix: 'Xã',
          },
          {
            id: '8165',
            name: 'Thượng Nông',
            prefix: 'Xã',
          },
          {
            id: '8166',
            name: 'Tứ Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8167',
            name: 'Văn Lương',
            prefix: 'Xã',
          },
          {
            id: '8168',
            name: 'Vực Trường',
            prefix: 'Xã',
          },
          {
            id: '8169',
            name: 'Xuân Quang',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '508',
        name: 'Tân Sơn',
        wards: [
          {
            id: '8170',
            name: 'Đồng Sơn',
            prefix: 'Xã',
          },
          {
            id: '8171',
            name: 'Kiệt Sơn',
            prefix: 'Xã',
          },
          {
            id: '8172',
            name: 'Kim Thượng',
            prefix: 'Xã',
          },
          {
            id: '8173',
            name: 'Lai Đồng',
            prefix: 'Xã',
          },
          {
            id: '8174',
            name: 'Long Cốc',
            prefix: 'Xã',
          },
          {
            id: '8175',
            name: 'Minh Đài',
            prefix: 'Xã',
          },
          {
            id: '8176',
            name: 'Mỹ Thuận',
            prefix: 'Xã',
          },
          {
            id: '8177',
            name: 'Tam Thanh',
            prefix: 'Xã',
          },
          {
            id: '8178',
            name: 'Tân Phú',
            prefix: 'Xã',
          },
          {
            id: '8179',
            name: 'Tân Sơn',
            prefix: 'Xã',
          },
          {
            id: '8180',
            name: 'Thạch Kiệt',
            prefix: 'Xã',
          },
          {
            id: '8181',
            name: 'Thu Cúc',
            prefix: 'Xã',
          },
          {
            id: '8182',
            name: 'Thu Ngạc',
            prefix: 'Xã',
          },
          {
            id: '8183',
            name: 'Văn Luông',
            prefix: 'Xã',
          },
          {
            id: '8184',
            name: 'Vinh Tiền',
            prefix: 'Xã',
          },
          {
            id: '8185',
            name: 'Xuân Đài',
            prefix: 'Xã',
          },
          {
            id: '8186',
            name: 'Xuân Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '509',
        name: 'Thanh Ba',
        wards: [
          {
            id: '8187',
            name: 'Chí Tiên',
            prefix: 'Xã',
          },
          {
            id: '8188',
            name: 'Đại An',
            prefix: 'Xã',
          },
          {
            id: '8189',
            name: 'Đỗ Sơn',
            prefix: 'Xã',
          },
          {
            id: '8190',
            name: 'Đỗ Xuyên',
            prefix: 'Xã',
          },
          {
            id: '8191',
            name: 'Đông Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '8192',
            name: 'Đông Thành',
            prefix: 'Xã',
          },
          {
            id: '8193',
            name: 'Đồng Xuân',
            prefix: 'Xã',
          },
          {
            id: '8194',
            name: 'Hanh Cù',
            prefix: 'Xã',
          },
          {
            id: '8195',
            name: 'Hoàng Cương',
            prefix: 'Xã',
          },
          {
            id: '8196',
            name: 'Khải Xuân',
            prefix: 'Xã',
          },
          {
            id: '8197',
            name: 'Lương Lỗ',
            prefix: 'Xã',
          },
          {
            id: '8198',
            name: 'Mạn Lạn',
            prefix: 'Xã',
          },
          {
            id: '8199',
            name: 'Năng Yên',
            prefix: 'Xã',
          },
          {
            id: '8200',
            name: 'Ninh Dân',
            prefix: 'Xã',
          },
          {
            id: '8201',
            name: 'Phương Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '8202',
            name: 'Quảng Nạp',
            prefix: 'Xã',
          },
          {
            id: '8203',
            name: 'Sơn Cương',
            prefix: 'Xã',
          },
          {
            id: '8204',
            name: 'Thái Ninh',
            prefix: 'Xã',
          },
          {
            id: '8205',
            name: 'Thanh Ba',
            prefix: 'Thị trấn',
          },
          {
            id: '8206',
            name: 'Thanh Hà',
            prefix: 'Xã',
          },
          {
            id: '8207',
            name: 'Thanh Vân',
            prefix: 'Xã',
          },
          {
            id: '8208',
            name: 'Thanh Xá',
            prefix: 'Xã',
          },
          {
            id: '8209',
            name: 'Vân Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '8210',
            name: 'Võ Lao',
            prefix: 'Xã',
          },
          {
            id: '8211',
            name: 'Vũ Yển',
            prefix: 'Xã',
          },
          {
            id: '8212',
            name: 'Yển Khê',
            prefix: 'Xã',
          },
          {
            id: '8213',
            name: 'Yên Nội',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '510',
        name: 'Thanh Sơn',
        wards: [
          {
            id: '8214',
            name: 'Cự Đồng',
            prefix: 'Xã',
          },
          {
            id: '8215',
            name: 'Cự Thắng',
            prefix: 'Xã',
          },
          {
            id: '8216',
            name: 'Địch Quả',
            prefix: 'Xã',
          },
          {
            id: '8217',
            name: 'Đông Cửu',
            prefix: 'Xã',
          },
          {
            id: '8218',
            name: 'Giáp Lai',
            prefix: 'Xã',
          },
          {
            id: '8219',
            name: 'Hương Cần',
            prefix: 'Xã',
          },
          {
            id: '8220',
            name: 'Khả Cửu',
            prefix: 'Xã',
          },
          {
            id: '8221',
            name: 'Lương Nha',
            prefix: 'Xã',
          },
          {
            id: '8222',
            name: 'Sơn Hùng',
            prefix: 'Xã',
          },
          {
            id: '8223',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '8224',
            name: 'Tân Minh',
            prefix: 'Xã',
          },
          {
            id: '8225',
            name: 'Tất Thắng',
            prefix: 'Xã',
          },
          {
            id: '8226',
            name: 'Thạch Khoán',
            prefix: 'Xã',
          },
          {
            id: '8227',
            name: 'Thắng Sơn',
            prefix: 'Xã',
          },
          {
            id: '8228',
            name: 'Thanh Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '8229',
            name: 'Thục Luyện',
            prefix: 'Xã',
          },
          {
            id: '8230',
            name: 'Thượng Cửu',
            prefix: 'Xã',
          },
          {
            id: '8231',
            name: 'Tinh Nhuệ',
            prefix: 'Xã',
          },
          {
            id: '8232',
            name: 'Văn Miếu',
            prefix: 'Xã',
          },
          {
            id: '8233',
            name: 'Võ Miếu',
            prefix: 'Xã',
          },
          {
            id: '8234',
            name: 'Yên Lãng',
            prefix: 'Xã',
          },
          {
            id: '8235',
            name: 'Yên Lương',
            prefix: 'Xã',
          },
          {
            id: '8236',
            name: 'Yên Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '511',
        name: 'Thanh Thủy',
        wards: [
          {
            id: '8237',
            name: 'Bảo Yên',
            prefix: 'Xã',
          },
          {
            id: '8238',
            name: 'Đào Xá',
            prefix: 'Xã',
          },
          {
            id: '8239',
            name: 'Đoan Hạ',
            prefix: 'Xã',
          },
          {
            id: '8240',
            name: 'Đồng Luận',
            prefix: 'Xã',
          },
          {
            id: '8241',
            name: 'Hoàng Xá',
            prefix: 'Xã',
          },
          {
            id: '8242',
            name: 'Phượng Mao',
            prefix: 'Xã',
          },
          {
            id: '8243',
            name: 'Sơn Thủy',
            prefix: 'Xã',
          },
          {
            id: '8244',
            name: 'Tân Phương',
            prefix: 'Xã',
          },
          {
            id: '8245',
            name: 'Thạch Đồng',
            prefix: 'Xã',
          },
          {
            id: '8246',
            name: 'Thanh Thủy',
            prefix: 'Thị trấn',
          },
          {
            id: '8247',
            name: 'Trung Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '8248',
            name: 'Trung Thịnh',
            prefix: 'Xã',
          },
          {
            id: '8249',
            name: 'Tu Vũ',
            prefix: 'Xã',
          },
          {
            id: '8250',
            name: 'Xuân Lộc',
            prefix: 'Xã',
          },
          {
            id: '8251',
            name: 'Yến Mao',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '512',
        name: 'Việt Trì',
        wards: [
          {
            id: '8252',
            name: 'Bạch Hạc',
            prefix: 'Phường',
          },
          {
            id: '8253',
            name: 'Bến Gót',
            prefix: 'Phường',
          },
          {
            id: '8254',
            name: 'Chu Hóa',
            prefix: 'Xã',
          },
          {
            id: '8255',
            name: 'Dữu Lâu',
            prefix: 'Phường',
          },
          {
            id: '8256',
            name: 'Gia Cẩm',
            prefix: 'Phường',
          },
          {
            id: '8257',
            name: 'Hùng Lô',
            prefix: 'Xã',
          },
          {
            id: '8258',
            name: 'Hy Cương',
            prefix: 'Xã',
          },
          {
            id: '8259',
            name: 'Kim Đức',
            prefix: 'Xã',
          },
          {
            id: '8260',
            name: 'Minh Nông',
            prefix: 'Phường',
          },
          {
            id: '8261',
            name: 'Minh Phương',
            prefix: 'Phường',
          },
          {
            id: '8262',
            name: 'Nông Trang',
            prefix: 'Phường',
          },
          {
            id: '8263',
            name: 'Phượng Lâu',
            prefix: 'Xã',
          },
          {
            id: '8264',
            name: 'Sông Lô',
            prefix: 'Xã',
          },
          {
            id: '8265',
            name: 'Tân Dân',
            prefix: 'Phường',
          },
          {
            id: '8266',
            name: 'Tân Đức',
            prefix: 'Xã',
          },
          {
            id: '8267',
            name: 'Thanh Đình',
            prefix: 'Xã',
          },
          {
            id: '8268',
            name: 'Thanh Miếu',
            prefix: 'Phường',
          },
          {
            id: '8269',
            name: 'Thọ Sơn',
            prefix: 'Phường',
          },
          {
            id: '8270',
            name: 'Thụy Vân',
            prefix: 'Xã',
          },
          {
            id: '8271',
            name: 'Tiên Cát',
            prefix: 'Phường',
          },
          {
            id: '8272',
            name: 'Trưng Vương',
            prefix: 'Xã',
          },
          {
            id: '8273',
            name: 'Vân Cơ',
            prefix: 'Phường',
          },
          {
            id: '8274',
            name: 'Vân Phú',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '513',
        name: 'Yên Lập',
        wards: [
          {
            id: '8275',
            name: 'Đồng Lạc',
            prefix: 'Xã',
          },
          {
            id: '8276',
            name: 'Đồng Thịnh',
            prefix: 'Xã',
          },
          {
            id: '8277',
            name: 'Hưng Long',
            prefix: 'Xã',
          },
          {
            id: '8278',
            name: 'Lương Sơn',
            prefix: 'Xã',
          },
          {
            id: '8279',
            name: 'Minh Hòa',
            prefix: 'Xã',
          },
          {
            id: '8280',
            name: 'Mỹ Lung',
            prefix: 'Xã',
          },
          {
            id: '8281',
            name: 'Mỹ Lương',
            prefix: 'Xã',
          },
          {
            id: '8282',
            name: 'Nga Hoàng',
            prefix: 'Xã',
          },
          {
            id: '8283',
            name: 'Ngọc Đồng',
            prefix: 'Xã',
          },
          {
            id: '8284',
            name: 'Ngọc Lập',
            prefix: 'Xã',
          },
          {
            id: '8285',
            name: 'Phúc Khánh',
            prefix: 'Xã',
          },
          {
            id: '8286',
            name: 'Thượng Long',
            prefix: 'Xã',
          },
          {
            id: '8287',
            name: 'Trung Sơn',
            prefix: 'Xã',
          },
          {
            id: '8288',
            name: 'Xuân An',
            prefix: 'Xã',
          },
          {
            id: '8289',
            name: 'Xuân Thủy',
            prefix: 'Xã',
          },
          {
            id: '8290',
            name: 'Xuân Viên',
            prefix: 'Xã',
          },
          {
            id: '8291',
            name: 'Yên Lập',
            prefix: 'Thị trấn',
          },
        ],
      },
    ],
  },
  {
    id: '43',
    code: 'NT',
    name: 'Ninh Thuận',
    districts: [
      {
        id: '514',
        name: 'Bác Ái',
        wards: [
          {
            id: '8292',
            name: 'Phước Bình',
            prefix: 'Xã',
          },
          {
            id: '8293',
            name: 'Phước Chính',
            prefix: 'Xã',
          },
          {
            id: '8294',
            name: 'Phước Đại',
            prefix: 'Thị trấn',
          },
          {
            id: '8295',
            name: 'Phước Hòa',
            prefix: 'Xã',
          },
          {
            id: '8296',
            name: 'Phước Tân',
            prefix: 'Xã',
          },
          {
            id: '8297',
            name: 'Phước Thắng',
            prefix: 'Xã',
          },
          {
            id: '8298',
            name: 'Phước Thành',
            prefix: 'Xã',
          },
          {
            id: '8299',
            name: 'Phước Tiến',
            prefix: 'Xã',
          },
          {
            id: '8300',
            name: 'Phước Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '515',
        name: 'Ninh Hải',
        wards: [
          {
            id: '8301',
            name: 'Hộ Hải',
            prefix: 'Xã',
          },
          {
            id: '8302',
            name: 'Khánh Hải',
            prefix: 'Thị trấn',
          },
          {
            id: '8303',
            name: 'Nhơn Hải',
            prefix: 'Xã',
          },
          {
            id: '8304',
            name: 'Phương Hải',
            prefix: 'Xã',
          },
          {
            id: '8305',
            name: 'Tân Hải',
            prefix: 'Xã',
          },
          {
            id: '8306',
            name: 'Thanh Hải',
            prefix: 'Xã',
          },
          {
            id: '8307',
            name: 'Tri Hải',
            prefix: 'Xã',
          },
          {
            id: '8308',
            name: 'Vĩnh Hải',
            prefix: 'Xã',
          },
          {
            id: '8309',
            name: 'Xuân Hải',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '516',
        name: 'Ninh Phước',
        wards: [
          {
            id: '8310',
            name: 'An Hải',
            prefix: 'Xã',
          },
          {
            id: '8311',
            name: 'Phước Dân',
            prefix: 'Thị trấn',
          },
          {
            id: '8312',
            name: 'Phước Hải',
            prefix: 'Xã',
          },
          {
            id: '8313',
            name: 'Phước Hậu',
            prefix: 'Xã',
          },
          {
            id: '8314',
            name: 'Phước Hữu',
            prefix: 'Xã',
          },
          {
            id: '8315',
            name: 'Phước Sơn',
            prefix: 'Xã',
          },
          {
            id: '8316',
            name: 'Phước Thái',
            prefix: 'Xã',
          },
          {
            id: '8317',
            name: 'Phước Thuận',
            prefix: 'Xã',
          },
          {
            id: '8318',
            name: 'Phước Vinh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '517',
        name: 'Ninh Sơn',
        wards: [
          {
            id: '8319',
            name: 'Hòa Sơn',
            prefix: 'Xã',
          },
          {
            id: '8320',
            name: 'Lâm Sơn',
            prefix: 'Xã',
          },
          {
            id: '8321',
            name: 'Lương Sơn',
            prefix: 'Xã',
          },
          {
            id: '8322',
            name: 'Ma Nới',
            prefix: 'Xã',
          },
          {
            id: '8323',
            name: 'Mỹ Sơn',
            prefix: 'Xã',
          },
          {
            id: '8324',
            name: 'Nhơn Sơn',
            prefix: 'Xã',
          },
          {
            id: '8325',
            name: 'Quảng Sơn',
            prefix: 'Xã',
          },
          {
            id: '8326',
            name: 'Tân Sơn',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '518',
        name: 'Phan Rang - Tháp Chàm',
        wards: [
          {
            id: '8327',
            name: 'Bảo An',
            prefix: 'Phường',
          },
          {
            id: '8328',
            name: 'Đài Sơn',
            prefix: 'Phường',
          },
          {
            id: '8329',
            name: 'Đạo Long',
            prefix: 'Phường',
          },
          {
            id: '8330',
            name: 'Đô Vinh',
            prefix: 'Phường',
          },
          {
            id: '8331',
            name: 'Đông Hải',
            prefix: 'Phường',
          },
          {
            id: '8332',
            name: 'Kinh Dinh',
            prefix: 'Phường',
          },
          {
            id: '8333',
            name: 'Mỹ Bình',
            prefix: 'Phường',
          },
          {
            id: '8334',
            name: 'Mỹ Đông',
            prefix: 'Phường',
          },
          {
            id: '8335',
            name: 'Mỹ Hải',
            prefix: 'Phường',
          },
          {
            id: '8336',
            name: 'Mỹ Hương',
            prefix: 'Phường',
          },
          {
            id: '8337',
            name: 'Phủ Hà',
            prefix: 'Phường',
          },
          {
            id: '8338',
            name: 'Phước Mỹ',
            prefix: 'Phường',
          },
          {
            id: '8339',
            name: 'Tấn Tài',
            prefix: 'Phường',
          },
          {
            id: '8340',
            name: 'Thành Hải',
            prefix: 'Xã',
          },
          {
            id: '8341',
            name: 'Thanh Sơn',
            prefix: 'Phường',
          },
          {
            id: '8342',
            name: 'Văn Hải',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '519',
        name: 'Thuận Bắc',
        wards: [
          {
            id: '8343',
            name: 'Bắc Phong',
            prefix: 'Xã',
          },
          {
            id: '8344',
            name: 'Bắc Sơn',
            prefix: 'Xã',
          },
          {
            id: '8345',
            name: 'Công Hải',
            prefix: 'Xã',
          },
          {
            id: '8346',
            name: 'Lợi Hải',
            prefix: 'Thị trấn',
          },
          {
            id: '8347',
            name: 'Phước Chiến',
            prefix: 'Xã',
          },
          {
            id: '8348',
            name: 'Phước Kháng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '520',
        name: 'Thuận Nam',
        wards: [
          {
            id: '8349',
            name: 'Cà Ná',
            prefix: 'Xã',
          },
          {
            id: '8350',
            name: 'Nhị Hà',
            prefix: 'Xã',
          },
          {
            id: '8351',
            name: 'Phước Diêm',
            prefix: 'Xã',
          },
          {
            id: '8352',
            name: 'Phước Dinh',
            prefix: 'Xã',
          },
          {
            id: '8353',
            name: 'Phước Hà',
            prefix: 'Xã',
          },
          {
            id: '8354',
            name: 'Phước Minh',
            prefix: 'Xã',
          },
          {
            id: '8355',
            name: 'Phước Nam',
            prefix: 'Xã',
          },
          {
            id: '8356',
            name: 'Phước Ninh',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '44',
    code: 'PY',
    name: 'Phú Yên',
    districts: [
      {
        id: '521',
        name: 'Đông Hòa',
        wards: [
          {
            id: '8357',
            name: 'Hòa Hiệp Bắc',
            prefix: 'Xã',
          },
          {
            id: '8358',
            name: 'Hòa Hiệp Nam',
            prefix: 'Xã',
          },
          {
            id: '8359',
            name: 'Hòa Hiệp Trung',
            prefix: 'Xã',
          },
          {
            id: '8360',
            name: 'Hòa Tâm',
            prefix: 'Xã',
          },
          {
            id: '8361',
            name: 'Hòa Tân Đông',
            prefix: 'Xã',
          },
          {
            id: '8362',
            name: 'Hòa Thành',
            prefix: 'Xã',
          },
          {
            id: '8363',
            name: 'Hòa Vinh',
            prefix: 'Xã',
          },
          {
            id: '8364',
            name: 'Hòa Xuân Đông',
            prefix: 'Xã',
          },
          {
            id: '8365',
            name: 'Hòa Xuân Nam',
            prefix: 'Xã',
          },
          {
            id: '8366',
            name: 'Hòa Xuân Tây',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '522',
        name: 'Đồng Xuân',
        wards: [
          {
            id: '8367',
            name: 'Đa Lộc',
            prefix: 'Xã',
          },
          {
            id: '8368',
            name: 'La Hai',
            prefix: 'Thị trấn',
          },
          {
            id: '8369',
            name: 'Phú Mỡ',
            prefix: 'Xã',
          },
          {
            id: '8370',
            name: 'Xuân Lãnh',
            prefix: 'Xã',
          },
          {
            id: '8371',
            name: 'Xuân Long',
            prefix: 'Xã',
          },
          {
            id: '8372',
            name: 'Xuân Phước',
            prefix: 'Xã',
          },
          {
            id: '8373',
            name: 'Xuân Quang 1',
            prefix: 'Xã',
          },
          {
            id: '8374',
            name: 'Xuân Quang 2',
            prefix: 'Xã',
          },
          {
            id: '8375',
            name: 'Xuân Quang 3',
            prefix: 'Xã',
          },
          {
            id: '8376',
            name: 'Xuân Sơn Bắc',
            prefix: 'Xã',
          },
          {
            id: '8377',
            name: 'Xuân Sơn Nam',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '523',
        name: 'Phú Hòa',
        wards: [
          {
            id: '8378',
            name: 'Hòa An',
            prefix: 'Xã',
          },
          {
            id: '8379',
            name: 'Hòa Định Đông',
            prefix: 'Xã',
          },
          {
            id: '8380',
            name: 'Hòa Định Tây',
            prefix: 'Xã',
          },
          {
            id: '8381',
            name: 'Hòa Hội',
            prefix: 'Xã',
          },
          {
            id: '8382',
            name: 'Hoà Quang Bắc',
            prefix: 'Xã',
          },
          {
            id: '8383',
            name: 'Hoà Quang Nam',
            prefix: 'Xã',
          },
          {
            id: '8384',
            name: 'Hòa Thắng',
            prefix: 'Xã',
          },
          {
            id: '8385',
            name: 'Hòa Trị',
            prefix: 'Xã',
          },
          {
            id: '8386',
            name: 'Phú Hòa',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '524',
        name: 'Sơn Hòa',
        wards: [
          {
            id: '8387',
            name: 'Cà Lúi',
            prefix: 'Xã',
          },
          {
            id: '8388',
            name: 'Củng Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '8389',
            name: 'Eachà Rang',
            prefix: 'Xã',
          },
          {
            id: '8390',
            name: 'Krông Pa',
            prefix: 'Xã',
          },
          {
            id: '8391',
            name: 'Phước Tân',
            prefix: 'Xã',
          },
          {
            id: '8392',
            name: 'Sơn Định',
            prefix: 'Xã',
          },
          {
            id: '8393',
            name: 'Sơn Hà',
            prefix: 'Xã',
          },
          {
            id: '8394',
            name: 'Sơn Hội',
            prefix: 'Xã',
          },
          {
            id: '8395',
            name: 'Sơn Long',
            prefix: 'Xã',
          },
          {
            id: '8396',
            name: 'Sơn Nguyên',
            prefix: 'Xã',
          },
          {
            id: '8397',
            name: 'Sơn Phước',
            prefix: 'Xã',
          },
          {
            id: '8398',
            name: 'Sơn Xuân',
            prefix: 'Xã',
          },
          {
            id: '8399',
            name: 'Suối Bạc',
            prefix: 'Xã',
          },
          {
            id: '8400',
            name: 'Suối Trai',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '525',
        name: 'Sông Cầu',
        wards: [
          {
            id: '8401',
            name: 'Xuân Bình',
            prefix: 'Xã',
          },
          {
            id: '8402',
            name: 'Xuân Cảnh',
            prefix: 'Xã',
          },
          {
            id: '8403',
            name: 'Xuân Đài',
            prefix: 'Phường',
          },
          {
            id: '8404',
            name: 'Xuân Hải',
            prefix: 'Xã',
          },
          {
            id: '8405',
            name: 'Xuân Hòa',
            prefix: 'Xã',
          },
          {
            id: '8406',
            name: 'Xuân Lâm',
            prefix: 'Xã',
          },
          {
            id: '8407',
            name: 'Xuân Lộc',
            prefix: 'Xã',
          },
          {
            id: '8408',
            name: 'Xuân Phú',
            prefix: 'Phường',
          },
          {
            id: '8409',
            name: 'Xuân Phương',
            prefix: 'Xã',
          },
          {
            id: '8410',
            name: 'Xuân Thành',
            prefix: 'Phường',
          },
          {
            id: '8411',
            name: 'Xuân Thịnh',
            prefix: 'Xã',
          },
          {
            id: '8412',
            name: 'Xuân Thọ 1',
            prefix: 'Xã',
          },
          {
            id: '8413',
            name: 'Xuân Thọ 2',
            prefix: 'Xã',
          },
          {
            id: '8414',
            name: 'Xuân Yên',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '526',
        name: 'Sông Hinh',
        wards: [
          {
            id: '8415',
            name: 'Đức Bình Đông',
            prefix: 'Xã',
          },
          {
            id: '8416',
            name: 'Đức Bình Tây',
            prefix: 'Xã',
          },
          {
            id: '8417',
            name: 'Ea Bá',
            prefix: 'Xã',
          },
          {
            id: '8418',
            name: 'Ea Bar',
            prefix: 'Xã',
          },
          {
            id: '8419',
            name: 'Ea Bia',
            prefix: 'Xã',
          },
          {
            id: '8420',
            name: 'Ea Lâm',
            prefix: 'Xã',
          },
          {
            id: '8421',
            name: 'Ea Ly',
            prefix: 'Xã',
          },
          {
            id: '8422',
            name: 'Ea Trol',
            prefix: 'Xã',
          },
          {
            id: '8423',
            name: 'Hai Riêng',
            prefix: 'Thị trấn',
          },
          {
            id: '8424',
            name: 'Sơn Giang',
            prefix: 'Xã',
          },
          {
            id: '8425',
            name: 'Sông Hinh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '527',
        name: 'Tây Hòa',
        wards: [
          {
            id: '8426',
            name: 'Hòa Bình 1',
            prefix: 'Xã',
          },
          {
            id: '8427',
            name: 'Hòa Đồng',
            prefix: 'Xã',
          },
          {
            id: '8428',
            name: 'Hòa Mỹ Đông',
            prefix: 'Xã',
          },
          {
            id: '8429',
            name: 'Hòa Mỹ Tây',
            prefix: 'Xã',
          },
          {
            id: '8430',
            name: 'Hòa Phong',
            prefix: 'Xã',
          },
          {
            id: '8431',
            name: 'Hòa Phú',
            prefix: 'Xã',
          },
          {
            id: '8432',
            name: 'Hòa Tân Tây',
            prefix: 'Xã',
          },
          {
            id: '8433',
            name: 'Hòa Thịnh',
            prefix: 'Xã',
          },
          {
            id: '8434',
            name: 'Phú Thứ',
            prefix: 'Thị trấn',
          },
          {
            id: '8435',
            name: 'Sơn Thành Đông',
            prefix: 'Xã',
          },
          {
            id: '8436',
            name: 'Sơn Thành Tây',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '528',
        name: 'Tuy An',
        wards: [
          {
            id: '8437',
            name: 'An Chấn',
            prefix: 'Xã',
          },
          {
            id: '8438',
            name: 'An Cư',
            prefix: 'Xã',
          },
          {
            id: '8439',
            name: 'An Dân',
            prefix: 'Xã',
          },
          {
            id: '8440',
            name: 'An Định',
            prefix: 'Xã',
          },
          {
            id: '8441',
            name: 'An Hải',
            prefix: 'Xã',
          },
          {
            id: '8442',
            name: 'An Hiệp',
            prefix: 'Xã',
          },
          {
            id: '8443',
            name: 'An Hoà',
            prefix: 'Xã',
          },
          {
            id: '8444',
            name: 'An Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '8445',
            name: 'An Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8446',
            name: 'An Nghiệp',
            prefix: 'Xã',
          },
          {
            id: '8447',
            name: 'An Ninh Đông',
            prefix: 'Xã',
          },
          {
            id: '8448',
            name: 'An Ninh Tây',
            prefix: 'Xã',
          },
          {
            id: '8449',
            name: 'An Thạch',
            prefix: 'Xã',
          },
          {
            id: '8450',
            name: 'An Thọ',
            prefix: 'Xã',
          },
          {
            id: '8451',
            name: 'An Xuân',
            prefix: 'Xã',
          },
          {
            id: '8452',
            name: 'Chí Thạnh',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '529',
        name: 'Tuy Hòa',
        wards: [
          {
            id: '8453',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '8454',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '8455',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '8456',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '8457',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '8458',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '8459',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '8460',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '8461',
            name: '9',
            prefix: 'Phường',
          },
          {
            id: '8462',
            name: 'An Phú',
            prefix: 'Xã',
          },
          {
            id: '8463',
            name: 'Bình Kiến',
            prefix: 'Xã',
          },
          {
            id: '8464',
            name: 'Bình Ngọc',
            prefix: 'Xã',
          },
          {
            id: '8465',
            name: 'Hoà Kiến',
            prefix: 'Xã',
          },
          {
            id: '8466',
            name: 'Phú Đông',
            prefix: 'Phường',
          },
          {
            id: '8467',
            name: 'Phú Lâm',
            prefix: 'Phường',
          },
          {
            id: '8468',
            name: 'Phú Lâm',
            prefix: 'Phường',
          },
          {
            id: '8469',
            name: 'Phú Thạnh',
            prefix: 'Phường',
          },
        ],
      },
    ],
  },
  {
    id: '45',
    code: 'HNA',
    name: 'Hà Nam',
    districts: [
      {
        id: '530',
        name: 'Bình Lục',
        wards: [
          {
            id: '8470',
            name: 'An Đổ',
            prefix: 'Xã',
          },
          {
            id: '8471',
            name: 'An Lão',
            prefix: 'Xã',
          },
          {
            id: '8472',
            name: 'An Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8473',
            name: 'An Ninh',
            prefix: 'Xã',
          },
          {
            id: '8474',
            name: 'An Nội',
            prefix: 'Xã',
          },
          {
            id: '8475',
            name: 'Bình Mỹ',
            prefix: 'Thị trấn',
          },
          {
            id: '8476',
            name: 'Bình Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '8477',
            name: 'Bồ Đề',
            prefix: 'Xã',
          },
          {
            id: '8478',
            name: 'Bối Cầu',
            prefix: 'Xã',
          },
          {
            id: '8479',
            name: 'Đồn Xá',
            prefix: 'Xã',
          },
          {
            id: '8480',
            name: 'Đồng Du',
            prefix: 'Xã',
          },
          {
            id: '8481',
            name: 'Hưng Công',
            prefix: 'Xã',
          },
          {
            id: '8482',
            name: 'La Sơn',
            prefix: 'Xã',
          },
          {
            id: '8483',
            name: 'Mỹ Thọ',
            prefix: 'Xã',
          },
          {
            id: '8484',
            name: 'Ngọc Lũ',
            prefix: 'Xã',
          },
          {
            id: '8485',
            name: 'Tiêu Động',
            prefix: 'Xã',
          },
          {
            id: '8486',
            name: 'Tràng An',
            prefix: 'Xã',
          },
          {
            id: '8487',
            name: 'Trung Lương',
            prefix: 'Xã',
          },
          {
            id: '8488',
            name: 'Vũ Bản',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '531',
        name: 'Duy Tiên',
        wards: [
          {
            id: '8489',
            name: 'Bạch Thượng',
            prefix: 'Xã',
          },
          {
            id: '8490',
            name: 'Châu Giang',
            prefix: 'Xã',
          },
          {
            id: '8491',
            name: 'Châu Sơn',
            prefix: 'Xã',
          },
          {
            id: '8492',
            name: 'Chuyên Ngoại',
            prefix: 'Xã',
          },
          {
            id: '8495',
            name: 'Duy Hải',
            prefix: 'Xã',
          },
          {
            id: '8496',
            name: 'Duy Minh',
            prefix: 'Xã',
          },
          {
            id: '8493',
            name: 'Đọi Sơn',
            prefix: 'Xã',
          },
          {
            id: '8494',
            name: 'Đồng Văn',
            prefix: 'Thị trấn',
          },
          {
            id: '8497',
            name: 'Hòa Mạc',
            prefix: 'Thị trấn',
          },
          {
            id: '8498',
            name: 'Hoàng Đông',
            prefix: 'Xã',
          },
          {
            id: '8499',
            name: 'Mộc Bắc',
            prefix: 'Xã',
          },
          {
            id: '8500',
            name: 'Mộc Nam',
            prefix: 'Xã',
          },
          {
            id: '8501',
            name: 'Tiên Ngoại',
            prefix: 'Xã',
          },
          {
            id: '8502',
            name: 'Tiên Nội',
            prefix: 'Xã',
          },
          {
            id: '8503',
            name: 'Tiên Phong',
            prefix: 'Xã',
          },
          {
            id: '8504',
            name: 'Trác Văn',
            prefix: 'Xã',
          },
          {
            id: '8505',
            name: 'Yên Bắc',
            prefix: 'Xã',
          },
          {
            id: '8506',
            name: 'Yên Nam',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '532',
        name: 'Kim Bảng',
        wards: [
          {
            id: '8507',
            name: 'Ba Sao',
            prefix: 'Thị trấn',
          },
          {
            id: '8508',
            name: 'Đại Cương',
            prefix: 'Xã',
          },
          {
            id: '8509',
            name: 'Đồng Hóa',
            prefix: 'Xã',
          },
          {
            id: '8510',
            name: 'Hoàng Tây',
            prefix: 'Xã',
          },
          {
            id: '8511',
            name: 'Khả Phong',
            prefix: 'Xã',
          },
          {
            id: '8512',
            name: 'Lê Hồ',
            prefix: 'Xã',
          },
          {
            id: '8513',
            name: 'Liên Sơn',
            prefix: 'Xã',
          },
          {
            id: '8514',
            name: 'Ngọc Sơn',
            prefix: 'Xã',
          },
          {
            id: '8515',
            name: 'Nguyễn Úy',
            prefix: 'Xã',
          },
          {
            id: '8516',
            name: 'Nhật Tân',
            prefix: 'Xã',
          },
          {
            id: '8517',
            name: 'Nhật Tựu',
            prefix: 'Xã',
          },
          {
            id: '8518',
            name: 'Quế',
            prefix: 'Thị trấn',
          },
          {
            id: '8519',
            name: 'Tân Sơn',
            prefix: 'Xã',
          },
          {
            id: '8520',
            name: 'Thanh Sơn',
            prefix: 'Xã',
          },
          {
            id: '8521',
            name: 'Thi Sơn',
            prefix: 'Xã',
          },
          {
            id: '8522',
            name: 'Thụy Lôi',
            prefix: 'Xã',
          },
          {
            id: '8523',
            name: 'Tượng Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '8524',
            name: 'Văn Xá',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '533',
        name: 'Lý Nhân',
        wards: [
          {
            id: '8525',
            name: 'Bắc Lý',
            prefix: 'Xã',
          },
          {
            id: '8526',
            name: 'Chân Lý',
            prefix: 'Xã',
          },
          {
            id: '8527',
            name: 'Chính Lý',
            prefix: 'Xã',
          },
          {
            id: '8528',
            name: 'Công Lý',
            prefix: 'Xã',
          },
          {
            id: '8529',
            name: 'Đạo Lý',
            prefix: 'Xã',
          },
          {
            id: '8530',
            name: 'Đồng Lý',
            prefix: 'Xã',
          },
          {
            id: '8531',
            name: 'Đức Lý',
            prefix: 'Xã',
          },
          {
            id: '8532',
            name: 'Hoà Hậu',
            prefix: 'Thị trấn',
          },
          {
            id: '8533',
            name: 'Hợp Lý',
            prefix: 'Xã',
          },
          {
            id: '8534',
            name: 'Nguyên Lý',
            prefix: 'Xã',
          },
          {
            id: '8535',
            name: 'Nhân Bình',
            prefix: 'Xã',
          },
          {
            id: '8536',
            name: 'Nhân Chính',
            prefix: 'Xã',
          },
          {
            id: '8537',
            name: 'Nhân Đạo',
            prefix: 'Xã',
          },
          {
            id: '8538',
            name: 'Nhân Hưng',
            prefix: 'Xã',
          },
          {
            id: '8539',
            name: 'Nhân Khang',
            prefix: 'Xã',
          },
          {
            id: '8540',
            name: 'Nhân Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8541',
            name: 'Nhân Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '8542',
            name: 'Nhân Thịnh',
            prefix: 'Xã',
          },
          {
            id: '8543',
            name: 'Phú Phúc',
            prefix: 'Thị trấn',
          },
          {
            id: '8544',
            name: 'Tiến Thắng',
            prefix: 'Xã',
          },
          {
            id: '8545',
            name: 'Văn Lý',
            prefix: 'Xã',
          },
          {
            id: '8546',
            name: 'Vĩnh Trụ',
            prefix: 'Thị trấn',
          },
          {
            id: '8547',
            name: 'Xuân Khê',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '534',
        name: 'Phủ Lý',
        wards: [
          {
            id: '8548',
            name: 'Châu Sơn',
            prefix: 'Xã',
          },
          {
            id: '8549',
            name: 'Đinh Xá',
            prefix: 'Xã',
          },
          {
            id: '8550',
            name: 'Hai Bà Trưng',
            prefix: 'Phường',
          },
          {
            id: '8551',
            name: 'Kim Bình',
            prefix: 'Xã',
          },
          {
            id: '8552',
            name: 'Lam Hạ',
            prefix: 'Xã',
          },
          {
            id: '8553',
            name: 'Lê Hồng Phong',
            prefix: 'Phường',
          },
          {
            id: '8554',
            name: 'Liêm Chính',
            prefix: 'Xã',
          },
          {
            id: '8555',
            name: 'Liêm Chung',
            prefix: 'Xã',
          },
          {
            id: '8556',
            name: 'Liêm Tiết',
            prefix: 'Xã',
          },
          {
            id: '8557',
            name: 'Liêm Tuyền',
            prefix: 'Xã',
          },
          {
            id: '8558',
            name: 'Lương Khánh Thiện',
            prefix: 'Phường',
          },
          {
            id: '8559',
            name: 'Minh Khai',
            prefix: 'Phường',
          },
          {
            id: '8560',
            name: 'Phù Vân',
            prefix: 'Xã',
          },
          {
            id: '8561',
            name: 'Quang Trung',
            prefix: 'Phường',
          },
          {
            id: '8562',
            name: 'Thanh Châu',
            prefix: 'Xã',
          },
          {
            id: '8563',
            name: 'Thanh Tuyền',
            prefix: 'Phường',
          },
          {
            id: '8564',
            name: 'Tiên Hải',
            prefix: 'Xã',
          },
          {
            id: '8565',
            name: 'Tiên Hiệp',
            prefix: 'Xã',
          },
          {
            id: '8566',
            name: 'Tiên Tân',
            prefix: 'Xã',
          },
          {
            id: '8567',
            name: 'Trần Hưng Đạo',
            prefix: 'Phường',
          },
          {
            id: '8568',
            name: 'Trịnh Xá',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '535',
        name: 'Thanh Liêm',
        wards: [
          {
            id: '8569',
            name: 'Kiện Khê',
            prefix: 'Thị trấn',
          },
          {
            id: '8570',
            name: 'Liêm Cần',
            prefix: 'Xã',
          },
          {
            id: '8571',
            name: 'Liêm Phong',
            prefix: 'Xã',
          },
          {
            id: '8572',
            name: 'Liêm Sơn',
            prefix: 'Xã',
          },
          {
            id: '8573',
            name: 'Liêm Thuận',
            prefix: 'Xã',
          },
          {
            id: '8574',
            name: 'Liêm Túc',
            prefix: 'Xã',
          },
          {
            id: '8575',
            name: 'Thanh Bình',
            prefix: 'Xã',
          },
          {
            id: '8576',
            name: 'Thanh Hà',
            prefix: 'Xã',
          },
          {
            id: '8577',
            name: 'Thanh Hải',
            prefix: 'Xã',
          },
          {
            id: '8578',
            name: 'Thanh Hương',
            prefix: 'Xã',
          },
          {
            id: '8579',
            name: 'Thanh Lưu',
            prefix: 'Xã',
          },
          {
            id: '8580',
            name: 'Thanh Nghị',
            prefix: 'Xã',
          },
          {
            id: '8581',
            name: 'Thanh Nguyên',
            prefix: 'Xã',
          },
          {
            id: '8582',
            name: 'Thanh Phong',
            prefix: 'Xã',
          },
          {
            id: '8583',
            name: 'Thanh Tâm',
            prefix: 'Xã',
          },
          {
            id: '8584',
            name: 'Thanh Tân',
            prefix: 'Xã',
          },
          {
            id: '8585',
            name: 'Thanh Thủy',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '46',
    code: 'HT',
    name: 'Hà Tĩnh',
    districts: [
      {
        id: '536',
        name: 'Cẩm Xuyên',
        wards: [
          {
            id: '8586',
            name: ' Cẩm Lộc',
            prefix: 'Xã',
          },
          {
            id: '8587',
            name: ' Cẩm Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8588',
            name: ' Cẩm Nhượng',
            prefix: 'Xã',
          },
          {
            id: '8589',
            name: 'Cẩm Bình',
            prefix: 'Xã',
          },
          {
            id: '8590',
            name: 'Cẩm Duệ',
            prefix: 'Xã',
          },
          {
            id: '8591',
            name: 'Cẩm Dương',
            prefix: 'Xã',
          },
          {
            id: '8592',
            name: 'Cẩm Hà',
            prefix: 'Xã',
          },
          {
            id: '8593',
            name: 'Cẩm Hoà',
            prefix: 'Xã',
          },
          {
            id: '8594',
            name: 'Cẩm Hưng',
            prefix: 'Xã',
          },
          {
            id: '8595',
            name: 'Cẩm Huy',
            prefix: 'Xã',
          },
          {
            id: '8596',
            name: 'Cẩm Lạc',
            prefix: 'Xã',
          },
          {
            id: '8597',
            name: 'Cẩm Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '8598',
            name: 'Cẩm Minh',
            prefix: 'Xã',
          },
          {
            id: '8599',
            name: 'Cẩm Nam',
            prefix: 'Xã',
          },
          {
            id: '8600',
            name: 'Cẩm Phúc',
            prefix: 'Xã',
          },
          {
            id: '8601',
            name: 'Cẩm Quan',
            prefix: 'Xã',
          },
          {
            id: '8602',
            name: 'Cẩm Quang',
            prefix: 'Xã',
          },
          {
            id: '8603',
            name: 'Cẩm Sơn',
            prefix: 'Xã',
          },
          {
            id: '8604',
            name: 'Cẩm thạch',
            prefix: 'Xã',
          },
          {
            id: '8605',
            name: 'Cẩm Thăng',
            prefix: 'Xã',
          },
          {
            id: '8606',
            name: 'Cẩm Thành',
            prefix: 'Xã',
          },
          {
            id: '8607',
            name: 'Cẩm Thịnh',
            prefix: 'Xã',
          },
          {
            id: '8608',
            name: 'Cẩm Trung',
            prefix: 'Xã',
          },
          {
            id: '8609',
            name: 'Cẩm Vịnh',
            prefix: 'Xã',
          },
          {
            id: '8610',
            name: 'Cẩm Xuyên',
            prefix: 'Thị trấn',
          },
          {
            id: '8611',
            name: 'Cẩm Yên',
            prefix: 'Xã',
          },
          {
            id: '8612',
            name: 'Thiên Cầm',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '537',
        name: 'Can Lộc',
        wards: [
          {
            id: '8613',
            name: ' Xuân Lộc',
            prefix: 'Xã',
          },
          {
            id: '8614',
            name: 'Đồng Lộc',
            prefix: 'Xã',
          },
          {
            id: '8615',
            name: 'Gia Hanh',
            prefix: 'Xã',
          },
          {
            id: '8616',
            name: 'Khánh Lộc',
            prefix: 'Xã',
          },
          {
            id: '8617',
            name: 'Kim Lộc',
            prefix: 'Xã',
          },
          {
            id: '8618',
            name: 'Mỹ Lộc',
            prefix: 'Xã',
          },
          {
            id: '8619',
            name: 'Nghèn',
            prefix: 'Thị trấn',
          },
          {
            id: '8620',
            name: 'Phú Lộc',
            prefix: 'Xã',
          },
          {
            id: '8621',
            name: 'Quang Lộc',
            prefix: 'Xã',
          },
          {
            id: '8622',
            name: 'Sơn Lộc',
            prefix: 'Xã',
          },
          {
            id: '8623',
            name: 'Song Lộc',
            prefix: 'Xã',
          },
          {
            id: '8624',
            name: 'Thanh Lộc',
            prefix: 'Xã',
          },
          {
            id: '8625',
            name: 'Thiên Lộc',
            prefix: 'Xã',
          },
          {
            id: '8626',
            name: 'Thuần Thiện',
            prefix: 'Xã',
          },
          {
            id: '8627',
            name: 'Thượng Lộc',
            prefix: 'Xã',
          },
          {
            id: '8628',
            name: 'Thường Nga',
            prefix: 'Xã',
          },
          {
            id: '8629',
            name: 'Tiến Lộc',
            prefix: 'Xã',
          },
          {
            id: '8630',
            name: 'Trung Lộc',
            prefix: 'Xã',
          },
          {
            id: '8631',
            name: 'Trường Lộc',
            prefix: 'Xã',
          },
          {
            id: '8632',
            name: 'Tùng Lộc',
            prefix: 'Xã',
          },
          {
            id: '8633',
            name: 'Vĩnh Lộc',
            prefix: 'Xã',
          },
          {
            id: '8634',
            name: 'Vượng Lộc',
            prefix: 'Xã',
          },
          {
            id: '8635',
            name: 'Yên Lộc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '538',
        name: 'Đức Thọ',
        wards: [
          {
            id: '8636',
            name: 'Bùi Xá',
            prefix: 'Xã',
          },
          {
            id: '8637',
            name: 'Đức An',
            prefix: 'Xã',
          },
          {
            id: '8638',
            name: 'Đức Châu',
            prefix: 'Xã',
          },
          {
            id: '8640',
            name: 'Đức Dũng',
            prefix: 'Xã',
          },
          {
            id: '8639',
            name: 'Đức Đồng',
            prefix: 'Xã',
          },
          {
            id: '8641',
            name: 'Đức Hòa',
            prefix: 'Xã',
          },
          {
            id: '8642',
            name: 'Đức La',
            prefix: 'Xã',
          },
          {
            id: '8643',
            name: 'Đức Lạc',
            prefix: 'Xã',
          },
          {
            id: '8644',
            name: 'Đức Lâm',
            prefix: 'Xã',
          },
          {
            id: '8645',
            name: 'Đức Lạng',
            prefix: 'Xã',
          },
          {
            id: '8646',
            name: 'Đức Lập',
            prefix: 'Xã',
          },
          {
            id: '8647',
            name: 'Đức Long',
            prefix: 'Xã',
          },
          {
            id: '8648',
            name: 'Đức Nhân',
            prefix: 'Xã',
          },
          {
            id: '8649',
            name: 'Đức Quang',
            prefix: 'Xã',
          },
          {
            id: '8650',
            name: 'Đức Thanh',
            prefix: 'Xã',
          },
          {
            id: '8651',
            name: 'Đức Thịnh',
            prefix: 'Xã',
          },
          {
            id: '8652',
            name: 'Đức Thọ',
            prefix: 'Thị trấn',
          },
          {
            id: '8653',
            name: 'Đức Thủy',
            prefix: 'Xã',
          },
          {
            id: '8654',
            name: 'Đức Tùng',
            prefix: 'Xã',
          },
          {
            id: '8655',
            name: 'Đức Vịnh',
            prefix: 'Xã',
          },
          {
            id: '8656',
            name: 'Đức Yên',
            prefix: 'Xã',
          },
          {
            id: '8657',
            name: 'Liên Minh',
            prefix: 'Xã',
          },
          {
            id: '8658',
            name: 'Tân Hương',
            prefix: 'Xã',
          },
          {
            id: '8659',
            name: 'Thái Yên',
            prefix: 'Xã',
          },
          {
            id: '8660',
            name: 'Trung Lễ',
            prefix: 'Xã',
          },
          {
            id: '8661',
            name: 'Trường Sơn',
            prefix: 'Xã',
          },
          {
            id: '8662',
            name: 'Tùng Ảnh',
            prefix: 'Xã',
          },
          {
            id: '8663',
            name: 'Yên Hồ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '539',
        name: 'Hà Tĩnh',
        wards: [
          {
            id: '8664',
            name: ' Nam Hà',
            prefix: 'Phường',
          },
          {
            id: '8665',
            name: ' Thạch Quý',
            prefix: 'Phường',
          },
          {
            id: '8666',
            name: ' Văn Yên',
            prefix: 'Phường',
          },
          {
            id: '8667',
            name: 'Bắc Hà',
            prefix: 'Phường',
          },
          {
            id: '8668',
            name: 'Đại Nài',
            prefix: 'Phường',
          },
          {
            id: '8669',
            name: 'Hà Huy Tập',
            prefix: 'Phường',
          },
          {
            id: '8670',
            name: 'Nguyễn Du',
            prefix: 'Phường',
          },
          {
            id: '8671',
            name: 'Tân Giang',
            prefix: 'Phường',
          },
          {
            id: '8672',
            name: 'Thạch Bình',
            prefix: 'Xã',
          },
          {
            id: '8673',
            name: 'Thạch Đồng',
            prefix: 'Xã',
          },
          {
            id: '8674',
            name: 'Thạch Hạ',
            prefix: 'Xã',
          },
          {
            id: '8675',
            name: 'Thạch Hưng',
            prefix: 'Xã',
          },
          {
            id: '8676',
            name: 'Thạch Linh',
            prefix: 'Phường',
          },
          {
            id: '8677',
            name: 'Thạch Môn',
            prefix: 'Xã',
          },
          {
            id: '8678',
            name: 'Thạch Trung',
            prefix: 'Xã',
          },
          {
            id: '8679',
            name: 'Trần Phú',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '540',
        name: 'Hồng Lĩnh',
        wards: [
          {
            id: '8680',
            name: ' Trung Lương',
            prefix: 'Phường',
          },
          {
            id: '8681',
            name: 'Bắc Hồng',
            prefix: 'Phường',
          },
          {
            id: '8682',
            name: 'Đậu Liêu',
            prefix: 'Phường',
          },
          {
            id: '8683',
            name: 'Đức Thuận',
            prefix: 'Phường',
          },
          {
            id: '8684',
            name: 'Nam Hồng',
            prefix: 'Phường',
          },
          {
            id: '8685',
            name: 'Thuận Lộc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '541',
        name: 'Hương Khê',
        wards: [
          {
            id: '8686',
            name: ' Phúc Đồng',
            prefix: 'Xã',
          },
          {
            id: '8687',
            name: 'Gia Phố',
            prefix: 'Xã',
          },
          {
            id: '8688',
            name: 'Hà Linh',
            prefix: 'Xã',
          },
          {
            id: '8689',
            name: 'Hoà Hải',
            prefix: 'Xã',
          },
          {
            id: '8690',
            name: 'Hương Bình',
            prefix: 'Xã',
          },
          {
            id: '8691',
            name: 'Hương Đô',
            prefix: 'Xã',
          },
          {
            id: '8692',
            name: 'Hương Giang',
            prefix: 'Xã',
          },
          {
            id: '8693',
            name: 'Hương Khê',
            prefix: 'Thị trấn',
          },
          {
            id: '8694',
            name: 'Hương Lâm',
            prefix: 'Xã',
          },
          {
            id: '8695',
            name: 'Hương Liên',
            prefix: 'Xã',
          },
          {
            id: '8696',
            name: 'Hương Long',
            prefix: 'Xã',
          },
          {
            id: '8697',
            name: 'Hương Thuỷ',
            prefix: 'Xã',
          },
          {
            id: '8698',
            name: 'Hương Trà',
            prefix: 'Xã',
          },
          {
            id: '8699',
            name: 'Hương Trạch',
            prefix: 'Xã',
          },
          {
            id: '8700',
            name: 'Hương Vĩnh',
            prefix: 'Xã',
          },
          {
            id: '8701',
            name: 'Hương Xuân',
            prefix: 'Xã',
          },
          {
            id: '8702',
            name: 'Lộc Yên',
            prefix: 'Xã',
          },
          {
            id: '8703',
            name: 'Phú Gia',
            prefix: 'Xã',
          },
          {
            id: '8704',
            name: 'Phú Phong',
            prefix: 'Xã',
          },
          {
            id: '8705',
            name: 'Phúc Trạch',
            prefix: 'Xã',
          },
          {
            id: '8706',
            name: 'Phương Điền',
            prefix: 'Xã',
          },
          {
            id: '8707',
            name: 'Phương Mỹ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '542',
        name: 'Hương Sơn',
        wards: [
          {
            id: '8708',
            name: ' Sơn Phúc',
            prefix: 'Xã',
          },
          {
            id: '8709',
            name: 'Phố Châu',
            prefix: 'Thị trấn',
          },
          {
            id: '8710',
            name: 'Sơn An',
            prefix: 'Xã',
          },
          {
            id: '8711',
            name: 'Sơn Bằng',
            prefix: 'Xã',
          },
          {
            id: '8712',
            name: 'Sơn Bình',
            prefix: 'Xã',
          },
          {
            id: '8713',
            name: 'Sơn Châu',
            prefix: 'Xã',
          },
          {
            id: '8714',
            name: 'Sơn Diệm',
            prefix: 'Xã',
          },
          {
            id: '8715',
            name: 'Sơn Giang',
            prefix: 'Xã',
          },
          {
            id: '8716',
            name: 'Sơn Hà',
            prefix: 'Xã',
          },
          {
            id: '8717',
            name: 'Sơn Hàm',
            prefix: 'Xã',
          },
          {
            id: '8718',
            name: 'Sơn Hòa',
            prefix: 'Xã',
          },
          {
            id: '8719',
            name: 'Sơn Hồng',
            prefix: 'Xã',
          },
          {
            id: '8720',
            name: 'Sơn Kim 1',
            prefix: 'Xã',
          },
          {
            id: '8721',
            name: 'Sơn Kim 2',
            prefix: 'Xã',
          },
          {
            id: '8722',
            name: 'Sơn Lâm',
            prefix: 'Xã',
          },
          {
            id: '8723',
            name: 'Sơn Lễ',
            prefix: 'Xã',
          },
          {
            id: '8724',
            name: 'Sơn Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '8725',
            name: 'Sơn Long',
            prefix: 'Xã',
          },
          {
            id: '8726',
            name: 'Sơn Mai',
            prefix: 'Xã',
          },
          {
            id: '8727',
            name: 'Sơn Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8728',
            name: 'Sơn Ninh',
            prefix: 'Xã',
          },
          {
            id: '8729',
            name: 'Sơn Phú',
            prefix: 'Xã',
          },
          {
            id: '8730',
            name: 'Sơn Quang',
            prefix: 'Xã',
          },
          {
            id: '8731',
            name: 'Sơn Tân',
            prefix: 'Xã',
          },
          {
            id: '8732',
            name: 'Sơn Tây',
            prefix: 'Xã',
          },
          {
            id: '8733',
            name: 'Sơn Thịnh',
            prefix: 'Xã',
          },
          {
            id: '8734',
            name: 'Sơn Thủy',
            prefix: 'Xã',
          },
          {
            id: '8735',
            name: 'Sơn Tiến',
            prefix: 'Xã',
          },
          {
            id: '8736',
            name: 'Sơn Trà',
            prefix: 'Xã',
          },
          {
            id: '8737',
            name: 'Sơn Trung',
            prefix: 'Xã',
          },
          {
            id: '8738',
            name: 'Sơn Trường',
            prefix: 'Xã',
          },
          {
            id: '8739',
            name: 'Tây Sơn',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '543',
        name: 'Kỳ Anh',
        wards: [
          {
            id: '8740',
            name: ' Kỳ Lợi',
            prefix: 'Xã',
          },
          {
            id: '8741',
            name: ' Kỳ Long',
            prefix: 'Xã',
          },
          {
            id: '8742',
            name: ' Kỳ Phương',
            prefix: 'Xã',
          },
          {
            id: '8743',
            name: ' Kỳ Tiến',
            prefix: 'Xã',
          },
          {
            id: '8744',
            name: 'Kỳ Anh',
            prefix: 'Thị trấn',
          },
          {
            id: '8745',
            name: 'Kỳ Bắc',
            prefix: 'Xã',
          },
          {
            id: '8746',
            name: 'Kỳ Châu',
            prefix: 'Xã',
          },
          {
            id: '8747',
            name: 'Kỳ Đồng',
            prefix: 'Xã',
          },
          {
            id: '8748',
            name: 'Kỳ Giang',
            prefix: 'Xã',
          },
          {
            id: '8749',
            name: 'Kỳ Hà',
            prefix: 'Xã',
          },
          {
            id: '8750',
            name: 'Kỳ Hải',
            prefix: 'Xã',
          },
          {
            id: '8751',
            name: 'Kỳ Hoa',
            prefix: 'Xã',
          },
          {
            id: '8752',
            name: 'Kỳ Hợp',
            prefix: 'Xã',
          },
          {
            id: '8753',
            name: 'Kỳ Hưng',
            prefix: 'Xã',
          },
          {
            id: '8754',
            name: 'Kỳ Khang',
            prefix: 'Xã',
          },
          {
            id: '8755',
            name: 'Kỳ Lạc',
            prefix: 'Xã',
          },
          {
            id: '8756',
            name: 'Kỳ Lâm',
            prefix: 'Xã',
          },
          {
            id: '8757',
            name: 'Kỳ Liên',
            prefix: 'Xã',
          },
          {
            id: '8758',
            name: 'Kỳ Nam',
            prefix: 'Xã',
          },
          {
            id: '8759',
            name: 'Kỳ Ninh',
            prefix: 'Xã',
          },
          {
            id: '8760',
            name: 'Kỳ Phong',
            prefix: 'Xã',
          },
          {
            id: '8761',
            name: 'Kỳ Phú',
            prefix: 'Xã',
          },
          {
            id: '8762',
            name: 'Kỳ Sơn',
            prefix: 'Xã',
          },
          {
            id: '8763',
            name: 'Kỳ Tân',
            prefix: 'Xã',
          },
          {
            id: '8764',
            name: 'Kỳ Tây',
            prefix: 'Xã',
          },
          {
            id: '8765',
            name: 'Kỳ Thịnh',
            prefix: 'Xã',
          },
          {
            id: '8766',
            name: 'Kỳ Thọ',
            prefix: 'Xã',
          },
          {
            id: '8767',
            name: 'Kỳ Thư',
            prefix: 'Xã',
          },
          {
            id: '8768',
            name: 'Kỳ Thượng',
            prefix: 'Xã',
          },
          {
            id: '8769',
            name: 'Kỳ Trinh',
            prefix: 'Xã',
          },
          {
            id: '8770',
            name: 'Kỳ Trung',
            prefix: 'Xã',
          },
          {
            id: '8771',
            name: 'Kỳ Văn',
            prefix: 'Xã',
          },
          {
            id: '8772',
            name: 'Kỳ Xuân',
            prefix: 'Xã',
          },
          {
            id: '8773',
            name: 'Sông Trí',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '544',
        name: 'Lộc Hà',
        wards: [
          {
            id: '8774',
            name: 'An Lộc',
            prefix: 'Xã',
          },
          {
            id: '8775',
            name: 'Bình Lộc',
            prefix: 'Xã',
          },
          {
            id: '8776',
            name: 'Hộ Độ',
            prefix: 'Xã',
          },
          {
            id: '8777',
            name: 'Hồng Lộc',
            prefix: 'Xã',
          },
          {
            id: '8778',
            name: 'Ích Hậu',
            prefix: 'Xã',
          },
          {
            id: '8779',
            name: 'Mai Phụ',
            prefix: 'Xã',
          },
          {
            id: '8780',
            name: 'Phù Lưu',
            prefix: 'Xã',
          },
          {
            id: '8781',
            name: 'Tân Lộc',
            prefix: 'Xã',
          },
          {
            id: '8782',
            name: 'Thạch Bằng',
            prefix: 'Xã',
          },
          {
            id: '8783',
            name: 'Thạch Châu',
            prefix: 'Xã',
          },
          {
            id: '8784',
            name: 'Thạch Kim',
            prefix: 'Xã',
          },
          {
            id: '8785',
            name: 'Thạch Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8786',
            name: 'Thịnh Lộc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '545',
        name: 'Nghi Xuân',
        wards: [
          {
            id: '8787',
            name: ' Xuân Hải',
            prefix: 'Xã',
          },
          {
            id: '8788',
            name: ' Xuân Phổ',
            prefix: 'Xã',
          },
          {
            id: '8789',
            name: 'Cổ Đạm',
            prefix: 'Xã',
          },
          {
            id: '8790',
            name: 'Cương Gián',
            prefix: 'Xã',
          },
          {
            id: '8791',
            name: 'Nghi Trường',
            prefix: 'Xã',
          },
          {
            id: '8792',
            name: 'Nghi Xuân',
            prefix: 'Thị trấn',
          },
          {
            id: '8793',
            name: 'Tiên Điền',
            prefix: 'Xã',
          },
          {
            id: '8794',
            name: 'Xuân An',
            prefix: 'Thị trấn',
          },
          {
            id: '8795',
            name: 'Xuân An',
            prefix: 'Thị trấn',
          },
          {
            id: '8796',
            name: 'Xuân Đan',
            prefix: 'Xã',
          },
          {
            id: '8797',
            name: 'Xuân Giang',
            prefix: 'Xã',
          },
          {
            id: '8798',
            name: 'Xuân Hội',
            prefix: 'Xã',
          },
          {
            id: '8799',
            name: 'Xuân Hồng',
            prefix: 'Xã',
          },
          {
            id: '8800',
            name: 'Xuân Lam',
            prefix: 'Xã',
          },
          {
            id: '8801',
            name: 'Xuân Liên',
            prefix: 'Xã',
          },
          {
            id: '8802',
            name: 'Xuân Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '8803',
            name: 'Xuân Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8804',
            name: 'Xuân Thành',
            prefix: 'Xã',
          },
          {
            id: '8805',
            name: 'Xuân Trường',
            prefix: 'Xã',
          },
          {
            id: '8806',
            name: 'Xuân Viên',
            prefix: 'Xã',
          },
          {
            id: '8807',
            name: 'Xuân Yên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '546',
        name: 'Thạch Hà',
        wards: [
          {
            id: '8808',
            name: 'Bắc Sơn',
            prefix: 'Xã',
          },
          {
            id: '8809',
            name: 'Nam Hương',
            prefix: 'Xã',
          },
          {
            id: '8810',
            name: 'Ngọc Sơn ',
            prefix: 'Xã',
          },
          {
            id: '8811',
            name: 'Phù Việt',
            prefix: 'Xã',
          },
          {
            id: '8812',
            name: 'Thạch Bàn',
            prefix: 'Xã',
          },
          {
            id: '8813',
            name: 'Thạch Đài',
            prefix: 'Xã',
          },
          {
            id: '8814',
            name: 'Thạch Điền',
            prefix: 'Xã',
          },
          {
            id: '8815',
            name: 'Thạch Đỉnh',
            prefix: 'Xã',
          },
          {
            id: '8816',
            name: 'Thạch Hà',
            prefix: 'Thị trấn',
          },
          {
            id: '8817',
            name: 'Thạch Hải',
            prefix: 'Xã',
          },
          {
            id: '8818',
            name: 'Thạch Hội',
            prefix: 'Xã',
          },
          {
            id: '8819',
            name: 'Thạch Hương',
            prefix: 'Xã',
          },
          {
            id: '8820',
            name: 'Thạch Kênh',
            prefix: 'Xã',
          },
          {
            id: '8821',
            name: 'Thạch Khê',
            prefix: 'Xã',
          },
          {
            id: '8822',
            name: 'Thạch Lạc',
            prefix: 'Xã',
          },
          {
            id: '8823',
            name: 'Thạch Lâm',
            prefix: 'Xã',
          },
          {
            id: '8824',
            name: 'Thạch Liên',
            prefix: 'Xã',
          },
          {
            id: '8825',
            name: 'Thạch Long',
            prefix: 'Xã',
          },
          {
            id: '8826',
            name: 'Thạch Lưu',
            prefix: 'Xã',
          },
          {
            id: '8827',
            name: 'Thạch Ngọc',
            prefix: 'Xã',
          },
          {
            id: '8828',
            name: 'Thạch Sơn',
            prefix: 'Xã',
          },
          {
            id: '8829',
            name: 'Thạch Tân',
            prefix: 'Xã',
          },
          {
            id: '8830',
            name: 'Thạch Thắng',
            prefix: 'Xã',
          },
          {
            id: '8831',
            name: 'Thạch Thanh',
            prefix: 'Xã',
          },
          {
            id: '8832',
            name: 'Thạch Tiến',
            prefix: 'Xã',
          },
          {
            id: '8833',
            name: 'Thạch Trị',
            prefix: 'Xã',
          },
          {
            id: '8834',
            name: 'Thạch Văn',
            prefix: 'Xã',
          },
          {
            id: '8835',
            name: 'Thạch Vĩnh',
            prefix: 'Xã',
          },
          {
            id: '8836',
            name: 'Thạch Xuân',
            prefix: 'Xã',
          },
          {
            id: '8837',
            name: 'Tượng Sơn',
            prefix: 'Xã',
          },
          {
            id: '8838',
            name: 'Việt Xuyên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '547',
        name: 'Vũ Quang',
        wards: [
          {
            id: '8839',
            name: 'Ân Phú',
            prefix: 'Xã',
          },
          {
            id: '8840',
            name: 'Đức Bồng',
            prefix: 'Xã',
          },
          {
            id: '8841',
            name: 'Đức Giang',
            prefix: 'Xã',
          },
          {
            id: '8842',
            name: 'Đức Hương',
            prefix: 'Xã',
          },
          {
            id: '8843',
            name: 'Đức Liên',
            prefix: 'Xã',
          },
          {
            id: '8844',
            name: 'Đức Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '8845',
            name: 'Hương Điền',
            prefix: 'Xã',
          },
          {
            id: '8846',
            name: 'Hương Minh',
            prefix: 'Xã',
          },
          {
            id: '8847',
            name: 'Hương Quang',
            prefix: 'Xã',
          },
          {
            id: '8848',
            name: 'Hương Thọ',
            prefix: 'Xã',
          },
          {
            id: '8849',
            name: 'Sơn Thọ',
            prefix: 'Xã',
          },
          {
            id: '8850',
            name: 'Vũ Quang',
            prefix: 'Thị trấn',
          },
        ],
      },
    ],
  },
  {
    id: '47',
    code: 'DDT',
    name: 'Đồng Tháp',
    districts: [
      {
        id: '548',
        name: 'Cao Lãnh',
        wards: [
          {
            id: '8851',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '8852',
            name: '11',
            prefix: 'Phường',
          },
          {
            id: '8853',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '8854',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '8855',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '8856',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '8857',
            name: 'Hoà An',
            prefix: 'Xã',
          },
          {
            id: '8858',
            name: 'Hoà Thuận',
            prefix: 'Phường',
          },
          {
            id: '8859',
            name: 'Mỹ Ngãi',
            prefix: 'Xã',
          },
          {
            id: '8860',
            name: 'Mỹ Phú',
            prefix: 'Phường',
          },
          {
            id: '8861',
            name: 'Mỹ Phú',
            prefix: 'Phường',
          },
          {
            id: '8862',
            name: 'Mỹ Tân',
            prefix: 'Xã',
          },
          {
            id: '8863',
            name: 'Mỹ Trà',
            prefix: 'Xã',
          },
          {
            id: '8864',
            name: 'Tân Thuận Đông',
            prefix: 'Xã',
          },
          {
            id: '8865',
            name: 'Tân Thuận Tây',
            prefix: 'Xã',
          },
          {
            id: '8866',
            name: 'Tịnh Thới',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '549',
        name: 'Châu Thành',
        wards: [
          {
            id: '8867',
            name: 'An Hiệp',
            prefix: 'Xã',
          },
          {
            id: '8868',
            name: 'An Khánh',
            prefix: 'Xã',
          },
          {
            id: '8869',
            name: 'An Nhơn',
            prefix: 'Xã',
          },
          {
            id: '8870',
            name: 'An Phú Thuận',
            prefix: 'Xã',
          },
          {
            id: '8871',
            name: 'Cái Tàu Hạ',
            prefix: 'Thị trấn',
          },
          {
            id: '8872',
            name: 'Hòa Tân',
            prefix: 'Xã',
          },
          {
            id: '8873',
            name: 'Phú Hựu',
            prefix: 'Xã',
          },
          {
            id: '8874',
            name: 'Phú Long',
            prefix: 'Xã',
          },
          {
            id: '8875',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '8876',
            name: 'Tân Nhuận Đông',
            prefix: 'Xã',
          },
          {
            id: '8877',
            name: 'Tân Phú',
            prefix: 'Xã',
          },
          {
            id: '8878',
            name: 'Tân Phú Trung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '550',
        name: 'Hồng Ngự',
        wards: [
          {
            id: '8879',
            name: 'An Bình A',
            prefix: 'Xã',
          },
          {
            id: '8880',
            name: 'An Bình B',
            prefix: 'Xã',
          },
          {
            id: '8881',
            name: 'An Lạc',
            prefix: 'Phường',
          },
          {
            id: '8882',
            name: 'An Lộc',
            prefix: 'Phường',
          },
          {
            id: '8883',
            name: 'An Thạnh',
            prefix: 'Phường',
          },
          {
            id: '8884',
            name: 'Bình Thạnh',
            prefix: 'Xã',
          },
          {
            id: '8885',
            name: 'Tân Hội',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '551',
        name: 'Huyện Cao Lãnh',
        wards: [
          {
            id: '8886',
            name: 'An Bình',
            prefix: 'Xã',
          },
          {
            id: '8887',
            name: 'Ba Sao',
            prefix: 'Xã',
          },
          {
            id: '8888',
            name: 'Bình Hàng Tây',
            prefix: 'Xã',
          },
          {
            id: '8889',
            name: 'Bình Hàng Trung',
            prefix: 'Xã',
          },
          {
            id: '8890',
            name: 'Bình Thạnh',
            prefix: 'Xã',
          },
          {
            id: '8891',
            name: 'Gáo Giồng',
            prefix: 'Xã',
          },
          {
            id: '8892',
            name: 'Mỹ Hiệp',
            prefix: 'Xã',
          },
          {
            id: '8893',
            name: 'Mỹ Hội',
            prefix: 'Xã',
          },
          {
            id: '8894',
            name: 'Mỹ Long',
            prefix: 'Xã',
          },
          {
            id: '8895',
            name: 'Mỹ Thọ',
            prefix: 'Thị trấn',
          },
          {
            id: '8896',
            name: 'Mỹ Xương',
            prefix: 'Xã',
          },
          {
            id: '8897',
            name: 'Nhị Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8898',
            name: 'Phong Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8899',
            name: 'Phương Thịnh',
            prefix: 'Xã',
          },
          {
            id: '8900',
            name: 'Phương Trà',
            prefix: 'Xã',
          },
          {
            id: '8901',
            name: 'Tân Hội Trung',
            prefix: 'Xã',
          },
          {
            id: '8902',
            name: 'Tân Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '8903',
            name: 'Xã Mỹ Thọ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '552',
        name: 'Huyện Hồng Ngự',
        wards: [
          {
            id: '8904',
            name: 'Long Khánh A',
            prefix: 'Xã',
          },
          {
            id: '8905',
            name: 'Long Khánh B',
            prefix: 'Xã',
          },
          {
            id: '8906',
            name: 'Long Thuận',
            prefix: 'Xã',
          },
          {
            id: '8907',
            name: 'Phú Thuận A',
            prefix: 'Xã',
          },
          {
            id: '8908',
            name: 'Phú Thuận B',
            prefix: 'Xã',
          },
          {
            id: '8909',
            name: 'Thường Lạc',
            prefix: 'Xã',
          },
          {
            id: '8910',
            name: 'Thường Phước 1',
            prefix: 'Xã',
          },
          {
            id: '8911',
            name: 'Thường Phước 2',
            prefix: 'Xã',
          },
          {
            id: '8912',
            name: 'Thường Thới Hậu A',
            prefix: 'Xã',
          },
          {
            id: '8913',
            name: 'Thường Thới Hậu B',
            prefix: 'Xã',
          },
          {
            id: '8914',
            name: 'Thường Thới Tiền',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '553',
        name: 'Lai Vung',
        wards: [
          {
            id: '8915',
            name: 'Định Hòa',
            prefix: 'Xã',
          },
          {
            id: '8916',
            name: 'Hòa Long',
            prefix: 'Xã',
          },
          {
            id: '8917',
            name: 'Hòa Thành',
            prefix: 'Xã',
          },
          {
            id: '8918',
            name: 'Lai Vung',
            prefix: 'Thị trấn',
          },
          {
            id: '8919',
            name: 'Long Hậu',
            prefix: 'Xã',
          },
          {
            id: '8920',
            name: 'Long Thắng',
            prefix: 'Xã',
          },
          {
            id: '8921',
            name: 'Phong Hòa',
            prefix: 'Xã',
          },
          {
            id: '8922',
            name: 'Tân Dương',
            prefix: 'Xã',
          },
          {
            id: '8923',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
          {
            id: '8924',
            name: 'Tân Phước',
            prefix: 'Xã',
          },
          {
            id: '8925',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '8926',
            name: 'Vĩnh Thới',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '554',
        name: 'Lấp Vò',
        wards: [
          {
            id: '8927',
            name: 'Bình Thành',
            prefix: 'Xã',
          },
          {
            id: '8928',
            name: 'Bình Thạnh Trung',
            prefix: 'Xã',
          },
          {
            id: '8929',
            name: 'Định An',
            prefix: 'Xã',
          },
          {
            id: '8930',
            name: 'Định Yên',
            prefix: 'Xã',
          },
          {
            id: '8931',
            name: 'Hội An Đông',
            prefix: 'Xã',
          },
          {
            id: '8932',
            name: 'Lấp Vò',
            prefix: 'Thị trấn',
          },
          {
            id: '8933',
            name: 'Long Hưng A',
            prefix: 'Xã',
          },
          {
            id: '8934',
            name: 'Long Hưng B',
            prefix: 'Xã',
          },
          {
            id: '8935',
            name: 'Mỹ An Hưng A',
            prefix: 'Xã',
          },
          {
            id: '8936',
            name: 'Mỹ An Hưng B',
            prefix: 'Xã',
          },
          {
            id: '8937',
            name: 'Tân Khánh Trung',
            prefix: 'Xã',
          },
          {
            id: '8938',
            name: 'Tân Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8939',
            name: 'Vĩnh Thạnh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '555',
        name: 'Sa Đéc',
        wards: [
          {
            id: '8940',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '8941',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '8942',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '8943',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '8944',
            name: 'An Hòa',
            prefix: 'Phường',
          },
          {
            id: '8945',
            name: 'Tân Khánh Đông',
            prefix: 'Xã',
          },
          {
            id: '8946',
            name: 'Tân Phú Đông',
            prefix: 'Xã',
          },
          {
            id: '8947',
            name: 'Tân Quy Đông',
            prefix: 'Phường',
          },
          {
            id: '8948',
            name: 'Tân Quy Tây',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '556',
        name: 'Tam Nông',
        wards: [
          {
            id: '8949',
            name: 'An Hòa',
            prefix: 'Xã',
          },
          {
            id: '8950',
            name: 'An Long',
            prefix: 'Xã',
          },
          {
            id: '8951',
            name: 'Hòa Bình',
            prefix: 'Xã',
          },
          {
            id: '8952',
            name: 'Phú Cường',
            prefix: 'Xã',
          },
          {
            id: '8953',
            name: 'Phú Đức',
            prefix: 'Xã',
          },
          {
            id: '8954',
            name: 'Phú Hiệp',
            prefix: 'Xã',
          },
          {
            id: '8955',
            name: 'Phú Ninh',
            prefix: 'Xã',
          },
          {
            id: '8956',
            name: 'Phú Thành A',
            prefix: 'Xã',
          },
          {
            id: '8957',
            name: 'Phú Thành B',
            prefix: 'Xã',
          },
          {
            id: '8958',
            name: 'Phú Thọ',
            prefix: 'Xã',
          },
          {
            id: '8959',
            name: 'Tân Công Sính',
            prefix: 'Xã',
          },
          {
            id: '8960',
            name: 'Tràm Chim',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '557',
        name: 'Tân Hồng',
        wards: [
          {
            id: '8961',
            name: 'An Phước',
            prefix: 'Xã',
          },
          {
            id: '8962',
            name: 'Bình Phú',
            prefix: 'Xã',
          },
          {
            id: '8963',
            name: 'Sa Rài',
            prefix: 'Thị trấn',
          },
          {
            id: '8964',
            name: 'Tân Công Chí',
            prefix: 'Xã',
          },
          {
            id: '8965',
            name: 'Tân Hộ Cơ',
            prefix: 'Xã',
          },
          {
            id: '8966',
            name: 'Tân Phước',
            prefix: 'Xã',
          },
          {
            id: '8967',
            name: 'Tân Thành A',
            prefix: 'Xã',
          },
          {
            id: '8968',
            name: 'Tân Thành B',
            prefix: 'Xã',
          },
          {
            id: '8969',
            name: 'Thông Bình',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '558',
        name: 'Thanh Bình',
        wards: [
          {
            id: '8970',
            name: 'An Phong',
            prefix: 'Xã',
          },
          {
            id: '8971',
            name: 'Bình Tấn',
            prefix: 'Xã',
          },
          {
            id: '8972',
            name: 'Bình Thành',
            prefix: 'Xã',
          },
          {
            id: '8973',
            name: 'Phú Lợi',
            prefix: 'Xã',
          },
          {
            id: '8974',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '8975',
            name: 'Tân Hoà',
            prefix: 'Xã',
          },
          {
            id: '8976',
            name: 'Tân Huề',
            prefix: 'Xã',
          },
          {
            id: '8977',
            name: 'Tân Long',
            prefix: 'Xã',
          },
          {
            id: '8978',
            name: 'Tân Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8979',
            name: 'Tân Phú',
            prefix: 'Xã',
          },
          {
            id: '8980',
            name: 'Tân Quới',
            prefix: 'Xã',
          },
          {
            id: '8981',
            name: 'Tân Thạnh',
            prefix: 'Xã',
          },
          {
            id: '8982',
            name: 'Thanh Bình',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '559',
        name: 'Tháp Mười',
        wards: [
          {
            id: '8983',
            name: 'Đốc Binh Kiều',
            prefix: 'Xã',
          },
          {
            id: '8984',
            name: 'Hưng Thạnh',
            prefix: 'Xã',
          },
          {
            id: '8985',
            name: 'Láng Biển',
            prefix: 'Xã',
          },
          {
            id: '8986',
            name: 'Mỹ An',
            prefix: 'Thị trấn',
          },
          {
            id: '8987',
            name: 'Mỹ An',
            prefix: 'Xã',
          },
          {
            id: '8988',
            name: 'Mỹ Đông',
            prefix: 'Xã',
          },
          {
            id: '8989',
            name: 'Mỹ Hòa',
            prefix: 'Xã',
          },
          {
            id: '8990',
            name: 'Mỹ Quý',
            prefix: 'Xã',
          },
          {
            id: '8991',
            name: 'Phú Điền',
            prefix: 'Xã',
          },
          {
            id: '8992',
            name: 'Tân Kiều',
            prefix: 'Xã',
          },
          {
            id: '8993',
            name: 'Thạnh Lợi',
            prefix: 'Xã',
          },
          {
            id: '8994',
            name: 'Thanh Mỹ',
            prefix: 'Xã',
          },
          {
            id: '8995',
            name: 'Trường Xuân',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '48',
    code: 'ST',
    name: 'Sóc Trăng',
    districts: [
      {
        id: '560',
        name: 'Châu Thành',
        wards: [
          {
            id: '8996',
            name: 'An Hiệp',
            prefix: 'Xã',
          },
          {
            id: '8997',
            name: 'An Ninh',
            prefix: 'Xã',
          },
          {
            id: '8998',
            name: 'Châu Thành',
            prefix: 'Thị trấn',
          },
          {
            id: '8999',
            name: 'Hồ Đắc Kiện',
            prefix: 'Xã',
          },
          {
            id: '9000',
            name: 'Phú Tâm',
            prefix: 'Xã',
          },
          {
            id: '9001',
            name: 'Phú Tân',
            prefix: 'Xã',
          },
          {
            id: '9002',
            name: 'Thiện Mỹ',
            prefix: 'Xã',
          },
          {
            id: '9003',
            name: 'Thuận Hòa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '561',
        name: 'Cù Lao Dung',
        wards: [
          {
            id: '9004',
            name: 'An Thạnh 1',
            prefix: 'Xã',
          },
          {
            id: '9005',
            name: 'An Thạnh 2',
            prefix: 'Xã',
          },
          {
            id: '9006',
            name: 'An Thạnh 3',
            prefix: 'Xã',
          },
          {
            id: '9007',
            name: 'An Thạnh Đông',
            prefix: 'Xã',
          },
          {
            id: '9008',
            name: 'An Thạnh Nam',
            prefix: 'Xã',
          },
          {
            id: '9009',
            name: 'An Thạnh Tây',
            prefix: 'Xã',
          },
          {
            id: '9010',
            name: 'Cù Lao Dung',
            prefix: 'Thị trấn',
          },
          {
            id: '9011',
            name: 'Đại Ân 1',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '562',
        name: 'Kế Sách',
        wards: [
          {
            id: '9012',
            name: 'An Lạc Tây',
            prefix: 'Xã',
          },
          {
            id: '9013',
            name: 'An Lạc Thôn',
            prefix: 'Xã',
          },
          {
            id: '9014',
            name: 'An Mỹ',
            prefix: 'Xã',
          },
          {
            id: '9015',
            name: 'Ba Trinh',
            prefix: 'Xã',
          },
          {
            id: '9016',
            name: 'Đại Hải',
            prefix: 'Xã',
          },
          {
            id: '9017',
            name: 'Kế An',
            prefix: 'Xã',
          },
          {
            id: '9018',
            name: 'Kế Sách',
            prefix: 'Thị trấn',
          },
          {
            id: '9019',
            name: 'Kế Thành',
            prefix: 'Xã',
          },
          {
            id: '9020',
            name: 'Nhơn Mỹ',
            prefix: 'Xã',
          },
          {
            id: '9021',
            name: 'Phong Nẫm',
            prefix: 'Xã',
          },
          {
            id: '9022',
            name: 'Thới An Hội',
            prefix: 'Xã',
          },
          {
            id: '9023',
            name: 'Trinh Phú',
            prefix: 'Xã',
          },
          {
            id: '9024',
            name: 'Xuân Hòa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '563',
        name: 'Long Phú',
        wards: [
          {
            id: '9025',
            name: 'Châu Khánh',
            prefix: 'Xã',
          },
          {
            id: '9026',
            name: 'Đại Ngãi',
            prefix: 'Thị trấn',
          },
          {
            id: '9027',
            name: 'Hậu Thạnh',
            prefix: 'Xã',
          },
          {
            id: '9028',
            name: 'Long Đức',
            prefix: 'Xã',
          },
          {
            id: '9029',
            name: 'Long Phú',
            prefix: 'Thị trấn',
          },
          {
            id: '9030',
            name: 'Long Phú',
            prefix: 'Xã',
          },
          {
            id: '9031',
            name: 'Phú Hữu',
            prefix: 'Xã',
          },
          {
            id: '9032',
            name: 'Song Phụng',
            prefix: 'Xã',
          },
          {
            id: '9033',
            name: 'Tân Hưng',
            prefix: 'Xã',
          },
          {
            id: '9034',
            name: 'Tân Thạnh',
            prefix: 'Xã',
          },
          {
            id: '9035',
            name: 'Trường Khánh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '564',
        name: 'Mỹ Tú',
        wards: [
          {
            id: '9036',
            name: 'Hưng Phú',
            prefix: 'Xã',
          },
          {
            id: '9037',
            name: 'Huỳnh Hữu Nghĩa',
            prefix: 'Thị trấn',
          },
          {
            id: '9038',
            name: 'Long Hưng',
            prefix: 'Xã',
          },
          {
            id: '9039',
            name: 'Mỹ Hương',
            prefix: 'Xã',
          },
          {
            id: '9040',
            name: 'Mỹ Phước',
            prefix: 'Xã',
          },
          {
            id: '9041',
            name: 'Mỹ Thuận',
            prefix: 'Xã',
          },
          {
            id: '9042',
            name: 'Mỹ Tú',
            prefix: 'Xã',
          },
          {
            id: '9043',
            name: 'Phú Mỹ',
            prefix: 'Xã',
          },
          {
            id: '9044',
            name: 'Thuận Hưng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '565',
        name: 'Mỹ Xuyên',
        wards: [
          {
            id: '9045',
            name: 'Đại Tâm',
            prefix: 'Xã',
          },
          {
            id: '9046',
            name: 'Gia Hòa 1',
            prefix: 'Xã',
          },
          {
            id: '9047',
            name: 'Gia Hòa 2',
            prefix: 'Xã',
          },
          {
            id: '9048',
            name: 'Hòa Tú 1',
            prefix: 'Xã',
          },
          {
            id: '9049',
            name: 'Hòa Tú 2',
            prefix: 'Xã',
          },
          {
            id: '9050',
            name: 'Mỹ Xuyên',
            prefix: 'Thị trấn',
          },
          {
            id: '9051',
            name: 'Ngọc Đông',
            prefix: 'Xã',
          },
          {
            id: '9052',
            name: 'Ngọc Tố',
            prefix: 'Xã',
          },
          {
            id: '9053',
            name: 'Tài Văn',
            prefix: 'Xã',
          },
          {
            id: '9054',
            name: 'Tham Đôn',
            prefix: 'Xã',
          },
          {
            id: '9055',
            name: 'Thạnh Phú',
            prefix: 'Xã',
          },
          {
            id: '9056',
            name: 'Thạnh Quới',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '566',
        name: 'Ngã Năm',
        wards: [
          {
            id: '9057',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '9058',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '9059',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '9060',
            name: 'Long Bình',
            prefix: 'Xã',
          },
          {
            id: '9061',
            name: 'Mỹ Bình',
            prefix: 'Xã',
          },
          {
            id: '9062',
            name: 'Mỹ Quới',
            prefix: 'Xã',
          },
          {
            id: '9063',
            name: 'Tân Long',
            prefix: 'Xã',
          },
          {
            id: '9064',
            name: 'Vĩnh Quới',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '567',
        name: 'Sóc Trăng',
        wards: [
          {
            id: '9065',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '9066',
            name: '10',
            prefix: 'Phường',
          },
          {
            id: '9067',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '9068',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '9069',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '9070',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '9071',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '9072',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '9073',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '9074',
            name: '9',
            prefix: 'Phường',
          },
          {
            id: '9075',
            name: 'Phú Tân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '568',
        name: 'Thạnh Trị',
        wards: [
          {
            id: '9076',
            name: 'Châu Hưng',
            prefix: 'Xã',
          },
          {
            id: '9077',
            name: 'Hưng Lợi',
            prefix: 'Thị trấn',
          },
          {
            id: '9078',
            name: 'Lâm Kiết',
            prefix: 'Xã',
          },
          {
            id: '9079',
            name: 'Lâm Tân',
            prefix: 'Xã',
          },
          {
            id: '9080',
            name: 'Phú Lộc',
            prefix: 'Thị trấn',
          },
          {
            id: '9081',
            name: 'Thạnh Tân',
            prefix: 'Xã',
          },
          {
            id: '9082',
            name: 'Thạnh Trị',
            prefix: 'Xã',
          },
          {
            id: '9083',
            name: 'Tuân Tức',
            prefix: 'Xã',
          },
          {
            id: '9084',
            name: 'Vĩnh Lợi',
            prefix: 'Xã',
          },
          {
            id: '9085',
            name: 'Vĩnh Thành',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '569',
        name: 'Trần Đề',
        wards: [
          {
            id: '9086',
            name: 'Đại Ân',
            prefix: 'Xã',
          },
          {
            id: '9087',
            name: 'Đại Ân 2',
            prefix: 'Xã',
          },
          {
            id: '9088',
            name: 'Lịch Hội Thượng',
            prefix: 'Thị trấn',
          },
          {
            id: '9089',
            name: 'Liêu Tú',
            prefix: 'Xã',
          },
          {
            id: '9090',
            name: 'Tài Văn',
            prefix: 'Xã',
          },
          {
            id: '9091',
            name: 'Thạnh Thới An',
            prefix: 'Xã',
          },
          {
            id: '9092',
            name: 'Thạnh Thới Thuận',
            prefix: 'Xã',
          },
          {
            id: '9093',
            name: 'Trần Đề',
            prefix: 'Thị trấn',
          },
          {
            id: '9094',
            name: 'Trung Bình',
            prefix: 'Xã',
          },
          {
            id: '9095',
            name: 'Viên An',
            prefix: 'Xã',
          },
          {
            id: '9096',
            name: 'Viên Bình',
            prefix: 'Xã',
          },
          {
            id: '9097',
            name: 'Xã Lịch Hội Thượng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '570',
        name: 'Vĩnh Châu',
        wards: [
          {
            id: '9098',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '9099',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '9100',
            name: 'Hòa Đông',
            prefix: 'Xã',
          },
          {
            id: '9101',
            name: 'Khánh Hòa',
            prefix: 'Phường',
          },
          {
            id: '9102',
            name: 'Lạc Hòa',
            prefix: 'Xã',
          },
          {
            id: '9103',
            name: 'Lai Hòa',
            prefix: 'Xã',
          },
          {
            id: '9104',
            name: 'Vĩnh Hải',
            prefix: 'Xã',
          },
          {
            id: '9105',
            name: 'Vĩnh Hiệp',
            prefix: 'Xã',
          },
          {
            id: '9106',
            name: 'Vĩnh Phước',
            prefix: 'Phường',
          },
          {
            id: '9107',
            name: 'Vĩnh Tân',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '49',
    code: 'KT',
    name: 'Kon Tum',
    districts: [
      {
        id: '571',
        name: 'Đăk Glei',
        wards: [
          {
            id: '9108',
            name: ' Đăk Glei',
            prefix: 'Xã',
          },
          {
            id: '9109',
            name: ' Đăk Kroong',
            prefix: 'Xã',
          },
          {
            id: '9110',
            name: ' Đăk Môn',
            prefix: 'Xã',
          },
          {
            id: '9111',
            name: 'Đăk Choong',
            prefix: 'Xã',
          },
          {
            id: '9112',
            name: 'Đăk Long',
            prefix: 'Xã',
          },
          {
            id: '9113',
            name: 'Đăk Man',
            prefix: 'Xã',
          },
          {
            id: '9114',
            name: 'Đăk Nhoong',
            prefix: 'Xã',
          },
          {
            id: '9115',
            name: 'Đăk Pék',
            prefix: 'Xã',
          },
          {
            id: '9116',
            name: 'Đăk Plô',
            prefix: 'Xã',
          },
          {
            id: '9117',
            name: 'Mường Hoong',
            prefix: 'Xã',
          },
          {
            id: '9118',
            name: 'Ngọc Linh',
            prefix: 'Xã',
          },
          {
            id: '9119',
            name: 'Xốp',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '572',
        name: 'Đăk Hà',
        wards: [
          {
            id: '9120',
            name: 'Đắk Hà',
            prefix: 'Thị trấn',
          },
          {
            id: '9121',
            name: 'Đăk Hring',
            prefix: 'Xã',
          },
          {
            id: '9122',
            name: 'Đăk La',
            prefix: 'Xã',
          },
          {
            id: '9123',
            name: 'Đắk Long',
            prefix: 'Xã',
          },
          {
            id: '9124',
            name: 'Đăk Mar',
            prefix: 'Xã',
          },
          {
            id: '9125',
            name: 'Đắk Ngọk',
            prefix: 'Xã',
          },
          {
            id: '9126',
            name: 'Đăk Pxi',
            prefix: 'Xã',
          },
          {
            id: '9127',
            name: 'Đăk Uy',
            prefix: 'Xã',
          },
          {
            id: '9128',
            name: 'Hà Mòn',
            prefix: 'Xã',
          },
          {
            id: '9129',
            name: 'Ngọk Réo',
            prefix: 'Xã',
          },
          {
            id: '9130',
            name: 'Ngọk Wang',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '573',
        name: 'Đăk Tô',
        wards: [
          {
            id: '9131',
            name: ' Đắk Rơ Nga',
            prefix: 'Xã',
          },
          {
            id: '9132',
            name: ' Văn Lem',
            prefix: 'Xã',
          },
          {
            id: '9135',
            name: 'Diên Bình',
            prefix: 'Xã',
          },
          {
            id: '9133',
            name: 'Đắk Tô',
            prefix: 'Thị trấn',
          },
          {
            id: '9134',
            name: 'Đắk Trăm',
            prefix: 'Xã',
          },
          {
            id: '9136',
            name: 'Kon Đào',
            prefix: 'Xã',
          },
          {
            id: '9137',
            name: 'Ngọk Tụ',
            prefix: 'Xã',
          },
          {
            id: '9138',
            name: 'Pô kô',
            prefix: 'Xã',
          },
          {
            id: '9139',
            name: 'Tân Cảnh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '574',
        name: "Ia H'Drai",
        wards: [
          {
            id: '9141',
            name: 'Ia Dom',
            prefix: 'Xã',
          },
          {
            id: '9140',
            name: 'Ia Đal',
            prefix: 'Xã',
          },
          {
            id: '9142',
            name: 'Ia Tơi',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '575',
        name: 'Kon Plông',
        wards: [
          {
            id: '9143',
            name: 'Đắk Long',
            prefix: 'Xã',
          },
          {
            id: '9144',
            name: 'Đăk Nên',
            prefix: 'Xã',
          },
          {
            id: '9145',
            name: 'Đăk Ring',
            prefix: 'Xã',
          },
          {
            id: '9146',
            name: 'Đăk Tăng',
            prefix: 'Xã',
          },
          {
            id: '9147',
            name: 'Hiếu',
            prefix: 'Xã',
          },
          {
            id: '9148',
            name: 'Măng Bút',
            prefix: 'Xã',
          },
          {
            id: '9149',
            name: 'Măng Cành',
            prefix: 'Xã',
          },
          {
            id: '9150',
            name: 'Ngọk Tem',
            prefix: 'Xã',
          },
          {
            id: '9151',
            name: 'Pờ Ê',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '576',
        name: 'Kon Rẫy',
        wards: [
          {
            id: '9152',
            name: 'Đăk Kôi',
            prefix: 'Xã',
          },
          {
            id: '9153',
            name: 'Đăk Pne',
            prefix: 'Xã',
          },
          {
            id: '9154',
            name: 'Đăk Ruồng',
            prefix: 'Xã',
          },
          {
            id: '9155',
            name: 'Đăk Rve',
            prefix: 'Thị trấn',
          },
          {
            id: '9156',
            name: 'Đăk Tơ Lùng',
            prefix: 'Xã',
          },
          {
            id: '9157',
            name: 'Đắk Tờ Re',
            prefix: 'Xã',
          },
          {
            id: '9158',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '577',
        name: 'KonTum',
        wards: [
          {
            id: '9159',
            name: ' Ia Chim',
            prefix: 'Xã',
          },
          {
            id: '9160',
            name: ' Quang Trung',
            prefix: 'Phường',
          },
          {
            id: '9161',
            name: 'Chư Hreng',
            prefix: 'Xã',
          },
          {
            id: '9167',
            name: 'Duy Tân',
            prefix: 'Phường',
          },
          {
            id: '9162',
            name: 'Đăk Blà',
            prefix: 'Xã',
          },
          {
            id: '9163',
            name: 'Đăk Cấm',
            prefix: 'Xã',
          },
          {
            id: '9164',
            name: 'Đăk Năng',
            prefix: 'Xã',
          },
          {
            id: '9165',
            name: 'Đăk Rơ Wa',
            prefix: 'Xã',
          },
          {
            id: '9166',
            name: 'Đoàn Kết',
            prefix: 'Xã',
          },
          {
            id: '9168',
            name: 'Hoà Bình',
            prefix: 'Xã',
          },
          {
            id: '9169',
            name: 'Kroong',
            prefix: 'Xã',
          },
          {
            id: '9170',
            name: 'Lê Lợi',
            prefix: 'Phường',
          },
          {
            id: '9171',
            name: 'Ngô Mây',
            prefix: 'Phường',
          },
          {
            id: '9172',
            name: 'Ngọk Bay',
            prefix: 'Xã',
          },
          {
            id: '9173',
            name: 'Nguyễn Trãi',
            prefix: 'Phường',
          },
          {
            id: '9174',
            name: 'Quyết Thắng',
            prefix: 'Phường',
          },
          {
            id: '9175',
            name: 'Thắng Lợi',
            prefix: 'Phường',
          },
          {
            id: '9176',
            name: 'Thống Nhất',
            prefix: 'Phường',
          },
          {
            id: '9177',
            name: 'Trần Hưng Đạo',
            prefix: 'Phường',
          },
          {
            id: '9178',
            name: 'Trường Chinh',
            prefix: 'Phường',
          },
          {
            id: '9179',
            name: 'Vinh Quang',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '578',
        name: 'Ngọc Hồi',
        wards: [
          {
            id: '9180',
            name: ' Đăk Xú',
            prefix: 'Xã',
          },
          {
            id: '9181',
            name: 'Đăk Ang',
            prefix: 'Xã',
          },
          {
            id: '9182',
            name: 'Đăk Dục',
            prefix: 'Xã',
          },
          {
            id: '9183',
            name: 'Đăk Kan',
            prefix: 'Xã',
          },
          {
            id: '9184',
            name: 'Đăk Nông',
            prefix: 'Xã',
          },
          {
            id: '9185',
            name: 'Plei Kần',
            prefix: 'Thị trấn',
          },
          {
            id: '9186',
            name: 'Pờ Y',
            prefix: 'Xã',
          },
          {
            id: '9187',
            name: 'Sa Loong',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '579',
        name: 'Sa Thầy',
        wards: [
          {
            id: '9188',
            name: ' Sa sơn',
            prefix: 'Xã',
          },
          {
            id: '9189',
            name: 'Hơ moong',
            prefix: 'Xã',
          },
          {
            id: '9190',
            name: 'Mô Rai',
            prefix: 'Xã',
          },
          {
            id: '9191',
            name: 'Rờ kơi',
            prefix: 'Xã',
          },
          {
            id: '9192',
            name: 'Sa Bình',
            prefix: 'Xã',
          },
          {
            id: '9193',
            name: 'Sa Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '9194',
            name: 'Sa nhơn',
            prefix: 'Xã',
          },
          {
            id: '9195',
            name: 'Sa Thầy',
            prefix: 'Thị trấn',
          },
          {
            id: '9196',
            name: 'Ya Ly',
            prefix: 'Xã',
          },
          {
            id: '9197',
            name: 'Ya tăng ',
            prefix: 'Xã',
          },
          {
            id: '9198',
            name: 'Ya Xiêr',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '580',
        name: 'Tu Mơ Rông',
        wards: [
          {
            id: '9199',
            name: 'Đắk Hà',
            prefix: 'Xã',
          },
          {
            id: '9200',
            name: 'Đắk Na',
            prefix: 'Xã',
          },
          {
            id: '9201',
            name: 'Đắk Rơ Ông',
            prefix: 'Xã',
          },
          {
            id: '9202',
            name: 'Đắk Sao',
            prefix: 'Xã',
          },
          {
            id: '9203',
            name: 'Đắk Tờ Kan',
            prefix: 'Xã',
          },
          {
            id: '9204',
            name: 'Măng Ri',
            prefix: 'Xã',
          },
          {
            id: '9205',
            name: 'Ngọk Lây',
            prefix: 'Xã',
          },
          {
            id: '9206',
            name: 'Ngọk Yêu',
            prefix: 'Xã',
          },
          {
            id: '9207',
            name: 'Tê Xăng',
            prefix: 'Xã',
          },
          {
            id: '9208',
            name: 'Tu Mơ Rông',
            prefix: 'Xã',
          },
          {
            id: '9209',
            name: 'Văn Xuôi',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '50',
    code: 'QB',
    name: 'Quảng Bình',
    districts: [
      {
        id: '581',
        name: 'Ba Đồn',
        wards: [
          {
            id: '9210',
            name: 'Quảng Hòa',
            prefix: 'Xã',
          },
          {
            id: '9211',
            name: 'Quảng Thọ',
            prefix: 'Phường',
          },
          {
            id: '9212',
            name: 'Quảng Thuận',
            prefix: 'Xã',
          },
          {
            id: '9213',
            name: 'Quảng Thủy',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '582',
        name: 'Bố Trạch',
        wards: [
          {
            id: '9214',
            name: 'Bắc Trạch',
            prefix: 'Xã',
          },
          {
            id: '9215',
            name: 'Cự Nẫm',
            prefix: 'Xã',
          },
          {
            id: '9216',
            name: 'Đại Trạch',
            prefix: 'Xã',
          },
          {
            id: '9217',
            name: 'Đồng Trạch',
            prefix: 'Xã',
          },
          {
            id: '9218',
            name: 'Đức Trạch',
            prefix: 'Xã',
          },
          {
            id: '9219',
            name: 'Hạ Trạch',
            prefix: 'Xã',
          },
          {
            id: '9220',
            name: 'Hải Trạch',
            prefix: 'Xã',
          },
          {
            id: '9221',
            name: 'Hoà Trạch',
            prefix: 'Xã',
          },
          {
            id: '9222',
            name: 'Hoàn Lão',
            prefix: 'Thị trấn',
          },
          {
            id: '9223',
            name: 'Hoàn Trạch',
            prefix: 'Xã',
          },
          {
            id: '9224',
            name: 'Hưng Trạch',
            prefix: 'Xã',
          },
          {
            id: '9225',
            name: 'Lâm Trạch',
            prefix: 'Xã',
          },
          {
            id: '9226',
            name: 'Liên Trạch',
            prefix: 'Xã',
          },
          {
            id: '9227',
            name: 'Lý Trạch',
            prefix: 'Xã',
          },
          {
            id: '9228',
            name: 'Mỹ Trạch',
            prefix: 'Xã',
          },
          {
            id: '9229',
            name: 'Nam Trạch',
            prefix: 'Xã',
          },
          {
            id: '9230',
            name: 'Nhân Trạch',
            prefix: 'Xã',
          },
          {
            id: '9231',
            name: 'Nông trường Việt Trung',
            prefix: 'Thị trấn',
          },
          {
            id: '9232',
            name: 'Phú Định',
            prefix: 'Xã',
          },
          {
            id: '9233',
            name: 'Phú Trạch',
            prefix: 'Xã',
          },
          {
            id: '9234',
            name: 'Phúc Trạch',
            prefix: 'Xã',
          },
          {
            id: '9235',
            name: 'Sơn Lộc',
            prefix: 'Xã',
          },
          {
            id: '9236',
            name: 'Sơn Trạch',
            prefix: 'Xã',
          },
          {
            id: '9237',
            name: 'Tân Trạch',
            prefix: 'Xã',
          },
          {
            id: '9238',
            name: 'Tây Trạch',
            prefix: 'Xã',
          },
          {
            id: '9239',
            name: 'Thanh Trạch',
            prefix: 'Xã',
          },
          {
            id: '9240',
            name: 'Thượng Trạch',
            prefix: 'Xã',
          },
          {
            id: '9241',
            name: 'Trung Trạch',
            prefix: 'Xã',
          },
          {
            id: '9242',
            name: 'Vạn Trạch',
            prefix: 'Xã',
          },
          {
            id: '9243',
            name: 'Xuân Trạch',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '583',
        name: 'Đồng Hới',
        wards: [
          {
            id: '9244',
            name: 'Bắc Lý',
            prefix: 'Phường',
          },
          {
            id: '9245',
            name: 'Bắc Nghĩa',
            prefix: 'Phường',
          },
          {
            id: '9246',
            name: 'Bảo Ninh',
            prefix: 'Xã',
          },
          {
            id: '9247',
            name: 'Đồng Mỹ',
            prefix: 'Phường',
          },
          {
            id: '9248',
            name: 'Đồng Phú',
            prefix: 'Phường',
          },
          {
            id: '9249',
            name: 'Đồng Sơn',
            prefix: 'Phường',
          },
          {
            id: '9250',
            name: 'Đức Ninh',
            prefix: 'Xã',
          },
          {
            id: '9251',
            name: 'Đức Ninh Đông',
            prefix: 'Phường',
          },
          {
            id: '9252',
            name: 'Hải Đình',
            prefix: 'Phường',
          },
          {
            id: '9253',
            name: 'Hải Thành',
            prefix: 'Phường',
          },
          {
            id: '9254',
            name: 'Lộc Ninh',
            prefix: 'Xã',
          },
          {
            id: '9255',
            name: 'Nam Lý',
            prefix: 'Phường',
          },
          {
            id: '9256',
            name: 'Nghĩa Ninh',
            prefix: 'Xã',
          },
          {
            id: '9257',
            name: 'Phú Hải',
            prefix: 'Phường',
          },
          {
            id: '9258',
            name: 'Quang Phú',
            prefix: 'Xã',
          },
          {
            id: '9259',
            name: 'Thuận Đức',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '584',
        name: 'Lệ Thủy',
        wards: [
          {
            id: '9260',
            name: 'An Thuỷ',
            prefix: 'Xã',
          },
          {
            id: '9261',
            name: 'Cam Thủy',
            prefix: 'Xã',
          },
          {
            id: '9262',
            name: 'Dương Thủy',
            prefix: 'Xã',
          },
          {
            id: '9263',
            name: 'Hoa Thủy',
            prefix: 'Xã',
          },
          {
            id: '9264',
            name: 'Hồng Thủy',
            prefix: 'Xã',
          },
          {
            id: '9265',
            name: 'Hưng Thủy',
            prefix: 'Xã',
          },
          {
            id: '9266',
            name: 'Kiến Giang',
            prefix: 'Thị trấn',
          },
          {
            id: '9267',
            name: 'Kim Thủy',
            prefix: 'Xã',
          },
          {
            id: '9268',
            name: 'Lâm Thủy',
            prefix: 'Xã',
          },
          {
            id: '9269',
            name: 'Liên Thủy',
            prefix: 'Xã',
          },
          {
            id: '9270',
            name: 'Lộc Thủy',
            prefix: 'Xã',
          },
          {
            id: '9271',
            name: 'Mai Thủy',
            prefix: 'Xã',
          },
          {
            id: '9272',
            name: 'Mỹ Thủy',
            prefix: 'Xã',
          },
          {
            id: '9273',
            name: 'Ngân Thủy',
            prefix: 'Xã',
          },
          {
            id: '9274',
            name: 'Ngư Thủy Bắc',
            prefix: 'Xã',
          },
          {
            id: '9275',
            name: 'Ngư Thủy Nam',
            prefix: 'Xã',
          },
          {
            id: '9276',
            name: 'Ngư Thủy Trung',
            prefix: 'Xã',
          },
          {
            id: '9277',
            name: 'Nông Trường Lệ Ninh',
            prefix: 'Thị trấn',
          },
          {
            id: '9278',
            name: 'Phong Thủy',
            prefix: 'Xã',
          },
          {
            id: '9279',
            name: 'Phú Thủy',
            prefix: 'Xã',
          },
          {
            id: '9280',
            name: 'Sen Thủy',
            prefix: 'Xã',
          },
          {
            id: '9281',
            name: 'Sơn Thủy',
            prefix: 'Xã',
          },
          {
            id: '9282',
            name: 'Tân Thủy',
            prefix: 'Xã',
          },
          {
            id: '9283',
            name: 'Thái Thủy',
            prefix: 'Xã',
          },
          {
            id: '9284',
            name: 'Thanh Thủy',
            prefix: 'Xã',
          },
          {
            id: '9285',
            name: 'Trường Thủy',
            prefix: 'Xã',
          },
          {
            id: '9286',
            name: 'Văn Thủy',
            prefix: 'Xã',
          },
          {
            id: '9287',
            name: 'Xuân Thủy',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '585',
        name: 'Minh Hóa',
        wards: [
          {
            id: '9288',
            name: 'Dân Hóa',
            prefix: 'Xã',
          },
          {
            id: '9289',
            name: 'Hóa Hợp',
            prefix: 'Xã',
          },
          {
            id: '9290',
            name: 'Hóa Phúc',
            prefix: 'Xã',
          },
          {
            id: '9291',
            name: 'Hóa Sơn',
            prefix: 'Xã',
          },
          {
            id: '9292',
            name: 'Hóa Thanh',
            prefix: 'Xã',
          },
          {
            id: '9293',
            name: 'Hóa Tiến',
            prefix: 'Xã',
          },
          {
            id: '9294',
            name: 'Hồng Hóa',
            prefix: 'Xã',
          },
          {
            id: '9295',
            name: 'Minh Hóa',
            prefix: 'Xã',
          },
          {
            id: '9296',
            name: 'Quy Đạt',
            prefix: 'Thị trấn',
          },
          {
            id: '9297',
            name: 'Quy Hóa',
            prefix: 'Xã',
          },
          {
            id: '9298',
            name: 'Tân Hóa',
            prefix: 'Xã',
          },
          {
            id: '9299',
            name: 'Thượng Hóa',
            prefix: 'Xã',
          },
          {
            id: '9300',
            name: 'Trọng Hóa',
            prefix: 'Xã',
          },
          {
            id: '9301',
            name: 'Trung Hóa',
            prefix: 'Xã',
          },
          {
            id: '9302',
            name: 'Xuân Hóa',
            prefix: 'Xã',
          },
          {
            id: '9303',
            name: 'Yên Hóa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '586',
        name: 'Quảng Ninh',
        wards: [
          {
            id: '9304',
            name: 'An Ninh',
            prefix: 'Xã',
          },
          {
            id: '9305',
            name: 'Duy Ninh',
            prefix: 'Xã',
          },
          {
            id: '9306',
            name: 'Gia Ninh',
            prefix: 'Xã',
          },
          {
            id: '9307',
            name: 'Hải Ninh',
            prefix: 'Xã',
          },
          {
            id: '9308',
            name: 'Hàm Ninh',
            prefix: 'Xã',
          },
          {
            id: '9309',
            name: 'Hiền Ninh',
            prefix: 'Xã',
          },
          {
            id: '9310',
            name: 'Lương Ninh',
            prefix: 'Xã',
          },
          {
            id: '9311',
            name: 'Quán Hàu',
            prefix: 'Thị trấn',
          },
          {
            id: '9312',
            name: 'Tân Ninh',
            prefix: 'Xã',
          },
          {
            id: '9313',
            name: 'Trường Sơn',
            prefix: 'Xã',
          },
          {
            id: '9314',
            name: 'Trường Xuân',
            prefix: 'Xã',
          },
          {
            id: '9315',
            name: 'Vạn Ninh',
            prefix: 'Xã',
          },
          {
            id: '9316',
            name: 'Vĩnh Ninh',
            prefix: 'Xã',
          },
          {
            id: '9317',
            name: 'Võ Ninh',
            prefix: 'Xã',
          },
          {
            id: '9318',
            name: 'Xuân Ninh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '587',
        name: 'Quảng Trạch',
        wards: [
          {
            id: '9319',
            name: 'Ba Đồn',
            prefix: 'Thị trấn',
          },
          {
            id: '9320',
            name: 'Cảnh Dương',
            prefix: 'Xã',
          },
          {
            id: '9321',
            name: 'Cảnh Hoá',
            prefix: 'Xã',
          },
          {
            id: '9322',
            name: 'Phù Hóa',
            prefix: 'Xã',
          },
          {
            id: '9323',
            name: 'Quảng Châu',
            prefix: 'Xã',
          },
          {
            id: '9324',
            name: 'Quảng Đông',
            prefix: 'Xã',
          },
          {
            id: '9325',
            name: 'Quảng Hải',
            prefix: 'Xã',
          },
          {
            id: '9326',
            name: 'Quảng Hoà',
            prefix: 'Xã',
          },
          {
            id: '9327',
            name: 'Quảng Hợp',
            prefix: 'Xã',
          },
          {
            id: '9328',
            name: 'Quảng Hưng',
            prefix: 'Xã',
          },
          {
            id: '9329',
            name: 'Quảng Kim',
            prefix: 'Xã',
          },
          {
            id: '9330',
            name: 'Quảng Liên',
            prefix: 'Xã',
          },
          {
            id: '9331',
            name: 'Quảng Lộc',
            prefix: 'Xã',
          },
          {
            id: '9332',
            name: 'Quảng Long',
            prefix: 'Xã',
          },
          {
            id: '9333',
            name: 'Quảng Lưu',
            prefix: 'Xã',
          },
          {
            id: '9334',
            name: 'Quảng Minh',
            prefix: 'Xã',
          },
          {
            id: '9335',
            name: 'Quảng Phong',
            prefix: 'Xã',
          },
          {
            id: '9336',
            name: 'Quảng Phú',
            prefix: 'Xã',
          },
          {
            id: '9337',
            name: 'Quảng Phúc',
            prefix: 'Xã',
          },
          {
            id: '9338',
            name: 'Quảng Phương',
            prefix: 'Xã',
          },
          {
            id: '9339',
            name: 'Quảng Sơn',
            prefix: 'Xã',
          },
          {
            id: '9340',
            name: 'Quảng Tân',
            prefix: 'Xã',
          },
          {
            id: '9341',
            name: 'Quảng Thạch',
            prefix: 'Xã',
          },
          {
            id: '9342',
            name: 'Quảng Thanh',
            prefix: 'Xã',
          },
          {
            id: '9343',
            name: 'Quảng Thọ',
            prefix: 'Xã',
          },
          {
            id: '9344',
            name: 'Quảng Thuỷ',
            prefix: 'Xã',
          },
          {
            id: '9345',
            name: 'Quảng Tiên',
            prefix: 'Xã',
          },
          {
            id: '9346',
            name: 'Quảng Tiến',
            prefix: 'Xã',
          },
          {
            id: '9347',
            name: 'Quảng Trung',
            prefix: 'Xã',
          },
          {
            id: '9348',
            name: 'Quảng Trường',
            prefix: 'Xã',
          },
          {
            id: '9349',
            name: 'Quảng Tùng',
            prefix: 'Xã',
          },
          {
            id: '9350',
            name: 'Quảng Văn',
            prefix: 'Xã',
          },
          {
            id: '9351',
            name: 'Quảng Xuân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '588',
        name: 'Tuyên Hóa',
        wards: [
          {
            id: '9352',
            name: 'Cao Quảng',
            prefix: 'Xã',
          },
          {
            id: '9353',
            name: 'Châu Hóa',
            prefix: 'Xã',
          },
          {
            id: '9354',
            name: 'Đồng Hóa',
            prefix: 'Xã',
          },
          {
            id: '9355',
            name: 'Đồng Lê',
            prefix: 'Thị trấn',
          },
          {
            id: '9356',
            name: 'Đức Hóa',
            prefix: 'Xã',
          },
          {
            id: '9357',
            name: 'Hương Hóa',
            prefix: 'Xã',
          },
          {
            id: '9358',
            name: 'Kim Hóa',
            prefix: 'Xã',
          },
          {
            id: '9359',
            name: 'Lâm Hóa',
            prefix: 'Xã',
          },
          {
            id: '9360',
            name: 'Lê Hóa',
            prefix: 'Xã',
          },
          {
            id: '9361',
            name: 'Mai Hóa',
            prefix: 'Xã',
          },
          {
            id: '9362',
            name: 'Nam Hóa',
            prefix: 'Xã',
          },
          {
            id: '9363',
            name: 'Ngư Hóa',
            prefix: 'Xã',
          },
          {
            id: '9364',
            name: 'Phong Hóa',
            prefix: 'Xã',
          },
          {
            id: '9365',
            name: 'Sơn Hóa',
            prefix: 'Xã',
          },
          {
            id: '9366',
            name: 'Thạch Hóa',
            prefix: 'Xã',
          },
          {
            id: '9367',
            name: 'Thanh Hóa',
            prefix: 'Xã',
          },
          {
            id: '9368',
            name: 'Thanh Thạch',
            prefix: 'Xã',
          },
          {
            id: '9369',
            name: 'Thuận Hóa',
            prefix: 'Xã',
          },
          {
            id: '9370',
            name: 'Tiến Hóa',
            prefix: 'Xã',
          },
          {
            id: '9371',
            name: 'Văn Hóa',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '51',
    code: 'QT',
    name: 'Quảng Trị',
    districts: [
      {
        id: '589',
        name: 'Cam Lộ',
        wards: [
          {
            id: '9372',
            name: 'Cam An',
            prefix: 'Xã',
          },
          {
            id: '9373',
            name: 'Cam Chính',
            prefix: 'Xã',
          },
          {
            id: '9374',
            name: 'Cam Hiếu',
            prefix: 'Xã',
          },
          {
            id: '9375',
            name: 'Cam Lộ',
            prefix: 'Thị trấn',
          },
          {
            id: '9376',
            name: 'Cam Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '9377',
            name: 'Cam Thanh',
            prefix: 'Xã',
          },
          {
            id: '9378',
            name: 'Cam Thành',
            prefix: 'Xã',
          },
          {
            id: '9379',
            name: 'Cam Thủy',
            prefix: 'Xã',
          },
          {
            id: '9380',
            name: 'Cam Tuyền',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '590',
        name: 'Đa Krông',
        wards: [
          {
            id: '9381',
            name: 'A Bung',
            prefix: 'Xã',
          },
          {
            id: '9382',
            name: 'A Ngo',
            prefix: 'Xã',
          },
          {
            id: '9383',
            name: 'A Vao',
            prefix: 'Xã',
          },
          {
            id: '9384',
            name: 'Ba Lòng',
            prefix: 'Xã',
          },
          {
            id: '9385',
            name: 'Ba Nang',
            prefix: 'Xã',
          },
          {
            id: '9386',
            name: 'Đa Krông',
            prefix: 'Xã',
          },
          {
            id: '9387',
            name: 'Hải Phúc',
            prefix: 'Xã',
          },
          {
            id: '9388',
            name: 'Húc Nghì',
            prefix: 'Xã',
          },
          {
            id: '9389',
            name: 'Hướng Hiệp',
            prefix: 'Xã',
          },
          {
            id: '9390',
            name: 'Krông Klang',
            prefix: 'Thị trấn',
          },
          {
            id: '9391',
            name: 'Mò Ó',
            prefix: 'Xã',
          },
          {
            id: '9392',
            name: 'Tà Long',
            prefix: 'Xã',
          },
          {
            id: '9393',
            name: 'Tà Rụt',
            prefix: 'Xã',
          },
          {
            id: '9394',
            name: 'Triệu Nguyên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '591',
        name: 'Đảo Cồn cỏ',
        wards: [],
      },
      {
        id: '592',
        name: 'Đông Hà',
        wards: [
          {
            id: '9395',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '9396',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '9397',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '9398',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '9399',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '9400',
            name: 'Đông Giang',
            prefix: 'Phường',
          },
          {
            id: '9401',
            name: 'Đông Lễ',
            prefix: 'Phường',
          },
          {
            id: '9402',
            name: 'Đông Lương',
            prefix: 'Phường',
          },
          {
            id: '9403',
            name: 'Đông Thanh',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '593',
        name: 'Gio Linh',
        wards: [
          {
            id: '9404',
            name: 'Cửa Việt',
            prefix: 'Thị trấn',
          },
          {
            id: '9405',
            name: 'Gio An',
            prefix: 'Xã',
          },
          {
            id: '9406',
            name: 'Gio Bình',
            prefix: 'Xã',
          },
          {
            id: '9407',
            name: 'Gio Châu',
            prefix: 'Xã',
          },
          {
            id: '9408',
            name: 'Gio Hải',
            prefix: 'Xã',
          },
          {
            id: '9409',
            name: 'Gio Hòa',
            prefix: 'Xã',
          },
          {
            id: '9410',
            name: 'Gio Linh',
            prefix: 'Thị trấn',
          },
          {
            id: '9411',
            name: 'Gio Mai',
            prefix: 'Xã',
          },
          {
            id: '9412',
            name: 'Gio Mỹ',
            prefix: 'Xã',
          },
          {
            id: '9413',
            name: 'Gio Phong',
            prefix: 'Xã',
          },
          {
            id: '9414',
            name: 'Gio Quang',
            prefix: 'Xã',
          },
          {
            id: '9415',
            name: 'Gio Sơn',
            prefix: 'Xã',
          },
          {
            id: '9416',
            name: 'Gio Thành',
            prefix: 'Xã',
          },
          {
            id: '9417',
            name: 'Gio Việt',
            prefix: 'Xã',
          },
          {
            id: '9418',
            name: 'Hải Thái',
            prefix: 'Xã',
          },
          {
            id: '9419',
            name: 'Linh Hải',
            prefix: 'Xã',
          },
          {
            id: '9420',
            name: 'Linh Thượng',
            prefix: 'Xã',
          },
          {
            id: '9421',
            name: 'Trung Giang',
            prefix: 'Xã',
          },
          {
            id: '9422',
            name: 'Trung Hải',
            prefix: 'Xã',
          },
          {
            id: '9423',
            name: 'Trung Sơn',
            prefix: 'Xã',
          },
          {
            id: '9424',
            name: 'Vĩnh Trường',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '594',
        name: 'Hải Lăng',
        wards: [
          {
            id: '9425',
            name: 'Hải An',
            prefix: 'Xã',
          },
          {
            id: '9426',
            name: 'Hải Ba',
            prefix: 'Xã',
          },
          {
            id: '9427',
            name: 'Hải Chánh',
            prefix: 'Xã',
          },
          {
            id: '9428',
            name: 'Hải Dương',
            prefix: 'Xã',
          },
          {
            id: '9429',
            name: 'Hải Hòa',
            prefix: 'Xã',
          },
          {
            id: '9430',
            name: 'Hải Khê',
            prefix: 'Xã',
          },
          {
            id: '9431',
            name: 'Hải Lâm',
            prefix: 'Xã',
          },
          {
            id: '9432',
            name: 'Hải Lăng',
            prefix: 'Thị trấn',
          },
          {
            id: '9433',
            name: 'Hải Phú',
            prefix: 'Xã',
          },
          {
            id: '9434',
            name: 'Hải Quế',
            prefix: 'Xã',
          },
          {
            id: '9435',
            name: 'Hải Quy',
            prefix: 'Xã',
          },
          {
            id: '9436',
            name: 'Hải Sơn',
            prefix: 'Xã',
          },
          {
            id: '9437',
            name: 'Hải Tân',
            prefix: 'Xã',
          },
          {
            id: '9438',
            name: 'Hải Thành',
            prefix: 'Xã',
          },
          {
            id: '9439',
            name: 'Hải Thiện',
            prefix: 'Xã',
          },
          {
            id: '9440',
            name: 'Hải Thọ',
            prefix: 'Xã',
          },
          {
            id: '9441',
            name: 'Hải Thượng',
            prefix: 'Xã',
          },
          {
            id: '9442',
            name: 'Hải Trường',
            prefix: 'Xã',
          },
          {
            id: '9443',
            name: 'Hải Vĩnh',
            prefix: 'Xã',
          },
          {
            id: '9444',
            name: 'Hải Xuân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '595',
        name: 'Hướng Hóa',
        wards: [
          {
            id: '9445',
            name: 'A Dơi',
            prefix: 'Xã',
          },
          {
            id: '9446',
            name: 'A Túc',
            prefix: 'Xã',
          },
          {
            id: '9447',
            name: 'A Xing',
            prefix: 'Xã',
          },
          {
            id: '9448',
            name: 'Ba Tầng',
            prefix: 'Xã',
          },
          {
            id: '9449',
            name: 'Húc',
            prefix: 'Xã',
          },
          {
            id: '9450',
            name: 'Hướng Lập',
            prefix: 'Xã',
          },
          {
            id: '9451',
            name: 'Hướng Linh',
            prefix: 'Xã',
          },
          {
            id: '9452',
            name: 'Hướng Lộc',
            prefix: 'Xã',
          },
          {
            id: '9453',
            name: 'Hướng Phùng',
            prefix: 'Xã',
          },
          {
            id: '9454',
            name: 'Hướng Sơn',
            prefix: 'Xã',
          },
          {
            id: '9455',
            name: 'Hướng Tân',
            prefix: 'Xã',
          },
          {
            id: '9456',
            name: 'Hướng Việt',
            prefix: 'Xã',
          },
          {
            id: '9457',
            name: 'Khe Sanh',
            prefix: 'Thị trấn',
          },
          {
            id: '9458',
            name: 'Lao Bảo',
            prefix: 'Thị trấn',
          },
          {
            id: '9459',
            name: 'Tân Hợp',
            prefix: 'Xã',
          },
          {
            id: '9460',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '9461',
            name: 'Tân Liên',
            prefix: 'Xã',
          },
          {
            id: '9462',
            name: 'Tân Long',
            prefix: 'Xã',
          },
          {
            id: '9463',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '9464',
            name: 'Thanh',
            prefix: 'Xã',
          },
          {
            id: '9465',
            name: 'Thuận',
            prefix: 'Xã',
          },
          {
            id: '9466',
            name: 'Xy',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '596',
        name: 'Quảng Trị',
        wards: [
          {
            id: '9467',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '9468',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '9469',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '9470',
            name: 'An Đôn',
            prefix: 'Phường',
          },
          {
            id: '9471',
            name: 'Hải Lệ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '597',
        name: 'Triệu Phong',
        wards: [
          {
            id: '9472',
            name: 'Ái Tử',
            prefix: 'Thị trấn',
          },
          {
            id: '9473',
            name: 'Triệu Ái',
            prefix: 'Xã',
          },
          {
            id: '9474',
            name: 'Triệu An',
            prefix: 'Xã',
          },
          {
            id: '9475',
            name: 'Triệu Đại',
            prefix: 'Xã',
          },
          {
            id: '9476',
            name: 'Triệu Độ',
            prefix: 'Xã',
          },
          {
            id: '9477',
            name: 'Triệu Đông',
            prefix: 'Xã',
          },
          {
            id: '9478',
            name: 'Triệu Giang',
            prefix: 'Xã',
          },
          {
            id: '9479',
            name: 'Triệu Hòa',
            prefix: 'Xã',
          },
          {
            id: '9480',
            name: 'Triệu Lăng',
            prefix: 'Xã',
          },
          {
            id: '9481',
            name: 'Triệu Long',
            prefix: 'Xã',
          },
          {
            id: '9482',
            name: 'Triệu Phước',
            prefix: 'Xã',
          },
          {
            id: '9483',
            name: 'Triệu Sơn',
            prefix: 'Xã',
          },
          {
            id: '9484',
            name: 'Triệu Tài',
            prefix: 'Xã',
          },
          {
            id: '9485',
            name: 'Triệu Thành',
            prefix: 'Xã',
          },
          {
            id: '9486',
            name: 'Triệu Thuận',
            prefix: 'Xã',
          },
          {
            id: '9487',
            name: 'Triệu Thượng',
            prefix: 'Xã',
          },
          {
            id: '9488',
            name: 'Triệu Trạch',
            prefix: 'Xã',
          },
          {
            id: '9489',
            name: 'Triệu Trung',
            prefix: 'Xã',
          },
          {
            id: '9490',
            name: 'Triệu Vân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '598',
        name: 'Vĩnh Linh',
        wards: [
          {
            id: '9491',
            name: 'Bến Quan',
            prefix: 'Thị trấn',
          },
          {
            id: '9492',
            name: 'Cửa Tùng',
            prefix: 'Thị trấn',
          },
          {
            id: '9493',
            name: 'Hồ Xá',
            prefix: 'Thị trấn',
          },
          {
            id: '9494',
            name: 'Vĩnh Chấp',
            prefix: 'Xã',
          },
          {
            id: '9495',
            name: 'Vĩnh Giang',
            prefix: 'Xã',
          },
          {
            id: '9496',
            name: 'Vĩnh Hà',
            prefix: 'Xã',
          },
          {
            id: '9497',
            name: 'Vĩnh Hiền',
            prefix: 'Xã',
          },
          {
            id: '9498',
            name: 'Vĩnh Hòa',
            prefix: 'Xã',
          },
          {
            id: '9499',
            name: 'Vĩnh Khê',
            prefix: 'Xã',
          },
          {
            id: '9500',
            name: 'Vĩnh Kim',
            prefix: 'Xã',
          },
          {
            id: '9501',
            name: 'Vĩnh Lâm',
            prefix: 'Xã',
          },
          {
            id: '9502',
            name: 'Vĩnh Long',
            prefix: 'Xã',
          },
          {
            id: '9503',
            name: 'Vĩnh Nam',
            prefix: 'Xã',
          },
          {
            id: '9504',
            name: 'Vĩnh Ô',
            prefix: 'Xã',
          },
          {
            id: '9505',
            name: 'Vĩnh Sơn',
            prefix: 'Xã',
          },
          {
            id: '9506',
            name: 'Vĩnh Tân',
            prefix: 'Xã',
          },
          {
            id: '9507',
            name: 'Vĩnh Thạch',
            prefix: 'Xã',
          },
          {
            id: '9508',
            name: 'Vĩnh Thái',
            prefix: 'Xã',
          },
          {
            id: '9509',
            name: 'Vĩnh Thành',
            prefix: 'Xã',
          },
          {
            id: '9510',
            name: 'Vĩnh Thủy',
            prefix: 'Xã',
          },
          {
            id: '9511',
            name: 'Vĩnh Trung',
            prefix: 'Xã',
          },
          {
            id: '9512',
            name: 'Vĩnh Tú',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '52',
    code: 'TV',
    name: 'Trà Vinh',
    districts: [
      {
        id: '599',
        name: 'Càng Long',
        wards: [
          {
            id: '9513',
            name: 'An Trường',
            prefix: 'Xã',
          },
          {
            id: '9514',
            name: 'An Trường A',
            prefix: 'Xã',
          },
          {
            id: '9515',
            name: 'Bình Phú',
            prefix: 'Xã',
          },
          {
            id: '9516',
            name: 'Càng Long',
            prefix: 'Thị trấn',
          },
          {
            id: '9517',
            name: 'Đại Phúc',
            prefix: 'Xã',
          },
          {
            id: '9518',
            name: 'Đại Phước',
            prefix: 'Xã',
          },
          {
            id: '9519',
            name: 'Đức Mỹ',
            prefix: 'Xã',
          },
          {
            id: '9520',
            name: 'Huyền Hội',
            prefix: 'Xã',
          },
          {
            id: '9521',
            name: 'Mỹ Cẩm',
            prefix: 'Xã',
          },
          {
            id: '9522',
            name: 'Nhị Long',
            prefix: 'Xã',
          },
          {
            id: '9523',
            name: 'Nhị Long Phú',
            prefix: 'Xã',
          },
          {
            id: '9524',
            name: 'Phương Thạnh',
            prefix: 'Xã',
          },
          {
            id: '9525',
            name: 'Tân An',
            prefix: 'Xã',
          },
          {
            id: '9526',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '600',
        name: 'Cầu Kè',
        wards: [
          {
            id: '9527',
            name: 'An Phú Tân',
            prefix: 'Xã',
          },
          {
            id: '9528',
            name: 'Cầu Kè',
            prefix: 'Thị trấn',
          },
          {
            id: '9529',
            name: 'Châu Điền',
            prefix: 'Xã',
          },
          {
            id: '9530',
            name: 'Hòa Ân',
            prefix: 'Xã',
          },
          {
            id: '9531',
            name: 'Hòa Tân',
            prefix: 'Xã',
          },
          {
            id: '9532',
            name: 'Ninh Thới',
            prefix: 'Xã',
          },
          {
            id: '9533',
            name: 'Phong Phú',
            prefix: 'Xã',
          },
          {
            id: '9534',
            name: 'Phong Thạnh',
            prefix: 'Xã',
          },
          {
            id: '9535',
            name: 'Tam Ngãi',
            prefix: 'Xã',
          },
          {
            id: '9536',
            name: 'Thạnh Phú',
            prefix: 'Xã',
          },
          {
            id: '9537',
            name: 'Thông Hòa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '601',
        name: 'Cầu Ngang',
        wards: [
          {
            id: '9538',
            name: 'Cầu Ngang',
            prefix: 'Thị trấn',
          },
          {
            id: '9539',
            name: 'Hiệp Hòa',
            prefix: 'Xã',
          },
          {
            id: '9540',
            name: 'Hiệp Mỹ Đông',
            prefix: 'Xã',
          },
          {
            id: '9541',
            name: 'Hiệp Mỹ Tây',
            prefix: 'Xã',
          },
          {
            id: '9542',
            name: 'Kim Hòa',
            prefix: 'Xã',
          },
          {
            id: '9543',
            name: 'Long Sơn',
            prefix: 'Xã',
          },
          {
            id: '9544',
            name: 'Mỹ Hòa',
            prefix: 'Xã',
          },
          {
            id: '9545',
            name: 'Mỹ Long',
            prefix: 'Thị trấn',
          },
          {
            id: '9546',
            name: 'Mỹ Long Bắc',
            prefix: 'Xã',
          },
          {
            id: '9547',
            name: 'Mỹ Long Nam',
            prefix: 'Xã',
          },
          {
            id: '9548',
            name: 'Nhị Trường',
            prefix: 'Xã',
          },
          {
            id: '9549',
            name: 'Thạnh Hòa Sơn',
            prefix: 'Xã',
          },
          {
            id: '9550',
            name: 'Thuận Hòa',
            prefix: 'Xã',
          },
          {
            id: '9551',
            name: 'Trường Thọ',
            prefix: 'Xã',
          },
          {
            id: '9552',
            name: 'Vinh Kim',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '602',
        name: 'Châu Thành',
        wards: [
          {
            id: '9553',
            name: 'Châu Thành',
            prefix: 'Thị trấn',
          },
          {
            id: '9554',
            name: 'Đa Lộc',
            prefix: 'Xã',
          },
          {
            id: '9555',
            name: 'Hòa Lợi',
            prefix: 'Xã',
          },
          {
            id: '9556',
            name: 'Hòa Minh',
            prefix: 'Xã',
          },
          {
            id: '9557',
            name: 'Hòa Thuận',
            prefix: 'Xã',
          },
          {
            id: '9558',
            name: 'Hưng Mỹ',
            prefix: 'Xã',
          },
          {
            id: '9559',
            name: 'Long Hòa',
            prefix: 'Xã',
          },
          {
            id: '9560',
            name: 'Lương Hòa',
            prefix: 'Xã',
          },
          {
            id: '9561',
            name: 'Lương Hòa A',
            prefix: 'Xã',
          },
          {
            id: '9562',
            name: 'Mỹ Chánh',
            prefix: 'Xã',
          },
          {
            id: '9563',
            name: 'Nguyệt Hóa',
            prefix: 'Xã',
          },
          {
            id: '9564',
            name: 'Phước Hảo',
            prefix: 'Xã',
          },
          {
            id: '9565',
            name: 'Song Lộc',
            prefix: 'Xã',
          },
          {
            id: '9566',
            name: 'Thanh Mỹ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '603',
        name: 'Duyên Hải',
        wards: [
          {
            id: '9567',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '9568',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '9569',
            name: 'Dân Thành',
            prefix: 'Xã',
          },
          {
            id: '9571',
            name: 'Duyên Hải',
            prefix: 'Thị trấn',
          },
          {
            id: '9570',
            name: 'Đông Hải',
            prefix: 'Xã',
          },
          {
            id: '9572',
            name: 'Hiệp Thạnh',
            prefix: 'Xã',
          },
          {
            id: '9573',
            name: 'Long Hữu',
            prefix: 'Xã',
          },
          {
            id: '9574',
            name: 'Long Khánh',
            prefix: 'Xã',
          },
          {
            id: '9575',
            name: 'Long Thành',
            prefix: 'Thị trấn',
          },
          {
            id: '9576',
            name: 'Long Toàn',
            prefix: 'Xã',
          },
          {
            id: '9577',
            name: 'Long Vĩnh',
            prefix: 'Xã',
          },
          {
            id: '9578',
            name: 'Ngũ Lạc',
            prefix: 'Xã',
          },
          {
            id: '9579',
            name: 'Trường Long Hòa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '604',
        name: 'Tiểu Cần',
        wards: [
          {
            id: '9580',
            name: 'Cầu Quan',
            prefix: 'Thị trấn',
          },
          {
            id: '9581',
            name: 'Hiếu Trung',
            prefix: 'Xã',
          },
          {
            id: '9582',
            name: 'Hiếu Tử',
            prefix: 'Xã',
          },
          {
            id: '9583',
            name: 'Hùng Hoà',
            prefix: 'Xã',
          },
          {
            id: '9584',
            name: 'Long Thới',
            prefix: 'Xã',
          },
          {
            id: '9585',
            name: 'Ngãi Hùng',
            prefix: 'Xã',
          },
          {
            id: '9586',
            name: 'Phú Cần',
            prefix: 'Xã',
          },
          {
            id: '9587',
            name: 'Tân Hoà',
            prefix: 'Xã',
          },
          {
            id: '9588',
            name: 'Tân Hùng',
            prefix: 'Xã',
          },
          {
            id: '9589',
            name: 'Tập Ngãi',
            prefix: 'Xã',
          },
          {
            id: '9590',
            name: 'Tiểu Cần',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '605',
        name: 'Trà Cú',
        wards: [
          {
            id: '9591',
            name: 'An Quảng Hữu',
            prefix: 'Xã',
          },
          {
            id: '9592',
            name: 'Đại An',
            prefix: 'Xã',
          },
          {
            id: '9593',
            name: 'Định An',
            prefix: 'Thị trấn',
          },
          {
            id: '9594',
            name: 'Định An',
            prefix: 'Xã',
          },
          {
            id: '9595',
            name: 'Đôn Châu',
            prefix: 'Xã',
          },
          {
            id: '9596',
            name: 'Đôn Xuân',
            prefix: 'Xã',
          },
          {
            id: '9597',
            name: 'Hàm Giang',
            prefix: 'Xã',
          },
          {
            id: '9598',
            name: 'Hàm Tân',
            prefix: 'Xã',
          },
          {
            id: '9599',
            name: 'Kim Sơn',
            prefix: 'Xã',
          },
          {
            id: '9600',
            name: 'Long Hiệp',
            prefix: 'Xã',
          },
          {
            id: '9601',
            name: 'Lưu Nghiệp Anh',
            prefix: 'Xã',
          },
          {
            id: '9602',
            name: 'Ngãi Xuyên',
            prefix: 'Xã',
          },
          {
            id: '9603',
            name: 'Ngọc Biên',
            prefix: 'Xã',
          },
          {
            id: '9604',
            name: 'Phước Hưng',
            prefix: 'Xã',
          },
          {
            id: '9605',
            name: 'Tân Hiệp',
            prefix: 'Xã',
          },
          {
            id: '9606',
            name: 'Tân Sơn',
            prefix: 'Xã',
          },
          {
            id: '9607',
            name: 'Tập Sơn',
            prefix: 'Xã',
          },
          {
            id: '9608',
            name: 'Thanh Sơn',
            prefix: 'Xã',
          },
          {
            id: '9609',
            name: 'Trà Cú',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '606',
        name: 'Trà Vinh',
        wards: [
          {
            id: '9610',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '9611',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '9612',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '9613',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '9614',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '9615',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '9616',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '9617',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '9618',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '9619',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '9620',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '9621',
            name: '6',
            prefix: 'Phường',
          },
          {
            id: '9622',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '9623',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '9624',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '9625',
            name: '9',
            prefix: 'Phường',
          },
          {
            id: '9626',
            name: 'Long Đức',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '53',
    code: 'HGI',
    name: 'Hậu Giang',
    districts: [
      {
        id: '607',
        name: 'Châu Thành',
        wards: [
          {
            id: '9627',
            name: 'Đông Phú',
            prefix: 'Xã',
          },
          {
            id: '9628',
            name: 'Đông Phước',
            prefix: 'Xã',
          },
          {
            id: '9629',
            name: 'Đông Phước A',
            prefix: 'Xã',
          },
          {
            id: '9630',
            name: 'Đông Thạnh',
            prefix: 'Xã',
          },
          {
            id: '9631',
            name: 'Mái Dầm',
            prefix: 'Xã',
          },
          {
            id: '9632',
            name: 'Ngã Sáu',
            prefix: 'Thị trấn',
          },
          {
            id: '9633',
            name: 'Phú An',
            prefix: 'Xã',
          },
          {
            id: '9634',
            name: 'Phú Hữu',
            prefix: 'Xã',
          },
          {
            id: '9635',
            name: 'Phú Tân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '608',
        name: 'Châu Thành A',
        wards: [
          {
            id: '9636',
            name: 'Bảy Ngàn',
            prefix: 'Thị trấn',
          },
          {
            id: '9637',
            name: 'Cái Tắc',
            prefix: 'Thị trấn',
          },
          {
            id: '9638',
            name: 'Một Ngàn',
            prefix: 'Thị trấn',
          },
          {
            id: '9639',
            name: 'Nhơn Nghĩa A',
            prefix: 'Xã',
          },
          {
            id: '9640',
            name: 'Rạch Gòi',
            prefix: 'Thị trấn',
          },
          {
            id: '9641',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
          {
            id: '9642',
            name: 'Tân Phú Thạnh',
            prefix: 'Xã',
          },
          {
            id: '9643',
            name: 'Thạnh Xuân',
            prefix: 'Xã',
          },
          {
            id: '9644',
            name: 'Trường Long A',
            prefix: 'Xã',
          },
          {
            id: '9645',
            name: 'Trường Long Tây',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '609',
        name: 'Long Mỹ',
        wards: [
          {
            id: '9646',
            name: 'Long Bình',
            prefix: 'Xã',
          },
          {
            id: '9647',
            name: 'Long Mỹ',
            prefix: 'Thị trấn',
          },
          {
            id: '9648',
            name: 'Long Phú',
            prefix: 'Xã',
          },
          {
            id: '9649',
            name: 'Long Trị',
            prefix: 'Xã',
          },
          {
            id: '9650',
            name: 'Long Trị A',
            prefix: 'Xã',
          },
          {
            id: '9651',
            name: 'Lương Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '9652',
            name: 'Lương Tâm',
            prefix: 'Xã',
          },
          {
            id: '9653',
            name: 'Tân Phú',
            prefix: 'Xã',
          },
          {
            id: '9654',
            name: 'Thuận Hòa',
            prefix: 'Xã',
          },
          {
            id: '9655',
            name: 'Thuận Hưng',
            prefix: 'Xã',
          },
          {
            id: '9656',
            name: 'Trà Lồng',
            prefix: 'Thị trấn',
          },
          {
            id: '9657',
            name: 'Vĩnh Thuận Đông',
            prefix: 'Xã',
          },
          {
            id: '9658',
            name: 'Vĩnh Viễn',
            prefix: 'Xã',
          },
          {
            id: '9659',
            name: 'Vĩnh Viễn A',
            prefix: 'Xã',
          },
          {
            id: '9660',
            name: 'Xà Phiên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '610',
        name: 'Ngã Bảy',
        wards: [
          {
            id: '9661',
            name: 'Đại Thành',
            prefix: 'Xã',
          },
          {
            id: '9662',
            name: 'Hiệp Lợi',
            prefix: 'Xã',
          },
          {
            id: '9663',
            name: 'Hiệp Thành',
            prefix: 'Xã',
          },
          {
            id: '9664',
            name: 'Lái Hiếu',
            prefix: 'Phường',
          },
          {
            id: '9665',
            name: 'Ngã Bảy',
            prefix: 'Phường',
          },
          {
            id: '9666',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '611',
        name: 'Phụng Hiệp',
        wards: [
          {
            id: '9667',
            name: 'Bình Thành',
            prefix: 'Xã',
          },
          {
            id: '9668',
            name: 'Búng Tàu',
            prefix: 'Thị trấn',
          },
          {
            id: '9669',
            name: 'Cây Dương',
            prefix: 'Thị trấn',
          },
          {
            id: '9670',
            name: 'Hiệp Hưng',
            prefix: 'Xã',
          },
          {
            id: '9671',
            name: 'Hòa An',
            prefix: 'Xã',
          },
          {
            id: '9672',
            name: 'Hòa Mỹ',
            prefix: 'Xã',
          },
          {
            id: '9673',
            name: 'Kinh Cùng',
            prefix: 'Xã',
          },
          {
            id: '9674',
            name: 'Long Thạnh',
            prefix: 'Xã',
          },
          {
            id: '9675',
            name: 'Phụng Hiệp',
            prefix: 'Xã',
          },
          {
            id: '9676',
            name: 'Phương Bình',
            prefix: 'Xã',
          },
          {
            id: '9677',
            name: 'Phương Phú',
            prefix: 'Xã',
          },
          {
            id: '9678',
            name: 'Tân Bình',
            prefix: 'Xã',
          },
          {
            id: '9679',
            name: 'Tân Long',
            prefix: 'Xã',
          },
          {
            id: '9680',
            name: 'Tân Phước Hưng',
            prefix: 'Xã',
          },
          {
            id: '9681',
            name: 'Thạnh Hòa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '612',
        name: 'Vị Thanh',
        wards: [
          {
            id: '9682',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '9683',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '9684',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '9685',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '9686',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '9687',
            name: 'Hoả Lựu',
            prefix: 'Xã',
          },
          {
            id: '9688',
            name: 'Hoả Tiến',
            prefix: 'Xã',
          },
          {
            id: '9689',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '9690',
            name: 'Vị Tân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '613',
        name: 'Vị Thủy',
        wards: [
          {
            id: '9691',
            name: 'Nàng Mau',
            prefix: 'Thị trấn',
          },
          {
            id: '9692',
            name: 'Vị Bình',
            prefix: 'Xã',
          },
          {
            id: '9693',
            name: 'Vị Đông',
            prefix: 'Xã',
          },
          {
            id: '9694',
            name: 'Vị Thắng',
            prefix: 'Xã',
          },
          {
            id: '9695',
            name: 'Vị Thanh',
            prefix: 'Xã',
          },
          {
            id: '9696',
            name: 'Vị Thủy',
            prefix: 'Xã',
          },
          {
            id: '9697',
            name: 'Vị Trung',
            prefix: 'Xã',
          },
          {
            id: '9698',
            name: 'Vĩnh Thuận Tây',
            prefix: 'Xã',
          },
          {
            id: '9699',
            name: 'Vĩnh Trung',
            prefix: 'Xã',
          },
          {
            id: '9700',
            name: 'Vĩnh Tường',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '54',
    code: 'SL',
    name: 'Sơn La',
    districts: [
      {
        id: '614',
        name: 'Bắc Yên',
        wards: [
          {
            id: '9701',
            name: 'Bắc Yên',
            prefix: 'Thị trấn',
          },
          {
            id: '9702',
            name: 'Chiềng Sại',
            prefix: 'Xã',
          },
          {
            id: '9703',
            name: 'Chim Vàn',
            prefix: 'Xã',
          },
          {
            id: '9704',
            name: 'Hang Chú',
            prefix: 'Xã',
          },
          {
            id: '9705',
            name: 'Háng Đồng',
            prefix: 'Xã',
          },
          {
            id: '9706',
            name: 'Hồng Ngài',
            prefix: 'Xã',
          },
          {
            id: '9707',
            name: 'Hua Nhàn',
            prefix: 'Xã',
          },
          {
            id: '9708',
            name: 'Làng Chếu',
            prefix: 'Xã',
          },
          {
            id: '9709',
            name: 'Mường Khoa',
            prefix: 'Xã',
          },
          {
            id: '9710',
            name: 'Pắc Ngà',
            prefix: 'Xã',
          },
          {
            id: '9711',
            name: 'Phiêng Ban',
            prefix: 'Xã',
          },
          {
            id: '9712',
            name: 'Phiêng Côn',
            prefix: 'Xã',
          },
          {
            id: '9713',
            name: 'Song Pe',
            prefix: 'Xã',
          },
          {
            id: '9714',
            name: 'Tạ Khoa',
            prefix: 'Xã',
          },
          {
            id: '9715',
            name: 'Tà Xùa',
            prefix: 'Xã',
          },
          {
            id: '9716',
            name: 'Xím Vàng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '615',
        name: 'Mai Sơn',
        wards: [
          {
            id: '9717',
            name: 'Chiềng Ban',
            prefix: 'Xã',
          },
          {
            id: '9718',
            name: 'Chiềng Chăn',
            prefix: 'Xã',
          },
          {
            id: '9719',
            name: 'Chiềng Chung',
            prefix: 'Xã',
          },
          {
            id: '9720',
            name: 'Chiềng Dong',
            prefix: 'Xã',
          },
          {
            id: '9721',
            name: 'Chiềng Kheo',
            prefix: 'Xã',
          },
          {
            id: '9722',
            name: 'Chiềng Lương',
            prefix: 'Xã',
          },
          {
            id: '9723',
            name: 'Chiềng Mai',
            prefix: 'Xã',
          },
          {
            id: '9724',
            name: 'Chiềng Mung',
            prefix: 'Xã',
          },
          {
            id: '9725',
            name: 'Chiềng Nơi',
            prefix: 'Xã',
          },
          {
            id: '9726',
            name: 'Chiềng Sung',
            prefix: 'Xã',
          },
          {
            id: '9727',
            name: 'Chiềng Ve',
            prefix: 'Xã',
          },
          {
            id: '9728',
            name: 'Cò Nòi',
            prefix: 'Xã',
          },
          {
            id: '9729',
            name: 'Hát Lót',
            prefix: 'Thị trấn',
          },
          {
            id: '9730',
            name: 'Mường Bằng',
            prefix: 'Xã',
          },
          {
            id: '9731',
            name: 'Mường Bon',
            prefix: 'Xã',
          },
          {
            id: '9732',
            name: 'Mường Tranh',
            prefix: 'Xã',
          },
          {
            id: '9733',
            name: 'Nà Bó',
            prefix: 'Xã',
          },
          {
            id: '9734',
            name: 'Nà Ớt',
            prefix: 'Xã',
          },
          {
            id: '9735',
            name: 'Phiêng Cằm',
            prefix: 'Xã',
          },
          {
            id: '9736',
            name: 'Phiêng Pằn',
            prefix: 'Xã',
          },
          {
            id: '9737',
            name: 'Tà Hộc',
            prefix: 'Xã',
          },
          {
            id: '9738',
            name: 'Xã Hát Lót',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '616',
        name: 'Mộc Châu',
        wards: [
          {
            id: '9739',
            name: 'Chiềng Hắc',
            prefix: 'Xã',
          },
          {
            id: '9740',
            name: 'Chiềng Khừa',
            prefix: 'Xã',
          },
          {
            id: '9741',
            name: 'Chiềng Sơn',
            prefix: 'Xã',
          },
          {
            id: '9742',
            name: 'Đông Sang',
            prefix: 'Xã',
          },
          {
            id: '9743',
            name: 'Hua Păng',
            prefix: 'Xã',
          },
          {
            id: '9744',
            name: 'Lóng Sập',
            prefix: 'Xã',
          },
          {
            id: '9745',
            name: 'Mộc Châu',
            prefix: 'Thị trấn',
          },
          {
            id: '9746',
            name: 'Mường Sang',
            prefix: 'Xã',
          },
          {
            id: '9747',
            name: 'Nà Mường',
            prefix: 'Xã',
          },
          {
            id: '9748',
            name: 'Nông trường Mộc Châu',
            prefix: 'Thị trấn',
          },
          {
            id: '9749',
            name: 'Phiêng Luông',
            prefix: 'Xã',
          },
          {
            id: '9750',
            name: 'Quy Hướng',
            prefix: 'Xã',
          },
          {
            id: '9751',
            name: 'Tà Lại',
            prefix: 'Xã',
          },
          {
            id: '9752',
            name: 'Tân Hợp',
            prefix: 'Xã',
          },
          {
            id: '9753',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '617',
        name: 'Mường La',
        wards: [
          {
            id: '9754',
            name: 'Chiềng Ân',
            prefix: 'Xã',
          },
          {
            id: '9755',
            name: 'Chiềng Công',
            prefix: 'Xã',
          },
          {
            id: '9756',
            name: 'Chiềng Hoa',
            prefix: 'Xã',
          },
          {
            id: '9757',
            name: 'Chiềng Lao',
            prefix: 'Xã',
          },
          {
            id: '9758',
            name: 'Chiềng Muôn',
            prefix: 'Xã',
          },
          {
            id: '9759',
            name: 'Chiềng San',
            prefix: 'Xã',
          },
          {
            id: '9760',
            name: 'Hua Trai',
            prefix: 'Xã',
          },
          {
            id: '9761',
            name: 'Ít Ong',
            prefix: 'Thị trấn',
          },
          {
            id: '9762',
            name: 'Mường Bú',
            prefix: 'Xã',
          },
          {
            id: '9763',
            name: 'Mường Chùm',
            prefix: 'Xã',
          },
          {
            id: '9764',
            name: 'Mường Trai',
            prefix: 'Xã',
          },
          {
            id: '9765',
            name: 'Nậm Giôn',
            prefix: 'Xã',
          },
          {
            id: '9766',
            name: 'Nậm Păm',
            prefix: 'Xã',
          },
          {
            id: '9767',
            name: 'Ngọc Chiến',
            prefix: 'Xã',
          },
          {
            id: '9768',
            name: 'Pi Toong',
            prefix: 'Xã',
          },
          {
            id: '9769',
            name: 'Tạ Bú',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '618',
        name: 'Phù Yên',
        wards: [
          {
            id: '9770',
            name: 'Bắc Phong',
            prefix: 'Xã',
          },
          {
            id: '9771',
            name: 'Đá Đỏ',
            prefix: 'Xã',
          },
          {
            id: '9772',
            name: 'Gia Phù',
            prefix: 'Xã',
          },
          {
            id: '9773',
            name: 'Huy Bắc',
            prefix: 'Xã',
          },
          {
            id: '9774',
            name: 'Huy Hạ',
            prefix: 'Xã',
          },
          {
            id: '9775',
            name: 'Huy Tân',
            prefix: 'Xã',
          },
          {
            id: '9776',
            name: 'Huy Thượng',
            prefix: 'Xã',
          },
          {
            id: '9777',
            name: 'Huy Tường',
            prefix: 'Xã',
          },
          {
            id: '9778',
            name: 'Kim Bon',
            prefix: 'Xã',
          },
          {
            id: '9779',
            name: 'Mường Bang',
            prefix: 'Xã',
          },
          {
            id: '9780',
            name: 'Mường Cơi',
            prefix: 'Xã',
          },
          {
            id: '9781',
            name: 'Mường Do',
            prefix: 'Xã',
          },
          {
            id: '9782',
            name: 'Mường Lang',
            prefix: 'Xã',
          },
          {
            id: '9783',
            name: 'Mường Thải',
            prefix: 'Xã',
          },
          {
            id: '9784',
            name: 'Nam Phong',
            prefix: 'Xã',
          },
          {
            id: '9785',
            name: 'Phù Yên',
            prefix: 'Thị trấn',
          },
          {
            id: '9786',
            name: 'Quang Huy',
            prefix: 'Xã',
          },
          {
            id: '9787',
            name: 'Sập Sa',
            prefix: 'Xã',
          },
          {
            id: '9788',
            name: 'Suối Bau',
            prefix: 'Xã',
          },
          {
            id: '9789',
            name: 'Suối Tọ',
            prefix: 'Xã',
          },
          {
            id: '9790',
            name: 'Tân Lang',
            prefix: 'Xã',
          },
          {
            id: '9791',
            name: 'Tân Phong',
            prefix: 'Xã',
          },
          {
            id: '9792',
            name: 'Tường Hạ',
            prefix: 'Xã',
          },
          {
            id: '9793',
            name: 'Tường Phong',
            prefix: 'Xã',
          },
          {
            id: '9794',
            name: 'Tường Phù',
            prefix: 'Xã',
          },
          {
            id: '9795',
            name: 'Tường Thượng',
            prefix: 'Xã',
          },
          {
            id: '9796',
            name: 'Tường Tiến',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '619',
        name: 'Quỳnh Nhai',
        wards: [
          {
            id: '9797',
            name: 'Cà Nàng',
            prefix: 'Xã',
          },
          {
            id: '9798',
            name: 'Chiềng Bằng',
            prefix: 'Xã',
          },
          {
            id: '9799',
            name: 'Chiềng Khay',
            prefix: 'Xã',
          },
          {
            id: '9800',
            name: 'Chiềng Khoang',
            prefix: 'Xã',
          },
          {
            id: '9801',
            name: 'Chiềng Ơn',
            prefix: 'Xã',
          },
          {
            id: '9802',
            name: 'Mường Chiên',
            prefix: 'Xã',
          },
          {
            id: '9803',
            name: 'Mường Giàng',
            prefix: 'Xã',
          },
          {
            id: '9804',
            name: 'Mường Giôn',
            prefix: 'Xã',
          },
          {
            id: '9805',
            name: 'Mường Sại',
            prefix: 'Xã',
          },
          {
            id: '9806',
            name: 'Nậm Ét',
            prefix: 'Xã',
          },
          {
            id: '9807',
            name: 'Pá Ma Pha Khinh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '620',
        name: 'Sơn La',
        wards: [
          {
            id: '9808',
            name: 'Chiềng An',
            prefix: 'Phường',
          },
          {
            id: '9809',
            name: 'Chiềng Cọ',
            prefix: 'Xã',
          },
          {
            id: '9810',
            name: 'Chiềng Cơi',
            prefix: 'Phường',
          },
          {
            id: '9811',
            name: 'Chiềng Đen',
            prefix: 'Xã',
          },
          {
            id: '9812',
            name: 'Chiềng Lề',
            prefix: 'Phường',
          },
          {
            id: '9813',
            name: 'Chiềng Ngần',
            prefix: 'Xã',
          },
          {
            id: '9814',
            name: 'Chiềng Sinh',
            prefix: 'Phường',
          },
          {
            id: '9815',
            name: 'Chiềng Xôm',
            prefix: 'Xã',
          },
          {
            id: '9816',
            name: 'Hua La',
            prefix: 'Xã',
          },
          {
            id: '9817',
            name: 'Quyết Tâm',
            prefix: 'Phường',
          },
          {
            id: '9818',
            name: 'Quyết Thắng',
            prefix: 'Phường',
          },
          {
            id: '9819',
            name: 'Tô Hiệu',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '621',
        name: 'Sông Mã',
        wards: [
          {
            id: '9820',
            name: 'Bó Sinh',
            prefix: 'Xã',
          },
          {
            id: '9821',
            name: 'Chiềng Cang',
            prefix: 'Xã',
          },
          {
            id: '9822',
            name: 'Chiềng En',
            prefix: 'Xã',
          },
          {
            id: '9823',
            name: 'Chiềng Khoong',
            prefix: 'Xã',
          },
          {
            id: '9824',
            name: 'Chiềng Khương',
            prefix: 'Xã',
          },
          {
            id: '9825',
            name: 'Chiềng Phung',
            prefix: 'Xã',
          },
          {
            id: '9826',
            name: 'Chiềng Sơ',
            prefix: 'Xã',
          },
          {
            id: '9827',
            name: 'Đứa Mòn',
            prefix: 'Xã',
          },
          {
            id: '9828',
            name: 'Huổi Một',
            prefix: 'Xã',
          },
          {
            id: '9829',
            name: 'Mường Cai',
            prefix: 'Xã',
          },
          {
            id: '9830',
            name: 'Mường Hung',
            prefix: 'Xã',
          },
          {
            id: '9831',
            name: 'Mường Lầm',
            prefix: 'Xã',
          },
          {
            id: '9832',
            name: 'Mường Sai',
            prefix: 'Xã',
          },
          {
            id: '9833',
            name: 'Nà Nghịu',
            prefix: 'Xã',
          },
          {
            id: '9834',
            name: 'Nậm Mằn',
            prefix: 'Xã',
          },
          {
            id: '9835',
            name: 'Nậm Ty',
            prefix: 'Xã',
          },
          {
            id: '9836',
            name: 'Pú Pẩu',
            prefix: 'Xã',
          },
          {
            id: '9837',
            name: 'Sông Mã',
            prefix: 'Thị trấn',
          },
          {
            id: '9838',
            name: 'Yên Hưng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '622',
        name: 'Sốp Cộp',
        wards: [
          {
            id: '9839',
            name: 'Dồm Cang',
            prefix: 'Xã',
          },
          {
            id: '9840',
            name: 'Mường Lạn',
            prefix: 'Xã',
          },
          {
            id: '9841',
            name: 'Mường Lèo',
            prefix: 'Xã',
          },
          {
            id: '9842',
            name: 'Mường Và',
            prefix: 'Xã',
          },
          {
            id: '9843',
            name: 'Nậm Lạnh',
            prefix: 'Xã',
          },
          {
            id: '9844',
            name: 'Púng Bánh',
            prefix: 'Xã',
          },
          {
            id: '9845',
            name: 'Sam Kha',
            prefix: 'Xã',
          },
          {
            id: '9846',
            name: 'Sốp Cộp',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '623',
        name: 'Thuận Châu',
        wards: [
          {
            id: '9847',
            name: 'Bản Lầm',
            prefix: 'Xã',
          },
          {
            id: '9848',
            name: 'Bó Mười',
            prefix: 'Xã',
          },
          {
            id: '9849',
            name: 'Bon Phặng',
            prefix: 'Xã',
          },
          {
            id: '9850',
            name: 'Chiềng Bôm',
            prefix: 'Xã',
          },
          {
            id: '9851',
            name: 'Chiềng La',
            prefix: 'Xã',
          },
          {
            id: '9852',
            name: 'Chiềng Ly',
            prefix: 'Xã',
          },
          {
            id: '9853',
            name: 'Chiềng Ngàm',
            prefix: 'Xã',
          },
          {
            id: '9854',
            name: 'Chiềng Pấc',
            prefix: 'Xã',
          },
          {
            id: '9855',
            name: 'Chiềng Pha',
            prefix: 'Xã',
          },
          {
            id: '9856',
            name: 'Co Mạ',
            prefix: 'Xã',
          },
          {
            id: '9857',
            name: 'Co Tòng',
            prefix: 'Xã',
          },
          {
            id: '9858',
            name: 'É Tòng',
            prefix: 'Xã',
          },
          {
            id: '9859',
            name: 'Liệp Tè',
            prefix: 'Xã',
          },
          {
            id: '9860',
            name: 'Long Hẹ',
            prefix: 'Xã',
          },
          {
            id: '9861',
            name: 'Muổi Nọi',
            prefix: 'Xã',
          },
          {
            id: '9862',
            name: 'Mường Bám',
            prefix: 'Xã',
          },
          {
            id: '9863',
            name: 'Mường É',
            prefix: 'Xã',
          },
          {
            id: '9864',
            name: 'Mường Khiêng',
            prefix: 'Xã',
          },
          {
            id: '9865',
            name: 'Nậm Lầu',
            prefix: 'Xã',
          },
          {
            id: '9866',
            name: 'Nong Lay',
            prefix: 'Xã',
          },
          {
            id: '9867',
            name: 'Pá Lông',
            prefix: 'Xã',
          },
          {
            id: '9868',
            name: 'Phổng Lái',
            prefix: 'Xã',
          },
          {
            id: '9869',
            name: 'Phổng Lặng',
            prefix: 'Xã',
          },
          {
            id: '9870',
            name: 'Phỏng Lập',
            prefix: 'Xã',
          },
          {
            id: '9871',
            name: 'Púng Tra',
            prefix: 'Xã',
          },
          {
            id: '9872',
            name: 'Thôm Mòn',
            prefix: 'Xã',
          },
          {
            id: '9873',
            name: 'Thuận Châu',
            prefix: 'Thị trấn',
          },
          {
            id: '9874',
            name: 'Tông Cọ',
            prefix: 'Xã',
          },
          {
            id: '9875',
            name: 'Tông Lệnh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '624',
        name: 'Vân Hồ',
        wards: [
          {
            id: '9876',
            name: 'Chiềng Khoa',
            prefix: 'Xã',
          },
          {
            id: '9877',
            name: 'Chiềng Xuân',
            prefix: 'Xã',
          },
          {
            id: '9878',
            name: 'Chiềng Yên',
            prefix: 'Xã',
          },
          {
            id: '9879',
            name: 'Liên Hòa',
            prefix: 'Xã',
          },
          {
            id: '9880',
            name: 'Lóng Luông',
            prefix: 'Xã',
          },
          {
            id: '9881',
            name: 'Mường Men',
            prefix: 'Xã',
          },
          {
            id: '9882',
            name: 'Mường Tè',
            prefix: 'Xã',
          },
          {
            id: '9883',
            name: 'Quang Minh',
            prefix: 'Xã',
          },
          {
            id: '9884',
            name: 'Song Khủa',
            prefix: 'Xã',
          },
          {
            id: '9885',
            name: 'Suối Bảng',
            prefix: 'Xã',
          },
          {
            id: '9886',
            name: 'Tân Xuân',
            prefix: 'Xã',
          },
          {
            id: '9887',
            name: 'Tô Múa',
            prefix: 'Xã',
          },
          {
            id: '9888',
            name: 'Vân Hồ',
            prefix: 'Xã',
          },
          {
            id: '9889',
            name: 'Xuân Nha',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '625',
        name: 'Yên Châu',
        wards: [
          {
            id: '9890',
            name: 'Chiềng Đông',
            prefix: 'Xã',
          },
          {
            id: '9891',
            name: 'Chiềng Hặc',
            prefix: 'Xã',
          },
          {
            id: '9892',
            name: 'Chiềng Khoi',
            prefix: 'Xã',
          },
          {
            id: '9893',
            name: 'Chiềng On',
            prefix: 'Xã',
          },
          {
            id: '9894',
            name: 'Chiềng Pằn',
            prefix: 'Xã',
          },
          {
            id: '9895',
            name: 'Chiềng Sàng',
            prefix: 'Xã',
          },
          {
            id: '9896',
            name: 'Chiềng Tương',
            prefix: 'Xã',
          },
          {
            id: '9897',
            name: 'Lóng Phiêng',
            prefix: 'Xã',
          },
          {
            id: '9898',
            name: 'Mường Lựm',
            prefix: 'Xã',
          },
          {
            id: '9899',
            name: 'Phiêng Khoài',
            prefix: 'Xã',
          },
          {
            id: '9900',
            name: 'Sập Vạt',
            prefix: 'Xã',
          },
          {
            id: '9901',
            name: 'Tú Nang',
            prefix: 'Xã',
          },
          {
            id: '9902',
            name: 'Viêng Lán',
            prefix: 'Xã',
          },
          {
            id: '9903',
            name: 'Yên Châu',
            prefix: 'Thị trấn',
          },
          {
            id: '9904',
            name: 'Yên Sơn',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '55',
    code: 'BL',
    name: 'Bạc Liêu',
    districts: [
      {
        id: '626',
        name: 'Bạc Liêu',
        wards: [
          {
            id: '9905',
            name: '1',
            prefix: 'Phường',
          },
          {
            id: '9906',
            name: '2',
            prefix: 'Phường',
          },
          {
            id: '9907',
            name: '3',
            prefix: 'Phường',
          },
          {
            id: '9908',
            name: '4',
            prefix: 'Phường',
          },
          {
            id: '9909',
            name: '5',
            prefix: 'Phường',
          },
          {
            id: '9910',
            name: '7',
            prefix: 'Phường',
          },
          {
            id: '9911',
            name: '8',
            prefix: 'Phường',
          },
          {
            id: '9912',
            name: 'Hiệp Thành',
            prefix: 'Xã',
          },
          {
            id: '9913',
            name: 'Nhà Mát',
            prefix: 'Phường',
          },
          {
            id: '9914',
            name: 'Nhà Mát',
            prefix: 'Phường',
          },
          {
            id: '9915',
            name: 'Vĩnh Trạch',
            prefix: 'Xã',
          },
          {
            id: '9916',
            name: 'Vĩnh Trạch Đông',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '627',
        name: 'Đông Hải',
        wards: [
          {
            id: '9917',
            name: 'An Phúc',
            prefix: 'Xã',
          },
          {
            id: '9918',
            name: 'An Trạch',
            prefix: 'Xã',
          },
          {
            id: '9919',
            name: 'An Trạch A',
            prefix: 'Xã',
          },
          {
            id: '9920',
            name: 'Điền Hải',
            prefix: 'Xã',
          },
          {
            id: '9921',
            name: 'Định Thành',
            prefix: 'Xã',
          },
          {
            id: '9922',
            name: 'Định Thành A',
            prefix: 'Xã',
          },
          {
            id: '9923',
            name: 'Gành Hào',
            prefix: 'Thị trấn',
          },
          {
            id: '9924',
            name: 'Long Điền',
            prefix: 'Xã',
          },
          {
            id: '9925',
            name: 'Long Điền Đông',
            prefix: 'Xã',
          },
          {
            id: '9926',
            name: 'Long Điền Đông A',
            prefix: 'Xã',
          },
          {
            id: '9927',
            name: 'Long Điền Tây',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '628',
        name: 'Giá Rai',
        wards: [
          {
            id: '9928',
            name: 'Giá Rai',
            prefix: 'Thị trấn',
          },
          {
            id: '9929',
            name: 'Hộ Phòng',
            prefix: 'Thị trấn',
          },
          {
            id: '9930',
            name: 'Láng Tròn',
            prefix: 'Phường',
          },
          {
            id: '9931',
            name: 'Phong Tân',
            prefix: 'Xã',
          },
          {
            id: '9932',
            name: 'Phong Thạnh',
            prefix: 'Xã',
          },
          {
            id: '9933',
            name: 'Phong Thạnh A',
            prefix: 'Xã',
          },
          {
            id: '9934',
            name: 'Phong Thạnh Đông',
            prefix: 'Xã',
          },
          {
            id: '9935',
            name: 'Phong Thạnh Đông A',
            prefix: 'Xã',
          },
          {
            id: '9936',
            name: 'Phong Thạnh Tây',
            prefix: 'Xã',
          },
          {
            id: '9937',
            name: 'Tân Phong',
            prefix: 'Xã',
          },
          {
            id: '9938',
            name: 'Tân Thạnh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '629',
        name: 'Hòa Bình',
        wards: [
          {
            id: '9939',
            name: 'Hoà Bình',
            prefix: 'Thị trấn',
          },
          {
            id: '9940',
            name: 'Minh Diệu',
            prefix: 'Xã',
          },
          {
            id: '9941',
            name: 'Vĩnh Bình',
            prefix: 'Xã',
          },
          {
            id: '9942',
            name: 'Vĩnh Hậu',
            prefix: 'Xã',
          },
          {
            id: '9943',
            name: 'Vĩnh Hậu A',
            prefix: 'Xã',
          },
          {
            id: '9944',
            name: 'Vĩnh Mỹ A',
            prefix: 'Xã',
          },
          {
            id: '9945',
            name: 'Vĩnh Mỹ B',
            prefix: 'Xã',
          },
          {
            id: '9946',
            name: 'Vĩnh Thịnh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '630',
        name: 'Hồng Dân',
        wards: [
          {
            id: '9947',
            name: 'Lộc Ninh',
            prefix: 'Xã',
          },
          {
            id: '9948',
            name: 'Ngan Dừa',
            prefix: 'Thị trấn',
          },
          {
            id: '9949',
            name: 'Ninh Hòa',
            prefix: 'Xã',
          },
          {
            id: '9950',
            name: 'Ninh Quới',
            prefix: 'Xã',
          },
          {
            id: '9951',
            name: 'Ninh Quới A',
            prefix: 'Xã',
          },
          {
            id: '9952',
            name: 'Ninh Thạnh Lợi',
            prefix: 'Xã',
          },
          {
            id: '9953',
            name: 'Ninh Thạnh Lợi A',
            prefix: 'Xã',
          },
          {
            id: '9954',
            name: 'Vĩnh Lộc',
            prefix: 'Xã',
          },
          {
            id: '9955',
            name: 'Vĩnh Lộc A',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '631',
        name: 'Phước Long',
        wards: [
          {
            id: '9956',
            name: 'Hưng Phú',
            prefix: 'Xã',
          },
          {
            id: '9957',
            name: 'Phong Thạnh Tây A',
            prefix: 'Xã',
          },
          {
            id: '9958',
            name: 'Phong Thạnh Tây B',
            prefix: 'Xã',
          },
          {
            id: '9959',
            name: 'Phước Long',
            prefix: 'Thị trấn',
          },
          {
            id: '9960',
            name: 'Phước Long',
            prefix: 'Xã',
          },
          {
            id: '9961',
            name: 'Vĩnh Phú Đông',
            prefix: 'Xã',
          },
          {
            id: '9962',
            name: 'Vĩnh Phú Tây',
            prefix: 'Xã',
          },
          {
            id: '9963',
            name: 'Vĩnh Thanh',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '632',
        name: 'Vĩnh Lợi',
        wards: [
          {
            id: '9964',
            name: 'Châu Hưng',
            prefix: 'Thị trấn',
          },
          {
            id: '9965',
            name: 'Châu Hưng A',
            prefix: 'Xã',
          },
          {
            id: '9966',
            name: 'Châu Thới',
            prefix: 'Xã',
          },
          {
            id: '9967',
            name: 'Hưng Hội',
            prefix: 'Xã',
          },
          {
            id: '9968',
            name: 'Hưng Thành',
            prefix: 'Xã',
          },
          {
            id: '9969',
            name: 'Long Thạnh',
            prefix: 'Xã',
          },
          {
            id: '9970',
            name: 'Vĩnh Hưng',
            prefix: 'Xã',
          },
          {
            id: '9971',
            name: 'Vĩnh Hưng A',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '56',
    code: 'YB',
    name: 'Yên Bái',
    districts: [
      {
        id: '633',
        name: 'Lục Yên',
        wards: [
          {
            id: '9972',
            name: 'An Lạc',
            prefix: 'Xã',
          },
          {
            id: '9973',
            name: 'An Phú',
            prefix: 'Xã',
          },
          {
            id: '9974',
            name: 'Động Quan',
            prefix: 'Xã',
          },
          {
            id: '9975',
            name: 'Khai Trung',
            prefix: 'Xã',
          },
          {
            id: '9976',
            name: 'Khánh Hòa',
            prefix: 'Xã',
          },
          {
            id: '9977',
            name: 'Khánh Thiện',
            prefix: 'Xã',
          },
          {
            id: '9978',
            name: 'Lâm Thượng',
            prefix: 'Xã',
          },
          {
            id: '9979',
            name: 'Liễu Đô',
            prefix: 'Xã',
          },
          {
            id: '9980',
            name: 'Mai Sơn',
            prefix: 'Xã',
          },
          {
            id: '9981',
            name: 'Minh Chuẩn',
            prefix: 'Xã',
          },
          {
            id: '9982',
            name: 'Minh Tiến',
            prefix: 'Xã',
          },
          {
            id: '9983',
            name: 'Minh Xuân',
            prefix: 'Xã',
          },
          {
            id: '9984',
            name: 'Mường Lai',
            prefix: 'Xã',
          },
          {
            id: '9985',
            name: 'Phan Thanh',
            prefix: 'Xã',
          },
          {
            id: '9986',
            name: 'Phúc Lợi',
            prefix: 'Xã',
          },
          {
            id: '9987',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '9988',
            name: 'Tân Lĩnh',
            prefix: 'Xã',
          },
          {
            id: '9989',
            name: 'Tân Phượng',
            prefix: 'Xã',
          },
          {
            id: '9990',
            name: 'Tô Mậu',
            prefix: 'Xã',
          },
          {
            id: '9991',
            name: 'Trúc Lâu',
            prefix: 'Xã',
          },
          {
            id: '9992',
            name: 'Trung Tâm',
            prefix: 'Xã',
          },
          {
            id: '9993',
            name: 'Vĩnh Lạc',
            prefix: 'Xã',
          },
          {
            id: '9994',
            name: 'Yên Thắng',
            prefix: 'Xã',
          },
          {
            id: '9995',
            name: 'Yên Thế',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '634',
        name: 'Mù Cang Chải',
        wards: [
          {
            id: '9996',
            name: 'Cao Phạ',
            prefix: 'Xã',
          },
          {
            id: '9997',
            name: 'Chế Cu Nha',
            prefix: 'Xã',
          },
          {
            id: '9998',
            name: 'Chế Tạo',
            prefix: 'Xã',
          },
          {
            id: '9999',
            name: 'Dế Xu Phình',
            prefix: 'Xã',
          },
          {
            id: '10000',
            name: 'Hồ Bốn',
            prefix: 'Xã',
          },
          {
            id: '10001',
            name: 'Khao Mang',
            prefix: 'Xã',
          },
          {
            id: '10002',
            name: 'Kim Nọi',
            prefix: 'Xã',
          },
          {
            id: '10003',
            name: 'La Pán Tẩn',
            prefix: 'Xã',
          },
          {
            id: '10004',
            name: 'Lao Chải',
            prefix: 'Xã',
          },
          {
            id: '10005',
            name: 'Mồ Dề',
            prefix: 'Xã',
          },
          {
            id: '10006',
            name: 'Mù Cang Chải',
            prefix: 'Thị trấn',
          },
          {
            id: '10007',
            name: 'Nậm Có',
            prefix: 'Xã',
          },
          {
            id: '10008',
            name: 'Nậm Khắt',
            prefix: 'Xã',
          },
          {
            id: '10009',
            name: 'Púng Luông',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '635',
        name: 'Nghĩa Lộ',
        wards: [
          {
            id: '10010',
            name: 'Cầu Thia',
            prefix: 'Phường',
          },
          {
            id: '10011',
            name: 'Nghĩa An',
            prefix: 'Xã',
          },
          {
            id: '10012',
            name: 'Nghĩa Lợi',
            prefix: 'Xã',
          },
          {
            id: '10013',
            name: 'Nghĩa Phúc',
            prefix: 'Xã',
          },
          {
            id: '10014',
            name: 'Pú Trạng',
            prefix: 'Phường',
          },
          {
            id: '10015',
            name: 'Tân An',
            prefix: 'Phường',
          },
          {
            id: '10016',
            name: 'Trung Tâm',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '636',
        name: 'Trạm Tấu',
        wards: [
          {
            id: '10017',
            name: 'Bản Công',
            prefix: 'Xã',
          },
          {
            id: '10018',
            name: 'Bản Mù',
            prefix: 'Xã',
          },
          {
            id: '10019',
            name: 'Hát Lừu',
            prefix: 'Xã',
          },
          {
            id: '10020',
            name: 'Làng Nhì',
            prefix: 'Xã',
          },
          {
            id: '10021',
            name: 'Pá Hu',
            prefix: 'Xã',
          },
          {
            id: '10022',
            name: 'Pá Lau',
            prefix: 'Xã',
          },
          {
            id: '10023',
            name: 'Phình Hồ',
            prefix: 'Xã',
          },
          {
            id: '10024',
            name: 'Tà Si Láng',
            prefix: 'Xã',
          },
          {
            id: '10025',
            name: 'Trạm Tấu',
            prefix: 'Thị trấn',
          },
          {
            id: '10026',
            name: 'Trạm Tấu',
            prefix: 'Xã',
          },
          {
            id: '10027',
            name: 'Túc Đán',
            prefix: 'Xã',
          },
          {
            id: '10028',
            name: 'Xà Hồ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '637',
        name: 'Trấn Yên',
        wards: [
          {
            id: '10029',
            name: 'Báo Đáp',
            prefix: 'Xã',
          },
          {
            id: '10030',
            name: 'Bảo Hưng',
            prefix: 'Xã',
          },
          {
            id: '10031',
            name: 'Cổ Phúc',
            prefix: 'Thị trấn',
          },
          {
            id: '10032',
            name: 'Cường Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10033',
            name: 'Đào Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10034',
            name: 'Hòa Cuông',
            prefix: 'Xã',
          },
          {
            id: '10035',
            name: 'Hồng Ca',
            prefix: 'Xã',
          },
          {
            id: '10036',
            name: 'Hưng Khánh',
            prefix: 'Xã',
          },
          {
            id: '10037',
            name: 'Hưng Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10038',
            name: 'Kiên Thành',
            prefix: 'Xã',
          },
          {
            id: '10039',
            name: 'Lương Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10040',
            name: 'Minh Quán',
            prefix: 'Xã',
          },
          {
            id: '10041',
            name: 'Minh Quân',
            prefix: 'Xã',
          },
          {
            id: '10042',
            name: 'Minh Tiến',
            prefix: 'Xã',
          },
          {
            id: '10043',
            name: 'Nga Quán',
            prefix: 'Xã',
          },
          {
            id: '10044',
            name: 'Quy Mông',
            prefix: 'Xã',
          },
          {
            id: '10045',
            name: 'Tân Đồng',
            prefix: 'Xã',
          },
          {
            id: '10046',
            name: 'Vân Hội',
            prefix: 'Xã',
          },
          {
            id: '10047',
            name: 'Việt Cường',
            prefix: 'Xã',
          },
          {
            id: '10048',
            name: 'Việt Hồng',
            prefix: 'Xã',
          },
          {
            id: '10049',
            name: 'Việt Thành',
            prefix: 'Xã',
          },
          {
            id: '10050',
            name: 'Y Can',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '638',
        name: 'Văn Chấn',
        wards: [
          {
            id: '10051',
            name: 'An Lương',
            prefix: 'Xã',
          },
          {
            id: '10052',
            name: 'Bình Thuận',
            prefix: 'Xã',
          },
          {
            id: '10053',
            name: 'Cát Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10054',
            name: 'Chấn Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10055',
            name: 'Đại Lịch',
            prefix: 'Xã',
          },
          {
            id: '10056',
            name: 'Đồng Khê',
            prefix: 'Xã',
          },
          {
            id: '10057',
            name: 'Gia Hội',
            prefix: 'Xã',
          },
          {
            id: '10058',
            name: 'Hạnh Sơn',
            prefix: 'Xã',
          },
          {
            id: '10059',
            name: 'Minh An',
            prefix: 'Xã',
          },
          {
            id: '10060',
            name: 'Nậm Búng',
            prefix: 'Xã',
          },
          {
            id: '10061',
            name: 'Nậm Lành',
            prefix: 'Xã',
          },
          {
            id: '10062',
            name: 'Nậm Mười',
            prefix: 'Xã',
          },
          {
            id: '10063',
            name: 'Nghĩa Sơn',
            prefix: 'Xã',
          },
          {
            id: '10064',
            name: 'Nghĩa Tâm',
            prefix: 'Xã',
          },
          {
            id: '10065',
            name: 'Nông trường Liên Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '10066',
            name: 'Nông trường Nghĩa Lộ',
            prefix: 'Thị trấn',
          },
          {
            id: '10067',
            name: 'Nông trường Trần Phú',
            prefix: 'Thị trấn',
          },
          {
            id: '10068',
            name: 'Phù Nham',
            prefix: 'Xã',
          },
          {
            id: '10069',
            name: 'Phúc Sơn',
            prefix: 'Xã',
          },
          {
            id: '10070',
            name: 'Sơn A',
            prefix: 'Xã',
          },
          {
            id: '10071',
            name: 'Sơn Lương',
            prefix: 'Xã',
          },
          {
            id: '10072',
            name: 'Sơn Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10073',
            name: 'Sùng Đô',
            prefix: 'Xã',
          },
          {
            id: '10074',
            name: 'Suối Bu',
            prefix: 'Xã',
          },
          {
            id: '10075',
            name: 'Suối Giàng',
            prefix: 'Xã',
          },
          {
            id: '10076',
            name: 'Suối Quyền',
            prefix: 'Xã',
          },
          {
            id: '10077',
            name: 'Tân Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10078',
            name: 'Thạch Lương',
            prefix: 'Xã',
          },
          {
            id: '10079',
            name: 'Thanh Lương',
            prefix: 'Xã',
          },
          {
            id: '10080',
            name: 'Thượng Bằng La',
            prefix: 'Xã',
          },
          {
            id: '10081',
            name: 'Tú Lệ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '639',
        name: 'Văn Yên',
        wards: [
          {
            id: '10082',
            name: 'An Bình',
            prefix: 'Xã',
          },
          {
            id: '10083',
            name: 'An Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10084',
            name: 'Châu Quế Hạ',
            prefix: 'Xã',
          },
          {
            id: '10085',
            name: 'Châu Quế Thượng',
            prefix: 'Xã',
          },
          {
            id: '10086',
            name: 'Đại Phác',
            prefix: 'Xã',
          },
          {
            id: '10087',
            name: 'Đại Sơn',
            prefix: 'Xã',
          },
          {
            id: '10088',
            name: 'Đông An',
            prefix: 'Xã',
          },
          {
            id: '10089',
            name: 'Đông Cuông',
            prefix: 'Xã',
          },
          {
            id: '10090',
            name: 'Hoàng Thắng',
            prefix: 'Xã',
          },
          {
            id: '10091',
            name: 'Lâm Giang',
            prefix: 'Xã',
          },
          {
            id: '10092',
            name: 'Lang Thíp',
            prefix: 'Xã',
          },
          {
            id: '10093',
            name: 'Mậu A',
            prefix: 'Thị trấn',
          },
          {
            id: '10094',
            name: 'Mậu Đông',
            prefix: 'Xã',
          },
          {
            id: '10095',
            name: 'Mỏ Vàng',
            prefix: 'Xã',
          },
          {
            id: '10096',
            name: 'Nà Hẩu',
            prefix: 'Xã',
          },
          {
            id: '10097',
            name: 'Ngòi A',
            prefix: 'Xã',
          },
          {
            id: '10098',
            name: 'Phong Dụ Hạ',
            prefix: 'Xã',
          },
          {
            id: '10099',
            name: 'Phong Dụ Thượng',
            prefix: 'Xã',
          },
          {
            id: '10100',
            name: 'Quang Minh',
            prefix: 'Xã',
          },
          {
            id: '10101',
            name: 'Tân Hợp',
            prefix: 'Xã',
          },
          {
            id: '10102',
            name: 'Viễn Sơn',
            prefix: 'Xã',
          },
          {
            id: '10103',
            name: 'Xuân Ái',
            prefix: 'Xã',
          },
          {
            id: '10104',
            name: 'Xuân Tầm',
            prefix: 'Xã',
          },
          {
            id: '10105',
            name: 'Yên Hợp',
            prefix: 'Xã',
          },
          {
            id: '10106',
            name: 'Yên Hưng',
            prefix: 'Xã',
          },
          {
            id: '10107',
            name: 'Yên Phú',
            prefix: 'Xã',
          },
          {
            id: '10108',
            name: 'Yên Thái',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '640',
        name: 'Yên Bái',
        wards: [
          {
            id: '10109',
            name: 'Âu Lâu',
            prefix: 'Xã',
          },
          {
            id: '10110',
            name: 'Đồng Tâm',
            prefix: 'Phường',
          },
          {
            id: '10111',
            name: 'Giới Phiên',
            prefix: 'Xã',
          },
          {
            id: '10112',
            name: 'Hồng Hà',
            prefix: 'Phường',
          },
          {
            id: '10113',
            name: 'Hợp Minh',
            prefix: 'Xã',
          },
          {
            id: '10114',
            name: 'Minh Bảo',
            prefix: 'Xã',
          },
          {
            id: '10115',
            name: 'Minh Tân',
            prefix: 'Phường',
          },
          {
            id: '10116',
            name: 'Nam Cường',
            prefix: 'Xã',
          },
          {
            id: '10117',
            name: 'Nguyễn Phúc',
            prefix: 'Phường',
          },
          {
            id: '10118',
            name: 'Nguyễn Thái Học',
            prefix: 'Phường',
          },
          {
            id: '10119',
            name: 'Phúc Lộc',
            prefix: 'Xã',
          },
          {
            id: '10120',
            name: 'Tân Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10121',
            name: 'Tuy Lộc',
            prefix: 'Xã',
          },
          {
            id: '10122',
            name: 'Văn Phú',
            prefix: 'Xã',
          },
          {
            id: '10123',
            name: 'Văn Tiến',
            prefix: 'Xã',
          },
          {
            id: '10124',
            name: 'Yên Ninh',
            prefix: 'Phường',
          },
          {
            id: '10125',
            name: 'Yên Thịnh',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '641',
        name: 'Yên Bình',
        wards: [
          {
            id: '10126',
            name: 'Bạch Hà',
            prefix: 'Xã',
          },
          {
            id: '10127',
            name: 'Bảo Ái',
            prefix: 'Xã',
          },
          {
            id: '10128',
            name: 'Cảm Ân',
            prefix: 'Xã',
          },
          {
            id: '10129',
            name: 'Cẩm Nhân',
            prefix: 'Xã',
          },
          {
            id: '10130',
            name: 'Đại Đồng',
            prefix: 'Xã',
          },
          {
            id: '10131',
            name: 'Đại Minh',
            prefix: 'Xã',
          },
          {
            id: '10132',
            name: 'Hán Đà',
            prefix: 'Xã',
          },
          {
            id: '10133',
            name: 'Mông Sơn',
            prefix: 'Xã',
          },
          {
            id: '10134',
            name: 'Mỹ Gia',
            prefix: 'Xã',
          },
          {
            id: '10135',
            name: 'Ngọc Chấn',
            prefix: 'Xã',
          },
          {
            id: '10136',
            name: 'Phú Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10137',
            name: 'Phúc An',
            prefix: 'Xã',
          },
          {
            id: '10138',
            name: 'Phúc Ninh',
            prefix: 'Xã',
          },
          {
            id: '10139',
            name: 'Tân Hương',
            prefix: 'Xã',
          },
          {
            id: '10140',
            name: 'Tân Nguyên',
            prefix: 'Xã',
          },
          {
            id: '10141',
            name: 'Thác Bà',
            prefix: 'Thị trấn',
          },
          {
            id: '10142',
            name: 'Thịnh Hưng',
            prefix: 'Xã',
          },
          {
            id: '10143',
            name: 'Tích Cốc',
            prefix: 'Xã',
          },
          {
            id: '10144',
            name: 'Văn Lãng',
            prefix: 'Xã',
          },
          {
            id: '10145',
            name: 'Vĩnh Kiên',
            prefix: 'Xã',
          },
          {
            id: '10146',
            name: 'Vũ Linh',
            prefix: 'Xã',
          },
          {
            id: '10147',
            name: 'Xuân Lai',
            prefix: 'Xã',
          },
          {
            id: '10148',
            name: 'Xuân Long',
            prefix: 'Xã',
          },
          {
            id: '10149',
            name: 'Yên Bình',
            prefix: 'Thị trấn',
          },
          {
            id: '10150',
            name: 'Yên Bình',
            prefix: 'Xã',
          },
          {
            id: '10151',
            name: 'Yên Thành',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '57',
    code: 'TQ',
    name: 'Tuyên Quang',
    districts: [
      {
        id: '642',
        name: 'Chiêm Hóa',
        wards: [
          {
            id: '10152',
            name: 'Bình Nhân',
            prefix: 'Xã',
          },
          {
            id: '10153',
            name: 'Bình Phú',
            prefix: 'Xã',
          },
          {
            id: '10154',
            name: 'Hà Lang',
            prefix: 'Xã',
          },
          {
            id: '10155',
            name: 'Hòa An',
            prefix: 'Xã',
          },
          {
            id: '10156',
            name: 'Hòa Phú',
            prefix: 'Xã',
          },
          {
            id: '10157',
            name: 'Hùng Mỹ',
            prefix: 'Xã',
          },
          {
            id: '10158',
            name: 'Kiên Đài',
            prefix: 'Xã',
          },
          {
            id: '10159',
            name: 'Kim Bình',
            prefix: 'Xã',
          },
          {
            id: '10160',
            name: 'Linh Phú',
            prefix: 'Xã',
          },
          {
            id: '10161',
            name: 'Minh Quang',
            prefix: 'Xã',
          },
          {
            id: '10162',
            name: 'Ngọc Hội',
            prefix: 'Xã',
          },
          {
            id: '10163',
            name: 'Nhân Lý',
            prefix: 'Xã',
          },
          {
            id: '10164',
            name: 'Phú Bình',
            prefix: 'Xã',
          },
          {
            id: '10165',
            name: 'Phúc Sơn',
            prefix: 'Xã',
          },
          {
            id: '10166',
            name: 'Phúc Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10167',
            name: 'Tân An',
            prefix: 'Xã',
          },
          {
            id: '10168',
            name: 'Tân Mỹ',
            prefix: 'Xã',
          },
          {
            id: '10169',
            name: 'Tân Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10170',
            name: 'Tri Phú',
            prefix: 'Xã',
          },
          {
            id: '10171',
            name: 'Trung Hà',
            prefix: 'Xã',
          },
          {
            id: '10172',
            name: 'Trung Hòa',
            prefix: 'Xã',
          },
          {
            id: '10173',
            name: 'Vĩnh Lộc',
            prefix: 'Thị trấn',
          },
          {
            id: '10174',
            name: 'Vinh Quang',
            prefix: 'Xã',
          },
          {
            id: '10175',
            name: 'Xuân Quang',
            prefix: 'Xã',
          },
          {
            id: '10176',
            name: 'Yên Lập',
            prefix: 'Xã',
          },
          {
            id: '10177',
            name: 'Yên Nguyên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '643',
        name: 'Hàm Yên',
        wards: [
          {
            id: '10178',
            name: 'Bạch Xa',
            prefix: 'Xã',
          },
          {
            id: '10179',
            name: 'Bằng Cốc',
            prefix: 'Xã',
          },
          {
            id: '10180',
            name: 'Bình Xa',
            prefix: 'Xã',
          },
          {
            id: '10181',
            name: 'Đức Ninh',
            prefix: 'Xã',
          },
          {
            id: '10182',
            name: 'Hùng Đức',
            prefix: 'Xã',
          },
          {
            id: '10183',
            name: 'Minh Dân',
            prefix: 'Xã',
          },
          {
            id: '10184',
            name: 'Minh Hương',
            prefix: 'Xã',
          },
          {
            id: '10185',
            name: 'Minh Khương',
            prefix: 'Xã',
          },
          {
            id: '10186',
            name: 'Nhân Mục',
            prefix: 'Xã',
          },
          {
            id: '10187',
            name: 'Phù Lưu',
            prefix: 'Xã',
          },
          {
            id: '10188',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '10189',
            name: 'Tân Yên',
            prefix: 'Thị trấn',
          },
          {
            id: '10190',
            name: 'Thái Hòa',
            prefix: 'Xã',
          },
          {
            id: '10191',
            name: 'Thái Sơn',
            prefix: 'Xã',
          },
          {
            id: '10192',
            name: 'Thành Long',
            prefix: 'Xã',
          },
          {
            id: '10193',
            name: 'Yên Lâm',
            prefix: 'Xã',
          },
          {
            id: '10194',
            name: 'Yên Phú',
            prefix: 'Xã',
          },
          {
            id: '10195',
            name: 'Yên Thuận',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '644',
        name: 'Lâm Bình',
        wards: [
          {
            id: '10196',
            name: 'Bình An',
            prefix: 'Xã',
          },
          {
            id: '10197',
            name: 'Hồng Quang',
            prefix: 'Xã',
          },
          {
            id: '10198',
            name: 'Khuôn Hà',
            prefix: 'Xã',
          },
          {
            id: '10199',
            name: 'Lăng Can',
            prefix: 'Xã',
          },
          {
            id: '10200',
            name: 'Phúc Yên',
            prefix: 'Xã',
          },
          {
            id: '10201',
            name: 'Thổ Bình',
            prefix: 'Xã',
          },
          {
            id: '10202',
            name: 'Thượng Lâm',
            prefix: 'Xã',
          },
          {
            id: '10203',
            name: 'Xuân Lập',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '645',
        name: 'Na Hang',
        wards: [
          {
            id: '10204',
            name: 'Côn Lôn',
            prefix: 'Xã',
          },
          {
            id: '10205',
            name: 'Đà Vị',
            prefix: 'Xã',
          },
          {
            id: '10206',
            name: 'Hồng Thái',
            prefix: 'Xã',
          },
          {
            id: '10207',
            name: 'Khâu Tinh',
            prefix: 'Xã',
          },
          {
            id: '10208',
            name: 'Na Hang',
            prefix: 'Thị trấn',
          },
          {
            id: '10209',
            name: 'Năng Khả',
            prefix: 'Xã',
          },
          {
            id: '10210',
            name: 'Sinh Long',
            prefix: 'Xã',
          },
          {
            id: '10211',
            name: 'Sơn Phú',
            prefix: 'Xã',
          },
          {
            id: '10212',
            name: 'Thanh Tương',
            prefix: 'Xã',
          },
          {
            id: '10213',
            name: 'Thượng Giáp',
            prefix: 'Xã',
          },
          {
            id: '10214',
            name: 'Thượng Nông',
            prefix: 'Xã',
          },
          {
            id: '10215',
            name: 'Yên Hoa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '646',
        name: 'Sơn Dương',
        wards: [
          {
            id: '10216',
            name: 'Bình Yên',
            prefix: 'Xã',
          },
          {
            id: '10217',
            name: 'Cấp Tiến',
            prefix: 'Xã',
          },
          {
            id: '10218',
            name: 'Chi Thiết',
            prefix: 'Xã',
          },
          {
            id: '10219',
            name: 'Đại Phú',
            prefix: 'Xã',
          },
          {
            id: '10220',
            name: 'Đông Lợi',
            prefix: 'Xã',
          },
          {
            id: '10221',
            name: 'Đồng Quý',
            prefix: 'Xã',
          },
          {
            id: '10222',
            name: 'Đông Thọ',
            prefix: 'Xã',
          },
          {
            id: '10223',
            name: 'Hào Phú',
            prefix: 'Xã',
          },
          {
            id: '10224',
            name: 'Hồng Lạc',
            prefix: 'Xã',
          },
          {
            id: '10225',
            name: 'Hợp Hòa',
            prefix: 'Xã',
          },
          {
            id: '10226',
            name: 'Hợp Thành',
            prefix: 'Xã',
          },
          {
            id: '10227',
            name: 'Kháng Nhật',
            prefix: 'Xã',
          },
          {
            id: '10228',
            name: 'Lâm Xuyên',
            prefix: 'Xã',
          },
          {
            id: '10229',
            name: 'Lương Thiện',
            prefix: 'Xã',
          },
          {
            id: '10230',
            name: 'Minh Thanh',
            prefix: 'Xã',
          },
          {
            id: '10231',
            name: 'Ninh Lai',
            prefix: 'Xã',
          },
          {
            id: '10232',
            name: 'Phú Lương',
            prefix: 'Xã',
          },
          {
            id: '10233',
            name: 'Phúc Ứng',
            prefix: 'Xã',
          },
          {
            id: '10234',
            name: 'Quyết Thắng',
            prefix: 'Xã',
          },
          {
            id: '10235',
            name: 'Sầm Dương',
            prefix: 'Xã',
          },
          {
            id: '10236',
            name: 'Sơn Dương',
            prefix: 'Thị trấn',
          },
          {
            id: '10237',
            name: 'Sơn Nam',
            prefix: 'Xã',
          },
          {
            id: '10238',
            name: 'Tam Đa',
            prefix: 'Xã',
          },
          {
            id: '10239',
            name: 'Tân Trào',
            prefix: 'Xã',
          },
          {
            id: '10240',
            name: 'Thanh Phát',
            prefix: 'Xã',
          },
          {
            id: '10241',
            name: 'Thiện Kế',
            prefix: 'Xã',
          },
          {
            id: '10242',
            name: 'Thương Ấm',
            prefix: 'Xã',
          },
          {
            id: '10243',
            name: 'Trung Yên',
            prefix: 'Xã',
          },
          {
            id: '10244',
            name: 'Tú Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10245',
            name: 'Tuân Lộ',
            prefix: 'Xã',
          },
          {
            id: '10246',
            name: 'Văn Phú',
            prefix: 'Xã',
          },
          {
            id: '10247',
            name: 'Vân Sơn',
            prefix: 'Xã',
          },
          {
            id: '10248',
            name: 'Vĩnh Lợi',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '647',
        name: 'Tuyên Quang',
        wards: [
          {
            id: '10249',
            name: 'An Khang',
            prefix: 'Xã',
          },
          {
            id: '10250',
            name: 'An Tường',
            prefix: 'Xã',
          },
          {
            id: '10251',
            name: 'Đội Cấn',
            prefix: 'Xã',
          },
          {
            id: '10252',
            name: 'Hưng Thành',
            prefix: 'Phường',
          },
          {
            id: '10253',
            name: 'Lưỡng Vượng',
            prefix: 'Xã',
          },
          {
            id: '10254',
            name: 'Minh Xuân',
            prefix: 'Phường',
          },
          {
            id: '10255',
            name: 'Nông Tiến',
            prefix: 'Phường',
          },
          {
            id: '10256',
            name: 'Phan Thiết',
            prefix: 'Phường',
          },
          {
            id: '10257',
            name: 'Tân Binh',
            prefix: 'Xã',
          },
          {
            id: '10258',
            name: 'Tân Hà',
            prefix: 'Phường',
          },
          {
            id: '10259',
            name: 'Tân Quang',
            prefix: 'Phường',
          },
          {
            id: '10260',
            name: 'Thái Long',
            prefix: 'Xã',
          },
          {
            id: '10261',
            name: 'Tràng Đà',
            prefix: 'Xã',
          },
          {
            id: '10262',
            name: 'Ỷ La',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '648',
        name: 'Yên Sơn',
        wards: [
          {
            id: '10263',
            name: 'Chân Sơn',
            prefix: 'Xã',
          },
          {
            id: '10264',
            name: 'Chiêu Yên',
            prefix: 'Xã',
          },
          {
            id: '10265',
            name: 'Công Đa',
            prefix: 'Xã',
          },
          {
            id: '10266',
            name: 'Đạo Viện',
            prefix: 'Xã',
          },
          {
            id: '10267',
            name: 'Đội Bình',
            prefix: 'Xã',
          },
          {
            id: '10268',
            name: 'Hoàng Khai',
            prefix: 'Xã',
          },
          {
            id: '10269',
            name: 'Hùng Lợi',
            prefix: 'Xã',
          },
          {
            id: '10270',
            name: 'Kiến Thiết',
            prefix: 'Xã',
          },
          {
            id: '10271',
            name: 'Kim Phú',
            prefix: 'Xã',
          },
          {
            id: '10272',
            name: 'Kim Quan',
            prefix: 'Xã',
          },
          {
            id: '10273',
            name: 'Lang Quán',
            prefix: 'Xã',
          },
          {
            id: '10274',
            name: 'Lực Hành',
            prefix: 'Xã',
          },
          {
            id: '10275',
            name: 'Mỹ Bằng',
            prefix: 'Xã',
          },
          {
            id: '10276',
            name: 'Nhữ Hán',
            prefix: 'Xã',
          },
          {
            id: '10277',
            name: 'Nhữ Khê',
            prefix: 'Xã',
          },
          {
            id: '10278',
            name: 'Phú Lâm',
            prefix: 'Xã',
          },
          {
            id: '10279',
            name: 'Phú Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10280',
            name: 'Phúc Ninh',
            prefix: 'Xã',
          },
          {
            id: '10281',
            name: 'Quý Quân',
            prefix: 'Xã',
          },
          {
            id: '10282',
            name: 'Tân Bình',
            prefix: 'Thị trấn',
          },
          {
            id: '10283',
            name: 'Tân Long',
            prefix: 'Xã',
          },
          {
            id: '10284',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '10285',
            name: 'Thái Bình',
            prefix: 'Xã',
          },
          {
            id: '10286',
            name: 'Thắng Quân',
            prefix: 'Xã',
          },
          {
            id: '10287',
            name: 'Tiến Bộ',
            prefix: 'Xã',
          },
          {
            id: '10288',
            name: 'Trung Minh',
            prefix: 'Xã',
          },
          {
            id: '10289',
            name: 'Trung Môn',
            prefix: 'Xã',
          },
          {
            id: '10290',
            name: 'Trung Sơn',
            prefix: 'Xã',
          },
          {
            id: '10291',
            name: 'Trung Trực',
            prefix: 'Xã',
          },
          {
            id: '10292',
            name: 'Tứ Quận',
            prefix: 'Xã',
          },
          {
            id: '10293',
            name: 'Xuân Vân',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '58',
    code: 'DDB',
    name: 'Điện Biên',
    districts: [
      {
        id: '649',
        name: 'Điện Biên',
        wards: [
          {
            id: '10294',
            name: 'Hẹ Muông',
            prefix: 'Xã',
          },
          {
            id: '10295',
            name: 'Hua Thanh',
            prefix: 'Xã',
          },
          {
            id: '10296',
            name: 'Mường Lói',
            prefix: 'Xã',
          },
          {
            id: '10297',
            name: 'Mường Nhà',
            prefix: 'Xã',
          },
          {
            id: '10298',
            name: 'Mường Phăng',
            prefix: 'Xã',
          },
          {
            id: '10299',
            name: 'Mường Pồn',
            prefix: 'Xã',
          },
          {
            id: '10300',
            name: 'Nà Nhạn',
            prefix: 'Xã',
          },
          {
            id: '10301',
            name: 'Nà Tấu',
            prefix: 'Xã',
          },
          {
            id: '10302',
            name: 'Na Tông',
            prefix: 'Xã',
          },
          {
            id: '10303',
            name: 'Na Ư',
            prefix: 'Xã',
          },
          {
            id: '10304',
            name: 'Noong Bua',
            prefix: 'Phường',
          },
          {
            id: '10305',
            name: 'Noong Hẹt',
            prefix: 'Xã',
          },
          {
            id: '10306',
            name: 'Noong Luống',
            prefix: 'Xã',
          },
          {
            id: '10307',
            name: 'Núa Ngam',
            prefix: 'Xã',
          },
          {
            id: '10308',
            name: 'Pá Khoang',
            prefix: 'Xã',
          },
          {
            id: '10309',
            name: 'Pa Thơm',
            prefix: 'Xã',
          },
          {
            id: '10310',
            name: 'Phu Luông',
            prefix: 'Xã',
          },
          {
            id: '10311',
            name: 'Pom Lót',
            prefix: 'Xã',
          },
          {
            id: '10312',
            name: 'Sam Mứn',
            prefix: 'Xã',
          },
          {
            id: '10313',
            name: 'Thanh An',
            prefix: 'Xã',
          },
          {
            id: '10314',
            name: 'Thanh Chăn',
            prefix: 'Xã',
          },
          {
            id: '10315',
            name: 'Thanh Hưng',
            prefix: 'Xã',
          },
          {
            id: '10316',
            name: 'Thanh Luông',
            prefix: 'Xã',
          },
          {
            id: '10317',
            name: 'Thanh Nưa',
            prefix: 'Xã',
          },
          {
            id: '10318',
            name: 'Thanh Xương',
            prefix: 'Xã',
          },
          {
            id: '10319',
            name: 'Thanh Yên',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '650',
        name: 'Điện Biên Đông',
        wards: [
          {
            id: '10320',
            name: 'Chiềng Sơ',
            prefix: 'Xã',
          },
          {
            id: '10321',
            name: 'Điện Biên Đông',
            prefix: 'Thị trấn',
          },
          {
            id: '10322',
            name: 'Háng Lìa',
            prefix: 'Xã',
          },
          {
            id: '10323',
            name: 'Keo Lôm',
            prefix: 'Xã',
          },
          {
            id: '10324',
            name: 'Luân Giới',
            prefix: 'Xã',
          },
          {
            id: '10325',
            name: 'Mường Luân',
            prefix: 'Xã',
          },
          {
            id: '10326',
            name: 'Na Son',
            prefix: 'Xã',
          },
          {
            id: '10327',
            name: 'Nong U',
            prefix: 'Xã',
          },
          {
            id: '10328',
            name: 'Phì Nhừ',
            prefix: 'Xã',
          },
          {
            id: '10329',
            name: 'Phình Giàng',
            prefix: 'Xã',
          },
          {
            id: '10330',
            name: 'Pú Hồng',
            prefix: 'Xã',
          },
          {
            id: '10331',
            name: 'Pú Nhi',
            prefix: 'Xã',
          },
          {
            id: '10332',
            name: 'Tìa Dình',
            prefix: 'Xã',
          },
          {
            id: '10333',
            name: 'Xa Dung',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '651',
        name: 'Điện Biên Phủ',
        wards: [
          {
            id: '10334',
            name: 'Him Lam',
            prefix: 'Phường',
          },
          {
            id: '10335',
            name: 'Mường Thanh',
            prefix: 'Phường',
          },
          {
            id: '10336',
            name: 'Nam Thanh',
            prefix: 'Phường',
          },
          {
            id: '10337',
            name: 'Noong Bua',
            prefix: 'Phường',
          },
          {
            id: '10338',
            name: 'Tà Lèng',
            prefix: 'Xã',
          },
          {
            id: '10339',
            name: 'Tân Thanh',
            prefix: 'Phường',
          },
          {
            id: '10340',
            name: 'Thanh Bình',
            prefix: 'Phường',
          },
          {
            id: '10341',
            name: 'Thanh Minh',
            prefix: 'Xã',
          },
          {
            id: '10342',
            name: 'Thanh Trường',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '652',
        name: 'Mường Ảng',
        wards: [
          {
            id: '10343',
            name: 'Ẳng Cang',
            prefix: 'Xã',
          },
          {
            id: '10344',
            name: 'Ẳng Nưa',
            prefix: 'Xã',
          },
          {
            id: '10345',
            name: 'Ẳng Tở',
            prefix: 'Xã',
          },
          {
            id: '10346',
            name: 'Búng Lao',
            prefix: 'Xã',
          },
          {
            id: '10347',
            name: 'Mường Ảng',
            prefix: 'Thị trấn',
          },
          {
            id: '10348',
            name: 'Mường Đăng',
            prefix: 'Xã',
          },
          {
            id: '10349',
            name: 'Mường Lạn',
            prefix: 'Xã',
          },
          {
            id: '10350',
            name: 'Nặm Lịch',
            prefix: 'Xã',
          },
          {
            id: '10351',
            name: 'Ngối Cáy',
            prefix: 'Xã',
          },
          {
            id: '10352',
            name: 'Xuân Lao',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '653',
        name: 'Mường Chà',
        wards: [
          {
            id: '10353',
            name: 'Hừa Ngài',
            prefix: 'Xã',
          },
          {
            id: '10354',
            name: 'Huổi Lèng',
            prefix: 'Xã',
          },
          {
            id: '10355',
            name: 'Huổi Mí',
            prefix: 'Xã',
          },
          {
            id: '10356',
            name: 'Ma Thì Hồ',
            prefix: 'Xã',
          },
          {
            id: '10357',
            name: 'Mường Chà',
            prefix: 'Thị trấn',
          },
          {
            id: '10358',
            name: 'Mường Mươn',
            prefix: 'Xã',
          },
          {
            id: '10359',
            name: 'Mường Tùng',
            prefix: 'Xã',
          },
          {
            id: '10360',
            name: 'Na Sang',
            prefix: 'Xã',
          },
          {
            id: '10361',
            name: 'Nậm Nèn',
            prefix: 'Xã',
          },
          {
            id: '10362',
            name: 'Pa Ham',
            prefix: 'Xã',
          },
          {
            id: '10363',
            name: 'Phìn Hồ',
            prefix: 'Xã',
          },
          {
            id: '10364',
            name: 'Sa Lông',
            prefix: 'Xã',
          },
          {
            id: '10365',
            name: 'Sá Tổng',
            prefix: 'Xã',
          },
          {
            id: '10366',
            name: 'Si Pa Phìn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '654',
        name: 'Mường Lay',
        wards: [
          {
            id: '10367',
            name: 'Lay Nưa',
            prefix: 'Xã',
          },
          {
            id: '10368',
            name: 'Na Lay',
            prefix: 'Phường',
          },
          {
            id: '10369',
            name: 'Sông Đà',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '655',
        name: 'Mường Nhé',
        wards: [
          {
            id: '10370',
            name: 'Chung Chải',
            prefix: 'Xã',
          },
          {
            id: '10371',
            name: 'Huổi Lếch',
            prefix: 'Xã',
          },
          {
            id: '10372',
            name: 'Leng Su Sìn',
            prefix: 'Xã',
          },
          {
            id: '10373',
            name: 'Mường Nhé',
            prefix: 'Xã',
          },
          {
            id: '10374',
            name: 'Mường Toong',
            prefix: 'Xã',
          },
          {
            id: '10375',
            name: 'Nậm Kè',
            prefix: 'Xã',
          },
          {
            id: '10376',
            name: 'Nậm Vì',
            prefix: 'Xã',
          },
          {
            id: '10377',
            name: 'Pá Mỳ',
            prefix: 'Xã',
          },
          {
            id: '10378',
            name: 'Quảng Lâm',
            prefix: 'Xã',
          },
          {
            id: '10379',
            name: 'Sen Thượng',
            prefix: 'Xã',
          },
          {
            id: '10380',
            name: 'Sín Thầu',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '656',
        name: 'Nậm Pồ',
        wards: [
          {
            id: '10381',
            name: 'Chà Cang',
            prefix: 'Xã',
          },
          {
            id: '10382',
            name: 'Chà Nưa',
            prefix: 'Xã',
          },
          {
            id: '10383',
            name: 'Chà Tở',
            prefix: 'Xã',
          },
          {
            id: '10384',
            name: 'Nà Bủng',
            prefix: 'Xã',
          },
          {
            id: '10385',
            name: 'Na Cô Sa',
            prefix: 'Xã',
          },
          {
            id: '10386',
            name: 'Nà Hỳ',
            prefix: 'Xã',
          },
          {
            id: '10387',
            name: 'Nà Khoa',
            prefix: 'Xã',
          },
          {
            id: '10388',
            name: 'Nậm Chua',
            prefix: 'Xã',
          },
          {
            id: '10389',
            name: 'Nậm Khăn',
            prefix: 'Xã',
          },
          {
            id: '10390',
            name: 'Nậm Nhừ',
            prefix: 'Xã',
          },
          {
            id: '10391',
            name: 'Nậm Tin',
            prefix: 'Xã',
          },
          {
            id: '10392',
            name: 'Pa Tần',
            prefix: 'Xã',
          },
          {
            id: '10393',
            name: 'Phìn Hồ',
            prefix: 'Xã',
          },
          {
            id: '10394',
            name: 'Vàng Đán',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '657',
        name: 'Tủa Chùa',
        wards: [
          {
            id: '10395',
            name: 'Huổi Só',
            prefix: 'Xã',
          },
          {
            id: '10396',
            name: 'Lao Xả Phình',
            prefix: 'Xã',
          },
          {
            id: '10397',
            name: 'Mường Báng',
            prefix: 'Xã',
          },
          {
            id: '10398',
            name: 'Mường Đun',
            prefix: 'Xã',
          },
          {
            id: '10399',
            name: 'Sáng Nhè',
            prefix: 'Xã',
          },
          {
            id: '10400',
            name: 'Sín Chải',
            prefix: 'Xã',
          },
          {
            id: '10401',
            name: 'Sính Phình',
            prefix: 'Xã',
          },
          {
            id: '10402',
            name: 'Tả Phìn',
            prefix: 'Xã',
          },
          {
            id: '10403',
            name: 'Tả Sìn Thàng',
            prefix: 'Xã',
          },
          {
            id: '10404',
            name: 'Trung Thu',
            prefix: 'Xã',
          },
          {
            id: '10405',
            name: 'Tủa Chùa',
            prefix: 'Xã',
          },
          {
            id: '10406',
            name: 'Tủa Thàng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '658',
        name: 'Tuần Giáo',
        wards: [
          {
            id: '10407',
            name: 'Chiềng Đông',
            prefix: 'Xã',
          },
          {
            id: '10408',
            name: 'Chiềng Sinh',
            prefix: 'Xã',
          },
          {
            id: '10409',
            name: 'Mùn Chung',
            prefix: 'Xã',
          },
          {
            id: '10410',
            name: 'Mường Khong',
            prefix: 'Xã',
          },
          {
            id: '10411',
            name: 'Mường Mùn',
            prefix: 'Xã',
          },
          {
            id: '10412',
            name: 'Mường Thín',
            prefix: 'Xã',
          },
          {
            id: '10413',
            name: 'Nà Sáy',
            prefix: 'Xã',
          },
          {
            id: '10414',
            name: 'Nà Tòng',
            prefix: 'Xã',
          },
          {
            id: '10415',
            name: 'Phình Sáng',
            prefix: 'Xã',
          },
          {
            id: '10416',
            name: 'Pú Nhung',
            prefix: 'Xã',
          },
          {
            id: '10417',
            name: 'Pú Xi',
            prefix: 'Xã',
          },
          {
            id: '10418',
            name: 'Quài Cang',
            prefix: 'Xã',
          },
          {
            id: '10419',
            name: 'Quài Nưa',
            prefix: 'Xã',
          },
          {
            id: '10420',
            name: 'Quài Tở',
            prefix: 'Xã',
          },
          {
            id: '10421',
            name: 'Rạng Đông',
            prefix: 'Xã',
          },
          {
            id: '10422',
            name: 'Ta Ma',
            prefix: 'Xã',
          },
          {
            id: '10423',
            name: 'Tênh Phông',
            prefix: 'Xã',
          },
          {
            id: '10424',
            name: 'Tỏa Tình',
            prefix: 'Xã',
          },
          {
            id: '10425',
            name: 'Tuần Giáo',
            prefix: 'Thị trấn',
          },
        ],
      },
    ],
  },
  {
    id: '59',
    code: 'LCH',
    name: 'Lai Châu',
    districts: [
      {
        id: '659',
        name: 'Lai Châu',
        wards: [
          {
            id: '10426',
            name: 'Đoàn Kết',
            prefix: 'Phường',
          },
          {
            id: '10427',
            name: 'Đông Phong',
            prefix: 'Phường',
          },
          {
            id: '10428',
            name: 'Nậm Loỏng',
            prefix: 'Xã',
          },
          {
            id: '10429',
            name: 'Quyết Thắng',
            prefix: 'Phường',
          },
          {
            id: '10430',
            name: 'Quyết Tiến',
            prefix: 'Phường',
          },
          {
            id: '10431',
            name: 'San Thàng',
            prefix: 'Xã',
          },
          {
            id: '10432',
            name: 'Tân Phong',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '660',
        name: 'Mường Tè',
        wards: [
          {
            id: '10433',
            name: 'Bum Nưa',
            prefix: 'Xã',
          },
          {
            id: '10434',
            name: 'Bum Tở',
            prefix: 'Xã',
          },
          {
            id: '10435',
            name: 'Ka Lăng',
            prefix: 'Xã',
          },
          {
            id: '10436',
            name: 'Kan Hồ',
            prefix: 'Xã',
          },
          {
            id: '10437',
            name: 'Mù Cả',
            prefix: 'Xã',
          },
          {
            id: '10438',
            name: 'Mường Tè',
            prefix: 'Thị trấn',
          },
          {
            id: '10439',
            name: 'Nậm Khao',
            prefix: 'Xã',
          },
          {
            id: '10440',
            name: 'Pa Ủ',
            prefix: 'Xã',
          },
          {
            id: '10441',
            name: 'Pa Vệ Sử',
            prefix: 'Xã',
          },
          {
            id: '10442',
            name: 'Tá Bạ',
            prefix: 'Xã',
          },
          {
            id: '10443',
            name: 'Tà Tổng',
            prefix: 'Xã',
          },
          {
            id: '10444',
            name: 'Thu Lũm',
            prefix: 'Xã',
          },
          {
            id: '10445',
            name: 'Vàng San',
            prefix: 'Xã',
          },
          {
            id: '10446',
            name: 'Xã Mường Tè',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '661',
        name: 'Nậm Nhùn',
        wards: [
          {
            id: '10447',
            name: 'Hua Bum',
            prefix: 'Xã',
          },
          {
            id: '10448',
            name: 'Lê Lợi',
            prefix: 'Xã',
          },
          {
            id: '10449',
            name: 'Mường Mô',
            prefix: 'Xã',
          },
          {
            id: '10450',
            name: 'Nậm Ban',
            prefix: 'Xã',
          },
          {
            id: '10451',
            name: 'Nậm Chà',
            prefix: 'Xã',
          },
          {
            id: '10452',
            name: 'Nậm Hàng',
            prefix: 'Xã',
          },
          {
            id: '10453',
            name: 'Nậm Manh',
            prefix: 'Xã',
          },
          {
            id: '10454',
            name: 'Nậm Nhùn',
            prefix: 'Thị trấn',
          },
          {
            id: '10455',
            name: 'Nậm Pì',
            prefix: 'Xã',
          },
          {
            id: '10456',
            name: 'Pú Đao',
            prefix: 'Xã',
          },
          {
            id: '10457',
            name: 'Trung Chải',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '662',
        name: 'Phong Thổ',
        wards: [
          {
            id: '10458',
            name: 'Bản Lang',
            prefix: 'Xã',
          },
          {
            id: '10459',
            name: 'Dào San',
            prefix: 'Xã',
          },
          {
            id: '10460',
            name: 'Hoang Thèn',
            prefix: 'Xã',
          },
          {
            id: '10461',
            name: 'Huổi Luông',
            prefix: 'Xã',
          },
          {
            id: '10462',
            name: 'Khổng Lào',
            prefix: 'Xã',
          },
          {
            id: '10463',
            name: 'Lản Nhì Thàng',
            prefix: 'Xã',
          },
          {
            id: '10464',
            name: 'Ma Ly Chải',
            prefix: 'Xã',
          },
          {
            id: '10465',
            name: 'Ma Ly Pho',
            prefix: 'Xã',
          },
          {
            id: '10466',
            name: 'Mồ Sì San',
            prefix: 'Xã',
          },
          {
            id: '10467',
            name: 'Mù Sang',
            prefix: 'Xã',
          },
          {
            id: '10468',
            name: 'Mường So',
            prefix: 'Xã',
          },
          {
            id: '10469',
            name: 'Nậm Xe',
            prefix: 'Xã',
          },
          {
            id: '10470',
            name: 'Pa Vây Sử',
            prefix: 'Xã',
          },
          {
            id: '10471',
            name: 'Phong Thổ',
            prefix: 'Thị trấn',
          },
          {
            id: '10472',
            name: 'Sì Lở Lầu',
            prefix: 'Xã',
          },
          {
            id: '10473',
            name: 'Sin Súi Hồ',
            prefix: 'Xã',
          },
          {
            id: '10474',
            name: 'Tung Qua Lìn',
            prefix: 'Xã',
          },
          {
            id: '10475',
            name: 'Vàng Ma Chải',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '663',
        name: 'Sìn Hồ',
        wards: [
          {
            id: '10476',
            name: 'Căn Co',
            prefix: 'Xã',
          },
          {
            id: '10477',
            name: 'Chăn Nưa',
            prefix: 'Xã',
          },
          {
            id: '10478',
            name: 'Hồng Thu',
            prefix: 'Xã',
          },
          {
            id: '10479',
            name: 'Làng Mô',
            prefix: 'Xã',
          },
          {
            id: '10480',
            name: 'Lùng Thàng',
            prefix: 'Xã',
          },
          {
            id: '10481',
            name: 'Ma Quai',
            prefix: 'Xã',
          },
          {
            id: '10482',
            name: 'Ma Quai,',
            prefix: 'Xã',
          },
          {
            id: '10483',
            name: 'Nậm Cha',
            prefix: 'Xã',
          },
          {
            id: '10484',
            name: 'Nậm Cuổi',
            prefix: 'Xã',
          },
          {
            id: '10485',
            name: 'Nậm Hăn',
            prefix: 'Xã',
          },
          {
            id: '10486',
            name: 'Nậm Mạ',
            prefix: 'Xã',
          },
          {
            id: '10487',
            name: 'Nậm Tăm',
            prefix: 'Xã',
          },
          {
            id: '10488',
            name: 'Noong Hẻo',
            prefix: 'Thị trấn',
          },
          {
            id: '10489',
            name: 'Pa Khóa',
            prefix: 'Xã',
          },
          {
            id: '10490',
            name: 'Pa Tần',
            prefix: 'Xã',
          },
          {
            id: '10491',
            name: 'Phăng Sô Lin',
            prefix: 'Xã',
          },
          {
            id: '10492',
            name: 'Phìn Hồ',
            prefix: 'Xã',
          },
          {
            id: '10493',
            name: 'Pu Sam Cáp',
            prefix: 'Xã',
          },
          {
            id: '10494',
            name: 'Sà Dề Phìn',
            prefix: 'Xã',
          },
          {
            id: '10495',
            name: 'Sìn Hồ',
            prefix: 'Thị trấn',
          },
          {
            id: '10496',
            name: 'Tả Ngảo',
            prefix: 'Xã',
          },
          {
            id: '10497',
            name: 'Tả Phìn',
            prefix: 'Xã',
          },
          {
            id: '10498',
            name: 'Tủa Sín Chải',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '664',
        name: 'Tam Đường',
        wards: [
          {
            id: '10499',
            name: 'Bản Bo',
            prefix: 'Xã',
          },
          {
            id: '10500',
            name: 'Bản Giang',
            prefix: 'Xã',
          },
          {
            id: '10501',
            name: 'Bản Hon',
            prefix: 'Xã',
          },
          {
            id: '10502',
            name: 'Bình Lư',
            prefix: 'Xã',
          },
          {
            id: '10503',
            name: 'Giang Ma',
            prefix: 'Xã',
          },
          {
            id: '10504',
            name: 'Hồ Thầu',
            prefix: 'Xã',
          },
          {
            id: '10505',
            name: 'Khun Há',
            prefix: 'Xã',
          },
          {
            id: '10506',
            name: 'Nà Tăm',
            prefix: 'Xã',
          },
          {
            id: '10507',
            name: 'Nùng Nàng',
            prefix: 'Xã',
          },
          {
            id: '10508',
            name: 'Sơn Bình',
            prefix: 'Xã',
          },
          {
            id: '10509',
            name: 'Sùng Phài',
            prefix: 'Xã',
          },
          {
            id: '10510',
            name: 'Tả Lèng',
            prefix: 'Xã',
          },
          {
            id: '10511',
            name: 'Tam Đường',
            prefix: 'Thị trấn',
          },
          {
            id: '10512',
            name: 'Thèn Xin',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '665',
        name: 'Tân Uyên',
        wards: [
          {
            id: '10513',
            name: 'Hố Mít',
            prefix: 'Xã',
          },
          {
            id: '10514',
            name: 'Mường Khoa',
            prefix: 'Xã',
          },
          {
            id: '10515',
            name: 'Nậm Cần',
            prefix: 'Xã',
          },
          {
            id: '10516',
            name: 'Nậm Sỏ',
            prefix: 'Xã',
          },
          {
            id: '10517',
            name: 'Pắc Ta',
            prefix: 'Xã',
          },
          {
            id: '10518',
            name: 'Phúc Khoa',
            prefix: 'Xã',
          },
          {
            id: '10519',
            name: 'Tà Mít',
            prefix: 'Xã',
          },
          {
            id: '10520',
            name: 'Tân Uyên',
            prefix: 'Thị trấn',
          },
          {
            id: '10521',
            name: 'Thân Thuộc',
            prefix: 'Xã',
          },
          {
            id: '10522',
            name: 'Trung Đồng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '666',
        name: 'Than Uyên',
        wards: [
          {
            id: '10523',
            name: 'Hua Nà',
            prefix: 'Xã',
          },
          {
            id: '10524',
            name: 'Khoen On',
            prefix: 'Xã',
          },
          {
            id: '10525',
            name: 'Mường Cang',
            prefix: 'Xã',
          },
          {
            id: '10526',
            name: 'Mường Kim',
            prefix: 'Xã',
          },
          {
            id: '10527',
            name: 'Mường Mít',
            prefix: 'Xã',
          },
          {
            id: '10528',
            name: 'Mường Than',
            prefix: 'Xã',
          },
          {
            id: '10529',
            name: 'Pha Mu',
            prefix: 'Xã',
          },
          {
            id: '10530',
            name: 'Phúc Than',
            prefix: 'Xã',
          },
          {
            id: '10531',
            name: 'Ta Gia',
            prefix: 'Xã',
          },
          {
            id: '10532',
            name: 'Tà Hừa',
            prefix: 'Xã',
          },
          {
            id: '10533',
            name: 'Tà Mung',
            prefix: 'Xã',
          },
          {
            id: '10534',
            name: 'Than Uyên',
            prefix: 'Thị trấn',
          },
        ],
      },
    ],
  },
  {
    id: '60',
    code: 'LS',
    name: 'Lạng Sơn',
    districts: [
      {
        id: '667',
        name: 'Bắc Sơn',
        wards: [
          {
            id: '10535',
            name: 'Bắc Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '10536',
            name: 'Bắc Sơn',
            prefix: 'Xã',
          },
          {
            id: '10537',
            name: 'Chiến Thắng',
            prefix: 'Xã',
          },
          {
            id: '10538',
            name: 'Chiêu Vũ',
            prefix: 'Xã',
          },
          {
            id: '10539',
            name: 'Đồng Ý',
            prefix: 'Xã',
          },
          {
            id: '10540',
            name: 'Hưng Vũ',
            prefix: 'Xã',
          },
          {
            id: '10541',
            name: 'Hữu Vĩnh',
            prefix: 'Xã',
          },
          {
            id: '10542',
            name: 'Long Đống',
            prefix: 'Xã',
          },
          {
            id: '10543',
            name: 'Nhất Hòa',
            prefix: 'Xã',
          },
          {
            id: '10544',
            name: 'Nhất Tiến',
            prefix: 'Xã',
          },
          {
            id: '10545',
            name: 'Quỳnh Sơn',
            prefix: 'Xã',
          },
          {
            id: '10546',
            name: 'Tân Hương',
            prefix: 'Xã',
          },
          {
            id: '10547',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '10548',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '10549',
            name: 'Tân Tri',
            prefix: 'Xã',
          },
          {
            id: '10550',
            name: 'Trấn Yên',
            prefix: 'Xã',
          },
          {
            id: '10551',
            name: 'Vạn Thủy',
            prefix: 'Xã',
          },
          {
            id: '10552',
            name: 'Vũ Lăng',
            prefix: 'Xã',
          },
          {
            id: '10553',
            name: 'Vũ Lễ',
            prefix: 'Xã',
          },
          {
            id: '10554',
            name: 'Vũ Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '668',
        name: 'Bình Gia',
        wards: [
          {
            id: '10555',
            name: 'Bình Gia',
            prefix: 'Thị trấn',
          },
          {
            id: '10556',
            name: 'Bình La',
            prefix: 'Xã',
          },
          {
            id: '10557',
            name: 'Hòa Bình',
            prefix: 'Xã',
          },
          {
            id: '10558',
            name: 'Hoa Thám',
            prefix: 'Xã',
          },
          {
            id: '10559',
            name: 'Hoàng Văn Thụ',
            prefix: 'Xã',
          },
          {
            id: '10560',
            name: 'Hồng Phong',
            prefix: 'Xã',
          },
          {
            id: '10561',
            name: 'Hồng Thái',
            prefix: 'Xã',
          },
          {
            id: '10562',
            name: 'Hưng Đạo',
            prefix: 'Xã',
          },
          {
            id: '10563',
            name: 'Minh Khai',
            prefix: 'Xã',
          },
          {
            id: '10564',
            name: 'Mông Ân',
            prefix: 'Xã',
          },
          {
            id: '10565',
            name: 'Quang Trung',
            prefix: 'Xã',
          },
          {
            id: '10566',
            name: 'Quý Hòa',
            prefix: 'Xã',
          },
          {
            id: '10567',
            name: 'Tân Hòa',
            prefix: 'Xã',
          },
          {
            id: '10568',
            name: 'Tân Văn',
            prefix: 'Xã',
          },
          {
            id: '10569',
            name: 'Thiện Hòa',
            prefix: 'Xã',
          },
          {
            id: '10570',
            name: 'Thiện Long',
            prefix: 'Xã',
          },
          {
            id: '10571',
            name: 'Thiện Thuật',
            prefix: 'Xã',
          },
          {
            id: '10572',
            name: 'Tô Hiệu',
            prefix: 'Xã',
          },
          {
            id: '10573',
            name: 'Vĩnh Yên',
            prefix: 'Xã',
          },
          {
            id: '10574',
            name: 'Yên Lỗ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '669',
        name: 'Cao Lộc',
        wards: [
          {
            id: '10575',
            name: 'Bảo Lâm',
            prefix: 'Xã',
          },
          {
            id: '10576',
            name: 'Bình Trung',
            prefix: 'Xã',
          },
          {
            id: '10577',
            name: 'Cao Lâu',
            prefix: 'Xã',
          },
          {
            id: '10578',
            name: 'Cao Lộc',
            prefix: 'Thị trấn',
          },
          {
            id: '10579',
            name: 'Cống Sơn',
            prefix: 'Xã',
          },
          {
            id: '10580',
            name: 'Đồng Đăng',
            prefix: 'Thị trấn',
          },
          {
            id: '10581',
            name: 'Gia Cát',
            prefix: 'Xã',
          },
          {
            id: '10582',
            name: 'Hải Yến',
            prefix: 'Xã',
          },
          {
            id: '10583',
            name: 'Hòa Cư',
            prefix: 'Xã',
          },
          {
            id: '10584',
            name: 'Hồng Phong',
            prefix: 'Xã',
          },
          {
            id: '10585',
            name: 'Hợp Thành',
            prefix: 'Xã',
          },
          {
            id: '10586',
            name: 'Lộc Yên',
            prefix: 'Xã',
          },
          {
            id: '10587',
            name: 'Mẫu Sơn',
            prefix: 'Xã',
          },
          {
            id: '10588',
            name: 'Phú Xá',
            prefix: 'Xã',
          },
          {
            id: '10589',
            name: 'Song Giáp',
            prefix: 'Xã',
          },
          {
            id: '10590',
            name: 'Tân Liên',
            prefix: 'Xã',
          },
          {
            id: '10591',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '10592',
            name: 'Thạch Đạn',
            prefix: 'Xã',
          },
          {
            id: '10593',
            name: 'Thanh Lòa',
            prefix: 'Xã',
          },
          {
            id: '10594',
            name: 'Thụy Hùng',
            prefix: 'Xã',
          },
          {
            id: '10595',
            name: 'Xuân Long',
            prefix: 'Xã',
          },
          {
            id: '10596',
            name: 'Xuất Lễ',
            prefix: 'Xã',
          },
          {
            id: '10597',
            name: 'Yên Trạch',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '670',
        name: 'Chi Lăng',
        wards: [
          {
            id: '10598',
            name: 'Bắc Thủy',
            prefix: 'Xã',
          },
          {
            id: '10599',
            name: 'Bằng Hữu',
            prefix: 'Xã',
          },
          {
            id: '10600',
            name: 'Bằng Mạc',
            prefix: 'Xã',
          },
          {
            id: '10601',
            name: 'Chi Lăng',
            prefix: 'Thị trấn',
          },
          {
            id: '10602',
            name: 'Chi Lăng',
            prefix: 'Xã',
          },
          {
            id: '10603',
            name: 'Chiến Thắng',
            prefix: 'Xã',
          },
          {
            id: '10604',
            name: 'Đồng Mỏ',
            prefix: 'Thị trấn',
          },
          {
            id: '10605',
            name: 'Gia Lộc',
            prefix: 'Xã',
          },
          {
            id: '10606',
            name: 'Hòa Bình',
            prefix: 'Xã',
          },
          {
            id: '10607',
            name: 'Hồng Phong',
            prefix: 'Xã',
          },
          {
            id: '10608',
            name: 'Hữu Kiên',
            prefix: 'Xã',
          },
          {
            id: '10609',
            name: 'Lâm Sơn',
            prefix: 'Xã',
          },
          {
            id: '10610',
            name: 'Liên Sơn',
            prefix: 'Xã',
          },
          {
            id: '10611',
            name: 'Mai Sao',
            prefix: 'Xã',
          },
          {
            id: '10612',
            name: 'Nhân Lý',
            prefix: 'Xã',
          },
          {
            id: '10613',
            name: 'Quan Sơn',
            prefix: 'Xã',
          },
          {
            id: '10614',
            name: 'Quang Lang',
            prefix: 'Xã',
          },
          {
            id: '10615',
            name: 'Thượng Cường',
            prefix: 'Xã',
          },
          {
            id: '10616',
            name: 'Vân An',
            prefix: 'Xã',
          },
          {
            id: '10617',
            name: 'Vạn Linh',
            prefix: 'Xã',
          },
          {
            id: '10618',
            name: 'Vân Thủy',
            prefix: 'Xã',
          },
          {
            id: '10619',
            name: 'Y Tịch',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '671',
        name: 'Đình Lập',
        wards: [
          {
            id: '10620',
            name: 'Bắc Lãng',
            prefix: 'Xã',
          },
          {
            id: '10621',
            name: 'Bắc Xa',
            prefix: 'Xã',
          },
          {
            id: '10622',
            name: 'Bính Xá',
            prefix: 'Xã',
          },
          {
            id: '10623',
            name: 'Châu Sơn',
            prefix: 'Xã',
          },
          {
            id: '10624',
            name: 'Cường Lợi',
            prefix: 'Xã',
          },
          {
            id: '10625',
            name: 'Đình Lập',
            prefix: 'Xã',
          },
          {
            id: '10626',
            name: 'Đình Lập',
            prefix: 'Thị trấn',
          },
          {
            id: '10627',
            name: 'Đồng Thắng',
            prefix: 'Xã',
          },
          {
            id: '10628',
            name: 'Kiên Mộc',
            prefix: 'Xã',
          },
          {
            id: '10629',
            name: 'Lâm Ca',
            prefix: 'Xã',
          },
          {
            id: '10630',
            name: 'Nông trường Thái Bình',
            prefix: 'Xã',
          },
          {
            id: '10631',
            name: 'Thái Bình',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '672',
        name: 'Hữu Lũng',
        wards: [
          {
            id: '10632',
            name: 'Cai Kinh',
            prefix: 'Xã',
          },
          {
            id: '10633',
            name: 'Đô Lương',
            prefix: 'Xã',
          },
          {
            id: '10634',
            name: 'Đồng Tân',
            prefix: 'Xã',
          },
          {
            id: '10635',
            name: 'Đồng Tiến',
            prefix: 'Xã',
          },
          {
            id: '10636',
            name: 'Hồ Sơn',
            prefix: 'Xã',
          },
          {
            id: '10637',
            name: 'Hòa Bình',
            prefix: 'Xã',
          },
          {
            id: '10638',
            name: 'Hòa Lạc',
            prefix: 'Xã',
          },
          {
            id: '10639',
            name: 'Hòa Sơn',
            prefix: 'Xã',
          },
          {
            id: '10640',
            name: 'Hòa Thắng',
            prefix: 'Xã',
          },
          {
            id: '10641',
            name: 'Hữu Liên',
            prefix: 'Xã',
          },
          {
            id: '10642',
            name: 'Hữu Lũng',
            prefix: 'Thị trấn',
          },
          {
            id: '10643',
            name: 'Minh Hòa',
            prefix: 'Xã',
          },
          {
            id: '10644',
            name: 'Minh Sơn',
            prefix: 'Xã',
          },
          {
            id: '10645',
            name: 'Minh Tiến',
            prefix: 'Xã',
          },
          {
            id: '10646',
            name: 'Nhật Tiến',
            prefix: 'Xã',
          },
          {
            id: '10647',
            name: 'Quyết Thắng',
            prefix: 'Xã',
          },
          {
            id: '10648',
            name: 'Sơn Hà',
            prefix: 'Xã',
          },
          {
            id: '10649',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '10650',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '10651',
            name: 'Thanh Sơn',
            prefix: 'Xã',
          },
          {
            id: '10652',
            name: 'Thiện Ky',
            prefix: 'Xã',
          },
          {
            id: '10653',
            name: 'Vân Nham',
            prefix: 'Xã',
          },
          {
            id: '10654',
            name: 'Yên Bình',
            prefix: 'Xã',
          },
          {
            id: '10655',
            name: 'Yên Sơn',
            prefix: 'Xã',
          },
          {
            id: '10656',
            name: 'Yên Thịnh',
            prefix: 'Thị trấn',
          },
          {
            id: '10657',
            name: 'Yên Vượng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '673',
        name: 'Lạng Sơn',
        wards: [
          {
            id: '10658',
            name: 'Chi Lăng',
            prefix: 'Phường',
          },
          {
            id: '10659',
            name: 'Đông Kinh',
            prefix: 'Phường',
          },
          {
            id: '10660',
            name: 'Hoàng Đồng',
            prefix: 'Xã',
          },
          {
            id: '10661',
            name: 'Hoàng Văn Thụ',
            prefix: 'Phường',
          },
          {
            id: '10662',
            name: 'Mai Pha',
            prefix: 'Xã',
          },
          {
            id: '10663',
            name: 'Nà Poong',
            prefix: 'Xã',
          },
          {
            id: '10664',
            name: 'Nà Thó',
            prefix: 'Xã',
          },
          {
            id: '10665',
            name: 'Pò Đứa',
            prefix: 'Xã',
          },
          {
            id: '10666',
            name: 'Quảng Lạc',
            prefix: 'Xã',
          },
          {
            id: '10667',
            name: 'Tam Thanh',
            prefix: 'Phường',
          },
          {
            id: '10668',
            name: 'Vĩnh Trại',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '674',
        name: 'Lộc Bình',
        wards: [
          {
            id: '10669',
            name: 'Ái Quốc',
            prefix: 'Xã',
          },
          {
            id: '10670',
            name: 'Bằng Khánh',
            prefix: 'Xã',
          },
          {
            id: '10671',
            name: 'Đồng Bục',
            prefix: 'Xã',
          },
          {
            id: '10672',
            name: 'Đông Quan',
            prefix: 'Xã',
          },
          {
            id: '10673',
            name: 'Hiệp Hạ',
            prefix: 'Xã',
          },
          {
            id: '10674',
            name: 'Hữu Khánh',
            prefix: 'Xã',
          },
          {
            id: '10675',
            name: 'Hữu Lân',
            prefix: 'Xã',
          },
          {
            id: '10676',
            name: 'Khuất Xá',
            prefix: 'Xã',
          },
          {
            id: '10677',
            name: 'Lộc Bình',
            prefix: 'Thị trấn',
          },
          {
            id: '10678',
            name: 'Lợi Bác',
            prefix: 'Xã',
          },
          {
            id: '10679',
            name: 'Lục Thôn',
            prefix: 'Xã',
          },
          {
            id: '10680',
            name: 'Mẫu Sơn',
            prefix: 'Xã',
          },
          {
            id: '10681',
            name: 'Minh Phát',
            prefix: 'Xã',
          },
          {
            id: '10682',
            name: 'Na Dương',
            prefix: 'Thị trấn',
          },
          {
            id: '10683',
            name: 'Nam Quan',
            prefix: 'Xã',
          },
          {
            id: '10684',
            name: 'Như Khuê',
            prefix: 'Xã',
          },
          {
            id: '10685',
            name: 'Nhượng Bạn',
            prefix: 'Xã',
          },
          {
            id: '10686',
            name: 'Quan Bản',
            prefix: 'Xã',
          },
          {
            id: '10687',
            name: 'Sàn Viên',
            prefix: 'Xã',
          },
          {
            id: '10688',
            name: 'Tam Gia',
            prefix: 'Xã',
          },
          {
            id: '10689',
            name: 'Tĩnh Bắc',
            prefix: 'Xã',
          },
          {
            id: '10690',
            name: 'Tú Đoạn',
            prefix: 'Xã',
          },
          {
            id: '10691',
            name: 'Tú Mịch',
            prefix: 'Xã',
          },
          {
            id: '10692',
            name: 'Vân Mộng',
            prefix: 'Xã',
          },
          {
            id: '10693',
            name: 'Xuân Dương',
            prefix: 'Xã',
          },
          {
            id: '10694',
            name: 'Xuân Lễ',
            prefix: 'Xã',
          },
          {
            id: '10695',
            name: 'Xuân Mãn',
            prefix: 'Xã',
          },
          {
            id: '10696',
            name: 'Xuân Tình',
            prefix: 'Xã',
          },
          {
            id: '10697',
            name: 'Yên Khoái',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '675',
        name: 'Tràng Định',
        wards: [
          {
            id: '10698',
            name: 'Bắc Ái',
            prefix: 'Xã',
          },
          {
            id: '10699',
            name: 'Cao Minh',
            prefix: 'Xã',
          },
          {
            id: '10700',
            name: 'Chi Lăng',
            prefix: 'Xã',
          },
          {
            id: '10701',
            name: 'Chí Minh',
            prefix: 'Xã',
          },
          {
            id: '10702',
            name: 'Đại Đồng',
            prefix: 'Xã',
          },
          {
            id: '10703',
            name: 'Đào Viên',
            prefix: 'Xã',
          },
          {
            id: '10704',
            name: 'Đề Thám',
            prefix: 'Xã',
          },
          {
            id: '10705',
            name: 'Đoàn Kết',
            prefix: 'Xã',
          },
          {
            id: '10706',
            name: 'Đội Cấn',
            prefix: 'Xã',
          },
          {
            id: '10707',
            name: 'Hùng Sơn',
            prefix: 'Xã',
          },
          {
            id: '10708',
            name: 'Hùng Việt',
            prefix: 'Xã',
          },
          {
            id: '10709',
            name: 'Kháng Chiến',
            prefix: 'Xã',
          },
          {
            id: '10710',
            name: 'Khánh Long',
            prefix: 'Xã',
          },
          {
            id: '10711',
            name: 'Kim Đồng',
            prefix: 'Xã',
          },
          {
            id: '10712',
            name: 'Quốc Khánh',
            prefix: 'Xã',
          },
          {
            id: '10713',
            name: 'Quốc Việt',
            prefix: 'Xã',
          },
          {
            id: '10714',
            name: 'Tân Minh',
            prefix: 'Xã',
          },
          {
            id: '10715',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '10716',
            name: 'Tân Yên',
            prefix: 'Xã',
          },
          {
            id: '10717',
            name: 'Thất Khê',
            prefix: 'Thị trấn',
          },
          {
            id: '10718',
            name: 'Tri Phương',
            prefix: 'Xã',
          },
          {
            id: '10719',
            name: 'Trung Thành',
            prefix: 'Xã',
          },
          {
            id: '10720',
            name: 'Vĩnh Tiến',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '676',
        name: 'Văn Lãng',
        wards: [
          {
            id: '10721',
            name: 'An Hùng',
            prefix: 'Xã',
          },
          {
            id: '10722',
            name: 'Bắc La',
            prefix: 'Xã',
          },
          {
            id: '10723',
            name: 'Gia Miễn',
            prefix: 'Xã',
          },
          {
            id: '10724',
            name: 'Hoàng Văn Thụ',
            prefix: 'Xã',
          },
          {
            id: '10725',
            name: 'Hoàng Việt',
            prefix: 'Xã',
          },
          {
            id: '10726',
            name: 'Hội Hoan',
            prefix: 'Xã',
          },
          {
            id: '10727',
            name: 'Hồng Thái',
            prefix: 'Xã',
          },
          {
            id: '10728',
            name: 'Na Sầm',
            prefix: 'Thị trấn',
          },
          {
            id: '10729',
            name: 'Nam La',
            prefix: 'Xã',
          },
          {
            id: '10730',
            name: 'Nhạc Kỳ',
            prefix: 'Xã',
          },
          {
            id: '10731',
            name: 'Tân Lang',
            prefix: 'Xã',
          },
          {
            id: '10732',
            name: 'Tân Mỹ',
            prefix: 'Xã',
          },
          {
            id: '10733',
            name: 'Tân Tác',
            prefix: 'Xã',
          },
          {
            id: '10734',
            name: 'Tân Thanh',
            prefix: 'Xã',
          },
          {
            id: '10735',
            name: 'Tân Việt',
            prefix: 'Xã',
          },
          {
            id: '10736',
            name: 'Thành Hoà',
            prefix: 'Xã',
          },
          {
            id: '10737',
            name: 'Thanh Long',
            prefix: 'Xã',
          },
          {
            id: '10738',
            name: 'Thuỵ Hùng',
            prefix: 'Xã',
          },
          {
            id: '10739',
            name: 'Trùng Khánh',
            prefix: 'Xã',
          },
          {
            id: '10740',
            name: 'Trùng Quán',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '677',
        name: 'Văn Quan',
        wards: [
          {
            id: '10741',
            name: 'Bình Phúc',
            prefix: 'Xã',
          },
          {
            id: '10742',
            name: 'Chu Túc',
            prefix: 'Xã',
          },
          {
            id: '10743',
            name: 'Đại An',
            prefix: 'Xã',
          },
          {
            id: '10744',
            name: 'Đồng Giáp',
            prefix: 'Xã',
          },
          {
            id: '10745',
            name: 'Gia Miễn',
            prefix: 'Xã',
          },
          {
            id: '10746',
            name: 'Hòa Bình',
            prefix: 'Xã',
          },
          {
            id: '10747',
            name: 'Hoàng Văn Thụ',
            prefix: 'Xã',
          },
          {
            id: '10748',
            name: 'Hữu Lễ',
            prefix: 'Xã',
          },
          {
            id: '10749',
            name: 'Khánh Khê',
            prefix: 'Xã',
          },
          {
            id: '10750',
            name: 'Lương Năng',
            prefix: 'Xã',
          },
          {
            id: '10751',
            name: 'Phú Mỹ',
            prefix: 'Xã',
          },
          {
            id: '10752',
            name: 'Song Giang',
            prefix: 'Xã',
          },
          {
            id: '10753',
            name: 'Tân Đoàn',
            prefix: 'Xã',
          },
          {
            id: '10754',
            name: 'Tân Tác',
            prefix: 'Xã',
          },
          {
            id: '10755',
            name: 'Trấn Ninh',
            prefix: 'Xã',
          },
          {
            id: '10756',
            name: 'Tràng Các',
            prefix: 'Xã',
          },
          {
            id: '10757',
            name: 'Tràng Phái',
            prefix: 'Xã',
          },
          {
            id: '10758',
            name: 'Tràng Sơn',
            prefix: 'Xã',
          },
          {
            id: '10759',
            name: 'Tri Lễ',
            prefix: 'Xã',
          },
          {
            id: '10760',
            name: 'Tú Xuyên',
            prefix: 'Xã',
          },
          {
            id: '10761',
            name: 'Văn An',
            prefix: 'Xã',
          },
          {
            id: '10762',
            name: 'Vân Mộng',
            prefix: 'Xã',
          },
          {
            id: '10763',
            name: 'Văn Quan',
            prefix: 'Thị trấn',
          },
          {
            id: '10764',
            name: 'Việt Yên',
            prefix: 'Xã',
          },
          {
            id: '10765',
            name: 'Vĩnh Lai',
            prefix: 'Xã',
          },
          {
            id: '10766',
            name: 'Xuân Mai',
            prefix: 'Xã',
          },
          {
            id: '10767',
            name: 'Yên Phúc',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '61',
    code: 'HG',
    name: 'Hà Giang',
    districts: [
      {
        id: '678',
        name: 'Bắc Mê',
        wards: [
          {
            id: '10768',
            name: 'Đường Âm',
            prefix: 'Xã',
          },
          {
            id: '10769',
            name: 'Đường Hồng',
            prefix: 'Xã',
          },
          {
            id: '10770',
            name: 'Giáp Trung',
            prefix: 'Xã',
          },
          {
            id: '10771',
            name: 'Lạc Nông',
            prefix: 'Xã',
          },
          {
            id: '10772',
            name: 'Minh Ngọc',
            prefix: 'Xã',
          },
          {
            id: '10773',
            name: 'Minh Sơn',
            prefix: 'Xã',
          },
          {
            id: '10774',
            name: 'Phiêng Luông',
            prefix: 'Xã',
          },
          {
            id: '10775',
            name: 'Phú Nam',
            prefix: 'Xã',
          },
          {
            id: '10776',
            name: 'Thượng Tân',
            prefix: 'Xã',
          },
          {
            id: '10777',
            name: 'Yên Cường',
            prefix: 'Xã',
          },
          {
            id: '10778',
            name: 'Yên Định',
            prefix: 'Xã',
          },
          {
            id: '10779',
            name: 'Yên Phong',
            prefix: 'Xã',
          },
          {
            id: '10780',
            name: 'Yên Phú',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '679',
        name: 'Bắc Quang',
        wards: [
          {
            id: '10781',
            name: 'Bằng Hành',
            prefix: 'Xã',
          },
          {
            id: '10782',
            name: 'Đồng Tâm',
            prefix: 'Xã',
          },
          {
            id: '10783',
            name: 'Đông Thành',
            prefix: 'Xã',
          },
          {
            id: '10784',
            name: 'Đồng Tiến',
            prefix: 'Xã',
          },
          {
            id: '10785',
            name: 'Đồng Yên',
            prefix: 'Xã',
          },
          {
            id: '10786',
            name: 'Đức Xuân',
            prefix: 'Xã',
          },
          {
            id: '10787',
            name: 'Hùng An',
            prefix: 'Xã',
          },
          {
            id: '10788',
            name: 'Hữu Sản',
            prefix: 'Xã',
          },
          {
            id: '10789',
            name: 'Kim Ngọc',
            prefix: 'Xã',
          },
          {
            id: '10790',
            name: 'Liên Hiệp',
            prefix: 'Xã',
          },
          {
            id: '10791',
            name: 'Quang Minh',
            prefix: 'Xã',
          },
          {
            id: '10792',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '10793',
            name: 'Tân Quang',
            prefix: 'Xã',
          },
          {
            id: '10794',
            name: 'Tân Thành',
            prefix: 'Xã',
          },
          {
            id: '10795',
            name: 'Thượng Bình',
            prefix: 'Xã',
          },
          {
            id: '10796',
            name: 'Tiên Kiều',
            prefix: 'Xã',
          },
          {
            id: '10797',
            name: 'Việt Hồng',
            prefix: 'Xã',
          },
          {
            id: '10798',
            name: 'Việt Quang',
            prefix: 'Thị trấn',
          },
          {
            id: '10799',
            name: 'Việt Vinh',
            prefix: 'Xã',
          },
          {
            id: '10800',
            name: 'Vĩnh Hảo',
            prefix: 'Xã',
          },
          {
            id: '10801',
            name: 'Vĩnh Phúc',
            prefix: 'Xã',
          },
          {
            id: '10802',
            name: 'Vĩnh Tuy',
            prefix: 'Thị trấn',
          },
          {
            id: '10803',
            name: 'Vô Điếm',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '680',
        name: 'Đồng Văn',
        wards: [
          {
            id: '10804',
            name: 'Đồng Văn',
            prefix: 'Thị trấn',
          },
          {
            id: '10805',
            name: 'Hố Quáng Phìn',
            prefix: 'Xã',
          },
          {
            id: '10806',
            name: 'Lũng Cú',
            prefix: 'Xã',
          },
          {
            id: '10807',
            name: 'Lũng Phìn',
            prefix: 'Xã',
          },
          {
            id: '10808',
            name: 'Lũng Táo',
            prefix: 'Xã',
          },
          {
            id: '10809',
            name: 'Lũng Thầu',
            prefix: 'Xã',
          },
          {
            id: '10810',
            name: 'Má Lé',
            prefix: 'Xã',
          },
          {
            id: '10811',
            name: 'Phó Bảng',
            prefix: 'Thị trấn',
          },
          {
            id: '10812',
            name: 'Phố Cáo',
            prefix: 'Xã',
          },
          {
            id: '10813',
            name: 'Phố Là',
            prefix: 'Xã',
          },
          {
            id: '10814',
            name: 'Sà Phìn',
            prefix: 'Xã',
          },
          {
            id: '10815',
            name: 'Sảng Tủng',
            prefix: 'Xã',
          },
          {
            id: '10816',
            name: 'Sính Lủng',
            prefix: 'Xã',
          },
          {
            id: '10817',
            name: 'Sủng Là',
            prefix: 'Xã',
          },
          {
            id: '10818',
            name: 'Sủng Trái',
            prefix: 'Xã',
          },
          {
            id: '10819',
            name: 'Tả Lủng',
            prefix: 'Xã',
          },
          {
            id: '10820',
            name: 'Tả Phìn',
            prefix: 'Xã',
          },
          {
            id: '10821',
            name: 'Thài Phìn Tủng',
            prefix: 'Xã',
          },
          {
            id: '10822',
            name: 'Vần Chải',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '681',
        name: 'Hà Giang',
        wards: [
          {
            id: '10823',
            name: 'Minh Khai',
            prefix: 'Phường',
          },
          {
            id: '10824',
            name: 'Ngọc Đường',
            prefix: 'Xã',
          },
          {
            id: '10825',
            name: 'Ngọc Hà',
            prefix: 'Phường',
          },
          {
            id: '10826',
            name: 'Nguyễn Trãi',
            prefix: 'Phường',
          },
          {
            id: '10827',
            name: 'Phương Độ',
            prefix: 'Xã',
          },
          {
            id: '10828',
            name: 'Phương Thiện',
            prefix: 'Xã',
          },
          {
            id: '10829',
            name: 'Quang Trung',
            prefix: 'Phường',
          },
          {
            id: '10830',
            name: 'Trần Phú',
            prefix: 'Phường',
          },
        ],
      },
      {
        id: '682',
        name: 'Hoàng Su Phì',
        wards: [
          {
            id: '10831',
            name: 'Bản Luốc',
            prefix: 'Xã',
          },
          {
            id: '10832',
            name: 'Bản Máy',
            prefix: 'Xã',
          },
          {
            id: '10833',
            name: 'Bản Nhùng',
            prefix: 'Xã',
          },
          {
            id: '10834',
            name: 'Bản Péo',
            prefix: 'Xã',
          },
          {
            id: '10835',
            name: 'Bản Phùng',
            prefix: 'Xã',
          },
          {
            id: '10836',
            name: 'Chiến Phố',
            prefix: 'Xã',
          },
          {
            id: '10837',
            name: 'Đản Ván',
            prefix: 'Xã',
          },
          {
            id: '10838',
            name: 'Hồ Thầu',
            prefix: 'Xã',
          },
          {
            id: '10839',
            name: 'Nậm Dịch',
            prefix: 'Xã',
          },
          {
            id: '10840',
            name: 'Nậm Khòa',
            prefix: 'Xã',
          },
          {
            id: '10841',
            name: 'Nam Sơn',
            prefix: 'Xã',
          },
          {
            id: '10842',
            name: 'Nậm Ty',
            prefix: 'Xã',
          },
          {
            id: '10843',
            name: 'Nàng Đôn',
            prefix: 'Xã',
          },
          {
            id: '10844',
            name: 'Ngàm Đăng Vài',
            prefix: 'Xã',
          },
          {
            id: '10845',
            name: 'Pố Lồ',
            prefix: 'Xã',
          },
          {
            id: '10846',
            name: 'Pờ Ly Ngài',
            prefix: 'Xã',
          },
          {
            id: '10847',
            name: 'Sán Xả Hồ',
            prefix: 'Xã',
          },
          {
            id: '10848',
            name: 'Tả Sử Choóng',
            prefix: 'Xã',
          },
          {
            id: '10849',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '10850',
            name: 'Thàng Tín',
            prefix: 'Xã',
          },
          {
            id: '10851',
            name: 'Thèn Chu Phìn',
            prefix: 'Xã',
          },
          {
            id: '10852',
            name: 'Thông Nguyên',
            prefix: 'Xã',
          },
          {
            id: '10853',
            name: 'Tụ Nhân',
            prefix: 'Xã',
          },
          {
            id: '10854',
            name: 'Túng Sán',
            prefix: 'Xã',
          },
          {
            id: '10855',
            name: 'Vinh Quang',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '683',
        name: 'Mèo Vạc',
        wards: [
          {
            id: '10856',
            name: 'Cán Chu Phìn',
            prefix: 'Xã',
          },
          {
            id: '10857',
            name: 'Giàng Chu Phìn',
            prefix: 'Xã',
          },
          {
            id: '10858',
            name: 'Khâu Vai',
            prefix: 'Xã',
          },
          {
            id: '10859',
            name: 'Lũng Chinh',
            prefix: 'Xã',
          },
          {
            id: '10860',
            name: 'Lũng Pù',
            prefix: 'Xã',
          },
          {
            id: '10861',
            name: 'Mèo Vạc',
            prefix: 'Thị trấn',
          },
          {
            id: '10862',
            name: 'Nậm Ban',
            prefix: 'Xã',
          },
          {
            id: '10863',
            name: 'Niêm Sơn',
            prefix: 'Xã',
          },
          {
            id: '10864',
            name: 'Niêm Tòng',
            prefix: 'Xã',
          },
          {
            id: '10865',
            name: 'Pả Vi',
            prefix: 'Xã',
          },
          {
            id: '10866',
            name: 'Pải Lủng',
            prefix: 'Xã',
          },
          {
            id: '10867',
            name: 'Sơn Vĩ',
            prefix: 'Xã',
          },
          {
            id: '10868',
            name: 'Sủng Máng',
            prefix: 'Xã',
          },
          {
            id: '10869',
            name: 'Sủng Trà',
            prefix: 'Xã',
          },
          {
            id: '10870',
            name: 'Tả Lủng',
            prefix: 'Xã',
          },
          {
            id: '10871',
            name: 'Tát Ngà',
            prefix: 'Xã',
          },
          {
            id: '10872',
            name: 'Thượng Phùng',
            prefix: 'Xã',
          },
          {
            id: '10873',
            name: 'Xín Cái',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '684',
        name: 'Quản Bạ',
        wards: [
          {
            id: '10874',
            name: 'Bát Đại Sơn',
            prefix: 'Xã',
          },
          {
            id: '10875',
            name: 'Cán Tỷ',
            prefix: 'Xã',
          },
          {
            id: '10876',
            name: 'Cao Mã Pờ',
            prefix: 'Xã',
          },
          {
            id: '10877',
            name: 'Đông Hà',
            prefix: 'Xã',
          },
          {
            id: '10878',
            name: 'Lùng Tám',
            prefix: 'Xã',
          },
          {
            id: '10879',
            name: 'Nghĩa Thuận',
            prefix: 'Xã',
          },
          {
            id: '10880',
            name: 'Quản Bạ',
            prefix: 'Xã',
          },
          {
            id: '10881',
            name: 'Quyết Tiến',
            prefix: 'Xã',
          },
          {
            id: '10882',
            name: 'Tả Ván',
            prefix: 'Xã',
          },
          {
            id: '10883',
            name: 'Tam Sơn',
            prefix: 'Thị trấn',
          },
          {
            id: '10884',
            name: 'Thái An',
            prefix: 'Xã',
          },
          {
            id: '10885',
            name: 'Thanh Vân',
            prefix: 'Xã',
          },
          {
            id: '10886',
            name: 'Tùng Vài',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '685',
        name: 'Quang Bình',
        wards: [
          {
            id: '10887',
            name: 'Bản Rịa',
            prefix: 'Xã',
          },
          {
            id: '10888',
            name: 'Bằng Lang',
            prefix: 'Xã',
          },
          {
            id: '10889',
            name: 'Hương Sơn',
            prefix: 'Xã',
          },
          {
            id: '10890',
            name: 'Nà Khương',
            prefix: 'Xã',
          },
          {
            id: '10891',
            name: 'Tân Bắc',
            prefix: 'Xã',
          },
          {
            id: '10892',
            name: 'Tân Nam',
            prefix: 'Xã',
          },
          {
            id: '10893',
            name: 'Tân Trịnh',
            prefix: 'Xã',
          },
          {
            id: '10894',
            name: 'Tiên Nguyên',
            prefix: 'Xã',
          },
          {
            id: '10895',
            name: 'Tiên Yên',
            prefix: 'Xã',
          },
          {
            id: '10896',
            name: 'Vĩ Thượng',
            prefix: 'Xã',
          },
          {
            id: '10897',
            name: 'Xuân Giang',
            prefix: 'Xã',
          },
          {
            id: '10898',
            name: 'Xuân Minh',
            prefix: 'Xã',
          },
          {
            id: '10899',
            name: 'Yên Bình',
            prefix: 'Thị trấn',
          },
          {
            id: '10900',
            name: 'Yên Hà',
            prefix: 'Xã',
          },
          {
            id: '10901',
            name: 'Yên Thành',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '686',
        name: 'Vị Xuyên',
        wards: [
          {
            id: '10902',
            name: 'Bạch Ngọc',
            prefix: 'Xã',
          },
          {
            id: '10903',
            name: 'Cao Bồ',
            prefix: 'Xã',
          },
          {
            id: '10904',
            name: 'Đạo Đức',
            prefix: 'Xã',
          },
          {
            id: '10905',
            name: 'Kim Linh',
            prefix: 'Xã',
          },
          {
            id: '10906',
            name: 'Kim Thạch',
            prefix: 'Xã',
          },
          {
            id: '10907',
            name: 'Lao Chải',
            prefix: 'Xã',
          },
          {
            id: '10908',
            name: 'Linh Hồ',
            prefix: 'Xã',
          },
          {
            id: '10909',
            name: 'Minh Tân',
            prefix: 'Xã',
          },
          {
            id: '10910',
            name: 'Ngọc Linh',
            prefix: 'Xã',
          },
          {
            id: '10911',
            name: 'Ngọc Minh',
            prefix: 'Xã',
          },
          {
            id: '10912',
            name: 'Nông trường Việt Lâm',
            prefix: 'Thị trấn',
          },
          {
            id: '10913',
            name: 'Phong Quang',
            prefix: 'Xã',
          },
          {
            id: '10914',
            name: 'Phú Linh',
            prefix: 'Xã',
          },
          {
            id: '10915',
            name: 'Phương Tiến',
            prefix: 'Xã',
          },
          {
            id: '10916',
            name: 'Quảng Ngần',
            prefix: 'Xã',
          },
          {
            id: '10917',
            name: 'Thanh Đức',
            prefix: 'Xã',
          },
          {
            id: '10918',
            name: 'Thanh Thủy',
            prefix: 'Xã',
          },
          {
            id: '10919',
            name: 'Thuận Hòa',
            prefix: 'Xã',
          },
          {
            id: '10920',
            name: 'Thượng Sơn',
            prefix: 'Xã',
          },
          {
            id: '10921',
            name: 'Trung Thành',
            prefix: 'Xã',
          },
          {
            id: '10922',
            name: 'Tùng Bá',
            prefix: 'Xã',
          },
          {
            id: '10923',
            name: 'Vị Xuyên',
            prefix: 'Thị trấn',
          },
          {
            id: '10924',
            name: 'Việt Lâm',
            prefix: 'Xã',
          },
          {
            id: '10925',
            name: 'Xín Chải',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '687',
        name: 'Xín Mần',
        wards: [
          {
            id: '10926',
            name: 'Bản Díu',
            prefix: 'Xã',
          },
          {
            id: '10927',
            name: 'Bản Ngò',
            prefix: 'Xã',
          },
          {
            id: '10928',
            name: 'Chế Là',
            prefix: 'Xã',
          },
          {
            id: '10929',
            name: 'Chí Cà',
            prefix: 'Xã',
          },
          {
            id: '10930',
            name: 'Cốc Pài',
            prefix: 'Thị trấn',
          },
          {
            id: '10931',
            name: 'Cốc Rế',
            prefix: 'Xã',
          },
          {
            id: '10932',
            name: 'Khuôn Lùng',
            prefix: 'Xã',
          },
          {
            id: '10933',
            name: 'Nà Chì',
            prefix: 'Xã',
          },
          {
            id: '10934',
            name: 'Nấm Dẩn',
            prefix: 'Xã',
          },
          {
            id: '10935',
            name: 'Nàn Ma',
            prefix: 'Xã',
          },
          {
            id: '10936',
            name: 'Nàn Xỉn',
            prefix: 'Xã',
          },
          {
            id: '10937',
            name: 'Ngán Chiên',
            prefix: 'Xã',
          },
          {
            id: '10938',
            name: 'Pà Vầy Sủ',
            prefix: 'Xã',
          },
          {
            id: '10939',
            name: 'Quảng Nguyên',
            prefix: 'Xã',
          },
          {
            id: '10940',
            name: 'Tả Nhìu',
            prefix: 'Xã',
          },
          {
            id: '10941',
            name: 'Thèn Phàng',
            prefix: 'Xã',
          },
          {
            id: '10942',
            name: 'Thu Tà',
            prefix: 'Xã',
          },
          {
            id: '10943',
            name: 'Trung Thịnh',
            prefix: 'Xã',
          },
          {
            id: '10944',
            name: 'Xín Mần',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '688',
        name: 'Yên Minh',
        wards: [
          {
            id: '10945',
            name: 'Bạch Đích',
            prefix: 'Xã',
          },
          {
            id: '10947',
            name: 'Du Già',
            prefix: 'Xã',
          },
          {
            id: '10948',
            name: 'Du Tiến',
            prefix: 'Xã',
          },
          {
            id: '10946',
            name: 'Đông Minh',
            prefix: 'Xã',
          },
          {
            id: '10949',
            name: 'Đường Thượng',
            prefix: 'Xã',
          },
          {
            id: '10950',
            name: 'Hữu Vinh',
            prefix: 'Xã',
          },
          {
            id: '10951',
            name: 'Lao Và Chải',
            prefix: 'Xã',
          },
          {
            id: '10952',
            name: 'Lũng Hồ',
            prefix: 'Xã',
          },
          {
            id: '10953',
            name: 'Mậu Duệ',
            prefix: 'Xã',
          },
          {
            id: '10954',
            name: 'Mậu Long',
            prefix: 'Xã',
          },
          {
            id: '10955',
            name: 'Na Khê',
            prefix: 'Xã',
          },
          {
            id: '10956',
            name: 'Ngam La',
            prefix: 'Xã',
          },
          {
            id: '10957',
            name: 'Ngọc Long',
            prefix: 'Xã',
          },
          {
            id: '10958',
            name: 'Phú Lũng',
            prefix: 'Xã',
          },
          {
            id: '10959',
            name: 'Sủng Thài',
            prefix: 'Xã',
          },
          {
            id: '10960',
            name: 'Sủng Tráng',
            prefix: 'Xã',
          },
          {
            id: '10961',
            name: 'Thắng Mố',
            prefix: 'Xã',
          },
          {
            id: '10962',
            name: 'Yên Minh',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '62',
    code: 'BK',
    name: 'Bắc Kạn',
    districts: [
      {
        id: '689',
        name: 'Ba Bể',
        wards: [
          {
            id: '10963',
            name: 'Bành Trạch',
            prefix: 'Xã',
          },
          {
            id: '10964',
            name: 'Cao Thượng',
            prefix: 'Xã',
          },
          {
            id: '10965',
            name: 'Cao Trĩ',
            prefix: 'Xã',
          },
          {
            id: '10966',
            name: 'Chợ Rã',
            prefix: 'Thị trấn',
          },
          {
            id: '10967',
            name: 'Chu Hương',
            prefix: 'Xã',
          },
          {
            id: '10968',
            name: 'Địa Linh',
            prefix: 'Xã',
          },
          {
            id: '10969',
            name: 'Đồng Phúc',
            prefix: 'Xã',
          },
          {
            id: '10970',
            name: 'Hà Hiệu',
            prefix: 'Xã',
          },
          {
            id: '10971',
            name: 'Hoàng Trĩ',
            prefix: 'Xã',
          },
          {
            id: '10972',
            name: 'Khang Ninh',
            prefix: 'Xã',
          },
          {
            id: '10973',
            name: 'Mỹ Phương',
            prefix: 'Xã',
          },
          {
            id: '10974',
            name: 'Nam Mẫu',
            prefix: 'Xã',
          },
          {
            id: '10975',
            name: 'Phúc Lộc',
            prefix: 'Xã',
          },
          {
            id: '10976',
            name: 'Quảng Khê',
            prefix: 'Xã',
          },
          {
            id: '10977',
            name: 'Thượng Giáo',
            prefix: 'Xã',
          },
          {
            id: '10978',
            name: 'Yến Dương',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '690',
        name: 'Bắc Kạn',
        wards: [
          {
            id: '10979',
            name: 'Dư¬ơng Quang',
            prefix: 'Xã',
          },
          {
            id: '10980',
            name: 'Đức Xuân',
            prefix: 'Phường',
          },
          {
            id: '10981',
            name: 'Huyền Tụng',
            prefix: 'Xã',
          },
          {
            id: '10982',
            name: 'Nguyễn Thị Minh Khai',
            prefix: 'Phường',
          },
          {
            id: '10983',
            name: 'Nông Thượng',
            prefix: 'Xã',
          },
          {
            id: '10984',
            name: 'Phùng Chí Kiên',
            prefix: 'Phường',
          },
          {
            id: '10985',
            name: 'Sông Cầu',
            prefix: 'Phường',
          },
          {
            id: '10986',
            name: 'Xuất Hóa',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '691',
        name: 'Bạch Thông',
        wards: [
          {
            id: '10987',
            name: 'Cẩm Giàng',
            prefix: 'Xã',
          },
          {
            id: '10988',
            name: 'Cao Sơn',
            prefix: 'Xã',
          },
          {
            id: '10990',
            name: 'Dương Phong',
            prefix: 'Xã',
          },
          {
            id: '10989',
            name: 'Đôn Phong',
            prefix: 'Xã',
          },
          {
            id: '10991',
            name: 'Hà Vị',
            prefix: 'Xã',
          },
          {
            id: '10992',
            name: 'Lục Bình',
            prefix: 'Xã',
          },
          {
            id: '10993',
            name: 'Mỹ Thanh',
            prefix: 'Xã',
          },
          {
            id: '10994',
            name: 'Nguyên Phúc',
            prefix: 'Xã',
          },
          {
            id: '10995',
            name: 'Phủ Thông',
            prefix: 'Thị trấn',
          },
          {
            id: '10996',
            name: 'Phương Linh',
            prefix: 'Xã',
          },
          {
            id: '10997',
            name: 'Quân Bình',
            prefix: 'Xã',
          },
          {
            id: '10998',
            name: 'Quang Thuận',
            prefix: 'Xã',
          },
          {
            id: '10999',
            name: 'Sĩ Bình',
            prefix: 'Xã',
          },
          {
            id: '11000',
            name: 'Tân Tiến',
            prefix: 'Xã',
          },
          {
            id: '11001',
            name: 'Tú Trĩ',
            prefix: 'Xã',
          },
          {
            id: '11002',
            name: 'Vi Hương',
            prefix: 'Xã',
          },
          {
            id: '11003',
            name: 'Vũ Muộn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '692',
        name: 'Chợ Đồn',
        wards: [
          {
            id: '11004',
            name: 'Bản Thi',
            prefix: 'Xã',
          },
          {
            id: '11005',
            name: 'Bằng Lãng',
            prefix: 'Xã',
          },
          {
            id: '11006',
            name: 'Bằng Lũng',
            prefix: 'Thị trấn',
          },
          {
            id: '11007',
            name: 'Bằng Phúc',
            prefix: 'Xã',
          },
          {
            id: '11008',
            name: 'Bình Trung',
            prefix: 'Xã',
          },
          {
            id: '11009',
            name: 'Đại Sảo',
            prefix: 'Xã',
          },
          {
            id: '11010',
            name: 'Đồng Lạc',
            prefix: 'Xã',
          },
          {
            id: '11011',
            name: 'Đông Viên',
            prefix: 'Xã',
          },
          {
            id: '11012',
            name: 'Lương Bằng',
            prefix: 'Xã',
          },
          {
            id: '11013',
            name: 'Nam Cường',
            prefix: 'Xã',
          },
          {
            id: '11014',
            name: 'Nghĩa Tá',
            prefix: 'Xã',
          },
          {
            id: '11015',
            name: 'Ngọc Phái',
            prefix: 'Xã',
          },
          {
            id: '11016',
            name: 'Phong Huân',
            prefix: 'Xã',
          },
          {
            id: '11017',
            name: 'Phương Viên',
            prefix: 'Xã',
          },
          {
            id: '11018',
            name: 'Quảng Bạch',
            prefix: 'Xã',
          },
          {
            id: '11019',
            name: 'Rã Bản',
            prefix: 'Xã',
          },
          {
            id: '11020',
            name: 'Tân Lập',
            prefix: 'Xã',
          },
          {
            id: '11021',
            name: 'Xuân Lạc',
            prefix: 'Xã',
          },
          {
            id: '11022',
            name: 'Yên Mỹ',
            prefix: 'Xã',
          },
          {
            id: '11023',
            name: 'Yên Nhuận',
            prefix: 'Xã',
          },
          {
            id: '11024',
            name: 'Yên Thịnh',
            prefix: 'Xã',
          },
          {
            id: '11025',
            name: 'Yên Thượng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '693',
        name: 'Chợ Mới',
        wards: [
          {
            id: '11026',
            name: 'Bình Văn',
            prefix: 'Xã',
          },
          {
            id: '11027',
            name: 'Cao Kỳ',
            prefix: 'Xã',
          },
          {
            id: '11028',
            name: 'Chợ Mới',
            prefix: 'Thị trấn',
          },
          {
            id: '11029',
            name: 'Hòa Mục',
            prefix: 'Xã',
          },
          {
            id: '11030',
            name: 'Mai Lạp',
            prefix: 'Xã',
          },
          {
            id: '11031',
            name: 'Như Cố',
            prefix: 'Xã',
          },
          {
            id: '11032',
            name: 'Nông Hạ',
            prefix: 'Xã',
          },
          {
            id: '11033',
            name: 'Nông Thịnh',
            prefix: 'Xã',
          },
          {
            id: '11034',
            name: 'Quảng Chu',
            prefix: 'Xã',
          },
          {
            id: '11035',
            name: 'Tân Sơn',
            prefix: 'Xã',
          },
          {
            id: '11036',
            name: 'Thanh Bình',
            prefix: 'Xã',
          },
          {
            id: '11037',
            name: 'Thanh Mai',
            prefix: 'Xã',
          },
          {
            id: '11038',
            name: 'Thanh Vận',
            prefix: 'Xã',
          },
          {
            id: '11039',
            name: 'Yên Cư',
            prefix: 'Xã',
          },
          {
            id: '11040',
            name: 'Yên Đĩnh',
            prefix: 'Xã',
          },
          {
            id: '11041',
            name: 'Yên Hân',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '694',
        name: 'Na Rì',
        wards: [
          {
            id: '11042',
            name: 'Ân Tình',
            prefix: 'Xã',
          },
          {
            id: '11043',
            name: 'Côn Minh',
            prefix: 'Xã',
          },
          {
            id: '11044',
            name: 'Cư Lễ',
            prefix: 'Xã',
          },
          {
            id: '11045',
            name: 'Cường Lợi',
            prefix: 'Xã',
          },
          {
            id: '11047',
            name: 'Dương Sơn',
            prefix: 'Xã',
          },
          {
            id: '11046',
            name: 'Đổng Xá',
            prefix: 'Xã',
          },
          {
            id: '11048',
            name: 'Hảo Nghĩa',
            prefix: 'Xã',
          },
          {
            id: '11049',
            name: 'Hữu Thác',
            prefix: 'Xã',
          },
          {
            id: '11050',
            name: 'Kim Hỷ',
            prefix: 'Xã',
          },
          {
            id: '11051',
            name: 'Kim Lư',
            prefix: 'Xã',
          },
          {
            id: '11052',
            name: 'Lam Sơn',
            prefix: 'Xã',
          },
          {
            id: '11053',
            name: 'Lạng San',
            prefix: 'Thị trấn',
          },
          {
            id: '11054',
            name: 'Liêm Thủy',
            prefix: 'Xã',
          },
          {
            id: '11055',
            name: 'Lương Hạ',
            prefix: 'Xã',
          },
          {
            id: '11056',
            name: 'Lương Thành',
            prefix: 'Xã',
          },
          {
            id: '11057',
            name: 'Lương Thượng',
            prefix: 'Xã',
          },
          {
            id: '11058',
            name: 'Quang Phong',
            prefix: 'Xã',
          },
          {
            id: '11059',
            name: 'Văn Học',
            prefix: 'Xã',
          },
          {
            id: '11060',
            name: 'Văn Minh',
            prefix: 'Xã',
          },
          {
            id: '11061',
            name: 'Vũ Loan',
            prefix: 'Xã',
          },
          {
            id: '11062',
            name: 'Xuân Dương',
            prefix: 'Xã',
          },
          {
            id: '11063',
            name: 'Yến Lạc',
            prefix: 'Thị trấn',
          },
        ],
      },
      {
        id: '695',
        name: 'Ngân Sơn',
        wards: [
          {
            id: '11064',
            name: 'Bằng Vân',
            prefix: 'Xã',
          },
          {
            id: '11065',
            name: 'Cốc Đán',
            prefix: 'Xã',
          },
          {
            id: '11066',
            name: 'Đức Vân',
            prefix: 'Xã',
          },
          {
            id: '11067',
            name: 'Hương Nê',
            prefix: 'Xã',
          },
          {
            id: '11068',
            name: 'Lãng Ngâm',
            prefix: 'Xã',
          },
          {
            id: '11069',
            name: 'Nà Phặc',
            prefix: 'Thị trấn',
          },
          {
            id: '11070',
            name: 'Thuần Mang',
            prefix: 'Xã',
          },
          {
            id: '11071',
            name: 'Thượng Ân',
            prefix: 'Xã',
          },
          {
            id: '11072',
            name: 'Thượng Quan',
            prefix: 'Xã',
          },
          {
            id: '11073',
            name: 'Trung Hòa',
            prefix: 'Xã',
          },
          {
            id: '11074',
            name: 'Vân Tùng',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '696',
        name: 'Pác Nặm',
        wards: [
          {
            id: '11075',
            name: 'An Thắng',
            prefix: 'Xã',
          },
          {
            id: '11076',
            name: 'Bằng Thành',
            prefix: 'Xã',
          },
          {
            id: '11077',
            name: 'Bộc Bố',
            prefix: 'Xã',
          },
          {
            id: '11078',
            name: 'Cao Tân',
            prefix: 'Xã',
          },
          {
            id: '11079',
            name: 'Cổ Linh',
            prefix: 'Xã',
          },
          {
            id: '11080',
            name: 'Công Bằng',
            prefix: 'Xã',
          },
          {
            id: '11081',
            name: 'Giáo Hiệu',
            prefix: 'Xã',
          },
          {
            id: '11082',
            name: 'Nghiên Loan',
            prefix: 'Xã',
          },
          {
            id: '11083',
            name: 'Nhạn Môn',
            prefix: 'Xã',
          },
          {
            id: '11084',
            name: 'Xuân La',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
  {
    id: '63',
    code: 'CB',
    name: 'Cao Bằng',
    districts: [
      {
        id: '697',
        name: 'Bảo Lạc',
        wards: [
          {
            id: '11085',
            name: 'Bảo Lạc',
            prefix: 'Thị trấn',
          },
          {
            id: '11086',
            name: 'Bảo Toàn',
            prefix: 'Xã',
          },
          {
            id: '11087',
            name: 'Cô Ba',
            prefix: 'Xã',
          },
          {
            id: '11088',
            name: 'Cốc Pàng',
            prefix: 'Xã',
          },
          {
            id: '11089',
            name: 'Đình Phùng',
            prefix: 'Xã',
          },
          {
            id: '11090',
            name: 'Hồng An',
            prefix: 'Xã',
          },
          {
            id: '11091',
            name: 'Hồng Trị',
            prefix: 'Xã',
          },
          {
            id: '11092',
            name: 'Hưng Đạo',
            prefix: 'Xã',
          },
          {
            id: '11093',
            name: 'Hưng Thịnh',
            prefix: 'Xã',
          },
          {
            id: '11094',
            name: 'Huy Giáp',
            prefix: 'Xã',
          },
          {
            id: '11095',
            name: 'Khánh Xuân',
            prefix: 'Xã',
          },
          {
            id: '11096',
            name: 'Kim Cúc',
            prefix: 'Xã',
          },
          {
            id: '11097',
            name: 'Phan Thanh',
            prefix: 'Xã',
          },
          {
            id: '11098',
            name: 'Sơn Lập',
            prefix: 'Xã',
          },
          {
            id: '11099',
            name: 'Sơn Lộ',
            prefix: 'Xã',
          },
          {
            id: '11100',
            name: 'Thượng Hà',
            prefix: 'Xã',
          },
          {
            id: '11101',
            name: 'Xuân Trường',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '698',
        name: 'Bảo Lâm',
        wards: [
          {
            id: '11102',
            name: 'Đức Hạnh',
            prefix: 'Xã',
          },
          {
            id: '11103',
            name: 'Lý Bôn',
            prefix: 'Xã',
          },
          {
            id: '11104',
            name: 'Mông Ân',
            prefix: 'Xã',
          },
          {
            id: '11105',
            name: 'Nam Cao',
            prefix: 'Xã',
          },
          {
            id: '11106',
            name: 'Nam Quang',
            prefix: 'Xã',
          },
          {
            id: '11107',
            name: 'Pác Miầu',
            prefix: 'Thị trấn',
          },
          {
            id: '11108',
            name: 'Quảng Lâm',
            prefix: 'Xã',
          },
          {
            id: '11109',
            name: 'Thạch Lâm',
            prefix: 'Xã',
          },
          {
            id: '11110',
            name: 'Thái Học',
            prefix: 'Xã',
          },
          {
            id: '11111',
            name: 'Thái Sơn',
            prefix: 'Xã',
          },
          {
            id: '11112',
            name: 'Vĩnh Phong',
            prefix: 'Xã',
          },
          {
            id: '11113',
            name: 'Vĩnh Quang',
            prefix: 'Xã',
          },
          {
            id: '11114',
            name: 'Yên Thổ',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '699',
        name: 'Cao Bằng',
        wards: [
          {
            id: '11115',
            name: 'Chu Trinh',
            prefix: 'Xã',
          },
          {
            id: '11117',
            name: 'Duyệt Trung',
            prefix: 'Phường',
          },
          {
            id: '11116',
            name: 'Đề Thám',
            prefix: 'Phường',
          },
          {
            id: '11118',
            name: 'Hòa Chung',
            prefix: 'Phường',
          },
          {
            id: '11119',
            name: 'Hợp Giang',
            prefix: 'Phường',
          },
          {
            id: '11120',
            name: 'Hưng Đạo',
            prefix: 'Xã',
          },
          {
            id: '11121',
            name: 'Ngọc Xuân',
            prefix: 'Phường',
          },
          {
            id: '11122',
            name: 'Sông Bằng',
            prefix: 'Phường',
          },
          {
            id: '11123',
            name: 'Sông Hiến',
            prefix: 'Phường',
          },
          {
            id: '11124',
            name: 'Tân Giang',
            prefix: 'Phường',
          },
          {
            id: '11125',
            name: 'Vĩnh Quang',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '700',
        name: 'Hạ Lang',
        wards: [
          {
            id: '11126',
            name: 'An Lạc',
            prefix: 'Xã',
          },
          {
            id: '11127',
            name: 'Cô Ngân',
            prefix: 'Xã',
          },
          {
            id: '11128',
            name: 'Đồng Loan',
            prefix: 'Xã',
          },
          {
            id: '11129',
            name: 'Đức Quang',
            prefix: 'Xã',
          },
          {
            id: '11130',
            name: 'Kim Loan',
            prefix: 'Xã',
          },
          {
            id: '11131',
            name: 'Lý Quốc',
            prefix: 'Xã',
          },
          {
            id: '11132',
            name: 'Minh Long',
            prefix: 'Xã',
          },
          {
            id: '11133',
            name: 'Quang Long',
            prefix: 'Xã',
          },
          {
            id: '11134',
            name: 'Tân Việt',
            prefix: 'Xã',
          },
          {
            id: '11135',
            name: 'Thái Đức',
            prefix: 'Xã',
          },
          {
            id: '11136',
            name: 'Thắng Lợi',
            prefix: 'Xã',
          },
          {
            id: '11137',
            name: 'Thanh Nhật',
            prefix: 'Thị trấn',
          },
          {
            id: '11138',
            name: 'Thị Hoa',
            prefix: 'Xã',
          },
          {
            id: '11139',
            name: 'Việt Chu',
            prefix: 'Xã',
          },
          {
            id: '11140',
            name: 'Vinh Quý',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '701',
        name: 'Hà Quảng',
        wards: [
          {
            id: '11141',
            name: 'Cải Viên',
            prefix: 'Xã',
          },
          {
            id: '11142',
            name: 'Đào Ngạn',
            prefix: 'Xã',
          },
          {
            id: '11143',
            name: 'Hạ Thôn',
            prefix: 'Xã',
          },
          {
            id: '11144',
            name: 'Hồng Sĩ',
            prefix: 'Xã',
          },
          {
            id: '11145',
            name: 'Kéo Yên',
            prefix: 'Xã',
          },
          {
            id: '11146',
            name: 'Lũng Nặm',
            prefix: 'Xã',
          },
          {
            id: '11147',
            name: 'Mã Ba',
            prefix: 'Xã',
          },
          {
            id: '11148',
            name: 'Nà Sác',
            prefix: 'Xã',
          },
          {
            id: '11149',
            name: 'Nội Thôn',
            prefix: 'Xã',
          },
          {
            id: '11150',
            name: 'Phù Ngọc',
            prefix: 'Xã',
          },
          {
            id: '11151',
            name: 'Quý Quân',
            prefix: 'Xã',
          },
          {
            id: '11152',
            name: 'Sĩ Hai',
            prefix: 'Xã',
          },
          {
            id: '11153',
            name: 'Sóc Hà',
            prefix: 'Xã',
          },
          {
            id: '11154',
            name: 'Thượng Thôn',
            prefix: 'Xã',
          },
          {
            id: '11155',
            name: 'Tổng Cọt',
            prefix: 'Xã',
          },
          {
            id: '11156',
            name: 'Trường Hà',
            prefix: 'Xã',
          },
          {
            id: '11157',
            name: 'Vân An',
            prefix: 'Xã',
          },
          {
            id: '11158',
            name: 'Vần Dính',
            prefix: 'Xã',
          },
          {
            id: '11159',
            name: 'Xuân Hoà',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '702',
        name: 'Hòa An',
        wards: [
          {
            id: '11160',
            name: 'Bạch Đằng',
            prefix: 'Xã',
          },
          {
            id: '11161',
            name: 'Bế Triều',
            prefix: 'Xã',
          },
          {
            id: '11162',
            name: 'Bình Dương',
            prefix: 'Xã',
          },
          {
            id: '11163',
            name: 'Bình Long',
            prefix: 'Xã',
          },
          {
            id: '11164',
            name: 'Công Trừng',
            prefix: 'Xã',
          },
          {
            id: '11166',
            name: 'Dân Chủ',
            prefix: 'Xã',
          },
          {
            id: '11165',
            name: 'Đại Tiến',
            prefix: 'Xã',
          },
          {
            id: '11167',
            name: 'Đức Long',
            prefix: 'Xã',
          },
          {
            id: '11168',
            name: 'Đức Xuân',
            prefix: 'Xã',
          },
          {
            id: '11169',
            name: 'Hà Trì',
            prefix: 'Xã',
          },
          {
            id: '11170',
            name: 'Hoàng Tung',
            prefix: 'Xã',
          },
          {
            id: '11171',
            name: 'Hồng Nam',
            prefix: 'Xã',
          },
          {
            id: '11172',
            name: 'Hồng Việt',
            prefix: 'Xã',
          },
          {
            id: '11173',
            name: 'Lê Chung',
            prefix: 'Xã',
          },
          {
            id: '11174',
            name: 'Nam Tuấn',
            prefix: 'Xã',
          },
          {
            id: '11175',
            name: 'Ngũ Lão',
            prefix: 'Xã',
          },
          {
            id: '11176',
            name: 'Nguyễn Huệ',
            prefix: 'Xã',
          },
          {
            id: '11177',
            name: 'Nước Hai',
            prefix: 'Thị trấn',
          },
          {
            id: '11178',
            name: 'Quang Trung',
            prefix: 'Xã',
          },
          {
            id: '11179',
            name: 'Trưng Vương',
            prefix: 'Xã',
          },
          {
            id: '11180',
            name: 'Trương Lương',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '703',
        name: 'Nguyên Bình',
        wards: [
          {
            id: '11181',
            name: 'Bắc Hợp',
            prefix: 'Xã',
          },
          {
            id: '11182',
            name: 'Ca Thành',
            prefix: 'Xã',
          },
          {
            id: '11183',
            name: 'Hoa Thám',
            prefix: 'Xã',
          },
          {
            id: '11184',
            name: 'Hưng Đạo',
            prefix: 'Xã',
          },
          {
            id: '11185',
            name: 'Lang Môn',
            prefix: 'Xã',
          },
          {
            id: '11186',
            name: 'Mai Long',
            prefix: 'Xã',
          },
          {
            id: '11187',
            name: 'Minh Tâm',
            prefix: 'Xã',
          },
          {
            id: '11188',
            name: 'Minh Thanh',
            prefix: 'Xã',
          },
          {
            id: '11189',
            name: 'Nguyên Bình',
            prefix: 'Thị trấn',
          },
          {
            id: '11190',
            name: 'Phan Thanh',
            prefix: 'Xã',
          },
          {
            id: '11191',
            name: 'Quang Thành',
            prefix: 'Xã',
          },
          {
            id: '11192',
            name: 'Tam Kim',
            prefix: 'Xã',
          },
          {
            id: '11193',
            name: 'Thái Học',
            prefix: 'Xã',
          },
          {
            id: '11194',
            name: 'Thành Công',
            prefix: 'Xã',
          },
          {
            id: '11195',
            name: 'Thể Dục',
            prefix: 'Xã',
          },
          {
            id: '11196',
            name: 'Thịnh Vượng',
            prefix: 'Xã',
          },
          {
            id: '11197',
            name: 'Tĩnh Túc',
            prefix: 'Thị trấn',
          },
          {
            id: '11198',
            name: 'Triệu Nguyên',
            prefix: 'Xã',
          },
          {
            id: '11199',
            name: 'Vũ Nông',
            prefix: 'Xã',
          },
          {
            id: '11200',
            name: 'Yên Lạc',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '704',
        name: 'Phục Hòa',
        wards: [
          {
            id: '11201',
            name: 'Cách Linh',
            prefix: 'Xã',
          },
          {
            id: '11202',
            name: 'Đại Sơn',
            prefix: 'Xã',
          },
          {
            id: '11203',
            name: 'Hòa Thuận',
            prefix: 'Thị trấn',
          },
          {
            id: '11204',
            name: 'Hồng Đại',
            prefix: 'Xã',
          },
          {
            id: '11205',
            name: 'Lương Thiện',
            prefix: 'Xã',
          },
          {
            id: '11206',
            name: 'Mỹ Hưng',
            prefix: 'Xã',
          },
          {
            id: '11207',
            name: 'Tà Lùng',
            prefix: 'Thị trấn',
          },
          {
            id: '11208',
            name: 'Tiên Thành',
            prefix: 'Xã',
          },
          {
            id: '11209',
            name: 'Triệu Ẩu',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '705',
        name: 'Quảng Uyên',
        wards: [
          {
            id: '11210',
            name: 'Bình Lăng',
            prefix: 'Xã',
          },
          {
            id: '11211',
            name: 'Cai Bộ',
            prefix: 'Xã',
          },
          {
            id: '11212',
            name: 'Chí Thảo',
            prefix: 'Xã',
          },
          {
            id: '11213',
            name: 'Đoài Khôn',
            prefix: 'Xã',
          },
          {
            id: '11214',
            name: 'Độc Lập',
            prefix: 'Xã',
          },
          {
            id: '11215',
            name: 'Hạnh Phúc',
            prefix: 'Xã',
          },
          {
            id: '11216',
            name: 'Hoàng Hải',
            prefix: 'Xã',
          },
          {
            id: '11217',
            name: 'Hồng Định',
            prefix: 'Xã',
          },
          {
            id: '11218',
            name: 'Hồng Quang',
            prefix: 'Xã',
          },
          {
            id: '11219',
            name: 'Ngọc Động',
            prefix: 'Xã',
          },
          {
            id: '11220',
            name: 'Phi Hải',
            prefix: 'Xã',
          },
          {
            id: '11221',
            name: 'Phúc Sen',
            prefix: 'Xã',
          },
          {
            id: '11222',
            name: 'Quảng Hưng',
            prefix: 'Xã',
          },
          {
            id: '11223',
            name: 'Quảng Uyên',
            prefix: 'Thị trấn',
          },
          {
            id: '11224',
            name: 'Quốc Dân',
            prefix: 'Xã',
          },
          {
            id: '11225',
            name: 'Quốc Phong',
            prefix: 'Xã',
          },
          {
            id: '11226',
            name: 'Tự Do',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '706',
        name: 'Thạch An',
        wards: [
          {
            id: '11227',
            name: 'Canh Tân',
            prefix: 'Xã',
          },
          {
            id: '11228',
            name: 'Danh Sỹ',
            prefix: 'Xã',
          },
          {
            id: '11229',
            name: 'Đông Khê',
            prefix: 'Thị trấn',
          },
          {
            id: '11230',
            name: 'Đức Long',
            prefix: 'Xã',
          },
          {
            id: '11231',
            name: 'Đức Thông',
            prefix: 'Xã',
          },
          {
            id: '11232',
            name: 'Đức Xuân',
            prefix: 'Xã',
          },
          {
            id: '11233',
            name: 'Kim Đồng',
            prefix: 'Xã',
          },
          {
            id: '11234',
            name: 'Lê Lai',
            prefix: 'Xã',
          },
          {
            id: '11235',
            name: 'Lê Lợi',
            prefix: 'Xã',
          },
          {
            id: '11236',
            name: 'Minh Khai',
            prefix: 'Xã',
          },
          {
            id: '11237',
            name: 'Quang Trọng',
            prefix: 'Xã',
          },
          {
            id: '11238',
            name: 'Thái Cường',
            prefix: 'Xã',
          },
          {
            id: '11239',
            name: 'Thị Ngân',
            prefix: 'Xã',
          },
          {
            id: '11240',
            name: 'Thụy Hùng',
            prefix: 'Xã',
          },
          {
            id: '11241',
            name: 'Trọng Con',
            prefix: 'Xã',
          },
          {
            id: '11242',
            name: 'Vân Trình',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '707',
        name: 'Thông Nông',
        wards: [
          {
            id: '11243',
            name: 'Bình Lãng',
            prefix: 'Xã',
          },
          {
            id: '11244',
            name: 'Cần Nông',
            prefix: 'Xã',
          },
          {
            id: '11245',
            name: 'Cần Yên',
            prefix: 'Xã',
          },
          {
            id: '11246',
            name: 'Đa Thông',
            prefix: 'Xã',
          },
          {
            id: '11247',
            name: 'Lương Can',
            prefix: 'Xã',
          },
          {
            id: '11248',
            name: 'Lương Thông',
            prefix: 'Xã',
          },
          {
            id: '11249',
            name: 'Ngọc Động',
            prefix: 'Xã',
          },
          {
            id: '11250',
            name: 'Thanh Long',
            prefix: 'Xã',
          },
          {
            id: '11251',
            name: 'Thông Nông',
            prefix: 'Thị trấn',
          },
          {
            id: '11252',
            name: 'Vị Quang',
            prefix: 'Xã',
          },
          {
            id: '11253',
            name: 'Yên Sơn',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '708',
        name: 'Trà Lĩnh',
        wards: [
          {
            id: '11254',
            name: 'Cao Chương',
            prefix: 'Xã',
          },
          {
            id: '11255',
            name: 'Cô Mười',
            prefix: 'Xã',
          },
          {
            id: '11256',
            name: 'Hùng Quốc',
            prefix: 'Thị trấn',
          },
          {
            id: '11257',
            name: 'Lưu Ngọc',
            prefix: 'Xã',
          },
          {
            id: '11258',
            name: 'Quang Hán',
            prefix: 'Xã',
          },
          {
            id: '11259',
            name: 'Quang Trung',
            prefix: 'Xã',
          },
          {
            id: '11260',
            name: 'Quang Vinh',
            prefix: 'Xã',
          },
          {
            id: '11261',
            name: 'Quốc Toản',
            prefix: 'Xã',
          },
          {
            id: '11262',
            name: 'Tri Phương',
            prefix: 'Xã',
          },
          {
            id: '11263',
            name: 'Xuân Nội',
            prefix: 'Xã',
          },
        ],
      },
      {
        id: '709',
        name: 'Trùng Khánh',
        wards: [
          {
            id: '11264',
            name: 'Cảnh Tiên',
            prefix: 'Xã',
          },
          {
            id: '11265',
            name: 'Cao Thăng',
            prefix: 'Xã',
          },
          {
            id: '11266',
            name: 'Chí Viễn',
            prefix: 'Xã',
          },
          {
            id: '11267',
            name: 'Đàm Thủy',
            prefix: 'Xã',
          },
          {
            id: '11268',
            name: 'Đình Minh',
            prefix: 'Xã',
          },
          {
            id: '11269',
            name: 'Đình Phong',
            prefix: 'Xã',
          },
          {
            id: '11270',
            name: 'Đoài Côn',
            prefix: 'Xã',
          },
          {
            id: '11271',
            name: 'Đức Hồng',
            prefix: 'Xã',
          },
          {
            id: '11272',
            name: 'Khâm Thành',
            prefix: 'Xã',
          },
          {
            id: '11273',
            name: 'Lăng Hiếu',
            prefix: 'Xã',
          },
          {
            id: '11274',
            name: 'Lăng Yên',
            prefix: 'Xã',
          },
          {
            id: '11275',
            name: 'Ngọc Chung',
            prefix: 'Xã',
          },
          {
            id: '11276',
            name: 'Ngọc Côn',
            prefix: 'Xã',
          },
          {
            id: '11277',
            name: 'Ngọc Khê',
            prefix: 'Xã',
          },
          {
            id: '11278',
            name: 'Phong Châu',
            prefix: 'Xã',
          },
          {
            id: '11279',
            name: 'Phong Nậm',
            prefix: 'Xã',
          },
          {
            id: '11280',
            name: 'Thân Giáp',
            prefix: 'Xã',
          },
          {
            id: '11281',
            name: 'Thông Huề',
            prefix: 'Xã',
          },
          {
            id: '11282',
            name: 'Trùng Khánh',
            prefix: 'Thị trấn',
          },
          {
            id: '11283',
            name: 'Trung Phúc',
            prefix: 'Xã',
          },
        ],
      },
    ],
  },
];
